// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/spinner.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/ui/tiled-background-skewed@0.82x.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/ui/savingsIcon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/programs/xcel/xcel-rebate-banner.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/ui/checkIcon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/ui/xIcon.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/ui/warningIcon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * React Select
 * ============
 * Created by Jed Watson and Joss Mackison for KeystoneJS, http://www.keystonejs.com/
 * https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs
 * MIT License: https://github.com/keystonejs/react-select
*/
.Select {
  position: relative;
}
.Select,
.Select div,
.Select input,
.Select span {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.Select.is-disabled > .Select-control {
  background-color: #f6f6f6;
}
.Select.is-disabled .Select-arrow-zone {
  cursor: default;
  pointer-events: none;
}
.Select-control {
  background-color: #fff;
  border-color: #d9d9d9 #ccc #b3b3b3;
  border-radius: 4px;
  border: 1px solid #ccc;
  color: #333;
  cursor: default;
  display: table;
  height: 46px;
  outline: none;
  overflow: hidden;
  position: relative;
  width: 100%;
}
.Select-control:hover {
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
}
.is-searchable.is-open > .Select-control {
  cursor: text;
}
.is-open > .Select-control {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  background: #fff;
  border-color: #b3b3b3 #ccc #d9d9d9;
}
.is-open > .Select-control > .Select-arrow {
  border-color: transparent transparent #999;
  border-width: 0 5px 5px;
}
.is-searchable.is-focused:not(.is-open) > .Select-control {
  cursor: text;
}
.is-focused:not(.is-open) > .Select-control {
  border-color: #08c #0099e6 #0099e6;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1), 0 0 5px -1px rgba(0, 136, 204, 0.5);
}
.Select-placeholder {
  bottom: 0;
  color: #777;
  left: 0;
  line-height: 44px;
  padding-left: 15px;
  padding-right: 15px;
  position: absolute;
  right: 0;
  top: 0;
  font-size: 18px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.has-value > .Select-control > .Select-placeholder {
  color: #333;
  font-size: 18px;
}
.Select-value {
  color: #777;
  left: 0;
  padding: 8px 52px 8px 15px;
  position: absolute;
  right: -20px;
  top: 0;
  font-size: 18px;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.has-value > .Select-control > .Select-value {
  color: #333;
  font-size: 18px;
}
.Select-input {
  height: 44px;
  padding-left: 15px;
  padding-right: 15px;
  vertical-align: middle;
}
.Select-input > input {
  background: none transparent;
  border: 0 none;
  box-shadow: none;
  cursor: default;
  display: inline-block;
  font-family: inherit;
  font-size: inherit;
  height: 44px;
  margin: 0;
  outline: none;
  padding: 0;
  -webkit-appearance: none;
}
.is-focused .Select-input > input {
  cursor: text;
}
.Select-control:not(.is-searchable) > .Select-input {
  outline: none;
}
.Select-loading-zone {
  cursor: pointer;
  display: table-cell;
  position: relative;
  text-align: center;
  vertical-align: middle;
  width: 16px;
}
.Select-loading {
  -webkit-animation: Select-animation-spin 400ms infinite linear;
  -o-animation: Select-animation-spin 400ms infinite linear;
  animation: Select-animation-spin 400ms infinite linear;
  width: 16px;
  height: 16px;
  box-sizing: border-box;
  border-radius: 50%;
  border: 2px solid #ccc;
  border-right-color: #333;
  display: inline-block;
  position: relative;
  vertical-align: middle;
}
.Select-clear-zone {
  -webkit-animation: Select-animation-fadeIn 200ms;
  -o-animation: Select-animation-fadeIn 200ms;
  animation: Select-animation-fadeIn 200ms;
  color: #999;
  cursor: pointer;
  display: table-cell;
  position: relative;
  text-align: center;
  vertical-align: middle;
  width: 22px;
}
.Select-clear-zone:hover {
  color: #d0021b;
}
.Select-clear {
  display: inline-block;
  font-size: 23px;
  line-height: 1;
}
.Select--multi .Select-clear-zone {
  width: 22px;
}
.Select-arrow-zone {
  cursor: pointer;
  display: table-cell;
  position: relative;
  text-align: center;
  vertical-align: middle;
  width: 25px;
  padding-right: 5px;
}
.Select-arrow {
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 2.5px;
  display: inline-block;
  height: 0;
  width: 0;
}
.is-open .Select-arrow,
.Select-arrow-zone:hover > .Select-arrow {
  border-top-color: #666;
}
@-webkit-keyframes Select-animation-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes Select-animation-fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.Select-menu-outer {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-top-color: #e6e6e6;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  margin-top: -1px;
  max-height: 200px;
  position: absolute;
  top: 100%;
  width: 100%;
  z-index: 1000;
  -webkit-overflow-scrolling: touch;
}
.Select-menu {
  max-height: 198px;
  overflow-y: auto;
}
.Select-option {
  box-sizing: border-box;
  color: #666666;
  cursor: pointer;
  display: block;
  padding: 8px 15px;
}
.Select-option:last-child {
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
}
.Select-option.is-focused {
  background-color: #f2f2f2;
  color: #333;
}
.Select-option.is-disabled {
  color: #cccccc;
  cursor: not-allowed;
}
.Select-noresults,
.Select-search-prompt,
.Select-searching {
  box-sizing: border-box;
  color: #999999;
  cursor: default;
  display: block;
  padding: 8px 15px;
}
.Select--multi .Select-input {
  vertical-align: middle;
  margin-left: 15px;
  padding: 0;
}
.Select--multi.has-value .Select-input {
  margin-left: 5px;
}
.Select-item {
  background-color: #f2f2f2;
  border-radius: 2px;
  border: 1px solid #d9d9d9;
  color: #333333;
  display: inline-block;
  font-size: 1em;
  margin-left: 5px;
  margin-top: 5px;
  vertical-align: top;
}
.Select-item-icon,
.Select-item-label {
  display: inline-block;
  vertical-align: middle;
}
.Select-item-label {
  border-bottom-right-radius: 2px;
  border-top-right-radius: 2px;
  cursor: default;
  padding: 5px 5px;
}
.Select-item-label .Select-item-label__a {
  color: #333333;
  cursor: pointer;
}
.Select-item-icon {
  cursor: pointer;
  border-bottom-left-radius: 2px;
  border-top-left-radius: 2px;
  border-right: 1px solid #d9d9d9;
  padding: 5px 5px 6px;
}
.Select-item-icon:hover,
.Select-item-icon:focus {
  background-color: #e5e5e5;
  color: #262626;
}
.Select-item-icon:active {
  background-color: #d9d9d9;
}
.Select--multi.is-disabled .Select-item {
  background-color: #f2f2f2;
  border: 1px solid #d9d9d9;
  color: #888;
}
.Select--multi.is-disabled .Select-item-icon {
  cursor: not-allowed;
  border-right: 1px solid #d9d9d9;
}
.Select--multi.is-disabled .Select-item-icon:hover,
.Select--multi.is-disabled .Select-item-icon:focus,
.Select--multi.is-disabled .Select-item-icon:active {
  background-color: #f2f2f2;
}
@keyframes Select-animation-spin {
  to {
    transform: rotate(1turn);
  }
}
@-webkit-keyframes Select-animation-spin {
  to {
    -webkit-transform: rotate(1turn);
  }
}
.m-signature-pad {
  position: absolute;
  font-size: 10px;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  background-color: #fff;
  border-radius: 4px;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}
.m-signature-pad--body {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  border: 1px solid #f4f4f4;
}
.m-signature-pad--body canvas {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-radius: 4px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.02) inset;
}
.m-signature-pad--footer {
  position: absolute;
  left: 20px;
  right: 20px;
  bottom: 20px;
  height: 40px;
}
.m-signature-pad--footer .description {
  color: #c3c3c3;
  text-align: center;
  font-size: 1.2em;
  margin-top: 1.8em;
}
.m-signature-pad--footer .button {
  position: absolute;
  bottom: 0;
}
.m-signature-pad--footer .button.clear {
  left: 0;
}
.m-signature-pad--footer .button.save {
  right: 0;
}
@media screen and (max-width: 1024px) {
  .m-signature-pad {
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: auto;
    height: auto;
    min-width: 250px;
    min-height: 140px;
  }
  #github {
    display: none;
  }
}
@media screen and (max-height: 320px) {
  .m-signature-pad--body {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .m-signature-pad--footer {
    left: 20px;
    right: 20px;
    bottom: 4px;
    height: 28px;
  }
  .m-signature-pad--footer .description {
    font-size: 1em;
    margin-top: 1em;
  }
}
@media print {
  .m-signature-pad-button {
    height: 30px;
    margin-bottom: 10px;
  }
  .m-signature-pad-button .btn,
  .m-signature-pad-button button {
    display: none !important;
  }
}
.sample-job-watermark:after {
  content: 'Sample';
  position: absolute;
  z-index: 2;
  left: 20%;
  top: 30%;
  font-size: 180px;
  text-transform: uppercase;
  font-family: 'open sans', 'helvetica neue', helvetica, arial;
  -webkit-transform: rotate(-25deg);
  -moz-transform: rotate(-25deg);
  -ms-transform: rotate(-25deg);
  transform: rotate(-25deg);
  font-family: 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif;
  font-weight: 300;
  color: rgba(0, 0, 0, 0.24);
}
.signed-copy-job-watermark:after {
  content: 'Signed Copy';
  position: absolute;
  z-index: 2;
  left: 0%;
  top: 32%;
  font-size: 154px;
  text-transform: uppercase;
  font-weight: 300;
  font-family: 'open sans', 'helvetica neue', helvetica, arial;
  -webkit-transform: rotate(-30deg);
  -moz-transform: rotate(-30deg);
  -ms-transform: rotate(-30deg);
  transform: rotate(-30deg);
  color: rgba(0, 0, 0, 0.24);
}
.out-of-date-job-watermark:after {
  content: 'Out of Date';
  position: absolute;
  z-index: 2;
  left: 0%;
  top: 32%;
  font-size: 154px;
  text-transform: uppercase;
  font-weight: 300;
  font-family: 'open sans', 'helvetica neue', helvetica, arial;
  -webkit-transform: rotate(-30deg);
  -moz-transform: rotate(-30deg);
  -ms-transform: rotate(-30deg);
  transform: rotate(-30deg);
  color: rgba(217, 45, 32, 0.24);
}
.desaturate-image {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  filter: grayscale(100%);
}
@-webkit-keyframes fadeOut {
  to {
    opacity: 0;
  }
}
@keyframes fadeOut {
  to {
    opacity: 0;
  }
}
@-webkit-keyframes shrinkHeight {
  to {
    max-height: 0;
    transform: scale(0);
  }
}
@keyframes shrinkHeight {
  to {
    max-height: 0;
    transform: scale(0);
  }
}
.uploader-container {
  position: relative;
  height: 115px;
  text-align: center;
  background-color: #f9f9f9;
  border-radius: 6px;
  cursor: pointer;
}
.uploader-container .btn.delete-photo {
  color: red;
  background-color: #fff;
  border-color: #ccc;
  border: 1px solid #ddd;
  position: absolute;
  left: 0;
  right: 0;
  bottom: -10px;
  margin: auto;
  width: 45px;
  font-size: 18px;
}
.uploader-container .btn.delete-photo:hover,
.uploader-container .btn.delete-photo:focus,
.uploader-container .btn.delete-photo:active,
.uploader-container .btn.delete-photo.active,
.open > .dropdown-toggle.uploader-container .btn.delete-photo {
  color: red;
  background-color: #e6e6e6;
  border-color: #adadad;
}
.uploader-container .btn.delete-photo:active,
.uploader-container .btn.delete-photo.active,
.open > .dropdown-toggle.uploader-container .btn.delete-photo {
  background-image: none;
}
.uploader-container .btn.delete-photo.disabled,
.uploader-container .btn.delete-photo[disabled],
fieldset[disabled] .uploader-container .btn.delete-photo,
.uploader-container .btn.delete-photo.disabled:hover,
.uploader-container .btn.delete-photo[disabled]:hover,
fieldset[disabled] .uploader-container .btn.delete-photo:hover,
.uploader-container .btn.delete-photo.disabled:focus,
.uploader-container .btn.delete-photo[disabled]:focus,
fieldset[disabled] .uploader-container .btn.delete-photo:focus,
.uploader-container .btn.delete-photo.disabled:active,
.uploader-container .btn.delete-photo[disabled]:active,
fieldset[disabled] .uploader-container .btn.delete-photo:active,
.uploader-container .btn.delete-photo.disabled.active,
.uploader-container .btn.delete-photo[disabled].active,
fieldset[disabled] .uploader-container .btn.delete-photo.active {
  background-color: #fff;
  border-color: #ccc;
}
.uploader-container .btn.delete-photo .badge {
  color: #fff;
  background-color: red;
}
.uploader-container .delete-photo {
  display: none;
}
.uploader-container img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  max-height: 100%;
  max-width: 100%;
  height: auto;
  width: auto;
  min-height: 50px;
  min-width: 50px;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.uploader-container > .uploadcare--widget__dragndrop-area {
  margin-top: 0;
  cursor: pointer;
  position: relative;
  border-radius: 5px;
  min-width: initial;
  background-color: #f9f9f9;
  color: #777777;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  border: 1px dashed rgba(0, 0, 0, 0.2);
}
.uploader-container > .uploadcare--widget__dragndrop-area:hover {
  background-color: #fef5e9;
  border-color: #fbbc6d;
}
.uploader-container > .uploadcare--widget__dragndrop-area:active,
.uploader-container > .uploadcare--widget__dragndrop-area:focus {
  background-color: #ffe5c5;
  border-color: #fbb65e;
}
.uploader-container > .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text {
  line-height: 28px;
  padding: 15px 0;
  display: block;
  margin: auto;
  font-size: 10px;
}
.uploader-container > .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text i[class^='ico-'],
.uploader-container > .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text i[class*=' ico-'] {
  font-size: 36px;
}
.uploadcare--widget {
  width: 100%;
  cursor: pointer;
}
.uploadcare--widget .uploadcare--widget__button {
  display: none !important;
}
.uploadcare--widget .uploadcare--widget__status,
.uploadcare--widget .uploadcare--widget__circle-back {
  display: none;
}
.uploadcare--widget .uploadcare--widget__status {
  display: none;
}
.uploadcare--widget .uploadcare--widget__dragndrop-area {
  margin-top: 0;
  cursor: pointer;
  position: relative;
  border-radius: 5px;
  min-width: initial;
  background-color: #f9f9f9;
  color: #777777;
  left: 0;
  display: block;
  min-height: 115px;
}
.uploadcare--widget .uploadcare--widget__dragndrop-area:hover {
  background-color: #fef5e9;
  border-color: #fbbc6d;
}
.uploadcare--widget .uploadcare--widget__dragndrop-area:active,
.uploadcare--widget .uploadcare--widget__dragndrop-area:focus {
  background-color: #ffe5c5;
  border-color: #fbb65e;
}
.uploadcare--widget .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text {
  line-height: 28px;
  padding: 15px 0;
  display: block;
  margin: auto;
  font-size: 10px;
}
.uploadcare--widget .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text i[class^='ico-'],
.uploadcare--widget .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text i[class*=' ico-'] {
  font-size: 36px;
}
.uploadcare-dragging {
  background-color: #fffcf8;
}
.snugg-uploader-dropzone-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 5;
  pointer-events: none;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  border-radius: 6px;
  border: 2px dashed #ff9003;
  background-color: rgba(255, 144, 3, 0.1);
  animation: snugg-uploader-dropzone-in 120ms ease-out;
}
.snugg-uploader-dropzone-overlay__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  text-align: center;
  color: #c56e00;
}
.snugg-uploader-dropzone-overlay__icon {
  width: 28px;
  height: 28px;
  color: #ff9003;
}
.snugg-uploader-dropzone-overlay__text {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
}
@keyframes snugg-uploader-dropzone-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.uploadcare--dialog__powered-by {
  display: none;
}
.uploadcare-file-container .uploadcare--widget {
  display: none !important;
}
.uploadcare-widget-disabled {
  float: left;
  margin-left: 10px;
  min-width: initial;
  min-height: 115px;
  width: 200px;
  height: 100%;
  left: 0;
  margin-top: 0;
  display: block;
  position: relative;
  border-radius: 5px;
  margin-bottom: 20px;
  text-align: center;
  background-color: #eeeeee;
  border: 1px dashed rgba(0, 0, 0, 0.2);
}
.uploadcare-widget-disabled .ico-budicon-10 {
  position: absolute;
  z-index: 3;
  top: 0.8em;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
  color: #777777;
}
.photo-upload-refine {
  position: relative;
  margin-bottom: 20px;
}
.photo-upload-refine .snugg-upload-prompt-text {
  line-height: 1.1 !important;
}
.uploaded-image-loading {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center center no-repeat;
}
.photo-upload-report {
  position: relative;
  width: 200px;
  margin-bottom: 20px;
}
.photo-upload-report .snugg-upload-prompt-text {
  line-height: 1.1 !important;
}
.snugg-uploader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10500;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.45);
  animation: snugg-uploader-fade-in 0.2s ease;
}
@keyframes snugg-uploader-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.snugg-uploader-dialog {
  display: flex;
  position: relative;
  width: 800px;
  max-width: calc(100% - 40px);
  height: 660px;
  max-height: calc(100% - 40px);
  border-radius: 6px;
  overflow: hidden;
  box-shadow: -2px 1px 50px rgba(0, 0, 0, 0.4);
  animation: snugg-uploader-slide-up 0.25s ease;
}
@media (max-width: 767px), (max-height: 500px) {
  .snugg-uploader-dialog {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    border-radius: 0;
  }
}
@keyframes snugg-uploader-slide-up {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.snugg-uploader-panel {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: #fff;
}
.snugg-uploader-header {
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  background: #f2f2f2;
  border-bottom: 1px solid #eeeeee;
}
.snugg-uploader-header__close {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  margin: 0;
  padding: 0;
  background: transparent;
  border: none;
  color: #333333;
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease;
  outline: none;
  -webkit-appearance: none;
}
.snugg-uploader-header__close:hover {
  color: #333333;
  background-color: rgba(0, 0, 0, 0.06);
}
.snugg-uploader-header__close:focus-visible {
  box-shadow: inset 0 0 0 2px #fa7b00;
}
@media (max-width: 600px) {
  .snugg-uploader-header__close {
    width: 44px;
  }
}
.snugg-uploader-tabs {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
@media (max-width: 600px) {
  .snugg-uploader-tabs {
    margin: 0;
    flex: 1;
    min-width: 0;
  }
}
.snugg-uploader-tab {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 24px;
  gap: 12px;
  height: 60px;
  background: transparent;
  border: none;
  border-radius: 0;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 142%;
  color: #777777;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
  outline: none;
  -webkit-appearance: none;
}
@media (max-width: 600px) {
  .snugg-uploader-tab {
    padding: 0 12px;
    gap: 6px;
    font-size: 13px;
  }
}
.snugg-uploader-tab:hover {
  background-color: rgba(255, 255, 255, 0.5);
}
.snugg-uploader-tab:focus-visible {
  box-shadow: inset 0 0 0 2px #fa7b00;
}
.snugg-uploader-tab.snugg-uploader-tab--active {
  background: #fff;
  color: #333333;
}
.snugg-uploader-tab__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.snugg-uploader-tab__icon svg {
  width: 16px;
  height: 16px;
}
.snugg-uploader-tab__label {
  white-space: nowrap;
}
.snugg-uploader-body {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 0;
}
.snugg-uploader-upload-body {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 24px;
  gap: 16px;
  width: 100%;
  height: 100%;
}
.snugg-uploader-progress {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px 24px;
  width: 100%;
  height: 100%;
  text-align: center;
}
.snugg-uploader-progress__icon {
  color: #777777;
  opacity: 0.8;
}
.snugg-uploader-progress__icon svg {
  width: 40px;
  height: 40px;
}
.snugg-uploader-progress__name {
  max-width: 320px;
  color: #333333;
  font-weight: 600;
  word-break: break-word;
}
.snugg-uploader-progress__track {
  position: relative;
  width: 100%;
  max-width: 320px;
  height: 8px;
  border-radius: 999px;
  background: #eeeeee;
  overflow: hidden;
}
.snugg-uploader-progress__bar {
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(180deg, #fea100 0%, #fa7b00 100%);
  transition: width 0.2s ease;
}
.snugg-uploader-progress__pct {
  color: #777777;
  font-size: 13px;
}
.snugg-uploader-progress--error .snugg-uploader-progress__name {
  color: #d92d20;
}
.snugg-uploader-dropzone {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 24px;
  width: 100%;
  flex-grow: 1;
  background: #fff;
  border: 1px dashed #cccccc;
  border-radius: 12px;
  text-align: center;
  cursor: default;
}
.snugg-uploader-dropzone--dragging {
  background-color: rgba(250, 123, 0, 0.04);
  border-color: #fa7b00;
  border-style: dashed;
}
.snugg-uploader-dropzone__heading {
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 142%;
  color: #333333;
}
.snugg-uploader-dropzone__or {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 142%;
  color: #777777;
}
.snugg-uploader-dropzone__browse {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 15px 18px;
  background: linear-gradient(180deg, #fea100 0%, #fa7b00 100%);
  border: none;
  border-radius: 6px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  transition: opacity 0.15s ease;
  outline: none;
  -webkit-appearance: none;
}
.snugg-uploader-dropzone__browse:hover {
  opacity: 0.9;
}
.snugg-uploader-dropzone__browse:active {
  opacity: 0.8;
}
.snugg-uploader-dropzone__browse:focus-visible {
  box-shadow: 0 0 0 2px rgba(250, 123, 0, 0.5);
}
.snugg-uploader-dropzone__url-row {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  width: 500px;
  max-width: 100%;
}
.snugg-uploader-dropzone__url-input {
  box-sizing: border-box;
  flex: 1;
  height: 46px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #cccccc;
  border-radius: 6px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 142%;
  color: #555555;
  outline: none;
}
.snugg-uploader-dropzone__url-input::placeholder {
  color: #555555;
  opacity: 0.5;
}
.snugg-uploader-dropzone__url-input:focus {
  border-color: #fa7b00;
  box-shadow: 0 0 0 2px rgba(250, 123, 0, 0.2);
}
.snugg-uploader-dropzone__url-input:disabled {
  opacity: 0.6;
}
.snugg-uploader-dropzone__url-btn {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  width: 82px;
  height: 46px;
  background: linear-gradient(180deg, #505252 0%, #2f3030 100%);
  border: none;
  border-radius: 6px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  transition: opacity 0.15s ease;
  outline: none;
  -webkit-appearance: none;
}
.snugg-uploader-dropzone__url-btn:hover {
  opacity: 0.9;
}
.snugg-uploader-dropzone__url-btn:active {
  opacity: 0.8;
}
.snugg-uploader-dropzone__url-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.snugg-uploader-dropzone__url-btn:focus-visible {
  box-shadow: 0 0 0 2px rgba(47, 48, 48, 0.5);
}
.snugg-uploader-dropzone__size-pill {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 6px 12px;
  background: #f2f2f2;
  border-radius: 12px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 142%;
  color: #777777;
}
.snugg-uploader-dropzone__error {
  color: #c90606;
  font-size: 13px;
  margin-top: 4px;
}
.snugg-uploader-footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px 16px;
  min-height: 65px;
  border-top: 1px solid #eeeeee;
}
.snugg-uploader-footer:not(.snugg-uploader-footer--crop) > :first-child,
.snugg-uploader-footer:not(.snugg-uploader-footer--crop) > :last-child {
  flex: 0 0 160px;
}
.snugg-uploader-footer > :first-child {
  text-align: left;
}
.snugg-uploader-footer > :last-child {
  text-align: right;
}
@media (max-width: 600px) {
  .snugg-uploader-footer {
    padding: 10px 12px 14px;
  }
  .snugg-uploader-footer:not(.snugg-uploader-footer--crop) {
    flex-wrap: wrap;
    row-gap: 12px;
  }
  .snugg-uploader-footer:not(.snugg-uploader-footer--crop) .snugg-uploader-toolbar {
    order: -1;
    flex: 0 0 100%;
    padding: 0;
  }
  .snugg-uploader-footer:not(.snugg-uploader-footer--crop) > :first-child,
  .snugg-uploader-footer:not(.snugg-uploader-footer--crop) > :last-child {
    flex: 0 0 auto;
  }
  .snugg-uploader-footer .snugg-uploader-btn {
    padding: 0 14px;
    font-size: 13px;
    min-width: 0;
  }
}
.snugg-uploader-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-width: 90px;
  height: 40px;
  padding: 0 20px;
  border: 1px solid #fa7b00;
  border-radius: 6px;
  background: transparent;
  color: #fa7b00;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
  outline: none;
  -webkit-appearance: none;
}
.snugg-uploader-btn:hover {
  border-color: #ff9024;
  color: #ff9024;
}
.snugg-uploader-btn:active {
  border-color: #db6c00;
  color: #db6c00;
}
.snugg-uploader-btn:focus-visible {
  box-shadow: 0 0 0 2px rgba(250, 123, 0, 0.4);
}
.snugg-uploader-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.snugg-uploader-btn--primary {
  background: linear-gradient(180deg, #fea100 0%, #fa7b00 100%);
  border-color: #fa7b00;
  color: #fff;
  font-weight: 700;
}
.snugg-uploader-btn--primary:hover {
  opacity: 0.9;
  border-color: #ff9024;
  color: #fff;
}
.snugg-uploader-btn--primary:active {
  opacity: 0.8;
  border-color: #db6c00;
  color: #fff;
}
.snugg-uploader-btn--primary:disabled {
  background: #ccc;
  border-color: #ccc;
  color: #fff;
  opacity: 1;
}
.snugg-uploader-btn--close {
  min-width: 0;
  border-color: transparent;
  color: #777777;
}
.snugg-uploader-btn--close:hover {
  color: #333333;
  border-color: transparent;
}
.snugg-uploader-toolbar {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 0 12px;
}
.snugg-uploader-toolbar__btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 0;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: #333333;
  font-size: 18px;
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease;
  outline: none;
  -webkit-appearance: none;
}
.snugg-uploader-toolbar__btn:hover {
  background-color: rgba(0, 0, 0, 0.06);
  color: #fa7b00;
}
.snugg-uploader-toolbar__btn:focus-visible {
  box-shadow: 0 0 0 2px #fa7b00;
}
.snugg-uploader-toolbar__btn.snugg-uploader-toolbar__btn--active {
  color: #fa7b00;
}
.snugg-uploader-toolbar__btn.snugg-uploader-toolbar__btn--active::after {
  content: '';
  position: absolute;
  bottom: 2px;
  left: 50%;
  transform: translateX(-50%);
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #fa7b00;
}
.snugg-uploader-toolbar__btn:disabled {
  opacity: 0.35;
  cursor: default;
}
.snugg-uploader-toolbar__btn:disabled:hover {
  background-color: transparent;
  color: #333333;
}
.snugg-uploader-toolbar__btn[title] {
  position: relative;
}
.snugg-uploader-camera {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 20px;
}
.snugg-uploader-camera video {
  flex: 0 1 auto;
  min-height: 0;
  width: 100%;
  max-height: 380px;
  object-fit: contain;
  background: #000;
  border-radius: 4px;
}
.snugg-uploader-camera canvas {
  display: none;
}
.snugg-uploader-camera .snugg-uploader-camera__controls {
  flex-shrink: 0;
  margin-top: 16px;
}
@media (max-height: 500px) {
  .snugg-uploader-camera {
    padding: 10px;
  }
  .snugg-uploader-camera .snugg-uploader-camera__controls {
    margin-top: 10px;
  }
}
.snugg-uploader-camera .snugg-uploader-camera__error {
  color: #c90606;
  text-align: center;
  padding: 40px 20px;
}
.snugg-uploader-camera .snugg-uploader-camera__spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #777777;
}
.snugg-uploader-camera .snugg-uploader-camera__message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  max-width: 480px;
}
.snugg-uploader-camera .snugg-uploader-camera__message-heading {
  font-family: 'Open Sans', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 142%;
  color: #333333;
  margin-bottom: 8px;
}
.snugg-uploader-camera .snugg-uploader-camera__message-line {
  font-family: 'Open Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 160%;
  color: #777777;
}
.snugg-uploader-camera .snugg-uploader-camera__message-line:first-of-type {
  font-weight: 600;
  color: #333333;
  margin-top: 4px;
  margin-bottom: 6px;
}
.snugg-uploader-camera .snugg-uploader-camera__message-action {
  margin-top: 20px;
  padding: 10px 20px;
  background: transparent;
  border: 1px solid #fa7b00;
  border-radius: 6px;
  color: #fa7b00;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease;
  outline: none;
  -webkit-appearance: none;
}
.snugg-uploader-camera .snugg-uploader-camera__message-action:hover {
  background-color: rgba(250, 123, 0, 0.08);
}
.snugg-uploader-camera .snugg-uploader-camera__message-action:focus-visible {
  box-shadow: 0 0 0 2px rgba(250, 123, 0, 0.4);
}
.snugg-uploader-url {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 20px 40px;
}
.snugg-uploader-url__input-group {
  display: flex;
  width: 100%;
  max-width: 500px;
  gap: 8px;
  margin-bottom: 8px;
}
.snugg-uploader-url__input-group input {
  flex: 1;
  height: 40px;
  padding: 0 12px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  font-family: inherit;
  outline: none;
}
.snugg-uploader-url__input-group input:focus {
  border-color: #fa7b00;
  box-shadow: 0 0 0 2px rgba(250, 123, 0, 0.2);
}
.snugg-uploader-url__input-group input::placeholder {
  color: #bbb;
}
.snugg-uploader-url__error {
  color: #c90606;
  font-size: 13px;
  margin-bottom: 8px;
  max-width: 500px;
  width: 100%;
}
.snugg-uploader-url__preview {
  text-align: center;
  margin-top: 16px;
}
.snugg-uploader-url__preview img {
  max-width: 100%;
  max-height: 260px;
  border-radius: 4px;
  margin-bottom: 12px;
}
.snugg-uploader-editor {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  overflow: hidden;
}
.snugg-uploader-editor img {
  max-width: 100%;
  display: block;
}
.snugg-uploader-editor-canvas-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.snugg-uploader-preview-canvas {
  max-width: 100%;
  max-height: 100%;
  display: block;
  border-radius: 4px;
}
.snugg-uploader-editor .cropper-container {
  max-height: 100%;
}
.snugg-uploader-editor .cropper-view-box {
  outline: 1px solid rgba(255, 255, 255, 0.7);
  outline-color: rgba(51, 153, 255, 0.5);
}
.snugg-uploader-editor .cropper-line {
  background-color: #fa7b00;
  opacity: 0.2;
}
.snugg-uploader-editor .cropper-point {
  background-color: #fa7b00;
  opacity: 0.7;
  width: 8px;
  height: 8px;
}
.snugg-uploader-editor .cropper-modal {
  background-color: #000;
  opacity: 0.4;
}
.custom-uploader-progress {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background-color: #eee;
  border-radius: 0 0 6px 6px;
  overflow: hidden;
}
.custom-uploader-progress .progress-fill {
  height: 100%;
  background-color: #ff9003;
  transition: width 0.2s ease;
}
.snugg-uploader-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 40px;
  color: #777777;
  font-size: 14px;
}
.snugg-uploader-error {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px;
  color: #777777;
  font-size: 14px;
}
.snugg-uploader-mobile-home {
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  position: relative;
  padding: 56px 24px 40px;
}
.snugg-uploader-mobile-home__close {
  position: absolute;
  top: 12px;
  right: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: transparent;
  border: none;
  border-radius: 50%;
  color: #333333;
  cursor: pointer;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  transition: background-color 0.15s ease;
}
.snugg-uploader-mobile-home__close:hover {
  background-color: rgba(0, 0, 0, 0.06);
}
.snugg-uploader-mobile-home__close:focus-visible {
  box-shadow: inset 0 0 0 2px #fa7b00;
}
.snugg-uploader-mobile-home__back {
  position: absolute;
  top: 12px;
  left: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: transparent;
  border: none;
  border-radius: 50%;
  color: #333333;
  cursor: pointer;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  transition: background-color 0.15s ease;
}
.snugg-uploader-mobile-home__back:hover {
  background-color: rgba(0, 0, 0, 0.06);
}
.snugg-uploader-mobile-home__back:focus-visible {
  box-shadow: inset 0 0 0 2px #fa7b00;
}
.snugg-uploader-mobile-sources {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 14px;
  width: 100%;
  max-width: 300px;
}
.snugg-uploader-mobile-source-btn {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding: 18px 24px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 14px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 17px;
  line-height: 1.3;
  color: #333333;
  cursor: pointer;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  text-align: left;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  transition: background-color 0.15s ease;
}
.snugg-uploader-mobile-source-btn:hover {
  background-color: #f7f7f7;
}
.snugg-uploader-mobile-source-btn:active {
  background-color: #efefef;
}
.snugg-uploader-mobile-source-btn:focus-visible {
  box-shadow: 0 0 0 2px #fa7b00;
}
.snugg-uploader-mobile-source-btn__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #777777;
}
.snugg-uploader-mobile-source-btn__icon svg {
  width: 22px;
  height: 22px;
}
.snugg-uploader-mobile-source-btn__label {
  white-space: nowrap;
}
.snugg-uploader-mobile-home__filesize {
  margin-top: 20px;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  color: #777777;
}
.snugg-uploader-url-tab {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 24px 32px;
  gap: 8px;
}
.snugg-uploader-url-tab .snugg-uploader-dropzone__url-row {
  width: 100%;
  max-width: 480px;
}
.snugg-uploader-mobile-nav {
  display: none;
  flex-shrink: 0;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  padding: 0 4px;
  background: #f2f2f2;
  border-bottom: 1px solid #eeeeee;
}
.snugg-uploader-mobile-nav__back {
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 0 12px;
  height: 44px;
  background: transparent;
  border: none;
  color: #fa7b00;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  font-size: 15px;
  cursor: pointer;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  border-radius: 4px;
  transition: background-color 0.15s ease;
}
.snugg-uploader-mobile-nav__back:hover {
  background-color: rgba(0, 0, 0, 0.04);
}
.snugg-uploader-mobile-nav__back:focus-visible {
  box-shadow: inset 0 0 0 2px #fa7b00;
}
.snugg-uploader-mobile-nav__back svg {
  width: 18px;
  height: 18px;
}
.snugg-uploader-mobile-nav__close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background: transparent;
  border: none;
  color: #333333;
  cursor: pointer;
  border-radius: 4px;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  transition: background-color 0.15s ease;
}
.snugg-uploader-mobile-nav__close:hover {
  background-color: rgba(0, 0, 0, 0.06);
}
.snugg-uploader-mobile-nav__close:focus-visible {
  box-shadow: inset 0 0 0 2px #fa7b00;
}
.snugg-uploader-mobile-nav__menu {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background: transparent;
  border: none;
  color: #333333;
  cursor: pointer;
  border-radius: 4px;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  transition: background-color 0.15s ease;
}
.snugg-uploader-mobile-nav__menu:hover {
  background-color: rgba(0, 0, 0, 0.06);
}
.snugg-uploader-mobile-nav__menu:focus-visible {
  box-shadow: inset 0 0 0 2px #fa7b00;
}
@media (max-width: 767px) {
  .snugg-uploader-header {
    display: none;
  }
  .snugg-uploader-panel--picker .snugg-uploader-body {
    display: none;
  }
  .snugg-uploader-panel--picker .snugg-uploader-mobile-home {
    display: flex;
  }
  .snugg-uploader-panel:not(.snugg-uploader-panel--picker) .snugg-uploader-mobile-nav {
    display: flex;
  }
}
.snugg-uploader-gdrive {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-align: center;
  color: #777777;
  font-size: 14px;
  overflow: hidden;
}
.snugg-uploader-gdrive__status {
  color: #777777;
  font-size: 14px;
  padding: 40px;
}
.snugg-uploader-gdrive__error {
  color: #c90606;
  font-size: 13px;
  padding: 40px;
  max-width: 400px;
}
.content-header .dropdown-menu {
  min-width: 280px;
}
.dropdown-toggle .badge {
  background-color: #303232;
  color: #d9d9d9;
}
.dropdown-toggle .badge .badge-left-tip {
  border-right-color: #303232;
}
.dropdown-menu {
  overflow: scroll;
  max-height: 500px;
  padding: 0;
  border-radius: 6px;
  padding: 8px;
  border: none;
  width: 100%;
  margin-top: -1px;
  text-align: left;
  background-color: #fff;
  box-shadow: 0 5px 20px 5px rgba(0, 0, 0, 0.3);
  z-index: 1065;
}
.dropdown-menu .active,
.dropdown-menu .active > a,
.dropdown-menu .active > a:hover,
.dropdown-menu a:active,
.dropdown-menu a:focus {
  border-radius: 4px;
  background-color: #eeeeee;
  color: #000;
}
.dropdown-menu .active .badge,
.dropdown-menu .active > a .badge,
.dropdown-menu .active > a:hover .badge,
.dropdown-menu a:active .badge,
.dropdown-menu a:focus .badge {
  background-color: #303232;
  color: #d9d9d9;
}
.dropdown-menu .active .badge .badge-left-tip,
.dropdown-menu .active > a .badge .badge-left-tip,
.dropdown-menu .active > a:hover .badge .badge-left-tip,
.dropdown-menu a:active .badge .badge-left-tip,
.dropdown-menu a:focus .badge .badge-left-tip {
  border-right-color: #303232;
}
.dropdown-menu > li.top-divider {
  border-top: 3px solid #cccccc;
  position: relative;
}
.dropdown-menu > li > a {
  padding: 13px 10px;
  border-radius: 4px;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 13px;
}
.dropdown-menu > li > a:hover,
.dropdown-menu > li > a:focus {
  background-color: #f2f2f2;
  outline: none;
}
.dropdown-menu > li > a:hover .badge,
.dropdown-menu > li > a:focus .badge {
  background-color: #777777;
  color: #f2f2f2;
}
.dropdown-menu > li > a:hover .badge .badge-left-tip,
.dropdown-menu > li > a:focus .badge .badge-left-tip {
  border-right-color: #777777;
}
.dropdown-menu > li > a:active {
  background-color: #cccccc;
}
.dropdown.btn-group {
  width: 100%;
  border-left: solid 0px transparent;
}
.dropdown.btn-group > .btn:first-child {
  background-color: #f9f9f9;
  border: none;
}
.dropdown.btn-group#btn-group-companies {
  position: relative;
  z-index: 4;
}
.dropdown.btn-group#btn-group-companies > .btn {
  border-left: none;
  border-radius: 0;
}
.dropdown.btn-group#btn-group-stages {
  z-index: 3;
  position: relative;
  text-align: left;
}
.dropdown.btn-group#btn-group-stages > .btn {
  border-left: none;
  border-radius: 0;
}
.dropdown.btn-group#btn-group-sort {
  border-right: 1px solid #ededed;
  text-align: left;
}
.dropdown.btn-group#btn-group-sort > .btn {
  border-left: none;
  border-radius: 0;
}
.dropdown.btn-group .btn {
  float: none;
  text-align: left;
  border-color: transparent;
  border-top: none;
  border-bottom: none;
  border-right: none;
  background-color: inherit;
  margin: auto;
  height: 100%;
  width: 100%;
  min-width: 60px;
  padding: 4px 12px;
  font-size: 12px;
  color: #303232;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}
.dropdown.btn-group .btn [class*=' ico-'],
.dropdown.btn-group .btn [class^='ico-'] {
  font-size: 16px;
  display: block;
  float: none;
  clear: both;
}
.dropdown.btn-group .btn:hover {
  background-color: #ededed;
}
.dropdown.btn-group .btn:hover .arrow-right {
  border-left-color: #ededed;
}
.dropdown.btn-group .btn:hover .arrow-right-n1,
.dropdown.btn-group .btn:hover .arrow-right-n2 {
  border-right-color: #ededed;
}
.dropdown.btn-group .btn:active,
.dropdown.btn-group .btn.active,
.dropdown.btn-group .btn:focus {
  color: #303232;
  box-shadow: none;
  background-color: #e3e3e3;
}
.dropdown.btn-group .btn:active .arrow-right,
.dropdown.btn-group .btn.active .arrow-right,
.dropdown.btn-group .btn:focus .arrow-right {
  border-left-color: #e3e3e3;
}
.dropdown.btn-group .btn .arrow-right {
  width: 0;
  height: 0;
  border-top: 23px solid transparent;
  border-bottom: 23px solid transparent;
  border-left: 14px solid #f9f9f9;
  float: right;
  position: absolute;
  right: -13px;
  top: 0;
  z-index: 10;
}
.dropdown.btn-group .btn .arrow-right.arrow-right-border {
  right: -14px;
  border-left-color: #d9d9d9;
  z-index: 9;
}
.dropdown.btn-group .btn.btn-lg {
  font-size: 14px;
  padding: 7px 13px 14px 20px;
}
.dropdown.btn-group .btn.btn-lg .caret {
  margin: auto 0 auto 8px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 8px;
  font-size: 24px;
  border-left-width: 5px;
  border-right-width: 5px;
  border-top-width: 5px;
  opacity: 0.7;
}
.dropdown.btn-group .btn.btn-lg .badge {
  margin: 0 10px 0 0;
  top: 1px;
}
.dropdown.btn-group.open .dropdown-toggle {
  -webkit-box-shadow: none;
  box-shadow: none;
  background-color: #f7f7f7;
  color: #303232;
}
.dropdown.btn-group.open .dropdown-toggle .arrow-right {
  border-left: 14px solid #f7f7f7;
}
.dropdown.btn-group.open .dropdown-toggle .arrow-right.arrow-right-border {
  border-left-color: #e5e5e5;
}
.secondary-nav::-webkit-scrollbar {
  width: 8px;
  background-color: transparent;
}
.secondary-nav::-webkit-scrollbar-track {
  background-color: transparent;
  margin-bottom: 30px;
}
.secondary-nav::-webkit-scrollbar-thumb {
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.25);
}
@media (min-height: 720px) {
  .secondary-nav::-webkit-scrollbar {
    display: none;
  }
}
@media (min-height: 425px) {
  .secondary-nav.report-secondary-nav::-webkit-scrollbar {
    display: none;
  }
}
:focus {
  outline: transparent auto 0;
}
html {
  height: 100%;
}
body {
  height: 100%;
  background: #ffffff;
  font-weight: 400;
  color: #303232;
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: #303232;
  line-height: 1.4em;
}
h1,
h2,
h3 {
  text-rendering: auto;
}
h2 {
  font-size: 24px;
  margin-bottom: 15px;
}
h4 {
  font-weight: 600;
  margin-bottom: 10px;
}
h5 {
  line-height: 1.1em;
  font-weight: 600;
  color: inherit;
}
a {
  color: #c84900;
}
a:focus {
  text-decoration: none;
}
a:hover {
  color: #e25200;
  text-decoration: none;
}
.desaturate {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  filter: grayscale(100%);
}
hr {
  border-top: 1px solid #ddd;
}
textarea::-moz-placeholder,
select::-moz-placeholder,
.form-control::-moz-placeholder,
input[type='text']::-moz-placeholder,
input[type='password']::-moz-placeholder,
input[type='datetime']::-moz-placeholder,
input[type='datetime-local']::-moz-placeholder,
input[type='date']::-moz-placeholder,
input[type='month']::-moz-placeholder,
input[type='time']::-moz-placeholder,
input[type='week']::-moz-placeholder,
input[type='number']::-moz-placeholder,
input[type='email']::-moz-placeholder,
input[type='url']::-moz-placeholder,
input[type='search']::-moz-placeholder,
input[type='tel']::-moz-placeholder,
input[type='color']::-moz-placeholder,
.uneditable-input::-moz-placeholder {
  color: #aaa;
  opacity: 1;
}
textarea:-ms-input-placeholder,
select:-ms-input-placeholder,
.form-control:-ms-input-placeholder,
input[type='text']:-ms-input-placeholder,
input[type='password']:-ms-input-placeholder,
input[type='datetime']:-ms-input-placeholder,
input[type='datetime-local']:-ms-input-placeholder,
input[type='date']:-ms-input-placeholder,
input[type='month']:-ms-input-placeholder,
input[type='time']:-ms-input-placeholder,
input[type='week']:-ms-input-placeholder,
input[type='number']:-ms-input-placeholder,
input[type='email']:-ms-input-placeholder,
input[type='url']:-ms-input-placeholder,
input[type='search']:-ms-input-placeholder,
input[type='tel']:-ms-input-placeholder,
input[type='color']:-ms-input-placeholder,
.uneditable-input:-ms-input-placeholder {
  color: #aaa;
}
textarea::-webkit-input-placeholder,
select::-webkit-input-placeholder,
.form-control::-webkit-input-placeholder,
input[type='text']::-webkit-input-placeholder,
input[type='password']::-webkit-input-placeholder,
input[type='datetime']::-webkit-input-placeholder,
input[type='datetime-local']::-webkit-input-placeholder,
input[type='date']::-webkit-input-placeholder,
input[type='month']::-webkit-input-placeholder,
input[type='time']::-webkit-input-placeholder,
input[type='week']::-webkit-input-placeholder,
input[type='number']::-webkit-input-placeholder,
input[type='email']::-webkit-input-placeholder,
input[type='url']::-webkit-input-placeholder,
input[type='search']::-webkit-input-placeholder,
input[type='tel']::-webkit-input-placeholder,
input[type='color']::-webkit-input-placeholder,
.uneditable-input::-webkit-input-placeholder {
  color: #aaa;
}
.form-group-lg select[multiple].form-control {
  padding: 0;
}
.form-group-lg select[multiple].form-control option {
  border-bottom: 1px dashed #ddd;
  padding: 10px 15px;
}
.form-group-lg select[multiple].form-control option:hover {
  background-color: #ffd39c;
}
.form-group-lg select[multiple].form-control option:active,
.form-group-lg select[multiple].form-control option:focus,
.form-group-lg select[multiple].form-control option:checked {
  background-color: #ff9003;
}
textarea:focus,
select:focus,
.form-control:focus,
.form-control.focused,
input[type='text']:focus,
input[type='password']:focus,
input[type='datetime']:focus,
input[type='datetime-local']:focus,
input[type='date']:focus,
input[type='month']:focus,
input[type='time']:focus,
input[type='week']:focus,
input[type='number']:focus,
input[type='email']:focus,
input[type='url']:focus,
input[type='search']:focus,
input[type='tel']:focus,
input[type='color']:focus,
.uneditable-input:focus {
  border-color: #66afe9;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
  outline: 0;
  outline: thin dotted \\9;
  /* IE6-9 */
}
textarea:focus::-moz-placeholder,
select:focus::-moz-placeholder,
.form-control:focus::-moz-placeholder,
.form-control.focused::-moz-placeholder,
input[type='text']:focus::-moz-placeholder,
input[type='password']:focus::-moz-placeholder,
input[type='datetime']:focus::-moz-placeholder,
input[type='datetime-local']:focus::-moz-placeholder,
input[type='date']:focus::-moz-placeholder,
input[type='month']:focus::-moz-placeholder,
input[type='time']:focus::-moz-placeholder,
input[type='week']:focus::-moz-placeholder,
input[type='number']:focus::-moz-placeholder,
input[type='email']:focus::-moz-placeholder,
input[type='url']:focus::-moz-placeholder,
input[type='search']:focus::-moz-placeholder,
input[type='tel']:focus::-moz-placeholder,
input[type='color']:focus::-moz-placeholder,
.uneditable-input:focus::-moz-placeholder {
  color: #ccc;
  opacity: 1;
}
textarea:focus:-ms-input-placeholder,
select:focus:-ms-input-placeholder,
.form-control:focus:-ms-input-placeholder,
.form-control.focused:-ms-input-placeholder,
input[type='text']:focus:-ms-input-placeholder,
input[type='password']:focus:-ms-input-placeholder,
input[type='datetime']:focus:-ms-input-placeholder,
input[type='datetime-local']:focus:-ms-input-placeholder,
input[type='date']:focus:-ms-input-placeholder,
input[type='month']:focus:-ms-input-placeholder,
input[type='time']:focus:-ms-input-placeholder,
input[type='week']:focus:-ms-input-placeholder,
input[type='number']:focus:-ms-input-placeholder,
input[type='email']:focus:-ms-input-placeholder,
input[type='url']:focus:-ms-input-placeholder,
input[type='search']:focus:-ms-input-placeholder,
input[type='tel']:focus:-ms-input-placeholder,
input[type='color']:focus:-ms-input-placeholder,
.uneditable-input:focus:-ms-input-placeholder {
  color: #ccc;
}
textarea:focus::-webkit-input-placeholder,
select:focus::-webkit-input-placeholder,
.form-control:focus::-webkit-input-placeholder,
.form-control.focused::-webkit-input-placeholder,
input[type='text']:focus::-webkit-input-placeholder,
input[type='password']:focus::-webkit-input-placeholder,
input[type='datetime']:focus::-webkit-input-placeholder,
input[type='datetime-local']:focus::-webkit-input-placeholder,
input[type='date']:focus::-webkit-input-placeholder,
input[type='month']:focus::-webkit-input-placeholder,
input[type='time']:focus::-webkit-input-placeholder,
input[type='week']:focus::-webkit-input-placeholder,
input[type='number']:focus::-webkit-input-placeholder,
input[type='email']:focus::-webkit-input-placeholder,
input[type='url']:focus::-webkit-input-placeholder,
input[type='search']:focus::-webkit-input-placeholder,
input[type='tel']:focus::-webkit-input-placeholder,
input[type='color']:focus::-webkit-input-placeholder,
.uneditable-input:focus::-webkit-input-placeholder {
  color: #ccc;
}
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button,
input[type='datetime']::-webkit-inner-spin-button,
input[type='datetime']::-webkit-outer-spin-button,
input[type='datetime-local']::-webkit-inner-spin-button,
input[type='datetime-local']::-webkit-outer-spin-button,
input[type='date']::-webkit-inner-spin-button,
input[type='date']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button,
input[type='date']::-webkit-inner-spin-button,
input[type='date']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
legend {
  margin-bottom: 15px;
}
.has-error {
  position: relative;
}
.has-error .form-control.focused {
  border-color: #843534;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;
}
body #primary-container {
  background-color: #f9f9f9;
  height: auto;
  min-height: 100vh;
}
body #primary-container ::-webkit-input-placeholder {
  color: #aaa;
}
body #primary-container .inverse-placeholder ::-webkit-input-placeholder {
  color: #fff;
}
body #primary-container .inverse-placeholder:hover ::-webkit-input-placeholder {
  color: #777777;
}
body #primary-container .sidebar-placeholder::-webkit-input-placeholder {
  color: #857e79;
}
.form-horizontal textarea {
  height: 80px;
}
.input-xsmall {
  width: 60px;
}
.search-jobs.topmost-search-job-container {
  display: inline-block;
  width: 210px;
  float: left;
}
.form-search .form-group {
  margin-top: 8px;
  margin-bottom: 8px;
  border-radius: 30px;
  border: 1px solid #eeeeee;
}
.form-search .form-group:focus-within {
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
  border-color: #66afe9;
}
.form-search .form-group .form-control.search-query {
  -webkit-appearance: none;
  outline: none;
  box-shadow: none;
  padding-left: 0;
  padding-right: 3px;
  border-right-width: 0;
  border-left-width: 0;
  padding-top: 7px;
  padding-bottom: 7px;
  border: none;
  font-size: 16px;
}
.form-search .form-group .input-group-addon {
  box-shadow: none;
  background-color: white;
  font-size: 18px;
  color: #777;
  padding-top: 10px;
  min-width: initial;
  width: 30px;
  border: none;
}
.form-search .form-group .input-group-addon.input-group-addon-clickable:hover {
  color: #000;
  cursor: pointer;
}
.form-search .form-group .input-group-addon:first-child {
  border-radius: 30px 0 0 30px;
  border-right: none;
}
.form-search .form-group .input-group-addon:last-child {
  border-radius: 0 30px 30px 0;
}
.form-group {
  height: auto !important;
  -webkit-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.form-group.success {
  -webkit-transition: border-color 0.4s ease-in-out;
  -moz-transition: border-color 0.4s ease-in-out;
  -o-transition: border-color 0.4s ease-in-out;
  transition: border-color 0.4s ease-in-out;
}
.form-group-lg .form-control-static,
.form-group-lg .form-control-static {
  padding-top: 12px;
  padding-bottom: 7px;
}
.form-group-lg .btn-group > .btn,
.form-group-lg .btn-group > .btn {
  padding: 12px 11px;
  min-width: 47px;
}
label {
  font-weight: 600;
  padding: 0.3em 0.6em 0.3em;
}
label small {
  color: #777777;
}
.label.label-danger {
  margin-top: 2px;
  color: #ffffff;
}
.label-touch {
  cursor: pointer;
}
.label-touch:hover {
  background-color: #f2f2f2;
}
.label {
  color: #303232;
  font-weight: 400;
}
.input-group-addon {
  background-color: #f7f7f7;
  min-width: 40px;
  padding: 6px 8px;
  color: #777777;
  font-size: 1em !important;
}
::selection {
  background-color: #f2a814;
  color: #000;
}
.form-group.form-group-two-rows label.control-label {
  padding-top: inherit;
}
.label-secondary {
  font-size: 0.85em;
  text-transform: uppercase;
  margin-top: 10px;
}
.jl .snugg-select {
  height: 74px;
}
.snugg-select {
  width: 36px;
  height: 46px;
  position: relative;
  float: left;
  cursor: pointer;
}
.snugg-select > span {
  border-radius: 2px;
  width: 20px;
  height: 20px;
  line-height: 1.2em;
  display: block;
  cursor: pointer;
  margin: auto;
  font-size: 18px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  background: #fff;
  position: absolute;
  text-align: center;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  ms-user-select: none;
}
.snugg-select > span:after {
  content: '';
  width: 20px;
  height: 20px;
  display: block;
}
.snugg-select:hover {
  background-color: #fef4cb;
  color: #cccccc;
}
.snugg-select:hover span {
  border-color: #555555;
}
.snugg-select:hover span:after {
  content: '\\2713';
}
.snugg-select:hover:active,
.snugg-select:active,
.snugg-select:focus,
.snugg-select:focus:active {
  background-color: #fef4cb;
  color: black;
}
.snugg-select:hover:active span,
.snugg-select:active span,
.snugg-select:focus span,
.snugg-select:focus:active span {
  background: #777777;
}
.snugg-select:hover:active span:after,
.snugg-select:active span:after,
.snugg-select:focus span:after,
.snugg-select:focus:active span:after {
  content: '\\2713';
}
.snugg-selected .snugg-select span {
  color: #333333;
  background: #fff;
}
.snugg-selected .snugg-select span:after {
  content: '';
}
.snugg-selected .snugg-select:hover span {
  color: #777777;
}
.snugg-selected .snugg-select:hover span:after {
  content: '';
}
.snugg-selected .snugg-select:focus span,
.snugg-selected .snugg-select:focus:active span,
.snugg-selected .snugg-select:active span {
  background: #777777;
  color: #555555;
}
.snugg-selected {
  background-color: #fff4e6;
}
.snugg-selected:nth-child(even) {
  background-color: #fff8f0;
}
.table-extra-condensed > tbody > tr > td,
.table-extra-condensed > thead > tr > th {
  padding: 5px 2px;
  font-size: 0.8em;
  line-height: 100%;
}
table.table th {
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.9em;
}
table.table.table-expansive th,
table.table.table-expansive td {
  padding: 15px 5px;
  line-height: 100%;
  vertical-align: middle;
}
.table-striped > tbody > tr:nth-child(odd) > td,
.table-striped > tbody > tr:nth-child(odd) > th {
  background-color: #f5f5f5;
}
.has-switch:focus {
  outline: none;
}
.select-inline {
  margin-left: 10px;
  margin-top: 10px;
}
/* target job form only*/
.form-block {
  *zoom: 1;
  padding-bottom: 30px;
  margin-bottom: 10;
}
.form-block:before,
.form-block:after {
  content: " ";
  display: table;
}
.form-block:after {
  clear: both;
}
.form-block:before,
.form-block:after {
  display: table;
  content: '';
  line-height: 0;
}
.form-block:after {
  clear: both;
}
.headless-page {
  margin-top: 50px;
}
.container-flex {
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
}
.signin-container {
  background-color: #e8e8e8;
  position: relative;
  z-index: 0;
  min-height: 100vh;
  min-width: 320px;
}
.signin-container h1 {
  font-size: 24px;
  font-weight: 600;
}
.signin-container h2 {
  font-size: 18px;
  font-weight: 600;
}
.signin-container h3 {
  font-weight: 400;
}
.signin-container .signin-form {
  padding: 25px 30px 10px;
  margin-bottom: 30px;
  border: 1px solid #dddddd;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
}
.signin-container .signin-form:after {
  content: '';
  position: absolute;
  z-index: -1;
  -webkit-box-shadow: 0 5px 40px rgba(0, 0, 0, 0.4);
  box-shadow: 0 5px 40px rgba(0, 0, 0, 0.4);
  bottom: 0;
  left: 0;
  right: 0;
  top: auto;
  height: 30px;
  width: 90%;
  margin: auto 5%;
}
.signin-container .welcome-logo {
  text-align: center;
}
.signin-container .welcome-logo img {
  margin: 0 auto 10px;
}
.otp-form {
  margin-top: 26px;
}
.opt-login-link-section {
  margin-top: 10px;
  margin-bottom: 23px;
}
.otp-title {
  color: #333333;
  font-size: 20px;
  font-weight: 600;
}
.otp-title-bottom {
  height: 43px;
}
.pointer {
  cursor: pointer;
}
.form-wizard {
  display: table;
  margin-top: 20px;
  width: 100%;
}
.form-wizard span {
  text-align: center;
  display: table-cell;
  color: #ccc;
  position: relative;
  width: 25%;
}
.form-wizard span.completed {
  color: #666;
}
.form-wizard i {
  display: block;
  font-size: 18px;
}
.form-wizard label {
  display: block;
  font-size: 12px;
}
.form-wizard span:before,
.form-wizard span:after {
  position: absolute;
  content: '';
  right: -10px;
  top: 8px;
  width: 50%;
  height: 0;
  border-bottom: 1px dashed #ccc;
}
.form-wizard span:before {
  left: -8px;
}
.form-wizard span:first-child:before {
  display: none;
}
.form-wizard span:last-child:after {
  display: none;
}
.otp-secret-input {
  padding-left: 25px;
  padding-right: 25px;
  letter-spacing: 18px;
  font-family: 'Courier New', monospace;
  font-weight: bold;
  width: 100% !important;
  box-shadow: none !important;
  font-size: 30px;
  height: auto;
}
.otp-form {
  max-width: 490px;
}
@media (max-width: 767px) {
  .otp-form {
    max-width: 250px;
  }
}
.secret-key-input {
  height: 46px;
  font-size: 30px;
  letter-spacing: 30px;
}
.dashes-text {
  text-align: center;
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 3px;
  border-style: dashed;
  border-radius: 11px;
  line-height: 42px;
  margin-top: 15px;
  margin-bottom: 15px;
  border: 2px dashed #bcb8b0;
}
.phone-format-number {
  letter-spacing: 1px;
}
.alert-error-link {
  font-weight: bold;
  color: #6c3636 !important;
}
.phone-number-input {
  height: 46px;
  margin-top: 72px;
  font-size: 17px;
  letter-spacing: 7px;
}
.form-control.input-header .input-header,
.form-group-lg .form-control .input-header {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: #c84900 dashed 1px;
  box-shadow: none;
  padding: 10px 0 0;
  line-height: inherit;
  height: auto;
  border-radius: 0;
  font-size: 18px;
  color: #000;
}
.form-control.input-header .input-header:hover,
.form-group-lg .form-control .input-header:hover {
  background-color: #fef2c1;
}
.form-control.input-header .input-header:focus,
.form-group-lg .form-control .input-header:focus {
  background-color: inherit;
  outline: none;
  box-shadow: none;
}
.form-group-lg input[type='date'].form-control {
  line-height: 2.5em;
}
.back-link {
  color: #333333;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  margin-bottom: 10px;
  display: inline-block;
}
.back-link:hover {
  color: #333333;
}
.back-icon {
  font-size: 21px;
  float: left;
  margin-right: 11px;
}
button[disabled] {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
}
.btn {
  border-radius: 4px;
  background-image: none;
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  background-color: #e7e7e7;
  box-sizing: border-box;
  vertical-align: middle;
  outline: none;
  outline-offset: 0;
}
.btn:focus,
.btn:active:focus,
.btn:active,
.btn.active,
.btn.active:focus,
.btn:hover:focus {
  outline: none;
  outline-offset: 0;
}
.btn:hover {
  background-color: #dadada;
}
.btn.disabled,
.btn[disabled] {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
}
.btn.active[disabled] {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
  background-color: #dadada !important;
  color: #6f6f6f !important;
}
.btn-mini {
  line-height: 1em;
  padding: 6px;
}
.btn-mini [class^='icofont-'],
.btn-mini [class*=' icofont-'] {
  font-size: 20px;
}
.btn-md {
  padding: 15px 6px;
  font-size: 12px;
  line-height: 1.33;
}
.btn-lg {
  font-size: 16px;
  padding: 15px;
}
.btn-group-lg > .btn {
  font-size: 16px;
}
.btn-xlarge {
  padding: 15px 25px;
  font-size: 24px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}
.btn-brand-1,
.btn-primary {
  background: #ff7f00;
  border: none;
  background-image: linear-gradient(10deg, #f96b00 0%, #ffb100 100% 100%);
  color: #fff;
  font-weight: 600;
}
.btn-brand-1:hover,
.btn-primary:hover {
  background-image: linear-gradient(10deg, #f47516 0%, #ffbc22 100% 100%);
  color: #fff;
}
.btn-brand-1:active,
.btn-primary:active,
.btn-brand-1:focus,
.btn-primary:focus {
  background: #ff7f00;
  background-image: linear-gradient(10deg, #e26202 0%, #ffb000 100% 100%);
  color: #fff;
}
.btn-brand-1.disabled,
.btn-primary.disabled,
.btn-brand-1[disabled],
.btn-primary[disabled] {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
}
.btn-brand-2 {
  position: relative;
  cursor: pointer;
  color: #fff;
  background: #303232;
  background-image: 0;
  text-shadow: none;
  font-weight: normal;
}
.btn-brand-2:hover,
.btn-brand-2:focus {
  background: #414444;
  color: #fff;
}
.btn-brand-2.active,
.btn-brand-2:active,
.open > .dropdown-toggle.btn-brand-2 {
  background-color: #171818;
  color: #fff;
}
.btn-brand-2:active,
.btn-brand-2.active,
.open > .dropdown-toggle.btn-brand-2 {
  background-image: none;
}
.btn-brand-2:before {
  display: block;
  position: absolute;
  padding-top: 10px;
  top: 10px;
}
.btn-brand-2.disabled,
.btn-brand-2[disabled],
fieldset[disabled] .btn-brand-2,
.btn-brand-2.disabled:hover,
.btn-brand-2[disabled]:hover,
fieldset[disabled] .btn-brand-2:hover,
.btn-brand-2.disabled:focus,
.btn-brand-2[disabled]:focus,
fieldset[disabled] .btn-brand-2:focus,
.btn-brand-2.disabled:active,
.btn-brand-2[disabled]:active,
fieldset[disabled] .btn-brand-2:active,
.btn-brand-2.disabled.active,
.btn-brand-2[disabled].active,
fieldset[disabled] .btn-brand-2.active {
  background-color: #303232;
  border-color: transparent;
}
.btn-brand-2 .badge {
  color: #303232;
  background-color: #fff;
}
.btn-brand-2.disabled,
.btn-brand-2[disabled],
.btn-brand-2.disabled:hover,
.btn-brand-2[disabled]:hover,
.btn-brand-2.disabled:focus,
.btn-brand-2[disabled]:focus,
.btn-brand-2.disabled:active,
.btn-brand-2[disabled]:active,
.btn-brand-2.disabled.active,
.btn-brand-2[disabled].active {
  background-color: #303232;
  border-color: transparent;
}
.btn-brand-3 {
  color: #a5a5a5;
  background-color: rgba(0, 0, 0, 0.03);
  border-color: #cccccc;
}
.btn-brand-3:hover,
.btn-brand-3:focus,
.btn-brand-3:active,
.btn-brand-3.active,
.open > .dropdown-toggle.btn-brand-3 {
  color: #a5a5a5;
  background-color: rgba(0, 0, 0, 0.03);
  border-color: #adadad;
}
.btn-brand-3:active,
.btn-brand-3.active,
.open > .dropdown-toggle.btn-brand-3 {
  background-image: none;
}
.btn-brand-3.disabled,
.btn-brand-3[disabled],
fieldset[disabled] .btn-brand-3,
.btn-brand-3.disabled:hover,
.btn-brand-3[disabled]:hover,
fieldset[disabled] .btn-brand-3:hover,
.btn-brand-3.disabled:focus,
.btn-brand-3[disabled]:focus,
fieldset[disabled] .btn-brand-3:focus,
.btn-brand-3.disabled:active,
.btn-brand-3[disabled]:active,
fieldset[disabled] .btn-brand-3:active,
.btn-brand-3.disabled.active,
.btn-brand-3[disabled].active,
fieldset[disabled] .btn-brand-3.active {
  background-color: rgba(0, 0, 0, 0.03);
  border-color: #cccccc;
}
.btn-brand-3 .badge {
  color: rgba(0, 0, 0, 0.03);
  background-color: #a5a5a5;
}
.btn-brand-3.disabled,
.btn-brand-3[disabled],
.btn-brand-3.disabled:hover,
.btn-brand-3[disabled]:hover,
.btn-brand-3.disabled:focus,
.btn-brand-3[disabled]:focus,
.btn-brand-3.disabled:active,
.btn-brand-3[disabled]:active,
.btn-brand-3.disabled.active,
.btn-brand-3[disabled].active {
  background-color: rgba(0, 0, 0, 0.03);
  border-color: #cccccc;
}
.btn-brand-3:active,
.btn-brand-3 .active {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.btn-brand-4 {
  background: #ff7f00;
  background-image: linear-gradient(208deg, #ffba00 0%, #ff8f2a 100%);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  color: #303232;
  border: none;
}
.btn-brand-4:hover {
  background: #ff7f00;
  background-image: linear-gradient(208deg, #f9c539 0%, #f99c47 100%);
}
.btn-brand-4:active,
.btn-brand-4:focus {
  background-image: linear-gradient(208deg, #f0b413 0%, #ee8321 100%);
}
.btn-brand-4.disabled,
.btn-brand-4[disabled] {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
}
.btn-brand-5 {
  color: #303232;
  background-color: #f9f9f9;
  border-color: #d3d3d3;
}
.btn-brand-5:hover,
.btn-brand-5:focus,
.btn-brand-5:active,
.btn-brand-5.active,
.open > .dropdown-toggle.btn-brand-5 {
  color: #303232;
  background-color: #e0e0e0;
  border-color: #b4b4b4;
}
.btn-brand-5:active,
.btn-brand-5.active,
.open > .dropdown-toggle.btn-brand-5 {
  background-image: none;
}
.btn-brand-5.disabled,
.btn-brand-5[disabled],
fieldset[disabled] .btn-brand-5,
.btn-brand-5.disabled:hover,
.btn-brand-5[disabled]:hover,
fieldset[disabled] .btn-brand-5:hover,
.btn-brand-5.disabled:focus,
.btn-brand-5[disabled]:focus,
fieldset[disabled] .btn-brand-5:focus,
.btn-brand-5.disabled:active,
.btn-brand-5[disabled]:active,
fieldset[disabled] .btn-brand-5:active,
.btn-brand-5.disabled.active,
.btn-brand-5[disabled].active,
fieldset[disabled] .btn-brand-5.active {
  background-color: #f9f9f9;
  border-color: #d3d3d3;
}
.btn-brand-5 .badge {
  color: #f9f9f9;
  background-color: #303232;
}
.btn-brand-5.disabled,
.btn-brand-5[disabled],
.btn-brand-5.disabled:hover,
.btn-brand-5[disabled]:hover,
.btn-brand-5.disabled:focus,
.btn-brand-5[disabled]:focus,
.btn-brand-5.disabled:active,
.btn-brand-5[disabled]:active,
.btn-brand-5.disabled.active,
.btn-brand-5[disabled].active {
  background-color: #f9f9f9;
  border-color: #d3d3d3;
}
.btn-brand-5:active,
.btn-brand-5 .active {
  -webkit-box-shadow: none;
  box-shadow: none;
  background-color: #bfbfbf;
}
.btn-back {
  padding: 9px 10px;
  position: relative;
  min-width: 80px;
  width: auto;
  margin-left: 15px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: #373a3a;
  border-color: #373a3a;
}
.btn-back:hover,
.btn-back:active,
.btn-back:focus {
  background-color: #242525;
  border-color: #242525;
}
.btn-back:after,
.btn-back:before,
.btn-back:after:active,
.btn-back:before:active {
  content: '';
  position: absolute;
  top: 50%;
  margin-top: -19px;
  border-top: 20px solid transparent;
  border-bottom: 19px solid transparent;
  border-right: 1em solid;
  left: -0.98em;
  padding-top: 0;
}
.btn-back:before {
  z-index: 2;
  border-right-color: inherit;
}
.btn-back:hover:before {
  border-right-color: inherit;
}
.btn-delete {
  background-color: inherit;
  color: red;
  margin-left: 30px;
  margin-top: 3px;
}
.btn-delete:hover {
  background-color: red;
  color: white;
}
.btn.btn-message {
  background-image: none;
}
.btn.btn-message:hover,
.btn.btn-message:active,
.btn.btn-message.active,
.btn.btn-message:focus {
  box-shadow: none;
  background-image: none;
  cursor: default;
}
.btn.btn-message.success {
  background-color: #dff0d8;
  color: #3c763d;
  font-size: 1.2em;
  border: 1px solid #d6e9c6;
}
.btn-group > .btn {
  cursor: pointer;
  background-color: white;
  border: 1px solid #cccccc;
  color: #555555;
}
.btn-group > .btn:hover {
  background-color: #f2f2f2;
}
.btn-group > .btn + .btn {
  border-left: 1px solid #cccccc;
}
.btn-group > .btn:first-child {
  border-right: 1px solid #cccccc;
}
.btn-group > .btn.active {
  text-shadow: none;
  -webkit-box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.5);
  box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.5);
  color: black;
  background-color: #eeeeee;
}
.report-toggles .btn-group > .btn {
  background: white;
  color: #777777;
}
.report-toggles .btn-group > .btn:hover {
  background-color: #f2f2f2;
  color: #333333;
}
.report-toggles .btn-group > .btn.active {
  background-color: #555555;
  color: #f9f9f9;
  font-weight: 600;
  cursor: default;
  border-color: transparent;
  box-shadow: inset -1px -1px 0 rgba(0, 0, 0, 0.3);
}
.report-toggles .btn-group.btn-group-sm {
  padding-top: 6px;
}
.nav-tabs a:hover,
.nav-tabs > .active > a:hover,
.nav-tabs > .active > a:focus {
  color: #303232;
}
.nav-tabs > li {
  margin-bottom: -2px;
}
.nav-tabs > li > a:hover {
  background-color: #e5e5e5;
  border-bottom: white;
}
.nav-tabs > li > a:active {
  background-color: #dedede;
  border-bottom: white;
}
.nav-tabs > li > a:focus {
  outline: none;
}
.nav.nav-tabs li > a {
  padding: 10px;
}
.tab-content {
  margin-top: 5px;
}
.nav-pills > li {
  margin-bottom: -2px;
  border-radius: 0;
}
.nav-pills > li.active > a {
  border-bottom: 3px solid #ff9003;
  background-color: transparent;
  color: #303232;
  text-shadow: 0px 0px 0px black,
        0px 0px 0px black,
        0px 0px 0px black;
}
.nav-pills > li.active > a:hover {
  background-color: transparent;
  color: #303232;
  border-bottom: 3px solid #ff9003;
}
.nav-pills > li.active > a:focus {
  background-color: transparent;
  color: #303232;
}
.nav-pills > li > a {
  cursor: pointer;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  background-color: transparent;
  color: #303232;
  font-size: 15px;
}
.nav-pills > li > a:hover {
  background-color: #f7f7f7;
  color: #303232;
  border-bottom: 3px solid #cccccc;
}
.nav-pills > li > a:active {
  background-color: #f2f2f2;
  border-bottom: white;
  border-bottom: 3px solid #f38800;
}
.nav-pills > li > a:focus {
  outline: none;
}
.nav.nav-pills li > a {
  padding: 10px 14px;
}
.tab-content {
  margin-top: 5px;
}
.pills {
  margin-bottom: 20px;
  background-color: #f2f2f2;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  overflow: hidden;
}
.pills .btn {
  cursor: pointer;
  border-radius: 0;
  background-color: #f2f2f2;
  color: #303232;
  border-right: 1px solid #e5e5e5;
  padding: 5px 6px;
  font-weight: 600;
  font-size: 13px;
  line-height: 1em;
}
.pills .btn:focus {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.pills .btn:hover {
  background-color: #e9e9e9;
}
.pills .btn:active,
.pills .btn.active {
  background-color: #494c4c;
  color: #ff9003;
  font-weight: 400;
}
.pills .btn:active small,
.pills .btn.active small {
  color: #b5b0b0;
}
.pills .btn:nth-child(4),
.pills .btn:nth-child(4).active {
  border-right: none;
}
.pills .btn small {
  color: #555555;
  display: block;
  font-size: 0.85em;
}
.pills .btn.active {
  -webkit-box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.6);
  box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.6);
  border-right-color: #b2b2b2;
}
.badge {
  background-color: #e0e0e0;
  color: #494c4c;
  margin-left: 5px;
  font-weight: 600;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
.badge.badge-inverse {
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
}
.badge.badge-header {
  background-color: rgba(217, 0, 0, 0.8);
  color: #fff;
  position: absolute;
  top: 14px;
  right: 24%;
  padding: 1px 4px;
  font-size: 11px;
}
.badge .badge-left-tip {
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-right: 6px solid #e0e0e0;
  position: absolute;
  left: -5px;
  bottom: 0;
  top: 0;
  margin: auto;
}
.label.label-title {
  color: #303232;
  font-weight: 700;
  text-align: left;
  text-shadow: none;
  display: block;
  margin-bottom: 5px;
  font-size: 1em;
  padding: 4px 10px 2px 0;
  border-radius: 0;
}
.well {
  background-color: #ffffff;
  -webkit-box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 6px inset;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 6px inset;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  *zoom: 1;
}
.well:before,
.well:after {
  content: " ";
  display: table;
}
.well:after {
  clear: both;
}
.well:before,
.well:after {
  display: table;
  content: '';
  line-height: 0;
}
.well:after {
  clear: both;
}
.title-divider {
  position: relative;
  text-align: center;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 10px;
}
.title-divider span {
  padding: 0 15px;
  position: relative;
  color: #333333;
  text-transform: uppercase;
  font-size: 11;
  font-weight: 700;
}
.title-divider:before {
  display: block;
  content: '';
  height: 1px;
  background: -webkit-gradient(linear, 0 0, 100% 0, from(rgba(0, 0, 0, 0)), color-stop(0.5, #999), color-stop(0.5, #999), to(rgba(0, 0, 0, 0)));
  background: -webkit-linear-gradient(left, rgba(0, 0, 0, 0), #999, #999, rgba(0, 0, 0, 0));
  background: -moz-linear-gradient(left, rgba(0, 0, 0, 0), #999, #999, rgba(0, 0, 0, 0));
  background: -o-linear-gradient(left, rgba(0, 0, 0, 0), #999, #999, rgba(0, 0, 0, 0));
  background: linear-gradient(left, rgba(0, 0, 0, 0), #999, #999, rgba(0, 0, 0, 0));
  position: absolute;
  top: 50%;
  width: 100%;
}
.inlay {
  max-height: 0;
  min-height: 0;
  overflow: hidden;
  -webkit-transition: max-height 0.5s cubic-bezier(0, 1.05, 0, 1);
  transition: max-height 0.5s cubic-bezier(0, 1.05, 0, 1);
  width: 100%;
}
.inlay.inlay-open {
  -webkit-transition: max-height 1s cubic-bezier(0.1, 1.05, 0, 1);
  transition: max-height 1s cubic-bezier(0.1, 1.05, 0, 1);
  max-height: 3000px;
}
.inlay.inlay-open-60 {
  max-height: 60px;
  -webkit-transition: max-height 0.2s ease-in-out;
  transition: max-height 0.2s ease-in-out;
}
.popover {
  display: block;
  font-size: 13px;
  z-index: 1061;
}
.popover ul {
  padding-left: 15px;
}
.popover.popover-field {
  z-index: 1070;
}
.popover.popover-field.bottom {
  position: relative;
  top: -3px !important;
  left: 0 !important;
  max-width: none;
  width: 100%;
}
.popover.popover-error {
  background-color: rgba(194, 51, 51, 0.85);
  border-color: rgba(194, 51, 51, 0.85);
  z-index: 19;
  color: rgba(255, 255, 255, 0.8);
  min-height: 46px;
  display: flex !important;
  align-items: center;
}
.popover.popover-error.popover-compact {
  min-width: 200px;
}
.popover.popover-error.popover-compact .popover-content {
  padding: 3px 6px;
  font-size: 12px;
}
.popover.popover-error.right > .arrow:after,
.popover.popover-error-and-content.right > .arrow:after {
  border-right-color: #c95150;
}
.popover.popover-error.bottom > .arrow:after,
.popover.popover-error-and-content.bottom > .arrow:after {
  border-bottom-color: #c95150;
}
.popover.popover-error.right > .arrow,
.popover.popover-error-and-content.right > .arrow {
  top: 20px !important;
}
.popover-dark {
  background: rgba(48, 50, 50, 0.97);
  color: #eeeeee;
}
.popover-dark .popover-title {
  background: rgba(48, 50, 50, 0.97);
  border: rgba(36, 37, 37, 0.97);
  color: #cdcdcd;
  font-size: 18px;
}
.popover-dark.left .arrow {
  border-left-color: rgba(48, 50, 50, 0.97);
}
.popover-dark.left .arrow:after {
  border-left-color: transparent;
}
.popover-dark.right .arrow {
  border-right-color: rgba(48, 50, 50, 0.97);
}
.popover-dark.right .arrow:after {
  border-right-color: transparent;
}
.popover-dark .nav-pills {
  font-size: 16px;
}
.nav-pills.nav-pills-popover {
  -webkit-box-shadow: 0 4px 10px #f2f2f2;
  box-shadow: 0 4px 10px #f2f2f2;
  z-index: 1;
  position: relative;
}
.nav-pills.nav-pills-popover li {
  width: 50%;
  margin: 0;
  overflow: hidden;
}
.nav-pills.nav-pills-popover li:first-child > a {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.nav-pills.nav-pills-popover li:last-child > a {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.nav-pills.nav-pills-popover li + li {
  margin: 0;
}
.nav-pills.nav-pills-popover li > a {
  border-radius: 0;
  text-align: center;
  color: #303232;
  padding: 15px 20px;
  font-weight: 600;
  font-size: 13px;
  line-height: 1em;
  background-color: #e9e9e9;
}
.nav-pills.nav-pills-popover li > a:focus {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.nav-pills.nav-pills-popover li > a:hover {
  background-color: #e0e0e0;
}
.nav-pills.nav-pills-popover li > a:active,
.nav-pills.nav-pills-popover li > a.active {
  background-color: #494c4c;
  color: #ff9003;
  font-weight: 400;
}
.nav-pills.nav-pills-popover > .active > a,
.nav-pills.nav-pills-popover > .active > a:hover,
.nav-pills.nav-pills-popover > .active > a:focus {
  background-color: #494c4c;
  color: #ff9003;
  font-weight: 400;
}
.tab-content > .tab-pane,
.pill-content > .pill-pane {
  overflow: hidden;
  padding: 0 10px;
}
.input-lg,
.form-group-lg textarea.form-control {
  height: auto;
  width: 100%;
}
.break-word {
  word-wrap: break-word;
}
.float-right {
  float: right;
}
.flex-center {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.font-weight-700 {
  font-weight: 700;
}
.container-fluid.core-container {
  margin-left: 0;
  margin-right: 0;
  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
}
.sidebar > .spacer {
  height: 5px;
}
#intercom-container .intercom-launcher {
  right: 10px !important;
}
#intercom-container .intercom-powered-by {
  visibility: hidden !important;
}
.content {
  margin-top: 0;
  padding-bottom: 50px;
  background: white;
  border: none;
  position: relative;
  z-index: auto;
  min-height: 100vh;
}
.settings-company-logo img {
  max-height: 164px;
}
.header {
  background-color: #303232;
  background-image: none;
  border-bottom: none;
}
.header .username {
  color: #eeeeee;
  line-height: 1em;
  margin-right: 10px;
}
.header .top-nav-buttons {
  position: relative;
  margin-right: 20px;
  float: right;
  right: 0;
}
.header .btn-group {
  margin-top: -5px;
}
.content-header-h1 {
  font-size: 20px;
  font-weight: 700;
  line-height: 36px;
  padding-top: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.content-header {
  background: #f9f9f9;
  border-bottom: 1px solid #dddddd;
  *zoom: 1;
  /* Style the secondary header bar */
  /* Style header metrics like the ones on the refine screen */
}
.content-header:before,
.content-header:after {
  content: " ";
  display: table;
}
.content-header:after {
  clear: both;
}
.content-header:before,
.content-header:after {
  display: table;
  content: '';
  line-height: 0;
}
.content-header:after {
  clear: both;
}
.content-header h1 {
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
  margin: 5px 0 0;
}
.content-header h1.vertical-center {
  margin-top: 12px;
  float: left;
}
.content-header small {
  font-size: 13px;
  color: #555555;
  line-height: 18px;
  font-weight: 400;
  margin: 2px 0;
}
.content-header h4 {
  margin-bottom: 10px;
}
.content-header .nav {
  margin: 1px 0 0px;
}
.content-header .nav-tabs {
  border-bottom: none;
}
.content-header .header-btn-right {
  margin-top: 5px;
}
.content-header .header-account {
  line-height: 1.2em;
  margin-top: 3px;
  margin-right: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 260px;
}
.content-header .header-account i {
  margin-left: 6px;
}
.content-header .app-logo {
  margin: 13px 2px 0 0;
  float: left;
}
.content-header .app-logo img {
  width: 93px;
  height: auto;
}
.content-header .navbar-group {
  float: none;
  display: block;
}
.content-header .navbar-group .header-navbar {
  width: 25%;
}
.content-header .header-navbar {
  height: 46px;
  position: relative;
  float: left;
}
.content-header .header-navbar .nav-tabs > li > a {
  line-height: 44px;
  margin: auto;
  padding: 0 15px;
}
.content-header .header-navbar .badge {
  float: right;
}
.content-header .header-navbar .btn-error [class*=' ico-'],
.content-header .header-navbar .btn-error [class^='ico-'] {
  color: #e9001d;
}
.content-header .header-navbar .btn-warning [class*=' ico-'],
.content-header .header-navbar .btn-warning [class^='ico-'] {
  color: #ff9003;
}
.content-header .btn.btn-header {
  position: relative;
  border-color: transparent;
  border-top: none;
  border-bottom: none;
  border-right: none;
  background-color: inherit;
  margin: auto;
  height: 100%;
  width: auto;
  min-width: 60px;
  padding: 2.5px 12px;
  font-size: 12px;
  color: #303232;
  -webkit-border-radius: 0;
  -moz-border-radius: 0;
  border-radius: 0;
}
.content-header .btn.btn-header [class*=' ico-'],
.content-header .btn.btn-header [class^='ico-'] {
  font-size: 16px;
  display: block;
  float: none;
  clear: both;
}
.content-header .btn.btn-header:hover {
  background-color: #e9e9e9;
}
.content-header .btn.btn-header:hover .arrow-right {
  border-left-color: #e9e9e9;
}
.content-header .btn.btn-header:hover .arrow-right-n1,
.content-header .btn.btn-header:hover .arrow-right-n2 {
  border-right-color: #e9e9e9;
}
.content-header .btn.btn-header:active,
.content-header .btn.btn-header.active,
.content-header .btn.btn-header:focus {
  color: #303232;
  box-shadow: none;
  background-color: #e0e0e0;
}
.content-header .btn.btn-header:active .arrow-right,
.content-header .btn.btn-header.active .arrow-right,
.content-header .btn.btn-header:focus .arrow-right {
  border-left-color: #e0e0e0;
}
.content-header .btn.btn-header .arrow-right {
  width: 0;
  height: 0;
  border-top: 23px solid transparent;
  border-bottom: 23px solid transparent;
  border-left: 14px solid #f2f2f2;
  float: right;
  position: absolute;
  right: -13px;
  top: 0;
  z-index: 10;
}
.content-header .btn.btn-header .arrow-right.arrow-right-border {
  right: -14px;
  border-left-color: #d9d9d9;
  z-index: 9;
}
.content-header .btn.btn-header.btn-lg {
  font-size: 15px;
  padding: 14px 13px 13px 20px;
}
.content-header .btn.btn-header.btn-lg .caret {
  margin: auto 0 auto 8px;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 10px;
  font-size: 24px;
  border-left-width: 5px;
  border-right-width: 5px;
  border-top-width: 5px;
  opacity: 0.7;
}
.content-header .btn.btn-header.btn-lg .badge {
  margin: 2px 15px 0 10px;
}
.content-header .btn.btn-header.btn-side-left-handle {
  margin: 0 5px 0 -15px;
  font-size: 18px;
  color: #7b8080;
  padding: 13px 12px 12px;
}
.content-header ul.content-header-action {
  text-align: center;
  padding: 10px 10px 0px;
}
.content-header ul.content-header-action li .action-text {
  margin: 5px 0 5px 5px;
}
.content-header ul.content-header-action li.divider {
  height: 33px;
}
.content-header.content-header-2 {
  border-bottom: 1px solid #fff;
  background: #f2f2f2;
}
.content-header.content-header-2 .header-navbar > .btn,
.content-header.content-header-2 .header-navbar > .btn-group > .btn {
  border-left: none;
}
.content-header .header-metrics {
  display: flex;
  justify-content: flex-end;
  padding-top: 3px;
  padding-bottom: 3px;
}
.content-header .header-metrics .header-metric {
  text-align: right;
  margin-right: 20px;
}
.content-header .header-metrics .header-metric:last-child {
  margin-right: 0;
}
.content-header .header-metrics .header-metric small {
  display: block;
  float: none;
  clear: both;
  color: #777777;
  font-size: 0.8em;
  margin: 0;
  line-height: 1.2;
}
.header-instructions {
  *zoom: 1;
  margin: -2px -15px 20px -15px;
  padding: 15px 15px 10px;
  font-size: 16px;
  -webkit-box-shadow: inset 0 -1px 4px rgba(0, 0, 0, 0.1);
  box-shadow: inset 0 -1px 4px rgba(0, 0, 0, 0.1);
  background-color: #f5f5f5;
  font-size: 14px;
  color: #333333;
  position: relative;
}
.header-instructions:before,
.header-instructions:after {
  content: " ";
  display: table;
}
.header-instructions:after {
  clear: both;
}
.header-instructions:before,
.header-instructions:after {
  display: table;
  content: '';
  line-height: 0;
}
.header-instructions:after {
  clear: both;
}
.header-instructions h1,
.header-instructions h2,
.header-instructions h3 {
  text-rendering: auto;
  margin-bottom: 0.5em;
}
.popover {
  z-index: 20;
}
.popover.popover-support {
  top: auto !important;
  bottom: 15px !important;
}
.popover.popover-support .arrow {
  border-right-color: rgba(41, 42, 42, 0.97);
  bottom: 5px;
  left: -11px;
  top: auto;
}
.popover.popover-settings {
  top: auto !important;
  bottom: 0px !important;
}
.popover.popover-settings > .arrow {
  border-right-color: rgba(41, 42, 42, 0.97);
  bottom: 20px;
  left: -11px;
  top: auto;
}
.popover.popover-leftnav {
  left: 100%;
  margin-left: 11px;
  display: block;
  z-index: 1063;
  width: 220px;
  border-radius: 3px;
}
.popover.popover-leftnav .popover-content {
  padding: 0;
}
.popover.popover-leftnav .link-icon {
  display: block;
  float: left;
  margin-right: 10px;
  background-color: rgba(43, 45, 45, 0.97);
  padding: 10px 12px 6px 8px;
  height: 100%;
}
.popover.popover-leftnav .link-label {
  display: block;
  padding: 10px;
  height: 100%;
}
.popover.popover-leftnav a {
  height: 45px;
  padding: 0;
  font-size: 1em;
  letter-spacing: 0em;
  font-weight: 400;
  display: block;
  text-align: left;
  color: #cdcdcd;
  -webkit-transition: all 0.1s;
  -o-transition: all 0.1s;
  transition: all 0.1s;
}
.popover.popover-leftnav a:hover {
  color: #fff;
  background-color: rgba(43, 45, 45, 0.97);
}
.popover.popover-leftnav a:hover .link-icon {
  background-color: rgba(31, 32, 32, 0.97);
}
.popover.popover-leftnav a:active {
  color: #ff9003;
  background-color: rgba(60, 63, 63, 0.97);
}
.popover.popover-leftnav a:active .link-icon {
  background-color: rgba(48, 50, 50, 0.97);
}
.popover.popover-leftnav .list-footer {
  border-top: 1px solid rgba(28, 29, 29, 0.97);
  background-color: rgba(41, 42, 42, 0.97);
  border-bottom: none;
  font-size: 13px;
  color: #999;
  line-height: 1.2em;
  font-weight: normal;
  padding: 8px 0 6px 5px;
  text-align: center;
  cursor: default;
}
.popover.popover-header {
  top: 46px;
  width: 360px;
  max-width: 360px;
  background-color: #f9f9f9;
  border-radius: 2px;
  border: 1px solid transparent;
  box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.4);
  border-radius: 4px;
}
.popover.popover-header.popover-debug {
  max-width: none;
}
.popover.popover-header.bottom .arrow {
  border-bottom-color: #c6c6c6;
}
.popover.popover-header.bottom .arrow:after {
  border-bottom-color: #f9f9f9;
}
.popover .popover-scrollable-content {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
.side-left {
  position: fixed;
  z-index: 1062;
  left: 0;
  overflow: visible;
  float: left;
  width: 60px;
  height: 100%;
  text-align: center;
  border: none;
  background-color: #303232;
  background-image: none;
  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
}
.side-left .btn-calculate-job {
  cursor: pointer;
  font-size: 10px;
  font-weight: 700;
  padding: 5px 4px;
  border-radius: 4px;
  margin: 5px 3px;
  width: 54px;
}
.side-left .btn-calculate-job:not(disabled),
.side-left .btn-calculate-job:not([disabled]) {
  background: #ff7f00;
  background-image: linear-gradient(208deg, #ffba00 0%, #ff8f2a 100%);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  color: #303232;
  border: none;
}
.side-left .btn-calculate-job:not(disabled):hover,
.side-left .btn-calculate-job:not([disabled]):hover {
  background: #ff7f00;
  background-image: linear-gradient(208deg, #f9c539 0%, #f99c47 100%);
}
.side-left .btn-calculate-job:not(disabled):active,
.side-left .btn-calculate-job:not([disabled]):active,
.side-left .btn-calculate-job:not(disabled):focus,
.side-left .btn-calculate-job:not([disabled]):focus {
  background-image: linear-gradient(208deg, #f0b413 0%, #ee8321 100%);
}
.side-left .btn-calculate-job:not(disabled).disabled,
.side-left .btn-calculate-job:not([disabled]).disabled,
.side-left .btn-calculate-job:not(disabled)[disabled],
.side-left .btn-calculate-job:not([disabled])[disabled] {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
}
.side-left .btn-calculate-job.disabled,
.side-left .btn-calculate-job[disabled] {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
}
.side-left .btn-calculate-job .isolate-spinner {
  height: 27px;
  overflow: hidden;
}
.signup-form {
  margin-top: 50px;
}
.form-paragraph {
  margin-top: 5px;
  margin-bottom: 5px;
}
.utility-bills .row > select:first-child,
.utility-bills .row > input:first-child,
.utility-bills .row > .input-append:first-child {
  margin-left: 20px;
}
.utility-bills .input-start-date {
  width: 75px;
}
.utility-bills .input-date {
  width: 102px;
}
.utility-bills select {
  width: 194px;
  margin-bottom: 10px;
}
#js-calculate-div {
  height: 15px;
  padding-top: 13px;
}
/* Remove / Tweak Shadow DOM elements */
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Rotate icons when class is added (by javascript) */
.rotate-clockwise {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  transition: 0.2s;
  -webkit-transition: 0.2s;
}
.rotate-counterclockwise {
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  transition: 0.2s;
  -webkit-transition: 0.2s;
}
.rotate-180 {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  display: block;
}
/* Overwrite themes*/
.solid-grey {
  background: #ccc;
  color: #333;
}
.spin-box-container {
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  position: fixed;
  margin: auto;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
}
.circle {
  width: 80px;
  height: 80px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 40px;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  border: solid 10px rgba(48, 50, 50, 0.15);
  border-top-color: #ff9003;
  -webkit-animation: loader-spin 0.75s infinite linear;
}
@-webkit-keyframes loader-spin {
  100% {
    transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
  }
}
.loader-wrap {
  width: 20px;
  height: 20px;
  position: relative;
  flex-shrink: 0;
}
.body-loader {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  border: 2px solid rgba(0, 0, 0, 0.2);
  border-left-color: #ffffff;
  animation: utilitySpin 1.1s linear infinite;
  will-change: transform;
  contain: layout paint;
  /* hide text safely */
  color: transparent;
  white-space: nowrap;
  pointer-events: none;
}
@keyframes utilitySpin {
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}
/* CARD SPINNER */
.loader-spinner {
  display: flex;
  position: relative;
  width: 42px;
  height: 42px;
}
.loader-spinner div {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 42px;
  height: 42px;
  border: 5px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
}
.loader-spinner div:not(:nth-child(1)) {
  clip-path: polygon(50% 50%, 0 0, 80% 0);
  border: 5px solid #f56600;
  animation: loader-spinner_spin 1.4s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}
.loader-spinner div:nth-child(2) {
  animation-delay: 0s;
}
.loader-spinner div:nth-child(3) {
  animation-delay: -0.06s;
}
.loader-spinner div:nth-child(4) {
  animation-delay: -0.11s;
}
.loader-spinner div:nth-child(5) {
  animation-delay: -0.17s;
}
.loader-spinner div:nth-child(6) {
  animation-delay: -0.22s;
}
@keyframes loader-spinner_spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.muted {
  opacity: 0.75;
}
.clickable {
  cursor: pointer;
}
.visibility-hidden {
  visibility: hidden;
}
.link-disabled {
  color: #777777;
  cursor: not-allowed;
}
.no-float {
  float: none !important;
}
.no-relative {
  position: static;
}
.no-gutter-al {
  padding-left: 0px;
  padding-right: 0px;
}
.no-gutter-left-al {
  padding-left: 0px;
}
.no-gutter-right-al {
  padding-right: 0px;
}
.col-no-gutter {
  padding-left: 0px;
  padding-right: 0px;
}
.col-no-left-gutter {
  padding-left: 0;
}
.col-no-right-gutter {
  padding-right: 0;
}
.scroll-past-200 {
  max-height: 200px;
  overflow: scroll;
}
.ma-tb-5 {
  margin-top: 5px !important;
  margin-bottom: 5px !important;
}
.ma-bo-5 {
  margin-bottom: 5px !important;
}
.ma-tb-10 {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.ma-tb-20 {
  margin-top: 20px;
  margin-bottom: 20px;
}
.ma-bo-20 {
  margin-bottom: 20px;
}
.ma-to-10 {
  margin-top: 10px;
}
.ma-to-20 {
  margin-top: 20px;
}
.form-actions {
  margin-top: 30px;
}
.error-page .box-container {
  border-radius: 4px;
  background-color: #f7f7f7;
  padding: 22px 22px 40px;
  margin: 45px 0 40px;
}
.error-page .box-container .error-code {
  font-size: 1.125em;
  line-height: 24px;
  color: #333333;
  float: right;
  border-radius: 6px;
  background-color: rgba(0, 0, 0, 0.08);
  padding: 3px 8px;
}
.error-page .box-container h1 {
  margin-top: 0;
  font-size: 24px;
  font-weight: 700;
}
.error-page .box-container p {
  font-size: 16px;
  line-height: 22px;
}
.snugg-pro-footer-icon {
  display: inline-block;
  width: auto;
  border-radius: 12px;
  padding: 12px;
  box-shadow: inset 0 3px 4px 2px rgba(0, 0, 0, 0.06), inset 0 -3px 4px 2px rgba(255, 255, 255, 0.88);
  margin: 50px 0 10px;
}
.snugg-pro-footer-icon img {
  opacity: 0.95;
}
/* Extra small devices (phones, less than 768px) */
/* No media query since this is the default in Bootstrap */
/* ONLY extra small devices (phones less than 768px) */
@media (max-width: 767px) {
  .xs-ma-bo-20 {
    margin-bottom: 20px;
  }
  .xs-ma-bo-40 {
    margin-bottom: 40px;
  }
  .col-xs-no-gutter {
    padding-left: 0px;
    padding-right: 0px;
  }
  .col-xs-no-left-gutter {
    padding-left: 0px;
  }
  .col-xs-no-right-gutter {
    padding-right: 0px;
  }
  .xs-no-relative {
    position: static !important;
  }
  .nav-tabs-xs-compact.nav.nav-tabs {
    font-size: 0.8em;
  }
  .nav-tabs-xs-compact.nav.nav-tabs > li > a {
    padding: 12px 5px;
  }
  .side-left {
    -ms-transform: translateX(-60px);
    transform: translateX(-60px);
    -webkit-transform: translateX(-60px);
    /** Chrome & Safari **/
    -o-transform: translateX(-60px);
    /** Opera **/
    -moz-transform: translateX(-60px);
    /** Firefox **/
  }
  .push-left .container-fluid.core-container {
    -ms-transform: translateX(60px);
    transform: translateX(60px);
    -webkit-transform: translateX(60px);
    /** Chrome & Safari **/
    -o-transform: translateX(60px);
    /** Opera **/
    -moz-transform: translateX(60px);
    /** Firefox **/
  }
  .push-left .side-left {
    -ms-transform: translateX(0);
    transform: translateX(0);
    -webkit-transform: translateX(0);
    /** Chrome & Safari **/
    -o-transform: translateX(0);
    /** Opera **/
    -moz-transform: translateX(0);
    /** Firefox **/
  }
  .push-left .push-menu-overlay {
    position: fixed;
    cursor: pointer;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    z-index: 1060;
    background-color: rgba(255, 255, 255, 0.5);
  }
  .form-control.input-header.rec-input-header {
    font-size: 15px;
    font-weight: 600;
    min-width: 255px;
  }
}
/* Small devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .container-fluid.core-container {
    margin-left: 60px;
    margin-right: 0;
  }
  .push-left .container-fluid.core-container {
    margin-left: 60px;
    margin-right: 0;
  }
  .push-left .side-left {
    left: 0;
  }
  .push-left .push-menu-overlay {
    display: none;
  }
  .col-sm-no-gutter {
    padding-left: 0;
    padding-right: 0;
  }
  .col-sm-no-left-gutter {
    padding-left: 0;
  }
  .col-sm-no-right-gutter {
    padding-right: 0;
  }
  .side-left {
    left: 0;
    transform: translateX(0);
  }
  .content-header .app-logo {
    margin: 11px 10px 0 0;
  }
  .content-header .btn.btn-new-job {
    border-left: 0;
  }
  .content-header .navbar-group {
    float: right;
    display: block;
  }
  .content-header .navbar-group .header-navbar {
    width: auto;
  }
  .content-header .header-navbar .btn-group.btn-group-sort {
    border-right: 1px solid #d9d9d9;
  }
  .form-search .form-group {
    margin-top: 4px;
  }
  .popover.popover-header {
    right: 0;
  }
  .popover.popover-header .arrow {
    left: auto;
    right: 15px;
  }
  .form-group.form-group-two-rows label.control-label {
    padding-top: 42px;
  }
  .form-control.input-header.rec-input-header {
    min-width: 300px;
  }
  .modal-dialog.modal-lg {
    min-width: 600px;
    max-width: 90%;
    width: auto;
  }
  .jl .snugg-select {
    height: 46px;
  }
  .search-jobs.topmost-search-job-container {
    width: 60px;
  }
}
/* Medium devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .search-jobs.topmost-search-job-container {
    width: auto;
    max-width: 160px;
  }
}
/* Large devices (desktops, 992px and up) */
@media (min-width: 1200px) {
  .search-jobs.topmost-search-job-container {
    max-width: 260px;
  }
}
/* ONLY extra short devices (phones less than 568px)  This is a fringe case*/
@media (max-height: 589px) {
  .popover.popover-support .arrow {
    bottom: 3px;
  }
  .popover.popover-settings .arrow {
    bottom: 30px;
  }
}
.no-gutter-all {
  padding-left: 0px;
  padding-right: 0px;
}
.no-gutter-left-all {
  padding-left: 0px;
}
.no-gutter-right-all {
  padding-right: 0px;
}
.margin-top-all-5 {
  margin-top: 5;
}
.margin-bottom-all-5 {
  margin-top: 5;
}
.margin-vertical-all-5 {
  margin-top: 5;
  margin-bottom: 5;
}
.margin-top-all-10 {
  margin-top: 10;
}
.margin-bottom-all-10 {
  margin-top: 10;
}
.margin-vertical-all-10 {
  margin-top: 10;
  margin-bottom: 10;
}
.margin-top-all-15 {
  margin-top: 15;
}
.margin-bottom-all-15 {
  margin-top: 15;
}
.margin-vertical-all-15 {
  margin-top: 15;
  margin-bottom: 15;
}
.margin-top-all-20 {
  margin-top: 20;
}
.margin-bottom-all-20 {
  margin-top: 20;
}
.margin-vertical-all-20 {
  margin-top: 20;
  margin-bottom: 20;
}
@media (max-width: 767px) {
  .no-gutter-xs {
    padding-left: 0px;
    padding-right: 0px;
  }
  .no-gutter-left-xs {
    padding-left: 0px;
  }
  .no-gutter-right-xs {
    padding-right: 0px;
  }
  .margin-top-xs-5 {
    margin-top: 5;
  }
  .margin-bottom-xs-5 {
    margin-top: 5;
  }
  .margin-vertical-xs-5 {
    margin-top: 5;
    margin-bottom: 5;
  }
  .margin-top-xs-10 {
    margin-top: 10;
  }
  .margin-bottom-xs-10 {
    margin-top: 10;
  }
  .margin-vertical-xs-10 {
    margin-top: 10;
    margin-bottom: 10;
  }
  .margin-top-xs-15 {
    margin-top: 15;
  }
  .margin-bottom-xs-15 {
    margin-top: 15;
  }
  .margin-vertical-xs-15 {
    margin-top: 15;
    margin-bottom: 15;
  }
  .margin-top-xs-20 {
    margin-top: 20;
  }
  .margin-bottom-xs-20 {
    margin-top: 20;
  }
  .margin-vertical-xs-20 {
    margin-top: 20;
    margin-bottom: 20;
  }
}
@media (min-width: 768px) {
  .no-gutter-sm {
    padding-left: 0px;
    padding-right: 0px;
  }
  .no-gutter-left-sm {
    padding-left: 0px;
  }
  .no-gutter-right-sm {
    padding-right: 0px;
  }
  .margin-top-sm-5 {
    margin-top: 5;
  }
  .margin-bottom-sm-5 {
    margin-top: 5;
  }
  .margin-vertical-sm-5 {
    margin-top: 5;
    margin-bottom: 5;
  }
  .margin-top-sm-10 {
    margin-top: 10;
  }
  .margin-bottom-sm-10 {
    margin-top: 10;
  }
  .margin-vertical-sm-10 {
    margin-top: 10;
    margin-bottom: 10;
  }
  .margin-top-sm-15 {
    margin-top: 15;
  }
  .margin-bottom-sm-15 {
    margin-top: 15;
  }
  .margin-vertical-sm-15 {
    margin-top: 15;
    margin-bottom: 15;
  }
  .margin-top-sm-20 {
    margin-top: 20;
  }
  .margin-bottom-sm-20 {
    margin-top: 20;
  }
  .margin-vertical-sm-20 {
    margin-top: 20;
    margin-bottom: 20;
  }
}
@media (min-width: 992px) {
  .no-gutter-md {
    padding-left: 0px;
    padding-right: 0px;
  }
  .no-gutter-left-md {
    padding-left: 0px;
  }
  .no-gutter-right-md {
    padding-right: 0px;
  }
  .margin-top-md-5 {
    margin-top: 5;
  }
  .margin-bottom-md-5 {
    margin-top: 5;
  }
  .margin-vertical-md-5 {
    margin-top: 5;
    margin-bottom: 5;
  }
  .margin-top-md-10 {
    margin-top: 10;
  }
  .margin-bottom-md-10 {
    margin-top: 10;
  }
  .margin-vertical-md-10 {
    margin-top: 10;
    margin-bottom: 10;
  }
  .margin-top-md-15 {
    margin-top: 15;
  }
  .margin-bottom-md-15 {
    margin-top: 15;
  }
  .margin-vertical-md-15 {
    margin-top: 15;
    margin-bottom: 15;
  }
  .margin-top-md-20 {
    margin-top: 20;
  }
  .margin-bottom-md-20 {
    margin-top: 20;
  }
  .margin-vertical-md-20 {
    margin-top: 20;
    margin-bottom: 20;
  }
}
@media (min-width: 1200px) {
  .no-gutter-lg {
    padding-left: 0px;
    padding-right: 0px;
  }
  .no-gutter-left-lg {
    padding-left: 0px;
  }
  .no-gutter-right-lg {
    padding-right: 0px;
  }
  .margin-top-lg-5 {
    margin-top: 5;
  }
  .margin-bottom-lg-5 {
    margin-top: 5;
  }
  .margin-vertical-lg-5 {
    margin-top: 5;
    margin-bottom: 5;
  }
  .margin-top-lg-10 {
    margin-top: 10;
  }
  .margin-bottom-lg-10 {
    margin-top: 10;
  }
  .margin-vertical-lg-10 {
    margin-top: 10;
    margin-bottom: 10;
  }
  .margin-top-lg-15 {
    margin-top: 15;
  }
  .margin-bottom-lg-15 {
    margin-top: 15;
  }
  .margin-vertical-lg-15 {
    margin-top: 15;
    margin-bottom: 15;
  }
  .margin-top-lg-20 {
    margin-top: 20;
  }
  .margin-bottom-lg-20 {
    margin-top: 20;
  }
  .margin-vertical-lg-20 {
    margin-top: 20;
    margin-bottom: 20;
  }
}
@media print {
  .side-right-handle {
    display: none;
  }
  .side-right.report-side-right,
  .side-right.report-side-right.expanded {
    right: -197px;
    top: -10px;
  }
  .side-left {
    top: -10px;
  }
}
.custom-dropdown li {
  margin-bottom: 2px;
}
.custom-dropdown li:last-child {
  margin-bottom: 0;
}
.custom-dropdown li a {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 12px;
  font-size: 14px;
  line-height: 1.42;
  color: #111;
  font-weight: 600;
}
.custom-dropdown li a span {
  font-size: 12px;
  color: #777;
  display: inline-block;
  font-weight: 500;
}
.custom-dropdown li.delete a {
  color: #d92d20;
}
.custom-dropdown li.active {
  background-color: #fff5e9;
}
.custom-dropdown li.active a {
  background-color: #fff5e9;
  color: #f56600;
}
.custom-dropdown li.active a span {
  color: #555;
}
.custom-dropdown li.active a:hover {
  color: #f56600;
  background-color: #feecd6;
}
.custom-dropdown .dropdown-icon {
  margin-left: 8px;
  margin-top: -4px;
  width: 16px;
  height: 16px;
  transition: all 200ms linear;
}
.custom-dropdown .dropdown-icon.rotated {
  transform: rotate(-180deg);
}
.custom-dropdown button span {
  transition: all 150ms ease;
}
.custom-dropdown:hover button span {
  color: #f56600;
}
.settings-page-header {
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  justify-content: space-between;
  gap: 24px;
}
.settings-page-title-container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.incentive-template-empty-state {
  background-color: #fff;
  border: 1px dashed #ccc;
  border-radius: 6px;
  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 24px 16px 32px;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.42;
  color: #333;
}
.incentives-list-empty-state {
  background-color: #fff;
  border: 1px dashed #ccc;
  border-radius: 6px;
  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  padding: 24px 16px 32px;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.42;
  color: #333;
  border: 1px solid #eee;
}
.incentives-template-wrapper {
  background-color: #f9f9f9;
  padding-top: 20px;
  padding-bottom: 40px;
}
.incentives-template-layout {
  width: 800px;
}
.incentives-field-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 20px;
}
.incentives-field-container .form-group {
  margin-bottom: 0;
}
.incentives-field-container span {
  margin: 0 0 0 0 !important;
  padding-left: 8px;
  font-size: 12px;
  line-height: 1.42;
}
.incentives-category-title {
  font-size: 10px;
  font-weight: 700;
  line-height: 1.5;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: #555;
  background-color: #f7f7f7;
  padding: 4px 8px;
  border-radius: 3px;
  margin-bottom: 4px;
}
.measure-checklist {
  display: flex;
  align-items: center;
  padding: 0 16px 8px 28px !important;
  margin-left: 16px;
  margin-top: 8px;
  border-bottom: 1px solid #eee;
}
.measure-checklist:last-child {
  border-bottom: none;
}
.incentives-text-list {
  text-align: 'left';
  font-size: 12px;
  line-height: 1.5;
  color: #555;
  padding-left: 24px;
}
.incentives-text-list li {
  margin-bottom: 4px;
}
.incentives-text-list b {
  font-weight: 600;
}
.incentive-template-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 8px;
}
.seprator-style {
  border-top: 1px solid #eee;
}
.seprator-style.dark {
  border-color: #ddd;
}
.seprator-style.mb0 {
  margin-bottom: 0;
}
.seprator-style.mt0 {
  margin-top: 0;
}
.seprator-style.my0 {
  margin-top: 0;
  margin-bottom: 0;
}
.incentive-published-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  font-size: 12px;
  line-height: 1.42;
  color: #555;
  font-style: italic;
}
.incentives-dropdown-style {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.incentives-dropdown-style .incentive-source-and-name-container {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 14px;
  line-height: 1.42;
  color: #333;
}
.incentives-dropdown-style .incentive-source-and-name-container .source {
  font-size: 12px;
  line-height: 1.42;
  color: #777;
}
.incentives-dropdown-style .incentive-type {
  font-size: 12px;
  line-height: 1.42;
  text-align: center;
  color: #555;
  text-transform: uppercase;
  padding: 1px 6px 2px;
  background-color: #eee;
  border-radius: 3px;
}
.incentives-list-container-table thead th {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.42;
  color: #656565;
  text-transform: none !important;
  letter-spacing: 0;
  border-bottom: 1px solid #eee !important;
}
.incentives-list-container-table thead th:first-child {
  padding-left: 16px;
}
.incentives-list-container-table .incentive-source {
  background-color: #f2f2f2;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.42;
  color: #656565;
}
.incentives-list-container-table .incentive-source td {
  padding: 4px 8px;
}
.incentives-list-container-table .incentive-source td:first-child {
  padding-left: 16px;
  border-left: 1px solid #eee;
}
.incentives-list-container-table .incentive-source td:last-child {
  border-right: 1px solid #eee;
}
.incentives-list-container-table .incentive-list-itme {
  cursor: pointer;
  background-color: #fff;
  transition: all 250ms ease;
  position: relative;
}
.incentives-list-container-table .incentive-list-itme td {
  vertical-align: middle;
  padding: 16px 8px;
  border-top: none;
  border-bottom: 1px solid #eee;
}
.incentives-list-container-table .incentive-list-itme td:first-child {
  padding-left: 16px;
  border-left: 1px solid #eee;
}
.incentives-list-container-table .incentive-list-itme td:last-child {
  border-right: 1px solid #eee;
}
.incentives-list-container-table .incentive-list-itme:hover {
  background-color: #fff;
  z-index: 10;
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.2);
}
.incentives-list-container-table .incentive-list-itme:hover td {
  border-bottom: 1px solid #fff;
}
.incentives-list-container-table .incentive-list-itme:hover td:first-child {
  border-left: 1px solid #fff;
}
.incentives-list-container-table .incentive-list-itme:hover td:last-child {
  border-right: 1px solid #fff;
}
.incentives-list-container-table .incentive-list-item-title {
  font-size: 14px;
  line-height: 1.42;
  font-weight: 600;
  color: #333;
}
.incentives-details-title-section {
  padding-top: 24px;
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  gap: 0;
}
.incentives-details-title-section span {
  font-size: 12px;
  line-height: 1.42;
  color: #555;
}
.incentives-details-status-section {
  padding-top: 24px;
  padding-bottom: 8px;
  display: flex;
  justify-content: flex-end;
}
@media (max-width: 991px) {
  .incentives-details-status-section {
    justify-content: flex-start;
    padding-top: 0;
  }
}
.incentives-details-estimated-amount {
  font-size: 12px;
  line-height: 1.42;
  font-weight: 600;
  text-align: right;
  margin-bottom: 4px;
}
.incentives-details-estimated-amount a {
  text-decoration: underline;
}
.incentives-details-estimated-amount a:hover {
  text-decoration: none;
}
.incentives-line-items-table thead tr th {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.42;
  color: #c84900;
  letter-spacing: 0;
  text-transform: none;
  border-bottom: none;
  background-color: #f7f7f7;
  padding: 4px 8px;
}
.incentives-line-items-table thead tr th.incentive-source-total {
  color: #656565;
  text-align: right;
}
.incentives-line-items-table tbody tr td {
  font-weight: 600;
}
.incentives-line-items-table tbody tr:first-child td {
  border-top: none;
}
@media (max-width: 991px) {
  .incentives-list-container-table thead {
    display: none;
  }
  .incentives-list-container-table .incentive-source {
    display: flex;
    flex-wrap: wrap;
    background: none;
  }
  .incentives-list-container-table .incentive-source td {
    display: block;
    width: 50%;
    box-sizing: border-box;
    font-size: 1.5rem;
    border: none !important;
    padding-left: 0 !important;
    padding-top: 4px;
  }
  .incentives-list-container-table .incentive-source td:last-child {
    text-align: right;
  }
  .incentives-list-container-table .incentive-list-itme {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 16px;
    margin-top: 16px;
    width: 100%;
    padding: 8px 16px;
    box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
  }
  .incentives-list-container-table .incentive-list-itme td {
    display: block;
    width: 50%;
    box-sizing: border-box;
    text-align: left;
    padding-top: 24px !important;
    position: relative;
    border: none !important;
  }
  .incentives-list-container-table .incentive-list-itme td:first-child {
    padding-left: 8px;
  }
  .incentives-list-container-table .incentive-list-itme td:nth-child(1) {
    width: 50%;
    padding-top: 16px !important;
  }
  .incentives-list-container-table .incentive-list-itme td:nth-child(2) {
    width: 50%;
    padding-top: 8px !important;
  }
  .incentives-list-container-table .incentive-list-itme td::before {
    content: attr(data-label);
    position: absolute;
    top: 4px;
    left: 8px;
    width: 100%;
    font-weight: 400;
    text-align: left;
    font-size: 12px;
  }
}
@media (max-width: 767px) {
  .incentives-list-container-table .incentive-list-itme td:nth-child(1) {
    width: 100%;
    padding-top: 16px !important;
  }
  .incentives-list-container-table .incentive-list-itme td:nth-child(2) {
    width: 100%;
    padding-top: 0 !important;
    padding-bottom: 8px !important;
  }
}
.selected-incentives-table thead tr th {
  font-size: 14px;
  font-weight: 700;
  line-height: 1.42;
  color: #333;
  border-bottom: none;
  background-color: #fff;
  padding: 8px;
}
.selected-incentives-table thead tr th.incentive-source-total {
  text-align: right;
}
.selected-incentives-table tbody tr td {
  vertical-align: middle;
  font-size: 14px;
  line-height: 1.42;
  color: #333;
  font-weight: 600;
}
.selected-incentives-table tbody tr td.rebate-type-block {
  font-size: 10px;
  line-height: 1.42;
  color: #656565;
  font-weight: 600;
  background-color: #f2f2f2;
  border: 1px solid #eee;
  padding-top: 2px;
  padding-bottom: 2px;
}
.incentives-line-items-total {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  text-align: right;
}
.eligibility-list {
  padding-left: 24px;
  margin-bottom: 0;
}
.eligibility-list li {
  margin-bottom: 6px;
}
.eligibility-list li:last-child {
  margin-bottom: 0;
}
.incentives-attributes-container {
  display: flex;
  flex-direction: column;
  gap: 0px;
  padding-right: 8px;
}
.incentives-key-value-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.floating-back-button {
  display: flex;
  justify-content: center;
  gap: 0;
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translate(-50%);
  z-index: 99;
  font-size: 14px;
  line-height: 1.42;
  text-align: left;
  color: #fff;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  overflow: hidden;
  transition: all 300ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
}
.floating-back-button .float-button-inner {
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 6px 0 0 6px;
  backdrop-filter: blur(16px);
  transition: all 300ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  cursor: pointer;
}
.floating-back-button .float-button-inner:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
.floating-back-button .close-float {
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 0 6px 6px 0;
  padding: 0px 16px 0 14px;
  backdrop-filter: blur(16px);
  transition: all 300ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  border-left: 1px solid rgba(0, 0, 0, 0.35);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.floating-back-button .close-float:hover {
  background-color: rgba(0, 0, 0, 0.8);
}
@media (max-width: 767px) {
  .floating-back-button {
    left: 4%;
    right: 4%;
    transform: translate(0%);
  }
  .floating-back-button .float-button-inner {
    flex: 1;
  }
}
.linked-measure-incentive-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 8px 0 0;
}
.linked-measure-incentive-button {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  border: 1px solid transparent;
  transition: all 300ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.42;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  padding: 8px 16px 8px 12px;
}
.linked-measure-incentive-button:hover {
  background-color: #fff5e9;
  border: 1px solid rgba(251, 207, 165, 0.5);
  border-radius: 6px;
  color: #f56600;
}
.line-items-show-more {
  font-size: 12px;
  line-height: 1.42;
  text-align: center;
  text-decoration: underline;
  color: #c84900;
}
.no-selected-incentives-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px 8px;
}
.cocompliances_table {
  width: 100%;
  font-size: 16px;
}
.cocompliances_table tr {
  display: flex;
  gap: 8px;
}
.cocompliances_table td,
.cocompliances_table th {
  padding: 10px 12px;
  width: 33.33%;
  border-bottom: 1px solid #eee;
}
.cocompliances_table th b {
  font-weight: 700;
}
.cocompliances_table td b {
  font-weight: 600;
}
.cocompliances_table th.active {
  background-color: #7cad3e;
  color: #fff;
  border-radius: 12px 12px 0 0;
  text-align: center;
}
.cocompliances_table th.inactive {
  background-color: #eee;
  color: #777;
  border-radius: 12px 12px 0 0;
  text-align: center;
}
.cocompliances_table td.active {
  background-color: #e5f0d6;
  border-bottom: 1px solid #c4dda2;
  text-align: center;
}
.cocompliances_table td.inactive {
  background-color: #f7f7f7;
  border-bottom: 1px solid #eee;
  text-align: center;
  color: #777;
}
.signature-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 240px;
  height: 164px;
  margin-top: 8px;
}
.signature-box .signature-action {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
  font-size: 12px;
  line-height: 1.42;
  text-transform: uppercase;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.2);
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 200ms ease-in-out;
}
.signature-box .signature-action svg {
  fill: rgba(0, 0, 0, 0.2);
  transition: all 200ms ease-in-out;
}
.signature-box .signature-action:hover {
  background-color: #fff5e9;
  color: #f56600;
}
.signature-box .signature-action:hover svg {
  fill: #f56600;
}
.signature-box .signature-footer {
  width: 100%;
  font-size: 12px;
  line-height: 1.42;
  color: #555;
  padding-top: 4px;
  border-top: 1px solid #cccccc;
  display: flex;
}
.signature-box .signature-footer span {
  float: left;
  width: 64px;
}
/* CUSTOM WORK ORDER COMPONENTS FOR PROGRAMS */
.energy-savings-improvements-work-order {
  display: flex;
  flex-direction: column;
  background-color: #f2f2f2;
  border-radius: 6px;
  padding: 2px 10px;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #555;
}
.energy-savings-improvements-work-order > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  border-bottom: 1px solid #e6e6e6;
}
.energy-savings-improvements-work-order > div:last-child {
  border-bottom: none;
}
.energy-savings-improvements-work-order .key {
  display: flex;
  align-items: center;
  gap: 4px;
}
.energy-savings-improvements-work-order .value {
  color: #111;
}
.custom-di-payment-modal {
  max-width: 1000px;
  width: 96%;
}
.custom-di-payment-modal-email {
  display: block;
  line-break: anywhere;
}
@media (max-width: 991px) {
  .custom-di-payment-modal {
    width: 96%;
  }
  .custom-di-payment-modal-email {
    display: inline;
  }
}
.konva-canvas-modal {
  width: 100vw;
  height: 100vh;
  margin: 0;
}
.konva-canvas-modal .modal-content {
  height: 100vh;
  border-radius: 0;
  border: none;
  display: flex;
  flex-direction: column;
  min-height: 600px;
}
.konva-canvas-modal .modal-header {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f7f7f7;
  border-bottom: 1px solid #e6e6e6;
  padding: 8px 16px;
  display: table;
}
.konva-canvas-modal .modal-header .modal-title {
  font-size: 16px;
  font-weight: 600;
  color: #777777;
}
.konva-canvas-modal .modal-body {
  flex: 1;
  overflow-y: auto;
  padding: 0;
  display: flex;
  flex-direction: row;
}
.konva-canvas-modal .modal-body .left-sidebar {
  width: 192px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  border-right: 1px solid #e6e6e6;
}
.konva-canvas-modal .modal-body .left-sidebar .top {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.konva-canvas-modal .modal-body .left-sidebar .top .draw-mode-btns-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.konva-canvas-modal .modal-body .left-sidebar .top .shape-btns-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.konva-canvas-modal .modal-body .right-sidebar {
  border-left: 1px solid #e6e6e6;
}
.konva-canvas-modal .modal-body hr {
  border-top: 1px solid #e6e6e6;
  width: 100%;
  margin: 0;
}
.konva-canvas-modal .fixed-footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background-color: #f7f7f7;
  box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.1);
  padding: 16px;
}
.konva-canvas-modal .fixed-footer .footer-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.konva-canvas-modal .fixed-footer .footer-container span {
  font-size: 16px;
  font-weight: 600;
  line-height: 142%;
  color: #777777;
}
.konva-canvas-modal .fixed-footer .footer-container span b {
  font-weight: 700;
  color: #333333;
}
.konva-canvas-modal .fixed-footer .footer-container .footer-buttons-container {
  display: flex;
  flex-direction: row;
  gap: 4px;
}
.konva-canvas-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1064;
  background: #fff;
  display: flex;
  flex-direction: column;
  min-height: 600px;
}
.konva-canvas-page .konva-canvas-page-header {
  position: sticky;
  top: 0;
  z-index: 2;
  background: #f7f7f7;
  border-bottom: 1px solid #e6e6e6;
  padding: 8px 16px;
  display: table;
}
.konva-canvas-page .konva-canvas-page-header h3 {
  font-size: 16px;
  font-weight: 600;
  color: #777777;
  margin: 0;
}
.konva-canvas-page .konva-canvas-page-body {
  flex: 1;
  overflow-y: auto;
  padding: 0;
  display: flex;
  flex-direction: row;
}
.konva-canvas-page .konva-canvas-page-body .left-sidebar {
  width: 192px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px;
  border-right: 1px solid #e6e6e6;
}
.konva-canvas-page .konva-canvas-page-body .left-sidebar .top {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.konva-canvas-page .konva-canvas-page-body .left-sidebar .top .draw-mode-btns-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.konva-canvas-page .konva-canvas-page-body .left-sidebar .top .shape-btns-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.konva-canvas-page .konva-canvas-page-body .right-sidebar {
  border-left: 1px solid #e6e6e6;
}
.konva-canvas-page .konva-canvas-page-body hr {
  border-top: 1px solid #e6e6e6;
  width: 100%;
  margin: 0;
}
.konva-canvas-page .konva-canvas-page-footer {
  position: sticky;
  bottom: 0;
  z-index: 2;
  background-color: #f7f7f7;
  box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.1);
  padding: 16px;
}
.konva-canvas-page .konva-canvas-page-footer .footer-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.konva-canvas-page .konva-canvas-page-footer .footer-container span {
  font-size: 16px;
  font-weight: 600;
  line-height: 142%;
  color: #777777;
}
.konva-canvas-page .konva-canvas-page-footer .footer-container span b {
  font-weight: 700;
  color: #333333;
}
.konva-canvas-page .konva-canvas-page-footer .footer-container .footer-buttons-container {
  display: flex;
  flex-direction: row;
  gap: 4px;
}
.konva-edit-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #f7f7f7;
  padding: 16px;
}
.konva-fixed-area {
  width: 100%;
  max-width: 100%;
  aspect-ratio: 16 / 9;
  height: auto;
  max-height: 100%;
  position: relative;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}
.stored-file-notify {
  color: #777;
  font-size: 12px;
  line-height: 1.6;
  font-weight: 600;
  padding: 16px;
  border-radius: 12px;
  background-color: #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 1px 2px -1px rgba(0, 0, 0, 0.06), 0 2px 4px 0 rgba(0, 0, 0, 0.04);
}
.stored-file-notify b {
  font-weight: 700;
  color: #111;
}
.no-image-selected {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0;
  text-align: center;
  color: #777777;
  gap: 16px;
  z-index: 2;
}
.wwrt-image-uploader-container {
  align-items: center;
  background: #f9f9f9;
  border-color: #cccccc;
  border-radius: 12px;
  border-style: dashed;
  border-width: 1px;
  display: flex;
  gap: 16px;
  height: 100%;
  justify-content: center;
  padding: 8px;
  width: 100%;
  cursor: pointer;
}
.wwrt-image-uploader-container:hover {
  background-color: #f2f2f2;
}
.wwrt-image-uploader-container p {
  margin: 0;
}
.wwrt-image-uploader-container input[type='file'] {
  display: none;
}
.wwrt-image-uploader-container .wwrt-image-uploader {
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
  min-height: 115px;
  color: #777777;
  font-size: 12px;
}
.wwr-white-btn {
  transition: all 150ms ease-in-out;
}
.wwr-white-btn:hover {
  background-color: #f7f7f7 !important;
}
.wwr-wall-btn {
  transition: all 150ms ease-in-out;
}
.wwr-wall-btn:hover {
  background-color: #fef0e6 !important;
}
.wwr-window-btn {
  transition: all 150ms ease-in-out;
}
.wwr-window-btn:hover {
  background-color: #ebf1fe !important;
}
.wwr-delete-btn {
  transition: all 150ms ease-in-out;
  background-color: #d92d20 !important;
  color: #fff !important;
}
.wwr-delete-btn:hover {
  background-color: #ae241a !important;
}
.shape-properties-title {
  font-size: 12px;
  font-weight: 600;
  color: #777777;
  margin: 0;
}
.undo-redo-btns {
  display: flex;
  flex-direction: row;
  gap: 8px;
}
.zoom-controls {
  width: 34px;
  position: absolute;
  bottom: 24px;
  right: 24px;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.zoom-button {
  width: 100%;
  height: 32px;
  background-color: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  backdrop-filter: blur(2px);
}
.zoom-button:hover {
  background-color: #f2f2f2;
}
.zoom-button hr {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.start-audit-button {
  width: auto !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
@media (min-width: 992px) {
  .start-audit-button {
    padding-top: 11px !important;
    padding-bottom: 11px !important;
  }
}
.content.jobs-view {
  background-color: transparent;
  padding-top: 92px;
  min-height: 100vh;
}
.content.jobs-view.jobs-view-has-only-one-organization {
  padding-top: 46px;
}
.content.jobs-view h1 {
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
}
.content.jobs-view h1 .btn-group {
  margin-left: 10px;
}
.content.jobs-view h1 .btn-group > .btn-large {
  font-size: 24px;
}
.content.jobs-view h2 {
  font-size: 24px;
  font-weight: 300;
  margin-top: 5px;
}
.content.jobs-view .listings {
  min-height: 50vh;
}
.listings {
  color: #303232;
}
.listings h3 {
  font-weight: 600;
  font-size: 15px;
  text-transform: capitalize;
  margin: 0;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #222222;
}
.listings h3 small {
  color: #666;
}
.listings a {
  color: #333333;
}
.listings .jl {
  font-size: 13px;
  line-height: 26px;
  position: relative;
  overflow: hidden;
  min-height: 60px;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  *zoom: 1;
}
.listings .jl.jl-not-wholly-clickable {
  cursor: default;
}
.listings .jl.jl-not-wholly-clickable a {
  color: #c84900;
}
.listings .jl:before,
.listings .jl:after {
  content: " ";
  display: table;
}
.listings .jl:after {
  clear: both;
}
.listings .jl:before,
.listings .jl:after {
  display: table;
  content: '';
  line-height: 0;
}
.listings .jl:after {
  clear: both;
}
.listings .jl:nth-last-child(2) {
  border-bottom: 0;
}
.listings .jl.jl-header {
  text-transform: uppercase;
  cursor: default;
  border-bottom: none;
  min-height: 46px;
}
.listings .jl.jl-header .jl-buttons {
  min-height: 46px;
}
.listings .jl.jl-header .jl-everything-else {
  cursor: default;
  min-height: 46px;
}
.listings .jl.jl-header .jl-everything-else:hover {
  background-color: transparent;
}
.listings .jl.jl-header .jl-box {
  color: #555555;
  letter-spacing: 0.08em;
  font-size: 0.95em;
  font-weight: 700;
  text-align: left;
}
.listings .jl.jl-header-sortable .jl-box {
  cursor: pointer;
  border-radius: 5px;
}
.listings .jl.jl-header-sortable .jl-box:hover {
  background-color: #f2f2f2;
  color: #000;
}
.listings .jl.jl-header-sortable .jl-box:active,
.listings .jl.jl-header-sortable .jl-box:focus {
  background-color: #eeeeee;
}
.listings .jl.jl-unread {
  background-color: #f3f3f3;
}
.listings .jl.jl-unread h3 {
  padding-right: 35px;
  font-weight: 700;
  padding-right: 20px;
}
.listings .jl.jl-unread h3:after {
  content: '\\3e';
  font-family: 'snugg-6';
  position: absolute;
  display: block;
  height: 20px;
  right: 10px;
  top: 8px;
  top: 10px;
  font-size: 17px;
  padding-left: 5px;
  margin: auto;
  font-size: inherit;
  color: rgba(0, 0, 0, 0.5);
}
.listings .jl.jl-single-line .jl-everything-else {
  padding-top: 13px;
}
.listings .jl.jl-single-button .jl-buttons {
  width: 36px;
}
.listings .jl.jl-single-button .jl-everything-else {
  margin-left: 35px;
  padding-left: 5px;
}
.listings .jl.jl-no-button .jl-everything-else {
  margin-left: 0;
}
.listings .jl-buttons {
  width: 72px;
  min-height: 60px;
  float: left;
}
.listings .jl-buttons .snugg-select {
  min-height: 60px;
}
.listings .btn-map-it,
.listings .jl-select {
  position: relative;
  padding: 0;
  font-size: 18px;
  padding: 6px;
  border-radius: 0;
  height: 60px;
  width: 36px;
  color: rgba(0, 0, 0, 0.3);
  background-color: transparent;
  cursor: pointer;
}
.listings .btn-map-it:hover,
.listings .jl-select:hover,
.listings .btn-map-it:focus,
.listings .jl-select:focus,
.listings .btn-map-it:focus-within,
.listings .jl-select:focus-within {
  background-color: #fff3e3;
  color: #303232;
}
.listings .btn-map-it:active,
.listings .jl-select:active {
  background-color: #ffeacf;
  box-show: 'none';
}
.listings .btn-map-it [class^='ico-'],
.listings .jl-select [class^='ico-'],
.listings .btn-map-it [class*=' ico-'],
.listings .jl-select [class*=' ico-'] {
  height: 22px;
  position: absolute;
  margin: auto;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.listings .jl-select.checkbox-container {
  display: inline-block;
  width: 36px;
  height: 60px;
  float: left;
}
.listings .jl-select.checkbox-container .checkmark {
  top: 0;
  bottom: 0;
  left: 10px;
  margin: auto;
}
.listings .jl-everything-else {
  cursor: pointer;
  min-height: 60px;
  margin-left: 72px;
}
.listings .jl-everything-else:hover {
  background-color: #fff3e3;
}
.listings .jl-everything-else:active {
  background-color: #ffdfb5;
}
.listings .jl-everything-else .link-to-job {
  display: block;
}
.listings .jl-everything-else .link-to-job:focus {
  outline: none;
  background-color: #fff3e3;
}
.listings .jl-everything-else .job-row-unread-indicator {
  background-color: #3571f7;
  border-radius: 2em;
  width: 12px;
  height: 12px;
  position: absolute;
  right: 16px;
  left: auto;
  top: 42%;
  bottom: auto;
}
.listings .snugg-selected .jl-everything-else:hover {
  background-color: #ffefdc;
}
.listings .jl-box {
  padding-top: 15px;
  padding: 15px 1.5% 3px;
  float: left;
  color: #222222;
  position: relative;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.listings .jl-job-id {
  width: 25%;
}
.listings .jl-job-id-list {
  padding: 8px 5px 0 4px;
  line-height: 1.5;
}
.listings .jl-alt-job-id {
  line-height: 1.5;
  padding-top: 2px;
}
.listings .jl-account {
  *zoom: 1;
  padding: 6px 5px 0 4px;
}
.listings .jl-account:before,
.listings .jl-account:after {
  content: " ";
  display: table;
}
.listings .jl-account:after {
  clear: both;
}
.listings .jl-account:before,
.listings .jl-account:after {
  display: table;
  content: '';
  line-height: 0;
}
.listings .jl-account:after {
  clear: both;
}
.listings .jl-discreet {
  color: #555555;
  white-space: nowrap;
  overflow-x: hidden;
}
.listings .jl-user {
  width: 20%;
}
.listings .jl-program {
  width: 30%;
}
.listings .jl-stage {
  width: 20%;
}
.listings .jl-date-and-time {
  float: right;
  padding: 5px 5px 0 0;
}
.listings .jl-date-and-time .cal-icon {
  text-align: center;
  min-width: 70px;
  min-height: 57px;
}
.listings .jl-date-and-time .cal-icon .cal-icon__month {
  font-size: 11px;
  font-weight: 400;
}
.listings .jl-date-and-time .cal-icon .cal-icon__month-day {
  font-weight: 400;
  font-size: 22px;
  line-height: 1.2em;
}
.listings .jl-date-and-time .cal-icon .cal-icon__week-day-and-time {
  font-size: 11px;
  font-weight: 400;
  white-space: nowrap;
}
.listings .jl-date {
  float: none;
  text-align: left;
  padding-left: 0;
}
.listings .jl-job-type {
  float: right;
  text-align: right;
  padding-right: 0;
}
/* Extra small devices (phones, less than 768px) */
/* No media query since this is the default in Bootstrap */
/* ONLY extra small devices (phones less than 768px) */
@media (max-width: 767px) {
  .listings .jl.jl-unread h3 {
    padding-right: 35px;
  }
  .listings .jl.jl-unread h3:after {
    top: 10px;
    font-size: 17px;
  }
  .listings .jl-job-id-list {
    padding: 0;
    line-height: inherit;
  }
  .listings .jl-job-id-text {
    display: inline;
  }
  .listings .jl-alt-job-id {
    display: inline;
    padding-left: 4px;
    padding-top: 0;
  }
  .listings .jl-date-and-time {
    float: right;
    color: #555555;
  }
  .listings .jl-date-and-time .jl-box-left {
    display: none;
  }
  .listings .jl-select,
  .listings .btn-map-it,
  .listings .jl-everything-else {
    min-height: 80px;
  }
  .listings .jl-select .job-row-unread-indicator,
  .listings .btn-map-it .job-row-unread-indicator,
  .listings .jl-everything-else .job-row-unread-indicator {
    right: 8px;
  }
  .listings .jl-account {
    height: auto;
    padding: 8px 0 0 3px;
  }
  .listings .jl-account h3 {
    max-width: none;
    margin-top: 0;
    padding: 2px 0;
  }
  .listings .jl-job-id,
  .listings .jl-program,
  .listings .jl-user {
    display: inline;
    width: auto;
  }
  .listings .jl-job-stats {
    color: #777777;
    padding-top: 2px;
  }
  .listings .jl-job-stats .jl-box {
    width: auto;
    padding: 0;
    padding-left: 3px;
  }
  .listings .jl-job-stats .jl-box:first-child:after {
    content: ' \\2022  ';
  }
  .listings .jl-box {
    padding: 3px;
  }
}
#main-pane {
  min-height: 70vh;
}
/* Small devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .content.jobs-view {
    background-color: transparent;
    padding-top: 46px;
  }
  .content.jobs-view #main-pane {
    padding-left: 30px;
  }
}
/* Medium devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .content.jobs-view .jl-date {
    padding-left: 10%;
  }
  .content.jobs-view #main-pane {
    padding-left: 26px;
  }
}
/* Large devices (large desktops, 1200px and up) */
.content.activity-view {
  background-color: transparent;
  min-height: 500px;
  padding-bottom: 10px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-attachment: fixed;
  background-repeat: repeat;
  padding-top: 92px;
}
.content.activity-view.activity-view-has-only-one-organization {
  padding-top: 46px;
}
.content.activity-view .activity-feed-main-pane {
  margin-bottom: 40px;
  min-height: 700px;
}
.content.activity-view .activity-feed-newer-activity-detected.alert.alert-alert {
  border-radius: 30px;
  min-width: 370px;
  width: 370px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
}
.content.activity-view .activity-feed-newer-activity-detected.alert.alert-alert h4 {
  margin-bottom: 6px;
  padding-top: 4px;
}
.content.activity-view .activity-feed-newer-activity-detected.alert.alert-alert:hover {
  background-color: #e3f2fa;
  color: #1a3140;
}
.content.activity-view .activity-feed-newer-activity-detected.alert.alert-alert .close {
  padding: 8px 18px 0px;
}
.content.activity-view .activity-feed-newer-activity-detected.alert.alert-alert .close:hover {
  color: #000;
}
.content.activity-view .activity-feed-cards-container {
  position: relative;
}
.content.activity-view .activity-feed-cards-container .activity-feed-visual-card-link {
  position: absolute;
  top: 10px;
  bottom: 0;
  left: 9%;
  right: auto;
  width: 2px;
  background-color: #bbb;
  z-index: 0;
}
.content.activity-view .activity-feed-end-of-new-notifications {
  position: relative;
  text-align: center;
  max-width: 750px;
  font-weight: 600;
  margin-top: 30px;
  margin-bottom: 30px;
}
.content.activity-view .activity-feed-end-of-new-notifications span {
  padding: 5px 15px;
  position: relative;
  color: #f88b00;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  background-color: #f2f2f2;
  border: 2px solid #f88b00;
  border-radius: 4px;
  display: inline-block;
}
.content.activity-view .activity-feed-end-of-new-notifications:before {
  display: block;
  content: '';
  height: 1px;
  border-bottom: 2px dashed #f88b00;
  position: absolute;
  top: 50%;
  width: 100%;
}
.content.activity-view .activity-feed-day-divider {
  position: relative;
  z-index: 1;
  height: 30px;
  min-width: 18%;
  border-radius: 17px;
  background-color: #555555;
  color: #f9f9f9;
  padding: 6px 16px;
  display: inline-block;
  margin-bottom: 30px;
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.content.activity-view .activity-card + .activity-feed-day-divider {
  margin-top: 30px;
}
.content.activity-view .activity-card {
  z-index: 1;
  position: relative;
  min-height: 130px;
  border-radius: 5px;
  background-color: #ffffff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  padding: 20px 20px 15px;
  margin-bottom: 20px;
  animation-duration: 1.2s;
  max-width: 750px;
}
.content.activity-view .activity-card .activity-card-header {
  font-size: 22px;
  line-height: 1.3em;
  font-weight: 700;
  letter-spacing: 0;
  margin-bottom: 10px;
}
.content.activity-view .activity-card .activity-card-job-id {
  color: #777777;
  font-weight: 600;
  border-radius: 4px;
  padding-left: 5px;
  display: inline-block;
}
.content.activity-view .activity-card .activity-card-message {
  font-size: 14px;
  letter-spacing: 0;
  line-height: 19px;
  color: #333333;
  margin-top: 10px;
  margin-bottom: 10px;
}
.content.activity-view .activity-card .activity-card-user-name {
  color: #555555;
  font-size: 12px;
  line-height: 17px;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 80px;
  overflow-x: hidden;
}
.content.activity-view .activity-card .activity-card-time {
  font-size: 12px;
  line-height: 1.76em;
  color: #555;
  font-weight: 700;
  white-space: nowrap;
  text-align: left;
  padding-top: 3px;
  padding-bottom: 5px;
}
.content.activity-view .activity-card .activity-card-job-info {
  margin-bottom: 20px;
  font-weight: 600;
}
@media (min-width: 768px) {
  .content.activity-view {
    padding-top: 46px;
  }
  .content.activity-view.activity-view-has-only-one-organization {
    padding-top: 46px;
  }
  .content.activity-view .activity-card .activity-card-header {
    font-size: 20px;
  }
  .content.activity-view .activity-card .activity-card-time {
    text-align: center;
  }
  .content.activity-view .activity-card .activity-card-job-info {
    margin-bottom: 10px;
  }
  .content.activity-view .activity-card .activity-card-message {
    margin-left: 12px;
  }
}
.editable-prefix {
  float: left;
  margin-right: 20px;
  padding-top: 6px;
}
input.editable-title,
input.form-control.editable-title,
.form-horizontal .form-group-lg input.form-control.editable-title {
  display: block;
  background-color: inherit;
  border: 0;
  width: 100%;
  height: 28px;
  box-shadow: none;
  padding: 2px 0 3px 1px;
  margin-top: 9px;
  color: #000;
  border-radius: 0;
  border-bottom: 1px dashed #c84900;
}
input.editable-title:hover,
input.form-control.editable-title:hover,
.form-horizontal .form-group-lg input.form-control.editable-title:hover {
  background-color: #fef2c1;
}
input.editable-title:focus,
input.form-control.editable-title:focus,
.form-horizontal .form-group-lg input.form-control.editable-title:focus,
input.editable-title:active,
input.form-control.editable-title:active,
.form-horizontal .form-group-lg input.form-control.editable-title:active {
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: 0;
  background-color: inherit;
  -moz-appearance: none;
  -webkit-appearance: none;
}
.job-form input.editable-title,
.job-form input.form-control.editable-title,
.job-form .form-horizontal .form-group-lg input.form-control.editable-title {
  font-weight: 600;
  letter-spacing: 0.03em;
  font-size: 15px;
  margin-bottom: 10px;
  text-align: left;
  color: #666;
}
.editable {
  background-color: inherit;
  font: inherit;
  color: inherit;
  height: inherit;
  text-align: inherit;
  width: 100%;
  padding: 0;
  border: 0;
  border-radius: 0;
  margin: 0;
  line-height: inherit;
  vertical-align: inherit;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.editable:hover {
  background-color: rgba(249, 143, 9, 0.2);
  color: #222222;
  background-opacity: 1;
  cursor: text;
  outline: 0;
  -moz-appearance: none;
  -webkit-appearance: none;
}
.editable:focus,
.editable:active {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  color: inherit !important;
  outline: 0;
  background-color: inherit !important;
  -moz-appearance: none;
  -webkit-appearance: none;
}
input[type='text'].editable {
  border-bottom: 1px dashed #777777;
}
input[type='text'].editable[disabled] {
  border-bottom: none;
}
input[type='text'].editable[disabled]:hover {
  background-color: inherit;
  cursor: not-allowed;
  -webkit-user-select: none;
  user-select: none;
}
.editable-container {
  overflow: hidden;
}
.report-present .report-page .editable-container:hover {
  background-color: transparent !important;
  color: default !important;
  cursor: default;
}
.report-present .report-page input[type='text'].editable {
  border-bottom: none;
}
.report-present .report-page .disabled-hover {
  pointer-events: none;
}
.inline-editable__target {
  max-height: 580px;
  overflow: hidden;
}
.report-sidebar .editable:hover {
  background-color: rgba(255, 255, 255, 0.85);
}
.slidedown-enter {
  min-height: 0px;
  max-height: 0px;
  transition: all 0.5s ease;
  overflow: hidden;
}
.slidedown-enter.slidedown-enter-active {
  max-height: 600px;
}
.readonly-job select,
.readonly-job .form-control,
.readonly-job input[type='text'],
.readonly-job input[type='password'],
.readonly-job input[type='datetime'],
.readonly-job input[type='datetime-local'],
.readonly-job input[type='date'],
.readonly-job input[type='month'],
.readonly-job input[type='time'],
.readonly-job input[type='week'],
.readonly-job input[type='number'],
.readonly-job input[type='email'],
.readonly-job input[type='url'],
.readonly-job input[type='search'],
.readonly-job input[type='tel'],
.readonly-job input[type='color'],
.readonly-job .uneditable-input {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
  color: #555555 !important;
  background-color: #f2f2f2 !important;
  opacity: 1 !important;
  border-color: #dfdfdf !important;
  pointer-events: none;
}
.readonly-job .input-group-addon {
  background-color: #f2f2f2 !important;
  color: #555555 !important;
  border-color: #dfdfdf !important;
}
.readonly-job .btn-group {
  pointer-events: none;
}
.readonly-job .btn-group > .btn {
  color: #222;
  background-color: #f2f2f2;
  border-color: #dfdfdf;
}
.readonly-job .btn-group > .btn.active {
  box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.5);
  color: #222;
  background-color: #fff;
}
.readonly-job .DraftEditor-root {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
  pointer-events: none;
}
.readonly-job .themes-list {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
  pointer-events: none;
}
.readonly-job .snugg-btn-collectionAdd:not(.readonly-exception) {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
  pointer-events: none;
  background-color: #f9f9f9 !important;
  border: 1px dashed #dfdfdf !important;
}
.readonly-job .snugg-btn-orange {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
  pointer-events: none;
}
.readonly-job .snugg-btn-delete {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
  pointer-events: none;
}
.readonly-job .report-photo-row {
  pointer-events: none;
}
.job-container {
  padding-top: 91px;
  padding-bottom: 600px;
}
.collection-set {
  padding-bottom: 20px;
}
.collection {
  padding-bottom: 20px;
}
.collection + .collection {
  border-top: 1px solid #e0e0e0;
  padding-top: 20px;
}
.input-group {
  position: relative;
}
.input-group.deletable {
  display: block;
}
.input-group.deletable select {
  max-width: 76%;
  width: auto;
}
.input-group .popover-sibling {
  display: inline;
}
.delete-job-row {
  float: right;
  display: inline-block;
  color: red;
  margin-left: 16px;
  padding: 12px 16px;
  font-size: 16px;
  border-radius: 3px;
  background: inherit;
  border: none;
}
.delete-job-row:hover {
  color: #fff;
  background-color: red;
}
.delete-job-row:active {
  color: #fff;
  background-color: #db0000;
}
.table-control-group.jobform-refrigerator table td:last-child {
  position: relative;
  padding-right: 10px;
}
.table-control-group.jobform-windows .table > tbody > tr > td {
  border-top: none;
  padding: 8px 4px;
}
.table-control-group .control-label {
  padding-top: 50px;
}
.table-control-group .control-label span {
  display: block;
  padding-top: 46px;
}
.table-control-group .css-delete-row {
  position: absolute;
}
.table-control-group table {
  margin-bottom: 10px;
}
.table-control-group .delete-job-row {
  position: absolute;
  display: block;
  float: left;
  top: 3px;
  right: -45px;
}
.date-difference {
  float: right;
  margin-top: -95px;
  padding: 3px;
  border-radius: 10px;
  width: 67px;
  border: dotted 1px #aaa;
  -webkit-box-shadow: none;
  box-shadow: none;
  display: block;
  position: relative;
  z-index: 2;
}
.date-difference:before {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 20px;
  margin: auto;
  width: 1px;
  height: 177px;
  border-left: 1px dotted #aaa;
}
.date-difference:after {
  content: '\\25CB';
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 90px;
  bottom: 0;
  margin: auto;
  text-align: center;
  font-size: 18px;
  line-height: 7px;
  height: 10px;
  width: 15px;
  color: #555555;
  background-color: white;
}
.date-difference.label {
  background-color: white;
}
.date-difference.label-warning {
  background-color: #f7efd3;
  color: #554610;
  border-color: #efdfa8;
}
.date-difference.label-error {
  background-color: #f1e3e3;
  color: #b21212;
  border-color: #721111;
}
.date-difference.date-difference-start {
  content: '';
  border: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.date-difference.date-difference-start:before {
  top: 30px;
  height: 50px;
}
.date-difference.date-difference-start:after {
  content: '\\29BF';
  top: 47px;
}
.date-difference.date-difference-end {
  content: '';
}
.date-difference.date-difference-end:before {
  top: 17px;
  height: 30px;
}
.date-difference.date-difference-end:after {
  content: '\\29BF';
  top: 47px;
}
/* Extra small devices (phones, less than 768px) */
/* No media query since this is the default in Bootstrap */
/* ONLY extra small devices (phones less than 768px) */
@media (max-width: 767px) {
  .push-left .scroll-spy-clicked,
  .push-left.scroll-spy {
    left: 60px;
    right: -60px;
    -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
    -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
    transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  }
  .form-group-utility-date:last-child .date-difference:before {
    height: 80px;
  }
}
@media (max-width: 991px) {
  .form-group-narrow .input-lg,
  .form-group-narrow input.form-control {
    padding-left: 8px;
    padding-right: 5px;
  }
  .form-group-narrow .input-group-addon {
    min-width: 20px;
    padding-left: 5px;
    padding-right: 5px;
  }
  .form-group-narrow .btn-group > .btn {
    padding-left: 9px;
    padding-right: 9px;
  }
}
/* Small devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .push-left .scroll-spy-clicked,
  .push-left .scroll-spy {
    left: 60px;
    right: -60px;
    -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
    -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
    transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  }
  .scroll-spy-clicked,
  .scroll-spy {
    left: 60px;
    -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
    -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
    transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  }
  .delete-job-row {
    float: none;
  }
  .job-container {
    padding-top: 46px;
  }
}
/* Medium devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .date-difference {
    margin-top: 0;
  }
  .date-difference:before {
    left: 0;
    right: 0;
    top: 18px;
    height: 95px;
  }
  .date-difference:after {
    left: 0;
    right: 0;
    top: 90px;
    bottom: 0;
    height: 10px;
  }
  .date-difference.date-difference-start {
    margin-top: 0;
  }
  .date-difference.date-difference-start:before {
    top: 45px;
    height: 50px;
  }
  .date-difference.date-difference-start:after {
    content: '\\29BF';
    top: 47px;
  }
  .date-difference.date-difference-end:before {
    top: 16px;
    height: 30px;
  }
}
@media (max-height: 589px) {
  .push-left .scroll-spy-clicked,
  .push-left .scroll-spy {
    left: 108px;
    right: -108px;
    -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
    -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
    transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  }
}
@media (max-height: 589px) and (min-width: 768px) {
  .scroll-spy-clicked,
  .scroll-spy {
    left: 108px;
    right: -108px;
    -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
    -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
    transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  }
}
.rec-content .add-rec {
  margin: 20px 0 25px;
}
.rec-content .nav-tabs > li.active > a {
  background-color: #f4f4f4;
}
.rec-content .rec-row {
  *zoom: 1;
  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);
  border-radius: 0;
  font-size: 1em;
  margin-bottom: 10px;
  background-color: #fff;
  border: 1px solid #eaeaea;
  border-bottom: none;
  cursor: pointer;
  position: relative;
  user-select: none;
}
.rec-content .rec-row:before,
.rec-content .rec-row:after {
  content: " ";
  display: table;
}
.rec-content .rec-row:after {
  clear: both;
}
.rec-content .rec-row:before,
.rec-content .rec-row:after {
  display: table;
  content: '';
  line-height: 0;
}
.rec-content .rec-row:after {
  clear: both;
}
.rec-content .rec-row:hover,
.rec-content .rec-row:focus {
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);
  z-index: 1;
}
.rec-content .rec-row:active {
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);
  z-index: 10;
}
.rec-content .rec-row.rec-header {
  min-height: 20px;
  height: 20px;
  padding: 0 8px;
  text-align: center;
  font-size: 0.9em;
  text-transform: uppercase;
  border: none;
  box-shadow: none;
  background-color: transparent;
}
.rec-content .rec-row.rec-header:hover {
  box-shadow: none;
}
.rec-content .rec-row.rec-header .span-rec {
  padding-top: 0;
  padding-bottom: 5px;
  text-align: right;
}
.rec-content .rec-row.rec-header .span-rec.span-cost {
  text-align: right;
}
.rec-content .rec-row.rec-header .span-accept {
  text-align: left;
}
.rec-content .rec-row.new-rec-row {
  border: 1px dashed #cdcdcd;
}
.rec-content .rec-row.new-rec-row .custom-rec-name {
  color: #222;
  font-weight: 700;
}
.rec-content .btn-go {
  height: 62px;
  border-radius: 0;
  font-size: 18px;
  padding-top: 23px;
  border-top-right-radius: 4px;
}
.rec-content .span-rec {
  padding-top: 4px;
  padding-bottom: 8px;
}
.rec-content .span-rec .span-label {
  padding-bottom: 4px;
  color: #555555;
}
.rec-content .span-rec-name {
  display: block;
  font-weight: 600;
  padding-top: 15px;
  padding-left: 15px;
  color: #303232;
}
.rec-content .span-rec-name .span-rec-title {
  font-size: 0.9em;
  opacity: 0.7;
  font-weight: 400;
}
.rec-content .span-rec-name .notes-label {
  font-size: 0.9em;
}
.rec-content .span-rec-name .general-label {
  margin: 0;
}
.rec-content .span-cost {
  width: 100%;
  float: left;
  text-align: right;
  padding-right: 5px;
}
.rec-content .span-cost .span-label {
  padding-right: 10px;
  text-align: left;
}
.rec-content .span-cost input {
  text-align: right;
  padding-right: 5px;
}
.rec-content .span-potential {
  width: 25%;
  text-align: right;
  float: left;
  padding-right: 10px;
}
.rec-content .span-savings {
  width: 25%;
  text-align: right;
  float: left;
  padding-right: 10px;
}
.rec-content .span-sir {
  width: 25%;
  text-align: right;
  float: left;
  padding-right: 10px;
}
.rec-content .span-priorities {
  width: 45px;
  float: left;
  margin-right: 0px;
}
.rec-content .span-blank-state {
  text-align: center;
  padding: 22px 0;
}
.rec-content .rec-area {
  border-top: none;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
}
.rec-content .rec-untitled {
  color: #959999;
}
.incentive-badge-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: center;
  gap: 2px;
  padding-top: 4px;
  padding-bottom: 8px;
  padding-right: 0;
  padding-left: 0;
  height: auto;
}
.incentive-name-badge {
  font-size: 10px;
  font-weight: 600;
  color: #fff;
  line-height: 1.2;
  padding: 2px 8px;
  background-color: #555;
  border-radius: 24px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}
@media (min-width: 1200px) {
  .incentive-badge-container {
    padding-top: 4px;
    padding-bottom: 4px;
    padding-right: 0px;
    padding-left: 8px;
    height: 60px;
    justify-content: center;
  }
  .incentive-name-badge {
    max-width: 120px;
  }
}
.refine-table {
  width: 100%;
  border-collapse: collapse;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-right: 15px;
}
.refine-table > div {
  box-sizing: border-box;
  padding-right: 16px;
}
.refine-table .refine-name {
  width: 100%;
  order: 1;
}
.refine-table .refine-status {
  width: 100%;
  padding-left: 16px;
  display: flex;
  order: 2;
}
.refine-table .refine-cost {
  width: 45%;
  padding-left: 16px;
  padding-right: 5%;
  padding-bottom: 8px;
  text-align: left;
  order: 3;
}
.refine-table .refine-incentives {
  width: 45%;
  padding-left: 5%;
  padding-bottom: 8px;
  text-align: left;
  order: 4;
}
.refine-table .refine-incentive-sources {
  width: 100%;
  padding-left: 16px;
  padding-bottom: 8px;
  order: 5;
}
.refine-table .refine-savings {
  width: 50%;
  padding-left: 16px;
  padding-bottom: 16px;
  text-align: left;
  order: 6;
}
.refine-table .refine-sir {
  width: 50%;
  padding-bottom: 16px;
  text-align: left;
  order: 7;
}
.refine-table-head {
  display: none;
}
@media (min-width: 480px) {
  .refine-table > div {
    padding-right: 8px;
  }
  .refine-table .refine-cost {
    width: 45%;
  }
  .refine-table .refine-incentives {
    width: 45%;
  }
  .refine-table .refine-incentive-sources {
    width: 100%;
  }
  .refine-table .refine-savings {
    width: 50%;
  }
  .refine-table .refine-sir {
    width: 50%;
  }
}
@media (min-width: 768px) {
  .refine-table .refine-name {
    width: 50%;
    order: 1;
  }
  .refine-table .refine-status {
    width: 50%;
    justify-content: flex-end;
    order: 2;
  }
  .refine-table .refine-cost {
    width: 30%;
    padding-right: 0;
    padding-bottom: 8px;
    order: 3;
  }
  .refine-table .refine-incentives {
    width: 25%;
    padding-left: 5%;
    padding-bottom: 8px;
    order: 4;
  }
  .refine-table .refine-savings {
    width: 20%;
    padding-left: 0;
    padding-bottom: 8px;
    order: 5;
  }
  .refine-table .refine-sir {
    width: 20%;
    padding-bottom: 8px;
    order: 6;
  }
  .refine-table .refine-incentive-sources {
    width: 100%;
    order: 7;
  }
}
@media (min-width: 1200px) {
  .refine-table .refine-name {
    width: 22%;
    order: 1;
  }
  .refine-table .refine-status {
    width: 26%;
    justify-content: flex-start;
    padding: 0;
    order: 2;
  }
  .refine-table .refine-cost {
    width: 14%;
    order: 3;
  }
  .refine-table .refine-incentives {
    width: 10%;
    padding-left: 0;
    padding-right: 14px;
    order: 5;
    text-align: right;
  }
  .refine-table .refine-incentive-sources {
    width: 14%;
    padding: 0;
    order: 5;
  }
  .refine-table .refine-savings {
    width: 6%;
    text-align: right;
    order: 6;
  }
  .refine-table .refine-sir {
    width: 6%;
    text-align: right;
    order: 7;
  }
  .refine-table-head {
    display: flex;
    font-size: 13px;
    text-transform: uppercase;
    padding: 0px 5px 4px 15px;
    align-items: flex-end;
  }
  .refine-table-head .refine-name {
    width: 22%;
    order: 1;
  }
  .refine-table-head .refine-status {
    width: 26%;
    justify-content: flex-start;
    padding: 0;
    order: 2;
  }
  .refine-table-head .refine-cost {
    width: 14%;
    order: 3;
  }
  .refine-table-head .refine-incentives {
    width: 10%;
    padding-left: 0;
    padding-right: 14px;
    order: 5;
    text-align: right;
  }
  .refine-table-head .refine-incentive-sources {
    width: 14%;
    padding: 0;
    order: 5;
  }
  .refine-table-head .refine-savings {
    width: 6%;
    text-align: right;
    order: 6;
  }
  .refine-table-head .refine-sir {
    width: 6%;
    text-align: right;
    order: 7;
  }
}
/* Extra small devices (phones, less than 768px) */
/* No media query since this is the default in Bootstrap */
/* ONLY extra small devices (phones less than 768px) */
/* Small devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .rec-content .rec-row {
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    border-radius: 0;
    min-height: 62px;
    margin-bottom: 0;
    padding-left: 10px;
  }
  .rec-content .rec-row .span-cost .input-group-addon {
    min-width: 20px;
  }
  .rec-content .rec-row .span-sir,
  .rec-content .rec-row .span-savings {
    padding-top: 21px;
  }
  .rec-content .rec-row .btn-go {
    border-top-right-radius: 0;
  }
  .rec-content .span-accept .btn {
    padding: 8px 4px;
    font-size: 0.85em;
  }
}
/* Medium devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .rec-content .span-accept .btn {
    padding: 6px 9px;
    font-size: 1em;
  }
  .rec-content .span-cost {
    width: 100%;
  }
}
/* Large devices (large desktops, 1200px and up) */
.rec-single {
  /* Photo row styling*/
}
.rec-single .span-rec-name .form-group {
  margin-bottom: 0;
}
.rec-single .span-accept .btn {
  padding-left: 8px;
  padding-right: 8px;
}
.rec-single .btn-up,
.rec-single .btn-down {
  border-radius: 0;
  border-right: none;
  background-image: none;
  border-bottom: none;
  border-top: none;
  border-left: none;
  padding: 6px 9px;
}
.rec-single .btn-up:focus,
.rec-single .btn-down:focus {
  background-color: #f2f2f2;
}
.rec-single .btn-up:active,
.rec-single .btn-down:active {
  background-color: #c9c9c9;
}
.rec-single .btn-down {
  border-top: 1px solid #e8e8e8;
}
.rec-single .rec-blank-state {
  padding: 10px;
  margin: 20px 0;
  border-radius: 2px;
}
.rec-single .span-value {
  padding-top: 7px;
}
.rec-single .photo-row-container {
  padding-bottom: 20px;
}
.rec-single .photo-row {
  padding-top: 10px;
  padding-bottom: 5px;
  transition: outline 0.2s ease;
  position: relative;
  border-bottom: 1px dashed #ccc;
  max-height: 1000px;
  overflow: hidden;
  opacity: 1;
  transform: scale(1);
}
.rec-single .photo-row.photo-row-deleting {
  -webkit-animation: fadeOut 0.2s ease-in forwards, shrinkHeight 0.5s ease-in forwards;
  animation: fadeOut 0.2s ease-in forwards, shrinkHeight 0.5s ease-in forwards;
}
.rec-single .photo-row:first-child .span-priorities .btn-up {
  opacity: 0.5;
  cursor: not-allowed;
}
.rec-single .photo-row:first-child .span-priorities .btn-up:hover {
  background-color: #f2f2f2;
}
.rec-single .photo-row:last-child .span-priorities .btn-down {
  opacity: 0.5;
  cursor: not-allowed;
}
.rec-single .photo-row:last-child .span-priorities .btn-down:hover {
  background-color: #f2f2f2;
}
.rec-single .photo-row h4 {
  padding: 4px 0;
}
.rec-single .photo-row.highlight-delete {
  background-color: #f1e3e3;
}
.rec-single .photo-row .photo-caption {
  height: 115px;
}
.rec-single .photo-row .uploader-container .uploadcare-widget-circle--canvas {
  display: none;
}
.rec-single textarea.form-control {
  border: none;
  box-shadow: none;
  background-color: transparent;
}
.rec-single textarea.form-control:hover {
  background-color: #feeeda;
}
.rec-single textarea.form-control:hover:active,
.rec-single textarea.form-control:hover:focus {
  background-color: transparent;
}
/* Extra small devices (phones, less than 768px) */
/* No media query since this is the default in Bootstrap */
/* ONLY extra small devices (phones less than 768px) */
/* Small devices (tablets, 768px and up) */
/* Medium devices (desktops, 992px and up) */
/* Large devices (large desktops, 1200px and up) */
.recommendation-content .recommendation-area {
  border-top: none;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
}
.recommendation-content .recommendation-area .section-header {
  margin-top: 34px;
  border-bottom: 1px solid #e2e2e2;
}
.recommendation-content .recommendation-area .section-header .control-label {
  padding-top: 0;
}
.clearfix {
  *zoom: 1;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
  line-height: 0;
}
.clearfix:after {
  clear: both;
}
.r-row {
  margin-left: -18px;
  *zoom: 1;
}
.r-row:before,
.r-row:after {
  content: " ";
  display: table;
}
.r-row:after {
  clear: both;
}
.r-row:before,
.r-row:after {
  display: table;
  content: '';
  line-height: 0;
}
.r-row:after {
  clear: both;
}
[class*='r-spa'] {
  float: left;
  min-height: 5px;
  margin-left: 18px;
}
.r-container,
.r-navbar-static-top .container,
.r-navbar-fixed-top .container,
.r-navbar-fixed-bottom .container {
  width: 942px;
}
.r-spa12 {
  width: 942px;
}
.r-spa11 {
  width: 862px;
}
.r-spa10 {
  width: 782px;
}
.r-spa9 {
  width: 702px;
}
.r-spa8 {
  width: 622px;
}
.r-spa7 {
  width: 542px;
}
.r-spa6 {
  width: 462px;
}
.r-spa5 {
  width: 382px;
}
.r-spa4 {
  width: 302px;
}
.r-spa3 {
  width: 222px;
}
.r-spa2 {
  width: 142px;
}
.r-spa1 {
  width: 62px;
}
.r-offset12 {
  margin-left: 978px;
}
.r-offset11 {
  margin-left: 898px;
}
.r-offset10 {
  margin-left: 818px;
}
.r-offset9 {
  margin-left: 738px;
}
.r-offset8 {
  margin-left: 658px;
}
.r-offset7 {
  margin-left: 578px;
}
.r-offset6 {
  margin-left: 498px;
}
.r-offset5 {
  margin-left: 418px;
}
.r-offset4 {
  margin-left: 338px;
}
.r-offset3 {
  margin-left: 258px;
}
.r-offset2 {
  margin-left: 178px;
}
.r-offset1 {
  margin-left: 98px;
}
[class*='r-spa'].hide,
.row-fluid [class*='r-spa'].hide {
  display: none;
}
[class*='r-spa'].pull-right,
.row-fluid [class*='r-spa'].pull-right {
  float: right;
}
.repaginate-report {
  position: fixed;
  left: 10px;
  bottom: 10px;
}
.popover.popover-report-settings .popover-title {
  font-weight: 600;
  font-size: 16px;
  padding: 10px 14px;
}
.popover.popover-report-settings .popover-content {
  padding: 0;
}
.popover.popover-report-settings-pages .arrow {
  left: 50px;
  right: auto;
}
.popover.popover-report-settings-elements .arrow {
  left: 106px;
  right: auto;
}
.popover.popover-report-themes {
  max-width: 250px;
}
.popover.popover-report-themes .arrow {
  left: 156px;
  right: auto;
}
.popover.popover-report-signature-pages {
  max-width: 250px;
  left: 200px;
}
.popover.popover-report-signature-pages .arrow {
  right: 56px;
  left: auto;
}
.popover-report-link-items {
  padding: 8px 12px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 4px;
}
.popover-report-link-items:last-child {
  margin-bottom: 4px;
}
.popover-report-link-items:hover {
  background-color: #e6e6e6;
}
.scroll-spy.report-scroll-spy {
  position: fixed;
  background: #e8e8e8;
  width: 100%;
  z-index: 12;
  height: auto;
  top: 25px;
  padding: 0;
  opacity: 1;
  border-top: 1px solid #cccccc;
}
.content-header.content-header-report {
  background-color: #f2f2f2;
  min-height: 46px;
  height: auto;
}
.content-header.content-header-report h1 {
  width: 85%;
  display: inline-block;
  font-weight: 300;
  margin: 0;
  font-size: 18px;
  color: #575757;
  line-height: 46px;
}
.content-header.content-header-report h1 input[type='text'] {
  width: 100%;
}
.content-header.content-header-report .rep-toolbar {
  width: 100%;
  height: 46px;
  float: left;
}
.content-header.content-header-report .rep-toolbar .rep-btn {
  position: relative;
  text-align: center;
  color: #303232;
  background-color: transparent;
  white-space: inherit;
  font-size: 11px;
  min-width: 46px;
  min-height: 42px;
  padding: 5px 4px 3px;
  margin: 2px 4px 3px 0;
}
.content-header.content-header-report .rep-toolbar .rep-btn [class^='ico-'],
.content-header.content-header-report .rep-toolbar .rep-btn [class*=' ico-'] {
  display: block;
  float: none;
  font-size: 18px;
  line-height: 18px;
}
.content-header.content-header-report .rep-toolbar .rep-btn:last-child {
  margin-right: 0;
}
.content-header.content-header-report .rep-toolbar .rep-btn:hover {
  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
  background-color: inherit;
}
.content-header.content-header-report .rep-toolbar .rep-btn:active,
.content-header.content-header-report .rep-toolbar .rep-btn:focus,
.content-header.content-header-report .rep-toolbar .rep-btn.active {
  -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
  background-color: #e3e3e3;
}
.content-header.content-header-report .rep-toolbar-report {
  text-align: center;
}
.content-header.content-header-report .rep-toolbar-page {
  float: left;
  text-align: center;
}
.content-header.content-header-report .rep-toolbar-page > .btn {
  width: 20%;
}
.themes-list {
  margin: 0;
  padding: 0;
}
.themes-list .btn {
  width: 100%;
  clear: both;
  float: none;
  text-align: left;
  border-radius: 3px;
  padding: 10px;
}
.themes-list .btn.active {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.themes-list .report-theme {
  width: 60px;
  height: 40px;
  margin: 0 10px 0 0;
}
.report-theme {
  height: 17px;
  width: 25px;
  margin: auto;
  border-radius: 2px;
  margin-bottom: 3px;
  border: 1px solid #303232;
}
.report-present {
  background: #e4e4e4;
  padding-top: 5px;
  min-width: 982px;
}
.in-app-report .content {
  background-color: #fafafa;
  overflow-x: scroll;
  padding-top: 50px;
}
.in-app-report .editable-page-header {
  margin-right: 20px;
  width: 676px;
}
.in-app-report .report-photo-row textarea {
  opacity: 0;
  padding: 10px 5px 5px;
}
.in-app-report .report-photo-row textarea:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.in-app-report .report-photo-row textarea:focus {
  -webkit-box-shadow: 0 0 10px #a2a6a6;
  box-shadow: 0 0 10px #a2a6a6;
  border-color: #afb2b2;
  opacity: 1;
  transition: opacity 0.2s ease;
}
.in-app-report .report-page {
  zoom: 70%;
  margin: 10px 0;
  border-radius: 4px;
  opacity: 1;
  padding: 10px;
  width: 965px;
  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}
.in-app-report .report-page .report-body,
.in-app-report .report-page .report-main {
  height: auto;
  overflow: visible;
  min-height: 659px;
}
.in-app-report .report-page .report-sidebar {
  height: auto;
  min-height: 659px;
  position: absolute;
  bottom: 10px;
  top: 10px;
  width: 222px;
}
.in-app-report .report-page .report-sidebar dl dt {
  max-width: 145px;
}
.in-app-report .report-page .report-sidebar-v2 {
  min-height: 659px;
}
.report-page {
  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  background-color: #fff;
  border: 1px solid #d9d9d9;
  padding: 30px;
  margin: 10px 9px 20px 20px;
  width: 1005px;
  position: relative;
  border-radius: 4px;
  /* -- warn if printing on the in-app report page -- */
}
.report-page h1,
.report-page h2,
.report-page h3,
.report-page h4,
.report-page h5,
.report-page h6 {
  margin: 0 0 10px 0;
  text-rendering: optimizespeed;
}
.report-page h1 {
  color: #182416;
  font-size: 32px;
  font-weight: 600;
  margin: 10px 0 0;
}
.report-page h2 {
  color: #555555;
  font-size: 22px;
  font-weight: 600;
}
.report-page h3 {
  color: #2f2f2f;
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 5px;
}
.report-page h4 {
  color: #262626;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 5px;
}
.report-page h5 {
  color: #262626;
  font-size: 15px;
  margin-bottom: 5px;
}
.report-page h6 {
  margin: 0px;
}
.report-page p {
  line-height: 18px;
}
.report-page a {
  color: #4182d0;
}
.report-page hr.thick {
  border-top: 4px solid #eeeeee;
}
.report-page .report-header {
  *zoom: 1;
  height: 60px;
  overflow: hidden;
}
.report-page .report-header:before,
.report-page .report-header:after {
  content: " ";
  display: table;
}
.report-page .report-header:after {
  clear: both;
}
.report-page .report-header:before,
.report-page .report-header:after {
  display: table;
  content: '';
  line-height: 0;
}
.report-page .report-header:after {
  clear: both;
}
.report-page .report-header .company img {
  height: 60px;
  width: auto;
}
.report-page .report-header .program-branding {
  height: 55px;
  overflow: hidden;
  text-align: right;
  font-size: 12px;
  *zoom: 1;
}
.report-page .report-header .program-branding:before,
.report-page .report-header .program-branding:after {
  content: " ";
  display: table;
}
.report-page .report-header .program-branding:after {
  clear: both;
}
.report-page .report-header .program-branding:before,
.report-page .report-header .program-branding:after {
  display: table;
  content: '';
  line-height: 0;
}
.report-page .report-header .program-branding:after {
  clear: both;
}
.report-page .report-header .program-branding span {
  float: right;
  text-align: right;
  display: block;
}
.report-page .report-header .report-title {
  height: 60px;
  overflow-y: hidden;
  position: relative;
}
.report-page .report-header .report-title .report-title-input {
  color: #182416;
  font-size: 36px;
  margin: 0;
  height: auto;
  padding: 1px 0 0 0;
  width: 99%;
}
.report-page .report-logo {
  height: 60px;
  overflow: hidden;
  *zoom: 1;
}
.report-page .report-logo:before,
.report-page .report-logo:after {
  content: " ";
  display: table;
}
.report-page .report-logo:after {
  clear: both;
}
.report-page .report-logo:before,
.report-page .report-logo:after {
  display: table;
  content: '';
  line-height: 0;
}
.report-page .report-logo:after {
  clear: both;
}
.report-page .report-logo img {
  float: left;
  min-height: 30px;
  display: block;
  max-height: 55px;
  max-width: 222px;
  width: auto;
  height: auto;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
.report-page .report-logo h2 {
  text-align: center;
  padding: 8px 3px;
  font-size: 18px;
  white-space: nowrap;
  overflow: hidden;
}
.report-page .report-logo-area {
  height: 60px;
  text-align: center;
}
.report-page .report-logo-area span {
  display: block;
  padding-top: 25px;
}
.report-page .report-body {
  height: 659px;
}
.report-page .report-sidebar-borderless {
  position: relative;
  height: 659px;
}
.report-page .report-sidebar {
  position: relative;
  height: 659px;
  border-radius: 3px;
  line-height: 1.3em;
}
.report-page .report-sidebar h3 {
  margin-top: 10px;
  font-size: 16px;
  font-weight: 600;
}
.report-page .report-sidebar dl {
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 1em;
  *zoom: 1;
}
.report-page .report-sidebar dl:before,
.report-page .report-sidebar dl:after {
  content: " ";
  display: table;
}
.report-page .report-sidebar dl:after {
  clear: both;
}
.report-page .report-sidebar dl:before,
.report-page .report-sidebar dl:after {
  display: table;
  content: '';
  line-height: 0;
}
.report-page .report-sidebar dl:after {
  clear: both;
}
.report-page .report-sidebar dl dt {
  float: left;
  font-weight: normal;
  max-width: 125px;
  min-width: 100px;
  margin-bottom: 6px;
  line-height: 18px;
  *zoom: 1;
}
.report-page .report-sidebar dl dt:before,
.report-page .report-sidebar dl dt:after {
  content: " ";
  display: table;
}
.report-page .report-sidebar dl dt:after {
  clear: both;
}
.report-page .report-sidebar dl dt:before,
.report-page .report-sidebar dl dt:after {
  display: table;
  content: '';
  line-height: 0;
}
.report-page .report-sidebar dl dt:after {
  clear: both;
}
.report-page .report-sidebar dl dd {
  float: right;
  margin-bottom: 6px;
  line-height: 18px;
}
.report-page .sidebar-header {
  padding: 12px;
  border-radius: 3px 3px 0 0;
}
.report-page .sidebar-header h3 {
  font-size: 14px;
  margin: 0;
  text-transform: uppercase;
  font-weight: 500;
}
.report-page .sidebar-body {
  position: relative;
  height: 100%;
}
.report-page .sidebar-body input[type='date'],
.report-page .sidebar-body input[type='time'],
.report-page .sidebar-body input[type='datetime-local'],
.report-page .sidebar-body input[type='month'] {
  line-height: 1.42;
}
.report-page .header-key-value {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.report-page .header-key-value .sidebar-label {
  font-size: 12px;
  line-height: 1.42;
  color: #fff;
  font-weight: 600;
}
.report-page .header-key-value .sidebar-value {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.42;
  color: #fff;
}
.report-page .sidebar-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 12px;
  font-size: 12px;
  line-height: 1.5;
  font-weight: 500;
  color: #333;
}
.report-page .sidebar-section p {
  font-size: 12px;
  line-height: 1.5;
  font-weight: 500;
  color: #333;
}
.report-page .sidebar-section.medium-font {
  font-size: 14px;
  line-height: 1.5;
}
.report-page .sidebar-section.medium-font p {
  font-size: 14px;
  line-height: 1.5;
}
.report-page .sidebar-section.small-font {
  font-size: 12px;
  line-height: 1.5;
}
.report-page .sidebar-section.small-font p {
  font-size: 12px;
  line-height: 1.5;
}
.report-page .sidebar-section.solid-separator {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.report-page .sidebar-section.dashed-separator {
  border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
}
.report-page .sidebar-section:last-child {
  border-bottom: none;
}
.report-page .sidebar-section-title {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.42;
  color: #111;
  margin: 8px 0 0 0;
}
.report-page .sidebar-section-title.medium-font {
  font-size: 14px;
}
.report-page .sidebar-key-value-container {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.report-page .solid-separator {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.report-page .dashed-separator {
  border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
}
.report-page .sidebar-key-value-horizontal {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 4px;
  padding: 6px 0;
}
.report-page .sidebar-key-value-horizontal .sidebar-label {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.42;
  color: #333;
  text-align: left;
}
.report-page .sidebar-key-value-horizontal .sidebar-value {
  font-size: 12px;
  font-weight: 700;
  line-height: 1.42;
  color: #111;
  text-align: right;
}
.report-page .sidebar-key-value-horizontal.solid-separator {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.report-page .sidebar-key-value-horizontal.solid-separator:last-child {
  border-bottom: none;
}
.report-page .sidebar-key-value-horizontal.dashed-separator {
  border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
}
.report-page .sidebar-key-value-horizontal.dashed-separator:last-child {
  border-bottom: none;
}
.report-page .sidebar-key-value-horizontal:first-child {
  padding-top: 0;
}
.report-page .sidebar-key-value-horizontal:last-child {
  padding-bottom: 0;
}
.report-page .sidebar-key-value-horizontal.reverse-order {
  flex-direction: row-reverse;
}
.report-page .sidebar-key-value-vertical {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 12px 0;
}
.report-page .sidebar-key-value-vertical .sidebar-label {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.42;
  color: #555;
}
.report-page .sidebar-key-value-vertical .sidebar-value {
  font-size: 20px;
  line-height: 1.42;
  color: #111;
  font-weight: 600;
}
.report-page .sidebar-key-value-vertical:first-child {
  padding-top: 0;
}
.report-page .sidebar-key-value-vertical:last-child {
  padding-bottom: 0;
}
.report-page .sidebar-key-value-vertical.solid-separator {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.report-page .sidebar-key-value-vertical.solid-separator:last-child {
  border-bottom: none;
}
.report-page .sidebar-key-value-vertical.dashed-separator {
  border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
}
.report-page .sidebar-key-value-vertical.dashed-separator:last-child {
  border-bottom: none;
}
.report-page .sidebar-key-value-vertical.reverse-order {
  flex-direction: column-reverse;
}
.report-page .sidebar-key-value-vertical.no-bottom-spacing {
  padding-bottom: 0;
}
.report-page .uppercase {
  text-transform: uppercase;
}
.report-page .report-sidebar-v2 {
  height: 659px;
  border-radius: 3px;
  position: relative;
}
.report-page .report-sidebar-v2--title {
  font-size: 16px;
  color: #000000;
  line-height: 1.5;
  font-weight: 600;
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 11px;
  padding-bottom: 12px;
  margin-bottom: 0;
}
.report-page .report-main {
  height: 659px;
  overflow: hidden;
}
.report-page .report-photo-row {
  border-radius: 3px;
}
.report-page .report-footer {
  *zoom: 1;
  padding-top: 10px;
  color: #797979;
  height: 35px;
  font-size: 12px;
}
.report-page .report-footer:before,
.report-page .report-footer:after {
  content: " ";
  display: table;
}
.report-page .report-footer:after {
  clear: both;
}
.report-page .report-footer:before,
.report-page .report-footer:after {
  display: table;
  content: '';
  line-height: 0;
}
.report-page .report-footer:after {
  clear: both;
}
.report-page .report-footer .program-logo-footer {
  max-height: 25px;
  width: auto;
  margin-left: 5px;
}
.report-page .recommendation-category-label {
  font-size: 15px;
  margin-bottom: 12px;
  color: rgba(0, 0, 0, 0.7);
  text-transform: uppercase;
}
.report-page .notes-header,
.report-page .now-and-goals-header {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.42;
  color: #555;
}
.report-page .upgrade-details-section {
  margin-top: 6px;
  padding-top: 6px;
}
.report-page.report-page-cover .report-body .report-main .snugg-upload-prompt-text {
  position: absolute;
  z-index: 3;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 150px;
  width: 160px;
  text-align: center;
  font-size: 24px;
  color: #777777;
  cursor: pointer;
}
.report-page.report-page-cover .report-body .report-main .uploadcare--widget__button.uploadcare--widget__button_type_open {
  display: none !important;
}
.report-page.report-page-cover .report-body .report-main .uploadcare-widget-disabled .ico-budicon-10 {
  height: 150px;
  width: 160px;
}
.report-page.report-page-cover .report-body .report-main .uploadcare-widget-disabled {
  display: block !important;
  width: 99.5%;
  height: 347px;
  font-size: 24px;
}
.report-page.report-page-cover .report-body .report-main .uploadcare--widget {
  display: block !important;
  width: 99.5%;
  height: 347px;
  font-size: 24px;
}
.report-page.report-page-cover .report-body .report-main .uploadcare--widget .uploadcare--widget__dragndrop-area {
  width: 100%;
  height: 100%;
  position: relative;
  border-radius: 0;
  padding: 0 !important;
  left: 0 !important;
  margin: 0;
  line-height: normal;
  padding: 0;
  top: 0;
  display: block;
  cursor: pointer;
}
.report-page.report-page-cover .report-body .report-main .uploadcare--widget.uploadcare--widget .uploadcare--widget__circle {
  display: none;
}
.report-page.report-page-cover .report-body .report-main .uploader-container {
  width: 99.5%;
  height: 347px;
  font-size: 24px;
}
.report-page .intro-cover .wysiwyg {
  height: 270px;
  border: 1px dashed #bbb;
}
.report-page .intro-cover .wysiwyg:focus {
  border: 1px solid #bbb;
}
.report-page.report-page-metrics h6 {
  font-size: 1em;
}
.report-page.report-page-hes .report-header {
  overflow: visible;
}
.report-page.report-page-hes .report-main {
  overflow: visible;
}
.report-page.report-page-hes .nav.nav-tabs li > a {
  padding: 10px 20px;
  font-size: 18px;
  font-weight: 600;
  color: #c84900;
}
.report-page.report-page-hes .nav.nav-tabs li.active > a {
  color: #333;
}
.report-page.report-page-hes .hes-home {
  padding-top: 30px;
  padding-left: 20px;
}
.report-page.report-page-hes .hes-home dt {
  font-size: 11px;
  color: #196234;
  text-transform: uppercase;
  width: 120px;
  padding-top: 3px;
  padding-right: 10px;
  font-weight: 600;
  float: left;
  clear: left;
}
.report-page.report-page-hes .hes-home dd {
  float: left;
  font-weight: 700;
  font-size: 15px;
}
.report-page.report-page-hes .hes-container {
  margin-top: 30px;
  margin-left: 20px;
  margin-right: 10px;
  padding: 90px 0 15px 85px;
  position: relative;
  border-bottom: 4px solid #223f74;
  *zoom: 1;
}
.report-page.report-page-hes .hes-container:before,
.report-page.report-page-hes .hes-container:after {
  content: " ";
  display: table;
}
.report-page.report-page-hes .hes-container:after {
  clear: both;
}
.report-page.report-page-hes .hes-container:before,
.report-page.report-page-hes .hes-container:after {
  display: table;
  content: '';
  line-height: 0;
}
.report-page.report-page-hes .hes-container:after {
  clear: both;
}
.report-page.report-page-hes .hes-legend {
  float: left;
  min-height: 60px;
  padding: 24px 5px 0;
  text-align: left;
  font-weight: 600;
  font-size: 12px;
}
.report-page.report-page-hes .hes-legend:last-child {
  text-align: left;
}
.report-page.report-page-hes .hes-spectrum {
  position: relative;
  float: left;
}
.report-page.report-page-hes .hes-spectrum ul {
  text-align: center;
  background: #d9d9d9;
  background: -moz-linear-gradient(left, #d9d9d9 0%, #cbd4bf 44%, #89c648 97%, #89c648 100%);
  background: -webkit-gradient(left top, right top, color-stop(0%, #d9d9d9), color-stop(44%, #cbd4bf), color-stop(97%, #89c648), color-stop(100%, #89c648));
  background: -webkit-linear-gradient(left, #d9d9d9 0%, #cbd4bf 44%, #89c648 97%, #89c648 100%);
  background: -o-linear-gradient(left, #d9d9d9 0%, #cbd4bf 44%, #89c648 97%, #89c648 100%);
  background: -ms-linear-gradient(left, #d9d9d9 0%, #cbd4bf 44%, #89c648 97%, #89c648 100%);
  background: linear-gradient(to right, #d9d9d9 0%, #cbd4bf 44%, #89c648 97%, #89c648 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#d9d9d9', endColorstr='#89c648', GradientType=1);
  display: inline-block;
  float: left;
  *zoom: 1;
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-weight: 700;
  font-size: 20px;
}
.report-page.report-page-hes .hes-spectrum ul:before,
.report-page.report-page-hes .hes-spectrum ul:after {
  content: " ";
  display: table;
}
.report-page.report-page-hes .hes-spectrum ul:after {
  clear: both;
}
.report-page.report-page-hes .hes-spectrum ul:before,
.report-page.report-page-hes .hes-spectrum ul:after {
  display: table;
  content: '';
  line-height: 0;
}
.report-page.report-page-hes .hes-spectrum ul:after {
  clear: both;
}
.report-page.report-page-hes .hes-spectrum ul li {
  padding: 35px 0;
  margin: 0;
  float: left;
  border-right: 3px solid white;
  box-sizing: border-box;
}
.report-page.report-page-hes .hes-spectrum ul li:last-child {
  border-right: none;
}
.report-page.report-page-hes .hes-definition {
  padding-left: 20px;
  padding-top: 15px;
  font-size: 0.85em;
}
.report-page.report-page-hes .hes-stats {
  margin-top: 15px;
  color: #959394;
  font-weight: 700;
  text-align: right;
  font-size: 10px;
}
.print-preview .report-page {
  zoom: 100%;
  margin: 8px auto 20px;
}
.print-preview.sample-job .report-page:after {
  content: 'Sample';
  position: absolute;
  z-index: 2;
  left: 20%;
  top: 30%;
  font-size: 180px;
  text-transform: uppercase;
  font-family: 'open sans', 'helvetica neue', helvetica, arial;
  -webkit-transform: rotate(-25deg);
  -moz-transform: rotate(-25deg);
  -ms-transform: rotate(-25deg);
  transform: rotate(-25deg);
  font-family: 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif;
  font-weight: 300;
  color: rgba(0, 0, 0, 0.24);
}
.discrete-navigation {
  color: #fff;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 3px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);
  opacity: 0.65;
  transition: all 0.2s ease;
}
.discrete-navigation:hover,
.discrete-navigation:focus,
.discrete-navigation:focus-within {
  opacity: 1;
}
.discrete-navigation .btn {
  font-size: 11px;
  text-align: 'center';
  line-height: 1em;
  background-color: transparent;
  border-radius: 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.35);
  display: block;
  width: 100%;
  color: #fff;
  padding: 12px 12px;
}
.discrete-navigation .btn:hover,
.discrete-navigation .btn:focus {
  background-color: rgba(0, 0, 0, 0.75);
}
.discrete-navigation .btn:active {
  color: #ff9003;
  background-color: #000000;
}
.discrete-navigation .btn:first-child {
  border-radius: 3px;
}
.discrete-navigation .btn:last-child {
  border-bottom: none;
  margin-bottom: 0;
  border-radius: 3px;
}
.discrete-navigation--right {
  position: fixed;
  right: 5px;
  top: 5px;
  z-index: 1000;
}
.discrete-navigation--left {
  position: fixed;
  left: 5px;
  top: 5px;
  z-index: 1000;
}
body {
  counter-reset: page;
}
.report-footer {
  counter-increment: page;
}
.pageNumber {
  float: right;
  padding-right: 50px;
}
.pageNumber:before {
  content: '– ' counter(page) ' –';
}
@media print {
  * {
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
  }
  body {
    background: none;
    background-image: none;
  }
  body .report-present {
    background: none;
    background-image: none;
    padding-top: 0;
  }
  .hidden-print {
    display: none !important;
  }
  a.print-link[href^='http'] {
    font-weight: 700;
    text-decoration: none;
  }
  a.print-link[href^='http']:after {
    content: ' <' attr(href) '> ';
  }
  .content {
    background-image: none !important;
    background: transparent !important;
    padding: none !important;
    margin: none !important;
    border: none !important;
  }
  .discrete-navigation {
    display: none !important;
  }
  .print-preview .report-page {
    padding: 0.3in 0.5in 0.2in;
    margin: 0 !important;
    border: none !important;
    width: auto !important;
    page-break-inside: avoid;
    page-break-after: always;
  }
  .print-preview .report-page:last-child {
    page-break-after: avoid;
  }
  .r-container {
    margin: 0 !important;
    padding: 0 !important;
    border: none;
    position: relative;
    opacity: 1;
  }
  .r-container img {
    max-width: 100% !important;
  }
  .r-container .cover-photo-replace,
  .r-container .cover-photo-upload {
    display: none;
  }
  .r-container .img-border {
    outline: 0;
  }
  .r-container .editor-area {
    border: none;
  }
  .r-container .editor-area:hover,
  .r-container .editor-area:focus {
    border: none;
    -webkit-box-shadow: none;
    box-shadow: none;
    outline: none;
  }
  .repaginate-report {
    display: none;
  }
}
@page {
  size: letter landscape;
  margin: 0mm;
}
/* Extra small devices (phones, less than 768px) */
/* No media query since this is the default in Bootstrap */
/* ONLY extra small devices (phones less than 768px) */
@media (max-width: 767px) {
  .rep-toolbar {
    border-bottom: 1px solid #d9d9d9;
  }
}
/* Small devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .content-header.content-header-report .rep-toolbar .rep-btn {
    max-width: 56px;
  }
  .content-header.content-header-report .rep-toolbar-title {
    width: 240px;
  }
  .content-header.content-header-report .rep-toolbar-page {
    width: 242px;
  }
}
/* Medium devices (desktops, 992px and up) */
@media (min-width: 992px) {
  .in-app-report .report-page {
    zoom: 85%;
  }
  .in-app-report .editable-page-header {
    margin-right: 20px;
    width: 821px;
  }
}
/* Large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .in-app-report .report-page {
    zoom: 100%;
  }
  .in-app-report .editable-page-header {
    margin-right: 20px;
    width: 965px;
  }
}
.img-polaroid {
  padding: 4px;
  background-color: #fff;
  border: 1px solid #ccc;
  border: 1px solid rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.cards {
  *zoom: 1;
  margin-bottom: 24px;
}
.cards:before,
.cards:after {
  content: " ";
  display: table;
}
.cards:after {
  clear: both;
}
.cards:before,
.cards:after {
  display: table;
  content: '';
  line-height: 0;
}
.cards:after {
  clear: both;
}
.cards .cards-row {
  *zoom: 1;
}
.cards .cards-row:before,
.cards .cards-row:after {
  content: " ";
  display: table;
}
.cards .cards-row:after {
  clear: both;
}
.cards .cards-row:before,
.cards .cards-row:after {
  display: table;
  content: '';
  line-height: 0;
}
.cards .cards-row:after {
  clear: both;
}
.cards .card {
  display: inline-block;
  vertical-align: bottom;
  width: 250px;
  margin-right: 20px;
  margin-top: 20px;
  float: left;
  border-radius: 4px;
  background-color: white;
  border: solid 1px #e2e2e2;
  color: inherit;
  position: relative;
}
.cards .card:after {
  content: '';
  position: absolute;
  z-index: -1;
  -webkit-box-shadow: 0 2px 8px rgba(48, 50, 50, 0.2);
  box-shadow: 0 2px 8px rgba(48, 50, 50, 0.2);
  bottom: 0;
  left: 10px;
  right: 10px;
  height: 50%;
  width: auto;
}
.cards .card:hover,
.cards .card:focus {
  transition: all 0.3s ease;
  -webkit-box-shadow: 0 2px 8px rgba(48, 50, 50, 0.2);
  box-shadow: 0 2px 8px rgba(48, 50, 50, 0.2);
}
.cards .card:hover:after,
.cards .card:focus:after {
  transition: all 0.3s ease;
  -webkit-box-shadow: 0 5px 12px rgba(48, 50, 50, 0.35);
  box-shadow: 0 5px 12px rgba(48, 50, 50, 0.35);
}
.cards .card:active:after {
  transition: none;
  -webkit-box-shadow: 0 12px 22px rgba(48, 50, 50, 0.2);
  box-shadow: 0 12px 22px rgba(48, 50, 50, 0.2);
}
.cards .card.card-fluid {
  width: 100%;
}
.cards .card table.table {
  margin-bottom: 3px;
}
.cards .card table.table tr:first-child td {
  border-top: none;
}
.cards .card table.table td {
  padding: 10px 3px;
}
.cards .card table.table td:nth-child(2) {
  text-align: right;
}
.cards .card table.table.table-striped td {
  border-color: #e3e3e3;
}
.cards .card ul {
  margin: 0;
  padding-left: 0;
}
.cards .card ul li {
  font-size: 0.9em;
  list-style-type: none;
  padding: 10px 3px;
  margin: 0 12px;
  border-bottom: 1px solid #ddd;
}
.cards .card ul li:last-child {
  border-bottom: none;
}
.cards .card ul li .value {
  float: right;
}
.cards .card.card-readonly:hover,
.cards .card.card-readonly:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.cards .card.card-readonly:hover:after,
.cards .card.card-readonly:focus:after {
  -webkit-box-shadow: 0 4px 12px rgba(48, 50, 50, 0.2);
  box-shadow: 0 4px 12px rgba(48, 50, 50, 0.2);
}
.cards .card.card-readonly:active:after {
  -webkit-box-shadow: 0 4px 12px rgba(48, 50, 50, 0.2);
  box-shadow: 0 4px 12px rgba(48, 50, 50, 0.2);
}
.cards .card.card-rec {
  position: relative;
  z-index: 1;
  margin-bottom: 10px;
  margin-top: 0;
  cursor: pointer;
}
.cards .card.card-rec:first-child {
  border-top-width: 1px;
}
.cards .card.card-rec:hover {
  z-index: 2;
  -webkit-box-shadow: 0 0 10px rgba(48, 50, 50, 0.3);
  box-shadow: 0 0 10px rgba(48, 50, 50, 0.3);
}
.cards .card.card-rec:active {
  z-index: 3;
  transition: none;
  -webkit-box-shadow: 0 1px 14px rgba(48, 50, 50, 0.4);
  box-shadow: 0 1px 14px rgba(48, 50, 50, 0.4);
}
.cards .card.card-rec:active:after {
  z-index: 4;
}
.cards .card .card-rec-header {
  background-color: #ededed;
  color: #595959;
  height: 65px;
}
.cards .card .card-header {
  *zoom: 1;
  display: block;
  position: relative;
  border-radius: 0 !important;
  padding: 15px 10px 15px 12px;
  background-color: #f2f2f2;
  text-align: left;
  color: #555555;
  max-width: 100%;
  font-size: 14px;
  letter-spacing: 0.02em;
  line-height: 1em;
  white-space: nowrap;
  font-weight: 600;
}
.cards .card .card-header:before,
.cards .card .card-header:after {
  content: " ";
  display: table;
}
.cards .card .card-header:after {
  clear: both;
}
.cards .card .card-header:before,
.cards .card .card-header:after {
  display: table;
  content: '';
  line-height: 0;
}
.cards .card .card-header:after {
  clear: both;
}
.cards .card .card-header [class*=' ico-'],
.cards .card .card-header [class^='ico-'] {
  display: block;
  background-color: inherit;
  margin-left: 8px;
  opacity: 0.7;
  float: right;
}
.cards .card a.card-header {
  color: inherit;
}
.cards .card a.card-header:hover {
  cursor: pointer;
  background: #e5e5e5;
}
.cards .card a.card-header:active {
  background: #dedede;
}
.cards .card .card-body {
  *zoom: 1;
  padding: 10px 8px;
}
.cards .card .card-body:before,
.cards .card .card-body:after {
  content: " ";
  display: table;
}
.cards .card .card-body:after {
  clear: both;
}
.cards .card .card-body:before,
.cards .card .card-body:after {
  display: table;
  content: '';
  line-height: 0;
}
.cards .card .card-body:after {
  clear: both;
}
.cards .card .card-footer {
  *zoom: 1;
  padding: 12px 10px 0px;
  background-color: #f2f2f2;
  position: relative;
}
.cards .card .card-footer:before,
.cards .card .card-footer:after {
  content: " ";
  display: table;
}
.cards .card .card-footer:after {
  clear: both;
}
.cards .card .card-footer:before,
.cards .card .card-footer:after {
  display: table;
  content: '';
  line-height: 0;
}
.cards .card .card-footer:after {
  clear: both;
}
.cards .card .card-footer .card-footer-content {
  float: left;
  max-width: 190px;
  max-height: 20px;
  margin-bottom: 10px;
  overflow: hidden;
}
.cards .card .card-footer .card-delete {
  display: inline;
  font-size: 16px;
  color: red;
  margin-left: 10px;
  margin-top: -10px;
  margin-right: -11px;
  border-radius: 0 0 6px 0;
  padding: 12px 15px;
}
.cards .card .card-footer .card-delete:hover {
  color: #fff;
  background-color: red;
}
.cards .card .card-footer .card-delete:active {
  color: #fff;
  background-color: #db0000;
}
.cards .card.card-calculator {
  float: none;
}
.cards .card.card-calculator .input-group-addon {
  padding: 6px;
}
/* Small devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .cards .card.card-rec {
    margin-bottom: 1px;
    border-radius: 0;
    border: none;
    background-color: #f2f2f2;
  }
  .cards .card.card-rec:nth-child(even) {
    background-color: #f7f7f7;
  }
  .cards .card.card-rec:first-child {
    border-radius: 6px 6px 0 0;
  }
  .cards .card.card-rec:last-child {
    border-radius: 0 0 6px 6px;
  }
  .cards .card .card-rec-header {
    background-color: inherit;
    text-align: inherit;
    color: inherit;
    height: auto;
  }
}
.alert {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  border-radius: 6px;
  margin: 10px 0;
  padding: 12px;
}
.alert .alert-style-container {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}
.alert h4 {
  font-size: 1em;
  color: inherit;
  font-weight: 600;
  margin: 0;
}
.alert p {
  margin-bottom: 10px;
}
.alert.alert-live {
  padding: 0;
  border-radius: 0;
  display: inline-block;
  width: auto;
  border: 0;
  margin: 5px 0;
}
.alert.alert-live.character-counter {
  display: inline;
}
.alert.alert-banner {
  padding: 5px;
  text-align: center;
  border-top-style: solid;
  margin: 0 -15px;
  font-size: 12px;
  border-radius: 0;
  z-index: 1064;
  position: fixed;
  bottom: 0;
  right: 0;
  width: auto;
  left: 15px;
  border-top: 1px solid #c9dade;
}
.alert.alert-banner .alert-message {
  padding-bottom: 0;
  text-align: center;
  color: #333;
}
.alert.alert-alert {
  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  min-width: 500px;
  min-height: 40px;
  margin: 4px 0 8px 0;
  border-radius: 6px;
  border: none;
  padding: 16px;
  box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
  max-width: 500px;
}
.alert.alert-alert .close {
  transition: all 200ms linear;
  font-size: 24px;
  font-weight: 300;
  opacity: 0.3;
  width: 24px;
  min-width: 24px;
  height: 24px;
  border-radius: 100%;
  background-color: #fff;
}
.alert.alert-alert .close:hover {
  background-color: #eee;
  opacity: 0.6;
}
@media (max-width: 575.98px) {
  .alert.alert-alert {
    min-width: auto;
    width: 90%;
  }
}
.alert.alert-alert.alert-success {
  background-color: #ffffff;
}
.alert.alert-alert.alert-warning {
  background-color: #ffffff;
}
.alert.alert-alert.alert-error {
  background-color: #ffffff;
}
.alert.alert-alert.alert-minimized {
  min-width: 200px;
  max-width: fit-content;
  position: relative;
  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
}
.alert.alert-inline {
  margin: 20px 0;
}
.alert.alert-inline .alert-message {
  padding-bottom: 0;
  color: #333;
}
.alert.alert-field {
  margin: 8px 0 8px 0;
  padding: 0;
  border: none;
  background: none;
  font-size: 12px;
}
.alert.alert-field .alert-message {
  padding-bottom: 0;
}
.alert.alert-field img {
  width: 14px;
}
.alert.alert-field .alert-style-container {
  gap: 6px;
}
.alert-content {
  width: 100%;
  margin-top: 2px;
  margin-bottom: 2px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.alert-job-id {
  margin-left: 10px;
  font-size: 0.8em;
  opacity: 0.8;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  padding: 0 5px;
  color: #333333;
}
.alert-job-id:hover {
  background-color: rgba(0, 0, 0, 0.2);
  color: black;
}
.alert-job-id:active {
  background-color: rgba(0, 0, 0, 0.5);
  color: #eeeeee;
}
.alert-message {
  display: block;
  color: #333;
  line-height: 1.5;
  font-weight: 500;
}
.alert.alert-header {
  margin: 0;
  border-radius: 0;
}
.alert-warning {
  background-color: #faf0cb;
  color: #333;
  border: 1px solid #e1d8b7;
}
.alert-warning .alert-title {
  color: #e38016;
}
.alert-error {
  background-color: #fdf5f4;
  color: #333;
  border-color: #f7d5d2;
  border-style: solid;
  border-width: 1px;
}
.alert-error h2,
.alert-error h3,
.alert-error h4,
.alert-error h5 {
  color: #d92d20;
}
.alert-error .alert-title {
  color: #d92d20;
}
.alert-success {
  background-color: #f3faf7;
  color: #333;
  border-color: #cdeadd;
  border-style: solid;
  border-width: 1px;
}
.alert-success .alert-title {
  color: #039855;
}
.alert-info {
  background-color: #f5f8ff;
  color: #333;
  border-color: #d7e3fd;
  border-style: solid;
  border-width: 1px;
}
.alert-info a {
  color: #144761;
  text-decoration: underline;
}
.alert-info .alert-title {
  color: #3875f6;
}
.alert-neutral {
  background-color: #f9f9f9;
  border-color: #eaeaea;
  box-shadow: inset 0 0 0 1px white;
  border-style: solid;
  border-width: 1px;
}
.alert-neutral a {
  color: #c84900;
}
.alert-internal {
  background-color: #28548a;
  color: white;
  padding: 20px;
  -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.6);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.6);
}
.alert-primary-button {
  width: auto;
  display: inline-block;
  box-shadow: none;
  padding: 8px 16px 9px;
  background: #2b2b2b;
  color: #fff;
  font-weight: 500;
  border: none;
  border-radius: 6px;
}
.alert-primary-button:hover {
  background: #333;
  color: white;
}
.alert-primary-button:active {
  background: #111;
}
.alert-secondary-button {
  width: auto;
  display: inline-block;
  box-shadow: none;
  padding: 8px 16px 9px;
  background: #2b2b2b;
  color: #fff;
  font-weight: 500;
  border: none;
  border-radius: 6px;
  margin-left: 8px;
  background: #fff;
  border: 1px solid #d0d5dd;
  color: #222;
}
.alert-secondary-button:hover {
  background: #333;
  color: white;
}
.alert-secondary-button:active {
  background: #111;
}
.alert-secondary-button:hover {
  background: #eee;
  color: #222;
}
.alert-secondary-button:active {
  background: #ddd;
}
/* Extra small devices (phones, less than 768px) */
/* No media query since this is the default in Bootstrap */
/* ONLY extra small devices (phones less than 768px) */
@media (max-width: 767px) {
  .push-left .alert.alert-alert {
    margin-left: 5px;
  }
  .form-control.input-header.rec-input-header {
    font-size: 15px;
    font-weight: 600;
    min-width: 255px;
  }
}
/* Small devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .alert.alert-alert {
    width: 500px;
  }
  .alert.alert-banner {
    left: 75px;
  }
}
/* Medium devices (desktops, 992px and up) */
/* ONLY extra short devices (phones less than 568px)  This is a fringe case*/
@media (max-height: 589px) and (max-width: 767px) {
  .push-left .side-left {
    -ms-transform: tranformX(0);
    transform: tranformX(0);
    -webkit-transform: tranformX(0);
    /** Chrome & Safari **/
    -o-transform: tranformX(0);
    /** Opera **/
    -moz-transform: tranformX(0);
    /** Firefox **/
  }
}
.DraftEditor-root .public-DraftEditorPlaceholder-inner {
  color: #888;
  position: absolute;
}
.DraftEditor-root .public-DraftEditor-content {
  min-height: 40px;
  padding-bottom: 5px;
}
.DraftEditor-root .public-DraftEditor-content:hover {
  background-color: #fdd39e;
}
.DraftEditor-root .public-DraftEditor-content:hover:focus {
  background-color: inherit;
}
.DraftEditor-root:focus .public-DraftEditorPlaceholder-inner {
  display: none;
}
.tickets-template .DraftEditor-root .public-DraftEditor-content {
  min-height: 80px;
}
.report-sidebar .DraftEditor-root .public-DraftEditor-content:hover {
  background-color: rgba(255, 255, 255, 0.85);
}
.draft-toolbar {
  background-color: #000;
  border: none;
  border-radius: 50px;
  font-size: 16px;
}
.draft-toolbar .item {
  float: left;
  list-style: none;
  margin: 0;
  padding: 0;
  background-color: #000;
}
.draft-toolbar .item:first-child {
  border-bottom-left-radius: 50px;
  border-top-left-radius: 50px;
  padding-left: 6px;
}
.draft-toolbar .item:last-child {
  border-bottom-right-radius: 50px;
  border-top-right-radius: 50px;
  padding-right: 6px;
}
.draft-toolbar .item.active {
  background-color: #2f2f2f;
}
.draft-toolbar .item:hover {
  background-color: #2f2f2f;
}
.draft-toolbar .item button {
  background-color: transparent;
  border: 0;
  color: white;
  box-sizing: border-box;
  cursor: pointer;
  display: block;
  font-size: 14px;
  line-height: 1.33;
  margin: 0;
  padding: 15px;
  text-decoration: none;
}
.TeXEditor-container {
  width: 100%;
  height: 100%;
}
.TeXEditor-root {
  background: inherit;
  -webkit-font-smoothing: antialiased;
}
.TeXEditor-editor {
  cursor: text;
  min-height: 40px;
}
.TeXEditor-button {
  margin-top: 10px;
  text-align: center;
}
.TeXEditor-handle {
  color: #62b1fe;
  direction: ltr;
  unicode-bidi: bidi-override;
}
.TeXEditor-hashtag {
  color: #5fb88a;
}
.TeXEditor-tex {
  background-color: #fff;
  cursor: pointer;
  margin: 20px auto;
  padding: 20px;
  -webkit-transition: background-color 0.2s fade-in-out;
  user-select: none;
  -webkit-user-select: none;
}
.TeXEditor-activeTeX {
  color: #888;
}
.TeXEditor-panel {
  font-family: 'Helvetica', sans-serif;
  font-weight: 200;
}
.TeXEditor-panel .TeXEditor-texValue {
  border: 1px solid #e1e1e1;
  display: block;
  font-family: 'Inconsolata', 'Menlo', monospace;
  font-size: 14px;
  height: 110px;
  margin: 20px auto 10px;
  outline: none;
  padding: 14px;
  resize: none;
  -webkit-box-sizing: border-box;
  width: 500px;
}
.TeXEditor-buttons {
  text-align: center;
}
.TeXEditor-saveButton,
.TeXEditor-removeButton {
  background-color: #fff;
  border: 1px solid #0a0;
  cursor: pointer;
  font-family: 'Helvetica', 'Arial', sans-serif;
  font-size: 16px;
  font-weight: 200;
  margin: 10px auto;
  padding: 6px;
  -webkit-border-radius: 3px;
  width: 100px;
}
.TeXEditor-removeButton {
  border-color: #aaa;
  color: #999;
  margin-left: 8px;
}
.TeXEditor-invalidButton {
  background-color: #eee;
  border-color: #a00;
  color: #666;
}
.TeXEditor-insert {
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  border-radius: 3px;
  bottom: 30px;
  position: fixed;
  right: 30px;
}
.TeXEditor-insert2 {
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  border-radius: 3px;
  bottom: 30px;
  position: fixed;
  right: 160px;
}
.TeXEditor-insert3 {
  background-color: #f1f1f1;
  border: 1px solid #ccc;
  border-radius: 3px;
  bottom: 30px;
  position: fixed;
  right: 300px;
}
.secondary-nav .filter-item-container {
  margin-left: 7px;
  margin-right: 7px;
  padding: 8px 5px 8px 10px;
  border-radius: 4px;
}
.secondary-nav .filter-item-container:hover {
  background-color: rgba(0, 0, 0, 0.05);
  cursor: pointer;
}
.secondary-nav .filter-item-container:active,
.secondary-nav .filter-item-container:focus {
  background-color: rgba(0, 0, 0, 0.08);
}
.secondary-nav .filter-item-container.checkbox-filter.checkbox-container {
  padding-left: 36px;
}
.secondary-nav .filter-item-container .checkmark {
  top: 10px;
  left: 10px;
}
.secondary-nav .radio-filter {
  position: relative;
}
.secondary-nav-link {
  color: #303232;
  font-size: 12px;
  padding-top: 10px;
  padding-right: 5px;
  padding-bottom: 10px;
  cursor: pointer;
  padding-left: 15px;
  letter-spacing: 0.025em;
  display: block;
  user-select: none;
  border-radius: 4px;
  margin-left: 7px;
  margin-right: 7px;
}
.secondary-nav-link:hover {
  background-color: rgba(255, 144, 3, 0.3);
  color: inherit;
}
.secondary-nav-link:hover .active-only {
  display: inline !important;
}
.secondary-nav-link:focus {
  color: #303232;
  outline: none;
  background-color: #e7e7e7;
}
.secondary-nav-link:active {
  color: #303232;
  outline: none;
  background-color: rgba(255, 144, 3, 0.45);
}
.secondary-nav-link .active-only {
  display: none !important;
}
.secondary-nav-link.active {
  background-color: rgba(255, 144, 3, 0.35);
  color: #000;
  text-shadow: 0 0 0 #000;
}
.secondary-nav-link.active:active,
.secondary-nav-link.active:focus {
  background-color: rgba(255, 144, 3, 0.35);
  color: #000;
  text-shadow: 0 0 0 #000;
}
.secondary-nav-link.active .active-only {
  display: inline !important;
}
.secondary-nav-scroll-link {
  color: #303232;
  font-size: 12px;
  cursor: pointer;
  letter-spacing: 0.025em;
  display: block;
  user-select: none;
  position: relative;
  min-height: 36px;
}
.secondary-nav-scroll-link > a {
  margin-left: 7px;
  margin-right: 7px;
  border-radius: 4px;
  color: #303232;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding-top: 10px;
  padding-right: 5px;
  padding-bottom: 10px;
  padding-left: 15px;
  display: block;
}
.secondary-nav-scroll-link > a:hover {
  background-color: rgba(255, 144, 3, 0.3);
  color: inherit;
}
.secondary-nav-scroll-link > a:focus {
  color: #303232;
  outline: none;
  background-color: #e7e7e7;
}
.secondary-nav-scroll-link > a:active {
  color: #303232;
  outline: none;
  background-color: rgba(255, 144, 3, 0.45);
}
.secondary-nav-scroll-link > a.active {
  background-color: rgba(255, 144, 3, 0.35);
  color: #000;
  text-shadow: 0 0 0 #000;
}
.secondary-nav-scroll-link > a.active:active,
.secondary-nav-scroll-link > a.active:focus {
  background-color: rgba(255, 144, 3, 0.35);
  color: #000;
  text-shadow: 0 0 0 #000;
}
.secondary-nav-scroll-link .secondary-actions {
  position: absolute;
  right: 7px;
  top: 0;
  bottom: 0;
}
.secondary-nav-scroll-link .secondary-actions .snugg-btn {
  text-align: center;
  display: inline-block;
  width: auto;
  opacity: 0.8;
  padding-top: 8px;
  padding-left: 6px;
  padding-right: 6px;
  padding-bottom: 0;
  border-radius: 0;
  height: 100%;
  border-radius: 0 4px 4px 0;
}
.secondary-nav-scroll-link > .reveal-on-hover {
  display: none;
}
.secondary-nav-scroll-link:hover > .reveal-on-hover {
  display: inline;
}
.draggable-item {
  transform: scale(1);
}
#tertiary-nav {
  padding: 0;
  height: 100%;
  border-right: 1px solid #ddd;
  width: 50%;
  float: right;
}
#tertiary-nav .tertiary-list {
  top: 46px;
}
#tertiary-nav .tertiary-nav-link {
  width: 100%;
  padding: 8px 10px 8px 10px;
  box-shadow: inset 0 -1px 0 0 #eeeeee;
  cursor: pointer;
}
#tertiary-nav .tertiary-nav-link:hover {
  background-color: #f2f2f2;
}
#tertiary-nav .tertiary-nav-link:active {
  background-color: #eeeeee;
}
.pane-content ul {
  padding-left: 20px;
  padding-top: 5px;
}
.pane-content ul li {
  margin-bottom: 5px;
}
.snugg-btn {
  user-select: none;
  -webkit-user-select: none;
  background-image: none;
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-style: solid;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
  display: block;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.42;
  outline: none;
  outline-offset: 0;
  padding-top: 6px;
  padding-right: 12px;
  padding-bottom: 6px;
  padding-left: 12px;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  width: 100%;
  touch-action: manipulation;
}
.snugg-btn:active {
  box-shadow: none;
}
.snugg-btn.snugg-btn-primaryNavigation {
  color: #dedede;
  background-color: #303232;
  text-shadow: 0 2px 6px #000000;
  border-radius: 0;
  margin: 0;
  padding-top: 6px;
  padding-right: 0;
  padding-bottom: 6px;
  min-height: 18px;
  padding-left: 0;
  font-weight: 400;
  font-size: 10px;
  width: 100%;
  letter-spacing: 0.05em;
  display: block;
  position: relative;
}
.snugg-btn.snugg-btn-primaryNavigation:hover {
  color: #fff;
  background-color: #3c3f3f;
}
.snugg-btn.snugg-btn-primaryNavigation:focus {
  background-color: #1f2020;
}
.snugg-btn.snugg-btn-primaryNavigation > i[class^='ico-budicon'],
.snugg-btn.snugg-btn-primaryNavigation i[class*=' ico-budicon'] {
  height: 18px;
  width: 24px;
  color: #dedede;
  font-family: snugg-6;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
  text-shadow: 0px 2px 5px #000000;
}
.snugg-btn.snugg-btn-primaryNavigation img {
  filter: invert(96%) sepia(0%) saturate(1%) hue-rotate(192deg) brightness(88%) contrast(88%);
}
.snugg-btn.snugg-btn-primaryNavigation:active,
.snugg-btn.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive {
  background-color: #1f2020;
  color: #ff9003;
}
.snugg-btn.snugg-btn-primaryNavigation:active > i[class^='ico-budicon'],
.snugg-btn.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive > i[class^='ico-budicon'],
.snugg-btn.snugg-btn-primaryNavigation:active i[class*=' ico-budicon'],
.snugg-btn.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive i[class*=' ico-budicon'] {
  color: #ff9003;
}
.snugg-btn.snugg-btn-primaryNavigation:active > img,
.snugg-btn.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive > img {
  filter: invert(74%) sepia(76%) saturate(3050%) hue-rotate(355deg) brightness(101%) contrast(110%);
}
.snugg-btn.snugg-btn-add-new-job {
  padding-top: 8px;
  padding-left: 20px;
  padding-right: 20px;
  height: 37px;
  font-weight: 600;
  font-size: 15px;
  border-radius: 30px;
  margin-top: 4px;
  margin-left: 10px;
  width: auto;
  display: inline-block;
  float: left;
}
@-webkit-keyframes hvr-pop {
  50% {
    -webkit-transform: scale(1.04);
    transform: scale(1.04);
  }
}
@keyframes hvr-pop {
  50% {
    -webkit-transform: scale(1.04);
    transform: scale(1.04);
  }
}
@-webkit-keyframes nrml-pop {
  50% {
    -webkit-transform: scale(1.025);
    transform: scale(1.025);
  }
}
@keyframes nrml-pop {
  50% {
    -webkit-transform: scale(1.025);
    transform: scale(1.025);
  }
}
.snugg-btn.snugg-btn-unassigned-jobs {
  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  padding-left: 14px;
  padding-right: 14px;
  height: 35px;
  font-size: 15px;
  border-radius: 30px;
  margin-top: 8px;
  margin-right: 8px;
  width: 100%;
  float: left;
  background: #fffaf5 !important;
  background: linear-gradient(0deg, #fffcfa 0%, #fff0e6 51%, #fffcfa 100%) !important;
  background-size: auto 200% !important;
  box-shadow: inset 0px 1px 0px 0px rgba(255, 255, 255, 0.7);
  border: 1px solid #fbcfa5;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 142%;
  color: #f56600 !important;
  transform: perspective(1px) translateZ(0);
  -webkit-animation-name: nrml-pop;
  animation-name: nrml-pop;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
}
.snugg-btn.snugg-btn-unassigned-jobs:hover,
.snugg-btn.snugg-btn-unassigned-jobs:focus,
.snugg-btn.snugg-btn-unassigned-jobs:active {
  background-position: bottom !important;
  -webkit-animation-name: hvr-pop;
  animation-name: hvr-pop;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
}
.snugg-btn.snugg-btn-sm {
  padding-top: 5px;
  padding-right: 10px;
  padding-bottom: 5px;
  padding-left: 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 6px;
}
.snugg-btn.snugg-btn-md {
  padding-top: 11px;
  padding-right: 18px;
  padding-bottom: 11px;
  padding-left: 18px;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 6px;
  letter-spacing: 0.02em;
}
.snugg-btn.snugg-btn-lg {
  font-size: 15px;
  padding-top: 14px;
  padding-right: 18px;
  padding-bottom: 14px;
  padding-left: 18px;
}
.snugg-btn.snugg-btn-light {
  background: #f9f9f9;
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.05) 95%);
  color: #222;
  border: 1px solid #ddd;
}
.snugg-btn.snugg-btn-light:hover {
  color: #000;
  background: #f9f9f9;
  background-image: linear-gradient(202deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.07) 79%);
}
.snugg-btn.snugg-btn-light:active {
  color: #000;
  background: #f9f9f9;
}
.snugg-btn.snugg-btn-dark {
  background: #303232;
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.05) 79%);
  color: #f2f2f2;
}
.snugg-btn.snugg-btn-dark:hover {
  color: #fff;
  background-image: linear-gradient(202deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.07) 79%);
}
.snugg-btn.snugg-btn-dark:active {
  color: #fff;
  background: #171818;
  background-image: linear-gradient(202deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.07) 79%);
}
.snugg-btn.snugg-btn-collectionAdd {
  color: #3c2a14;
  border-style: dashed;
  background-color: #fef5e9;
  border-color: #f3c78f;
}
.snugg-btn.snugg-btn-collectionAdd:hover {
  background-color: #ffdfb5;
  border-color: #edb061;
}
.snugg-btn.snugg-btn-collectionAdd:active {
  background-color: #f7b767;
  border-color: #cf7400;
}
.snugg-btn.snugg-btn-yellow {
  position: relative;
  cursor: pointer;
  color: #303232;
  background: #fdda52;
  background-image: linear-gradient(202deg, #fdda52 0%, #fdde66 100% 79%);
  -webkit-transition: 200ms;
  /* Safari prior 6.1 */
  transition: 200ms;
  border: none;
}
.snugg-btn.snugg-btn-yellow:hover,
.snugg-btn.snugg-btn-yellow:focus {
  background: #fde175;
  background-image: linear-gradient(202deg, #fddf6b 9%, #fde37f 79%);
  color: #303232;
}
.snugg-btn.snugg-btn-yellow.active,
.snugg-btn.snugg-btn-yellow:active,
.open > .dropdown-toggle.snugg-btn.snugg-btn-yellow {
  background-color: #fccf20;
  background-image: linear-gradient(202deg, #fdd748 9%, #fddc5c 79%);
  color: #303232;
}
.snugg-btn.snugg-btn-yellow:active,
.snugg-btn.snugg-btn-yellow.active,
.open > .dropdown-toggle.snugg-btn.snugg-btn-yellow {
  background-image: none;
}
.snugg-btn.snugg-btn-yellow:before {
  display: block;
  position: absolute;
  padding-top: 10px;
  top: 10px;
}
.snugg-btn.snugg-btn-yellow.disabled,
.snugg-btn.snugg-btn-yellow[disabled],
fieldset[disabled] .snugg-btn.snugg-btn-yellow,
.snugg-btn.snugg-btn-yellow.disabled:hover,
.snugg-btn.snugg-btn-yellow[disabled]:hover,
fieldset[disabled] .snugg-btn.snugg-btn-yellow:hover,
.snugg-btn.snugg-btn-yellow.disabled:focus,
.snugg-btn.snugg-btn-yellow[disabled]:focus,
fieldset[disabled] .snugg-btn.snugg-btn-yellow:focus,
.snugg-btn.snugg-btn-yellow.disabled:active,
.snugg-btn.snugg-btn-yellow[disabled]:active,
fieldset[disabled] .snugg-btn.snugg-btn-yellow:active,
.snugg-btn.snugg-btn-yellow.disabled.active,
.snugg-btn.snugg-btn-yellow[disabled].active,
fieldset[disabled] .snugg-btn.snugg-btn-yellow.active {
  background-color: #fdda52;
  border-color: #fdde66;
}
.snugg-btn.snugg-btn-yellow .badge {
  color: #fdda52;
  background-color: #303232;
}
.snugg-btn.snugg-btn-orange {
  background: #ff7f00;
  border: none;
  background-image: linear-gradient(10deg, #f96b00 0%, #ffb100 100% 100%);
  color: #fff;
  font-weight: 600;
}
.snugg-btn.snugg-btn-orange:hover {
  background-image: linear-gradient(10deg, #f47516 0%, #ffbc22 100% 100%);
  color: #fff;
}
.snugg-btn.snugg-btn-orange:active,
.snugg-btn.snugg-btn-orange:focus {
  background: #ff7f00;
  background-image: linear-gradient(10deg, #e26202 0%, #ffb000 100% 100%);
  color: #fff;
}
.snugg-btn.snugg-btn-orange.disabled,
.snugg-btn.snugg-btn-orange[disabled] {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
}
.snugg-btn.snugg-btn-link {
  background-color: inherit;
  display: inline-block;
  color: #c84900;
}
.snugg-btn.snugg-btn-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.snugg-btn.snugg-btn-link:focus {
  background-color: rgba(0, 0, 0, 0.05);
}
.snugg-btn.snugg-btn-link:active {
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: none;
}
.snugg-btn.snugg-btn-discrete {
  background-color: inherit;
  display: inline-block;
  color: inherit;
}
.snugg-btn.snugg-btn-discrete:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.snugg-btn.snugg-btn-discrete:focus {
  background-color: rgba(0, 0, 0, 0.05);
}
.snugg-btn.snugg-btn-discrete:active {
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: none;
}
.snugg-btn.snugg-btn-delete {
  background-color: inherit;
  color: #333;
}
.snugg-btn.snugg-btn-delete:hover {
  background-color: #ff0000;
  color: #ffffff;
}
.snugg-btn.snugg-btn-delete:active {
  background-color: #b30000;
  color: #ffffff;
}
.snugg-btn.snugg-btn-rounded {
  background: #fff5e9;
  color: #c84900;
  box-shadow: 0 0 0 1px rgba(251, 207, 165, 0.5);
  border-radius: 50px;
  transition: all 200ms ease-in-out;
}
.snugg-btn.snugg-btn-rounded:hover {
  background: #ffedd5;
  box-shadow: 0 0 0 1px rgba(251, 207, 165, 0.7);
}
.snugg-btn.snugg-btn-rounded:active {
  background: #ffedd5;
  box-shadow: 0 0 0 1px rgba(251, 207, 165, 0.7);
}
.modal-footer .snugg-btn {
  border: none;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.02em;
  border-radius: 0 0 4px 4px;
}
.modal-footer .snugg-btn.snugg-btn-yellow {
  background-image: linear-gradient(15deg, #ff9003 50%, #fdde6645 90% 79%);
  color: #fff;
}
@media (min-height: 590px) {
  .snugg-btn.snugg-btn-primaryNavigation {
    min-height: 55px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
}
/* Small devices (tablets, 768px and up) */
@media (min-width: 768px) {
  .snugg-btn.snugg-btn-add-new-job {
    float: right;
  }
  .snugg-btn.snugg-btn-unassigned-jobs {
    width: auto;
    margin-top: 5px;
  }
}
/* Customize the label (the container) */
.checkbox-container {
  display: block;
  position: relative;
  padding-left: 28px;
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 0;
  cursor: pointer;
  font-weight: inherit;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  /* Hide the browser's default checkbox */
  /* Create a custom checkbox */
  /* On mouse-over, add a grey background color */
  /* When the checkbox is checked, add a blue background */
  /* Show the checkmark when checked */
  /* Style the checkmark/indicator */
}
.checkbox-container.checkbox-container-no-label {
  padding-left: 0;
}
.checkbox-container:hover .checkmark:after,
.checkbox-container:focus-within .checkmark:after {
  display: block;
}
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkbox-container .checkmark {
  position: absolute;
  top: 2px;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: #eee;
  border-radius: 3px;
  /* Create the checkmark/indicator (hidden when not checked) */
}
.checkbox-container .checkmark:after {
  content: '';
  position: absolute;
  display: none;
}
.checkbox-container:hover input ~ .checkmark,
.checkbox-container:focus-within input ~ .checkmark {
  background-color: #ccc;
}
.checkbox-container input:checked ~ .checkmark {
  background-color: #ff9003;
}
.checkbox-container input:disabled ~ .checkmark {
  background-color: #777777;
}
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}
.checkbox-container .checkmark:after {
  left: 6px;
  top: 3px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
.checkbox-fix {
  width: 16px;
  height: 16px;
  display: inline-block;
}
.Select .Select-menu-outer {
  padding: 0 5px;
  border-radius: 0 0 4px 4px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.14);
}
.Select .Select-menu-outer .Select-menu .Select-option {
  border-radius: 4px;
}
#tickets-container {
  font-size: 16px;
}
#tickets-container #main-pane {
  padding-bottom: 180px;
}
#tickets-container .ticket-file-block {
  max-width: 235px;
  display: inline-block;
}
#tickets-container .ticket-file-block .no-file-cannot-modify {
  position: relative;
  height: 175px;
  width: 235px;
  background-color: #f9f9f9;
  border-radius: 6px;
  border: 1px solid #f9f9f9;
  font-size: 16px;
  color: #777777;
}
#tickets-container .ticket-file-block .no-file-cannot-modify .no-file-label {
  text-align: center;
  height: 60px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
#tickets-container .ticket-file-block .ticket-file-preview {
  transition: all ease-in-out 0.2s;
}
#tickets-container .ticket-file-block .ticket-file-preview img {
  border-radius: 6px;
}
#tickets-container .ticket-file-block .ticket-file-preview:hover {
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.15);
}
#tickets-container .ticket-file-block .ticket-file-preview:active,
#tickets-container .ticket-file-block .ticket-file-preview:focus {
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.15);
  transform: scale(1.05);
}
#tickets-container .ticket-file-block .ticket-file-is-image {
  width: 235px;
  height: 175px;
  display: inline-block;
  margin-right: 9px;
  overflow: hidden;
  border: 1px solid #cccccc;
  border-radius: 6px;
  position: relative;
}
#tickets-container .ticket-file-block .ticket-file-is-image img {
  height: 175px;
  width: 235px;
  position: relative;
  z-index: 2;
}
#tickets-container .ticket-file-block .ticket-file-is-not-image {
  height: 175px;
  width: 235px;
  background-color: white;
  position: relative;
  border-radius: 6px;
  border: 1px solid #cccccc;
  font-size: 16px;
  cursor: pointer;
}
#tickets-container .ticket-file-image--loader {
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  text-align: center;
  font-size: 12px;
  background-color: #f9f9f9;
  border: 1px dashed #ccc;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: #777;
  gap: 8px;
}
#tickets-container .uploader-container {
  width: 235px;
  height: 175px;
  margin-bottom: 0;
  border-radius: 6px;
}
#tickets-container .uploadcare--widget .uploadcare--widget__dragndrop-area {
  height: 175px;
  border-radius: 6px;
  border: 1px dashed #ccc;
}
#tickets-container .uploadcare--widget .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: fit-content;
  font-size: 12px;
  line-height: 1.1;
  color: #777;
}
.ticket-file-modal-nav {
  height: 60vh !important;
  top: 0;
  text-shadow: 0 0 10px #000;
  cursor: pointer;
  width: 74px;
  color: #fff;
  font-size: 60px;
  position: absolute;
  line-height: 122px;
  z-index: 1;
}
.ticket-file-modal-nav.ticket-file-modal-nav--left {
  left: 0;
  border-radius: 0 8px 8px 0;
}
.ticket-file-modal-nav.ticket-file-modal-nav--left:hover {
  background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0));
}
.ticket-file-modal-nav.ticket-file-modal-nav--left:active:hover {
  background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.1));
}
.ticket-file-modal-nav.ticket-file-modal-nav--right {
  right: 0;
  border-radius: 8px 0 0 8px;
}
.ticket-file-modal-nav.ticket-file-modal-nav--right:hover {
  background-image: linear-gradient(270deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0));
}
.ticket-file-modal-nav.ticket-file-modal-nav--right:active:hover {
  background-image: linear-gradient(270deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.1));
}
.geolocation-placeholder-wrapper {
  height: 60vh;
  overflow: auto;
  text-align: center;
}
.geolocation-image-wrapper {
  height: 60vh;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.geolocation-image-preview {
  max-height: 60vh;
  max-width: 100%;
  display: inline;
}
.ticket-file-modal-body .uploadcare--widget .uploadcare--widget__dragndrop-area {
  height: 60vh;
  display: flex;
  max-height: 560px;
}
.ticket-file-modal-body .uploadcare--widget .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text {
  font-size: 26px;
  letter-spacing: 0;
  line-height: 48px;
}
.ticket-file-modal-body .no-file-cannot-modify {
  position: relative;
  height: 60vh;
  overflow: auto;
  text-align: center;
  background-color: #f9f9f9;
  border-radius: 6px;
  border: 1px solid #f9f9f9;
  font-size: 36px;
  color: #777777;
}
.ticket-file-modal-body .no-file-cannot-modify .no-file-label {
  text-align: center;
  height: 100px;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
#tickets-status-mutton {
  user-select: none;
  -webkit-user-select: none;
  background-image: none;
  border-top-width: 1px;
  border-right-width: 1px;
  border-bottom-width: 1px;
  border-left-width: 1px;
  border-style: solid;
  border-top-color: transparent;
  border-right-color: transparent;
  border-bottom-color: transparent;
  border-left-color: transparent;
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
  display: block;
  font-size: 14px;
  line-height: 1.42;
  outline: none;
  outline-offset: 0;
  padding-top: 6px;
  padding-right: 12px;
  padding-bottom: 6px;
  padding-left: 12px;
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;
  touch-action: manipulation;
  background: #ff7f00;
  border: none;
  background-image: linear-gradient(10deg, #f96b00 0%, #ffb100 100% 100%);
  color: #fff;
  font-weight: 600;
  height: 40px;
  float: right;
  display: inline-block;
  max-width: 260px;
  min-width: 220px;
  width: 100%;
}
#tickets-status-mutton:active {
  box-shadow: none;
}
#tickets-status-mutton.snugg-btn-primaryNavigation {
  color: #dedede;
  background-color: #303232;
  text-shadow: 0 2px 6px #000000;
  border-radius: 0;
  margin: 0;
  padding-top: 6px;
  padding-right: 0;
  padding-bottom: 6px;
  min-height: 18px;
  padding-left: 0;
  font-weight: 400;
  font-size: 10px;
  width: 100%;
  letter-spacing: 0.05em;
  display: block;
  position: relative;
}
#tickets-status-mutton.snugg-btn-primaryNavigation:hover {
  color: #fff;
  background-color: #3c3f3f;
}
#tickets-status-mutton.snugg-btn-primaryNavigation:focus {
  background-color: #1f2020;
}
#tickets-status-mutton.snugg-btn-primaryNavigation > i[class^='ico-budicon'],
#tickets-status-mutton.snugg-btn-primaryNavigation i[class*=' ico-budicon'] {
  height: 18px;
  width: 24px;
  color: #dedede;
  font-family: snugg-6;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 18px;
  text-align: center;
  text-shadow: 0px 2px 5px #000000;
}
#tickets-status-mutton.snugg-btn-primaryNavigation img {
  filter: invert(96%) sepia(0%) saturate(1%) hue-rotate(192deg) brightness(88%) contrast(88%);
}
#tickets-status-mutton.snugg-btn-primaryNavigation:active,
#tickets-status-mutton.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive {
  background-color: #1f2020;
  color: #ff9003;
}
#tickets-status-mutton.snugg-btn-primaryNavigation:active > i[class^='ico-budicon'],
#tickets-status-mutton.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive > i[class^='ico-budicon'],
#tickets-status-mutton.snugg-btn-primaryNavigation:active i[class*=' ico-budicon'],
#tickets-status-mutton.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive i[class*=' ico-budicon'] {
  color: #ff9003;
}
#tickets-status-mutton.snugg-btn-primaryNavigation:active > img,
#tickets-status-mutton.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive > img {
  filter: invert(74%) sepia(76%) saturate(3050%) hue-rotate(355deg) brightness(101%) contrast(110%);
}
#tickets-status-mutton.snugg-btn-add-new-job {
  padding-top: 8px;
  padding-left: 20px;
  padding-right: 20px;
  height: 37px;
  font-weight: 600;
  font-size: 15px;
  border-radius: 30px;
  margin-top: 4px;
  margin-left: 10px;
  width: auto;
  display: inline-block;
  float: left;
}
@-webkit-keyframes hvr-pop {
  50% {
    -webkit-transform: scale(1.04);
    transform: scale(1.04);
  }
}
@keyframes hvr-pop {
  50% {
    -webkit-transform: scale(1.04);
    transform: scale(1.04);
  }
}
@-webkit-keyframes nrml-pop {
  50% {
    -webkit-transform: scale(1.025);
    transform: scale(1.025);
  }
}
@keyframes nrml-pop {
  50% {
    -webkit-transform: scale(1.025);
    transform: scale(1.025);
  }
}
#tickets-status-mutton.snugg-btn-unassigned-jobs {
  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);
  padding-left: 14px;
  padding-right: 14px;
  height: 35px;
  font-size: 15px;
  border-radius: 30px;
  margin-top: 8px;
  margin-right: 8px;
  width: 100%;
  float: left;
  background: #fffaf5 !important;
  background: linear-gradient(0deg, #fffcfa 0%, #fff0e6 51%, #fffcfa 100%) !important;
  background-size: auto 200% !important;
  box-shadow: inset 0px 1px 0px 0px rgba(255, 255, 255, 0.7);
  border: 1px solid #fbcfa5;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 142%;
  color: #f56600 !important;
  transform: perspective(1px) translateZ(0);
  -webkit-animation-name: nrml-pop;
  animation-name: nrml-pop;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
}
#tickets-status-mutton.snugg-btn-unassigned-jobs:hover,
#tickets-status-mutton.snugg-btn-unassigned-jobs:focus,
#tickets-status-mutton.snugg-btn-unassigned-jobs:active {
  background-position: bottom !important;
  -webkit-animation-name: hvr-pop;
  animation-name: hvr-pop;
  -webkit-animation-duration: 0.3s;
  animation-duration: 0.3s;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-iteration-count: 1;
  animation-iteration-count: 1;
}
#tickets-status-mutton.snugg-btn-sm {
  padding-top: 5px;
  padding-right: 10px;
  padding-bottom: 5px;
  padding-left: 10px;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 6px;
}
#tickets-status-mutton.snugg-btn-md {
  padding-top: 11px;
  padding-right: 18px;
  padding-bottom: 11px;
  padding-left: 18px;
  font-size: 14px;
  line-height: 1.5;
  border-radius: 6px;
  letter-spacing: 0.02em;
}
#tickets-status-mutton.snugg-btn-lg {
  font-size: 15px;
  padding-top: 14px;
  padding-right: 18px;
  padding-bottom: 14px;
  padding-left: 18px;
}
#tickets-status-mutton.snugg-btn-light {
  background: #f9f9f9;
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.05) 95%);
  color: #222;
  border: 1px solid #ddd;
}
#tickets-status-mutton.snugg-btn-light:hover {
  color: #000;
  background: #f9f9f9;
  background-image: linear-gradient(202deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.07) 79%);
}
#tickets-status-mutton.snugg-btn-light:active {
  color: #000;
  background: #f9f9f9;
}
#tickets-status-mutton.snugg-btn-dark {
  background: #303232;
  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.05) 79%);
  color: #f2f2f2;
}
#tickets-status-mutton.snugg-btn-dark:hover {
  color: #fff;
  background-image: linear-gradient(202deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.07) 79%);
}
#tickets-status-mutton.snugg-btn-dark:active {
  color: #fff;
  background: #171818;
  background-image: linear-gradient(202deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.07) 79%);
}
#tickets-status-mutton.snugg-btn-collectionAdd {
  color: #3c2a14;
  border-style: dashed;
  background-color: #fef5e9;
  border-color: #f3c78f;
}
#tickets-status-mutton.snugg-btn-collectionAdd:hover {
  background-color: #ffdfb5;
  border-color: #edb061;
}
#tickets-status-mutton.snugg-btn-collectionAdd:active {
  background-color: #f7b767;
  border-color: #cf7400;
}
#tickets-status-mutton.snugg-btn-yellow {
  position: relative;
  cursor: pointer;
  color: #303232;
  background: #fdda52;
  background-image: linear-gradient(202deg, #fdda52 0%, #fdde66 100% 79%);
  -webkit-transition: 200ms;
  /* Safari prior 6.1 */
  transition: 200ms;
  border: none;
}
#tickets-status-mutton.snugg-btn-yellow:hover,
#tickets-status-mutton.snugg-btn-yellow:focus {
  background: #fde175;
  background-image: linear-gradient(202deg, #fddf6b 9%, #fde37f 79%);
  color: #303232;
}
#tickets-status-mutton.snugg-btn-yellow.active,
#tickets-status-mutton.snugg-btn-yellow:active,
.open > .dropdown-toggle#tickets-status-mutton.snugg-btn-yellow {
  background-color: #fccf20;
  background-image: linear-gradient(202deg, #fdd748 9%, #fddc5c 79%);
  color: #303232;
}
#tickets-status-mutton.snugg-btn-yellow:active,
#tickets-status-mutton.snugg-btn-yellow.active,
.open > .dropdown-toggle#tickets-status-mutton.snugg-btn-yellow {
  background-image: none;
}
#tickets-status-mutton.snugg-btn-yellow:before {
  display: block;
  position: absolute;
  padding-top: 10px;
  top: 10px;
}
#tickets-status-mutton.snugg-btn-yellow.disabled,
#tickets-status-mutton.snugg-btn-yellow[disabled],
fieldset[disabled] #tickets-status-mutton.snugg-btn-yellow,
#tickets-status-mutton.snugg-btn-yellow.disabled:hover,
#tickets-status-mutton.snugg-btn-yellow[disabled]:hover,
fieldset[disabled] #tickets-status-mutton.snugg-btn-yellow:hover,
#tickets-status-mutton.snugg-btn-yellow.disabled:focus,
#tickets-status-mutton.snugg-btn-yellow[disabled]:focus,
fieldset[disabled] #tickets-status-mutton.snugg-btn-yellow:focus,
#tickets-status-mutton.snugg-btn-yellow.disabled:active,
#tickets-status-mutton.snugg-btn-yellow[disabled]:active,
fieldset[disabled] #tickets-status-mutton.snugg-btn-yellow:active,
#tickets-status-mutton.snugg-btn-yellow.disabled.active,
#tickets-status-mutton.snugg-btn-yellow[disabled].active,
fieldset[disabled] #tickets-status-mutton.snugg-btn-yellow.active {
  background-color: #fdda52;
  border-color: #fdde66;
}
#tickets-status-mutton.snugg-btn-yellow .badge {
  color: #fdda52;
  background-color: #303232;
}
#tickets-status-mutton.snugg-btn-orange {
  background: #ff7f00;
  border: none;
  background-image: linear-gradient(10deg, #f96b00 0%, #ffb100 100% 100%);
  color: #fff;
  font-weight: 600;
}
#tickets-status-mutton.snugg-btn-orange:hover {
  background-image: linear-gradient(10deg, #f47516 0%, #ffbc22 100% 100%);
  color: #fff;
}
#tickets-status-mutton.snugg-btn-orange:active,
#tickets-status-mutton.snugg-btn-orange:focus {
  background: #ff7f00;
  background-image: linear-gradient(10deg, #e26202 0%, #ffb000 100% 100%);
  color: #fff;
}
#tickets-status-mutton.snugg-btn-orange.disabled,
#tickets-status-mutton.snugg-btn-orange[disabled] {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
}
#tickets-status-mutton.snugg-btn-link {
  background-color: inherit;
  display: inline-block;
  color: #c84900;
}
#tickets-status-mutton.snugg-btn-link:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
#tickets-status-mutton.snugg-btn-link:focus {
  background-color: rgba(0, 0, 0, 0.05);
}
#tickets-status-mutton.snugg-btn-link:active {
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: none;
}
#tickets-status-mutton.snugg-btn-discrete {
  background-color: inherit;
  display: inline-block;
  color: inherit;
}
#tickets-status-mutton.snugg-btn-discrete:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
#tickets-status-mutton.snugg-btn-discrete:focus {
  background-color: rgba(0, 0, 0, 0.05);
}
#tickets-status-mutton.snugg-btn-discrete:active {
  background-color: rgba(0, 0, 0, 0.1);
  box-shadow: none;
}
#tickets-status-mutton.snugg-btn-delete {
  background-color: inherit;
  color: #333;
}
#tickets-status-mutton.snugg-btn-delete:hover {
  background-color: #ff0000;
  color: #ffffff;
}
#tickets-status-mutton.snugg-btn-delete:active {
  background-color: #b30000;
  color: #ffffff;
}
#tickets-status-mutton.snugg-btn-rounded {
  background: #fff5e9;
  color: #c84900;
  box-shadow: 0 0 0 1px rgba(251, 207, 165, 0.5);
  border-radius: 50px;
  transition: all 200ms ease-in-out;
}
#tickets-status-mutton.snugg-btn-rounded:hover {
  background: #ffedd5;
  box-shadow: 0 0 0 1px rgba(251, 207, 165, 0.7);
}
#tickets-status-mutton.snugg-btn-rounded:active {
  background: #ffedd5;
  box-shadow: 0 0 0 1px rgba(251, 207, 165, 0.7);
}
#tickets-status-mutton:hover {
  background-image: linear-gradient(10deg, #f47516 0%, #ffbc22 100% 100%);
  color: #fff;
}
#tickets-status-mutton:active,
#tickets-status-mutton:focus {
  background: #ff7f00;
  background-image: linear-gradient(10deg, #e26202 0%, #ffb000 100% 100%);
  color: #fff;
}
#tickets-status-mutton.disabled,
#tickets-status-mutton[disabled] {
  color: #777777 !important;
  background-color: #eeeeee !important;
  background-image: none !important;
  opacity: 0.8 !important;
  cursor: not-allowed;
  border-color: transparent !important;
  box-shadow: none !important;
}
#tickets-status-mutton > div {
  float: left;
  display: inline-block;
}
.mutton-dropdown-menu {
  padding: 8px;
}
.mutton-dropdown-menu li {
  border-radius: 4px;
  padding: 10px 20px;
}
.mutton-dropdown-menu li:hover {
  background-color: #f2f2f2;
}
.mutton-dropdown-menu li:active {
  background-color: #cccccc;
}
.mutton-dropdown-menu li.active {
  background-color: #eeeeee;
  color: #000;
}
.ticket-view {
  padding-top: 20px;
}
.ticket-view .tab-content > .tab-pane,
.ticket-view .pill-content > .pill-pane {
  padding: 0 2px;
}
.workflow-pane {
  padding: 0 10px;
}
.workflow-pane--ticket-list {
  position: relative;
  margin-bottom: 20px;
}
.workflow-pane--ticket-list .workflow-pane--continuity-line {
  position: absolute;
  top: 20px;
  bottom: 20px;
  left: 30px;
  right: auto;
  width: 1px;
  border-right: dashed #777777 1px;
  z-index: 0;
}
.workflow-pane--ticket-link {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-content: stretch;
  align-items: center;
  border-radius: 4px;
  padding: 10px 12px 10px 12px;
  margin-bottom: 4px;
  cursor: pointer;
  transition: background 0.15s ease-in-out;
}
.workflow-pane--ticket-link:hover,
.workflow-pane--ticket-link:focus {
  background-color: #f4f4f4;
}
.workflow-pane--ticket-link:active {
  background-color: #eee;
}
.workflow-pane--ticket-link.workflow-pane--ticket-link--template {
  border: 1px solid #f2f2f2;
  background-color: #f9f9f9;
}
.workflow-pane--ticket-link.workflow-pane--ticket-link--template:hover,
.workflow-pane--ticket-link.workflow-pane--ticket-link--template:focus {
  background-color: #f2f2f2;
}
.workflow-pane--ticket-link.workflow-pane--ticket-link--template:hover .workflow-ticket-icon-container,
.workflow-pane--ticket-link.workflow-pane--ticket-link--template:focus .workflow-ticket-icon-container {
  background-color: #e3e3e3;
}
.workflow-pane--ticket-link.workflow-pane--ticket-link--template:active {
  background-color: #eee;
}
.workflow-pane--ticket-details {
  max-width: 89%;
  flex-grow: 2;
  padding: 0 10px;
}
.workflow-pane--ticket-title {
  font-size: 1em;
  font-weight: 600;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 2px;
}
.workflow-pane--ticket-metadata,
.workflow-pane--ticket-heading {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-content: stretch;
  align-items: stretch;
}
.workflow-pane--ticket-created-by {
  font-size: 0.9em;
  color: #222222;
}
.workflow-pane--ticket-time {
  font-size: 0.8em;
  line-height: 16px;
  color: #555555;
}
.workflow-ticket-icon-container {
  border-radius: 20em;
  height: 36px;
  width: 36px;
  flex-shrink: 0;
  position: relative;
}
.workflow-pane--ticket-icon {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  left: 0;
  right: 0;
  width: 17px;
  height: 17px;
  font-size: 17px;
  line-height: 1;
}
.workflow-ticket-icon-container.workflow-status-icon--workflowTemplate {
  background-color: #eeeeee;
  color: #555555;
}
.workflow-ticket-icon-container.workflow-status-icon--workflowDraft {
  background-color: #faedb7;
  color: #967804;
}
.workflow-ticket-icon-container.workflow-status-icon--workflowSubmitted,
.workflow-ticket-icon-container.workflow-status-icon--workflowChangesRequested {
  background-color: #daf0fd;
  color: #196188;
}
.workflow-ticket-icon-container.workflow-status-icon--workflowClosedResolved {
  background-color: #c0f5c8;
  color: #0a6117;
}
.workflow-ticket-icon-container.workflow-status-icon--workflowClosedUnresolved {
  background-color: #fddeda;
  color: #922513;
}
.workflow-ticket-icon-container.workflow-status-icon--workflowClosedUnresolved .workflow-pane--ticket-icon {
  top: 2px;
}
.ticket-file-display-area {
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 90px;
  width: 90px;
  border-radius: 20em;
  background-color: #f2f2f2;
  color: #555555;
}
.ticket-file-extension {
  border-radius: 4px;
  font-size: 14px;
  background: #fa611b;
  color: white;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 20px;
  margin: auto;
  height: 1.4em;
  line-height: 1.4em;
  max-width: 46px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
@media (min-width: 768px) {
  #tickets-container #main-pane {
    padding-left: 30px;
  }
}
@media (min-width: 992px) {
  .geolocation-placeholder-wrapper {
    height: 70vh;
  }
  .geolocation-image-wrapper {
    height: 70vh;
  }
  .geolocation-image-preview {
    max-height: 70vh;
  }
}
.pane-job-snapshots * {
  pointer-events: all;
}
.snapshot-footer-banner {
  width: calc(100% - 60px) !important;
  box-shadow: 0 -2px 32px 0 rgba(0, 0, 0, 0.24);
}
.snapshot-footer-banner .alert-style-container {
  padding-left: 16px;
  padding-right: 16px;
}
.snapshot-footer-banner p {
  font-size: 13px;
  line-height: 1.42;
  margin-bottom: 0;
  color: #555;
}
.snapshot-footer-banner p span {
  color: #111;
}
@media (max-width: 768px) {
  .snapshot-footer-banner {
    width: auto !important;
  }
}
.snapshot-footer-banner.alert .alert-style-container {
  align-items: center;
}
.snapshot-footer-banner .alert-content > div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: baseline;
}
.custom-dropdown li {
  margin-bottom: 2px !important;
}
.custom-dropdown li:last-child {
  margin-bottom: 0;
}
.custom-dropdown li a {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 8px 12px;
  font-size: 14px;
  line-height: 1.42;
  color: #111;
  font-weight: 600;
}
.custom-dropdown li a span {
  font-size: 12px;
  color: #777;
  display: inline-block;
  font-weight: 500;
}
.custom-dropdown li.active {
  background-color: #fff5e9;
}
.custom-dropdown li.active a {
  background-color: #fff5e9;
  color: #f56600;
}
.custom-dropdown li.active a span {
  color: #555;
}
.custom-dropdown li.active a:hover {
  color: #f56600;
  background-color: #feecd6;
}
.custom-dropdown .dropdown-icon {
  margin-left: 8px;
  margin-top: -4px;
  width: 16px;
  height: 16px;
  transition: all 200ms linear;
}
.custom-dropdown .dropdown-icon.rotated {
  transform: rotate(-180deg);
}
.custom-dropdown button span {
  transition: all 150ms ease;
}
.custom-dropdown:hover button span {
  color: #f56600;
}
.snapshot-custom-dropdown ul {
  width: auto;
  padding: 8px !important;
  overflow: hidden;
}
.snapshot-custom-dropdown li {
  margin: 0 !important;
}
.snapshot-custom-dropdown li a {
  font-weight: normal;
}
.snapshot-custom-dropdown .divider {
  margin: 2px !important;
}
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(0.9);
    opacity: 0.75;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
/* ===================== INCENTIVES CSS =====================*/
.geo-photos-section {
  position: relative;
}
.geo-photos-grid {
  box-shadow: none;
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
}
.geo-photo-title-container {
  display: flex;
  gap: 4px;
  justify-content: space-between;
  align-items: flex-start;
}
.geo-photo-category-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  border-bottom: 1px solid #eee;
  padding-bottom: 32px;
  margin-bottom: 24px;
}
.geo-photo-category-container:last-of-type {
  border-bottom: none;
  padding-bottom: 16px;
  margin-bottom: 0px;
}
.geo-photo-file-block-inner {
  width: 235px;
  height: 175px;
  justify-content: center;
  align-items: center;
  margin-right: 8px;
  position: relative;
}
.geo-photo-file-block-inner:hover .incentives-photo-delete-button {
  bottom: 10px;
  opacity: 1;
}
.incentives-photo-delete-button {
  position: absolute;
  bottom: 0;
  opacity: 0;
  z-index: 5;
  margin-left: 50%;
  transform: translateX(-50%);
  transition: all 150ms ease-in-out;
}
.incentives-photo-delete-button button {
  width: 44px;
  height: 44px;
  background-color: rgba(255, 255, 255, 0.8) !important;
  border-radius: 6px;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.04);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 200ms ease-in-out;
}
.incentives-photo-delete-button button:hover {
  background-color: #ffffff !important;
  transform: scale(1.05);
}
.geotagging-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background-color: #039855;
  border-radius: 20px;
  box-shadow: inset 0 1px 2px 0 rgba(255, 255, 255, 0.1);
  border: 1px solid #039855;
  font-size: 9px;
  line-height: 140%;
  text-align: center;
  color: #fff;
  letter-spacing: 0.5px;
  padding: 2px 8px;
  position: absolute;
  z-index: 3;
  top: 8px;
  right: 8px;
  pointer-events: none;
}
.geo-photo-category-title {
  font-size: 16px !important;
  font-weight: 600 !important;
  line-height: 1.42 !important;
  letter-spacing: 0.3px !important;
  text-transform: uppercase !important;
  color: #555 !important;
  padding: 0 !important;
}
.geo-photo-file-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.42;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.geo-photo-badge-style {
  margin-left: 0px !important;
  margin-top: 3px !important;
  font-size: 9px !important;
  padding: 2px 4px !important;
  display: inline-table !important;
}
#tickets-container .geo-photo-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.uploadcare-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}
.uploadcare-icon-container .plus-text {
  font-size: 1.6em;
  font-weight: 700;
  line-height: 142%;
  text-align: center;
  color: #777;
  padding-left: 8px;
}
.geolocation-data-container {
  width: 100%;
}
.geolocation-data-vertical {
  background-color: #f9f9f9;
  border: 1px solid #eee;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  width: 100%;
}
.geolocation-data-vertical .geolocation-data-set {
  display: flex;
  gap: 4px;
  font-size: 12px;
  line-height: 1.42;
  color: #333;
  font-weight: 600;
  padding: 4px 8px;
  border-bottom: 1px solid #eee;
}
.geolocation-data-vertical .geolocation-data-set:last-child {
  border-bottom: none;
}
.geolocation-data-vertical .geolocation-data-set span {
  font-weight: 500;
}
.geolocation-data-horizontal {
  background-color: #f9f9f9;
  border: 1px solid #eee;
  border-radius: 6px;
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 8px 4px;
  gap: 6px;
}
.geolocation-data-horizontal .geolocation-data-set {
  display: flex;
  gap: 4px;
  font-size: 12px;
  line-height: 1.42;
  color: #333;
  font-weight: 600;
  padding: 4px 8px;
  border-bottom: 1px solid #eee;
}
.geolocation-data-horizontal .geolocation-data-set:last-child {
  border-bottom: none;
}
.geolocation-data-horizontal .geolocation-data-set span {
  font-weight: 500;
}
.geolocation-data-horizontal .geolocation-data-set {
  border-right: none;
  border-bottom: 1px solid #eee;
  padding: 4px 8px;
}
.geolocation-data-horizontal .geolocation-data-set:last-child {
  border-right: none;
}
.photo-notes {
  font-size: 14px !important;
  padding: 12px !important;
  resize: vertical;
  transition: all 200ms ease-in-out;
  min-height: 30px;
  max-height: 80px;
  field-sizing: content;
  border: 1px solid #e6e6e6 !important;
}
.photo-notes:focus,
.photo-notes:focus-within,
.photo-notes:active {
  min-height: 80px;
  border: 1px solid #ccc !important;
}
.modal-footer-action-container {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0;
  flex: 1;
}
.undo-delete-action {
  position: absolute;
  bottom: 1px;
  left: 1px;
  right: 1px;
  padding: 10px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.42;
  color: #d92d20;
  border-top: 1px solid #e6e6e6;
  transition: all 150ms ease-in-out;
  border-radius: 0 0 6px 6px;
}
.undo-delete-action span {
  transition: all 200ms ease-in-out;
  display: flex;
  gap: 6px;
  align-items: center;
}
.undo-delete-action:hover {
  background-color: #f2f2f2;
}
.undo-delete-action:hover span {
  transform: scale(1.1);
}
.undo-delete-modal {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.42;
  color: #d92d20;
  cursor: pointer;
}
.undo-delete-modal span {
  display: flex;
  align-items: center;
  gap: 12px;
  transition: all 200ms ease-in-out;
}
.undo-delete-modal:hover span {
  transform: scale(1.1);
}
.ticket-file-modal-footer {
  height: auto;
  padding: 24px 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
/* ================================================================
    ERROR STATES
================================================================ */
.no-camera-location {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.42;
  text-align: center;
  color: #555;
  padding: 8px 40px 56px;
}
.no-camera-location h2,
.no-camera-location p {
  margin: 0;
  padding: 0;
}
.no-camera-location h2 {
  font-size: 22px;
  line-height: 1.42;
  text-align: center;
  color: #111;
  font-weight: 600;
}
.no-camera-location p {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.42;
  text-align: center;
  color: #555;
}
.no-camera-location a {
  text-decoration: none;
  color: #c84900;
}
.no-camera-location .camera-location-error-icons {
  display: flex;
  gap: 4px;
  margin-bottom: 8px;
}
/* ================================================================
    MEDIA QUERIES
================================================================ */
@media (min-width: 992px) {
  .ticket-file-modal-footer {
    height: 92px;
    padding: 0 25px;
    flex-direction: row;
  }
  .geolocation-data-container {
    width: auto;
  }
  .geolocation-data-vertical {
    width: auto;
  }
  .geolocation-data-horizontal {
    flex-direction: row;
    width: auto;
  }
  .geolocation-data-horizontal .geolocation-data-set {
    border-bottom: none;
    border-right: 1px solid #eee;
  }
}
.incentives-edit-icon {
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 3px 3px -1.5px rgba(0, 0, 0, 0.02), 0 6px 6px -3px rgba(0, 0, 0, 0.02), 0 12px 12px -6px rgba(0, 0, 0, 0.02);
  transition: all 200ms ease-in-out;
  position: absolute;
  right: 22px;
  top: 41px;
  z-index: 10;
}
.incentives-edit-icon i {
  transition: all 200ms ease-in-out;
}
.incentives-edit-icon:hover {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 3px 3px 0 rgba(0, 0, 0, 0.02), 0 6px 6px 0 rgba(0, 0, 0, 0.02), 0 12px 12px 0 rgba(0, 0, 0, 0.02);
  transform: scale(1.05);
}
.incentives-edit-icon:hover i {
  color: #c84900;
}
/* ==================================================================  
    INCENTIVES REPORT CLASSES 
================================================================== */
.work-order-incentives-total {
  border: 1px solid #f2f2f2;
  border-radius: 6px;
  padding: 12px 0;
  display: flex;
  gap: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 1.42;
  color: #777;
  text-align: left;
}
.work-order-incentives-total span {
  font-size: 18px;
  line-height: 1.42;
  display: block;
  color: #111;
}
.work-order-incentives-total > div {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0 16px;
  border-right: 1px solid #e6e6e6;
}
.work-order-incentives-total > div:last-child {
  border-right: 0;
  padding-right: 4px;
}
.solutions-available-incentives {
  border: 1px solid rgba(52, 86, 73, 0.1);
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 12px;
  position: relative;
  overflow: hidden;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.42;
  color: #222;
}
.solutions-available-incentives span {
  display: block;
  font-size: 24px;
  line-height: 1.42;
  font-weight: 600;
}
.solutions-available-incentives::before {
  display: block;
  content: '';
  width: 100px;
  height: 100px;
  z-index: 10;
  position: absolute;
  right: 24px;
  top: -22px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  mix-blend-mode: luminosity;
}
.incentives-report-title-section {
  display: flex;
  flex-direction: column;
  gap: 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.42;
  color: #555;
}
.incentives-report-title-section span {
  padding: 0 4px;
  display: inline-block;
}
.incentives-report-title-section h1 {
  margin: 0;
  line-height: 1.2;
  font-size: 18px;
  padding-top: 4px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.key-value-container {
  background-color: #f9f9f9;
  border: 1px solid #e6e6e6;
  border-radius: 6px;
  padding: 12px 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.42;
  color: #111;
  display: flex;
}
.key-value-container div {
  padding-left: 24px;
  padding-right: 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  border-right: 1px solid #e6e6e6;
}
.key-value-container div:first-child {
  padding-left: 16px;
}
.key-value-container div:last-child {
  padding-right: 16px;
  border-right: none;
}
.key-value-container span {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.42;
  color: #777;
}
.key-value-container a {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.42;
  color: #c84900;
  display: inline;
}
.key-value-container a:hover {
  text-decoration: underline;
}
.key-value-container p {
  margin: 0;
  padding: 0;
}
.incentives-description-section {
  margin-top: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.7;
  color: #333;
}
.incentives-description-section h2 {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.42;
  color: #333;
  margin-bottom: 8px;
}
.incentives-description-section ul {
  padding-left: 16px;
}
.incentives-description-section ul,
.incentives-description-section li {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.7;
  color: #333;
}
/* ============= POTENTIAL INCENTIVES TABLE ============= */
.table-potential-incentives {
  border: none;
  font-size: 13px;
  line-height: 1.42;
  font-weight: 600;
  color: #111;
  page-break-inside: avoid;
  margin-bottom: 0;
}
.table-potential-incentives tr {
  page-break-inside: avoid;
  break-inside: avoid;
}
.table-potential-incentives td {
  border-top: 1px solid #eee !important;
  padding: 6px 12px !important;
  vertical-align: middle !important;
}
.table-potential-incentives thead th {
  font-size: 12px;
  font-weight: 700;
  line-height: 142%;
  color: #555;
  padding: 8px 12px !important;
  border-bottom: 2px solid #e6e6e6;
}
.table-potential-incentives .table-section-row {
  background-color: #f7f7f7;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.42;
  color: #555;
}
.table-potential-incentives .table-section-row td {
  border-bottom: 1px solid #eee !important;
  border-top: 1px solid #eee !important;
  padding: 3px 12px !important;
  letter-spacing: 0.2px;
}
.table-potential-incentives .table-incentive-name {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  color: #111;
}
.table-potential-incentives .table-incentive-name span {
  font-size: 11px;
  line-height: 1.3;
  color: #656565;
  display: block;
  font-weight: 500;
}
.table-potential-incentives .table-total-row {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.42;
  color: #111;
}
.potential-incentives-wrapper {
  page-break-inside: avoid;
  break-inside: avoid;
}
.table-style-2 thead th {
  font-size: 12px;
  font-weight: 700;
  line-height: 142%;
  color: #555;
  padding: 8px 12px !important;
  border-bottom: 2px solid #eee;
}
.table-style-2 tbody tr td {
  border-bottom: 1px dashed #eee;
  border-top: none !important;
}
.table-style-2 .table-section-category {
  font-size: 12px;
  font-weight: 600;
  line-height: 1.42;
  color: #656565;
}
.table-style-2 .table-section-category td {
  padding: 20px 8px 4px !important;
  border-bottom: none !important;
  border-top: none !important;
}
.table-style-2 .table-incentive-name {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.3;
  color: #111;
}
.table-style-2 .table-incentive-name span {
  font-size: 11px;
  line-height: 1.3;
  color: #656565;
  display: block;
  font-weight: 500;
}
.table-style-2 .table-total-row {
  font-size: 16px;
  font-weight: 700;
  line-height: 1.42;
  color: #111;
}
.table-style-2 .table-total-row td {
  border-bottom: none !important;
  padding-top: 12px;
  padding-bottom: 12px;
}
/* INCENTIVES DETAILS TABLE ROW */
.row-subheader {
  background-color: #f9f9f9;
  font-weight: bold;
}
/* ===================== BPI 2400 CSS =====================*/
.bpi-2400-container {
  border: 1px solid #e6e6e6;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  background-color: #fff;
  padding: 24px 16px;
  border-radius: 6px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
}
.bpi-2400-status-icon {
  height: 48px;
  width: 48px;
}
.bpi-2400-status.success {
  color: #039855;
}
.bpi-2400-status.error {
  color: #d92d20;
}
.bpi-2400-status.unavailable {
  color: #656565;
}
.bpi-2400-date-time {
  font-size: 12px;
  font-weight: 400;
  line-height: 1.42;
  color: #656565;
  margin-bottom: 0;
}
.bpi-2400-button-container {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}
.bpi-2400-button-container .primary-button {
  border: none;
  width: auto;
  padding: 6px 10px;
  color: #c84900;
  transition: all 250ms ease-in-out;
}
.bpi-2400-button-container .secondary-button {
  border: 1px solid rgba(200, 73, 0, 0.15);
  width: auto;
  padding: 6px 10px;
  color: #c84900;
  transition: all 250ms ease-in-out;
  background-color: #fff;
}
.bpi-2400-button-container .secondary-button:hover {
  border: 1px solid rgba(200, 73, 0, 0.15);
}
/* ===================== ALTERNATIVE METHOD CSS =====================*/
.alternative-method-card-container {
  background-color: #f2f2f2;
  border-radius: 6px;
}
.alternative-method-card-container .alternative-method-card-header {
  padding: 6px 16px 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.42;
  letter-spacing: 0.5px;
  text-align: left;
  color: #777;
}
/* ===================== HES MODAL CSS =====================*/
.hes-modal .hes-savings {
  background-color: #f7f7f7;
  border: 1px solid #eee;
  border-radius: 6px;
  padding: 6px 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 1.42;
  color: #555;
}
.hes-modal .hes-savings span {
  color: #7cad3e;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.42;
}
.hes-modal .no-intial-score {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-direction: column;
  padding-top: 16px;
  padding-bottom: 40px;
}
.hes-modal .no-alt-final-score {
  text-align: center;
  position: absolute;
  margin-left: 50%;
  transform: translateX(-50%);
  bottom: -90px;
}
.hes-modal .hes-container {
  margin-top: 0;
  margin-left: 0;
  margin-right: 0;
  padding: 120px 0;
  position: relative;
  display: flex;
  align-items: center;
  gap: 2px;
}
.hes-modal .hes-legend {
  min-height: 60px;
  padding: 2px 5px 0;
  text-align: left;
  font-weight: 600;
  font-size: 12px;
}
.hes-modal .hes-legend:last-child {
  text-align: left;
}
.hes-modal .hes-spectrum {
  position: relative;
}
.hes-modal .hes-spectrum ul {
  text-align: center;
  background: #d9d9d9;
  background: linear-gradient(to right, #d9d9d9 0%, #cbd4bf 44%, #89c648 97%, #89c648 100%);
  display: flex;
  gap: 2px;
  list-style-type: none;
  padding: 0;
  margin: 0;
  font-weight: 700;
  font-size: 20px;
}
.hes-modal .hes-spectrum ul li {
  padding: 12px 0;
  margin: 0;
  border-right: 3px solid white;
  box-sizing: border-box;
}
.hes-modal .hes-spectrum ul li:last-child {
  border-right: none;
}
.checklist-settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.checklist-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.import-checklist-box {
  padding: 64px;
  background-color: #fff;
  border: 1px dashed #ccc;
  border-radius: 6px;
  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
}
.import-checklist-box .text-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
}
.import-checklist-box h2 {
  font-size: 16px;
  font-weight: 600;
  color: #111;
  margin: 0;
}
.import-checklist-box span {
  display: block;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.8;
  color: #777;
  text-align: center;
}
.download-sample-file {
  display: flex;
  justify-content: flex-end;
  padding-top: 8px;
}
.compare-category .compare-question-container:last-child .compare-linestyle {
  display: none;
}
.compare-category-text {
  margin: 0 0 16px 0;
  padding: 8px 12px;
  font-size: 18px;
  line-height: 1.42;
  color: #000;
  background-color: #f7f7f7;
}
.compare-question {
  font-weight: 600;
  font-size: 14px;
  line-height: 1.42;
  color: #111111;
  text-align: right;
  padding: 6px 4px;
}
.compare-question span {
  font-weight: 600;
  font-size: 12px;
  line-height: 1.42;
  color: #777777;
  display: block;
}
.compare-linestyle {
  border-top: 1px solid #eee;
  margin: 0 0 16px 0;
}
.checklist-questions-category {
  font-size: 20px;
  font-weight: 600;
  color: #111;
  margin-top: 32px;
  margin-bottom: 12px;
}
.checklist-questions-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.checklist-questions-container .checklist-question {
  padding: 12px;
  background-color: #f9f9f9;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.42;
  color: #777;
  font-weight: 600;
  display: flex;
  gap: 8px;
}
.checklist-questions-container .checklist-question .question {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
}
.checklist-questions-container .checklist-question .question span {
  font-size: 12px;
  font-weight: 600;
  color: #777;
}
.checklist-questions-container .checklist-question .question-number {
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  padding-left: 12px;
}
.checklist-questions-container .checklist-question .question-number span {
  font-size: 12px;
  font-weight: 600;
  color: #777;
}
.checklist-questions-container .checklist-question .checklist-question-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.checklist-questions-container .checklist-question .checklist-question-content > span {
  display: block;
}
.checklist-empty-state {
  padding: 80px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
}
.checklist-empty-state .checklist-empty-state__text {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 8px;
}
.checklist-empty-state h2 {
  font-size: 16px;
  line-height: 1.42;
  font-weight: 700;
  color: #111;
  margin: 0;
}
.checklist-empty-state p {
  font-size: 14px;
  line-height: 1.42;
  font-weight: 500;
  color: #777;
  text-align: center;
}
.checklist-archived-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 24px;
}
.checklist-archived-section .checklist-archived-date {
  padding: 4px 8px;
  background-color: #eee;
  font-size: 14px;
  font-weight: 600;
  color: #2b2b2b;
  border-radius: 6px;
}
.checklist-archived-section .checklist-archived-question-container {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  border-bottom: 1px solid #eee;
  font-weight: 600;
  font-size: 14px;
  color: #2b2b2b;
  transition: all 200ms ease-in-out;
}
.checklist-archived-section .checklist-archived-question-container:last-child {
  border-bottom: none;
}
.checklist-archived-section .checklist-archived-question-container:hover {
  background-color: #f2f2f2;
}
.checklist-archived-section .checklist-archived-question-container .checklist-archived-answer {
  display: block;
  font-size: 16px;
  font-weight: 700;
}
.report-branding-setting .report-branding-settings-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.report-branding-setting .report-branding-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.report-branding-setting .theme-section {
  margin-bottom: 40px;
}
.report-branding-setting .theme-section .section-title {
  font-weight: 600;
  margin-top: 0;
  margin-bottom: 16px;
  color: #777;
  font-size: 14px;
}
.report-branding-setting .theme-list-container {
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 24px;
  align-self: stretch;
  flex-wrap: wrap;
}
.report-branding-setting .theme-card {
  width: 160px;
  padding: 16px 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 3px 3px -1.5px rgba(0, 0, 0, 0.02), 0 6px 6px -3px rgba(0, 0, 0, 0.02), 0 12px 12px -6px rgba(0, 0, 0, 0.02);
  transition: all 200ms ease-in-out;
  cursor: pointer;
}
.report-branding-setting .theme-card:hover {
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08), 0 3px 3px -1.5px rgba(0, 0, 0, 0.04), 0 6px 6px -3px rgba(0, 0, 0, 0.04), 0 12px 12px -6px rgba(0, 0, 0, 0.04);
}
.report-branding-setting .theme-card:active {
  transform: scale(0.97);
}
.report-branding-setting .theme-card .theme-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.42;
  color: #2b2b2b;
}
.report-branding-setting .theme-card .theme-card-header .more-options {
  min-width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  background-color: transparent;
  transition: background 200ms ease-in-out;
  padding: 0 1px 0 0;
}
.report-branding-setting .theme-card .theme-card-header .more-options:hover {
  background: #f0f0f0;
}
.report-branding-setting .theme-card .theme-card-header .more-options i {
  transform: rotate(90deg) !important;
  line-height: 1;
  color: #777;
}
.report-branding-setting .theme-card.custom-theme {
  width: 274px;
  gap: 32px;
}
.report-branding-setting .theme-card .theme-color-block {
  width: 80px;
  height: 48px;
  border-radius: 6px;
  display: flex;
  overflow: hidden;
  border: 1px solid #000;
}
.report-branding-setting .theme-card .theme-color-block div {
  height: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  line-height: 1.42;
  font-weight: 600;
  text-align: center;
}
.report-branding-setting .create-theme-action {
  width: 274px;
  height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  border-radius: 12px;
  border: 1px dashed #ccc;
  background: #fff;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.42;
  color: #777777;
  cursor: pointer;
  transition: all 150ms ease-in-out;
}
.report-branding-setting .create-theme-action:hover {
  border-color: #999;
  background: #f9f9f9;
}
.report-branding-setting .create-theme-action:active {
  transform: scale(0.98);
}
.report-branding-setting .report-branding-custom-dropdown {
  width: 30px;
  height: 30px;
}
.report-branding-setting .report-branding-custom-dropdown ul {
  width: auto;
  padding: 6px !important;
  overflow: hidden;
}
.report-branding-setting .report-branding-custom-dropdown li {
  margin: 0 !important;
}
.report-branding-setting .report-branding-custom-dropdown li a {
  font-weight: normal;
}
.report-branding-setting .report-branding-custom-dropdown .divider {
  margin: 2px !important;
}
.report-branding-setting .colors-input-section {
  margin-bottom: 12px;
}
.report-branding-setting .colors-input-section-title {
  font-size: 14px;
  font-weight: 600;
  color: #777;
  margin-bottom: 12px;
  margin-top: 0;
}
.report-branding-setting .colors-input-container {
  display: flex;
  gap: 8px;
}
.report-branding-setting .auto-gererate-container {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
}
.report-preview-page {
  width: 1005px;
  height: 816px;
  padding: 30px;
  background-color: #fff;
  box-shadow: 0 0 0 0.979px rgba(0, 0, 0, 0.06), 0 3px 3px -1.5px rgba(0, 0, 0, 0.02), 0 6px 6px -3px rgba(0, 0, 0, 0.02), 0 0 12px 8px rgba(0, 0, 0, 0.02);
  border-radius: 6px;
  border: none;
  transform-origin: top left;
  transform: scale(0.7);
  margin: 0;
}
.report-page.report-page-rebates .report-page-rebates-xcel .report-header {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat no-repeat right;
  background-size: auto 60px;
}
.report-page.report-page-rebates .report-page-rebates-xcel .report-body {
  height: 550px;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-header {
  font-size: 15px;
  color: #81112d;
  margin: 0;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-header.large-sub-header {
  margin-top: 10px;
  font-size: 2em;
}
.report-page.report-page-rebates .report-page-rebates-xcel .fine-print {
  font-size: 0.7em;
  line-height: 1.5;
}
.report-page.report-page-rebates .report-page-rebates-xcel .fine-print2 {
  font-size: 0.7em;
  line-height: 12px;
}
.report-page.report-page-rebates .report-page-rebates-xcel ul > li {
  margin: 12px 0;
}
.report-page.report-page-rebates .report-page-rebates-xcel .text-center {
  text-align: center;
  margin-top: 20px;
}
.report-page.report-page-rebates .report-page-rebates-xcel .text-right {
  text-align: right;
  margin-top: 20px;
}
.report-page.report-page-rebates .report-page-rebates-xcel img.rebate-icon {
  width: auto;
  height: 14px;
  margin-right: 5px;
}
.report-page.report-page-rebates .report-page-rebates-xcel .call-to-action {
  margin-top: 15px;
  height: 100px;
}
.report-page.report-page-rebates .report-page-rebates-xcel .call-to-action .contact {
  margin-top: 0;
  font-size: 1.5em;
}
.report-page.report-page-rebates .report-page-rebates-xcel .call-to-action .advisor-logo.img {
  margin-left: 10px;
  margin-top: -10px;
  width: 110px;
}
.report-page.report-page-rebates .report-page-rebates-xcel blockquote {
  background: #f9f9f9;
  border-left: 2px solid #eee;
  margin: 1.1em 1em;
  padding: 0.5em 1em;
  quotes: '\\201C' '\\201D';
}
.report-page.report-page-rebates .report-page-rebates-xcel blockquote:before {
  color: #808080;
  content: open-quote;
  font-size: 4em;
  line-height: 0.1em;
  margin-right: 0.25em;
  vertical-align: -0.4em;
}
.report-page.report-page-rebates .report-page-rebates-xcel blockquote:first-child {
  display: inline;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table {
  font-size: 0.7em;
  line-height: 1.1em;
  margin-bottom: 4px;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1 .col-power {
  width: 6%;
  text-align: center;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1 .col-rebate-area {
  width: 10%;
  font-weight: bold;
  line-height: 1.1;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1 .col-qualifier1 {
  width: 12%;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1 .col-qualifier2 {
  width: 8%;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1 .col-rebate {
  width: 0.8%;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1 .col-info {
  width: 40%;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1-1 .col-power {
  width: 7.4%;
  text-align: center;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1-1 .col-rebate-area {
  width: 36.5%;
  background-color: #9b9da2;
  font-weight: bold;
  color: #ffffff;
  line-height: 1.1;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1-1 .col-qualifier {
  width: 15%;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1-1 .col-utility1 {
  width: 3.7%;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1-1 .col-utility2 {
  width: 17.7%;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1-1 .col-utility3 {
  width: 17.7%;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2 td {
  line-height: 1.4;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2 .col-power {
  width: 7%;
  text-align: center;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2 .col-rebate-area {
  width: 30%;
  background-color: #9b9da2;
  font-weight: bold;
  color: #ffffff;
  line-height: 1.1;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2 .col-rebate {
  width: 20%;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2 .col-info {
  width: 43%;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2-1 td {
  line-height: 1.4;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2-1 .col-measures {
  width: 50%;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2-1 .col-utility1 {
  width: 14%;
  text-align: right;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2-1 .col-utility1.1 {
  width: 3%;
  text-align: right;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2-1 .col-utility2 {
  width: 15%;
  text-align: right;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2-1 .col-utility3 {
  width: 15%;
  text-align: right;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table th {
  border: 1px solid #c8c9cc;
  border-bottom: 0;
  border-top: 0;
  line-height: 1.5;
  padding: 2px 4px;
  background-color: #221f20;
  color: #ffffff;
  text-transform: none;
  font-size: 1em;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table td {
  border: 1px solid #c7c9cc;
  vertical-align: middle;
  padding: 3px 6px;
  line-height: 1.2;
  color: #262626;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table [class*='header'] td {
  padding: 3px 4px;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-cooling {
  background-color: #e92c31;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-cooling td {
  color: #fff;
  border-bottom: 0;
  border-top: 0;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-cooling-odd {
  background-color: #ffffff;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-cooling-even {
  background-color: #f5f5f5;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-heating {
  background-color: #e92c31;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-heating td {
  color: #fff;
  border-bottom: 0;
  border-top: 0;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-heating-odd {
  background-color: #ffffff;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-heating-even {
  background-color: #f5f5f5;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-dhw {
  background-color: #e92c31;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-dhw td {
  color: #fff;
  border-bottom: 0;
  border-top: 0;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-dhw-odd {
  background-color: #ffffff;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-dhw-even {
  background-color: #f5f5f5;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-insulation {
  background-color: #e92c31;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-insulation td {
  color: #fff;
  border-bottom: 0;
  border-top: 0;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .subheader-insulation {
  background-color: #dddee0;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .subheader-insulation td {
  color: #000;
  border: 1px solid #b7b9bd;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .subheader-hpwes {
  background-color: #9b9da2;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .subheader-hpwes td {
  color: #fff;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-insulation-odd {
  background-color: #ffffff;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-insulation-even {
  background-color: #f5f5f5;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-audit {
  background-color: #e92c31;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-audit td {
  color: #fff;
  border-bottom: 0;
  border-top: 0;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-audit-odd {
  background-color: #ffffff;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-audit-even {
  background-color: #f5f5f5;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-hpwes {
  background-color: #e92c31;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-hpwes td {
  color: #fff;
  border-bottom: 0;
  border-top: 0;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-hpwes-odd {
  background-color: #ffffff;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-hpwes-even {
  background-color: #f5f5f5;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-right {
  text-align: right;
}
.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-center {
  text-align: center;
}
.report-page.report-page-rebates .report-page-rebates-aps {
  font-size: 0.95em;
  line-height: 1.4em;
}
.report-page.report-page-rebates .report-page-rebates-aps ul,
.report-page.report-page-rebates .report-page-rebates-aps ol {
  padding-left: 20px;
}
.report-page.report-page-rebates .report-page-rebates-aps h3 {
  margin-top: 20px;
}
.report-page.report-page-rebates .report-page-rebates-aps h4 {
  margin: 30px 0 6px;
}
.report-page.report-page-rebates .report-page-rebates-aps li {
  line-height: 1.35em;
}
.report-page.report-page-rebates .report-page-rebates-aps p {
  margin-bottom: 10px;
}
.report-page-rebates-cvetu {
  padding-top: 10px;
}
.report-page-rebates-cvetu .timelineContainer img {
  max-width: 100%;
}
.report-page-rebates-cvetu .breakoutStyle {
  background-color: #f3f3f3;
  font-size: 12px;
  line-height: 20px;
  font-weight: 600;
}
.report-page-rebates-cvetu .textAlignCenter {
  text-align: center;
}
.report-page-rebates-cvetu .cvetu-body {
  padding-top: 20px;
}
.report-page-rebates-cvetu .cvetu-body h2 {
  font-size: 18px;
  font-weight: 600;
  color: #2f2d2b;
}
.report-page-rebates-cvetu .cvetu-body h3 {
  font-size: 14px;
  font-weight: 600;
  color: #2f2d2b;
}
.report-page-rebates-cvetu .cvetu-body p,
.report-page-rebates-cvetu .cvetu-body ul {
  font-size: 12px;
  line-height: 18px;
  color: #2f2d2b;
}
.report-page-rebates-cvetu .cvetu-body p {
  margin: 10px 0;
}
.report-page-rebates-cvetu .cvetu-body li {
  margin: 5px 0;
}
.report-page-rebates-cvetu .cvetu-body ul {
  padding-left: 15px;
}
.report-page-rebates-cvetu .cvetu-body h4 {
  font-size: 13px;
  font-weight: 700;
  color: #2f2d2b;
}
.report-page-rebates-cvetu .cvetu-body a {
  color: #0092d9;
}
.report-page-rebates-cvetu .cvetu-body table {
  font-size: 10px;
}
.report-page-rebates-cvetu .cvetu-body table td {
  vertical-align: middle;
}
.report-page-rebates-cvetu .cvetu-body table th {
  font-size: 11px;
  text-align: center;
  vertical-align: middle;
}
.report-page-rebates-cvetu .cvetu-body table img {
  max-width: 100%;
  max-height: 50px;
}
.report-page-rebates-cvetu .loanProgramList li {
  margin: 15px 0;
}
.report-page-rebates-cvetu .solarContractorList li {
  margin: 15px 0;
}
.report-page-rebates-cvetu .cvetu-terms,
.report-page-rebates-cvetu .cvetu-terms p {
  font-size: 11px;
  line-height: 17px;
}
.report-page-rebates-cvetu .cvetu-terms p,
.report-page-rebates-cvetu .cvetu-terms p p {
  margin-top: 0;
}
.report-page.report-page-tech_specs .headline-style {
  font-size: 16px;
  color: #000;
  font-weight: 600;
  padding-left: 20px;
  margin: 0;
}
.report-page.report-page-tech_specs .homeIcon {
  width: 70%;
  margin-top: -15px;
}
.report-page.report-page-tech_specs .tableTypeStyle {
  font-size: 12px;
}
.report-page.report-page-tech_specs .tableTypeStyle b u {
  padding-top: 7px;
  display: inline-block;
}
.report-page.report-page-tech_specs .tableTypeStyle > .r-row [class*='r-spa']:nth-child(1) {
  text-align: right;
  padding: 1px 0;
}
.report-page.report-page-tech_specs .tableTypeStyle > .r-row [class*='r-spa']:nth-child(2) {
  text-align: left;
  font-weight: 600;
  padding: 1px 0;
}
.report-page.report-page-tech_specs .leftBorder {
  position: relative;
  padding-bottom: 10px;
}
.report-page.report-page-tech_specs .leftBorder ::before {
  content: '';
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0%;
  border-left: 2px solid #213a81;
  transform: translate(-2px);
}
.report-page.report-page-tech_specs .rightBorder {
  position: relative;
  padding-bottom: 10px;
}
.report-page.report-page-tech_specs .rightBorder ::before {
  content: '';
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 100%;
  border-right: 2px solid #213a81;
  transform: translate(16px);
}
.report-page.report-page-tech_specs .topBorder {
  border-top: 2px solid #213a81;
  padding-top: 15px;
}
.report-page.report-page-tech_specs .fontSize12 {
  font-size: 12px;
}
.report-page.report-page-tech_specs .fontSize12 [class*='r-spa'] {
  padding: 1px 0;
}
.eneContentStyle.eneContentStyleXL p {
  font-size: 11px;
}
.eneContentStyle table {
  border: 1px solid #ddd;
  border-collapse: collapse;
  font-size: 10px;
  line-height: 1.2;
  margin-bottom: 10px;
  width: 100%;
}
.eneContentStyle table td,
.eneContentStyle table th {
  border: 1px solid #ddd;
  border-collapse: collapse;
  padding: 2px 5px 2px 7px;
}
.eneContentStyle table th,
.eneContentStyle table .headStyle td {
  padding: 5px 5px 5px 7px;
  background: #f0f0f0;
}
.eneContentStyle table td.rightAlign,
.eneContentStyle table th.rightAlign {
  text-align: right;
}
.eneContentStyle table tr:nth-child(even) {
  background: #fafafa;
}
.eneContentStyle table.lessContent {
  font-size: 12px;
  line-height: 1.5;
}
.eneContentStyle table.lessContent td,
.eneContentStyle table.lessContent th,
.eneContentStyle table.lessContent tr.headStyle td {
  padding: 4px 5px 4px 7px;
}
.eneContentStyle table.lessContent2 {
  font-size: 11px;
  line-height: 1.3;
}
.eneContentStyle table.lessContent2 td {
  padding: 4px 5px 4px 7px;
}
.eneContentStyle table.lessContent2 tr.headStyle td,
.eneContentStyle table.lessContent2 th {
  padding: 6px 5px 6px 7px;
}
.eneContentStyle Table.lessContent3 {
  font-size: 11px;
  line-height: 1.3;
}
.eneContentStyle Table.lessContent3 td {
  padding: 3px 5px 3px 7px;
}
.eneContentStyle Table.lessContent3 tr.headStyle td,
.eneContentStyle Table.lessContent3 th {
  padding: 4px 5px 4px 7px;
}
.eneContentStyle Table.lessContent4 {
  font-size: 11px;
  line-height: 1.2;
}
.eneContentStyle Table.lessContent4 td {
  padding: 2px 5px 2px 5px;
}
.eneContentStyle Table.lessContent4 tr.headStyle td,
.eneContentStyle Table.lessContent4 th {
  padding: 2px 5px 2px 5px;
}
.eneContentStyle table.eneCompact th,
.eneContentStyle table.eneCompact .headStyle td {
  padding: 3px 5px 3px 5px;
}
.eneContentStyle ul {
  font-size: 12px;
  margin-bottom: 5px;
  padding-left: 20px;
}
.eneContentStyle p {
  font-size: 10px;
  line-height: 1.5;
  margin-bottom: 5px;
}
.eneContentStyle h2 {
  font-size: 12px;
  color: #2f2b22;
  margin-bottom: 2px;
  line-height: 1.2;
}
.eneContentStyle hr {
  margin-top: 0px;
  margin-bottom: 15px;
}
.eneContentStyle .title {
  float: left;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  padding-top: 5px;
}
.eneContentStyle .logoImg {
  max-width: 100%;
  height: 30px;
  width: auto;
  margin-bottom: 4px;
  float: right;
}
.eneContentStyle .headerProgramName {
  font-size: 10;
  display: block;
}
.eneContentStyle .bold {
  font-weight: 700;
}
.eneContentStyle .conditions {
  color: #ef233c;
  line-height: 1.5;
  font-weight: 600;
}
.report-page.report-page-coc .table.table-extra-condensed.new-jersey-coc-table > thead > tr > th:nth-child(1) {
  width: 160px;
}
.report-page.report-page-coc .table.table-extra-condensed.new-jersey-coc-table > thead > tr > th:nth-child(2) {
  width: 190px;
}
.report-page.report-page-coc .table.table-extra-condensed.new-jersey-coc-table > thead > tr > th:nth-child(3) {
  width: 130px;
}
.report-page.report-page-coc .table.table-extra-condensed.new-jersey-coc-table > thead > tr > th:nth-child(4) {
  width: 130px;
}
.report-page.report-page-coc .table.table-extra-condensed.new-jersey-coc-table > thead > tr > th:nth-child(3) {
  width: 80px;
}
.report-page.report-page-coc .table.table-extra-condensed.new-jersey-coc-table > tbody > tr > td {
  padding-right: 8px;
}
.report-page .report-page-contract-terms-berkshire-gas {
  font-size: 11px;
}
.report-page .report-page-contract-terms-berkshire-gas p {
  line-height: 1.3em;
}
.report-page .report-page-contract-terms-berkshire-gas h5 {
  font-size: 1em;
  font-style: bold;
}
.report-page .report-page-contract-terms-berkshire-gas ol {
  padding-left: 20px;
}
.report-page .report-page-rebates-wge .fine-print {
  font-size: 10px;
  line-height: 1.5;
}
.report-page .report-page-rebates-wge .note {
  font-size: 10px;
  line-height: 1.5;
  display: block;
  padding: 5px 8px;
  background-color: #eee;
  border-radius: 4px;
}
.report-page .report-page-rebates-wge .heading-rebate-table {
  font-size: 12px;
  font-weight: 600;
}
.report-page .report-page-rebates-wge table {
  margin-bottom: 10px;
  width: 100%;
  border: 1px solid #ddd;
}
.report-page .report-page-rebates-wge table.table-extra-condensed > tbody > tr > td,
.report-page .report-page-rebates-wge table.table-extra-condensed > thead > tr > th {
  border: 1px solid #ddd;
  padding: 3px 4px;
  line-height: 1.3;
  font-size: 10px;
}
.report-page .report-page-rebates-wge table.table-extra-condensed > thead > tr > th {
  letter-spacing: 0.03em;
  text-transform: none;
}
.report-page .report-page-rebates-wge table.table-extra-condensed > thead > tr > th.darkbackground {
  background-color: #555555;
  color: #fff;
}
.wysiwyg .editor {
  border: 1px solid transparent;
  height: 100%;
  overflow: hidden;
}
.wysiwyg .editor.blank-editor:before {
  display: block;
  content: 'Click to add text';
  color: #777777;
}
.wysiwyg .editor:focus {
  border: 1px solid #777777;
  -webkit-box-shadow: none;
  box-shadow: none;
  outline: none;
}
.wysiwyg .editor:hover {
  background-color: #feeeb2;
}
.wysiwyg .editor:hover:focus {
  background-color: inherit;
}
.wysiwyg .toolbar {
  width: 360px;
}
.wysiwyg .toolbar .btn {
  float: left;
  font-size: 18px;
  width: 45px;
  height: 45px;
  border-radius: 0;
  text-align: center;
  box-shadow: 0 -1px 1px rgba(0, 0, 0, 0.5);
}
.wysiwyg .toolbar .btn:active:focus {
  outline: none;
}
.wysiwyg .toolbar .btn:first-child {
  border-top-left-radius: 5px;
}
.wysiwyg .toolbar .btn:last-child {
  border-top-right-radius: 5px;
}
.wysiwyg .toolbar .btn [class*=' icon-'],
.wysiwyg .toolbar .btn [class^='icon-'] {
  font-size: 15px;
}
.wysiwyg .toolbar .btn.active {
  background-color: #d0d0d0;
}
.wysiwyg .toolbar .btn-bold {
  font-weight: 700;
}
.wysiwyg .toolbar .btn-italic {
  font-style: italic;
}
.custom-rc-pagination .rc-pagination-item,
.custom-rc-pagination .rc-pagination-jump-prev,
.custom-rc-pagination .rc-pagination-jump-next,
.custom-rc-pagination .rc-pagination-prev,
.custom-rc-pagination .rc-pagination-next,
.custom-rc-pagination .rc-pagination-jump-prev,
.custom-rc-pagination .rc-pagination-jump-next {
  border: 1px solid #eeeeee;
  background-color: #fff;
  min-width: 38px;
  height: 38px;
  line-height: 38px;
}
.custom-rc-pagination .rc-pagination-item a,
.custom-rc-pagination .rc-pagination-jump-prev a,
.custom-rc-pagination .rc-pagination-jump-next a,
.custom-rc-pagination .rc-pagination-prev a,
.custom-rc-pagination .rc-pagination-next a,
.custom-rc-pagination .rc-pagination-jump-prev a,
.custom-rc-pagination .rc-pagination-jump-next a {
  color: #c84900;
}
.custom-rc-pagination .rc-pagination-item:hover,
.custom-rc-pagination .rc-pagination-jump-prev:hover,
.custom-rc-pagination .rc-pagination-jump-next:hover,
.custom-rc-pagination .rc-pagination-prev:hover,
.custom-rc-pagination .rc-pagination-next:hover,
.custom-rc-pagination .rc-pagination-jump-prev:hover,
.custom-rc-pagination .rc-pagination-jump-next:hover {
  border-color: #777777;
}
.custom-rc-pagination .rc-pagination-item:hover a,
.custom-rc-pagination .rc-pagination-jump-prev:hover a,
.custom-rc-pagination .rc-pagination-jump-next:hover a,
.custom-rc-pagination .rc-pagination-prev:hover a,
.custom-rc-pagination .rc-pagination-next:hover a,
.custom-rc-pagination .rc-pagination-jump-prev:hover a,
.custom-rc-pagination .rc-pagination-jump-next:hover a {
  color: #555555;
}
.custom-rc-pagination .rc-pagination-item:active,
.custom-rc-pagination .rc-pagination-jump-prev:active,
.custom-rc-pagination .rc-pagination-jump-next:active,
.custom-rc-pagination .rc-pagination-prev:active,
.custom-rc-pagination .rc-pagination-next:active,
.custom-rc-pagination .rc-pagination-jump-prev:active,
.custom-rc-pagination .rc-pagination-jump-next:active {
  background-color: #eeeeee;
}
.custom-rc-pagination .rc-pagination-item:active a,
.custom-rc-pagination .rc-pagination-jump-prev:active a,
.custom-rc-pagination .rc-pagination-jump-next:active a,
.custom-rc-pagination .rc-pagination-prev:active a,
.custom-rc-pagination .rc-pagination-next:active a,
.custom-rc-pagination .rc-pagination-jump-prev:active a,
.custom-rc-pagination .rc-pagination-jump-next:active a {
  color: #c84900;
}
.custom-rc-pagination .rc-pagination-item.rc-pagination-disabled,
.custom-rc-pagination .rc-pagination-jump-prev.rc-pagination-disabled,
.custom-rc-pagination .rc-pagination-jump-next.rc-pagination-disabled,
.custom-rc-pagination .rc-pagination-prev.rc-pagination-disabled,
.custom-rc-pagination .rc-pagination-next.rc-pagination-disabled,
.custom-rc-pagination .rc-pagination-jump-prev.rc-pagination-disabled,
.custom-rc-pagination .rc-pagination-jump-next.rc-pagination-disabled,
.custom-rc-pagination .rc-pagination-item .rc-pagination-disabled:hover,
.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:hover,
.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:hover,
.custom-rc-pagination .rc-pagination-prev .rc-pagination-disabled:hover,
.custom-rc-pagination .rc-pagination-next .rc-pagination-disabled:hover,
.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:hover,
.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:hover,
.custom-rc-pagination .rc-pagination-item .rc-pagination-disabled:active,
.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:active,
.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:active,
.custom-rc-pagination .rc-pagination-prev .rc-pagination-disabled:active,
.custom-rc-pagination .rc-pagination-next .rc-pagination-disabled:active,
.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:active,
.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:active {
  border: 1px solid #eeeeee;
  background-color: #fff;
}
.custom-rc-pagination .rc-pagination-item.rc-pagination-disabled a,
.custom-rc-pagination .rc-pagination-jump-prev.rc-pagination-disabled a,
.custom-rc-pagination .rc-pagination-jump-next.rc-pagination-disabled a,
.custom-rc-pagination .rc-pagination-prev.rc-pagination-disabled a,
.custom-rc-pagination .rc-pagination-next.rc-pagination-disabled a,
.custom-rc-pagination .rc-pagination-jump-prev.rc-pagination-disabled a,
.custom-rc-pagination .rc-pagination-jump-next.rc-pagination-disabled a,
.custom-rc-pagination .rc-pagination-item .rc-pagination-disabled:hover a,
.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:hover a,
.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:hover a,
.custom-rc-pagination .rc-pagination-prev .rc-pagination-disabled:hover a,
.custom-rc-pagination .rc-pagination-next .rc-pagination-disabled:hover a,
.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:hover a,
.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:hover a,
.custom-rc-pagination .rc-pagination-item .rc-pagination-disabled:active a,
.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:active a,
.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:active a,
.custom-rc-pagination .rc-pagination-prev .rc-pagination-disabled:active a,
.custom-rc-pagination .rc-pagination-next .rc-pagination-disabled:active a,
.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:active a,
.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:active a {
  color: #ccc;
}
.custom-rc-pagination .rc-pagination-item-active {
  background-color: #555555;
  border-color: #222222;
}
.custom-rc-pagination .rc-pagination-item-active a {
  color: #fff;
}
.custom-rc-pagination .rc-pagination-item-active:hover a {
  color: #fff;
}
.custom-rc-pagination .rc-pagination-jump-prev:hover:after,
.custom-rc-pagination .rc-pagination-jump-next:hover:after {
  color: #555555;
}
.custom-rc-pagination .rc-pagination-jump-prev-custom-icon:hover .custom-icon-jump-prev,
.custom-rc-pagination .rc-pagination-jump-next-custom-icon:hover .custom-icon-jump-prev,
.custom-rc-pagination .rc-pagination-jump-prev-custom-icon:hover .custom-icon-jump-next,
.custom-rc-pagination .rc-pagination-jump-next-custom-icon:hover .custom-icon-jump-next {
  opacity: 1;
  color: #555555;
}
.custom-rc-pagination .rc-pagination-options-quick-jumper input:hover {
  border-color: #555555;
}
.custom-rc-pagination .rc-pagination-options-quick-jumper button:hover,
.custom-rc-pagination .rc-pagination-options-quick-jumper button:active,
.custom-rc-pagination .rc-pagination-options-quick-jumper button:focus {
  color: #555555;
  background-color: #fff;
  border-color: #555555;
}
.custom-rc-pagination .rc-pagination-simple .rc-pagination-simple-pager input:hover {
  border-color: #555555;
}
.custom-rc-pagination .rc-pagination-simple .rc-pagination-simple-pager button:hover,
.custom-rc-pagination .rc-pagination-simple .rc-pagination-simple-pager button:active,
.custom-rc-pagination .rc-pagination-simple .rc-pagination-simple-pager button:focus {
  color: #555555;
  background-color: #fff;
  border-color: #555555;
}
.horizontal-slider {
  margin-bottom: 20px;
}
.horizontal-slider .handle {
  background-color: #303232;
  z-index: 101;
  margin-top: 8px;
  margin-left: -20px;
  border-color: rgba(48, 50, 50, 0.6);
}
.horizontal-slider div.bar:last-of-type {
  border-radius: 0 10px 10px 0;
}
.horizontal-slider .bar {
  height: 20px;
  text-align: center;
  color: transparent !important;
  -webkit-user-select: none;
}
.horizontal-slider .bar:first-child {
  border-radius: 10px 0 0 10px;
}
.horizontal-slider .bar.bar-0 {
  background-color: #872c4f;
  color: #fff;
}
.horizontal-slider .bar.bar-1 {
  background-color: #ef8a45;
}
.horizontal-slider .bar.bar-2 {
  background-color: #f2cd50;
}
.horizontal-slider .bar .bar-value {
  text-align: center;
}
.modal-backdrop {
  z-index: 1069;
}
.modal-backdrop.in {
  opacity: 0.7;
}
.modal-open .modal {
  z-index: 1070;
}
.modal-header {
  padding: 20px 20px 10px 25px;
  border-bottom: none;
}
.modal-title {
  font-weight: 600;
  font-size: 20px;
  color: #303232;
  text-align: left;
}
.modal-content {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.7);
  border-radius: 5px;
}
.modal-content .close {
  font-size: 36px;
  font-weight: 400;
  line-height: 1.72em;
  text-shadow: 0 1px 0 #ffffff;
  opacity: 0.3;
  filter: alpha(opacity=30);
  width: 44px;
  text-align: center;
  margin: -20px -12px 0 0;
}
.modal-content .close:hover {
  opacity: 0.4;
}
.modal-content .close:active {
  opacity: 0.8;
}
.modal-body {
  padding: 15px 25px;
}
.confirmation.modal {
  display: flex !important;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
  z-index: 1090;
}
.confirmation.modal .modal-dialog {
  font-size: 16px;
  max-width: 400px;
}
.confirmation.modal .modal-dialog .modal-body {
  padding: 25px;
  background-color: #ffffff;
}
.confirmation.modal-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1089;
  background-color: #000000;
}
.confirmation.modal-backdrop.fade {
  opacity: 0;
  filter: alpha(opacity=0);
}
.confirmation.modal-backdrop.in {
  opacity: 0.5;
  filter: alpha(opacity=50);
}
.modal-footer {
  padding: 0;
  border: none;
}
.actived-progress-btn {
  color: #ffa845;
}
.actived-progress-btn p {
  color: #303232 !important;
}
.actived-progress-btn:hover {
  cursor: pointer;
}
.buy-credit-modal .active {
  color: black;
}
.buy-credit-modal .disable {
  color: #f2f2f2;
}
.buy-credit-modal .disable p {
  color: #adadad !important;
}
.buy-credit-modal p.disable {
  color: #adadad !important;
}
.buy-credit-modal label {
  cursor: pointer;
}
.buy-credit-modal [type='radio']:checked,
.buy-credit-modal [type='radio']:not(:checked) {
  position: absolute;
  left: -99999px;
}
.buy-credit-modal [type='radio']:checked + span,
.buy-credit-modal [type='radio']:not(:checked) + span {
  position: relative;
  padding-left: 30px;
}
.buy-credit-modal [type='radio']:checked + span:before,
.buy-credit-modal [type='radio']:not(:checked) + span:before {
  content: '';
  position: absolute;
  left: 0px;
  top: 15px;
  width: 18px;
  height: 18px;
  border: 1px solid #ddd;
  border-radius: 100%;
  background: #ffffff;
}
.buy-credit-modal [type='radio']:checked + span:after,
.buy-credit-modal [type='radio']:not(:checked) + span:after {
  content: '';
  position: absolute;
  left: 3px;
  top: 18px;
  width: 12px;
  height: 12px;
  border: 1px solid #ffa845;
  border-radius: 100%;
  background: #ffa845;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.buy-credit-modal [type='radio']:not(:checked) + span:after {
  opacity: 0;
  transform: scale(0);
}
.buy-credit-modal [type='radio']:checked + span:after {
  opacity: 1;
  transform: scale(1);
}
.buy-credit-modal [type='radio']:checked + span:before {
  border: 1px solid #ffa845;
}
@media (min-width: 768px) {
  .assign-modal {
    width: 480px;
  }
}
.snapshot-compare .modal-dialog {
  width: 95%;
}
.snapshot-compare .modal-header {
  padding-bottom: 0px;
}
.snapshot-compare .modal-body {
  padding-top: 0px;
}
@media (max-width: 768px) {
  .snapshot-compare .snapshot-row .col-sm-4 {
    padding: 0;
  }
}
.checklist-compare .modal-dialog {
  width: 95%;
}
.checklist-compare .modal-header {
  padding-bottom: 0px;
}
.checklist-compare .modal-body {
  padding-top: 0px;
}
@media (max-width: 768px) {
  .checklist-compare .checklist-row .col-sm-4 {
    padding: 0;
  }
}
.block-container {
  display: flex;
  flex-wrap: wrap;
  border-bottom: 1px solid #eeeeee;
  color: #4a4a4a;
  padding-bottom: 25px;
}
.block-container.without-border-bottom {
  border-bottom: none;
}
.block-container button {
  margin-top: 15px;
  margin-bottom: 15px;
}
.block-container .block-content {
  height: 128.72px;
}
.block-container .block-header {
  color: #625845;
  padding: 0;
  margin-bottom: 10px;
}
.block-container .block-horizontal {
  width: 220px;
  margin-bottom: 15px;
  margin-right: 60px;
}
.section-info-container {
  padding: 16px;
  border-radius: 5px;
  cursor: pointer;
}
.section-info-container.disabled {
  cursor: default;
}
.section-info-container:not(.disabled):hover {
  padding: 15px;
  border-width: 1px;
  border-style: dashed;
  border-color: #cccccc;
  background-color: #f9f9f9;
}
.section-info-container .link {
  color: #c84900;
  font-size: 14px;
  margin-top: 10px;
  font-weight: 600;
}
#auto-badge-tooltip .tooltip-inner {
  text-align: left;
  width: 160px;
}
.vertical-center-icon {
  line-height: 1;
  margin-bottom: -2px;
}
.settings-companies,
.settings-programs {
  padding-top: 46px;
}
.content.settings-view {
  padding: 48px 16px;
}
.mt-0 {
  margin-top: 0px !important;
}
.mb-0 {
  margin-bottom: 0px !important;
}
.ml-0 {
  margin-left: 0px !important;
}
.mr-0 {
  margin-right: 0px !important;
}
.mx-0 {
  margin-left: 0px !important;
  margin-right: 0px !important;
}
.my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}
.pt-0 {
  padding-top: 0px !important;
}
.pb-0 {
  padding-bottom: 0px !important;
}
.pl-0 {
  padding-left: 0px !important;
}
.pr-0 {
  padding-right: 0px !important;
}
.px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.gap-0 {
  gap: 0px !important;
}
.mt-2 {
  margin-top: 2px !important;
}
.mb-2 {
  margin-bottom: 2px !important;
}
.ml-2 {
  margin-left: 2px !important;
}
.mr-2 {
  margin-right: 2px !important;
}
.mx-2 {
  margin-left: 2px !important;
  margin-right: 2px !important;
}
.my-2 {
  margin-top: 2px !important;
  margin-bottom: 2px !important;
}
.pt-2 {
  padding-top: 2px !important;
}
.pb-2 {
  padding-bottom: 2px !important;
}
.pl-2 {
  padding-left: 2px !important;
}
.pr-2 {
  padding-right: 2px !important;
}
.px-2 {
  padding-left: 2px !important;
  padding-right: 2px !important;
}
.py-2 {
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}
.gap-2 {
  gap: 2px !important;
}
.mt-4 {
  margin-top: 4px !important;
}
.mb-4 {
  margin-bottom: 4px !important;
}
.ml-4 {
  margin-left: 4px !important;
}
.mr-4 {
  margin-right: 4px !important;
}
.mx-4 {
  margin-left: 4px !important;
  margin-right: 4px !important;
}
.my-4 {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}
.pt-4 {
  padding-top: 4px !important;
}
.pb-4 {
  padding-bottom: 4px !important;
}
.pl-4 {
  padding-left: 4px !important;
}
.pr-4 {
  padding-right: 4px !important;
}
.px-4 {
  padding-left: 4px !important;
  padding-right: 4px !important;
}
.py-4 {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.gap-4 {
  gap: 4px !important;
}
.mt-6 {
  margin-top: 6px !important;
}
.mb-6 {
  margin-bottom: 6px !important;
}
.ml-6 {
  margin-left: 6px !important;
}
.mr-6 {
  margin-right: 6px !important;
}
.mx-6 {
  margin-left: 6px !important;
  margin-right: 6px !important;
}
.my-6 {
  margin-top: 6px !important;
  margin-bottom: 6px !important;
}
.pt-6 {
  padding-top: 6px !important;
}
.pb-6 {
  padding-bottom: 6px !important;
}
.pl-6 {
  padding-left: 6px !important;
}
.pr-6 {
  padding-right: 6px !important;
}
.px-6 {
  padding-left: 6px !important;
  padding-right: 6px !important;
}
.py-6 {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}
.gap-6 {
  gap: 6px !important;
}
.mt-8 {
  margin-top: 8px !important;
}
.mb-8 {
  margin-bottom: 8px !important;
}
.ml-8 {
  margin-left: 8px !important;
}
.mr-8 {
  margin-right: 8px !important;
}
.mx-8 {
  margin-left: 8px !important;
  margin-right: 8px !important;
}
.my-8 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}
.pt-8 {
  padding-top: 8px !important;
}
.pb-8 {
  padding-bottom: 8px !important;
}
.pl-8 {
  padding-left: 8px !important;
}
.pr-8 {
  padding-right: 8px !important;
}
.px-8 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.py-8 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
.gap-8 {
  gap: 8px !important;
}
.mt-10 {
  margin-top: 10px !important;
}
.mb-10 {
  margin-bottom: 10px !important;
}
.ml-10 {
  margin-left: 10px !important;
}
.mr-10 {
  margin-right: 10px !important;
}
.mx-10 {
  margin-left: 10px !important;
  margin-right: 10px !important;
}
.my-10 {
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}
.pt-10 {
  padding-top: 10px !important;
}
.pb-10 {
  padding-bottom: 10px !important;
}
.pl-10 {
  padding-left: 10px !important;
}
.pr-10 {
  padding-right: 10px !important;
}
.px-10 {
  padding-left: 10px !important;
  padding-right: 10px !important;
}
.py-10 {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
.gap-10 {
  gap: 10px !important;
}
.mt-12 {
  margin-top: 12px !important;
}
.mb-12 {
  margin-bottom: 12px !important;
}
.ml-12 {
  margin-left: 12px !important;
}
.mr-12 {
  margin-right: 12px !important;
}
.mx-12 {
  margin-left: 12px !important;
  margin-right: 12px !important;
}
.my-12 {
  margin-top: 12px !important;
  margin-bottom: 12px !important;
}
.pt-12 {
  padding-top: 12px !important;
}
.pb-12 {
  padding-bottom: 12px !important;
}
.pl-12 {
  padding-left: 12px !important;
}
.pr-12 {
  padding-right: 12px !important;
}
.px-12 {
  padding-left: 12px !important;
  padding-right: 12px !important;
}
.py-12 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}
.gap-12 {
  gap: 12px !important;
}
.mt-16 {
  margin-top: 16px !important;
}
.mb-16 {
  margin-bottom: 16px !important;
}
.ml-16 {
  margin-left: 16px !important;
}
.mr-16 {
  margin-right: 16px !important;
}
.mx-16 {
  margin-left: 16px !important;
  margin-right: 16px !important;
}
.my-16 {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}
.pt-16 {
  padding-top: 16px !important;
}
.pb-16 {
  padding-bottom: 16px !important;
}
.pl-16 {
  padding-left: 16px !important;
}
.pr-16 {
  padding-right: 16px !important;
}
.px-16 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}
.py-16 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}
.gap-16 {
  gap: 16px !important;
}
.mt-20 {
  margin-top: 20px !important;
}
.mb-20 {
  margin-bottom: 20px !important;
}
.ml-20 {
  margin-left: 20px !important;
}
.mr-20 {
  margin-right: 20px !important;
}
.mx-20 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}
.my-20 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}
.pt-20 {
  padding-top: 20px !important;
}
.pb-20 {
  padding-bottom: 20px !important;
}
.pl-20 {
  padding-left: 20px !important;
}
.pr-20 {
  padding-right: 20px !important;
}
.px-20 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}
.py-20 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}
.gap-20 {
  gap: 20px !important;
}
.mt-24 {
  margin-top: 24px !important;
}
.mb-24 {
  margin-bottom: 24px !important;
}
.ml-24 {
  margin-left: 24px !important;
}
.mr-24 {
  margin-right: 24px !important;
}
.mx-24 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}
.my-24 {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}
.pt-24 {
  padding-top: 24px !important;
}
.pb-24 {
  padding-bottom: 24px !important;
}
.pl-24 {
  padding-left: 24px !important;
}
.pr-24 {
  padding-right: 24px !important;
}
.px-24 {
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.py-24 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}
.gap-24 {
  gap: 24px !important;
}
.mt-28 {
  margin-top: 24px !important;
}
.mb-28 {
  margin-bottom: 24px !important;
}
.ml-28 {
  margin-left: 24px !important;
}
.mr-28 {
  margin-right: 24px !important;
}
.mx-28 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}
.my-28 {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}
.pt-28 {
  padding-top: 24px !important;
}
.pb-28 {
  padding-bottom: 24px !important;
}
.pl-28 {
  padding-left: 24px !important;
}
.pr-28 {
  padding-right: 24px !important;
}
.px-28 {
  padding-left: 24px !important;
  padding-right: 24px !important;
}
.py-28 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}
.gap-28 {
  gap: 24px !important;
}
.mt-32 {
  margin-top: 32px !important;
}
.mb-32 {
  margin-bottom: 32px !important;
}
.ml-32 {
  margin-left: 32px !important;
}
.mr-32 {
  margin-right: 32px !important;
}
.mx-32 {
  margin-left: 32px !important;
  margin-right: 32px !important;
}
.my-32 {
  margin-top: 32px !important;
  margin-bottom: 32px !important;
}
.pt-32 {
  padding-top: 32px !important;
}
.pb-32 {
  padding-bottom: 32px !important;
}
.pl-32 {
  padding-left: 32px !important;
}
.pr-32 {
  padding-right: 32px !important;
}
.px-32 {
  padding-left: 32px !important;
  padding-right: 32px !important;
}
.py-32 {
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}
.gap-32 {
  gap: 32px !important;
}
.mt-40 {
  margin-top: 40px !important;
}
.mb-40 {
  margin-bottom: 40px !important;
}
.ml-40 {
  margin-left: 40px !important;
}
.mr-40 {
  margin-right: 40px !important;
}
.mx-40 {
  margin-left: 40px !important;
  margin-right: 40px !important;
}
.my-40 {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}
.pt-40 {
  padding-top: 40px !important;
}
.pb-40 {
  padding-bottom: 40px !important;
}
.pl-40 {
  padding-left: 40px !important;
}
.pr-40 {
  padding-right: 40px !important;
}
.px-40 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}
.py-40 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}
.gap-40 {
  gap: 40px !important;
}
@media (min-width: 768px) {
  .mt-sm-0 {
    margin-top: 0px !important;
  }
  .mb-sm-0 {
    margin-bottom: 0px !important;
  }
  .ml-sm-0 {
    margin-left: 0px !important;
  }
  .mr-sm-0 {
    margin-right: 0px !important;
  }
  .mx-sm-0 {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .my-sm-0 {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  .pt-sm-0 {
    padding-top: 0px !important;
  }
  .pb-sm-0 {
    padding-bottom: 0px !important;
  }
  .pl-sm-0 {
    padding-left: 0px !important;
  }
  .pr-sm-0 {
    padding-right: 0px !important;
  }
  .px-sm-0 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .py-sm-0 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  .gap-sm-0 {
    gap: 0px !important;
  }
  .mt-sm-2 {
    margin-top: 2px !important;
  }
  .mb-sm-2 {
    margin-bottom: 2px !important;
  }
  .ml-sm-2 {
    margin-left: 2px !important;
  }
  .mr-sm-2 {
    margin-right: 2px !important;
  }
  .mx-sm-2 {
    margin-left: 2px !important;
    margin-right: 2px !important;
  }
  .my-sm-2 {
    margin-top: 2px !important;
    margin-bottom: 2px !important;
  }
  .pt-sm-2 {
    padding-top: 2px !important;
  }
  .pb-sm-2 {
    padding-bottom: 2px !important;
  }
  .pl-sm-2 {
    padding-left: 2px !important;
  }
  .pr-sm-2 {
    padding-right: 2px !important;
  }
  .px-sm-2 {
    padding-left: 2px !important;
    padding-right: 2px !important;
  }
  .py-sm-2 {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }
  .gap-sm-2 {
    gap: 2px !important;
  }
  .mt-sm-4 {
    margin-top: 4px !important;
  }
  .mb-sm-4 {
    margin-bottom: 4px !important;
  }
  .ml-sm-4 {
    margin-left: 4px !important;
  }
  .mr-sm-4 {
    margin-right: 4px !important;
  }
  .mx-sm-4 {
    margin-left: 4px !important;
    margin-right: 4px !important;
  }
  .my-sm-4 {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
  }
  .pt-sm-4 {
    padding-top: 4px !important;
  }
  .pb-sm-4 {
    padding-bottom: 4px !important;
  }
  .pl-sm-4 {
    padding-left: 4px !important;
  }
  .pr-sm-4 {
    padding-right: 4px !important;
  }
  .px-sm-4 {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  .py-sm-4 {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
  .gap-sm-4 {
    gap: 4px !important;
  }
  .mt-sm-6 {
    margin-top: 6px !important;
  }
  .mb-sm-6 {
    margin-bottom: 6px !important;
  }
  .ml-sm-6 {
    margin-left: 6px !important;
  }
  .mr-sm-6 {
    margin-right: 6px !important;
  }
  .mx-sm-6 {
    margin-left: 6px !important;
    margin-right: 6px !important;
  }
  .my-sm-6 {
    margin-top: 6px !important;
    margin-bottom: 6px !important;
  }
  .pt-sm-6 {
    padding-top: 6px !important;
  }
  .pb-sm-6 {
    padding-bottom: 6px !important;
  }
  .pl-sm-6 {
    padding-left: 6px !important;
  }
  .pr-sm-6 {
    padding-right: 6px !important;
  }
  .px-sm-6 {
    padding-left: 6px !important;
    padding-right: 6px !important;
  }
  .py-sm-6 {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }
  .gap-sm-6 {
    gap: 6px !important;
  }
  .mt-sm-8 {
    margin-top: 8px !important;
  }
  .mb-sm-8 {
    margin-bottom: 8px !important;
  }
  .ml-sm-8 {
    margin-left: 8px !important;
  }
  .mr-sm-8 {
    margin-right: 8px !important;
  }
  .mx-sm-8 {
    margin-left: 8px !important;
    margin-right: 8px !important;
  }
  .my-sm-8 {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
  }
  .pt-sm-8 {
    padding-top: 8px !important;
  }
  .pb-sm-8 {
    padding-bottom: 8px !important;
  }
  .pl-sm-8 {
    padding-left: 8px !important;
  }
  .pr-sm-8 {
    padding-right: 8px !important;
  }
  .px-sm-8 {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .py-sm-8 {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  .gap-sm-8 {
    gap: 8px !important;
  }
  .mt-sm-10 {
    margin-top: 10px !important;
  }
  .mb-sm-10 {
    margin-bottom: 10px !important;
  }
  .ml-sm-10 {
    margin-left: 10px !important;
  }
  .mr-sm-10 {
    margin-right: 10px !important;
  }
  .mx-sm-10 {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
  .my-sm-10 {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
  .pt-sm-10 {
    padding-top: 10px !important;
  }
  .pb-sm-10 {
    padding-bottom: 10px !important;
  }
  .pl-sm-10 {
    padding-left: 10px !important;
  }
  .pr-sm-10 {
    padding-right: 10px !important;
  }
  .px-sm-10 {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .py-sm-10 {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  .gap-sm-10 {
    gap: 10px !important;
  }
  .mt-sm-12 {
    margin-top: 12px !important;
  }
  .mb-sm-12 {
    margin-bottom: 12px !important;
  }
  .ml-sm-12 {
    margin-left: 12px !important;
  }
  .mr-sm-12 {
    margin-right: 12px !important;
  }
  .mx-sm-12 {
    margin-left: 12px !important;
    margin-right: 12px !important;
  }
  .my-sm-12 {
    margin-top: 12px !important;
    margin-bottom: 12px !important;
  }
  .pt-sm-12 {
    padding-top: 12px !important;
  }
  .pb-sm-12 {
    padding-bottom: 12px !important;
  }
  .pl-sm-12 {
    padding-left: 12px !important;
  }
  .pr-sm-12 {
    padding-right: 12px !important;
  }
  .px-sm-12 {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  .py-sm-12 {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
  .gap-sm-12 {
    gap: 12px !important;
  }
  .mt-sm-16 {
    margin-top: 16px !important;
  }
  .mb-sm-16 {
    margin-bottom: 16px !important;
  }
  .ml-sm-16 {
    margin-left: 16px !important;
  }
  .mr-sm-16 {
    margin-right: 16px !important;
  }
  .mx-sm-16 {
    margin-left: 16px !important;
    margin-right: 16px !important;
  }
  .my-sm-16 {
    margin-top: 16px !important;
    margin-bottom: 16px !important;
  }
  .pt-sm-16 {
    padding-top: 16px !important;
  }
  .pb-sm-16 {
    padding-bottom: 16px !important;
  }
  .pl-sm-16 {
    padding-left: 16px !important;
  }
  .pr-sm-16 {
    padding-right: 16px !important;
  }
  .px-sm-16 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .py-sm-16 {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
  .gap-sm-16 {
    gap: 16px !important;
  }
  .mt-sm-20 {
    margin-top: 20px !important;
  }
  .mb-sm-20 {
    margin-bottom: 20px !important;
  }
  .ml-sm-20 {
    margin-left: 20px !important;
  }
  .mr-sm-20 {
    margin-right: 20px !important;
  }
  .mx-sm-20 {
    margin-left: 20px !important;
    margin-right: 20px !important;
  }
  .my-sm-20 {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
  .pt-sm-20 {
    padding-top: 20px !important;
  }
  .pb-sm-20 {
    padding-bottom: 20px !important;
  }
  .pl-sm-20 {
    padding-left: 20px !important;
  }
  .pr-sm-20 {
    padding-right: 20px !important;
  }
  .px-sm-20 {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .py-sm-20 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  .gap-sm-20 {
    gap: 20px !important;
  }
  .mt-sm-28 {
    margin-top: 28px !important;
  }
  .mb-sm-28 {
    margin-bottom: 28px !important;
  }
  .ml-sm-28 {
    margin-left: 28px !important;
  }
  .mr-sm-28 {
    margin-right: 28px !important;
  }
  .mx-sm-28 {
    margin-left: 28px !important;
    margin-right: 28px !important;
  }
  .my-sm-28 {
    margin-top: 28px !important;
    margin-bottom: 28px !important;
  }
  .pt-sm-28 {
    padding-top: 28px !important;
  }
  .pb-sm-28 {
    padding-bottom: 28px !important;
  }
  .pl-sm-28 {
    padding-left: 28px !important;
  }
  .pr-sm-28 {
    padding-right: 28px !important;
  }
  .px-sm-28 {
    padding-left: 28px !important;
    padding-right: 28px !important;
  }
  .py-sm-28 {
    padding-top: 28px !important;
    padding-bottom: 28px !important;
  }
  .gap-sm-28 {
    gap: 28px !important;
  }
  .mt-sm-32 {
    margin-top: 32px !important;
  }
  .mb-sm-32 {
    margin-bottom: 32px !important;
  }
  .ml-sm-32 {
    margin-left: 32px !important;
  }
  .mr-sm-32 {
    margin-right: 32px !important;
  }
  .mx-sm-32 {
    margin-left: 32px !important;
    margin-right: 32px !important;
  }
  .my-sm-32 {
    margin-top: 32px !important;
    margin-bottom: 32px !important;
  }
  .pt-sm-32 {
    padding-top: 32px !important;
  }
  .pb-sm-32 {
    padding-bottom: 32px !important;
  }
  .pl-sm-32 {
    padding-left: 32px !important;
  }
  .pr-sm-32 {
    padding-right: 32px !important;
  }
  .px-sm-32 {
    padding-left: 32px !important;
    padding-right: 32px !important;
  }
  .py-sm-32 {
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  }
  .gap-sm-32 {
    gap: 32px !important;
  }
  .mt-sm-36 {
    margin-top: 36px !important;
  }
  .mb-sm-36 {
    margin-bottom: 36px !important;
  }
  .ml-sm-36 {
    margin-left: 36px !important;
  }
  .mr-sm-36 {
    margin-right: 36px !important;
  }
  .mx-sm-36 {
    margin-left: 36px !important;
    margin-right: 36px !important;
  }
  .my-sm-36 {
    margin-top: 36px !important;
    margin-bottom: 36px !important;
  }
  .pt-sm-36 {
    padding-top: 36px !important;
  }
  .pb-sm-36 {
    padding-bottom: 36px !important;
  }
  .pl-sm-36 {
    padding-left: 36px !important;
  }
  .pr-sm-36 {
    padding-right: 36px !important;
  }
  .px-sm-36 {
    padding-left: 36px !important;
    padding-right: 36px !important;
  }
  .py-sm-36 {
    padding-top: 36px !important;
    padding-bottom: 36px !important;
  }
  .gap-sm-36 {
    gap: 36px !important;
  }
  .mt-sm-40 {
    margin-top: 40px !important;
  }
  .mb-sm-40 {
    margin-bottom: 40px !important;
  }
  .ml-sm-40 {
    margin-left: 40px !important;
  }
  .mr-sm-40 {
    margin-right: 40px !important;
  }
  .mx-sm-40 {
    margin-left: 40px !important;
    margin-right: 40px !important;
  }
  .my-sm-40 {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  .pt-sm-40 {
    padding-top: 40px !important;
  }
  .pb-sm-40 {
    padding-bottom: 40px !important;
  }
  .pl-sm-40 {
    padding-left: 40px !important;
  }
  .pr-sm-40 {
    padding-right: 40px !important;
  }
  .px-sm-40 {
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
  .py-sm-40 {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  .gap-sm-40 {
    gap: 40px !important;
  }
}
@media (min-width: 992px) {
  .mt-md-0 {
    margin-top: 0px !important;
  }
  .mb-md-0 {
    margin-bottom: 0px !important;
  }
  .ml-md-0 {
    margin-left: 0px !important;
  }
  .mr-md-0 {
    margin-right: 0px !important;
  }
  .mx-md-0 {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .my-md-0 {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  .pt-md-0 {
    padding-top: 0px !important;
  }
  .pb-md-0 {
    padding-bottom: 0px !important;
  }
  .pl-md-0 {
    padding-left: 0px !important;
  }
  .pr-md-0 {
    padding-right: 0px !important;
  }
  .px-md-0 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .py-md-0 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  .gap-md-0 {
    gap: 0px !important;
  }
  .mt-md-2 {
    margin-top: 2px !important;
  }
  .mb-md-2 {
    margin-bottom: 2px !important;
  }
  .ml-md-2 {
    margin-left: 2px !important;
  }
  .mr-md-2 {
    margin-right: 2px !important;
  }
  .mx-md-2 {
    margin-left: 2px !important;
    margin-right: 2px !important;
  }
  .my-md-2 {
    margin-top: 2px !important;
    margin-bottom: 2px !important;
  }
  .pt-md-2 {
    padding-top: 2px !important;
  }
  .pb-md-2 {
    padding-bottom: 2px !important;
  }
  .pl-md-2 {
    padding-left: 2px !important;
  }
  .pr-md-2 {
    padding-right: 2px !important;
  }
  .px-md-2 {
    padding-left: 2px !important;
    padding-right: 2px !important;
  }
  .py-md-2 {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }
  .gap-md-2 {
    gap: 2px !important;
  }
  .mt-md-4 {
    margin-top: 4px !important;
  }
  .mb-md-4 {
    margin-bottom: 4px !important;
  }
  .ml-md-4 {
    margin-left: 4px !important;
  }
  .mr-md-4 {
    margin-right: 4px !important;
  }
  .mx-md-4 {
    margin-left: 4px !important;
    margin-right: 4px !important;
  }
  .my-md-4 {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
  }
  .pt-md-4 {
    padding-top: 4px !important;
  }
  .pb-md-4 {
    padding-bottom: 4px !important;
  }
  .pl-md-4 {
    padding-left: 4px !important;
  }
  .pr-md-4 {
    padding-right: 4px !important;
  }
  .px-md-4 {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  .py-md-4 {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
  .gap-md-4 {
    gap: 4px !important;
  }
  .mt-md-6 {
    margin-top: 6px !important;
  }
  .mb-md-6 {
    margin-bottom: 6px !important;
  }
  .ml-md-6 {
    margin-left: 6px !important;
  }
  .mr-md-6 {
    margin-right: 6px !important;
  }
  .mx-md-6 {
    margin-left: 6px !important;
    margin-right: 6px !important;
  }
  .my-md-6 {
    margin-top: 6px !important;
    margin-bottom: 6px !important;
  }
  .pt-md-6 {
    padding-top: 6px !important;
  }
  .pb-md-6 {
    padding-bottom: 6px !important;
  }
  .pl-md-6 {
    padding-left: 6px !important;
  }
  .pr-md-6 {
    padding-right: 6px !important;
  }
  .px-md-6 {
    padding-left: 6px !important;
    padding-right: 6px !important;
  }
  .py-md-6 {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }
  .gap-md-6 {
    gap: 6px !important;
  }
  .mt-md-8 {
    margin-top: 8px !important;
  }
  .mb-md-8 {
    margin-bottom: 8px !important;
  }
  .ml-md-8 {
    margin-left: 8px !important;
  }
  .mr-md-8 {
    margin-right: 8px !important;
  }
  .mx-md-8 {
    margin-left: 8px !important;
    margin-right: 8px !important;
  }
  .my-md-8 {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
  }
  .pt-md-8 {
    padding-top: 8px !important;
  }
  .pb-md-8 {
    padding-bottom: 8px !important;
  }
  .pl-md-8 {
    padding-left: 8px !important;
  }
  .pr-md-8 {
    padding-right: 8px !important;
  }
  .px-md-8 {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .py-md-8 {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  .gap-md-8 {
    gap: 8px !important;
  }
  .mt-md-10 {
    margin-top: 10px !important;
  }
  .mb-md-10 {
    margin-bottom: 10px !important;
  }
  .ml-md-10 {
    margin-left: 10px !important;
  }
  .mr-md-10 {
    margin-right: 10px !important;
  }
  .mx-md-10 {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
  .my-md-10 {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
  .pt-md-10 {
    padding-top: 10px !important;
  }
  .pb-md-10 {
    padding-bottom: 10px !important;
  }
  .pl-md-10 {
    padding-left: 10px !important;
  }
  .pr-md-10 {
    padding-right: 10px !important;
  }
  .px-md-10 {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .py-md-10 {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  .gap-md-10 {
    gap: 10px !important;
  }
  .mt-md-12 {
    margin-top: 12px !important;
  }
  .mb-md-12 {
    margin-bottom: 12px !important;
  }
  .ml-md-12 {
    margin-left: 12px !important;
  }
  .mr-md-12 {
    margin-right: 12px !important;
  }
  .mx-md-12 {
    margin-left: 12px !important;
    margin-right: 12px !important;
  }
  .my-md-12 {
    margin-top: 12px !important;
    margin-bottom: 12px !important;
  }
  .pt-md-12 {
    padding-top: 12px !important;
  }
  .pb-md-12 {
    padding-bottom: 12px !important;
  }
  .pl-md-12 {
    padding-left: 12px !important;
  }
  .pr-md-12 {
    padding-right: 12px !important;
  }
  .px-md-12 {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  .py-md-12 {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
  .gap-md-12 {
    gap: 12px !important;
  }
  .mt-md-16 {
    margin-top: 16px !important;
  }
  .mb-md-16 {
    margin-bottom: 16px !important;
  }
  .ml-md-16 {
    margin-left: 16px !important;
  }
  .mr-md-16 {
    margin-right: 16px !important;
  }
  .mx-md-16 {
    margin-left: 16px !important;
    margin-right: 16px !important;
  }
  .my-md-16 {
    margin-top: 16px !important;
    margin-bottom: 16px !important;
  }
  .pt-md-16 {
    padding-top: 16px !important;
  }
  .pb-md-16 {
    padding-bottom: 16px !important;
  }
  .pl-md-16 {
    padding-left: 16px !important;
  }
  .pr-md-16 {
    padding-right: 16px !important;
  }
  .px-md-16 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .py-md-16 {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
  .gap-md-16 {
    gap: 16px !important;
  }
  .mt-md-20 {
    margin-top: 20px !important;
  }
  .mb-md-20 {
    margin-bottom: 20px !important;
  }
  .ml-md-20 {
    margin-left: 20px !important;
  }
  .mr-md-20 {
    margin-right: 20px !important;
  }
  .mx-md-20 {
    margin-left: 20px !important;
    margin-right: 20px !important;
  }
  .my-md-20 {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
  .pt-md-20 {
    padding-top: 20px !important;
  }
  .pb-md-20 {
    padding-bottom: 20px !important;
  }
  .pl-md-20 {
    padding-left: 20px !important;
  }
  .pr-md-20 {
    padding-right: 20px !important;
  }
  .px-md-20 {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .py-md-20 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  .gap-md-20 {
    gap: 20px !important;
  }
  .mt-md-24 {
    margin-top: 24px !important;
  }
  .mb-md-24 {
    margin-bottom: 24px !important;
  }
  .ml-md-24 {
    margin-left: 24px !important;
  }
  .mr-md-24 {
    margin-right: 24px !important;
  }
  .mx-md-24 {
    margin-left: 24px !important;
    margin-right: 24px !important;
  }
  .my-md-24 {
    margin-top: 24px !important;
    margin-bottom: 24px !important;
  }
  .pt-md-24 {
    padding-top: 24px !important;
  }
  .pb-md-24 {
    padding-bottom: 24px !important;
  }
  .pl-md-24 {
    padding-left: 24px !important;
  }
  .pr-md-24 {
    padding-right: 24px !important;
  }
  .px-md-24 {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }
  .py-md-24 {
    padding-top: 24px !important;
    padding-bottom: 24px !important;
  }
  .gap-md-24 {
    gap: 24px !important;
  }
  .mt-md-28 {
    margin-top: 28px !important;
  }
  .mb-md-28 {
    margin-bottom: 28px !important;
  }
  .ml-md-28 {
    margin-left: 28px !important;
  }
  .mr-md-28 {
    margin-right: 28px !important;
  }
  .mx-md-28 {
    margin-left: 28px !important;
    margin-right: 28px !important;
  }
  .my-md-28 {
    margin-top: 28px !important;
    margin-bottom: 28px !important;
  }
  .pt-md-28 {
    padding-top: 28px !important;
  }
  .pb-md-28 {
    padding-bottom: 28px !important;
  }
  .pl-md-28 {
    padding-left: 28px !important;
  }
  .pr-md-28 {
    padding-right: 28px !important;
  }
  .px-md-28 {
    padding-left: 28px !important;
    padding-right: 28px !important;
  }
  .py-md-28 {
    padding-top: 28px !important;
    padding-bottom: 28px !important;
  }
  .gap-md-28 {
    gap: 28px !important;
  }
  .mt-md-32 {
    margin-top: 32px !important;
  }
  .mb-md-32 {
    margin-bottom: 32px !important;
  }
  .ml-md-32 {
    margin-left: 32px !important;
  }
  .mr-md-32 {
    margin-right: 32px !important;
  }
  .mx-md-32 {
    margin-left: 32px !important;
    margin-right: 32px !important;
  }
  .my-md-32 {
    margin-top: 32px !important;
    margin-bottom: 32px !important;
  }
  .pt-md-32 {
    padding-top: 32px !important;
  }
  .pb-md-32 {
    padding-bottom: 32px !important;
  }
  .pl-md-32 {
    padding-left: 32px !important;
  }
  .pr-md-32 {
    padding-right: 32px !important;
  }
  .px-md-32 {
    padding-left: 32px !important;
    padding-right: 32px !important;
  }
  .py-md-32 {
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  }
  .gap-md-32 {
    gap: 32px !important;
  }
  .mt-md-36 {
    margin-top: 36px !important;
  }
  .mb-md-36 {
    margin-bottom: 36px !important;
  }
  .ml-md-36 {
    margin-left: 36px !important;
  }
  .mr-md-36 {
    margin-right: 36px !important;
  }
  .mx-md-36 {
    margin-left: 36px !important;
    margin-right: 36px !important;
  }
  .my-md-36 {
    margin-top: 36px !important;
    margin-bottom: 36px !important;
  }
  .pt-md-36 {
    padding-top: 36px !important;
  }
  .pb-md-36 {
    padding-bottom: 36px !important;
  }
  .pl-md-36 {
    padding-left: 36px !important;
  }
  .pr-md-36 {
    padding-right: 36px !important;
  }
  .px-md-36 {
    padding-left: 36px !important;
    padding-right: 36px !important;
  }
  .py-md-36 {
    padding-top: 36px !important;
    padding-bottom: 36px !important;
  }
  .gap-md-36 {
    gap: 36px !important;
  }
  .mt-md-40 {
    margin-top: 40px !important;
  }
  .mb-md-40 {
    margin-bottom: 40px !important;
  }
  .ml-md-40 {
    margin-left: 40px !important;
  }
  .mr-md-40 {
    margin-right: 40px !important;
  }
  .mx-md-40 {
    margin-left: 40px !important;
    margin-right: 40px !important;
  }
  .my-md-40 {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  .pt-md-40 {
    padding-top: 40px !important;
  }
  .pb-md-40 {
    padding-bottom: 40px !important;
  }
  .pl-md-40 {
    padding-left: 40px !important;
  }
  .pr-md-40 {
    padding-right: 40px !important;
  }
  .px-md-40 {
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
  .py-md-40 {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  .gap-md-40 {
    gap: 40px !important;
  }
}
@media (min-width: 1200px) {
  .mt-lg-0 {
    margin-top: 0px !important;
  }
  .mb-lg-0 {
    margin-bottom: 0px !important;
  }
  .ml-lg-0 {
    margin-left: 0px !important;
  }
  .mr-lg-0 {
    margin-right: 0px !important;
  }
  .mx-lg-0 {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  .my-lg-0 {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
  }
  .pt-lg-0 {
    padding-top: 0px !important;
  }
  .pb-lg-0 {
    padding-bottom: 0px !important;
  }
  .pl-lg-0 {
    padding-left: 0px !important;
  }
  .pr-lg-0 {
    padding-right: 0px !important;
  }
  .px-lg-0 {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }
  .py-lg-0 {
    padding-top: 0px !important;
    padding-bottom: 0px !important;
  }
  .gap-lg-0 {
    gap: 0px !important;
  }
  .mt-lg-2 {
    margin-top: 2px !important;
  }
  .mb-lg-2 {
    margin-bottom: 2px !important;
  }
  .ml-lg-2 {
    margin-left: 2px !important;
  }
  .mr-lg-2 {
    margin-right: 2px !important;
  }
  .mx-lg-2 {
    margin-left: 2px !important;
    margin-right: 2px !important;
  }
  .my-lg-2 {
    margin-top: 2px !important;
    margin-bottom: 2px !important;
  }
  .pt-lg-2 {
    padding-top: 2px !important;
  }
  .pb-lg-2 {
    padding-bottom: 2px !important;
  }
  .pl-lg-2 {
    padding-left: 2px !important;
  }
  .pr-lg-2 {
    padding-right: 2px !important;
  }
  .px-lg-2 {
    padding-left: 2px !important;
    padding-right: 2px !important;
  }
  .py-lg-2 {
    padding-top: 2px !important;
    padding-bottom: 2px !important;
  }
  .gap-lg-2 {
    gap: 2px !important;
  }
  .mt-lg-4 {
    margin-top: 4px !important;
  }
  .mb-lg-4 {
    margin-bottom: 4px !important;
  }
  .ml-lg-4 {
    margin-left: 4px !important;
  }
  .mr-lg-4 {
    margin-right: 4px !important;
  }
  .mx-lg-4 {
    margin-left: 4px !important;
    margin-right: 4px !important;
  }
  .my-lg-4 {
    margin-top: 4px !important;
    margin-bottom: 4px !important;
  }
  .pt-lg-4 {
    padding-top: 4px !important;
  }
  .pb-lg-4 {
    padding-bottom: 4px !important;
  }
  .pl-lg-4 {
    padding-left: 4px !important;
  }
  .pr-lg-4 {
    padding-right: 4px !important;
  }
  .px-lg-4 {
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  .py-lg-4 {
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
  .gap-lg-4 {
    gap: 4px !important;
  }
  .mt-lg-6 {
    margin-top: 6px !important;
  }
  .mb-lg-6 {
    margin-bottom: 6px !important;
  }
  .ml-lg-6 {
    margin-left: 6px !important;
  }
  .mr-lg-6 {
    margin-right: 6px !important;
  }
  .mx-lg-6 {
    margin-left: 6px !important;
    margin-right: 6px !important;
  }
  .my-lg-6 {
    margin-top: 6px !important;
    margin-bottom: 6px !important;
  }
  .pt-lg-6 {
    padding-top: 6px !important;
  }
  .pb-lg-6 {
    padding-bottom: 6px !important;
  }
  .pl-lg-6 {
    padding-left: 6px !important;
  }
  .pr-lg-6 {
    padding-right: 6px !important;
  }
  .px-lg-6 {
    padding-left: 6px !important;
    padding-right: 6px !important;
  }
  .py-lg-6 {
    padding-top: 6px !important;
    padding-bottom: 6px !important;
  }
  .gap-lg-6 {
    gap: 6px !important;
  }
  .mt-lg-8 {
    margin-top: 8px !important;
  }
  .mb-lg-8 {
    margin-bottom: 8px !important;
  }
  .ml-lg-8 {
    margin-left: 8px !important;
  }
  .mr-lg-8 {
    margin-right: 8px !important;
  }
  .mx-lg-8 {
    margin-left: 8px !important;
    margin-right: 8px !important;
  }
  .my-lg-8 {
    margin-top: 8px !important;
    margin-bottom: 8px !important;
  }
  .pt-lg-8 {
    padding-top: 8px !important;
  }
  .pb-lg-8 {
    padding-bottom: 8px !important;
  }
  .pl-lg-8 {
    padding-left: 8px !important;
  }
  .pr-lg-8 {
    padding-right: 8px !important;
  }
  .px-lg-8 {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
  .py-lg-8 {
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  .gap-lg-8 {
    gap: 8px !important;
  }
  .mt-lg-10 {
    margin-top: 10px !important;
  }
  .mb-lg-10 {
    margin-bottom: 10px !important;
  }
  .ml-lg-10 {
    margin-left: 10px !important;
  }
  .mr-lg-10 {
    margin-right: 10px !important;
  }
  .mx-lg-10 {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
  .my-lg-10 {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
  .pt-lg-10 {
    padding-top: 10px !important;
  }
  .pb-lg-10 {
    padding-bottom: 10px !important;
  }
  .pl-lg-10 {
    padding-left: 10px !important;
  }
  .pr-lg-10 {
    padding-right: 10px !important;
  }
  .px-lg-10 {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .py-lg-10 {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }
  .gap-lg-10 {
    gap: 10px !important;
  }
  .mt-lg-12 {
    margin-top: 12px !important;
  }
  .mb-lg-12 {
    margin-bottom: 12px !important;
  }
  .ml-lg-12 {
    margin-left: 12px !important;
  }
  .mr-lg-12 {
    margin-right: 12px !important;
  }
  .mx-lg-12 {
    margin-left: 12px !important;
    margin-right: 12px !important;
  }
  .my-lg-12 {
    margin-top: 12px !important;
    margin-bottom: 12px !important;
  }
  .pt-lg-12 {
    padding-top: 12px !important;
  }
  .pb-lg-12 {
    padding-bottom: 12px !important;
  }
  .pl-lg-12 {
    padding-left: 12px !important;
  }
  .pr-lg-12 {
    padding-right: 12px !important;
  }
  .px-lg-12 {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }
  .py-lg-12 {
    padding-top: 12px !important;
    padding-bottom: 12px !important;
  }
  .gap-lg-12 {
    gap: 12px !important;
  }
  .mt-lg-16 {
    margin-top: 16px !important;
  }
  .mb-lg-16 {
    margin-bottom: 16px !important;
  }
  .ml-lg-16 {
    margin-left: 16px !important;
  }
  .mr-lg-16 {
    margin-right: 16px !important;
  }
  .mx-lg-16 {
    margin-left: 16px !important;
    margin-right: 16px !important;
  }
  .my-lg-16 {
    margin-top: 16px !important;
    margin-bottom: 16px !important;
  }
  .pt-lg-16 {
    padding-top: 16px !important;
  }
  .pb-lg-16 {
    padding-bottom: 16px !important;
  }
  .pl-lg-16 {
    padding-left: 16px !important;
  }
  .pr-lg-16 {
    padding-right: 16px !important;
  }
  .px-lg-16 {
    padding-left: 16px !important;
    padding-right: 16px !important;
  }
  .py-lg-16 {
    padding-top: 16px !important;
    padding-bottom: 16px !important;
  }
  .gap-lg-16 {
    gap: 16px !important;
  }
  .mt-lg-20 {
    margin-top: 20px !important;
  }
  .mb-lg-20 {
    margin-bottom: 20px !important;
  }
  .ml-lg-20 {
    margin-left: 20px !important;
  }
  .mr-lg-20 {
    margin-right: 20px !important;
  }
  .mx-lg-20 {
    margin-left: 20px !important;
    margin-right: 20px !important;
  }
  .my-lg-20 {
    margin-top: 20px !important;
    margin-bottom: 20px !important;
  }
  .pt-lg-20 {
    padding-top: 20px !important;
  }
  .pb-lg-20 {
    padding-bottom: 20px !important;
  }
  .pl-lg-20 {
    padding-left: 20px !important;
  }
  .pr-lg-20 {
    padding-right: 20px !important;
  }
  .px-lg-20 {
    padding-left: 20px !important;
    padding-right: 20px !important;
  }
  .py-lg-20 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  .gap-lg-20 {
    gap: 20px !important;
  }
  .mt-lg-24 {
    margin-top: 24px !important;
  }
  .mb-lg-24 {
    margin-bottom: 24px !important;
  }
  .ml-lg-24 {
    margin-left: 24px !important;
  }
  .mr-lg-24 {
    margin-right: 24px !important;
  }
  .mx-lg-24 {
    margin-left: 24px !important;
    margin-right: 24px !important;
  }
  .my-lg-24 {
    margin-top: 24px !important;
    margin-bottom: 24px !important;
  }
  .pt-lg-24 {
    padding-top: 24px !important;
  }
  .pb-lg-24 {
    padding-bottom: 24px !important;
  }
  .pl-lg-24 {
    padding-left: 24px !important;
  }
  .pr-lg-24 {
    padding-right: 24px !important;
  }
  .px-lg-24 {
    padding-left: 24px !important;
    padding-right: 24px !important;
  }
  .py-lg-24 {
    padding-top: 24px !important;
    padding-bottom: 24px !important;
  }
  .gap-lg-24 {
    gap: 24px !important;
  }
  .mt-lg-28 {
    margin-top: 28px !important;
  }
  .mb-lg-28 {
    margin-bottom: 28px !important;
  }
  .ml-lg-28 {
    margin-left: 28px !important;
  }
  .mr-lg-28 {
    margin-right: 28px !important;
  }
  .mx-lg-28 {
    margin-left: 28px !important;
    margin-right: 28px !important;
  }
  .my-lg-28 {
    margin-top: 28px !important;
    margin-bottom: 28px !important;
  }
  .pt-lg-28 {
    padding-top: 28px !important;
  }
  .pb-lg-28 {
    padding-bottom: 28px !important;
  }
  .pl-lg-28 {
    padding-left: 28px !important;
  }
  .pr-lg-28 {
    padding-right: 28px !important;
  }
  .px-lg-28 {
    padding-left: 28px !important;
    padding-right: 28px !important;
  }
  .py-lg-28 {
    padding-top: 28px !important;
    padding-bottom: 28px !important;
  }
  .gap-lg-28 {
    gap: 28px !important;
  }
  .mt-lg-32 {
    margin-top: 32px !important;
  }
  .mb-lg-32 {
    margin-bottom: 32px !important;
  }
  .ml-lg-32 {
    margin-left: 32px !important;
  }
  .mr-lg-32 {
    margin-right: 32px !important;
  }
  .mx-lg-32 {
    margin-left: 32px !important;
    margin-right: 32px !important;
  }
  .my-lg-32 {
    margin-top: 32px !important;
    margin-bottom: 32px !important;
  }
  .pt-lg-32 {
    padding-top: 32px !important;
  }
  .pb-lg-32 {
    padding-bottom: 32px !important;
  }
  .pl-lg-32 {
    padding-left: 32px !important;
  }
  .pr-lg-32 {
    padding-right: 32px !important;
  }
  .px-lg-32 {
    padding-left: 32px !important;
    padding-right: 32px !important;
  }
  .py-lg-32 {
    padding-top: 32px !important;
    padding-bottom: 32px !important;
  }
  .gap-lg-32 {
    gap: 32px !important;
  }
  .mt-lg-36 {
    margin-top: 36px !important;
  }
  .mb-lg-36 {
    margin-bottom: 36px !important;
  }
  .ml-lg-36 {
    margin-left: 36px !important;
  }
  .mr-lg-36 {
    margin-right: 36px !important;
  }
  .mx-lg-36 {
    margin-left: 36px !important;
    margin-right: 36px !important;
  }
  .my-lg-36 {
    margin-top: 36px !important;
    margin-bottom: 36px !important;
  }
  .pt-lg-36 {
    padding-top: 36px !important;
  }
  .pb-lg-36 {
    padding-bottom: 36px !important;
  }
  .pl-lg-36 {
    padding-left: 36px !important;
  }
  .pr-lg-36 {
    padding-right: 36px !important;
  }
  .px-lg-36 {
    padding-left: 36px !important;
    padding-right: 36px !important;
  }
  .py-lg-36 {
    padding-top: 36px !important;
    padding-bottom: 36px !important;
  }
  .gap-lg-36 {
    gap: 36px !important;
  }
  .mt-lg-40 {
    margin-top: 40px !important;
  }
  .mb-lg-40 {
    margin-bottom: 40px !important;
  }
  .ml-lg-40 {
    margin-left: 40px !important;
  }
  .mr-lg-40 {
    margin-right: 40px !important;
  }
  .mx-lg-40 {
    margin-left: 40px !important;
    margin-right: 40px !important;
  }
  .my-lg-40 {
    margin-top: 40px !important;
    margin-bottom: 40px !important;
  }
  .pt-lg-40 {
    padding-top: 40px !important;
  }
  .pb-lg-40 {
    padding-bottom: 40px !important;
  }
  .pl-lg-40 {
    padding-left: 40px !important;
  }
  .pr-lg-40 {
    padding-right: 40px !important;
  }
  .px-lg-40 {
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
  .py-lg-40 {
    padding-top: 40px !important;
    padding-bottom: 40px !important;
  }
  .gap-lg-40 {
    gap: 40px !important;
  }
}
.authentication-requirement {
  margin-left: 8px;
}
.authentication-requirement ul {
  margin: 12px 0;
  padding: 0;
}
.authentication-requirement ul:first-child {
  margin: 4px 0 10px;
}
.authentication-requirement ul li {
  margin: 6px 0;
  list-style: none;
  font-size: 12px;
  color: #777777;
  vertical-align: middle;
  display: flex;
  align-items: center;
}
.authentication-requirement ul li.error {
  color: #c90606;
}
.authentication-requirement ul li.active {
  font-weight: 600;
  color: #4a7222;
}
.authentication-requirement ul li.active span {
  background-color: #4a7222;
  border: 1px solid #4a7222;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 8px 7px;
}
.authentication-requirement ul li.error {
  font-weight: 600;
  color: #c10101;
}
.authentication-requirement ul li.error span {
  background-color: #c10101;
  border: 1px solid #c10101;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 6px 6px;
}
.authentication-requirement ul li.warning {
  font-weight: 600;
  color: #f6bb54;
}
.authentication-requirement ul li.warning span {
  background-color: #f6bb54;
  border: 1px solid #f6bb54;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 6px ​8p;
}
.authentication-requirement ul li.requirement-title {
  font-size: 13px;
  color: #555555;
  font-weight: 600;
  padding-bottom: 4px;
}
.authentication-requirement ul li span {
  background: #ffffff;
  border: 1px solid #dddddd;
  margin-left: 8px;
  margin-right: 10px;
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 100%;
}
/* TREE COMPONENT STYLES */
.tree {
  list-style: none;
  margin: 0 !important;
  padding: 0 !important;
  padding-bottom: 16px;
  font-size: 14px;
  color: #333;
}
.tree > li {
  padding: 8px 8px;
  border-bottom: 1px solid #eee;
}
.tree > li.read-only {
  padding: 8px 0;
}
.tree > li:last-child {
  border: none;
}
.tree > li ul {
  padding-bottom: 4px;
  list-style: none;
  margin: 0px;
  padding: 4px 0px 0px 16px;
}
.tree > li li {
  margin: 6px 16px;
  display: flex;
  align-items: center;
  gap: 6px;
}
.tree .box {
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  align-items: center;
  gap: 6px;
}
.tree .nested {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.15s ease-in-out;
}
.tree .active {
  max-height: 500px;
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(90deg);
  }
}
.tree .icon-rotate {
  display: inline-block;
  transition: transform 0.15s ease-in-out;
}
.tree .icon-rotate.rotating {
  transform: rotate(90deg);
}
.white-tooltip.in {
  opacity: 1 !important;
}
.white-tooltip .tooltip-arrow {
  border-top-color: #fff !important;
}
.white-tooltip .tooltip-inner {
  max-width: 280px;
  background-color: #fff;
  color: #555;
  text-align: left;
  padding: 12px;
  border-radius: 6px;
  display: flex;
  gap: 4px;
  flex-direction: column;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 4px 4px 0 rgba(0, 0, 0, 0.06), 0 8px 8px 0 rgba(0, 0, 0, 0.06), 0 16px 16px 0 rgba(0, 0, 0, 0.06);
}
.white-tooltip .tooltip-inner p {
  margin-bottom: 0;
}
.tooltip-td-trigger {
  cursor: pointer;
  transition: all 200ms ease-in-out;
}
.tooltip-td-trigger:hover {
  background-color: #fdf5f4 !important;
}
/*# sourceMappingURL=app.css.map */`, "",{"version":3,"sources":["webpack://./src/less/app.less","webpack://./react-select/control.less","webpack://./react-select/mixins.less","webpack://./react-select/spinner.less","webpack://./react-select/menu.less","webpack://./react-select/multi.less","webpack://./signature-pad.less","webpack://./app/snugg-mixins.less","webpack://./app/upload-widget.less","webpack://./bootstrap-3.2.0/mixins/buttons.less","webpack://./app/custom-uploader.less","webpack://./app/dropdowns.less","webpack://./bootstrap-3.2.0/mixins/vendor-prefixes.less","webpack://./app/misc.less","webpack://./app/report-grid.less","webpack://./bootstrap-3.2.0/mixins/clearfix.less","webpack://./app/button-custom.less","webpack://./app/jobs.less","webpack://./app/activity.less","webpack://./app/inline-editing.less","webpack://./app/transitions.less","webpack://./app/jobform.less","webpack://./app/recommendations.less","webpack://./app/recommendation-single.less","webpack://./app/energy-vals.less","webpack://./app/report.less","webpack://./app/cards.less","webpack://./app/alerts.less","webpack://./app/rte.less","webpack://./app/secondary-nav.less","webpack://./app/panes.less","webpack://./app/buttons.less","webpack://./app/forms.less","webpack://./app/tickets.less","webpack://./app/job-snapshots.less","webpack://./app/incentives.less","webpack://./app/incentives-report.less","webpack://./app/bpi-2400.less","webpack://./app/checklist.less","webpack://./app/report-branding-settings.less","webpack://./app/programs/xcel.less","webpack://./app/programs/aps.less","webpack://./app/programs/cvetu.less","webpack://./app/partners/hes-report.less","webpack://./app/programs/ene.less","webpack://./app/programs/new-jersey.less","webpack://./app/programs/berkshire-gas.less","webpack://./app/programs/wge.less","webpack://./plugins/wysiwyg.less","webpack://./plugins/rc-pagination.less","webpack://./app/slider.less","webpack://./app/modals.less","webpack://./app/common.less","webpack://./app/spacing.less","webpack://./app/change-password.less","webpack://./app/tree.less","webpack://./app/tooltip.less"],"names":[],"mappings":"AAAA;;;;;;CAMC;ACFD;EACE,kBAAA;ADIF;ACDE;;;;EC8BA,8BAAA;EACA,2BAAA;EACA,sBAAA;AFvBF;ACDE;EACE,yBAAA;ADGJ;ACDE;EACE,eAAA;EACA,oBAAA;ADGJ;ACGA;EACE,sBAAA;EACA,kCAAA;EAEA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;ADFF;ACIE;EACE,uCAAA;ADFJ;ACOE;EACE,YAAA;ADLJ;ACSA;EC/BE,6BAAA;EACA,4BAAA;EDgCA,gBAAA;EACA,kCAAA;ADNF;ACGA;EAQI,0CAAA;EACA,uBAAA;ADRJ;ACaE;EACE,YAAA;ADXJ;ACeA;EACE,kCAAA;EAGA,mFAAA;ADfF;ACsBA;EACE,SAAA;EACA,WAAA;EACA,OAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,eAAA;EAEA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ADrBF;ACwBA;EACE,WAAA;EACA,eAAA;ADtBF;AC2BA;EACE,WAAA;EACA,OAAA;EACA,0BAAA;EAEA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,eAAA;EAEA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AD3BF;AC8BA;EACE,WAAA;EACA,eAAA;AD5BF;ACiCA;EAEE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;ADhCF;AC2BA;EAQI,4BAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;EACA,UAAA;EACA,wBAAA;ADhCJ;ACkCI;EACE,YAAA;ADhCN;ACsCA;EACE,aAAA;ADpCF;ACwCA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;ADtCF;ACwCA;EC3IE,8DAAA;EACA,yDAAA;EACA,sDAAA;EA5BA,WAAA;EACA,YAAA;ECDA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EFkKA,sBAAA;AD5BF;ACiCA;EClJE,gDAAA;EACA,2CAAA;EACA,wCAAA;EDkJA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AD7BF;AC+BE;EACE,cAAA;AD7BJ;ACgCA;EACE,qBAAA;EACA,eAAA;EACA,cAAA;AD9BF;ACgCA;EACE,WAAA;AD9BF;ACmCA;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;ADjCF;ACoCA;EACE,0CAAA;EACA,mBAAA;EACA,2BAAA;EAEA,qBAAA;EACA,SAAA;EACA,QAAA;ADnCF;ACqCA;;EAEE,sBAAA;ADnCF;AC2CA;EACE;IACE,UAAA;EDzCF;EC2CA;IACE,UAAA;EDzCF;AACF;AC2CA;EACE;IACE,UAAA;EDzCF;EC2CA;IACE,UAAA;EDzCF;AACF;AIxMA;EFgBE,+BAAA;EACA,8BAAA;EEXA,sBAAA;EACA,sBAAA;EACA,yBAAA;EACA,uCAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,iCAAA;AJuMF;AIlMA;EACE,iBAAA;EACA,gBAAA;AJoMF;AI/LA;EACE,sBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AJiMF;AI/LE;EFpBA,+BAAA;EACA,8BAAA;AFsNF;AI/LE;EACE,yBAAA;EACA,WAAA;AJiMJ;AI9LE;EACE,cAAA;EACA,mBAAA;AJgMJ;AI1LA;;;EAGE,sBAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AJ4LF;AKxPA;EAOI,sBAAA;EAEA,iBAAA;EACA,UAAA;ALmPJ;AK/OE;EACE,gBAAA;ALiPJ;AK3OA;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AL6OF;AKzOA;;EAEE,qBAAA;EACA,sBAAA;AL2OF;AKvOA;EH7BE,+BAAA;EACA,4BAAA;EG8BA,eAAA;EACA,gBAAA;AL0OF;AK7OA;EAMI,cAAA;EACA,eAAA;AL0OJ;AKrOA;EACE,eAAA;EHlCA,8BAAA;EACA,2BAAA;EGmCA,+BAAA;EAGA,oBAAA;ALsOF;AKnOE;;EAEE,yBAAA;EACA,cAAA;ALqOJ;AKnOE;EACE,yBAAA;ALqOJ;AKjOA;EAEI,yBAAA;EACA,yBAAA;EACA,WAAA;ALkOJ;AKtOA;EAQI,mBAAA;EACA,+BAAA;ALiOJ;AK/NI;;;EAGE,yBAAA;ALiON;AG9SA;EACE;IACE,wBAAA;EHgTF;AACF;AG9SA;EACE;IACE,gCAAA;EHgTF;AACF;AMvUA;EACE,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;ANyUF;AMtUA;EACE,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,yBAAA;ANwUF;AMrUA;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6CAAA;ANuUF;AMpUA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;ANsUF;AMnUA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ANqUF;AMlUA;EACE,kBAAA;EACA,SAAA;ANoUF;AMjUA;EACE,OAAA;ANmUF;AMhUA;EACE,QAAA;ANkUF;AM/TA;EACE;IACE,MAAA;IACA,OAAA;IACA,QAAA;IACA,SAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,iBAAA;ENiUF;EM/TA;IACE,aAAA;ENiUF;AACF;AMzTA;EACE;IACE,OAAA;IACA,QAAA;IACA,MAAA;IACA,SAAA;EN2TF;EMzTA;IACE,UAAA;IACA,WAAA;IACA,WAAA;IACA,YAAA;EN2TF;EMzTA;IACE,cAAA;IACA,eAAA;EN2TF;AACF;AMxTA;EAEE;IACE,YAAA;IACA,mBAAA;ENyTF;EM3TA;;IAKI,wBAAA;EN0TJ;AACF;AO5VE;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,4DAAA;EACA,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,2HAAA;EAEA,gBAAA;EACA,0BAAA;AP6VJ;AOxVE;EACE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,4DAAA;EACA,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,0BAAA;AP0VJ;AOrVE;EACE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,4DAAA;EACA,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,8BAAA;APuVJ;AOnVA;EAEE,+BAAA;EACA,4BAAA;EACA,uBAAA;APoVF;AO9TA;EACE;IACE,UAAA;EPgUF;AACF;AO7TA;EACE;IACE,UAAA;EP+TF;AACF;AO5TA;EACE;IACE,aAAA;IACA,mBAAA;EP8TF;AACF;AO3TA;EACE;IACE,aAAA;IACA,mBAAA;EP6TF;AACF;AQjdA;EACE,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;ARmdF;AQzdA;EC7BE,UAAA;EACA,sBAAA;EACA,kBAAA;EDsCE,sBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;ARodJ;AS/fE;;;;;EAKE,UAAA;EACA,yBAAA;EACI,qBAAA;ATigBR;AS/fE;;;EAGE,sBAAA;ATigBJ;AS5fI;;;;;;;;;;;;;;;EAKE,sBAAA;EACI,kBAAA;ATwgBV;AQtgBA;ECGI,WAAA;EACA,qBAAA;ATsgBJ;AQ1gBA;EAsBI,aAAA;ARufJ;AQ7gBA;EA0BI,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,oCAAA;ARsfJ;AQ7hBA;EAlCE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,OAAA;EAyEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,qCAAA;AR0fJ;AQrkBE;EACE,yBAAA;EACA,qBAAA;ARukBJ;AQpkBE;;EAEE,yBAAA;EACA,qBAAA;ARskBJ;AQrjBA;EAbI,iBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;ARqkBJ;AQ5jBA;;EALM,eAAA;ARqkBN;AQ1gBA;EACE,WAAA;EACA,eAAA;AR4gBF;AQ9gBA;EAMI,wBAAA;AR2gBJ;AQjhBA;;EAYI,aAAA;ARygBJ;AQrhBA;EAiBI,aAAA;ARugBJ;AQxhBA;EAxFE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,OAAA;EAwGE,cAAA;EACA,iBAAA;AR4gBJ;AQnnBE;EACE,yBAAA;EACA,qBAAA;ARqnBJ;AQlnBE;;EAEE,yBAAA;EACA,qBAAA;ARonBJ;AQ7iBA;EAnEI,iBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;ARmnBJ;AQpjBA;;EA3DM,eAAA;ARmnBN;AQ5hBA;EACE,yBAAA;AR8hBF;AQzhBA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,oBAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,wCAAA;EACA,oDAAA;AR2hBF;AQzhBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,cAAA;AR2hBJ;AQxhBE;EACE,WAAA;EACA,YAAA;EACA,cAAA;AR0hBJ;AQvhBE;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;ARyhBJ;AQrhBA;EACE;IACE,UAAA;ERuhBF;EQrhBA;IACE,UAAA;ERuhBF;AACF;AQphBA;EACE,aAAA;ARshBF;AQnhBA;EAEI,wBAAA;ARohBJ;AQhhBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,OAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qCAAA;ARkhBF;AQjiBA;EAkBI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;ARkhBJ;AQ9gBA;EACE,kBAAA;EACA,mBAAA;ARghBF;AQlhBA;EAKI,2BAAA;ARghBJ;AQ5gBA;EACE,2EAAA;AR8gBF;AQ3gBA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;AR6gBF;AQhhBA;EAMI,2BAAA;AR6gBJ;AU9tBA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,2CAAA;AVguBF;AU7tBA;EACE;IACE,UAAA;EV+tBF;EU5tBA;IACE,UAAA;EV8tBF;AACF;AU1tBA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,4BAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,6CAAA;AV4tBF;AUxtBE;EAAA;IACE,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,gBAAA;EV2tBF;AACF;AUxtBA;EACE;IACE,UAAA;IACA,2BAAA;EV0tBF;EUvtBA;IACE,UAAA;IACA,wBAAA;EVytBF;AACF;AUrtBA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AVutBF;AUntBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,gCAAA;AVqtBF;AUltBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,yDAAA;EAGA,aAAA;EACA,wBAAA;AVktBF;AUhtBE;EACE,cAAA;EACA,qCAAA;AVktBJ;AU/sBE;EACE,mCAAA;AVitBJ;AU9sBE;EAAA;IACE,WAAA;EVitBF;AACF;AU7sBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,iCAAA;AV+sBF;AU7sBE;EAAA;IACE,SAAA;IACA,OAAA;IACA,YAAA;EVgtBF;AACF;AU7sBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,gBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EAQA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,yDAAA;EAGA,aAAA;EACA,wBAAA;AVssBF;AUntBE;EAAA;IACE,eAAA;IACA,QAAA;IACA,eAAA;EVstBF;AACF;AU3sBE;EACE,0CAAA;AV6sBJ;AU1sBE;EACE,mCAAA;AV4sBJ;AUzsBE;EACE,gBAAA;EACA,cAAA;AV2sBJ;AUvsBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AVysBF;AU7sBA;EAOI,WAAA;EACA,YAAA;AVysBJ;AUrsBA;EACE,mBAAA;AVusBF;AUnsBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;AVqsBF;AUjsBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AVmsBF;AU/rBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AVisBF;AU/rBE;EACE,cAAA;EACA,YAAA;AVisBJ;AUnsBE;EAKI,WAAA;EACA,YAAA;AVisBN;AU7rBE;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;AV+rBJ;AU5rBE;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;AV8rBJ;AU3rBE;EACE,YAAA;EACA,oBAAA;EACA,6DAAA;EACA,2BAAA;AV6rBJ;AU1rBE;EACE,cAAA;EACA,eAAA;AV4rBJ;AUzrBE;EACE,cAAA;AV2rBJ;AUtrBA;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AVwrBF;AUrrBA;EACE,yCAAA;EACA,qBAAA;EACA,oBAAA;AVurBF;AUprBA;EACE,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AVsrBF;AUnrBA;EACE,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AVqrBF;AUlrBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,aAAA;EACA,wBAAA;AVorBF;AUlrBE;EACE,YAAA;AVorBJ;AUjrBE;EACE,YAAA;AVmrBJ;AUhrBE;EACE,4CAAA;AVkrBJ;AU9qBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;AVgrBF;AU7qBA;EACE,sBAAA;EACA,OAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;AV+qBF;AU7qBE;EACE,cAAA;EACA,YAAA;AV+qBJ;AU5qBE;EACE,qBAAA;EACA,4CAAA;AV8qBJ;AU3qBE;EACE,YAAA;AV6qBJ;AUzqBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,aAAA;EACA,wBAAA;AV2qBF;AUzqBE;EACE,YAAA;AV2qBJ;AUxqBE;EACE,YAAA;AV0qBJ;AUvqBE;EACE,aAAA;EACA,mBAAA;AVyqBJ;AUtqBE;EACE,2CAAA;AVwqBJ;AUpqBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,mBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AVsqBF;AUnqBA;EACE,cAAA;EACA,eAAA;EACA,eAAA;AVqqBF;AUjqBA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gBAAA;EACA,6BAAA;AVmqBF;AUhqBE;;EAEE,eAAA;AVkqBJ;AU9qBA;EAgBI,gBAAA;AViqBJ;AUjrBA;EAoBI,iBAAA;AVgqBJ;AU1pBE;EAAA;IACE,uBAAA;EV6pBF;EU3pBE;IACE,eAAA;IACA,aAAA;EV6pBJ;EU/pBE;IAMI,SAAA;IACA,cAAA;IACA,UAAA;EV4pBN;EUpqBE;;IAeI,cAAA;EVypBN;EU3qBA;IAuBI,eAAA;IACA,eAAA;IACA,YAAA;EVupBJ;AACF;AUlpBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kFAAA;EAIA,aAAA;EACA,wBAAA;AVipBF;AU/oBE;EACE,qBAAA;EACA,cAAA;AVipBJ;AU9oBE;EACE,qBAAA;EACA,cAAA;AVgpBJ;AU7oBE;EACE,4CAAA;AV+oBJ;AU5oBE;EACE,aAAA;EACA,mBAAA;AV8oBJ;AU1oBA;EACE,6DAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;AV4oBF;AU1oBE;EACE,YAAA;EACA,qBAAA;EACA,WAAA;AV4oBJ;AUzoBE;EACE,YAAA;EACA,qBAAA;EACA,WAAA;AV2oBJ;AUxoBE;EACE,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AV0oBJ;AUtoBA;EACE,YAAA;EACA,yBAAA;EACA,cAAA;AVwoBF;AUtoBE;EACE,cAAA;EACA,yBAAA;AVwoBJ;AUnoBA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AVqoBF;AUloBA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,yDAAA;EAGA,aAAA;EACA,wBAAA;AVkoBF;AUhoBE;EACE,qCAAA;EACA,cAAA;AVkoBJ;AU/nBE;EACE,6BAAA;AVioBJ;AU9nBE;EACE,cAAA;AVgoBJ;AU9nBI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AVgoBN;AU5nBE;EACE,aAAA;EACA,eAAA;AV8nBJ;AU5nBI;EACE,6BAAA;EACA,cAAA;AV8nBN;AUznBE;EACE,kBAAA;AV2nBJ;AUtnBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AVwnBF;AU/nBA;EAUI,cAAA;EACA,aAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AVwnBJ;AUxoBA;EAoBI,aAAA;AVunBJ;AU3oBA;EAwBI,cAAA;EACA,gBAAA;AVsnBJ;AUnnBE;EAAA;IACE,aAAA;EVsnBF;EUvnBA;IAII,gBAAA;EVsnBJ;AACF;AUvpBA;EAqCI,cAAA;EACA,kBAAA;EACA,kBAAA;AVqnBJ;AU5pBA;EA2CI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;AVonBJ;AUnqBA;EAmDI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AVmnBJ;AU5qBA;EA6DI,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AVknBJ;AUprBA;EAsEI,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AVinBJ;AU/mBI;EACE,gBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AVinBN;AUjsBA;EAqFI,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yDAAA;EAGA,aAAA;EACA,wBAAA;AV6mBJ;AU3mBI;EACE,yCAAA;AV6mBN;AU1mBI;EACE,4CAAA;AV4mBN;AUtmBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AVwmBF;AUrmBA;EACE,aAAA;EACA,WAAA;EACA,gBAAA;EACA,QAAA;EACA,kBAAA;AVumBF;AU5mBA;EAQI,OAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,aAAA;AVumBJ;AUrmBI;EACE,qBAAA;EACA,4CAAA;AVumBN;AUpmBI;EACE,WAAA;AVsmBN;AUjmBA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;AVmmBF;AUhmBA;EACE,kBAAA;EACA,gBAAA;AVkmBF;AUpmBA;EAKI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;AVkmBJ;AU7lBA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;AV+lBF;AUtmBA;EAUI,eAAA;EACA,cAAA;AV+lBJ;AU3lBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AV6lBF;AU1lBA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AV4lBF;AUvlBA;EAEI,gBAAA;AVwlBJ;AU1lBA;EAMI,2CAAA;EACA,sCAAA;AVulBJ;AU9lBA;EAWI,yBAAA;EACA,YAAA;AVslBJ;AUlmBA;EAgBI,yBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;AVqlBJ;AUxmBA;EAuBI,sBAAA;EACA,YAAA;AVolBJ;AU/kBA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,sBAAA;EACA,0BAAA;EACA,gBAAA;AVilBF;AUzlBA;EAWI,YAAA;EACA,yBAAA;EACA,2BAAA;AVilBJ;AU5kBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AV8kBF;AU3kBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;AV6kBF;AUvkBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,kBAAA;EACA,uBAAA;AVykBF;AUtkBA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,uCAAA;AVwkBF;AUtkBE;EACE,qCAAA;AVwkBJ;AUrkBE;EACE,mCAAA;AVukBJ;AUjkBA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,uCAAA;AVmkBF;AUjkBE;EACE,qCAAA;AVmkBJ;AUhkBE;EACE,mCAAA;AVkkBJ;AU9jBA;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;AVgkBF;AU7jBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,yCAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,uCAAA;AV+jBF;AU7jBE;EACE,yBAAA;AV+jBJ;AU5jBE;EACE,yBAAA;AV8jBJ;AU3jBE;EACE,6BAAA;AV6jBJ;AUzjBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AV2jBF;AUhkBA;EAQI,WAAA;EACA,YAAA;AV2jBJ;AUvjBA;EACE,mBAAA;AVyjBF;AUtjBA;EACE,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,cAAA;AVwjBF;AUpjBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;AVsjBF;AU9jBA;EAWI,WAAA;EACA,gBAAA;AVsjBJ;AUjjBA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,gCAAA;AVmjBF;AUhjBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,kBAAA;EACA,uCAAA;AVkjBF;AUhjBE;EACE,qCAAA;AVkjBJ;AU/iBE;EACE,mCAAA;AVijBJ;AUzkBA;EA4BI,WAAA;EACA,YAAA;AVgjBJ;AU5iBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,uCAAA;AV8iBF;AU5iBE;EACE,qCAAA;AV8iBJ;AU3iBE;EACE,mCAAA;AV6iBJ;AUviBA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,wBAAA;EACA,gBAAA;EACA,uCAAA;AVyiBF;AUviBE;EACE,qCAAA;AVyiBJ;AUtiBE;EACE,mCAAA;AVwiBJ;AUniBA;EAEE;IACE,aAAA;EVoiBF;EUhiBA;IAEI,aAAA;EViiBJ;EUniBA;IAMI,aAAA;EVgiBJ;EU3hBA;IAEI,aAAA;EV4hBJ;AACF;AUvhBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AVyhBF;AUthBA;EACE,cAAA;EACA,eAAA;EACA,aAAA;AVwhBF;AUrhBA;EACE,cAAA;EACA,eAAA;EACA,aAAA;EACA,gBAAA;AVuhBF;AW3vDA;EACE,gBAAA;AX6vDF;AW3vDA;EAEI,yBAAA;EACA,cAAA;AX4vDJ;AW/vDA;EAKM,2BAAA;AX6vDN;AWzvDA;EACE,gBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,6CAAA;EACA,aAAA;AX2vDF;AWvwDA;;;;;EAkBI,kBAAA;EACA,yBAAA;EACA,WAAA;AX4vDJ;AWhxDA;;;;;EAsBM,yBAAA;EACA,cAAA;AXiwDN;AWxxDA;;;;;EAyBQ,2BAAA;AXswDR;AWjwDI;EACE,6BAAA;EACA,kBAAA;AXmwDN;AWnyDA;EAoCI,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AXkwDJ;AWjwDI;;EAEE,yBAAA;EACA,aAAA;AXmwDN;AWtwDI;;EAKI,yBAAA;EACA,cAAA;AXqwDR;AW3wDI;;EAQM,2BAAA;AXuwDV;AWnwDI;EACE,yBAAA;AXqwDN;AWjwDA;EACE,WAAA;EACA,kCAAA;AXmwDF;AWrwDA;EAII,yBAAA;EACA,YAAA;AXowDJ;AWlwDE;EACE,kBAAA;EACA,UAAA;AXowDJ;AWtwDE;EAII,iBAAA;EACA,gBAAA;AXqwDN;AWlwDE;EACE,UAAA;EACA,kBAAA;EACA,gBAAA;AXowDJ;AWvwDE;EAKI,iBAAA;EACA,gBAAA;AXqwDN;AWlwDE;EACE,+BAAA;EACA,gBAAA;AXowDJ;AWtwDE;EAII,iBAAA;EACA,gBAAA;AXqwDN;AWlyDA;EAkCI,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,eAAA;EACA,cAAA;EJjDF,wBAAA;EACA,qBAAA;EACA,gBAAA;APozDF;AWrzDA;;EAoDM,eAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;AXqwDN;AWnwDI;EACE,yBAAA;AXqwDN;AWtwDI;EAGI,0BAAA;AXswDR;AWzwDI;;EAOI,2BAAA;AXswDR;AWnwDI;;;EAGE,cAAA;EACA,gBAAA;EACA,yBAAA;AXqwDN;AW1wDI;;;EAOI,0BAAA;AXwwDR;AWl1DA;EA8EM,QAAA;EACA,SAAA;EACA,kCAAA;EACA,qCAAA;EACA,+BAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,WAAA;AXuwDN;AWtwDM;EACE,YAAA;EACA,0BAAA;EACA,UAAA;AXwwDR;AWrwDI;EACE,eAAA;EACA,2BAAA;AXuwDN;AWzwDI;EAII,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;AXwwDR;AWrxDI;EAgBI,kBAAA;EACA,QAAA;AXwwDR;AWpwDE;ECrHA,wBAAA;EACQ,gBAAA;EDsHN,yBAAA;EACA,cAAA;AXuwDJ;AW1wDE;EAKI,+BAAA;AXwwDN;AWvwDM;EACE,0BAAA;AXywDR;Aar8DE;EACE,UAAA;EACA,6BAAA;Abu8DJ;Aap8DE;EACE,6BAAA;EACA,mBAAA;Abs8DJ;Aan8DE;EACE,kBAAA;EACA,qCAAA;Abq8DJ;Aaj8DA;EAEI;IACE,aAAA;Ebk8DJ;AACF;Aa97DA;EAEI;IACE,aAAA;Eb+7DJ;AACF;Aa17DA;EACE,2BAAA;Ab47DF;Aaz7DA;EACE,YAAA;Ab27DF;Aax7DA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,wEAAA;Ab07DF;Aav7DA;;;;;;EAME,cAAA;EACA,kBAAA;Aby7DF;Aat7DA;;;EAGE,oBAAA;Abw7DF;Aar7DA;EACE,eAAA;EACA,mBAAA;Abu7DF;Aap7DA;EACE,gBAAA;EACA,mBAAA;Abs7DF;Aan7DA;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;Abq7DF;Aal7DA;EACE,cAAA;Abo7DF;Aal7DE;EACE,qBAAA;Abo7DJ;Aaj7DE;EACE,cAAA;EACA,qBAAA;Abm7DJ;Aa/6DA;ENsCE,+BAAA;EACA,4BAAA;EACA,uBAAA;AP44DF;Aah7DA;EACE,0BAAA;Abk7DF;AYp7DE;;;;;;;;;;;;;;;;;;EAAgC,WAAA;EACA,UAAA;AZw8DlC;AYv8DE;;;;;;;;;;;;;;;;;;EAAgC,WAAA;AZ29DlC;AY19DE;;;;;;;;;;;;;;;;;;EAAgC,WAAA;AZ8+DlC;Aat9DA;EACE,UAAA;Abw9DF;Aaz9DA;EAKI,8BAAA;EACA,kBAAA;Abu9DJ;Aar9DI;EACE,yBAAA;Abu9DN;Aap9DI;;;EAGE,yBAAA;Abs9DN;Aaj9DA;;;;;;;;;;;;;;;;;;;EAmBE,qBAAA;EDnGA,0FAAA;EACQ,kFAAA;ECuGR,UAAA;EACA,uBAAA;Ebi9DA,UAAU;AACZ;AY1hEE;;;;;;;;;;;;;;;;;;;EAAgC,WAAA;EACA,UAAA;AZ+iElC;AY9iEE;;;;;;;;;;;;;;;;;;;EAAgC,WAAA;AZmkElC;AYlkEE;;;;;;;;;;;;;;;;;;;EAAgC,WAAA;AZulElC;Aa5gEA;;;;;;;;EAQE,wBAAA;EACA,SAAA;Ab8gEF;Aa1gEA;;;;EAIE,wBAAA;EACA,SAAA;Ab4gEF;AazgEA;EACE,mBAAA;Ab2gEF;AaxgEA;EACE,kBAAA;Ab0gEF;AavgEA;EACE,qBAAA;EACA,yEAAA;EAGA,iEAAA;AbugEF;AalgEA;EACE,yBAAA;EACA,YAAA;EACA,iBAAA;AbogEF;AavgEA;EAMI,WAAA;AbogEJ;Aa1gEA;EAWM,WAAA;AbkgEN;Aa//DI;EAEI,cAAA;AbggER;Aa1/DI;EACE,cAAA;Ab4/DN;Aav/DA;EAEI,YAAA;Abw/DJ;Aap/DA;EACE,WAAA;Abs/DF;Aal/DA;EACE,qBAAA;EACA,YAAA;EACA,WAAA;Abo/DF;Aaj/DA;EACE,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;Abm/DF;Aaj/DE;EACE,kFAAA;EAGA,qBAAA;Abi/DJ;Aa3/DA;EAcI,wBAAA;EACA,aAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,eAAA;Abg/DJ;AaxgEA;EA4BI,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;Ab++DJ;Aa5+DM;EACE,WAAA;EAEA,eAAA;Ab6+DR;Aaz+DI;EACE,4BAAA;EACA,kBAAA;Ab2+DN;Aax+DI;EACE,4BAAA;Ab0+DN;Aar+DA;EACE,uBAAA;EDrIA,4BAAA;EACK,uBAAA;EACG,oBAAA;AZ6mEV;Aav+DE;EACE,iDAAA;EACA,8CAAA;EACA,4CAAA;EACA,yCAAA;Aby+DJ;Aar+DA;;EAGI,iBAAA;EACA,mBAAA;Abs+DJ;Aa1+DA;;EAQI,kBAAA;EACA,eAAA;Abs+DJ;Aal+DA;EACE,gBAAA;EACA,0BAAA;Abo+DF;Aat+DA;EAKI,cAAA;Abo+DJ;Aah+DA;EACE,eAAA;EACA,cAAA;Abk+DF;Aa/9DA;EACE,eAAA;Abi+DF;Aa/9DE;EACE,yBAAA;Abi+DJ;Aa79DA;EACE,cAAA;EACA,gBAAA;Ab+9DF;Aa59DA;EACE,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;Ab89DF;Aa39DA;EACE,yBAAA;EACA,WAAA;Ab69DF;Aaz9DA;EAEI,oBAAA;Ab09DJ;Aar9DA;EACE,iBAAA;EACA,yBAAA;EACA,gBAAA;Abu9DF;Aal9DA;EACE,YAAA;Abo9DF;Aaj9DA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;Abm9DF;Aax9DA;EAQI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,oBAAA;Abm9DJ;Aaj9DI;EACE,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;Abm9DN;Aa/8DE;EACE,yBAAA;EACA,cAAA;Abi9DJ;Aan9DE;EAKI,qBAAA;Abi9DN;Aa/8DM;EACE,gBAAA;Abi9DR;Aa58DE;;;;EAIE,yBAAA;EACA,YAAA;Ab88DJ;Aan9DE;;;;EAQI,mBAAA;Abi9DN;Aa/8DM;;;;EACE,gBAAA;Abo9DR;Aa78DA;EAEI,cAAA;EACA,gBAAA;Ab88DJ;Aa58DI;EACE,WAAA;Ab88DN;Aa18DE;EAEI,cAAA;Ab28DN;Aaz8DM;EACE,WAAA;Ab28DR;Aat8DE;;;EAII,mBAAA;EACA,cAAA;Abu8DN;Aaj8DA;EACE,yBAAA;Abm8DF;Aaj8DE;EACE,yBAAA;Abm8DJ;Aa/7DA;;EAEE,gBAAA;EACA,gBAAA;EACA,iBAAA;Abi8DF;Aa97DA;EAEI,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;Ab+7DJ;Aa37DA;;EAGI,iBAAA;EACA,iBAAA;EACA,sBAAA;Ab47DJ;Aax7DA;;EAIM,yBAAA;Abw7DN;Aan7DA;EACE,aAAA;Abq7DF;Aal7DA;EACE,iBAAA;EACA,gBAAA;Abo7DF;AACA,wBAAwB;Aah7DxB;GCriBE,OAAA;EDuiBA,oBAAA;EACA,iBAAA;Abk7DF;Aep9EE;;EAEE,YAAA;EACA,cAAA;Afs9EJ;Aep9EE;EACE,WAAA;Afs9EJ;Acj+EE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;Adi+EJ;Ac/9EE;EACE,WAAA;Adi+EJ;Aa97DA;EACE,gBAAA;Abg8DF;Aa77DA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;Ab+7DF;Aa57DA;EACE,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,gBAAA;Ab87DF;Aan8DA;EAQI,eAAA;EACA,gBAAA;Ab87DJ;Aav8DA;EAaI,eAAA;EACA,gBAAA;Ab67DJ;Aa38DA;EAkBI,gBAAA;Ab47DJ;Aa98DA;EAsBI,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;Ab27DJ;Aaz7DI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;ED9hBJ,iDAAA;EACQ,yCAAA;EC+hBJ,SAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;Ab47DN;Aap+DA;EA6CI,kBAAA;Ab07DJ;Aav+DA;EAgDM,mBAAA;Ab07DN;Aal7DA;EACE,gBAAA;Abo7DF;Aaj7DA;EACE,gBAAA;EACA,mBAAA;Abm7DF;Aah7DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;Abk7DF;Aa/6DA;EACE,YAAA;Abi7DF;Aa56DA;EACE,eAAA;Ab86DF;Aa36DA;EACE,cAAA;EACA,gBAAA;EACA,WAAA;Ab66DF;Aa16DA;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;Ab46DF;Aaz6DA;EACE,WAAA;Ab26DF;Aax6DA;EACE,cAAA;EACA,eAAA;Ab06DF;Aav6DA;EACE,cAAA;EACA,eAAA;Aby6DF;Aat6DA;;EAEE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,SAAA;EACA,8BAAA;Abw6DF;Aar6DA;EACE,UAAA;Abu6DF;Aap6DA;EACE,aAAA;Abs6DF;Aan6DA;EACE,aAAA;Abq6DF;Aal6DA;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qCAAA;EACA,iBAAA;EACA,sBAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;Abo6DF;Aaj6DA;EACE,gBAAA;Abm6DF;Aah6DA;EACE;IAEE,gBAAA;Ebi6DF;AACF;Aa95DA;EACE,YAAA;EACA,eAAA;EACA,oBAAA;Abg6DF;Aa75DA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;Ab+5DF;Aa55DA;EACE,mBAAA;Ab85DF;Aa35DA;EACE,iBAAA;EACA,yBAAA;Ab65DF;Aa15DA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;Ab45DF;Aaz5DA;;EAGI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;Ab05DJ;Aax5DI;;EACE,yBAAA;Ab25DN;Aax5DI;;EACE,yBAAA;EACA,aAAA;EACA,gBAAA;Ab25DN;Aat5DA;EACE,kBAAA;Abw5DF;Aar5DA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;Abu5DF;Aar5DE;EACE,cAAA;Abu5DJ;Aan5DA;EACE,eAAA;EACA,WAAA;EACA,kBAAA;Abq5DF;Aan4DA;EATE,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;Ab+4DF;Aax4DA;EACE,kBAAA;EAEA,sBAAA;EACA,YAAA;EDrwBA,wBAAA;EACQ,gBAAA;ECswBR,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;Ab04DF;Aax4DE;;;;;;EAME,aAAA;EACA,iBAAA;Ab04DJ;Aav4DE;EACE,yBAAA;Aby4DJ;Aat4DE;;EAvCA,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;Abi7DF;Aa34DE;EA5CA,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;EAwCE,oCAAA;EACA,yBAAA;Abm5DJ;Aa94DA;EACE,gBAAA;EACA,YAAA;Abg5DF;Aal5DA;;EAMI,eAAA;Abg5DJ;Aa54DA;EACE,iBAAA;EACA,eAAA;EACA,iBAAA;Ab84DF;Aa34DA;EACE,eAAA;EACA,aAAA;Ab64DF;Aa14DA;EACE,eAAA;Ab44DF;Aaz4DA;EACE,kBAAA;EACA,eAAA;ENl0BA,0BAAA;EACA,uBAAA;EACA,kBAAA;AP8sFF;Aaz4DA;;EAEE,mBAAA;EACA,YAAA;EACA,uEAAA;EAEA,WAAA;EACA,gBAAA;Ab04DF;Aax4DE;;EACE,uEAAA;EAEA,WAAA;Ab04DJ;Aav4DE;;;;EAEE,mBAAA;EACA,uEAAA;EACA,WAAA;Ab24DJ;Aax4DE;;;;EA1GA,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;Abw/DF;Aa94DA;EGh6BE,kBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;EH85BA,iBAAA;EACA,mBAAA;Abo5DF;AgBhzFE;;EAEE,mBAAA;EACA,WAAA;AhBkzFJ;AgB/yFE;;;EAGE,yBAAA;EACA,WAAA;AhBizFJ;AgB/yFE;;;EAGE,sBAAA;AhBizFJ;AgB9yFE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;AhBgzFJ;AgBtyFI;;;;;;;;;;;;;;;EAKE,yBAAA;EACA,yBAAA;AhBkzFN;Aa/7DA;EG/2BI,cAAA;EACA,sBAAA;AhBizFJ;AgB5zFI;;;;;;;;;;EAKE,yBAAA;EACA,yBAAA;AhBm0FN;Aar8DA;EJ76BE,cAAA;EACA,qCAAA;EACA,qBAAA;ATq3FF;ASn3FE;;;;;EAKE,cAAA;EACA,qCAAA;EACI,qBAAA;ATq3FR;ASn3FE;;;EAGE,sBAAA;ATq3FJ;ASh3FI;;;;;;;;;;;;;;;EAKE,qCAAA;EACI,qBAAA;AT43FV;Aa1+DA;EJ74BI,0BAAA;EACA,yBAAA;AT03FJ;ASt4FI;;;;;;;;;;EAKE,qCAAA;EACI,qBAAA;AT64FV;Aan/DE;;EDv3BA,wBAAA;EACQ,gBAAA;AZ82FV;Aal/DA;EACE,mBAAA;EACA,mEAAA;EACA,0CAAA;EACA,cAAA;EACA,YAAA;Abo/DF;Aal/DE;EACE,mBAAA;EACA,mEAAA;Abo/DJ;Aaj/DE;;EAEE,mEAAA;Abm/DJ;Aah/DE;;EA1JA,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;Ab8oEF;Aap/DA;EJl9BE,cAAA;EACA,yBAAA;EACA,qBAAA;ATy8FF;ASv8FE;;;;;EAKE,cAAA;EACA,yBAAA;EACI,qBAAA;ATy8FR;ASv8FE;;;EAGE,sBAAA;ATy8FJ;ASp8FI;;;;;;;;;;;;;;;EAKE,yBAAA;EACI,qBAAA;ATg9FV;AazhEA;EJl7BI,cAAA;EACA,yBAAA;AT88FJ;AS19FI;;;;;;;;;;EAKE,yBAAA;EACI,qBAAA;ATi+FV;AajiEE;;ED75BA,wBAAA;EACQ,gBAAA;EC+5BN,yBAAA;AboiEJ;Aa/hEA;EACE,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,4BAAA;EACA,4BAAA;EACA,+BAAA;EACA,yBAAA;EACA,qBAAA;AbiiEF;Aa/hEE;;;EAGE,yBAAA;EACA,qBAAA;AbiiEJ;Aa9hEE;;;;EAIE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;EACA,kCAAA;EACA,qCAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;AbgiEJ;Aa7hEE;EACE,UAAA;EACA,2BAAA;Ab+hEJ;Aa5hEE;EACE,2BAAA;Ab8hEJ;Aa1hEA;EACE,yBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;Ab4hEF;Aa1hEE;EACE,qBAAA;EACA,YAAA;Ab4hEJ;AaxhEA;EACE,sBAAA;Ab0hEF;AaxhEE;;;;EAIE,gBAAA;EACA,sBAAA;EACA,eAAA;Ab0hEJ;AavhEE;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;AbyhEJ;AaphEA;EAEI,eAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;AbqhEJ;AanhEI;EACE,yBAAA;AbqhEN;Aa7hEA;EAaI,8BAAA;AbmhEJ;AahiEA;EAiBI,+BAAA;AbkhEJ;AaniEA;EAqBI,iBAAA;EDxgCF,oDAAA;EACQ,4CAAA;ECygCN,YAAA;EAEA,yBAAA;AbihEJ;Aa7gEA;EAEI,iBAAA;EACA,cAAA;Ab8gEJ;Aa5gEI;EACE,yBAAA;EACA,cAAA;Ab8gEN;AarhEA;EAYI,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,gDAAA;Ab4gEJ;AazgEE;EACE,gBAAA;Ab2gEJ;AatgEA;;;EAGE,cAAA;AbwgEF;AargEA;EACE,mBAAA;AbugEF;AapgEI;EACE,yBAAA;EACA,oBAAA;AbsgEN;AangEI;EACE,yBAAA;EACA,oBAAA;AbqgEN;AalgEI;EACE,aAAA;AbogEN;Aa//DA;EAEI,aAAA;AbggEJ;Aa5/DA;EACE,eAAA;Ab8/DF;Aa1/DA;EACE,mBAAA;EACA,gBAAA;Ab4/DF;Aa1/DE;EAEI,gCAAA;EACA,6BAAA;EACA,cAAA;EACA;;yBAAA;Ab6/DN;Aax/DM;EACE,6BAAA;EACA,cAAA;EACA,gCAAA;Ab0/DR;Aav/DM;EACE,6BAAA;EACA,cAAA;Aby/DR;Aa/gEA;EA4BI,eAAA;EACA,oCAAA;EACA,gBAAA;EACA,6BAAA;EACA,cAAA;EACA,eAAA;Abs/DJ;Aap/DI;EACE,yBAAA;EACA,cAAA;EACA,gCAAA;Abs/DN;Aan/DI;EACE,yBAAA;EACA,oBAAA;EACA,gCAAA;Abq/DN;Aal/DI;EACE,aAAA;Abo/DN;Aa/+DA;EAEI,kBAAA;Abg/DJ;Aa5+DA;EACE,eAAA;Ab8+DF;Aa1+DA;EACE,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;Ab4+DF;Aaj/DA;EAQI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;Ab4+DJ;Aa1+DI;EACE,aAAA;EDlqCJ,wBAAA;EACQ,gBAAA;AZ+oGV;Aa1+DI;EACE,yBAAA;Ab4+DN;Aaz+DI;;EAEE,yBAAA;EAEA,cAAA;EACA,gBAAA;Ab0+DN;Aa/+DI;;EAQI,cAAA;Ab2+DR;Aav+DI;;EAEE,kBAAA;Aby+DN;AalhEA;EA6CM,cAAA;EACA,cAAA;EACA,iBAAA;Abw+DN;Aar+DI;EDjsCF,wDAAA;EACQ,gDAAA;ECksCJ,2BAAA;Abw+DN;Aal+DA;EACE,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EN5sCA,0BAAA;EACA,uBAAA;EACA,kBAAA;APirGF;Aap+DE;EACE,oCAAA;EACA,WAAA;Abs+DJ;Aan+DE;EACE,sCAAA;EACA,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;Abq+DJ;Aax/DA;EAuBI,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;EACA,+BAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,MAAA;EACA,YAAA;Abo+DJ;Aah+DA;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;Abk+DF;Aa99DA;EACE,yBAAA;ED3vCA,wDAAA;EACQ,gDAAA;ELAR,0BAAA;EACA,uBAAA;EACA,kBAAA;GOhEA,OAAA;Ad8xGF;AexxGE;;EAEE,YAAA;EACA,cAAA;Af0xGJ;AexxGE;EACE,WAAA;Af0xGJ;AcryGE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;AdqyGJ;AcnyGE;EACE,WAAA;AdqyGJ;Aah/DA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;Abk/DF;Aav/DA;EAQI,eAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;Abk/DJ;Aa/+DE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,6IAAA;EASA,yFAAA;EAOA,sFAAA;EAOA,oFAAA;EAOA,iFAAA;EAOA,kBAAA;EACA,QAAA;EACA,WAAA;Abi9DJ;Aa58DA;EACE,aAAA;EACA,aAAA;EACA,gBAAA;EACA,+DAAA;EACA,uDAAA;EACA,WAAA;Ab88DF;Aa58DE;EACE,+DAAA;EACA,uDAAA;EACA,kBAAA;Ab88DJ;Aa38DE;EACE,gBAAA;EACA,+CAAA;EACA,uCAAA;Ab68DJ;Aax8DA;EAEE,cAAA;EACA,eAAA;EACA,aAAA;Aby8DF;Aa78DA;EAOI,kBAAA;Aby8DJ;Aat8DE;EACE,aAAA;Abw8DJ;Aat8DI;EACE,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;Abw8DN;Aap8DE;EACE,yCAAA;EACA,qCAAA;EAGA,WAAA;EACA,+BAAA;EACA,gBAAA;EAEA,wBAAA;EACA,mBAAA;Abm8DJ;Aaj8DI;EACE,gBAAA;Abm8DN;Aap8DI;EAII,gBAAA;EACA,eAAA;Abm8DR;Aa57DI;;EACE,2BAAA;Ab+7DN;Aa57DI;;EAEI,4BAAA;Ab87DR;Aa17DI;;EACE,oBAAA;Ab67DN;Aax7DA;EACE,kCAAA;EACA,cAAA;Ab07DF;Aa57DA;EAKI,kCAAA;EACA,8BAAA;EACA,cAAA;EACA,eAAA;Ab07DJ;Aav7DE;EAEI,yCAAA;Abw7DN;Aat7DM;EACE,8BAAA;Abw7DR;Aan7DE;EAEI,0CAAA;Abo7DN;Aal7DM;EACE,+BAAA;Abo7DR;Aa98DA;EAgCI,eAAA;Abi7DJ;Aa36DA;ED57CE,sCAAA;EACQ,8BAAA;EC67CR,UAAA;EACA,kBAAA;Ab86DF;Aaj7DA;EAMI,UAAA;EACA,SAAA;EAgBA,gBAAA;Ab+5DJ;Aa76DI;EAEI,2BAAA;EACA,8BAAA;Ab86DR;Aa16DI;EAEI,4BAAA;EACA,+BAAA;Ab26DR;Aar6DI;EACE,SAAA;Abu6DN;Aaj8DA;EA8BM,gBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;Abs6DN;Aap6DM;EACE,aAAA;EDp+CN,wBAAA;EACQ,gBAAA;AZ24GV;Aap6DM;EACE,yBAAA;Abs6DR;Aan6DM;;EAEE,yBAAA;EACA,cAAA;EACA,gBAAA;Abq6DR;Aaz9DA;;;EA6DM,yBAAA;EACA,cAAA;EACA,gBAAA;Abi6DN;Aa55DA;;EAEE,gBAAA;EACA,eAAA;Ab85DF;Aa15DA;;EAEE,YAAA;EACA,WAAA;Ab45DF;Aav5DA;EACE,qBAAA;Aby5DF;Aat5DA;EACE,YAAA;Abw5DF;Aar5DA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;Abu5DF;Aap5DA;EACE,gBAAA;Abs5DF;Aal5DA;EACE,cAAA;EACA,eAAA;ED96CA,mEAAA;EACK,8DAAA;EACG,2DAAA;AZm0GV;Aal5DA;EACE,WAAA;Abo5DF;Aaj5DA;EACE,sBAAA;Abm5DF;Aah5DA;EACE,6BAAA;Abk5DF;Aa/4DA;EACE,aAAA;EACA,oBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;Abi5DF;Aa14DA;EACE,iBAAA;Ab44DF;Aax4DA;EACE,yBAAA;EACA,sBAAA;EACA,mBAAA;Ab04DF;Aa74DA;EAMI,cAAA;EACA,gBAAA;EACA,kBAAA;Ab04DJ;Aal5DA;EAYI,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;Aby4DJ;Aax5DA;EAmBI,gBAAA;Abw4DJ;Aap4DA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;Abs4DF;Aan4DA;EACE,mBAAA;EACA,gCAAA;GCzqDA,OAAA;Ed+iHA,mCAAmC;EACnC,4DAA4D;AAC9D;Ae3iHE;;EAEE,YAAA;EACA,cAAA;Af6iHJ;Ae3iHE;EACE,WAAA;Af6iHJ;AcxjHE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;AdwjHJ;ActjHE;EACE,WAAA;AdwjHJ;Aa35DA;EAMI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;Abw5DJ;Aat5DI;EACE,gBAAA;EACA,WAAA;Abw5DN;Aar6DA;EAkBI,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;Abs5DJ;Aa56DA;EA0BI,mBAAA;Abq5DJ;Aa/6DA;EA8BI,iBAAA;Abo5DJ;Aal7DA;EAkCI,mBAAA;Abm5DJ;Aar7DA;EAsCI,eAAA;Abk5DJ;Aax7DA;EA0CI,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,YAAA;Abi5DJ;Aaj8DA;EAmDM,gBAAA;Abi5DN;Aap8DA;EAwDI,oBAAA;EACA,WAAA;Ab+4DJ;Aax8DA;EA4DM,WAAA;EACA,YAAA;Ab+4DN;Aa58DA;EAkEI,WAAA;EACA,cAAA;Ab64DJ;Aah9DA;EAsEM,UAAA;Ab64DN;Aan9DA;EA2EI,YAAA;EACA,kBAAA;EACA,WAAA;Ab24DJ;Aax9DA;EAgFM,iBAAA;EACA,YAAA;EACA,eAAA;Ab24DN;Aa79DA;EAsFM,YAAA;Ab04DN;Aah+DA;;EA4FQ,cAAA;Abw4DR;Aap+DA;;EAmGQ,cAAA;Abq4DR;Aax+DA;EAyGI,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EAEA,YAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EN/tDF,wBAAA;EACA,qBAAA;EACA,gBAAA;APimHF;Aa1/DA;;EA2HM,eAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;Abm4DN;Aah4DI;EACE,yBAAA;Abk4DN;Aan4DI;EAII,0BAAA;Abk4DR;Aat4DI;;EASI,2BAAA;Abi4DR;Aa73DI;;;EAGE,cAAA;EACA,gBAAA;EACA,yBAAA;Ab+3DN;Aap4DI;;;EAQI,0BAAA;Abi4DR;AavhEA;EA2JM,QAAA;EACA,SAAA;EACA,kCAAA;EACA,qCAAA;EACA,+BAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,WAAA;Ab+3DN;Aa73DM;EACE,YAAA;EACA,0BAAA;EACA,UAAA;Ab+3DR;Aa33DI;EACE,eAAA;EACA,4BAAA;Ab63DN;Aa/3DI;EAKI,uBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;Ab63DR;Aa34DI;EAkBI,uBAAA;Ab43DR;Aax3DI;EACE,qBAAA;EACA,eAAA;EACA,cAAA;EACA,uBAAA;Ab03DN;AajkEA;EA8MI,kBAAA;EACA,sBAAA;Abs3DJ;AarkEA;EAmNQ,qBAAA;Abq3DR;Aal3DM;EACE,YAAA;Abo3DR;Aa92DE;EACE,6BAAA;EACA,mBAAA;Abg3DJ;Aal3DE;;EAOM,iBAAA;Ab+2DR;AanlEA;EA2OI,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;Ab22DJ;AazlEA;EAiPM,iBAAA;EACA,kBAAA;Ab22DN;Aaz2DM;EACE,eAAA;Ab22DR;AahmEA;EAyPQ,cAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;Ab02DR;Aah2DA;GCh7DE,OAAA;EDk7DA,6BAAA;EACA,uBAAA;EAEA,eAAA;EDx3DA,uDAAA;EACQ,+CAAA;EC03DR,yBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;Abi2DF;AetxHE;;EAEE,YAAA;EACA,cAAA;AfwxHJ;AetxHE;EACE,WAAA;AfwxHJ;AcnyHE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;AdmyHJ;AcjyHE;EACE,WAAA;AdmyHJ;Aa73DA;;;EAgBI,oBAAA;EACA,oBAAA;Abk3DJ;Aa72DA;EACE,WAAA;Ab+2DF;Aa72DE;EACE,oBAAA;EACA,uBAAA;Ab+2DJ;Aaj3DE;EAKI,0CAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;Ab+2DN;Aa32DE;EACE,oBAAA;EACA,sBAAA;Ab62DJ;Aa/2DE;EAKI,0CAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;Ab62DN;Aaz2DE;EACE,UAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;Ab22DJ;Aaj3DE;EASI,UAAA;Ab22DN;Aap3DE;EAaI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,0BAAA;EACA,YAAA;Ab02DN;Aa53DE;EAsBI,cAAA;EACA,aAAA;EACA,YAAA;Aby2DN;Aaj4DE;EA4BI,YAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,cAAA;EDh1DJ,4BAAA;EACK,uBAAA;EACG,oBAAA;AZyrHV;Aax2DM;EACE,WAAA;EACA,wCAAA;Ab02DR;Aa52DM;EAKI,wCAAA;Ab02DV;Aat2DM;EACE,cAAA;EACA,wCAAA;Abw2DR;Aa12DM;EAKI,wCAAA;Abw2DV;Aa55DE;EA0DI,4CAAA;EACA,wCAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;Abq2DN;Aaj2DE;EAEE,SAAA;EACA,YAAA;EACA,gBAAA;EAGA,yBAAA;EACA,kBAAA;EACA,6BAAA;EACA,0CAAA;EACA,kBAAA;Abg2DJ;Aa91DI;EACE,eAAA;Abg2DN;Aa71DI;EACE,4BAAA;Ab+1DN;Aa71DM;EACE,4BAAA;Ab+1DR;Aat9DA;EA6HI,kBAAA;EACA,iCAAA;Ab41DJ;Aat1DA;EACE,eAAA;EACA,aAAA;EACA,OAAA;EAEA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,sBAAA;EDl6DA,mEAAA;EACK,8DAAA;EACG,2DAAA;AZ0vHV;Aat2DA;EA4BI,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;Ab60DJ;Aa71DI;;EAjqCF,mBAAA;EACA,mEAAA;EACA,0CAAA;EACA,cAAA;EACA,YAAA;AbkgGF;AahgGE;;EACE,mBAAA;EACA,mEAAA;AbmgGJ;AahgGE;;;;EAEE,mEAAA;AbogGJ;AajgGE;;;;EA1JA,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;AbiqGF;Aav3DI;;EAhzCF,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;Ab2qGF;Aax5DA;EAqCM,YAAA;EACA,gBAAA;Abs3DN;Aaj3DA;EACE,gBAAA;Abm3DF;Aah3DA;EACE,eAAA;EACA,kBAAA;Abk3DF;Aa/2DA;;;EAGE,iBAAA;Abi3DF;Aa92DA;EACE,WAAA;Abg3DF;Aa72DA;EACE,YAAA;Ab+2DF;Aa52DA;EACE,YAAA;EACA,mBAAA;Ab82DF;Aa32DA;EACE,YAAA;EACA,iBAAA;Ab62DF;AACA,uCAAuC;Aa12DvC;;EAEE,wBAAA;EACA,SAAA;Ab42DF;AACA,qDAAqD;Aaz2DrD;EACE,wBAAA;EACA,gCAAA;EACA,gBAAA;EACA,wBAAA;Ab22DF;Aax2DA;EACE,uBAAA;EACA,+BAAA;EACA,gBAAA;EACA,wBAAA;Ab02DF;Aat2DA;EACE,yBAAA;EACA,iCAAA;EACA,cAAA;Abw2DF;AACA,oBAAoB;Aar2DpB;EACE,gBAAA;EACA,WAAA;Abu2DF;Aal2DA;EACE,oCAAA;EACA,aAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;Abo2DF;Aa/1DA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,8BAAA;EACA,yCAAA;EACA,yBAAA;EACA,oDAAA;Abi2DF;Aa91DA;EACE;IACE,yBAAA;IACA,8BAAA;IACA,iCAAA;Ebg2DF;AACF;Aa51DA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;Ab81DF;Aa31DA;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAEA,kBAAA;EACA,oCAAA;EACA,0BAAA;EAEA,2CAAA;EACA,sBAAA;EACA,qBAAA;Eb01DA,qBAAqB;Eav1DrB,kBAAA;EACA,mBAAA;EAEA,oBAAA;Abw1DF;Aar1DA;EACE;IACE,+CAAA;Ebu1DF;AACF;AACA,iBAAiB;Aan1DjB;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;Abq1DF;Aal1DA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;Abo1DF;Aaj1DA;EACE,uCAAA;EACA,yBAAA;EACA,yEAAA;Abm1DF;Aah1DA;EACE,mBAAA;Abk1DF;Aa/0DA;EACE,uBAAA;Abi1DF;Aa90DA;EACE,uBAAA;Abg1DF;Aa70DA;EACE,uBAAA;Ab+0DF;Aa50DA;EACE,uBAAA;Ab80DF;Aa30DA;EACE;IACE,uBAAA;Eb60DF;Ea10DA;IACE,yBAAA;Eb40DF;AACF;Aav0DA;EACE,aAAA;Aby0DF;Aat0DA;EAEE,eAAA;Abu0DF;Aap0DA;EACE,kBAAA;Abs0DF;Aan0DA;EACE,cAAA;EACA,mBAAA;Abq0DF;Aal0DA;EACE,sBAAA;Abo0DF;Aaj0DA;EACE,gBAAA;Abm0DF;Aa/zDA;EACE,iBAAA;EACA,kBAAA;Abi0DF;Aa9zDA;EACE,iBAAA;Abg0DF;Aa7zDA;EACE,kBAAA;Ab+zDF;Aa3zDA;EACE,iBAAA;EACA,kBAAA;Ab6zDF;Aa1zDA;EACE,eAAA;Ab4zDF;AazzDA;EACE,gBAAA;Ab2zDF;AatzDA;EACE,iBAAA;EACA,gBAAA;AbwzDF;AarzDA;EACE,0BAAA;EACA,6BAAA;AbuzDF;AapzDA;EACE,6BAAA;AbszDF;AanzDA;EACE,2BAAA;EACA,8BAAA;AbqzDF;AalzDA;EACE,gBAAA;EACA,mBAAA;AbozDF;AajzDA;EACE,mBAAA;AbmzDF;AahzDA;EACE,gBAAA;AbkzDF;Aa/yDA;EACE,gBAAA;AbizDF;Aa5yDA;EACE,gBAAA;Ab8yDF;AazyDA;EAEI,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;Ab0yDJ;Aa/yDA;EAQM,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;Ab0yDN;AaxzDA;EAkBM,aAAA;EACA,eAAA;EACA,gBAAA;AbyyDN;Aa7zDA;EAwBM,eAAA;EACA,iBAAA;AbwyDN;AajyDA;EACE,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mGAAA;EAGA,mBAAA;AbiyDF;AazyDA;EAWI,aAAA;AbiyDJ;AACA,kDAAkD;AAClD,0DAA0D;AAC1D,sDAAsD;Aa3xDtD;EACE;IACE,mBAAA;Eb6xDF;Ea1xDA;IACE,mBAAA;Eb4xDF;EazxDA;IACE,iBAAA;IACA,kBAAA;Eb2xDF;EaxxDA;IACE,iBAAA;Eb0xDF;EavxDA;IACE,kBAAA;EbyxDF;EatxDA;IACE,2BAAA;EbwxDF;EapxDE;IACE,gBAAA;EbsxDJ;EavxDE;IAII,iBAAA;EbsxDN;EajxDA;IXh9EA,gCAAA;IK2FA,4BAAA;IACA,oCAAA;IP0oIE,sBAAsB;IOxoIxB,+BAAA;IP0oIE,YAAY;IOxoId,iCAAA;IP0oIE,cAAc;EAChB;EarxDA;IXt9EA,+BAAA;IK2FA,2BAAA;IACA,mCAAA;IPopIE,sBAAsB;IOlpIxB,8BAAA;IPopIE,YAAY;IOlpId,gCAAA;IPopIE,cAAc;EAChB;Ea/xDA;IXt9EA,4BAAA;IK2FA,wBAAA;IACA,gCAAA;IP8pIE,sBAAsB;IO5pIxB,2BAAA;IP8pIE,YAAY;IO5pId,6BAAA;IP8pIE,cAAc;EAChB;EazyDA;IAUI,eAAA;IACA,eAAA;IACA,MAAA;IACA,SAAA;IACA,OAAA;IACA,QAAA;IACA,YAAA;IACA,WAAA;IACA,aAAA;IACA,0CAAA;EbkyDJ;Ea9xDA;IACE,eAAA;IACA,gBAAA;IACA,gBAAA;EbgyDF;AACF;AACA,0CAA0C;Aa7xD1C;EAEE;IAEE,iBAAA;IACA,eAAA;Eb6xDF;Ea1xDA;IAGI,iBAAA;IACA,eAAA;Eb0xDJ;Ea9xDA;IAQI,OAAA;EbyxDJ;EajyDA;IAYI,aAAA;EbwxDJ;EanxDA;IACE,eAAA;IACA,gBAAA;EbqxDF;EalxDA;IACE,eAAA;EboxDF;EajxDA;IACE,gBAAA;EbmxDF;Ea/wDA;IACE,OAAA;IACA,wBAAA;EbixDF;Ea9wDA;IAEI,qBAAA;Eb+wDJ;EajxDA;IASI,cAAA;Eb2wDJ;EapxDA;IAaI,YAAA;IACA,cAAA;Eb0wDJ;EaxxDA;IAiBM,WAAA;Eb0wDN;Ea3xDA;IAsBI,+BAAA;EbwwDJ;EapwDA;IACE,eAAA;EbswDF;EajwDE;IACE,QAAA;EbmwDJ;EapwDE;IAII,UAAA;IACA,WAAA;EbmwDN;Ea9vDA;IAEI,iBAAA;Eb+vDJ;Ea3vDA;IACE,gBAAA;Eb6vDF;Ea1vDA;IACE,gBAAA;IACA,cAAA;IACA,WAAA;Eb4vDF;EazvDA;IACE,YAAA;Eb2vDF;EaxvDA;IACE,WAAA;Eb0vDF;AACF;AACA,4CAA4C;AavvD5C;EACE;IACE,WAAA;IACA,gBAAA;EbyvDF;AACF;AACA,2CAA2C;AatvD3C;EACE;IACE,gBAAA;EbwvDF;AACF;AACA,4EAA4E;AanvD5E;EAEI;IAEI,WAAA;EbmvDN;Ea/uDE;IAEI,YAAA;EbgvDN;AACF;Aa3tDG;EACC,iBAAA;EACA,kBAAA;Ab6tDJ;Aa1tDG;EACC,iBAAA;Ab4tDJ;AaztDG;EACC,kBAAA;Ab2tDJ;AapvDG;EACC,aAAA;AbsvDJ;AanvDG;EACC,aAAA;AbqvDJ;AalvDG;EACC,aAAA;EACA,gBAAA;AbovDJ;Aa9vDG;EACC,cAAA;AbgwDJ;Aa7vDG;EACC,cAAA;Ab+vDJ;Aa5vDG;EACC,cAAA;EACA,iBAAA;Ab8vDJ;AaxwDG;EACC,cAAA;Ab0wDJ;AavwDG;EACC,cAAA;AbywDJ;AatwDG;EACC,cAAA;EACA,iBAAA;AbwwDJ;AalxDG;EACC,cAAA;AboxDJ;AajxDG;EACC,cAAA;AbmxDJ;AahxDG;EACC,cAAA;EACA,iBAAA;AbkxDJ;AapvDA;EAzBG;IACC,iBAAA;IACA,kBAAA;EbgxDF;Ea7wDC;IACC,iBAAA;Eb+wDF;Ea5wDC;IACC,kBAAA;Eb8wDF;EavyDC;IACC,aAAA;EbyyDF;EatyDC;IACC,aAAA;EbwyDF;EaryDC;IACC,aAAA;IACA,gBAAA;EbuyDF;EajzDC;IACC,cAAA;EbmzDF;EahzDC;IACC,cAAA;EbkzDF;Ea/yDC;IACC,cAAA;IACA,iBAAA;EbizDF;Ea3zDC;IACC,cAAA;Eb6zDF;Ea1zDC;IACC,cAAA;Eb4zDF;EazzDC;IACC,cAAA;IACA,iBAAA;Eb2zDF;Ear0DC;IACC,cAAA;Ebu0DF;Eap0DC;IACC,cAAA;Ebs0DF;Ean0DC;IACC,cAAA;IACA,iBAAA;Ebq0DF;AACF;AanyDA;EA9BG;IACC,iBAAA;IACA,kBAAA;Ebo0DF;Eaj0DC;IACC,iBAAA;Ebm0DF;Eah0DC;IACC,kBAAA;Ebk0DF;Ea31DC;IACC,aAAA;Eb61DF;Ea11DC;IACC,aAAA;Eb41DF;Eaz1DC;IACC,aAAA;IACA,gBAAA;Eb21DF;Ear2DC;IACC,cAAA;Ebu2DF;Eap2DC;IACC,cAAA;Ebs2DF;Ean2DC;IACC,cAAA;IACA,iBAAA;Ebq2DF;Ea/2DC;IACC,cAAA;Ebi3DF;Ea92DC;IACC,cAAA;Ebg3DF;Ea72DC;IACC,cAAA;IACA,iBAAA;Eb+2DF;Eaz3DC;IACC,cAAA;Eb23DF;Eax3DC;IACC,cAAA;Eb03DF;Eav3DC;IACC,cAAA;IACA,iBAAA;Eby3DF;AACF;Aal1DA;EAnCG;IACC,iBAAA;IACA,kBAAA;Ebw3DF;Ear3DC;IACC,iBAAA;Ebu3DF;Eap3DC;IACC,kBAAA;Ebs3DF;Ea/4DC;IACC,aAAA;Ebi5DF;Ea94DC;IACC,aAAA;Ebg5DF;Ea74DC;IACC,aAAA;IACA,gBAAA;Eb+4DF;Eaz5DC;IACC,cAAA;Eb25DF;Eax5DC;IACC,cAAA;Eb05DF;Eav5DC;IACC,cAAA;IACA,iBAAA;Eby5DF;Ean6DC;IACC,cAAA;Ebq6DF;Eal6DC;IACC,cAAA;Ebo6DF;Eaj6DC;IACC,cAAA;IACA,iBAAA;Ebm6DF;Ea76DC;IACC,cAAA;Eb+6DF;Ea56DC;IACC,cAAA;Eb86DF;Ea36DC;IACC,cAAA;IACA,iBAAA;Eb66DF;AACF;Aaj4DA;EAxCG;IACC,iBAAA;IACA,kBAAA;Eb46DF;Eaz6DC;IACC,iBAAA;Eb26DF;Eax6DC;IACC,kBAAA;Eb06DF;Ean8DC;IACC,aAAA;Ebq8DF;Eal8DC;IACC,aAAA;Ebo8DF;Eaj8DC;IACC,aAAA;IACA,gBAAA;Ebm8DF;Ea78DC;IACC,cAAA;Eb+8DF;Ea58DC;IACC,cAAA;Eb88DF;Ea38DC;IACC,cAAA;IACA,iBAAA;Eb68DF;Eav9DC;IACC,cAAA;Eby9DF;Eat9DC;IACC,cAAA;Ebw9DF;Ear9DC;IACC,cAAA;IACA,iBAAA;Ebu9DF;Eaj+DC;IACC,cAAA;Ebm+DF;Eah+DC;IACC,cAAA;Ebk+DF;Ea/9DC;IACC,cAAA;IACA,iBAAA;Ebi+DF;AACF;Aa/6DA;EACE;IACE,aAAA;Ebi7DF;Ea96DA;;IAEE,aAAA;IACA,UAAA;Ebg7DF;Ea76DA;IACE,UAAA;Eb+6DF;AACF;Aa16DA;EAEI,kBAAA;Ab26DJ;Aaz6DI;EACE,gBAAA;Ab26DN;Aah7DA;EASM,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;Ab06DN;Aa17DA;EAmBQ,eAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;Ab06DR;Aah8DA;EA6BM,cAAA;Abs6DN;Aan8DA;EAkCI,yBAAA;Abo6DJ;Aat8DA;EAqCM,yBAAA;EACA,cAAA;Abo6DN;Aa18DA;EAyCQ,WAAA;Abo6DR;Aaj6DM;EACE,cAAA;EACA,yBAAA;Abm6DR;Aaj9DA;EAoDI,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;Abg6DJ;Aa95DI;EACE,0BAAA;Abg6DN;Aa39DA;EAkEQ,0BAAA;Ab45DR;Aav5DE;EAGM,cAAA;Abu5DR;Aa/4DA;EACE,WAAA;EACA,iBAAA;EACA,oBAAA;EAEA,aAAA;EACA,8BAAA;EACA,SAAA;Abg5DF;Aa74DA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;Ab+4DF;Aa54DA;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8CAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EAEA,uBAAA;EACA,kBAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;Ab24DF;Aax4DA;EApBE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8CAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EAEA,uBAAA;EACA,kBAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EAKA,sBAAA;Abw5DF;Aar5DA;EACE,yBAAA;EACA,iBAAA;EACA,oBAAA;Abu5DF;Aap5DA;EACE,YAAA;Abs5DF;Aan5DA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;Abq5DF;Aaz5DA;EAOI,gBAAA;Abq5DJ;Aa55DA;EAWI,0BAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;Abo5DJ;Aah5DA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;EAEA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;Abi5DF;Aa94DA;EACE,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,iBAAA;EACA,eAAA;EAEA,6BAAA;Ab+4DF;Aa74DE;EACE,mBAAA;Ab+4DJ;Aa34DA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;Ab64DF;Aal5DA;EAQI,kBAAA;Ab64DJ;Aar5DA;EAYI,gBAAA;Ab44DJ;Aax4DA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;Ab04DF;Aav4DA;EACE,0BAAA;Aby4DF;Aav4DE;EACE,kBAAA;Aby4DJ;Aat4DE;EACE,gBAAA;Abw4DJ;Aar4DE;EACE,aAAA;Abu4DJ;Aap4DE;EACE,aAAA;EACA,gBAAA;Abs4DJ;Aal4DA;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;EAEA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;Abm4DF;Aah4DA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;Abk4DF;Aar4DA;EAMI,aAAA;EACA,sBAAA;EACA,QAAA;EAEA,eAAA;EACA,iBAAA;EACA,WAAA;Abi4DJ;Aa74DA;EAeM,eAAA;EACA,iBAAA;EACA,WAAA;Abi4DN;Aal5DA;EAsBI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EAEA,oBAAA;EACA,sBAAA;EACA,kBAAA;Ab83DJ;Aa13DA;EAGM,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,+BAAA;EACA,iBAAA;EAEA,wCAAA;Aby3DN;Aav3DM;EACE,kBAAA;Aby3DR;Aat4DA;EAmBI,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;Abs3DJ;Aa74DA;EA0BM,gBAAA;Abs3DN;Aap3DM;EACE,kBAAA;EACA,2BAAA;Abs3DR;Aan3DM;EACE,4BAAA;Abq3DR;Aav5DA;EAwCI,eAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;Abk3DJ;Aa75DA;EA8CM,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;Abk3DN;Aah3DM;EACE,kBAAA;EACA,2BAAA;Abk3DR;Aa/2DM;EACE,4BAAA;Abi3DR;Aa72DI;EACE,sBAAA;EACA,WAAA;EACA,yCAAA;Ab+2DN;Aal3DI;EAMI,6BAAA;Ab+2DR;Aa72DQ;EACE,2BAAA;Ab+2DV;Aa52DQ;EACE,4BAAA;Ab82DV;Aax7DA;EAiFI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;Ab02DJ;Aat2DA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;Abw2DF;Aa72DA;EAQI,eAAA;EACA,iBAAA;EACA,WAAA;Abw2DJ;Aap2DA;EACE,iBAAA;EACA,mBAAA;EAEA,aAAA;EACA,yBAAA;Abq2DF;Aal2DA;EACE;IACE,2BAAA;IACA,cAAA;Ebo2DF;AACF;Aaj2DA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;Abm2DF;Aax2DA;EAQI,0BAAA;Abm2DJ;Aaj2DI;EACE,qBAAA;Abm2DN;Aa91DA;EAIQ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EAEA,yBAAA;EACA,gBAAA;Ab41DR;Aa11DQ;EACE,cAAA;EACA,iBAAA;Ab41DV;Aa72DA;EA0BQ,gBAAA;Abs1DR;Aan1DM;EAEI,gBAAA;Abo1DV;Aa70DA;EACE;IAEI,aAAA;Eb80DJ;Eah1DA;IAMI,aAAA;IACA,eAAA;IACA,gBAAA;Eb60DJ;Ear1DA;IAWM,cAAA;IACA,UAAA;IACA,sBAAA;IACA,iBAAA;IACA,uBAAA;IACA,0BAAA;IACA,gBAAA;Eb60DN;Ea30DM;IACE,iBAAA;Eb60DR;Eaj2DA;IA0BI,aAAA;IACA,eAAA;IACA,mBAAA;IACA,gBAAA;IACA,WAAA;IACA,iBAAA;IACA,6EAAA;IAGA,kBAAA;Ebw0DJ;Ea32DA;IAsCM,cAAA;IACA,UAAA;IACA,sBAAA;IACA,gBAAA;IACA,4BAAA;IACA,kBAAA;IACA,uBAAA;Ebw0DN;Eat0DM;IACE,iBAAA;Ebw0DR;Ear0DM;IACE,UAAA;IACA,4BAAA;Ebu0DR;Eap0DM;IACE,UAAA;IACA,2BAAA;Ebs0DR;Ea/3DA;IA8DM,yBAAA;IACA,kBAAA;IACA,QAAA;IACA,SAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,eAAA;Ebo0DN;AACF;Aa/zDA;EAIQ;IACE,WAAA;IACA,4BAAA;Eb8zDR;Ea3zDM;IACE,WAAA;IACA,yBAAA;IACA,8BAAA;Eb6zDR;AACF;AavzDA;EAIQ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EAEA,mBAAA;EACA,sBAAA;EACA,YAAA;AbqzDR;AanzDQ;EACE,iBAAA;AbqzDV;Aan0DA;EAuBQ,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;Ab+yDR;Aa7yDQ;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EAEA,yBAAA;EACA,sBAAA;EAEA,gBAAA;EACA,mBAAA;Ab6yDV;AatyDA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AbwyDF;AaryDA;EACE,kBAAA;EACA,gBAAA;AbuyDF;AazyDA;EAKI,kBAAA;AbuyDJ;AaryDI;EACE,gBAAA;AbuyDN;AalyDA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;AboyDF;AajyDA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AbmyDF;AahyDA;EACE,aAAA;EACA,uBAAA;EACA,MAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;EACA,0BAAA;EACA,WAAA;EAEA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EAEA,0CAAA;EACA,kBAAA;EACA,gBAAA;EAEA,2DAAA;Ab+xDF;AalzDA;EAsBI,oCAAA;EACA,0BAAA;EACA,2BAAA;EACA,2DAAA;EAEA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;Ab8xDJ;Aa5xDI;EACE,oCAAA;Ab8xDN;Aah0DA;EAuCI,oCAAA;EACA,0BAAA;EACA,wBAAA;EACA,2BAAA;EACA,2DAAA;EACA,0CAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,eAAA;Ab0xDJ;AaxxDI;EACE,oCAAA;Ab0xDN;AarxDA;EACE;IACE,QAAA;IACA,SAAA;IACA,wBAAA;EbuxDF;Ea1xDA;IAMI,OAAA;EbuxDJ;AACF;AanxDA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,oBAAA;AbqxDF;AalxDA;EACE,WAAA;EACA,qCAAA;EACA,kBAAA;EACA,6BAAA;EACA,2DAAA;EACA,eAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,0BAAA;AbkxDF;AahxDE;EACE,yBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;AbkxDJ;Aa9wDA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,cAAA;AbgxDF;Aa7wDA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;Ab+wDF;Aa1wDA;EACE,WAAA;EACA,eAAA;Ab4wDF;Aa9wDA;EAKI,aAAA;EACA,QAAA;Ab4wDJ;AalxDA;;EAWI,kBAAA;EACA,aAAA;EACA,6BAAA;Ab2wDJ;AaxxDA;EAkBM,gBAAA;AbywDN;Aa3xDA;EAwBM,gBAAA;AbswDN;Aa9xDA;EA6BI,yBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;AbowDJ;AapyDA;EAoCI,sBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;AbmwDJ;Aa1yDA;EA2CI,yBAAA;EACA,gCAAA;EACA,kBAAA;AbkwDJ;Aa/yDA;EAiDI,yBAAA;EACA,6BAAA;EACA,kBAAA;EACA,WAAA;AbiwDJ;Aa3vDA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;Ab6vDF;AapwDA;EAUI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;EAEA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,yBAAA;EAEA,YAAA;EACA,kBAAA;EACA,eAAA;EAEA,iCAAA;Ab0vDJ;AanxDA;EA4BM,wBAAA;EACA,iCAAA;Ab0vDN;AavvDI;EACE,yBAAA;EACA,cAAA;AbyvDN;Aa3vDI;EAKI,aAAA;AbyvDR;Aa9xDA;EA2CI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,aAAA;AbsvDJ;AavyDA;EAoDM,WAAA;EACA,WAAA;AbsvDN;AACA,8CAA8C;AahvD9C;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,eAAA;EACA,gBAAA;EACA,WAAA;AbivDF;Aa/uDE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,cAAA;EACA,gCAAA;AbivDJ;Aa/uDI;EACE,mBAAA;AbivDN;AarwDA;EAyBI,aAAA;EACA,mBAAA;EACA,QAAA;Ab+uDJ;Aa1wDA;EA+BI,WAAA;Ab8uDJ;AaxuDA;EACE,iBAAA;EACA,UAAA;Ab0uDF;AavuDA;EACE,cAAA;EACA,oBAAA;AbyuDF;AatuDA;EACE;IACE,UAAA;EbwuDF;EaruDA;IACE,eAAA;EbuuDF;AACF;AanuDA;EACE,YAAA;EACA,aAAA;EACA,SAAA;AbquDF;AaxuDA;EAMI,aAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AbquDJ;AahvDA;EAeI,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,gCAAA;EACA,iBAAA;EACA,cAAA;AbouDJ;AazvDA;EAwBM,eAAA;EACA,gBAAA;EACA,cAAA;AbouDN;Aa9vDA;EA+BI,OAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AbkuDJ;AarwDA;EAsCM,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,+BAAA;AbkuDN;Aa7wDA;EA8CQ,aAAA;EACA,sBAAA;EACA,SAAA;AbkuDR;AalxDA;EAmDU,aAAA;EACA,sBAAA;EACA,QAAA;AbkuDV;AavxDA;EAyDU,aAAA;EACA,sBAAA;EACA,QAAA;AbiuDV;Aa5xDA;EAiEM,8BAAA;Ab8tDN;Aa/xDA;EAqEM,6BAAA;EACA,WAAA;EACA,SAAA;Ab6tDN;AapyDA;EA4EI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;Ab2tDJ;Aa5yDA;EAoFM,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;Ab2tDN;AalzDA;EA0FQ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;Ab2tDR;AaxzDA;EAgGU,gBAAA;EACA,cAAA;Ab2tDV;Aa5zDA;EAsGQ,aAAA;EACA,mBAAA;EACA,QAAA;AbytDR;AaltDA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;AbotDF;Aa9tDA;EAaI,gBAAA;EACA,MAAA;EACA,UAAA;EACA,mBAAA;EACA,gCAAA;EACA,iBAAA;EACA,cAAA;AbotDJ;AavuDA;EAsBM,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AbotDN;Aa7uDA;EA8BI,OAAA;EACA,gBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;AbktDJ;AapvDA;EAqCM,YAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,aAAA;EACA,+BAAA;AbktDN;Aa5vDA;EA6CQ,aAAA;EACA,sBAAA;EACA,SAAA;AbktDR;AajwDA;EAkDU,aAAA;EACA,sBAAA;EACA,QAAA;AbktDV;AatwDA;EAwDU,aAAA;EACA,sBAAA;EACA,QAAA;AbitDV;Aa3wDA;EAgEM,8BAAA;Ab8sDN;Aa9wDA;EAoEM,6BAAA;EACA,WAAA;EACA,SAAA;Ab6sDN;AanxDA;EA2EI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,yCAAA;EACA,aAAA;Ab2sDJ;Aa3xDA;EAmFM,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;Ab2sDN;AajyDA;EAyFQ,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;Ab2sDR;AavyDA;EA+FU,gBAAA;EACA,cAAA;Ab2sDV;Aa3yDA;EAqGQ,aAAA;EACA,mBAAA;EACA,QAAA;AbysDR;AansDA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;AbqsDF;AalsDA;EACE,WAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,2BAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AbosDF;AajsDA;EACE,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EAEA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,8GAAA;AbksDF;Aa3sDA;EAeI,gBAAA;EACA,WAAA;Ab+rDJ;Aa3rDA;EACE,oBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;Ab6rDF;Aa1rDA;EACE,mBAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,aAAA;EACA,SAAA;EACA,YAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;Ab4rDF;Aa1rDE;EACE,yBAAA;Ab4rDJ;Aa5sDA;EAoBI,SAAA;Ab2rDJ;AaxrDE;EACE,aAAA;Ab0rDJ;AaltDA;EA4BI,mBAAA;EACA,oBAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AbyrDJ;AarrDA;EACE,iCAAA;AburDF;AarrDE;EACE,oCAAA;AburDJ;AanrDA;EACE,iCAAA;AbqrDF;AanrDE;EACE,oCAAA;AbqrDJ;AajrDA;EACE,iCAAA;AbmrDF;AajrDE;EACE,oCAAA;AbmrDJ;Aa/qDA;EACE,iCAAA;EACA,oCAAA;EACA,sBAAA;AbirDF;Aa/qDE;EACE,oCAAA;AbirDJ;Aa7qDA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;Ab+qDF;Aa5qDA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;Ab8qDF;Aa3qDA;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;Ab6qDF;Aa1qDA;EACE,WAAA;EACA,YAAA;EACA,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;Ab4qDF;Aa1qDE;EACE,yBAAA;Ab4qDJ;AavrDA;EAeI,wCAAA;Ab2qDJ;AarqDA;EACE,sBAAA;EACA,2BAAA;EACA,8BAAA;AbuqDF;AarqDE;EAAA;IACE,4BAAA;IACA,+BAAA;EbwqDF;AACF;AiBptLA;EACE,6BAAA;EACA,iBAAA;EACA,iBAAA;AjBstLF;AiBptLE;EACE,iBAAA;AjBstLJ;AiB5tLA;EAUI,gBAAA;EACA,eAAA;EACA,iBAAA;AjBqtLJ;AiBjuLA;EAeM,iBAAA;AjBqtLN;AiBpuLA;EAkBQ,eAAA;AjBqtLR;AiBvuLA;EAwBI,eAAA;EACA,gBAAA;EACA,eAAA;AjBktLJ;AiB5uLA;EA8BI,gBAAA;AjBitLJ;AiB7sLA;EACE,cAAA;AjB+sLF;AiBhtLA;EAII,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,SAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,cAAA;AjB+sLJ;AiB3tLA;EAeM,WAAA;AjB+sLN;AiB9tLA;EAoBI,cAAA;AjB6sLJ;AiBjuLA;EAwBI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,4CAAA;GH7DF,OAAA;Ad0wLF;AiB3sLI;EACE,eAAA;AjB6sLN;AiB9sLI;EAII,cAAA;AjB6sLR;Ae1wLE;;EAEE,YAAA;EACA,cAAA;Af4wLJ;Ae1wLE;EACE,WAAA;Af4wLJ;AcvxLE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;AduxLJ;AcrxLE;EACE,WAAA;AduxLJ;AiBxtLI;EACE,gBAAA;AjB0tLN;AiBvtLI;EACE,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AjBytLN;AiB7tLI;EAOI,gBAAA;AjBytLR;AiBhuLI;EAWI,eAAA;EACA,gBAAA;AjBwtLR;AiBttLQ;EACE,6BAAA;AjBwtLV;AiBvuLI;EAoBI,cAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AjBstLR;AiBltLI;EACE,eAAA;EACA,kBAAA;AjBotLN;AiBltLM;EACE,yBAAA;EACA,WAAA;AjBotLR;AiBjtLM;;EAEE,yBAAA;AjBmtLR;AiB/sLI;EACE,yBAAA;AjBitLN;AiBltLI;EAII,mBAAA;EAEA,gBAAA;EACA,mBAAA;AjBgtLR;AiB9sLQ;EACE,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AjBgtLV;AiB3sLI;EAEI,iBAAA;AjB4sLR;AiBxsLI;EAEI,WAAA;AjBysLR;AiB3sLI;EAMI,iBAAA;EACA,iBAAA;AjBwsLR;AiBpsLI;EAEI,cAAA;AjBqsLR;AiB50LA;EA6II,WAAA;EACA,gBAAA;EACA,WAAA;AjBksLJ;AiBj1LA;EAkJM,gBAAA;AjBksLN;AiBp1LA;;EAwJI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,6BAAA;EACA,eAAA;AjBgsLJ;AiB9rLI;;;;;;EAGE,yBAAA;EACA,cAAA;AjBmsLN;AiBhsLI;;EACE,yBAAA;EACA,gBAAA;AjBmsLN;AiB/2LA;;;;EAiLM,YAAA;EACA,kBAAA;EACA,YAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;AjBosLN;AiB33LA;EA4LI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;AjBksLJ;AiBj4LA;EAkMM,MAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AjBksLN;AiBv4LA;EA0MI,eAAA;EACA,gBAAA;EACA,iBAAA;AjBgsLJ;AiB9rLI;EACE,yBAAA;AjBgsLN;AiB7rLI;EACE,yBAAA;AjB+rLN;AiBl5LA;EAuNM,cAAA;AjB8rLN;AiB5rLM;EACE,aAAA;EACA,yBAAA;AjB8rLR;AiBz5LA;EAgOM,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AjB4rLN;AiBp6LA;EA6OI,yBAAA;AjB0rLJ;AiBv6LA;EAmPI,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;AjBurLJ;AiBj7LA;EA8PI,UAAA;AjBsrLJ;AiBp7LA;EAkQI,sBAAA;EACA,gBAAA;AjBqrLJ;AiBx7LA;EAuQI,gBAAA;EACA,gBAAA;AjBorLJ;AiB57LA;GH/BE,OAAA;EG4SE,sBAAA;AjBmrLJ;Aez9LE;;EAEE,YAAA;EACA,cAAA;Af29LJ;Aez9LE;EACE,WAAA;Af29LJ;Act+LE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;Ads+LJ;Acp+LE;EACE,WAAA;Ads+LJ;AiBj9LA;EAiRI,cAAA;EACA,mBAAA;EACA,kBAAA;AjBmsLJ;AiBt9LA;EAuRI,UAAA;AjBksLJ;AiBz9LA;EA2RI,UAAA;AjBisLJ;AiB59LA;EA+RI,UAAA;AjBgsLJ;AiB/9LA;EAmSI,YAAA;EACA,oBAAA;AjB+rLJ;AiBn+LA;EAuSM,kBAAA;EACA,eAAA;EACA,gBAAA;AjB+rLN;AiBx+LA;EA4SQ,eAAA;EACA,gBAAA;AjB+rLR;AiB5+LA;EAiTQ,gBAAA;EACA,eAAA;EACA,kBAAA;AjB8rLR;AiBj/LA;EAuTQ,eAAA;EACA,gBAAA;EACA,mBAAA;AjB6rLR;AiBt/LA;EA+TI,WAAA;EACA,gBAAA;EACA,eAAA;AjB0rLJ;AiB3/LA;EAqUI,YAAA;EACA,iBAAA;EACA,gBAAA;AjByrLJ;AACA,kDAAkD;AAClD,0DAA0D;AAC1D,sDAAsD;AiBnrLtD;EAGM;IAEI,mBAAA;EjBkrLR;EiBhrLQ;IACE,SAAA;IACA,eAAA;EjBkrLV;EiB1rLA;IAeI,UAAA;IACA,oBAAA;EjB8qLJ;EiB9rLA;IAoBI,eAAA;EjB6qLJ;EiBjsLA;IAwBI,eAAA;IACA,iBAAA;IACA,cAAA;EjB4qLJ;EiBtsLA;IA8BI,YAAA;IACA,cAAA;EjB2qLJ;EiB1sLA;IAkCM,aAAA;EjB2qLN;EiB7sLA;;;IAyCI,gBAAA;EjByqLJ;EiBltLA;;;IA4CM,UAAA;EjB2qLN;EiBvtLA;IAiDI,YAAA;IACA,oBAAA;EjByqLJ;EiB3tLA;IAqDM,eAAA;IACA,aAAA;IACA,cAAA;EjByqLN;EiBhuLA;;;IAiEI,eAAA;IACA,WAAA;EjBoqLJ;EiBtuLA;IAsEI,cAAA;IACA,gBAAA;EjBmqLJ;EiB1uLA;IA0EM,WAAA;IACA,UAAA;IACA,iBAAA;EjBmqLN;EiBhqLQ;IACE,mBAAA;EjBkqLV;EiBlvLA;IAuFI,YAAA;EjB8pLJ;AACF;AiB1pLA;EACE,gBAAA;AjB4pLF;AACA,0CAA0C;AiBzpL1C;EACE;IACE,6BAAA;IACA,iBAAA;EjB2pLF;EiB7pLA;IAKI,kBAAA;EjB2pLJ;AACF;AACA,4CAA4C;AiBvpL5C;EACE;IAEI,iBAAA;EjBwpLJ;EiB1pLA;IAMI,kBAAA;EjBupLJ;AACF;AACA,kDAAkD;AkBpoMlD;EACE,6BAAA;EACA,iBAAA;EACA,oBAAA;EACA,yDAAA;EACA,4BAAA;EACA,yBAAA;EACA,iBAAA;AlBsoMF;AkBroME;EACE,iBAAA;AlBuoMJ;AkBhpMA;EAYI,mBAAA;EACA,iBAAA;AlBuoMJ;AkBppMA;EAgBI,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,iBAAA;EACA,kBAAA;AlBuoMJ;AkB7pMA;EAyBM,kBAAA;EACA,gBAAA;AlBuoMN;AkBroMI;EACE,yBAAA;EACA,cAAA;AlBuoMN;AkBrqMA;EAiCM,qBAAA;AlBuoMN;AkBtoMM;EACE,WAAA;AlBwoMR;AkB3qMA;EAwCI,kBAAA;AlBsoMJ;AkB9qMA;EA0CM,kBAAA;EACA,SAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,sBAAA;EACA,UAAA;AlBuoMN;AkBxrMA;EAqDI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AlBsoMJ;AkBhsMA;EA4DM,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;AlBuoMN;AkBroMI;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,iCAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;AlBuoMN;AkBrtMA;EAkFI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AlBsoMJ;AkBpuMA;EAiGI,gBAAA;AlBsoMJ;AkBvuMA;EAqGI,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,2CAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;AlBqoMJ;AkBnvMA;EAgHM,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AlBsoMN;AkB1vMA;EAyHM,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;AlBooMN;AkBjwMA;EAgIM,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AlBooMN;AkBzwMA;EAwIM,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AlBooMN;AkBnxMA;EAkJM,eAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AlBooMN;AkB7xMA;EA4JM,mBAAA;EACA,gBAAA;AlBooMN;AkB/nMA;EACE;IACE,iBAAA;ElBioMF;EkBhoME;IACE,iBAAA;ElBkoMJ;EkBroMA;IAOM,eAAA;ElBioMN;EkBxoMA;IAYM,kBAAA;ElB+nMN;EkB3oMA;IAeM,mBAAA;ElB+nMN;EkB9oMA;IAkBM,iBAAA;ElB+nMN;AACF;AmBrzMA;EACE,WAAA;EACA,kBAAA;EACA,gBAAA;AnBuzMF;AmBpzMA;;;EAGE,cAAA;EACA,yBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AnBszMF;AmBpzME;;;EACE,yBAAA;AnBwzMJ;AmBrzME;;;;;;EP2CA,wBAAA;EACQ,gBAAA;EOzCN,UAAA;EACA,yBAAA;EACA,qBAAA;EACA,wBAAA;AnB4zMJ;AmBxzMA;;;EAKI,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AnBwzMJ;AmBlzMA;EACE,yBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,oBAAA;EACA,uBAAA;EPKA,wBAAA;EACQ,gBAAA;AZgzMV;AmBnzME;EACE,wCAAA;EACA,cAAA;EACA,qBAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;EACA,wBAAA;AnBqzMJ;AmBlzME;;EPRA,mCAAA;EACQ,2BAAA;EOUN,yBAAA;EACA,UAAA;EACA,oCAAA;EACA,qBAAA;EACA,wBAAA;AnBqzMJ;AmBjzMA;EACE,iCAAA;AnBmzMF;AmBjzME;EACE,mBAAA;AnBmzMJ;AmBjzMI;EACE,yBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;AnBmzMN;AmB9yMA;EACE,gBAAA;AnBgzMF;AmB1yMM;EACE,wCAAA;EACA,yBAAA;EACA,eAAA;AnB4yMR;AmBlzMA;EAWM,mBAAA;AnB0yMN;AmBrzMA;EAeM,oBAAA;AnByyMN;AmBpyMA;EACE,iBAAA;EACA,gBAAA;AnBsyMF;AmBnyMA;EAEI,2CAAA;AnBoyMJ;AoBz6MA;EACE,eAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;ApB26MF;AoBz6MA;EACE,iBAAA;ApB26MF;AqBj7ME;;;;;;;;;;;;;;;;;ERuzBA,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;EQ1yBE,yBAAA;EACA,oCAAA;EACA,qBAAA;EACA,gCAAA;EACA,oBAAA;ArBw7MJ;AqBh9MA;EA4BI,oCAAA;EACA,yBAAA;EACA,gCAAA;ArBu7MJ;AqBr9MA;EAkCI,oBAAA;ArBs7MJ;AqBp7MI;EACE,WAAA;EACA,yBAAA;EACA,qBAAA;ArBs7MN;AqBp7MM;EACE,4CAAA;EACA,WAAA;EACA,sBAAA;ArBs7MR;AqBl+MA;ERwzBE,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;EQ3wBE,oBAAA;ArBy7MJ;AqB5+MA;ERwzBE,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;EQtwBE,oBAAA;ArB87MJ;AqB17MI;ER4vBF,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;EQhwBI,oBAAA;EACA,oCAAA;EACA,qCAAA;ArBk8MN;AqBlgNA;ERwzBE,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;EQxvBE,oBAAA;ArBs8MJ;AqB5gNA;ERwzBE,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;EQnvBE,oBAAA;ArB28MJ;AqBthNA;EA+EI,oBAAA;ArB08MJ;AqBr8MA;EACE,iBAAA;EACA,qBAAA;ArBu8MF;AqBn8MA;EACE,oBAAA;ArBq8MF;AqBj8MA;EACE,oBAAA;ArBm8MF;AqBp8MA;EAII,6BAAA;EACA,iBAAA;ArBm8MJ;AqB97MA;EACE,kBAAA;ArBg8MF;AqB97ME;EACE,cAAA;ArBg8MJ;AqBj8ME;EAII,cAAA;EAEA,WAAA;ArB+7MN;AqBx8MA;EAgBI,eAAA;ArB27MJ;AqBv7MA;EACE,YAAA;EACA,qBAAA;EACA,UAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;ArBy7MF;AqBv7ME;EACE,WAAA;EACA,qBAAA;ArBy7MJ;AqBt7ME;EACE,WAAA;EACA,yBAAA;ArBw7MJ;AqBj7ME;EAGI,kBAAA;EACA,mBAAA;ArBi7MN;AqB76ME;EAEI,gBAAA;EACA,gBAAA;ArB86MN;AqB17MA;EAiBI,iBAAA;ArB46MJ;AqB77MA;EAoBM,cAAA;EACA,iBAAA;ArB46MN;AqBj8MA;EA0BI,kBAAA;ArB06MJ;AqBp8MA;EA+BI,mBAAA;ArBw6MJ;AqBv8MA;EAmCI,kBAAA;EACA,cAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;ArBu6MJ;AqBl6MA;EACE,YAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;ETnIA,wBAAA;EACQ,gBAAA;ESoIR,cAAA;EACA,kBAAA;EACA,UAAA;ArBq6MF;AqBn6ME;EACE,WAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,4BAAA;ArBq6MJ;AqBl6ME;EACE,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;ArBo6MJ;AqBj6ME;EACE,uBAAA;ArBm6MJ;AqBh6ME;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;ArBk6MJ;AqB/5ME;EACE,yBAAA;EACA,cAAA;EACA,qBAAA;ArBi6MJ;AqB95ME;EACE,WAAA;EACA,YAAA;ET1LF,wBAAA;EACQ,gBAAA;AZ2lNV;AqB/5MI;EACE,SAAA;EACA,YAAA;ArBi6MN;AqB95MI;EACE,gBAAA;EACA,SAAA;ArBg6MN;AqB55ME;EACE,WAAA;ArB85MJ;AqB55MI;EACE,SAAA;EACA,YAAA;ArB85MN;AqB35MI;EACE,gBAAA;EACA,SAAA;ArB65MN;AACA,kDAAkD;AAClD,0DAA0D;AAC1D,sDAAsD;AqBr5MtD;EACE;;IAGI,UAAA;IACA,YAAA;IT3GJ,mEAAA;IACK,8DAAA;IACG,2DAAA;EZkgNR;EqBl5MI;IACE,YAAA;ErBo5MN;AACF;AqB94MA;EAEE;;IAGI,iBAAA;IACA,kBAAA;ErB84MJ;EqBl5MA;IAQI,eAAA;IACA,iBAAA;IACA,kBAAA;ErB64MJ;EqBv5MA;IAcI,iBAAA;IACA,kBAAA;ErB44MJ;AACF;AACA,0CAA0C;AqBx4M1C;EACE;;IAGI,UAAA;IACA,YAAA;ITtJJ,mEAAA;IACK,8DAAA;IACG,2DAAA;EZgiNR;EqBv4MA;;IAEE,UAAA;IT7JF,mEAAA;IACK,8DAAA;IACG,2DAAA;EZuiNR;EqBx4MA;IACE,WAAA;ErB04MF;EqBv4MA;IACE,iBAAA;ErBy4MF;AACF;AACA,4CAA4C;AqBt4M5C;EACE;IACE,aAAA;ErBw4MF;EqBt4ME;IACE,OAAA;IACA,QAAA;IACA,SAAA;IACA,YAAA;ErBw4MJ;EqBr4ME;IACE,OAAA;IACA,QAAA;IACA,SAAA;IACA,SAAA;IACA,YAAA;ErBu4MJ;EqBp4ME;IACE,aAAA;ErBs4MJ;EqBp4MI;IACE,SAAA;IACA,YAAA;ErBs4MN;EqBn4MI;IACE,gBAAA;IACA,SAAA;ErBq4MN;EqBh4MI;IACE,SAAA;IACA,YAAA;ErBk4MN;AACF;AqB73MA;EACE;;IAGI,WAAA;IACA,aAAA;IT1NJ,mEAAA;IACK,8DAAA;IACG,2DAAA;EZylNR;AACF;AqB53MA;EACE;;IAEE,WAAA;IACA,aAAA;ITpOF,mEAAA;IACK,8DAAA;IACG,2DAAA;EZmmNR;AACF;AsB9xNA;EAEI,mBAAA;AtB+xNJ;AsBjyNA;EAMI,yBAAA;AtB8xNJ;AsBpyNA;GRIE,OAAA;EQOE,wCAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AtB6xNJ;AevyNE;;EAEE,YAAA;EACA,cAAA;AfyyNJ;AevyNE;EACE,WAAA;AfyyNJ;AcpzNE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;AdozNJ;AclzNE;EACE,WAAA;AdozNJ;AsB5yNI;;EAEE,wCAAA;EACA,UAAA;AtB8yNN;AsB3yNI;EACE,0CAAA;EACA,WAAA;AtB6yNN;AsB1yNI;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;AtB4yNN;AsB1yNM;EACE,gBAAA;AtB4yNR;AsBxzNI;EAgBI,cAAA;EACA,mBAAA;EACA,iBAAA;AtB2yNR;AsBzyNQ;EACE,iBAAA;AtB2yNV;AsBh0NI;EA0BI,gBAAA;AtByyNR;AsBryNI;EACE,0BAAA;AtBuyNN;AsBxyNI;EAII,WAAA;EACA,gBAAA;AtBuyNR;AsB32NA;EA0EI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;AtBoyNJ;AsBl3NA;EAkFI,gBAAA;EACA,mBAAA;AtBmyNJ;AsBt3NA;EAsFM,mBAAA;EACA,cAAA;AtBmyNN;AsB13NA;EA4FI,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AtBiyNJ;AsBj4NA;EAmGM,gBAAA;EACA,YAAA;EACA,gBAAA;AtBiyNN;AsBt4NA;EAyGM,gBAAA;AtBgyNN;AsBz4NA;EA6GM,SAAA;AtB+xNN;AsB54NA;EAuHI,WAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AtBwxNJ;AsBl5NA;EAmHM,mBAAA;EACA,gBAAA;AtBkyNN;AsBt5NA;EA6HM,iBAAA;EACA,kBAAA;AtB4xNN;AsB15NA;EAmII,UAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AtB0xNJ;AsBh6NA;EA0II,UAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AtByxNJ;AsBt6NA;EAiJI,UAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AtBwxNJ;AsB56NA;EAwJI,WAAA;EACA,WAAA;EACA,iBAAA;AtBuxNJ;AsBj7NA;EA8JI,kBAAA;EACA,eAAA;AtBsxNJ;AsBr7NA;EAmKI,gBAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;AtBqxNJ;AsB37NA;EA0KI,cAAA;AtBoxNJ;AsB/wNA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,2BAAA;EACA,qBAAA;EACA,QAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;AtBixNF;AsB9wNA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AtB+wNF;AsB5wNA;EACE;IACE,gBAAA;IACA,mBAAA;IACA,kBAAA;IACA,iBAAA;IACA,YAAA;IACA,uBAAA;EtB8wNF;EsB3wNA;IACE,gBAAA;EtB6wNF;AACF;AsBzwNA;EACE,WAAA;EACA,yBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AtB2wNF;AsBzwNE;EACE,sBAAA;EACA,mBAAA;AtB2wNJ;AsBrxNA;EAcI,WAAA;EACA,QAAA;AtB0wNJ;AsBzxNA;EAmBI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;AtBywNJ;AsB/xNA;EA0BI,UAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,QAAA;AtBwwNJ;AsBvyNA;EAmCI,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,QAAA;AtBuwNJ;AsB9yNA;EA2CI,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,QAAA;AtBswNJ;AsBpzNA;EAkDI,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,QAAA;AtBqwNJ;AsB3zNA;EA0DI,UAAA;EACA,oBAAA;EACA,gBAAA;EACA,QAAA;AtBowNJ;AsBhwNA;EACE,aAAA;AtBkwNF;AsB/vNA;EAEI;IACE,kBAAA;EtBgwNJ;EsBlwNA;IAMI,UAAA;EtB+vNJ;EsBrwNA;IAUI,UAAA;EtB8vNJ;EsBxwNA;IAcI,WAAA;EtB6vNJ;EsB3wNA;IAkBI,UAAA;EtB4vNJ;EsB9wNA;IAsBI,UAAA;EtB2vNJ;AACF;AsBvvNA;EACE;IAEI,UAAA;IACA,QAAA;EtBwvNJ;EsB3vNA;IAOI,UAAA;IACA,yBAAA;IACA,QAAA;EtBuvNJ;EsBhwNA;IAaI,UAAA;IACA,gBAAA;IACA,mBAAA;IACA,QAAA;EtBsvNJ;EsBtwNA;IAoBI,UAAA;IACA,gBAAA;IACA,mBAAA;IACA,QAAA;EtBqvNJ;EsB5wNA;IA2BI,UAAA;IACA,eAAA;IACA,mBAAA;IACA,QAAA;EtBovNJ;EsBlxNA;IAkCI,UAAA;IACA,mBAAA;IACA,QAAA;EtBmvNJ;EsBvxNA;IAwCI,WAAA;IACA,QAAA;EtBkvNJ;AACF;AsB9uNA;EACE;IAEI,UAAA;IACA,QAAA;EtB+uNJ;EsBlvNA;IAOI,UAAA;IACA,2BAAA;IACA,UAAA;IACA,QAAA;EtB8uNJ;EsBxvNA;IAcI,UAAA;IACA,QAAA;EtB6uNJ;EsB5vNA;IAmBI,UAAA;IACA,eAAA;IACA,mBAAA;IACA,QAAA;IACA,iBAAA;EtB4uNJ;EsBnwNA;IA2BI,UAAA;IACA,UAAA;IACA,QAAA;EtB2uNJ;EsBxwNA;IAiCI,SAAA;IACA,iBAAA;IACA,QAAA;EtB0uNJ;EsB7wNA;IAuCI,SAAA;IACA,iBAAA;IACA,QAAA;EtByuNJ;EsBruNA;IAEE,aAAA;IACA,eAAA;IACA,yBAAA;IACA,yBAAA;IACA,qBAAA;EtBsuNF;EsB5uNA;IA3CI,UAAA;IACA,QAAA;EtB0xNJ;EsBhvNA;IAtCI,UAAA;IACA,2BAAA;IACA,UAAA;IACA,QAAA;EtByxNJ;EsBtvNA;IA/BI,UAAA;IACA,QAAA;EtBwxNJ;EsB1vNA;IA1BI,UAAA;IACA,eAAA;IACA,mBAAA;IACA,QAAA;IACA,iBAAA;EtBuxNJ;EsBjwNA;IAlBI,UAAA;IACA,UAAA;IACA,QAAA;EtBsxNJ;EsBtwNA;IAZI,SAAA;IACA,iBAAA;IACA,QAAA;EtBqxNJ;EsB3wNA;IANI,SAAA;IACA,iBAAA;IACA,QAAA;EtBoxNJ;AACF;AACA,kDAAkD;AAClD,0DAA0D;AAC1D,sDAAsD;AACtD,0CAA0C;AsB9vN1C;EACE;IAEI,wCAAA;IAEA,gBAAA;IACA,gBAAA;IACA,gBAAA;IACA,kBAAA;EtB8vNJ;EsBrwNA;IAWQ,eAAA;EtB6vNR;EsBxwNA;;IAiBM,iBAAA;EtB2vNN;EsB5wNA;IAqBM,0BAAA;EtB0vNN;EsB/wNA;IA2BM,gBAAA;IACA,iBAAA;EtBuvNN;AACF;AACA,4CAA4C;AsBlvN5C;EACE;IAGM,gBAAA;IACA,cAAA;EtBkvNN;EsBtvNA;IASI,WAAA;EtBgvNJ;AACF;AACA,kDAAkD;AuBrtOlD;EvButOE,qBAAqB;AACvB;AuBxtOA;EAGM,gBAAA;AvBwtON;AuB3tOA;EAQM,iBAAA;EACA,kBAAA;AvBstON;AuB/tOA;;EAcI,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AvBqtOJ;AuBptOI;;EACE,yBAAA;AvButON;AuBrtOI;;EACE,yBAAA;AvBwtON;AuBjvOA;EA6BI,6BAAA;AvButOJ;AuBpvOA;EAgCI,aAAA;EACA,cAAA;EACA,kBAAA;AvButOJ;AuBzvOA;EAqCI,gBAAA;AvButOJ;AuB5vOA;EA0CI,oBAAA;AvBqtOJ;AuB/vOA;EA6CI,iBAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,8BAAA;EAEA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,mBAAA;AvBotOJ;AuBntOI;EhBiGF,oFAAA;EAGA,4EAAA;APmnOF;AuBptOI;EAGM,YAAA;EACA,mBAAA;AvBotOV;AuBntOU;EACE,yBAAA;AvBqtOZ;AuBhtOI;EAGM,YAAA;EACA,mBAAA;AvBgtOV;AuB/sOU;EACE,yBAAA;AvBitOZ;AuB5xOA;EAkFM,cAAA;AvB6sON;AuB3sOI;EAEE,yBAAA;AvB4sON;AuBlyOA;EA2FM,aAAA;AvB0sON;AuBryOA;EA+FQ,aAAA;AvBysOR;AuBxyOA;EAoGI,YAAA;EACA,gBAAA;EACA,6BAAA;AvBusOJ;AuBtsOI;EACE,yBAAA;AvBwsON;AuBvsOM;;EAEE,6BAAA;AvBysOR;AACA,kDAAkD;AAClD,0DAA0D;AAC1D,sDAAsD;AACtD,0CAA0C;AAC1C,4CAA4C;AAC5C,kDAAkD;AwBxzOlD;EAEI,gBAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;AxByzOJ;AwB9zOA;EAQM,gBAAA;EACA,gCAAA;AxByzON;AwBl0OA;EAWQ,cAAA;AxB0zOR;Acj0OA;GACE,OAAA;Adm0OF;Acl0OE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;Adk0OJ;Ach0OE;EACE,WAAA;Adk0OJ;AclyOE;EACE,kBAAA;GA3CF,OAAA;Adg1OF;Ae10OE;;EAEE,YAAA;EACA,cAAA;Af40OJ;Ae10OE;EACE,WAAA;Af40OJ;Acv1OE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;Adu1OJ;Acr1OE;EACE,WAAA;Adu1OJ;AclzOE;EACE,WAAA;EACA,eAAA;EACA,iBAAA;AdozOJ;AchzOE;;;;EAfE,YAAA;Adq0OJ;Ac51OK;EAuBD,YAAA;Adw0OJ;Ac/1OK;EAuBD,YAAA;Ad20OJ;Acl2OK;EAuBD,YAAA;Ad80OJ;Acr2OK;EAuBD,YAAA;Adi1OJ;Acx2OK;EAuBD,YAAA;Ado1OJ;Ac32OK;EAuBD,YAAA;Adu1OJ;Ac92OK;EAuBD,YAAA;Ad01OJ;Acj3OK;EAuBD,YAAA;Ad61OJ;Acp3OK;EAuBD,YAAA;Adg2OJ;Acv3OK;EAuBD,YAAA;Adm2OJ;Ac13OK;EAuBD,YAAA;Ads2OJ;Ac73OK;EAuBD,WAAA;Ady2OJ;Acv3OK;EASD,kBAAA;Adi3OJ;Ac13OK;EASD,kBAAA;Ado3OJ;Ac73OK;EASD,kBAAA;Adu3OJ;Ach4OK;EASD,kBAAA;Ad03OJ;Acn4OK;EASD,kBAAA;Ad63OJ;Act4OK;EASD,kBAAA;Adg4OJ;Acz4OK;EASD,kBAAA;Adm4OJ;Ac54OK;EASD,kBAAA;Ads4OJ;Ac/4OK;EASD,kBAAA;Ady4OJ;Acl5OK;EASD,kBAAA;Ad44OJ;Acr5OK;EASD,kBAAA;Ad+4OJ;Acx5OK;EASD,iBAAA;Adk5OJ;Ac/2OA;;EAEE,aAAA;Adi3OF;Ac92OA;;EAEE,YAAA;Adg3OF;AyBj5OA;EACE,eAAA;EACA,UAAA;EACA,YAAA;AzBm5OF;AyB/4OE;EAEI,gBAAA;EACA,eAAA;EACA,kBAAA;AzBg5ON;AyBp5OE;EAQI,UAAA;AzB+4ON;AyB34OE;EAGI,UAAA;EACA,WAAA;AzB24ON;AyBv4OE;EAEI,WAAA;EACA,WAAA;AzBw4ON;AyBp4OE;EACE,gBAAA;AzBs4OJ;AyBv4OE;EAII,WAAA;EACA,WAAA;AzBs4ON;AyBl4OE;EACE,gBAAA;EACA,WAAA;AzBo4OJ;AyBt4OE;EAKI,WAAA;EACA,UAAA;AzBo4ON;AyB/3OA;EACE,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AzBi4OF;AyB/3OE;EACE,kBAAA;AzBi4OJ;AyB93OE;EACE,yBAAA;AzBg4OJ;AyB33OA;EACE,eAAA;EACA,mBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,6BAAA;AzB63OF;AyBv3OA;EACE,yBAAA;EACA,gBAAA;EACA,YAAA;AzBy3OF;AyB53OA;EAMI,UAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AzBy3OJ;AyBr4OA;EAeM,WAAA;AzBy3ON;AyBx4OA;EAoBI,WAAA;EACA,YAAA;EACA,WAAA;AzBu3OJ;AyB74OA;EAyBM,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,6BAAA;EACA,oBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;AzBu3ON;AyBz5OA;;EAsCQ,cAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AzBu3OR;AyBp3OM;EACE,eAAA;AzBs3OR;AyBn3OM;EbrHJ,8CAAA;EACQ,sCAAA;EasHF,yBAAA;AzBs3OR;AyBn3OM;;;Eb1HJ,oDAAA;EACQ,4CAAA;Ea6HF,yBAAA;AzBs3OR;AyB/6OA;EA+DI,kBAAA;AzBm3OJ;AyBl7OA;EAmEI,WAAA;EACA,kBAAA;AzBk3OJ;AyBt7OA;EAuEM,UAAA;AzBk3ON;AyB72OA;EACE,SAAA;EACA,UAAA;AzB+2OF;AyBj3OA;EAKI,WAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AzB+2OJ;AyB72OI;Eb7JF,wBAAA;EACQ,gBAAA;AZ6gPV;AyB73OA;EAkBI,WAAA;EACA,YAAA;EACA,kBAAA;AzB82OJ;AyB12OA;EACE,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;AzB42OF;AyBz2OA;EAEE,mBAAA;EACA,gBAAA;EACA,gBAAA;AzB02OF;AyBt2OA;EAEI,yBAAA;EACA,kBAAA;EACA,iBAAA;AzBu2OJ;AyB32OA;EAQI,kBAAA;EACA,YAAA;AzBs2OJ;AyB/2OA;EAcM,UAAA;EACA,qBAAA;AzBo2ON;AyBl2OM;EACE,oCAAA;AzBo2OR;AyBj2OM;Eb/MJ,oCAAA;EACQ,4BAAA;EagNF,qBAAA;EACA,UAAA;EACA,6BAAA;AzBo2OR;AyB73OA;EA+BI,SAAA;EACA,cAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,YAAA;Eb9NF,+CAAA;EACQ,uCAAA;AZgkPV;AyBv4OA;;EAyCM,YAAA;EACA,iBAAA;EACA,iBAAA;AzBk2ON;AyB74OA;EA+CM,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;AzBi2ON;AyBr5OA;EAuDQ,gBAAA;AzBi2OR;AyBx5OA;EA4DM,iBAAA;AzB+1ON;AyB11OA;EACE,wEAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EzB41OA,qDAAqD;AACvD;AyBr2OA;;;;;;EAmBI,kBAAA;EACA,6BAAA;AzB01OJ;AyB92OA;EAwBI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AzBy1OJ;AyBp3OA;EA+BI,cAAA;EACA,eAAA;EACA,gBAAA;AzBw1OJ;AyBz3OA;EAqCI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AzBu1OJ;AyB/3OA;EA4CI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AzBs1OJ;AyBr4OA;EAmDI,cAAA;EACA,eAAA;EACA,kBAAA;AzBq1OJ;AyB14OA;EAyDI,WAAA;AzBo1OJ;AyB74OA;EA6DI,iBAAA;AzBm1OJ;AyBh5OA;EAiEI,cAAA;AzBk1OJ;AyBn5OA;EAsEI,6BAAA;AzBg1OJ;AyBt5OA;GXxTE,OAAA;EWmYE,YAAA;EACA,gBAAA;AzB+0OJ;Ae7sPE;;EAEE,YAAA;EACA,cAAA;Af+sPJ;Ae7sPE;EACE,WAAA;Af+sPJ;Ac1tPE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;Ad0tPJ;AcxtPE;EACE,WAAA;Ad0tPJ;AyB56OA;EAgFQ,YAAA;EACA,WAAA;AzB+1OR;AyBh7OA;EAsFM,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;GXjZJ,OAAA;Ad+uPF;AezuPE;;EAEE,YAAA;EACA,cAAA;Af2uPJ;AezuPE;EACE,WAAA;Af2uPJ;ActvPE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;AdsvPJ;AcpvPE;EACE,WAAA;AdsvPJ;AyBx8OA;EA6FQ,YAAA;EACA,iBAAA;EACA,cAAA;AzB82OR;AyB78OA;EAoGM,YAAA;EACA,kBAAA;EACA,kBAAA;AzB42ON;AyBl9OA;EAyGQ,cAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AzB42OR;AyB19OA;EAoHI,YAAA;EACA,gBAAA;GX7aF,OAAA;AduxPF;AejxPE;;EAEE,YAAA;EACA,cAAA;AfmxPJ;AejxPE;EACE,WAAA;AfmxPJ;Ac9xPE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;Ad8xPJ;Ac5xPE;EACE,WAAA;Ad8xPJ;AyBh/OA;EAyHM,WAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EvBxZJ,8BAAA;EACA,2BAAA;EACA,sBAAA;AFmxPF;AyB5/OA;EAoIM,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AzB23ON;AyBngPA;EA8II,YAAA;EACA,kBAAA;AzBw3OJ;AyBvgPA;EAmJI,cAAA;EACA,iBAAA;AzBu3OJ;AyB3gPA;EAwJI,aAAA;AzBs3OJ;AyB9gPA;EA4JI,kBAAA;EACA,aAAA;AzBq3OJ;AyBlhPA;EAiKI,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AzBo3OJ;AyBxhPA;EAwKM,gBAAA;EACA,eAAA;EACA,gBAAA;AzBm3ON;AyB7hPA;EA8KM,gBAAA;EACA,mBAAA;EACA,gBAAA;GXxeJ,OAAA;Ad21PF;Aer1PE;;EAEE,YAAA;EACA,cAAA;Afu1PJ;Aer1PE;EACE,WAAA;Afu1PJ;Acl2PE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;Adk2PJ;Ach2PE;EACE,WAAA;Adk2PJ;AyBpjPA;EAoLQ,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;GXjfN,OAAA;Adq3PF;Ae/2PE;;EAEE,YAAA;EACA,cAAA;Afi3PJ;Ae/2PE;EACE,WAAA;Afi3PJ;Ac53PE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;Ad43PJ;Ac13PE;EACE,WAAA;Ad43PJ;AyB9kPA;EA8LQ,YAAA;EACA,kBAAA;EACA,iBAAA;AzBm5OR;AyBnlPA;EAsMI,aAAA;EACA,0BAAA;AzBg5OJ;AyBvlPA;EA0MM,eAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;AzBg5ON;AyB7lPA;EAkNI,kBAAA;EACA,YAAA;AzB84OJ;AyBjmPA;;;;EAyNM,iBAAA;AzB84ON;AyBvmPA;EA8NI,aAAA;EACA,sBAAA;EACA,MAAA;AzB44OJ;AyB5mPA;EAmOM,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AzB44ON;AyBlnPA;EA0OM,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AzB24ON;AyBxnPA;EAkPI,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EAEA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AzBw4OJ;AyBloPA;EA6PM,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AzBw4ON;AyBr4OI;EACE,eAAA;EACA,gBAAA;AzBu4ON;AyBz4OI;EAKI,eAAA;EACA,gBAAA;AzBu4OR;AyBn4OI;EACE,eAAA;EACA,gBAAA;AzBq4ON;AyBv4OI;EAKI,eAAA;EACA,gBAAA;AzBq4OR;AyBj4OI;EACE,2CAAA;AzBm4ON;AyBh4OI;EACE,4CAAA;AzBk4ON;AyB/3OI;EACE,mBAAA;AzBi4ON;AyBjqPA;EAqSI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;AzB+3OJ;AyB73OI;EACE,eAAA;AzB+3ON;AyB3qPA;EAiTI,aAAA;EACA,sBAAA;EACA,MAAA;AzB63OJ;AyBhrPA;EAuTI,2CAAA;AzB43OJ;AyBnrPA;EA2TI,4CAAA;AzB23OJ;AyBtrPA;EA+TI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,QAAA;EACA,cAAA;AzB03OJ;AyB/rPA;EAwUM,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AzB03ON;AyBtsPA;EAgVM,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,iBAAA;AzBy3ON;AyBt3OI;EACE,2CAAA;AzBw3ON;AyBt3OM;EACE,mBAAA;AzBw3OR;AyBp3OI;EACE,4CAAA;AzBs3ON;AyBp3OM;EACE,mBAAA;AzBs3OR;AyBl3OI;EACE,cAAA;AzBo3ON;AyBj3OI;EACE,iBAAA;AzBm3ON;AyBh3OI;EACE,2BAAA;AzBk3ON;AyBluPA;EAqXI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,MAAA;EACA,eAAA;AzBg3OJ;AyBzuPA;EA4XM,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AzBg3ON;AyB/uPA;EAmYM,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AzB+2ON;AyB52OI;EACE,cAAA;AzB82ON;AyB32OI;EACE,iBAAA;AzB62ON;AyB12OI;EACE,2CAAA;AzB42ON;AyB12OM;EACE,mBAAA;AzB42OR;AyBx2OI;EACE,4CAAA;AzB02ON;AyBx2OM;EACE,mBAAA;AzB02OR;AyBt2OI;EACE,8BAAA;AzBw2ON;AyBr2OI;EACE,iBAAA;AzBu2ON;AyB7wPA;EA2aI,yBAAA;AzBq2OJ;AyBhxPA;EAgbI,aAAA;EACA,kBAAA;EACA,kBAAA;AzBm2OJ;AyBrxPA;EAsbI,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EACA,gBAAA;AzBk2OJ;AyBhyPA;EAkcI,aAAA;EACA,gBAAA;AzBi2OJ;AyBpyPA;EAucI,kBAAA;AzBg2OJ;AyBvyPA;GXxTE,OAAA;EWowBE,iBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;AzB+1OJ;AehmQE;;EAEE,YAAA;EACA,cAAA;AfkmQJ;AehmQE;EACE,WAAA;AfkmQJ;Ac7mQE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;Ad6mQJ;Ac3mQE;EACE,WAAA;Ad6mQJ;AyB/zPA;EAkdM,gBAAA;EACA,WAAA;EACA,gBAAA;AzBg3ON;AyBp0PA;EA2dI,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;AzB42OJ;AyB10PA;;EAmeI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AzB22OJ;AyBj1PA;EA0eI,eAAA;EACA,gBAAA;AzB02OJ;AyBt2OE;EAIQ,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;AzBq2OV;AyBr3OE;EAoBQ,wBAAA;AzBo2OV;AyBx3OE;EAyBU,aAAA;EACA,YAAA;AzBk2OZ;AyB53OE;EA+BQ,yBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AzBg2OV;AyBl4OE;EAsCQ,yBAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AzB+1OV;AyBx4OE;EA4CU,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;EACA,UAAA;EACA,MAAA;EACA,cAAA;EACA,eAAA;AzB+1OZ;AyB51OU;EACE,aAAA;AzB81OZ;AyBz5OE;EAiEQ,YAAA;EACA,aAAA;EACA,eAAA;AzB21OV;AyB74PA;EA0jBM,aAAA;EACA,uBAAA;AzBs1ON;AyBp1OM;EACE,sBAAA;AzBs1OR;AyB5yOE;EAEI,cAAA;AzB6yON;AyBryOE;EAEI,iBAAA;AzBsyON;AyBxyOE;EAMI,iBAAA;AzBqyON;AyB3yOE;EAcM,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AzBgyOR;AyB7xOM;EACE,WAAA;AzB+xOR;AyBpzOE;EA4BI,iBAAA;EACA,kBAAA;AzB2xON;AyBxzOE;EAgCM,eAAA;EACA,cAAA;EACA,yBAAA;EAEA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,WAAA;AzB0xOR;AyBn0OE;EA6CM,WAAA;EACA,gBAAA;EACA,eAAA;AzByxOR;AyBx0OE;EAoDI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gCAAA;GXn+BJ,OAAA;Ad2vQF;AervQE;;EAEE,YAAA;EACA,cAAA;AfuvQJ;AervQE;EACE,WAAA;AfuvQJ;AclwQE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;AdkwQJ;AchwQE;EACE,WAAA;AdkwQJ;AyBl2OE;EA+DI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AzBsyON;AyBpyOM;EACE,gBAAA;AzBsyOR;AyB72OE;EA4EI,kBAAA;EACA,WAAA;AzBoyON;AyBj3OE;EAgFM,kBAAA;EACA,mBAAA;EACA,0FAAA;EAOA,yJAAA;EAQA,6FAAA;EAOA,wFAAA;EAOA,yFAAA;EAOA,yFAAA;EAOA,kHAAA;EACA,qBAAA;EACA,WAAA;GXziCN,OAAA;EW2iCM,qBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AzB+vOR;AexyQE;;EAEE,YAAA;EACA,cAAA;Af0yQJ;AexyQE;EACE,WAAA;Af0yQJ;AcrzQE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;AdqzQJ;AcnzQE;EACE,WAAA;AdqzQJ;AyBr5OE;EAwIQ,eAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,sBAAA;AzBgxOV;AyB9wOU;EACE,kBAAA;AzBgxOZ;AyB/5OE;EAsJI,kBAAA;EACA,iBAAA;EACA,iBAAA;AzB4wON;AyBp6OE;EA6JI,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AzB0wON;AyBlwOA;EAGI,UAAA;EACA,qBAAA;AzBkwOJ;AOpxQE;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,yBAAA;EACA,4DAAA;EACA,iCAAA;EACA,8BAAA;EACA,6BAAA;EACA,yBAAA;EACA,2HAAA;EAEA,gBAAA;EACA,0BAAA;APqxQJ;AyBxwOA;EACE,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,wCAAA;EACA,aAAA;EACA,yBAAA;AzB0wOF;AyBxwOE;;;EAGE,UAAA;AzB0wOJ;AyBtxOA;EAgBI,eAAA;EACA,oBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,4CAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;AzBywOJ;AyBvwOI;;EAEE,qCAAA;AzBywON;AyBtwOI;EACE,cAAA;EACA,yBAAA;AzBwwON;AyBrwOI;EACE,kBAAA;AzBuwON;AyBpwOI;EACE,mBAAA;EACA,gBAAA;EACA,kBAAA;AzBswON;AyBjwOA;EACE,eAAA;EACA,UAAA;EACA,QAAA;EACA,aAAA;AzBmwOF;AyBhwOA;EACE,eAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;AzBkwOF;AyB/vOA;EACE,mBAAA;AzBiwOF;AyB9vOA;EACE,uBAAA;AzBgwOF;AyB7vOA;EACE,YAAA;EACA,mBAAA;AzB+vOF;AyB7vOE;EACE,gCAAA;AzB+vOJ;AyB1vOA;EACE;IACE,4BAAA;IACA,uBAAA;IACA,2BAAA;IACA,4CAAA;IACA,oCAAA;IvB1pCF,8BAAA;IACA,2BAAA;IACA,sBAAA;EFu5QA;EyB3vOA;IACE,gBAAA;IACA,sBAAA;EzB6vOF;EyB/vOA;IAKI,gBAAA;IACA,sBAAA;IACA,cAAA;EzB6vOJ;EyBzvOA;IACE,wBAAA;EzB2vOF;EyBxvOA;IACE,gBAAA;IACA,qBAAA;EzB0vOF;EyBxvOE;IACE,6BAAA;EzB0vOJ;EyBhvOA;IACE,iCAAA;IACA,kCAAA;IACA,wBAAA;IACA,uBAAA;IACA,uBAAA;EzBkvOF;EyB/uOA;IACE,wBAAA;EzBivOF;EyB9uOA;IACE,0BAAA;IACA,oBAAA;IACA,uBAAA;IACA,sBAAA;IAIA,wBAAA;IACA,wBAAA;EzB6uOF;EyB3uOE;IACE,uBAAA;EzB6uOJ;EyBzuOA;IAKE,oBAAA;IACA,qBAAA;IACA,YAAA;IACA,kBAAA;IACA,UAAA;EzBuuOF;EyBhvOA;IAEI,0BAAA;EzBivOJ;EyBnvOA;;IAaI,aAAA;EzB0uOJ;EyBvvOA;IAiBI,UAAA;EzByuOJ;EyB1vOA;IAqBI,YAAA;EzBwuOJ;EyBtuOI;;IAEE,YAAA;IACA,wBAAA;IACA,gBAAA;IACA,aAAA;EzBwuON;EyBnuOA;IACE,aAAA;EzBquOF;AACF;AyBluOA;EACE,sBAAA;EACA,WAAA;AzBouOF;AACA,kDAAkD;AAClD,0DAA0D;AAC1D,sDAAsD;AyB/tOtD;EACE;IACE,gCAAA;EzBiuOF;AACF;AACA,0CAA0C;AyB9tO1C;EACE;IAGM,eAAA;EzB8tON;EyBjuOA;IAQI,YAAA;EzB4tOJ;EyBpuOA;IAYI,YAAA;EzB2tOJ;AACF;AACA,4CAA4C;AyBptO5C;EACE;IAEI,SAAA;EzBqtOJ;EyBvtOA;IAMI,kBAAA;IACA,YAAA;EzBotOJ;AACF;AACA,kDAAkD;AyBhtOlD;EACE;IAEI,UAAA;EzBitOJ;EyBntOA;IAMI,kBAAA;IACA,YAAA;EzBgtOJ;AACF;AyB5sOA;EACE,YAAA;EACA,sBAAA;EACA,sBAAA;EACA,oCAAA;EACA,gDAAA;EACA,6CAAA;EACA,wCAAA;AzB8sOF;A0BvjRA;GZGE,OAAA;EYDA,mBAAA;A1ByjRF;AeljRE;;EAEE,YAAA;EACA,cAAA;AfojRJ;AeljRE;EACE,WAAA;AfojRJ;Ac/jRE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;Ad+jRJ;Ac7jRE;EACE,WAAA;Ad+jRJ;A0B5kRA;GZGE,OAAA;Ad4kRF;AetkRE;;EAEE,YAAA;EACA,cAAA;AfwkRJ;AetkRE;EACE,WAAA;AfwkRJ;AcnlRE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;AdmlRJ;AcjlRE;EACE,WAAA;AdmlRJ;A0BhmRA;EASI,qBAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;A1B0lRJ;A0BxlRI;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EdwCJ,mDAAA;EACQ,2CAAA;EcvCJ,SAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;A1B2lRN;A0BxlRI;;EAEE,yBAAA;Ed6BJ,mDAAA;EACQ,2CAAA;AZ8jRV;A0BzlRM;;EACE,yBAAA;EdyBN,qDAAA;EACQ,6CAAA;AZokRV;A0BxlRM;EACE,gBAAA;EdkBN,qDAAA;EACQ,6CAAA;AZykRV;A0BvlRI;EACE,WAAA;A1BylRN;A0B7oRA;EAwDM,kBAAA;A1BwlRN;A0BhpRA;EA2DQ,gBAAA;A1BwlRR;A0BnpRA;EA+DQ,iBAAA;A1BulRR;A0BrlRQ;EACE,iBAAA;A1BulRV;A0BnlRM;EACE,qBAAA;A1BqlRR;A0B5pRA;EA4EM,SAAA;EACA,eAAA;A1BmlRN;A0BhqRA;EAgFQ,gBAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,6BAAA;A1BmlRR;A0BjlRQ;EACE,mBAAA;A1BmlRV;A0B1qRA;EA2FU,YAAA;A1BklRV;A0B5kRM;;EdjCJ,wBAAA;EACQ,gBAAA;AZinRV;A0B7kRQ;;EdrCN,oDAAA;EACQ,4CAAA;AZsnRV;A0B5kRQ;Ed3CN,oDAAA;EACQ,4CAAA;AZ0nRV;A0B1kRI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;A1B4kRN;A0B1kRM;EACE,qBAAA;A1B4kRR;A0BzkRM;EACE,UAAA;Ed7DN,kDAAA;EACQ,0CAAA;AZyoRV;A0BzkRM;EACE,UAAA;EACA,gBAAA;EdnEN,oDAAA;EACQ,4CAAA;AZ+oRV;A0B1kRQ;EACE,UAAA;A1B4kRV;A0BntRA;EA6IM,yBAAA;EACA,cAAA;EACA,YAAA;A1BykRN;A0BxtRA;GZGE,OAAA;EYiJI,cAAA;EACA,kBAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;A1BwkRN;Ae/tRE;;EAEE,YAAA;EACA,cAAA;AfiuRJ;Ae/tRE;EACE,WAAA;AfiuRJ;Ac5uRE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;Ad4uRJ;Ac1uRE;EACE,WAAA;Ad4uRJ;A0BzvRA;;EAoKQ,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,YAAA;A1BylRR;A0BjwRA;EA6KM,cAAA;A1BulRN;A0BrlRM;EACE,eAAA;EACA,mBAAA;A1BulRR;A0BplRM;EACE,mBAAA;A1BslRR;A0B3wRA;GZGE,OAAA;EYyLI,iBAAA;A1BmlRN;AetwRE;;EAEE,YAAA;EACA,cAAA;AfwwRJ;AetwRE;EACE,WAAA;AfwwRJ;AcnxRE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;AdmxRJ;AcjxRE;EACE,WAAA;AdmxRJ;A0BhyRA;GZGE,OAAA;EY8LI,sBAAA;EACA,yBAAA;EACA,kBAAA;A1BmmRN;Ae7xRE;;EAEE,YAAA;EACA,cAAA;Af+xRJ;Ae7xRE;EACE,WAAA;Af+xRJ;Ac1yRE;;EAEE,cAAA;EACA,WAAA;EAGA,cAAA;Ad0yRJ;AcxyRE;EACE,WAAA;Ad0yRJ;A0BvzRA;EAsMQ,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;A1BonRR;A0B9zRA;EA+MQ,eAAA;EACA,eAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kBAAA;A1BknRR;A0BhnRQ;EACE,WAAA;EACA,qBAAA;A1BknRV;A0B/mRQ;EACE,WAAA;EACA,yBAAA;A1BinRV;A0B3mRI;EACE,WAAA;A1B6mRN;A0B9mRI;EAII,YAAA;A1B6mRR;AACA,0CAA0C;A0BpmR1C;EAGM;IACE,kBAAA;IAEA,gBAAA;IACA,YAAA;IACA,yBAAA;E1BmmRN;E0BjmRM;IACE,yBAAA;E1BmmRR;E0BhmRM;IACE,0BAAA;E1BkmRR;E0B/lRM;IACE,0BAAA;E1BimRR;E0BnnRA;IAuBM,yBAAA;IACA,mBAAA;IACA,cAAA;IACA,YAAA;E1B+lRN;AACF;A2B/2RA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,SAAA;EACA,WAAA;EAEA,kBAAA;EACA,cAAA;EACA,aAAA;A3Bg3RF;A2Bz3RA;EAYI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;A3Bg3RJ;A2B/3RA;EAmBI,cAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;A3B+2RJ;A2Br4RA;EA2BI,mBAAA;A3B62RJ;A2B12RE;EACE,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,WAAA;EACA,SAAA;EACA,aAAA;A3B42RJ;A2B12RI;EACE,eAAA;A3B42RN;A2Bx2RE;EACE,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EAEA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,UAAA;EACA,6BAAA;A3By2RJ;A2Bv3RE;EAiBI,iBAAA;EACA,kBAAA;EACA,WAAA;A3By2RN;A2Br2RE;EfsHA,mEAAA;EACK,8DAAA;EACG,2DAAA;EetHN,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,4HAAA;EAIA,gBAAA;A3Bs2RJ;A2Bl3RE;EAeI,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;A3Bs2RN;A2Bp2RM;EACE,sBAAA;EACA,YAAA;A3Bs2RR;A2Bl2RI;EAAA;IACE,eAAA;IACA,UAAA;E3Bq2RJ;AACF;A2Bl2RI;EACE,yBAAA;A3Bo2RN;A2Bj2RI;EACE,yBAAA;A3Bm2RN;A2Bh2RI;EACE,yBAAA;A3Bk2RN;A2B/1RI;EACE,gBAAA;EACA,sBAAA;EACA,kBAAA;EfkEJ,mEAAA;EACK,8DAAA;EACG,2DAAA;AZgyRV;A2B/1RE;EACE,cAAA;A3Bi2RJ;A2Bl2RE;EAII,iBAAA;EACA,WAAA;A3Bi2RN;A2B71RE;EACE,mBAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;A3B+1RJ;A2Bp2RE;EAQI,iBAAA;A3B+1RN;A2Bv2RE;EAYI,WAAA;A3B81RN;A2B12RE;EAgBI,QAAA;A3B61RN;A2Bx1RA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;A3B01RF;A2Bv1RA;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,oCAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;A3By1RF;A2Bv1RE;EACE,oCAAA;EACA,YAAA;A3By1RJ;A2Bt1RE;EACE,oCAAA;EACA,cAAA;A3Bw1RJ;A2Bp1RA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;A3Bs1RF;A2Bn1RA;EACE,SAAA;EACA,gBAAA;A3Bq1RF;A2Bl1RA;EACE,yBAAA;EACA,WAAA;EACA,yBAAA;A3Bo1RF;A2Bv1RA;EAMI,cAAA;A3Bo1RJ;A2Bh1RA;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;A3Bk1RF;A2Bv1RA;;;;EAWI,cAAA;A3Bk1RJ;A2B71RA;EAeI,cAAA;A3Bi1RJ;A2B70RA;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;A3B+0RF;A2Bp1RA;EAQI,cAAA;A3B+0RJ;A2B30RA;EACE,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;A3B60RF;A2Bl1RA;EAQI,cAAA;EACA,0BAAA;A3B60RJ;A2Bt1RA;EAaI,cAAA;A3B40RJ;A2Bx0RA;EACE,yBAAA;EACA,qBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;A3B00RF;A2B/0RA;EAQI,cAAA;A3B00RJ;A2Bt0RA;EACE,yBAAA;EACA,YAAA;EACA,aAAA;Ef1MA,gDAAA;EACQ,wCAAA;AZmhSV;A2BjzRA;EApBE,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;A3Bw0RF;A2Bt0RE;EACE,gBAAA;EACA,YAAA;A3Bw0RJ;A2Br0RE;EACE,gBAAA;A3Bu0RJ;A2B/zRA;EAxBE,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EAkBA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,WAAA;A3By0RF;A2B51RE;EACE,gBAAA;EACA,YAAA;A3B81RJ;A2B31RE;EACE,gBAAA;A3B61RJ;A2B90RE;EACE,gBAAA;EACA,WAAA;A3Bg1RJ;A2B70RE;EACE,gBAAA;A3B+0RJ;AACA,kDAAkD;AAClD,0DAA0D;AAC1D,sDAAsD;A2Bz0RtD;EACE;IAEI,gBAAA;E3B00RJ;E2Bt0RA;IACE,eAAA;IACA,gBAAA;IACA,gBAAA;E3Bw0RF;AACF;AACA,0CAA0C;A2Br0R1C;EAOE;IACE,YAAA;E3Bi0RF;E2B9zRA;IACE,UAAA;E3Bg0RF;AACF;AACA,4CAA4C;AAC5C,4EAA4E;A2BrzR5E;EAEE;IzBzTA,2BAAA;IK2FA,uBAAA;IACA,+BAAA;IPshSE,sBAAsB;IOphSxB,0BAAA;IPshSE,YAAY;IOphSd,4BAAA;IPshSE,cAAc;EAChB;AACF;A4B3qSA;EAEI,WAAA;EACA,kBAAA;A5B4qSJ;A4B/qSA;EAMI,gBAAA;EACA,mBAAA;A5B4qSJ;A4B3qSI;EACE,yBAAA;A5B6qSN;A4B3qSI;EACE,yBAAA;A5B6qSN;A4B1qSE;EAEI,aAAA;A5B2qSN;A4BtqSA;EAEI,gBAAA;A5BuqSJ;A4BnqSA;EACE,2CAAA;A5BqqSF;A4BlqSA;EACE,sBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;A5BoqSF;A4BjqSA;EACE,WAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;A5BmqSF;A4BhqSA;EACE,+BAAA;EACA,4BAAA;EACA,iBAAA;A5BkqSF;A4B/pSA;EACE,gCAAA;EACA,6BAAA;EACA,kBAAA;A5BiqSF;A4B9pSA;EACE,yBAAA;A5BgqSF;A4B7pSA;EACE,yBAAA;A5B+pSF;A4B5pSA;EACE,6BAAA;EACA,SAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,aAAA;EACA,qBAAA;A5B8pSF;A4B3pSA;EACE,WAAA;EACA,YAAA;A5B6pSF;A4B1pSA;EACE,mBAAA;EACA,mCAAA;A5B4pSF;A4BzpSA;EACE,YAAA;EACA,gBAAA;A5B2pSF;A4BxpSA;EACE,gBAAA;EACA,kBAAA;A5B0pSF;A4BvpSA;EACE,cAAA;EACA,cAAA;EACA,2BAAA;A5BypSF;A4BtpSA;EACE,cAAA;A5BwpSF;A4BrpSA;EACE,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,qDAAA;EACA,iBAAA;EACA,yBAAA;A5BupSF;A4BppSA;EACE,WAAA;A5BspSF;A4BnpSA;EACE,oCAAA;EACA,gBAAA;A5BqpSF;A4BlpSA;EACE,yBAAA;EACA,cAAA;EACA,8CAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;A5BopSF;A4BjpSA;EACE,kBAAA;A5BmpSF;A4BhpSA;;EAEE,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,6CAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,0BAAA;EACA,YAAA;A5BkpSF;A4B/oSA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;A5BipSF;A4B9oSA;EACE,sBAAA;EACA,kBAAA;EACA,WAAA;A5BgpSF;A4B7oSA;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;A5B+oSF;A4B7oSA;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;A5B+oSF;A4B5oSA;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;A5B8oSF;A6B/0SA;EAEI,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;A7Bg1SJ;A6B/0SI;EACE,qCAAA;EACA,eAAA;A7Bi1SN;A6B/0SI;;EAEE,qCAAA;A7Bi1SN;A6B70SI;EACE,kBAAA;A7B+0SN;A6Bh2SA;EAoBM,SAAA;EACA,UAAA;A7B+0SN;A6Bp2SA;EA0BI,kBAAA;A7B60SJ;A6Bz0SA;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;A7B20SF;A6B10SE;EACE,wCAAA;EACA,cAAA;A7B40SJ;A6B90SE;EAII,0BAAA;A7B60SN;A6B10SE;EACE,cAAA;EACA,aAAA;EACA,yBAAA;A7B40SJ;A6B10SE;EACE,cAAA;EACA,aAAA;EACA,yCAAA;A7B40SJ;A6Bz2SA;EAgCI,wBAAA;A7B40SJ;A6B10SE;EACE,yCAAA;EACA,WAAA;EACA,uBAAA;A7B40SJ;A6B30SI;;EAEE,yCAAA;EACA,WAAA;EACA,uBAAA;A7B60SN;A6Br1SE;EAWI,0BAAA;A7B60SN;A6Bx0SA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;A7B00SF;A6Bl1SA;EAUI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;A7B20SJ;A6B10SI;EACE,wCAAA;EACA,cAAA;A7B40SN;A6B10SI;EACE,cAAA;EACA,aAAA;EACA,yBAAA;A7B40SN;A6B10SI;EACE,cAAA;EACA,aAAA;EACA,yCAAA;A7B40SN;A6B10SI;EACE,yCAAA;EACA,WAAA;EACA,uBAAA;A7B40SN;A6B10SM;;EAEE,yCAAA;EACA,WAAA;EACA,uBAAA;A7B40SR;A6B33SA;EAoDI,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;A7B00SJ;A6Bj4SA;EAyDM,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,0BAAA;A7B20SN;A6B94SA;EAuEI,aAAA;A7B00SJ;A6Bx0SE;EAEI,eAAA;A7By0SN;A6Bp0SA;EACE,mBAAA;A7Bs0SF;A6Bn0SA;EACE,UAAA;EACA,YAAA;EACA,4BAAA;EACA,UAAA;EACA,YAAA;A7Bq0SF;A6B10SA;EAOI,SAAA;A7Bs0SJ;A6B70SA;EAUI,WAAA;EACA,0BAAA;EACA,oCAAA;EACA,eAAA;A7Bs0SJ;A6Br0SI;EACE,yBAAA;A7Bu0SN;A6Br0SI;EACE,yBAAA;A7Bu0SN;A8BjgTA;EAEI,kBAAA;EACA,gBAAA;A9BkgTJ;A8BrgTA;EAKM,kBAAA;A9BmgTN;A+BxgTA;EACE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;A/B0gTF;A+BxgTE;EACE,gBAAA;A/B0gTJ;A+BtgTE;EACE,cAAA;EACA,yBAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;A/BwgTJ;A+BtgTI;EACE,WAAA;EACA,yBAAA;A/BwgTN;A+BrgTI;EACE,yBAAA;A/BugTN;A+B/hTE;;EAiCI,YAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;A/BkgTN;A+B3iTE;EA6CI,2FAAA;A/BigTN;A+B7/SI;;EAEE,yBAAA;EACA,cAAA;A/B+/SN;A+BlgTI;;;;EAOI,cAAA;A/BigTR;A+BxgTI;;EAWI,iGAAA;A/BigTR;A+B3/SE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;A/B6/SJ;A+B1/SE;EACE;IACE,8BAAA;IACA,sBAAA;E/B4/SJ;AACF;A+Bz/SE;EACE;IACE,8BAAA;IACA,sBAAA;E/B2/SJ;AACF;A+Bx/SE;EACE;IACE,+BAAA;IACA,uBAAA;E/B0/SJ;AACF;A+Bv/SE;EACE;IACE,+BAAA;IACA,uBAAA;E/By/SJ;AACF;A+Bt/SE;EnByCA,mEAAA;EACK,8DAAA;EACG,2DAAA;EmBzCN,kBAAA;EACA,mBAAA;EACA,YAAA;EAEA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;EACA,mFAAA;EAQA,qCAAA;EACA,0DAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EAEA,gCAAA;EACA,wBAAA;EACA,gCAAA;EACA,wBAAA;EACA,yCAAA;EACA,iCAAA;EACA,oCAAA;EACA,4BAAA;A/Bi/SJ;A+B/+SI;;;EAIE,sCAAA;EACA,+BAAA;EACA,uBAAA;EACA,gCAAA;EACA,wBAAA;EACA,yCAAA;EACA,iCAAA;EACA,oCAAA;EACA,4BAAA;A/Bg/SN;A+B1+SE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;A/B4+SJ;A+Bz+SE;EACE,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;A/B2+SJ;A+Bx+SE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;A/B0+SJ;A+Bn+SE;EACE,mBAAA;EACA,gGAAA;EAKA,WAAA;EACA,sBAAA;A/Bi+SJ;A+B/9SI;EACE,WAAA;EACA,mBAAA;EACA,+FAAA;A/Bi+SN;A+B19SI;EACE,WAAA;EACA,mBAAA;A/B49SN;A+Bx9SE;EACE,mBAAA;EACA,gGAAA;EAKA,cAAA;A/Bs9SJ;A+Bp9SI;EACE,WAAA;EACA,+FAAA;A/Bs9SN;A+B/8SI;EACE,WAAA;EACA,mBAAA;EACA,+FAAA;A/Bi9SN;A+Bz8SE;EACE,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;A/B28SJ;A+Bz8SI;EACE,yBAAA;EACA,qBAAA;A/B28SN;A+Bx8SI;EACE,yBAAA;EACA,qBAAA;A/B08SN;A+Bt8SE;EftPA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,uEAAA;EACA,yBAAA;EhB+rTA,qBAAqB;EgB9rTrB,iBAAA;EACA,YAAA;AhBgsTF;AgB9rTE;;EAEE,mBAAA;EACA,kEAAA;EAKA,cAAA;AhB4rTJ;AgB1rTE;;;EAGE,yBAAA;EACA,kEAAA;EAKA,cAAA;AhBwrTJ;AgBtrTE;;;EAGE,sBAAA;AhBwrTJ;AgBrrTE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;AhBurTJ;AgB7qTI;;;;;;;;;;;;;;;EAKE,yBAAA;EACA,qBAAA;AhByrTN;A+B3/SE;Ef1LE,cAAA;EACA,yBAAA;AhBwrTJ;A+B3/SE;ElBqlBA,mBAAA;EACA,YAAA;EACA,uEAAA;EAEA,WAAA;EACA,gBAAA;Abw6RF;Aat6RE;EACE,uEAAA;EAEA,WAAA;Abu6RJ;Aap6RE;;EAEE,mBAAA;EACA,uEAAA;EACA,WAAA;Abs6RJ;Aan6RE;;EA1GA,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;AbihSF;A+BlhTE;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;A/BohTJ;A+BlhTI;EACE,qCAAA;A/BohTN;A+BjhTI;EACE,qCAAA;A/BmhTN;A+BhhTI;EACE,oCAAA;EACA,gBAAA;A/BkhTN;A+B9gTE;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;A/BghTJ;A+B9gTI;EACE,qCAAA;A/BghTN;A+B7gTI;EACE,qCAAA;A/B+gTN;A+B5gTI;EACE,oCAAA;EACA,gBAAA;A/B8gTN;A+B1gTE;EACE,yBAAA;EACA,WAAA;A/B4gTJ;A+B1gTI;EACE,yBAAA;EACA,cAAA;A/B4gTN;A+BzgTI;EACE,yBAAA;EACA,cAAA;A/B2gTN;A+BvgTE;EACE,mBAAA;EACA,cAAA;EACA,8CAAA;EACA,mBAAA;EACA,iCAAA;A/BygTJ;A+BvgTI;EACE,mBAAA;EACA,8CAAA;A/BygTN;A+BtgTI;EACE,mBAAA;EACA,8CAAA;A/BwgTN;A+B//SA;EAEI,YAAA;EAEA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,0BAAA;A/B+/SJ;A+B7/SI;EACE,wEAAA;EAKA,WAAA;A/B2/SN;A+Bp/SA;EAEI;IACE,gBAAA;IACA,gBAAA;IACA,mBAAA;E/Bq/SJ;AACF;AACA,0CAA0C;A+B9+S1C;EAEI;IACE,YAAA;E/B++SJ;E+B5+SE;IACE,WAAA;IACA,eAAA;E/B8+SJ;AACF;AACA,wCAAwC;AgCp6TxC;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EhCs6TA,wCAAwC;EACxC,6BAA6B;EAC7B,+CAA+C;EAC/C,wDAAwD;EACxD,oCAAoC;EACpC,kCAAkC;AACpC;AgCz6TE;EACE,eAAA;AhC26TJ;AgCx6TE;;EAEE,cAAA;AhC06TJ;AgC/7TA;EAyBI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AhCy6TJ;AgCt8TA;EAkCI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;EhCu6TF,6DAA6D;AAC/D;AgCr6TI;EACE,WAAA;EACA,kBAAA;EACA,aAAA;AhCu6TN;AgCl6TE;;EAEE,sBAAA;AhCo6TJ;AgCz9TA;EA0DI,yBAAA;AhCk6TJ;AgC59TA;EA8DI,yBAAA;AhCi6TJ;AgC/9TA;EAmEI,cAAA;AhC+5TJ;AgCl+TA;EAwEI,SAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,4BAAA;EACA,wBAAA;AhC65TJ;AgCz5TA;EACE,WAAA;EACA,YAAA;EACA,qBAAA;AhC25TF;AgCv5TA;EAEI,cAAA;EACA,0BAAA;EACA,yCAAA;AhCw5TJ;AgC55TA;EAQQ,kBAAA;AhCu5TR;AiCv/TA;EACE,eAAA;AjCy/TF;AiC1/TA;EAII,qBAAA;AjCy/TJ;AiC7/TA;EAQI,gBAAA;EACA,qBAAA;AjCw/TJ;AiCjgUA;EAYM,kBAAA;EACA,aAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;AjCw/TN;AiC3gUA;EAsBQ,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AjCw/TR;AiCrhUA;EAkCM,gCAAA;AjCs/TN;AiCxhUA;EAqCQ,kBAAA;AjCs/TR;AiCn/TM;EACE,4CAAA;AjCq/TR;AiCl/TM;;EAEE,4CAAA;EACA,sBAAA;AjCo/TR;AiCniUA;EAoDM,YAAA;EACA,aAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AjCk/TN;AiC7iUA;EA8DQ,aAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AjCk/TR;AiCnjUA;EAsEM,aAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;AjCg/TN;AiC7jUA;EAkFI,kBAAA;EACA,UAAA;EAEA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,WAAA;EACA,QAAA;AjC6+TJ;AiCjlUA;EAwGI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AjC4+TJ;AiCvlUA;EA+GI,aAAA;EACA,kBAAA;EACA,uBAAA;AjC2+TJ;AiC5lUA;EAoHM,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AjC2+TN;AiCn+TA;EACE,uBAAA;EACA,MAAA;EACA,0BAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AjCq+TF;AiCn+TE;EACE,OAAA;EACA,0BAAA;AjCq+TJ;AiCn+TI;EACE,8EAAA;AjCq+TN;AiC99TI;EACE,gFAAA;AjCg+TN;AiCx9TE;EACE,QAAA;EACA,0BAAA;AjC09TJ;AiCx9TI;EACE,+EAAA;AjC09TN;AiCn9TI;EACE,iFAAA;AjCq9TN;AiC58TA;EACE,YAAA;EACA,cAAA;EACA,kBAAA;AjC88TF;AiC38TA;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AjC68TF;AiC18TA;EACE,gBAAA;EACA,eAAA;EACA,eAAA;AjC48TF;AiCz8TA;EAEI,YAAA;EACA,aAAA;EACA,iBAAA;AjC08TJ;AiC98TA;EAOM,eAAA;EACA,iBAAA;EACA,iBAAA;AjC08TN;AiCn9TA;EAcI,kBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,cAAA;AjCw8TJ;AiC99TA;EAyBM,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;AjCw8TN;AiCn8TA;EFvPE,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;EACA,8BAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EAEA,iBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EAEA,0BAAA;ElBg3BA,mBAAA;EACA,YAAA;EACA,uEAAA;EAEA,WAAA;EACA,gBAAA;EoBxpBA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AjCo+TF;A+BpsUE;EACE,gBAAA;A/BssUJ;A+BlsUE;EACE,cAAA;EACA,yBAAA;EACA,8BAAA;EACA,gBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;A/BosUJ;A+BlsUI;EACE,WAAA;EACA,yBAAA;A/BosUN;A+BjsUI;EACE,yBAAA;A/BmsUN;A+B3tUE;;EAiCI,YAAA;EACA,WAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;A/B8rUN;A+BvuUE;EA6CI,2FAAA;A/B6rUN;A+BzrUI;;EAEE,yBAAA;EACA,cAAA;A/B2rUN;A+B9rUI;;;;EAOI,cAAA;A/B6rUR;A+BpsUI;;EAWI,iGAAA;A/B6rUR;A+BvrUE;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;A/ByrUJ;A+BtrUE;EACE;IACE,8BAAA;IACA,sBAAA;E/BwrUJ;AACF;A+BrrUE;EACE;IACE,8BAAA;IACA,sBAAA;E/BurUJ;AACF;A+BprUE;EACE;IACE,+BAAA;IACA,uBAAA;E/BsrUJ;AACF;A+BnrUE;EACE;IACE,+BAAA;IACA,uBAAA;E/BqrUJ;AACF;A+BlrUE;EnByCA,mEAAA;EACK,8DAAA;EACG,2DAAA;EmBzCN,kBAAA;EACA,mBAAA;EACA,YAAA;EAEA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;EACA,mFAAA;EAQA,qCAAA;EACA,0DAAA;EACA,yBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,yCAAA;EAEA,gCAAA;EACA,wBAAA;EACA,gCAAA;EACA,wBAAA;EACA,yCAAA;EACA,iCAAA;EACA,oCAAA;EACA,4BAAA;A/B6qUJ;A+B3qUI;;;EAIE,sCAAA;EACA,+BAAA;EACA,uBAAA;EACA,gCAAA;EACA,wBAAA;EACA,yCAAA;EACA,iCAAA;EACA,oCAAA;EACA,4BAAA;A/B4qUN;A+BtqUE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;A/BwqUJ;A+BrqUE;EACE,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;A/BuqUJ;A+BpqUE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;A/BsqUJ;A+B/pUE;EACE,mBAAA;EACA,gGAAA;EAKA,WAAA;EACA,sBAAA;A/B6pUJ;A+B3pUI;EACE,WAAA;EACA,mBAAA;EACA,+FAAA;A/B6pUN;A+BtpUI;EACE,WAAA;EACA,mBAAA;A/BwpUN;A+BppUE;EACE,mBAAA;EACA,gGAAA;EAKA,cAAA;A/BkpUJ;A+BhpUI;EACE,WAAA;EACA,+FAAA;A/BkpUN;A+B3oUI;EACE,WAAA;EACA,mBAAA;EACA,+FAAA;A/B6oUN;A+BroUE;EACE,cAAA;EACA,oBAAA;EACA,yBAAA;EACA,qBAAA;A/BuoUJ;A+BroUI;EACE,yBAAA;EACA,qBAAA;A/BuoUN;A+BpoUI;EACE,yBAAA;EACA,qBAAA;A/BsoUN;A+BloUE;EftPA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,uEAAA;EACA,yBAAA;EhB23UA,qBAAqB;EgB13UrB,iBAAA;EACA,YAAA;AhB43UF;AgB13UE;;EAEE,mBAAA;EACA,kEAAA;EAKA,cAAA;AhBw3UJ;AgBt3UE;;;EAGE,yBAAA;EACA,kEAAA;EAKA,cAAA;AhBo3UJ;AgBl3UE;;;EAGE,sBAAA;AhBo3UJ;AgBj3UE;EACE,cAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;AhBm3UJ;AgBz2UI;;;;;;;;;;;;;;;EAKE,yBAAA;EACA,qBAAA;AhBq3UN;A+BvrUE;Ef1LE,cAAA;EACA,yBAAA;AhBo3UJ;A+BvrUE;ElBqlBA,mBAAA;EACA,YAAA;EACA,uEAAA;EAEA,WAAA;EACA,gBAAA;AbomTF;AalmTE;EACE,uEAAA;EAEA,WAAA;AbmmTJ;AahmTE;;EAEE,mBAAA;EACA,uEAAA;EACA,WAAA;AbkmTJ;Aa/lTE;;EA1GA,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;Ab6sTF;A+B9sUE;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;A/BgtUJ;A+B9sUI;EACE,qCAAA;A/BgtUN;A+B7sUI;EACE,qCAAA;A/B+sUN;A+B5sUI;EACE,oCAAA;EACA,gBAAA;A/B8sUN;A+B1sUE;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;A/B4sUJ;A+B1sUI;EACE,qCAAA;A/B4sUN;A+BzsUI;EACE,qCAAA;A/B2sUN;A+BxsUI;EACE,oCAAA;EACA,gBAAA;A/B0sUN;A+BtsUE;EACE,yBAAA;EACA,WAAA;A/BwsUJ;A+BtsUI;EACE,yBAAA;EACA,cAAA;A/BwsUN;A+BrsUI;EACE,yBAAA;EACA,cAAA;A/BusUN;A+BnsUE;EACE,mBAAA;EACA,cAAA;EACA,8CAAA;EACA,mBAAA;EACA,iCAAA;A/BqsUJ;A+BnsUI;EACE,mBAAA;EACA,8CAAA;A/BqsUN;A+BlsUI;EACE,mBAAA;EACA,8CAAA;A/BosUN;Aa/qTE;EACE,uEAAA;EAEA,WAAA;AbgrTJ;Aa7qTE;;EAEE,mBAAA;EACA,uEAAA;EACA,WAAA;Ab+qTJ;Aa5qTE;;EA1GA,yBAAA;EACA,oCAAA;EACA,iCAAA;EACA,uBAAA;EACA,mBAAA;EACA,oCAAA;EACA,2BAAA;Ab0xTF;AiCh2UA;EAWI,WAAA;EACA,qBAAA;AjCw1UJ;AiCp1UA;EACE,YAAA;AjCs1UF;AiCv1UA;EAII,kBAAA;EACA,kBAAA;AjCs1UJ;AiCp1UI;EACE,yBAAA;AjCs1UN;AiCn1UI;EACE,yBAAA;AjCq1UN;AiCl1UI;EACE,yBAAA;EACA,WAAA;AjCo1UN;AiC/0UA;EACE,iBAAA;AjCi1UF;AiCl1UA;;EAKI,cAAA;AjCi1UJ;AiC70UA;EACE,eAAA;AjC+0UF;AiC50UA;EACE,kBAAA;EACA,mBAAA;AjC80UF;AiCh1UA;EAKI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,gCAAA;EACA,UAAA;AjC80UJ;AiC10UA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,wCAAA;AjC40UF;AiC10UE;;EAEE,yBAAA;AjC40UJ;AiCz0UE;EACE,sBAAA;AjC20UJ;AiCx0UE;EACE,yBAAA;EACA,yBAAA;AjC00UJ;AiCx0UI;;EAEE,yBAAA;AjC00UN;AiC50UI;;EAKI,yBAAA;AjC20UR;AiCv0UI;EACE,sBAAA;AjCy0UN;AiCp0UA;EACE,cAAA;EACA,YAAA;EACA,eAAA;AjCs0UF;AiCn0UA;EACE,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;AjCq0UF;AiC/zUA;;EAEE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;EACA,sBAAA;EACA,oBAAA;AjCi0UF;AiC9zUA;EACE,gBAAA;EACA,cAAA;AjCg0UF;AiC7zUA;EACE,gBAAA;EACA,iBAAA;EACA,cAAA;AjC+zUF;AiC5zUA;EACE,mBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;AjC8zUF;AiC3zUA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;AjC6zUF;AiC1zUA;EACE,yBAAA;EACA,cAAA;AjC4zUF;AiCxzUE;EACE,yBAAA;EACA,cAAA;AjC0zUJ;AiCvzUE;;EAEE,yBAAA;EACA,cAAA;AjCyzUJ;AiCtzUE;EACE,yBAAA;EACA,cAAA;AjCwzUJ;AiCrzUE;EACE,yBAAA;EACA,cAAA;AjCuzUJ;AiCzzUE;EAKI,QAAA;AjCuzUN;AiClzUA;EACE,kBAAA;EAEA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;AjCmzUF;AiChzUA;EACE,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;AjCkzUF;AiC/yUA;EACE;IAEI,kBAAA;EjCgzUJ;AACF;AiC5yUA;EAGE;IACE,YAAA;EjC4yUF;EiCzyUA;IACE,YAAA;EjC2yUF;EiCxyUA;IACE,gBAAA;EjC0yUF;AACF;AkCnyVA;EAEI,mBAAA;AlCoyVJ;AkChyVA;EACE,mCAAA;EAEA,6CAAA;AlCiyVF;AkCpyVA;EAOI,kBAAA;EACA,mBAAA;AlCgyVJ;AkCxyVA;EAYI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AlC+xVJ;AkC9yVA;EAkBM,WAAA;AlC+xVN;AkC3xVE;EAAA;IACE,sBAAA;ElC8xVF;AACF;AkC5xVE;EAEI,mBAAA;AlC6xVN;AkCzzVA;EAkCM,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,qBAAA;AlC0xVN;AkCnxVA;EAEI,6BAAA;AlCoxVJ;AkClxVI;EACE,gBAAA;AlCoxVN;AkCzxVA;EASM,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AlCmxVN;AkCnyVA;EAmBQ,eAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;AlCmxVR;AkCzyVA;EA4BI,yBAAA;AlCgxVJ;AkC5yVA;EA+BM,yBAAA;EACA,cAAA;AlCgxVN;AkChzVA;EAmCQ,WAAA;AlCgxVR;AkC7wVM;EACE,cAAA;EACA,yBAAA;AlC+wVR;AkCvzVA;EA8CI,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;AlC4wVJ;AkC1wVI;EACE,0BAAA;AlC4wVN;AkCj0VA;EA4DQ,0BAAA;AlCwwVR;AkCnwVE;EAGM,cAAA;AlCmwVR;AkC7vVA;EAEI,WAAA;EACA,uBAAA;EACA,gBAAA;AlC8vVJ;AkClwVA;EAQI,oBAAA;AlC6vVJ;AkCrwVA;EAWM,mBAAA;AlC6vVN;AkCxwVA;EAgBI,sBAAA;AlC2vVJ;AkCrvVA;EACE;IACE,mBAAA;IACA,UAAA;ElCuvVF;EkCpvVA;IACE,qBAAA;IACA,aAAA;ElCsvVF;EkCnvVA;IACE,mBAAA;IACA,UAAA;ElCqvVF;AACF;AACA,8DAA8D;AmCp5V9D;EACE,kBAAA;AnCs5VF;AmCn5VA;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,SAAA;AnCq5VF;AmCl5VA;EACE,aAAA;EACA,QAAA;EACA,8BAAA;EACA,uBAAA;AnCo5VF;AmCj5VA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,6BAAA;EACA,oBAAA;EACA,mBAAA;AnCm5VF;AmCj5VE;EACE,mBAAA;EACA,oBAAA;EACA,kBAAA;AnCm5VJ;AmC/4VA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AnCi5VF;AmC/4VE;EAEI,YAAA;EACA,UAAA;AnCg5VN;AmC34VA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,gBAAA;EACA,2BAAA;EACA,iCAAA;AnC64VF;AmCp5VA;EAUI,WAAA;EACA,YAAA;EACA,qDAAA;EACA,kBAAA;EACA,2CAAA;EACA,0BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;AnC64VJ;AmC34VI;EACE,oCAAA;EACA,sBAAA;AnC64VN;AmCx4VA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EAEA,yBAAA;EACA,mBAAA;EACA,sDAAA;EACA,yBAAA;EAEA,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EAEA,oBAAA;AnCs4VF;AmCn4VA;EACE,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,gCAAA;EACA,oCAAA;EACA,sBAAA;EACA,qBAAA;AnCq4VF;AmCl4VA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EAEA,gBAAA;EACA,uBAAA;EACA,mBAAA;AnCm4VF;AmCh4VA;EACE,2BAAA;EACA,0BAAA;EACA,yBAAA;EACA,2BAAA;EACA,gCAAA;AnCk4VF;AmC/3VA;EAEI,aAAA;EACA,sBAAA;EACA,QAAA;AnCg4VJ;AmC53VA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AnC83VF;AmCl4VA;EAOI,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;AnC83VJ;AmC13VA;EACE,WAAA;AnC43VF;AmCz3VA;EACE,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AnC23VF;AmCj4VA;EASI,aAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;AnC23VJ;AmCz3VI;EACE,mBAAA;AnC23VN;AmC94VA;EAuBM,gBAAA;AnC03VN;AmCr3VA;EA3BE,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EAEA,WAAA;EAwBA,sBAAA;EACA,gBAAA;EACA,QAAA;AnC23VF;AmC/3VA;EAnBI,aAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;AnCq5VJ;AmCn5VI;EACE,mBAAA;AnCq5VN;AmC54VA;EALM,gBAAA;AnCo5VN;AmC/4VA;EAOI,kBAAA;EACA,6BAAA;EACA,gBAAA;AnC24VJ;AmCz4VI;EACE,kBAAA;AnC24VN;AmCt4VA;EACE,0BAAA;EACA,wBAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EAEA,oCAAA;AnCu4VF;AmCr4VE;;;EAGE,gBAAA;EACA,iCAAA;AnCu4VJ;AmCn4VA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,MAAA;EACA,OAAA;AnCq4VF;AmCl4VA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,6BAAA;EACA,iCAAA;EACA,0BAAA;AnCo4VF;AmCp5VA;EAmBI,iCAAA;EACA,aAAA;EACA,QAAA;EACA,mBAAA;AnCo4VJ;AmCj4VE;EACE,yBAAA;AnCm4VJ;AmCp4VE;EAII,qBAAA;AnCm4VN;AmC93VA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EAEA,eAAA;AnC+3VF;AmCr4VA;EASI,aAAA;EACA,mBAAA;EACA,SAAA;EACA,iCAAA;AnC+3VJ;AmC53VE;EAEI,qBAAA;AnC63VN;AmCx3VA;EACE,YAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AnC03VF;AACA;;kEAEkE;AmCt3VlE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EAEA,sBAAA;AnCs3VF;AmCl4VA;;EAgBI,SAAA;EACA,UAAA;AnCs3VJ;AmCv4VA;EAqBI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;AnCq3VJ;AmC94VA;EA6BI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AnCo3VJ;AmCr5VA;EAqCI,qBAAA;EACA,cAAA;AnCm3VJ;AmCz5VA;EA0CI,aAAA;EACA,QAAA;EACA,kBAAA;AnCk3VJ;AACA;;kEAEkE;AmC72VlE;EACE;IACE,YAAA;IACA,eAAA;IACA,mBAAA;EnC+2VF;EmC52VA;IACE,WAAA;EnC82VF;EmC32VA;IACE,WAAA;EnC62VF;EmC12VA;IACE,mBAAA;IACA,WAAA;EnC42VF;EmC92VA;IAKI,mBAAA;IACA,4BAAA;EnC42VJ;AACF;AmCx2VA;EACE,YAAA;EACA,WAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,yJAAA;EAMA,iCAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;AnCm2VF;AmCv3VA;EAuBI,iCAAA;AnCm2VJ;AmCh2VE;EACE,8IAAA;EAKA,sBAAA;AnC81VJ;AmCp2VE;EASI,cAAA;AnC81VN;AACA;;oEAEoE;AoC9vWpE;EACE,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;ApC+vWF;AoC1wWA;EAcI,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;ApC+vWJ;AoC5vWE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,+BAAA;ApC8vWJ;AoC5vWI;EACE,eAAA;EACA,kBAAA;ApC8vWN;AoCzvWA;EACE,uCAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;ApC0vWF;AoCrwWA;EAcI,cAAA;EAEA,eAAA;EACA,iBAAA;EACA,gBAAA;ApCyvWJ;AoCtvWE;EACE,cAAA;EACA,WAAA;EAEA,YAAA;EACA,aAAA;EACA,WAAA;EAEA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,6DAAA;EACA,0BAAA;ApCsvWJ;AoClvWA;EACE,aAAA;EACA,sBAAA;EACA,MAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;ApCmvWF;AoC3vWA;EAWI,cAAA;EACA,qBAAA;ApCmvWJ;AoC/vWA;EAgBI,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EAEA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ApCivWJ;AoC7uWA;EACE,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;ApC8uWF;AoCxvWA;EAaI,kBAAA;EACA,mBAAA;EAEA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;EAEA,+BAAA;ApC4uWJ;AoC1uWI;EACE,kBAAA;ApC4uWN;AoCzuWI;EACE,mBAAA;EACA,kBAAA;ApC2uWN;AoCxwWA;EAkCI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;ApCyuWJ;AoC9wWA;EAyCI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;ApCwuWJ;AoCtuWI;EACE,0BAAA;ApCwuWN;AoCxxWA;EAqDI,SAAA;EACA,UAAA;ApCsuWJ;AoCluWA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EAEA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;ApCmuWF;AoC3uWA;EAWI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;ApCmuWJ;AoClvWA;EAmBI,kBAAA;ApCkuWJ;AoCrvWA;;EAwBI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;ApCiuWJ;AACA,2DAA2D;AoC5tW3D;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,wBAAA;EACA,gBAAA;ApC8tWF;AoCruWA;EASI,wBAAA;EACA,mBAAA;ApC+tWJ;AoCzuWA;EAaI,qCAAA;EACA,4BAAA;EACA,iCAAA;ApC+tWJ;AoC9uWA;EAoBM,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EAEA,4BAAA;EACA,gCAAA;ApC4tWN;AoCtvWA;EA+BI,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;ApC0tWJ;AoC7vWA;EAsCM,wCAAA;EACA,qCAAA;EACA,4BAAA;EACA,qBAAA;ApC0tWN;AoCnwWA;EA8CI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;ApCwtWJ;AoCzwWA;EAoDM,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;ApCwtWN;AoChxWA;EA6DI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;ApCstWJ;AoCntWA;EACE,wBAAA;EACA,mBAAA;ApCqtWF;AoCntWA;EAGM,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EAEA,4BAAA;EACA,6BAAA;ApCktWN;AoC3tWA;EAgBQ,8BAAA;EACA,2BAAA;ApC8sWR;AoC/tWA;EAuBI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;ApC2sWJ;AoCruWA;EA6BM,gCAAA;EACA,8BAAA;EACA,2BAAA;ApC2sWN;AoC1uWA;EAoCI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;ApCysWJ;AoChvWA;EA0CM,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;ApCysWN;AoCvvWA;EAmDI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;ApCusWJ;AoC7vWA;EAyDM,8BAAA;EACA,iBAAA;EACA,oBAAA;ApCusWN;AACA,iCAAiC;AoClsWjC;EACE,yBAAA;EACA,iBAAA;ApCosWF;AACA,4DAA4D;AqC/gX5D;EACE,yBAAA;EACA,8CAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;ArCihXF;AqC9gXA;EACE,YAAA;EACA,WAAA;ArCghXF;AqC5gXE;EACE,cAAA;ArC8gXJ;AqC3gXE;EACE,cAAA;ArC6gXJ;AqC1gXE;EACE,cAAA;ArC4gXJ;AqCxgXA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;ArC0gXF;AqCvgXA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;ArCygXF;AqC5gXA;EAMI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iCAAA;ArCygXJ;AqCnhXA;EAcI,wCAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,iCAAA;EACA,sBAAA;ArCwgXJ;AqCtgXI;EACE,wCAAA;ArCwgXN;AACA,sEAAsE;AqClgXtE;EACE,yBAAA;EACA,kBAAA;ArCogXF;AqCtgXA;EAKI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;ArCogXJ;AACA,6DAA6D;AqC7/W7D;EAEI,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EAEA,eAAA;EACA,iBAAA;EACA,WAAA;ArC6/WJ;AqC1gXA;EAgBM,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ArC6/WN;AqChhXA;EAwBI,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;ArC2/WJ;AqC1hXA;EAmCI,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,aAAA;ArC0/WJ;AqCjiXA;EA2CI,aAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;ArCy/WJ;AqC3iXA;EAsDI,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;ArCw/WJ;AqCt/WI;EACE,gBAAA;ArCw/WN;AqCrjXA;EAkEI,kBAAA;ArCs/WJ;AqCxjXA;EAqEM,kBAAA;EACA,mBAAA;EACA,yFAAA;EAOA,aAAA;EACA,QAAA;EACA,qBAAA;EACA,UAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;ArCg/WN;AqCpkXA;EAuFQ,eAAA;EACA,SAAA;EACA,6BAAA;EACA,sBAAA;ArCg/WR;AqC9+WQ;EACE,kBAAA;ArCg/WV;AsCrqXA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AtCuqXF;AsCpqXA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AtCsqXF;AsCnqXA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8CAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AtCqqXF;AsC/qXA;EAaI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;AtCqqXJ;AsCtrXA;EAqBI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;AtCoqXJ;AsC5rXA;EA4BI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AtCmqXJ;AsC/pXA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AtCiqXF;AsC5pXI;EAEI,aAAA;AtC6pXR;AsCvpXA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,yBAAA;AtCypXF;AsCtpXA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;AtCwpXF;AsC9pXA;EASI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AtCwpXJ;AsCppXA;EACE,0BAAA;EACA,kBAAA;AtCspXF;AsCnpXA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AtCqpXF;AsClpXA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AtCopXF;AsCvpXA;EAMI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,QAAA;AtCopXJ;AsClqXA;EAiBM,eAAA;EACA,gBAAA;EACA,SAAA;AtCopXN;AsCvqXA;EAsBQ,eAAA;EACA,gBAAA;EACA,WAAA;AtCopXR;AsC5qXA;EAiBM,eAAA;EACA,gBAAA;EACA,SAAA;EAWA,kBAAA;AtCopXN;AsClrXA;EAsBQ,eAAA;EACA,gBAAA;EACA,WAAA;AtC+pXR;AsCvrXA;EAkCM,aAAA;EACA,sBAAA;EACA,QAAA;AtCwpXN;AsCtpXM;EACE,cAAA;AtCwpXR;AsClpXA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AtCopXF;AsCzpXA;EAQI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;AtCopXJ;AsC/pXA;EAeI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,SAAA;AtCmpXJ;AsCtqXA;EAuBI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AtCkpXJ;AsC9oXA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,mBAAA;AtCgpXF;AsCppXA;EAOI,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AtCgpXJ;AsC5pXA;EAgBI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,6BAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iCAAA;AtC+oXJ;AsC7oXI;EACE,mBAAA;AtC+oXN;AsC5oXI;EACE,yBAAA;AtC8oXN;AsC7qXA;EAmCM,cAAA;EACA,eAAA;EACA,gBAAA;AtC6oXN;AuCt2XA;EAEI,aAAA;EACA,8BAAA;EACA,mBAAA;AvCu2XJ;AuC32XA;EAQI,aAAA;EACA,mBAAA;EACA,QAAA;AvCs2XJ;AuCh3XA;EAcI,mBAAA;AvCq2XJ;AuCn3XA;EAiBM,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AvCq2XN;AuC13XA;EA0BI,aAAA;EACA,uBAAA;EACA,yBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AvCm2XJ;AuCl4XA;EAmCI,YAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,yJAAA;EAKA,iCAAA;EACA,eAAA;AvC81XJ;AuC51XI;EACE,yJAAA;AvC81XN;AuCv1XI;EACE,sBAAA;AvCy1XN;AuCp5XA;EA+DM,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AvCw1XN;AuC75XA;EAwEQ,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,wCAAA;EACA,kBAAA;AvCw1XR;AuCt1XQ;EACE,mBAAA;AvCw1XV;AuC56XA;EAwFU,mCAAA;EACA,cAAA;EACA,WAAA;AvCu1XV;AuCl1XI;EACE,YAAA;EACA,SAAA;AvCo1XN;AuCr7XA;EAqGM,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;AvCm1XN;AuC77XA;EA6GQ,YAAA;EACA,OAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AvCm1XR;AuCx8XA;EA2HI,YAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EAEA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;EACA,iCAAA;AvC+0XJ;AuC70XI;EACE,kBAAA;EACA,mBAAA;AvC+0XN;AuC50XI;EACE,sBAAA;AvC80XN;AuCj+XA;EAwJI,WAAA;EACA,YAAA;AvC40XJ;AuCr+XA;EA4JM,WAAA;EACA,uBAAA;EACA,gBAAA;AvC40XN;AuC1+XA;EAkKM,oBAAA;AvC20XN;AuC7+XA;EAqKQ,mBAAA;AvC20XR;AuCh/XA;EA0KM,sBAAA;AvCy0XN;AuCn/XA;EA+KI,mBAAA;AvCu0XJ;AuCt/XA;EAmLI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;AvCs0XJ;AuC7/XA;EA2LI,aAAA;EACA,QAAA;AvCq0XJ;AuCjgYA;EAgMI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,8BAAA;AvCo0XJ;AuCh0XA;EACE,aAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,yJAAA;EAKA,kBAAA;EACA,YAAA;EACA,0BAAA;EACA,qBAAA;EACA,SAAA;AvC8zXF;AwClhYA;EAGM,6EAAA;EAEA,0BAAA;AxCihYN;AwCthYA;EASM,aAAA;AxCghYN;AwCzhYA;EAaM,eAAA;EACA,cAAA;EACA,SAAA;AxC+gYN;AwC7gYM;EACE,gBAAA;EACA,cAAA;AxC+gYR;AwCliYA;EAwBM,gBAAA;EACA,gBAAA;AxC6gYN;AwCtiYA;EA6BM,gBAAA;EACA,iBAAA;AxC4gYN;AwC1iYA;EAkCM,cAAA;AxC2gYN;AwC7iYA;EAsCM,kBAAA;EACA,gBAAA;AxC0gYN;AwCjjYA;EA2CM,iBAAA;EACA,gBAAA;AxCygYN;AwCrjYA;EAgDM,WAAA;EACA,YAAA;EACA,iBAAA;AxCwgYN;AwC1jYA;EAsDM,gBAAA;EACA,aAAA;AxCugYN;AwC9jYA;EA0DQ,aAAA;EACA,gBAAA;AxCugYR;AwClkYA;EA+DQ,iBAAA;EACA,iBAAA;EACA,YAAA;AxCsgYR;AwCvkYA;EAsEM,mBAAA;EACA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;AxCogYN;AwClgYM;EACE,cAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;AxCogYR;AwCjgYM;EACE,eAAA;AxCmgYR;AwCzlYA;EA+FM,gBAAA;EACA,kBAAA;EACA,kBAAA;AxC6/XN;AwC3/XM;EAEI,SAAA;EACA,kBAAA;AxC4/XV;AwC//XM;EAOI,UAAA;EACA,iBAAA;EACA,gBAAA;AxC2/XV;AwCpgYM;EAaI,UAAA;AxC0/XV;AwCvgYM;EAiBI,SAAA;AxCy/XV;AwC1gYM;EAqBI,WAAA;AxCw/XV;AwC7gYM;EAyBI,UAAA;AxCu/XV;AwCn/XM;EAEI,WAAA;EACA,kBAAA;AxCo/XV;AwCv/XM;EAOI,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AxCm/XV;AwC9/XM;EAeI,UAAA;AxCk/XV;AwCjgYM;EAmBI,WAAA;AxCi/XV;AwCpgYM;EAuBI,YAAA;AxCg/XV;AwCvgYM;EA2BI,YAAA;AxC++XV;AwC3+XM;EAEI,gBAAA;AxC4+XV;AwC9+XM;EAMI,SAAA;EACA,kBAAA;AxC2+XV;AwCl/XM;EAWI,UAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AxC0+XV;AwCz/XM;EAmBI,UAAA;AxCy+XV;AwC5/XM;EAuBI,UAAA;AxCw+XV;AwCp+XM;EAEI,gBAAA;AxCq+XV;AwCv+XM;EAMI,UAAA;AxCo+XV;AwC1+XM;EAUI,UAAA;EACA,iBAAA;AxCm+XV;AwC9+XM;EAeI,SAAA;EACA,iBAAA;AxCk+XV;AwCl/XM;EAoBI,UAAA;EACA,iBAAA;AxCi+XV;AwCt/XM;EAyBI,UAAA;EACA,iBAAA;AxCg+XV;AwCprYA;EAyNQ,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,oBAAA;EACA,cAAA;AxC89XR;AwC/rYA;EAqOQ,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AxC69XR;AwCtsYA;EA6OQ,gBAAA;AxC49XR;AwCzsYA;EAiPQ,yBAAA;AxC29XR;AwC5sYA;EAqPQ,WAAA;EACA,gBAAA;EACA,aAAA;AxC09XR;AwCjtYA;EA2PQ,yBAAA;AxCy9XR;AwCptYA;EA+PQ,yBAAA;AxCw9XR;AwCvtYA;EAmQQ,yBAAA;AxCu9XR;AwC1tYA;EAuQQ,WAAA;EACA,gBAAA;EACA,aAAA;AxCs9XR;AwC/tYA;EA6QQ,yBAAA;AxCq9XR;AwCluYA;EAiRQ,yBAAA;AxCo9XR;AwCruYA;EAqRQ,yBAAA;AxCm9XR;AwCxuYA;EAyRQ,WAAA;EACA,gBAAA;EACA,aAAA;AxCk9XR;AwC7uYA;EA+RQ,yBAAA;AxCi9XR;AwChvYA;EAmSQ,yBAAA;AxCg9XR;AwCnvYA;EAuSQ,yBAAA;AxC+8XR;AwCtvYA;EA2SQ,WAAA;EACA,gBAAA;EACA,aAAA;AxC88XR;AwC3vYA;EAiTQ,yBAAA;AxC68XR;AwC9vYA;EAqTQ,WAAA;EACA,yBAAA;AxC48XR;AwClwYA;EA0TQ,yBAAA;AxC28XR;AwCrwYA;EA8TQ,WAAA;AxC08XR;AwCxwYA;EAkUQ,yBAAA;AxCy8XR;AwC3wYA;EAsUQ,yBAAA;AxCw8XR;AwC9wYA;EA0UQ,yBAAA;AxCu8XR;AwCjxYA;EA8UQ,WAAA;EACA,gBAAA;EACA,aAAA;AxCs8XR;AwCtxYA;EAoVQ,yBAAA;AxCq8XR;AwCzxYA;EAwVQ,yBAAA;AxCo8XR;AwC5xYA;EA4VQ,yBAAA;AxCm8XR;AwC/xYA;EAgWQ,WAAA;EACA,gBAAA;EACA,aAAA;AxCk8XR;AwCpyYA;EAsWQ,yBAAA;AxCi8XR;AwCvyYA;EA0WQ,yBAAA;AxCg8XR;AwC1yYA;EA8WQ,iBAAA;AxC+7XR;AwC7yYA;EAkXQ,kBAAA;AxC87XR;AyChzYA;EAEI,iBAAA;EACA,kBAAA;AzCizYJ;AyCpzYA;;EAMM,kBAAA;AzCkzYN;AyCxzYA;EASM,gBAAA;AzCkzYN;AyC3zYA;EAYM,kBAAA;AzCkzYN;AyC9zYA;EAeM,mBAAA;AzCkzYN;AyCj0YA;EAkBM,mBAAA;AzCkzYN;A0Cl0YA;EACE,iBAAA;A1Co0YF;A0Cr0YA;EAGI,eAAA;A1Cq0YJ;A0Cx0YA;EAMI,yBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;A1Cq0YJ;A0C90YA;EAYI,kBAAA;A1Cq0YJ;A0Cj1YA;EAeI,iBAAA;A1Cq0YJ;A0Cp1YA;EAiBM,eAAA;EACA,gBAAA;EACA,cAAA;A1Cs0YN;A0Cz1YA;EAsBM,eAAA;EACA,gBAAA;EACA,cAAA;A1Cs0YN;A0C91YA;;EA4BM,eAAA;EACA,iBAAA;EACA,cAAA;A1Cs0YN;A0Cp2YA;EAiCM,cAAA;A1Cs0YN;A0Cv2YA;EAoCM,aAAA;A1Cs0YN;A0C12YA;EAuCM,kBAAA;A1Cs0YN;A0C72YA;EA0CM,eAAA;EACA,gBAAA;EACA,cAAA;A1Cs0YN;A0Cl3YA;EA+CM,cAAA;A1Cs0YN;A0Cr3YA;EAkDM,eAAA;A1Cs0YN;A0Cx3YA;EAoDQ,sBAAA;A1Cu0YR;A0C33YA;EAuDQ,eAAA;EACA,kBAAA;EACA,sBAAA;A1Cu0YR;A0Ch4YA;EA4DQ,eAAA;EACA,gBAAA;A1Cu0YR;A0Cp4YA;EAmEM,cAAA;A1Co0YN;A0Cv4YA;EAwEM,cAAA;A1Ck0YN;A0C14YA;;EA8EI,eAAA;EACA,iBAAA;A1Cg0YJ;A0C/4YA;;EAiFM,aAAA;A1Ck0YN;A2Cr5YE;EAEI,eAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;A3Cs5YN;A2C55YE;EASI,UAAA;EACA,iBAAA;A3Cs5YN;A2Ch6YE;EAaI,eAAA;A3Cs5YN;A2Cn6YE;EAgBQ,gBAAA;EACA,qBAAA;A3Cs5YV;A2Cn5YM;EACE,iBAAA;EACA,cAAA;A3Cq5YR;A2C36YE;EA0BI,gBAAA;EACA,gBAAA;EACA,cAAA;A3Co5YN;A2Ch7YE;EAgCI,kBAAA;EACA,oBAAA;A3Cm5YN;A2Cp7YE;EAmCM,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,QAAA;EACA,8BAAA;EACA,0BAAA;A3Co5YR;A2C97YE;EA8CI,kBAAA;EACA,oBAAA;A3Cm5YN;A2Cl8YE;EAiDM,WAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,+BAAA;EACA,0BAAA;A3Co5YR;A2C58YE;EA6DI,6BAAA;EACA,iBAAA;A3Ck5YN;A2Ch9YE;EAkEI,eAAA;A3Ci5YN;A2Cn9YE;EAoEM,cAAA;A3Ck5YR;A4Cp9YE;EAEI,eAAA;A5Cq9YN;A4Cx9YA;EAQI,sBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;A5Cm9YJ;A4Ch+YA;;EAiBM,sBAAA;EACA,yBAAA;EACA,wBAAA;A5Cm9YN;A4Ct+YA;;EAwBM,wBAAA;EACA,mBAAA;A5Ck9YN;A4C3+YA;;EA8BM,iBAAA;A5Ci9YN;A4C/+YA;EAkCM,mBAAA;A5Cg9YN;A4Cl/YA;EAuCI,eAAA;EACA,gBAAA;A5C88YJ;A4Ct/YA;;;EA6CM,wBAAA;A5C88YN;A4C3/YA;EAkDI,eAAA;EACA,gBAAA;A5C48YJ;A4C//YA;EAsDM,wBAAA;A5C48YN;A4ClgZA;;EA2DM,wBAAA;A5C28YN;A4CtgZA;EAgEI,eAAA;EACA,gBAAA;A5Cy8YJ;A4C1gZA;EAoEM,wBAAA;A5Cy8YN;A4C7gZA;;EAyEM,wBAAA;A5Cw8YN;A4CjhZA;EA8EI,eAAA;EACA,gBAAA;A5Cs8YJ;A4CrhZA;EAkFM,wBAAA;A5Cs8YN;A4CxhZA;;EAuFM,wBAAA;A5Cq8YN;A4C5hZA;;EA8FM,wBAAA;A5Ck8YN;A4ChiZA;EAmGI,eAAA;EACA,kBAAA;EACA,kBAAA;A5Cg8YJ;A4CriZA;EAyGI,eAAA;EACA,gBAAA;EACA,kBAAA;A5C+7YJ;A4C1iZA;EA+GI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;A5C87YJ;A4ChjZA;EAsHI,eAAA;EACA,mBAAA;A5C67YJ;A4CpjZA;EA2HI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,gBAAA;A5C47YJ;A4C3jZA;EAmII,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;A5C27YJ;A4ClkZA;EA2II,aAAA;EACA,cAAA;A5C07YJ;A4CtkZA;EAgJI,gBAAA;A5Cy7YJ;A4CzkZA;EAoJI,cAAA;EACA,gBAAA;EACA,gBAAA;A5Cw7YJ;A6C5kZQ;EACE,YAAA;A7C8kZV;A6C5kZQ;EACE,YAAA;A7C8kZV;A6C5kZQ;EACE,YAAA;A7C8kZV;A6C5kZQ;EACE,YAAA;A7C8kZV;A6C5kZQ;EACE,WAAA;A7C8kZV;A6C9lZE;EAoBM,kBAAA;A7C6kZR;A8ClmZA;EAEI,eAAA;A9CmmZJ;A8CrmZA;EAIM,kBAAA;A9ComZN;A8CxmZA;EAOM,cAAA;EACA,gBAAA;A9ComZN;A8C5mZA;EAWM,kBAAA;A9ComZN;A+C/mZA;EAGM,eAAA;EACA,gBAAA;A/C+mZN;A+CnnZA;EAOM,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EACA,kBAAA;A/C+mZN;A+C3nZA;EAeM,eAAA;EACA,gBAAA;A/C+mZN;A+C/nZA;EAmBM,mBAAA;EACA,WAAA;EACA,sBAAA;A/C+mZN;A+C9mZM;;EAEE,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;A/CgnZR;A+C9mZM;EACE,sBAAA;EACA,oBAAA;A/CgnZR;A+C9mZM;EACE,yBAAA;EACA,WAAA;A/CgnZR;AgDlpZA;EAOI,6BAAA;EACA,YAAA;EACA,gBAAA;AhD8oZJ;AgDrpZI;EACE,cAAA;EACA,4BAAA;EACA,cAAA;AhDupZN;AgDlpZI;EACE,yBAAA;EACA,wBAAA;EACA,gBAAA;EACA,aAAA;AhDopZN;AgDlpZI;EACE,yBAAA;AhDopZN;AgDlpZI;EACE,yBAAA;AhDopZN;AgDxqZA;EAwBI,YAAA;AhDmpZJ;AgD3qZA;EA0BM,WAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;AhDopZN;AgDnpZM;EACE,aAAA;AhDqpZR;AgDnpZM;EACE,2BAAA;AhDqpZR;AgDnpZM;EACE,4BAAA;AhDqpZR;AgD7rZA;;EA4CQ,eAAA;AhDqpZR;AgDnpZM;EACE,yBAAA;AhDqpZR;AgDpsZA;EAmDM,gBAAA;AhDopZN;AgDvsZA;EAsDM,kBAAA;AhDopZN;AiDvsZA;;;;;;;EAQI,yBAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AjDwsZJ;AiDptZA;;;;;;;EAcM,cAAA;AjD+sZN;AiD7sZI;;;;;;;EACE,qBAAA;AjDqtZN;AiDttZI;;;;;;;EAGI,cAAA;AjD4tZR;AiDztZI;;;;;;;EACE,yBAAA;AjDiuZN;AiDluZI;;;;;;;EAGI,cAAA;AjDwuZR;AiDruZI;;;;;;;;;;;;;;;;;;;;;EAGE,yBAAA;EACA,sBAAA;AjDyvZN;AiD7vZI;;;;;;;;;;;;;;;;;;;;;EAMI,WAAA;AjD8wZR;AiDhzZA;EAuCI,yBAAA;EACA,qBAAA;AjD4wZJ;AiDpzZA;EA0CM,WAAA;AjD6wZN;AiD3wZI;EACE,WAAA;AjD6wZN;AiD1zZA;;EAmDI,cAAA;AjD2wZJ;AiD9zZA;;;;EAyDI,UAAA;EACA,cAAA;AjD2wZJ;AiDr0ZA;EA6DI,qBAAA;AjD2wZJ;AiDx0ZA;;;EAmEI,cAAA;EACA,sBAAA;EACA,qBAAA;AjD0wZJ;AiD/0ZA;EAwEI,qBAAA;AjD0wZJ;AiDl1ZA;;;EA8EI,cAAA;EACA,sBAAA;EACA,qBAAA;AjDywZJ;AkDz1ZA;EACE,mBAAA;AlD21ZF;AkD51ZA;EAGI,yBAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;EACA,mCAAA;AlD41ZJ;AkDn2ZA;EAUI,4BAAA;AlD41ZJ;AkDt2ZA;EAaI,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,yBAAA;AlD41ZJ;AkD31ZI;EACE,4BAAA;AlD61ZN;AkD31ZI;EACE,yBAAA;EACA,WAAA;AlD61ZN;AkD31ZI;EACE,yBAAA;AlD61ZN;AkD11ZI;EACE,yBAAA;AlD41ZN;AkDz3ZA;EAiCM,kBAAA;AlD21ZN;AmD/3ZA;EACE,aAAA;AnDi4ZF;AmD/3ZE;EACE,YAAA;AnDi4ZJ;AmD73ZA;EACE,aAAA;AnD+3ZF;AmD53ZA;EACE,4BAAA;EACA,mBAAA;AnD83ZF;AmD33ZA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AnD63ZF;AmD13ZA;EACE,yCAAA;EACA,kBAAA;AnD43ZF;AmDz3ZA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,4BAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;AnD23ZF;AmDz3ZE;EACE,YAAA;AnD23ZJ;AmDx3ZE;EACE,YAAA;AnD03ZJ;AmDt3ZA;EACE,kBAAA;AnDw3ZF;AmDp3ZA;EACE,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;AnDs3ZF;AmD73ZA;EAUI,eAAA;EACA,gBAAA;AnDs3ZJ;AmDj4ZA;EAcM,aAAA;EACA,yBAAA;AnDs3ZN;AmDj3ZA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,aAAA;EACA,yBAAA;AnDm3ZF;AmDj3ZE;EACE,UAAA;EACA,wBAAA;AnDm3ZJ;AmDh3ZE;EACE,YAAA;EACA,yBAAA;AnDk3ZJ;AmD92ZA;EACE,UAAA;EACA,YAAA;AnDg3ZF;AmDz2ZA;EACE,cAAA;AnD22ZF;AmD52ZA;EAII,yBAAA;AnD22ZJ;AmDx2ZE;EACE,eAAA;AnD02ZJ;AmDt2ZA;EAEI,YAAA;AnDu2ZJ;AmDz2ZA;EAMI,cAAA;AnDs2ZJ;AmD52ZA;EASM,yBAAA;AnDs2ZN;AmD/2ZA;EAcI,yBAAA;AnDo2ZJ;AmDl3ZA;EAkBI,eAAA;AnDm2ZJ;AmDr3ZA;;EAuBI,kBAAA;EACA,cAAA;AnDk2ZJ;AmD13ZA;;EA6BI,kBAAA;EACA,kBAAA;AnDi2ZJ;AmD/3ZA;;EAmCI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AnDg2ZJ;AmD34ZA;;EAgDI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iCAAA;EACA,yBAAA;AnD+1ZJ;AmDz5ZA;EA8DI,UAAA;EACA,mBAAA;AnD81ZJ;AmD75ZA;EAmEI,UAAA;EACA,mBAAA;AnD61ZJ;AmDj6ZA;EAwEI,yBAAA;AnD41ZJ;AmDx1ZA;EACE;IACE,YAAA;EnD01ZF;AACF;AmDv1ZA;EAEI,UAAA;AnDw1ZJ;AmD11ZA;EAKI,mBAAA;AnDw1ZJ;AmD71ZA;EAQI,gBAAA;AnDw1ZJ;AmDn1ZM;EAAA;IACE,UAAA;EnDs1ZN;AACF;AmDj1ZA;EAEI,UAAA;AnDk1ZJ;AmDp1ZA;EAKI,mBAAA;AnDk1ZJ;AmDv1ZA;EAQI,gBAAA;AnDk1ZJ;AmD70ZM;EAAA;IACE,UAAA;EnDg1ZN;AACF;AoDzjaA;EACE,aAAA;EACA,eAAA;EACA,gCAAA;EACA,cAAA;EACA,oBAAA;ApD2jaF;AoDzjaE;EACE,mBAAA;ApD2jaJ;AoDnkaA;EAYI,gBAAA;EACA,mBAAA;ApD0jaJ;AoDvkaA;EAiBI,gBAAA;ApDyjaJ;AoD1kaA;EAqBI,cAAA;EACA,UAAA;EACA,mBAAA;ApDwjaJ;AoD/kaA;EA2BI,YAAA;EACA,mBAAA;EACA,kBAAA;ApDujaJ;AoDnjaA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;ApDqjaF;AoDnjaE;EACE,eAAA;ApDqjaJ;AoDljaE;EACE,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,qBAAA;EACA,yBAAA;ApDojaJ;AoDlkaA;EAkBI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApDmjaJ;AoD/iaA;EAEI,gBAAA;EACA,YAAA;ApDgjaJ;AoD5iaA;EACE,cAAA;EACA,mBAAA;ApD8iaF;AoD3iaA;;EAEE,iBAAA;ApD6iaF;AoD1iaA;EACE,kBAAA;ApD4iaF;AqDtmaG;EACC,0BAAA;ArDwmaJ;AqDrmaG;EACC,6BAAA;ArDumaJ;AqDpmaG;EACC,2BAAA;ArDsmaJ;AqDnmaG;EACC,4BAAA;ArDqmaJ;AqDlmaG;EACC,2BAAA;EACA,4BAAA;ArDomaJ;AqDjmaG;EACC,0BAAA;EACA,6BAAA;ArDmmaJ;AqDhmaG;EACC,2BAAA;ArDkmaJ;AqD/laG;EACC,8BAAA;ArDimaJ;AqD9laG;EACC,4BAAA;ArDgmaJ;AqD7laG;EACC,6BAAA;ArD+laJ;AqD5laG;EACC,4BAAA;EACA,6BAAA;ArD8laJ;AqD3laG;EACC,2BAAA;EACA,8BAAA;ArD6laJ;AqD1laG;EACC,mBAAA;ArD4laJ;AqDjpaG;EACC,0BAAA;ArDmpaJ;AqDhpaG;EACC,6BAAA;ArDkpaJ;AqD/oaG;EACC,2BAAA;ArDipaJ;AqD9oaG;EACC,4BAAA;ArDgpaJ;AqD7oaG;EACC,2BAAA;EACA,4BAAA;ArD+oaJ;AqD5oaG;EACC,0BAAA;EACA,6BAAA;ArD8oaJ;AqD3oaG;EACC,2BAAA;ArD6oaJ;AqD1oaG;EACC,8BAAA;ArD4oaJ;AqDzoaG;EACC,4BAAA;ArD2oaJ;AqDxoaG;EACC,6BAAA;ArD0oaJ;AqDvoaG;EACC,4BAAA;EACA,6BAAA;ArDyoaJ;AqDtoaG;EACC,2BAAA;EACA,8BAAA;ArDwoaJ;AqDroaG;EACC,mBAAA;ArDuoaJ;AqD5raG;EACC,0BAAA;ArD8raJ;AqD3raG;EACC,6BAAA;ArD6raJ;AqD1raG;EACC,2BAAA;ArD4raJ;AqDzraG;EACC,4BAAA;ArD2raJ;AqDxraG;EACC,2BAAA;EACA,4BAAA;ArD0raJ;AqDvraG;EACC,0BAAA;EACA,6BAAA;ArDyraJ;AqDtraG;EACC,2BAAA;ArDwraJ;AqDrraG;EACC,8BAAA;ArDuraJ;AqDpraG;EACC,4BAAA;ArDsraJ;AqDnraG;EACC,6BAAA;ArDqraJ;AqDlraG;EACC,4BAAA;EACA,6BAAA;ArDoraJ;AqDjraG;EACC,2BAAA;EACA,8BAAA;ArDmraJ;AqDhraG;EACC,mBAAA;ArDkraJ;AqDvuaG;EACC,0BAAA;ArDyuaJ;AqDtuaG;EACC,6BAAA;ArDwuaJ;AqDruaG;EACC,2BAAA;ArDuuaJ;AqDpuaG;EACC,4BAAA;ArDsuaJ;AqDnuaG;EACC,2BAAA;EACA,4BAAA;ArDquaJ;AqDluaG;EACC,0BAAA;EACA,6BAAA;ArDouaJ;AqDjuaG;EACC,2BAAA;ArDmuaJ;AqDhuaG;EACC,8BAAA;ArDkuaJ;AqD/taG;EACC,4BAAA;ArDiuaJ;AqD9taG;EACC,6BAAA;ArDguaJ;AqD7taG;EACC,4BAAA;EACA,6BAAA;ArD+taJ;AqD5taG;EACC,2BAAA;EACA,8BAAA;ArD8taJ;AqD3taG;EACC,mBAAA;ArD6taJ;AqDlxaG;EACC,0BAAA;ArDoxaJ;AqDjxaG;EACC,6BAAA;ArDmxaJ;AqDhxaG;EACC,2BAAA;ArDkxaJ;AqD/waG;EACC,4BAAA;ArDixaJ;AqD9waG;EACC,2BAAA;EACA,4BAAA;ArDgxaJ;AqD7waG;EACC,0BAAA;EACA,6BAAA;ArD+waJ;AqD5waG;EACC,2BAAA;ArD8waJ;AqD3waG;EACC,8BAAA;ArD6waJ;AqD1waG;EACC,4BAAA;ArD4waJ;AqDzwaG;EACC,6BAAA;ArD2waJ;AqDxwaG;EACC,4BAAA;EACA,6BAAA;ArD0waJ;AqDvwaG;EACC,2BAAA;EACA,8BAAA;ArDywaJ;AqDtwaG;EACC,mBAAA;ArDwwaJ;AqD7zaG;EACC,2BAAA;ArD+zaJ;AqD5zaG;EACC,8BAAA;ArD8zaJ;AqD3zaG;EACC,4BAAA;ArD6zaJ;AqD1zaG;EACC,6BAAA;ArD4zaJ;AqDzzaG;EACC,4BAAA;EACA,6BAAA;ArD2zaJ;AqDxzaG;EACC,2BAAA;EACA,8BAAA;ArD0zaJ;AqDvzaG;EACC,4BAAA;ArDyzaJ;AqDtzaG;EACC,+BAAA;ArDwzaJ;AqDrzaG;EACC,6BAAA;ArDuzaJ;AqDpzaG;EACC,8BAAA;ArDszaJ;AqDnzaG;EACC,6BAAA;EACA,8BAAA;ArDqzaJ;AqDlzaG;EACC,4BAAA;EACA,+BAAA;ArDozaJ;AqDjzaG;EACC,oBAAA;ArDmzaJ;AqDx2aG;EACC,2BAAA;ArD02aJ;AqDv2aG;EACC,8BAAA;ArDy2aJ;AqDt2aG;EACC,4BAAA;ArDw2aJ;AqDr2aG;EACC,6BAAA;ArDu2aJ;AqDp2aG;EACC,4BAAA;EACA,6BAAA;ArDs2aJ;AqDn2aG;EACC,2BAAA;EACA,8BAAA;ArDq2aJ;AqDl2aG;EACC,4BAAA;ArDo2aJ;AqDj2aG;EACC,+BAAA;ArDm2aJ;AqDh2aG;EACC,6BAAA;ArDk2aJ;AqD/1aG;EACC,8BAAA;ArDi2aJ;AqD91aG;EACC,6BAAA;EACA,8BAAA;ArDg2aJ;AqD71aG;EACC,4BAAA;EACA,+BAAA;ArD+1aJ;AqD51aG;EACC,oBAAA;ArD81aJ;AqDn5aG;EACC,2BAAA;ArDq5aJ;AqDl5aG;EACC,8BAAA;ArDo5aJ;AqDj5aG;EACC,4BAAA;ArDm5aJ;AqDh5aG;EACC,6BAAA;ArDk5aJ;AqD/4aG;EACC,4BAAA;EACA,6BAAA;ArDi5aJ;AqD94aG;EACC,2BAAA;EACA,8BAAA;ArDg5aJ;AqD74aG;EACC,4BAAA;ArD+4aJ;AqD54aG;EACC,+BAAA;ArD84aJ;AqD34aG;EACC,6BAAA;ArD64aJ;AqD14aG;EACC,8BAAA;ArD44aJ;AqDz4aG;EACC,6BAAA;EACA,8BAAA;ArD24aJ;AqDx4aG;EACC,4BAAA;EACA,+BAAA;ArD04aJ;AqDv4aG;EACC,oBAAA;ArDy4aJ;AqD97aG;EACC,2BAAA;ArDg8aJ;AqD77aG;EACC,8BAAA;ArD+7aJ;AqD57aG;EACC,4BAAA;ArD87aJ;AqD37aG;EACC,6BAAA;ArD67aJ;AqD17aG;EACC,4BAAA;EACA,6BAAA;ArD47aJ;AqDz7aG;EACC,2BAAA;EACA,8BAAA;ArD27aJ;AqDx7aG;EACC,4BAAA;ArD07aJ;AqDv7aG;EACC,+BAAA;ArDy7aJ;AqDt7aG;EACC,6BAAA;ArDw7aJ;AqDr7aG;EACC,8BAAA;ArDu7aJ;AqDp7aG;EACC,6BAAA;EACA,8BAAA;ArDs7aJ;AqDn7aG;EACC,4BAAA;EACA,+BAAA;ArDq7aJ;AqDl7aG;EACC,oBAAA;ArDo7aJ;AqDz+aG;EACC,2BAAA;ArD2+aJ;AqDx+aG;EACC,8BAAA;ArD0+aJ;AqDv+aG;EACC,4BAAA;ArDy+aJ;AqDt+aG;EACC,6BAAA;ArDw+aJ;AqDr+aG;EACC,4BAAA;EACA,6BAAA;ArDu+aJ;AqDp+aG;EACC,2BAAA;EACA,8BAAA;ArDs+aJ;AqDn+aG;EACC,4BAAA;ArDq+aJ;AqDl+aG;EACC,+BAAA;ArDo+aJ;AqDj+aG;EACC,6BAAA;ArDm+aJ;AqDh+aG;EACC,8BAAA;ArDk+aJ;AqD/9aG;EACC,6BAAA;EACA,8BAAA;ArDi+aJ;AqD99aG;EACC,4BAAA;EACA,+BAAA;ArDg+aJ;AqD79aG;EACC,oBAAA;ArD+9aJ;AqDphbG;EACC,2BAAA;ArDshbJ;AqDnhbG;EACC,8BAAA;ArDqhbJ;AqDlhbG;EACC,4BAAA;ArDohbJ;AqDjhbG;EACC,6BAAA;ArDmhbJ;AqDhhbG;EACC,4BAAA;EACA,6BAAA;ArDkhbJ;AqD/gbG;EACC,2BAAA;EACA,8BAAA;ArDihbJ;AqD9gbG;EACC,4BAAA;ArDghbJ;AqD7gbG;EACC,+BAAA;ArD+gbJ;AqD5gbG;EACC,6BAAA;ArD8gbJ;AqD3gbG;EACC,8BAAA;ArD6gbJ;AqD1gbG;EACC,6BAAA;EACA,8BAAA;ArD4gbJ;AqDzgbG;EACC,4BAAA;EACA,+BAAA;ArD2gbJ;AqDxgbG;EACC,oBAAA;ArD0gbJ;AqD/jbG;EACC,2BAAA;ArDikbJ;AqD9jbG;EACC,8BAAA;ArDgkbJ;AqD7jbG;EACC,4BAAA;ArD+jbJ;AqD5jbG;EACC,6BAAA;ArD8jbJ;AqD3jbG;EACC,4BAAA;EACA,6BAAA;ArD6jbJ;AqD1jbG;EACC,2BAAA;EACA,8BAAA;ArD4jbJ;AqDzjbG;EACC,4BAAA;ArD2jbJ;AqDxjbG;EACC,+BAAA;ArD0jbJ;AqDvjbG;EACC,6BAAA;ArDyjbJ;AqDtjbG;EACC,8BAAA;ArDwjbJ;AqDrjbG;EACC,6BAAA;EACA,8BAAA;ArDujbJ;AqDpjbG;EACC,4BAAA;EACA,+BAAA;ArDsjbJ;AqDnjbG;EACC,oBAAA;ArDqjbJ;AqD1mbG;EACC,2BAAA;ArD4mbJ;AqDzmbG;EACC,8BAAA;ArD2mbJ;AqDxmbG;EACC,4BAAA;ArD0mbJ;AqDvmbG;EACC,6BAAA;ArDymbJ;AqDtmbG;EACC,4BAAA;EACA,6BAAA;ArDwmbJ;AqDrmbG;EACC,2BAAA;EACA,8BAAA;ArDumbJ;AqDpmbG;EACC,4BAAA;ArDsmbJ;AqDnmbG;EACC,+BAAA;ArDqmbJ;AqDlmbG;EACC,6BAAA;ArDombJ;AqDjmbG;EACC,8BAAA;ArDmmbJ;AqDhmbG;EACC,6BAAA;EACA,8BAAA;ArDkmbJ;AqD/lbG;EACC,4BAAA;EACA,+BAAA;ArDimbJ;AqD9lbG;EACC,oBAAA;ArDgmbJ;AqD3kbA;EAEK;IACC,0BAAA;ErD4kbJ;EqDzkbG;IACC,6BAAA;ErD2kbJ;EqDxkbG;IACC,2BAAA;ErD0kbJ;EqDvkbG;IACC,4BAAA;ErDykbJ;EqDtkbG;IACC,2BAAA;IACA,4BAAA;ErDwkbJ;EqDrkbG;IACC,0BAAA;IACA,6BAAA;ErDukbJ;EqDpkbG;IACC,2BAAA;ErDskbJ;EqDnkbG;IACC,8BAAA;ErDqkbJ;EqDlkbG;IACC,4BAAA;ErDokbJ;EqDjkbG;IACC,6BAAA;ErDmkbJ;EqDhkbG;IACC,4BAAA;IACA,6BAAA;ErDkkbJ;EqD/jbG;IACC,2BAAA;IACA,8BAAA;ErDikbJ;EqD9jbG;IACC,mBAAA;ErDgkbJ;EqDrnbG;IACC,0BAAA;ErDunbJ;EqDpnbG;IACC,6BAAA;ErDsnbJ;EqDnnbG;IACC,2BAAA;ErDqnbJ;EqDlnbG;IACC,4BAAA;ErDonbJ;EqDjnbG;IACC,2BAAA;IACA,4BAAA;ErDmnbJ;EqDhnbG;IACC,0BAAA;IACA,6BAAA;ErDknbJ;EqD/mbG;IACC,2BAAA;ErDinbJ;EqD9mbG;IACC,8BAAA;ErDgnbJ;EqD7mbG;IACC,4BAAA;ErD+mbJ;EqD5mbG;IACC,6BAAA;ErD8mbJ;EqD3mbG;IACC,4BAAA;IACA,6BAAA;ErD6mbJ;EqD1mbG;IACC,2BAAA;IACA,8BAAA;ErD4mbJ;EqDzmbG;IACC,mBAAA;ErD2mbJ;EqDhqbG;IACC,0BAAA;ErDkqbJ;EqD/pbG;IACC,6BAAA;ErDiqbJ;EqD9pbG;IACC,2BAAA;ErDgqbJ;EqD7pbG;IACC,4BAAA;ErD+pbJ;EqD5pbG;IACC,2BAAA;IACA,4BAAA;ErD8pbJ;EqD3pbG;IACC,0BAAA;IACA,6BAAA;ErD6pbJ;EqD1pbG;IACC,2BAAA;ErD4pbJ;EqDzpbG;IACC,8BAAA;ErD2pbJ;EqDxpbG;IACC,4BAAA;ErD0pbJ;EqDvpbG;IACC,6BAAA;ErDypbJ;EqDtpbG;IACC,4BAAA;IACA,6BAAA;ErDwpbJ;EqDrpbG;IACC,2BAAA;IACA,8BAAA;ErDupbJ;EqDppbG;IACC,mBAAA;ErDspbJ;EqD3sbG;IACC,0BAAA;ErD6sbJ;EqD1sbG;IACC,6BAAA;ErD4sbJ;EqDzsbG;IACC,2BAAA;ErD2sbJ;EqDxsbG;IACC,4BAAA;ErD0sbJ;EqDvsbG;IACC,2BAAA;IACA,4BAAA;ErDysbJ;EqDtsbG;IACC,0BAAA;IACA,6BAAA;ErDwsbJ;EqDrsbG;IACC,2BAAA;ErDusbJ;EqDpsbG;IACC,8BAAA;ErDssbJ;EqDnsbG;IACC,4BAAA;ErDqsbJ;EqDlsbG;IACC,6BAAA;ErDosbJ;EqDjsbG;IACC,4BAAA;IACA,6BAAA;ErDmsbJ;EqDhsbG;IACC,2BAAA;IACA,8BAAA;ErDksbJ;EqD/rbG;IACC,mBAAA;ErDisbJ;EqDtvbG;IACC,0BAAA;ErDwvbJ;EqDrvbG;IACC,6BAAA;ErDuvbJ;EqDpvbG;IACC,2BAAA;ErDsvbJ;EqDnvbG;IACC,4BAAA;ErDqvbJ;EqDlvbG;IACC,2BAAA;IACA,4BAAA;ErDovbJ;EqDjvbG;IACC,0BAAA;IACA,6BAAA;ErDmvbJ;EqDhvbG;IACC,2BAAA;ErDkvbJ;EqD/ubG;IACC,8BAAA;ErDivbJ;EqD9ubG;IACC,4BAAA;ErDgvbJ;EqD7ubG;IACC,6BAAA;ErD+ubJ;EqD5ubG;IACC,4BAAA;IACA,6BAAA;ErD8ubJ;EqD3ubG;IACC,2BAAA;IACA,8BAAA;ErD6ubJ;EqD1ubG;IACC,mBAAA;ErD4ubJ;EqDjybG;IACC,2BAAA;ErDmybJ;EqDhybG;IACC,8BAAA;ErDkybJ;EqD/xbG;IACC,4BAAA;ErDiybJ;EqD9xbG;IACC,6BAAA;ErDgybJ;EqD7xbG;IACC,4BAAA;IACA,6BAAA;ErD+xbJ;EqD5xbG;IACC,2BAAA;IACA,8BAAA;ErD8xbJ;EqD3xbG;IACC,4BAAA;ErD6xbJ;EqD1xbG;IACC,+BAAA;ErD4xbJ;EqDzxbG;IACC,6BAAA;ErD2xbJ;EqDxxbG;IACC,8BAAA;ErD0xbJ;EqDvxbG;IACC,6BAAA;IACA,8BAAA;ErDyxbJ;EqDtxbG;IACC,4BAAA;IACA,+BAAA;ErDwxbJ;EqDrxbG;IACC,oBAAA;ErDuxbJ;EqD50bG;IACC,2BAAA;ErD80bJ;EqD30bG;IACC,8BAAA;ErD60bJ;EqD10bG;IACC,4BAAA;ErD40bJ;EqDz0bG;IACC,6BAAA;ErD20bJ;EqDx0bG;IACC,4BAAA;IACA,6BAAA;ErD00bJ;EqDv0bG;IACC,2BAAA;IACA,8BAAA;ErDy0bJ;EqDt0bG;IACC,4BAAA;ErDw0bJ;EqDr0bG;IACC,+BAAA;ErDu0bJ;EqDp0bG;IACC,6BAAA;ErDs0bJ;EqDn0bG;IACC,8BAAA;ErDq0bJ;EqDl0bG;IACC,6BAAA;IACA,8BAAA;ErDo0bJ;EqDj0bG;IACC,4BAAA;IACA,+BAAA;ErDm0bJ;EqDh0bG;IACC,oBAAA;ErDk0bJ;EqDv3bG;IACC,2BAAA;ErDy3bJ;EqDt3bG;IACC,8BAAA;ErDw3bJ;EqDr3bG;IACC,4BAAA;ErDu3bJ;EqDp3bG;IACC,6BAAA;ErDs3bJ;EqDn3bG;IACC,4BAAA;IACA,6BAAA;ErDq3bJ;EqDl3bG;IACC,2BAAA;IACA,8BAAA;ErDo3bJ;EqDj3bG;IACC,4BAAA;ErDm3bJ;EqDh3bG;IACC,+BAAA;ErDk3bJ;EqD/2bG;IACC,6BAAA;ErDi3bJ;EqD92bG;IACC,8BAAA;ErDg3bJ;EqD72bG;IACC,6BAAA;IACA,8BAAA;ErD+2bJ;EqD52bG;IACC,4BAAA;IACA,+BAAA;ErD82bJ;EqD32bG;IACC,oBAAA;ErD62bJ;EqDl6bG;IACC,2BAAA;ErDo6bJ;EqDj6bG;IACC,8BAAA;ErDm6bJ;EqDh6bG;IACC,4BAAA;ErDk6bJ;EqD/5bG;IACC,6BAAA;ErDi6bJ;EqD95bG;IACC,4BAAA;IACA,6BAAA;ErDg6bJ;EqD75bG;IACC,2BAAA;IACA,8BAAA;ErD+5bJ;EqD55bG;IACC,4BAAA;ErD85bJ;EqD35bG;IACC,+BAAA;ErD65bJ;EqD15bG;IACC,6BAAA;ErD45bJ;EqDz5bG;IACC,8BAAA;ErD25bJ;EqDx5bG;IACC,6BAAA;IACA,8BAAA;ErD05bJ;EqDv5bG;IACC,4BAAA;IACA,+BAAA;ErDy5bJ;EqDt5bG;IACC,oBAAA;ErDw5bJ;EqD78bG;IACC,2BAAA;ErD+8bJ;EqD58bG;IACC,8BAAA;ErD88bJ;EqD38bG;IACC,4BAAA;ErD68bJ;EqD18bG;IACC,6BAAA;ErD48bJ;EqDz8bG;IACC,4BAAA;IACA,6BAAA;ErD28bJ;EqDx8bG;IACC,2BAAA;IACA,8BAAA;ErD08bJ;EqDv8bG;IACC,4BAAA;ErDy8bJ;EqDt8bG;IACC,+BAAA;ErDw8bJ;EqDr8bG;IACC,6BAAA;ErDu8bJ;EqDp8bG;IACC,8BAAA;ErDs8bJ;EqDn8bG;IACC,6BAAA;IACA,8BAAA;ErDq8bJ;EqDl8bG;IACC,4BAAA;IACA,+BAAA;ErDo8bJ;EqDj8bG;IACC,oBAAA;ErDm8bJ;EqDx/bG;IACC,2BAAA;ErD0/bJ;EqDv/bG;IACC,8BAAA;ErDy/bJ;EqDt/bG;IACC,4BAAA;ErDw/bJ;EqDr/bG;IACC,6BAAA;ErDu/bJ;EqDp/bG;IACC,4BAAA;IACA,6BAAA;ErDs/bJ;EqDn/bG;IACC,2BAAA;IACA,8BAAA;ErDq/bJ;EqDl/bG;IACC,4BAAA;ErDo/bJ;EqDj/bG;IACC,+BAAA;ErDm/bJ;EqDh/bG;IACC,6BAAA;ErDk/bJ;EqD/+bG;IACC,8BAAA;ErDi/bJ;EqD9+bG;IACC,6BAAA;IACA,8BAAA;ErDg/bJ;EqD7+bG;IACC,4BAAA;IACA,+BAAA;ErD++bJ;EqD5+bG;IACC,oBAAA;ErD8+bJ;EqDnicG;IACC,2BAAA;ErDqicJ;EqDlicG;IACC,8BAAA;ErDoicJ;EqDjicG;IACC,4BAAA;ErDmicJ;EqDhicG;IACC,6BAAA;ErDkicJ;EqD/hcG;IACC,4BAAA;IACA,6BAAA;ErDiicJ;EqD9hcG;IACC,2BAAA;IACA,8BAAA;ErDgicJ;EqD7hcG;IACC,4BAAA;ErD+hcJ;EqD5hcG;IACC,+BAAA;ErD8hcJ;EqD3hcG;IACC,6BAAA;ErD6hcJ;EqD1hcG;IACC,8BAAA;ErD4hcJ;EqDzhcG;IACC,6BAAA;IACA,8BAAA;ErD2hcJ;EqDxhcG;IACC,4BAAA;IACA,+BAAA;ErD0hcJ;EqDvhcG;IACC,oBAAA;ErDyhcJ;EqD9kcG;IACC,2BAAA;ErDglcJ;EqD7kcG;IACC,8BAAA;ErD+kcJ;EqD5kcG;IACC,4BAAA;ErD8kcJ;EqD3kcG;IACC,6BAAA;ErD6kcJ;EqD1kcG;IACC,4BAAA;IACA,6BAAA;ErD4kcJ;EqDzkcG;IACC,2BAAA;IACA,8BAAA;ErD2kcJ;EqDxkcG;IACC,4BAAA;ErD0kcJ;EqDvkcG;IACC,+BAAA;ErDykcJ;EqDtkcG;IACC,6BAAA;ErDwkcJ;EqDrkcG;IACC,8BAAA;ErDukcJ;EqDpkcG;IACC,6BAAA;IACA,8BAAA;ErDskcJ;EqDnkcG;IACC,4BAAA;IACA,+BAAA;ErDqkcJ;EqDlkcG;IACC,oBAAA;ErDokcJ;AACF;AqDljcA;EAEK;IACC,0BAAA;ErDmjcJ;EqDhjcG;IACC,6BAAA;ErDkjcJ;EqD/icG;IACC,2BAAA;ErDijcJ;EqD9icG;IACC,4BAAA;ErDgjcJ;EqD7icG;IACC,2BAAA;IACA,4BAAA;ErD+icJ;EqD5icG;IACC,0BAAA;IACA,6BAAA;ErD8icJ;EqD3icG;IACC,2BAAA;ErD6icJ;EqD1icG;IACC,8BAAA;ErD4icJ;EqDzicG;IACC,4BAAA;ErD2icJ;EqDxicG;IACC,6BAAA;ErD0icJ;EqDvicG;IACC,4BAAA;IACA,6BAAA;ErDyicJ;EqDticG;IACC,2BAAA;IACA,8BAAA;ErDwicJ;EqDricG;IACC,mBAAA;ErDuicJ;EqD5lcG;IACC,0BAAA;ErD8lcJ;EqD3lcG;IACC,6BAAA;ErD6lcJ;EqD1lcG;IACC,2BAAA;ErD4lcJ;EqDzlcG;IACC,4BAAA;ErD2lcJ;EqDxlcG;IACC,2BAAA;IACA,4BAAA;ErD0lcJ;EqDvlcG;IACC,0BAAA;IACA,6BAAA;ErDylcJ;EqDtlcG;IACC,2BAAA;ErDwlcJ;EqDrlcG;IACC,8BAAA;ErDulcJ;EqDplcG;IACC,4BAAA;ErDslcJ;EqDnlcG;IACC,6BAAA;ErDqlcJ;EqDllcG;IACC,4BAAA;IACA,6BAAA;ErDolcJ;EqDjlcG;IACC,2BAAA;IACA,8BAAA;ErDmlcJ;EqDhlcG;IACC,mBAAA;ErDklcJ;EqDvocG;IACC,0BAAA;ErDyocJ;EqDtocG;IACC,6BAAA;ErDwocJ;EqDrocG;IACC,2BAAA;ErDuocJ;EqDpocG;IACC,4BAAA;ErDsocJ;EqDnocG;IACC,2BAAA;IACA,4BAAA;ErDqocJ;EqDlocG;IACC,0BAAA;IACA,6BAAA;ErDoocJ;EqDjocG;IACC,2BAAA;ErDmocJ;EqDhocG;IACC,8BAAA;ErDkocJ;EqD/ncG;IACC,4BAAA;ErDiocJ;EqD9ncG;IACC,6BAAA;ErDgocJ;EqD7ncG;IACC,4BAAA;IACA,6BAAA;ErD+ncJ;EqD5ncG;IACC,2BAAA;IACA,8BAAA;ErD8ncJ;EqD3ncG;IACC,mBAAA;ErD6ncJ;EqDlrcG;IACC,0BAAA;ErDorcJ;EqDjrcG;IACC,6BAAA;ErDmrcJ;EqDhrcG;IACC,2BAAA;ErDkrcJ;EqD/qcG;IACC,4BAAA;ErDircJ;EqD9qcG;IACC,2BAAA;IACA,4BAAA;ErDgrcJ;EqD7qcG;IACC,0BAAA;IACA,6BAAA;ErD+qcJ;EqD5qcG;IACC,2BAAA;ErD8qcJ;EqD3qcG;IACC,8BAAA;ErD6qcJ;EqD1qcG;IACC,4BAAA;ErD4qcJ;EqDzqcG;IACC,6BAAA;ErD2qcJ;EqDxqcG;IACC,4BAAA;IACA,6BAAA;ErD0qcJ;EqDvqcG;IACC,2BAAA;IACA,8BAAA;ErDyqcJ;EqDtqcG;IACC,mBAAA;ErDwqcJ;EqD7tcG;IACC,0BAAA;ErD+tcJ;EqD5tcG;IACC,6BAAA;ErD8tcJ;EqD3tcG;IACC,2BAAA;ErD6tcJ;EqD1tcG;IACC,4BAAA;ErD4tcJ;EqDztcG;IACC,2BAAA;IACA,4BAAA;ErD2tcJ;EqDxtcG;IACC,0BAAA;IACA,6BAAA;ErD0tcJ;EqDvtcG;IACC,2BAAA;ErDytcJ;EqDttcG;IACC,8BAAA;ErDwtcJ;EqDrtcG;IACC,4BAAA;ErDutcJ;EqDptcG;IACC,6BAAA;ErDstcJ;EqDntcG;IACC,4BAAA;IACA,6BAAA;ErDqtcJ;EqDltcG;IACC,2BAAA;IACA,8BAAA;ErDotcJ;EqDjtcG;IACC,mBAAA;ErDmtcJ;EqDxwcG;IACC,2BAAA;ErD0wcJ;EqDvwcG;IACC,8BAAA;ErDywcJ;EqDtwcG;IACC,4BAAA;ErDwwcJ;EqDrwcG;IACC,6BAAA;ErDuwcJ;EqDpwcG;IACC,4BAAA;IACA,6BAAA;ErDswcJ;EqDnwcG;IACC,2BAAA;IACA,8BAAA;ErDqwcJ;EqDlwcG;IACC,4BAAA;ErDowcJ;EqDjwcG;IACC,+BAAA;ErDmwcJ;EqDhwcG;IACC,6BAAA;ErDkwcJ;EqD/vcG;IACC,8BAAA;ErDiwcJ;EqD9vcG;IACC,6BAAA;IACA,8BAAA;ErDgwcJ;EqD7vcG;IACC,4BAAA;IACA,+BAAA;ErD+vcJ;EqD5vcG;IACC,oBAAA;ErD8vcJ;EqDnzcG;IACC,2BAAA;ErDqzcJ;EqDlzcG;IACC,8BAAA;ErDozcJ;EqDjzcG;IACC,4BAAA;ErDmzcJ;EqDhzcG;IACC,6BAAA;ErDkzcJ;EqD/ycG;IACC,4BAAA;IACA,6BAAA;ErDizcJ;EqD9ycG;IACC,2BAAA;IACA,8BAAA;ErDgzcJ;EqD7ycG;IACC,4BAAA;ErD+ycJ;EqD5ycG;IACC,+BAAA;ErD8ycJ;EqD3ycG;IACC,6BAAA;ErD6ycJ;EqD1ycG;IACC,8BAAA;ErD4ycJ;EqDzycG;IACC,6BAAA;IACA,8BAAA;ErD2ycJ;EqDxycG;IACC,4BAAA;IACA,+BAAA;ErD0ycJ;EqDvycG;IACC,oBAAA;ErDyycJ;EqD91cG;IACC,2BAAA;ErDg2cJ;EqD71cG;IACC,8BAAA;ErD+1cJ;EqD51cG;IACC,4BAAA;ErD81cJ;EqD31cG;IACC,6BAAA;ErD61cJ;EqD11cG;IACC,4BAAA;IACA,6BAAA;ErD41cJ;EqDz1cG;IACC,2BAAA;IACA,8BAAA;ErD21cJ;EqDx1cG;IACC,4BAAA;ErD01cJ;EqDv1cG;IACC,+BAAA;ErDy1cJ;EqDt1cG;IACC,6BAAA;ErDw1cJ;EqDr1cG;IACC,8BAAA;ErDu1cJ;EqDp1cG;IACC,6BAAA;IACA,8BAAA;ErDs1cJ;EqDn1cG;IACC,4BAAA;IACA,+BAAA;ErDq1cJ;EqDl1cG;IACC,oBAAA;ErDo1cJ;EqDz4cG;IACC,2BAAA;ErD24cJ;EqDx4cG;IACC,8BAAA;ErD04cJ;EqDv4cG;IACC,4BAAA;ErDy4cJ;EqDt4cG;IACC,6BAAA;ErDw4cJ;EqDr4cG;IACC,4BAAA;IACA,6BAAA;ErDu4cJ;EqDp4cG;IACC,2BAAA;IACA,8BAAA;ErDs4cJ;EqDn4cG;IACC,4BAAA;ErDq4cJ;EqDl4cG;IACC,+BAAA;ErDo4cJ;EqDj4cG;IACC,6BAAA;ErDm4cJ;EqDh4cG;IACC,8BAAA;ErDk4cJ;EqD/3cG;IACC,6BAAA;IACA,8BAAA;ErDi4cJ;EqD93cG;IACC,4BAAA;IACA,+BAAA;ErDg4cJ;EqD73cG;IACC,oBAAA;ErD+3cJ;EqDp7cG;IACC,2BAAA;ErDs7cJ;EqDn7cG;IACC,8BAAA;ErDq7cJ;EqDl7cG;IACC,4BAAA;ErDo7cJ;EqDj7cG;IACC,6BAAA;ErDm7cJ;EqDh7cG;IACC,4BAAA;IACA,6BAAA;ErDk7cJ;EqD/6cG;IACC,2BAAA;IACA,8BAAA;ErDi7cJ;EqD96cG;IACC,4BAAA;ErDg7cJ;EqD76cG;IACC,+BAAA;ErD+6cJ;EqD56cG;IACC,6BAAA;ErD86cJ;EqD36cG;IACC,8BAAA;ErD66cJ;EqD16cG;IACC,6BAAA;IACA,8BAAA;ErD46cJ;EqDz6cG;IACC,4BAAA;IACA,+BAAA;ErD26cJ;EqDx6cG;IACC,oBAAA;ErD06cJ;EqD/9cG;IACC,2BAAA;ErDi+cJ;EqD99cG;IACC,8BAAA;ErDg+cJ;EqD79cG;IACC,4BAAA;ErD+9cJ;EqD59cG;IACC,6BAAA;ErD89cJ;EqD39cG;IACC,4BAAA;IACA,6BAAA;ErD69cJ;EqD19cG;IACC,2BAAA;IACA,8BAAA;ErD49cJ;EqDz9cG;IACC,4BAAA;ErD29cJ;EqDx9cG;IACC,+BAAA;ErD09cJ;EqDv9cG;IACC,6BAAA;ErDy9cJ;EqDt9cG;IACC,8BAAA;ErDw9cJ;EqDr9cG;IACC,6BAAA;IACA,8BAAA;ErDu9cJ;EqDp9cG;IACC,4BAAA;IACA,+BAAA;ErDs9cJ;EqDn9cG;IACC,oBAAA;ErDq9cJ;EqD1gdG;IACC,2BAAA;ErD4gdJ;EqDzgdG;IACC,8BAAA;ErD2gdJ;EqDxgdG;IACC,4BAAA;ErD0gdJ;EqDvgdG;IACC,6BAAA;ErDygdJ;EqDtgdG;IACC,4BAAA;IACA,6BAAA;ErDwgdJ;EqDrgdG;IACC,2BAAA;IACA,8BAAA;ErDugdJ;EqDpgdG;IACC,4BAAA;ErDsgdJ;EqDngdG;IACC,+BAAA;ErDqgdJ;EqDlgdG;IACC,6BAAA;ErDogdJ;EqDjgdG;IACC,8BAAA;ErDmgdJ;EqDhgdG;IACC,6BAAA;IACA,8BAAA;ErDkgdJ;EqD//cG;IACC,4BAAA;IACA,+BAAA;ErDigdJ;EqD9/cG;IACC,oBAAA;ErDggdJ;EqDrjdG;IACC,2BAAA;ErDujdJ;EqDpjdG;IACC,8BAAA;ErDsjdJ;EqDnjdG;IACC,4BAAA;ErDqjdJ;EqDljdG;IACC,6BAAA;ErDojdJ;EqDjjdG;IACC,4BAAA;IACA,6BAAA;ErDmjdJ;EqDhjdG;IACC,2BAAA;IACA,8BAAA;ErDkjdJ;EqD/idG;IACC,4BAAA;ErDijdJ;EqD9idG;IACC,+BAAA;ErDgjdJ;EqD7idG;IACC,6BAAA;ErD+idJ;EqD5idG;IACC,8BAAA;ErD8idJ;EqD3idG;IACC,6BAAA;IACA,8BAAA;ErD6idJ;EqD1idG;IACC,4BAAA;IACA,+BAAA;ErD4idJ;EqDzidG;IACC,oBAAA;ErD2idJ;EqDhmdG;IACC,2BAAA;ErDkmdJ;EqD/ldG;IACC,8BAAA;ErDimdJ;EqD9ldG;IACC,4BAAA;ErDgmdJ;EqD7ldG;IACC,6BAAA;ErD+ldJ;EqD5ldG;IACC,4BAAA;IACA,6BAAA;ErD8ldJ;EqD3ldG;IACC,2BAAA;IACA,8BAAA;ErD6ldJ;EqD1ldG;IACC,4BAAA;ErD4ldJ;EqDzldG;IACC,+BAAA;ErD2ldJ;EqDxldG;IACC,6BAAA;ErD0ldJ;EqDvldG;IACC,8BAAA;ErDyldJ;EqDtldG;IACC,6BAAA;IACA,8BAAA;ErDwldJ;EqDrldG;IACC,4BAAA;IACA,+BAAA;ErDuldJ;EqDpldG;IACC,oBAAA;ErDsldJ;AACF;AqDnkdA;EAEK;IACC,0BAAA;ErDokdJ;EqDjkdG;IACC,6BAAA;ErDmkdJ;EqDhkdG;IACC,2BAAA;ErDkkdJ;EqD/jdG;IACC,4BAAA;ErDikdJ;EqD9jdG;IACC,2BAAA;IACA,4BAAA;ErDgkdJ;EqD7jdG;IACC,0BAAA;IACA,6BAAA;ErD+jdJ;EqD5jdG;IACC,2BAAA;ErD8jdJ;EqD3jdG;IACC,8BAAA;ErD6jdJ;EqD1jdG;IACC,4BAAA;ErD4jdJ;EqDzjdG;IACC,6BAAA;ErD2jdJ;EqDxjdG;IACC,4BAAA;IACA,6BAAA;ErD0jdJ;EqDvjdG;IACC,2BAAA;IACA,8BAAA;ErDyjdJ;EqDtjdG;IACC,mBAAA;ErDwjdJ;EqD7mdG;IACC,0BAAA;ErD+mdJ;EqD5mdG;IACC,6BAAA;ErD8mdJ;EqD3mdG;IACC,2BAAA;ErD6mdJ;EqD1mdG;IACC,4BAAA;ErD4mdJ;EqDzmdG;IACC,2BAAA;IACA,4BAAA;ErD2mdJ;EqDxmdG;IACC,0BAAA;IACA,6BAAA;ErD0mdJ;EqDvmdG;IACC,2BAAA;ErDymdJ;EqDtmdG;IACC,8BAAA;ErDwmdJ;EqDrmdG;IACC,4BAAA;ErDumdJ;EqDpmdG;IACC,6BAAA;ErDsmdJ;EqDnmdG;IACC,4BAAA;IACA,6BAAA;ErDqmdJ;EqDlmdG;IACC,2BAAA;IACA,8BAAA;ErDomdJ;EqDjmdG;IACC,mBAAA;ErDmmdJ;EqDxpdG;IACC,0BAAA;ErD0pdJ;EqDvpdG;IACC,6BAAA;ErDypdJ;EqDtpdG;IACC,2BAAA;ErDwpdJ;EqDrpdG;IACC,4BAAA;ErDupdJ;EqDppdG;IACC,2BAAA;IACA,4BAAA;ErDspdJ;EqDnpdG;IACC,0BAAA;IACA,6BAAA;ErDqpdJ;EqDlpdG;IACC,2BAAA;ErDopdJ;EqDjpdG;IACC,8BAAA;ErDmpdJ;EqDhpdG;IACC,4BAAA;ErDkpdJ;EqD/odG;IACC,6BAAA;ErDipdJ;EqD9odG;IACC,4BAAA;IACA,6BAAA;ErDgpdJ;EqD7odG;IACC,2BAAA;IACA,8BAAA;ErD+odJ;EqD5odG;IACC,mBAAA;ErD8odJ;EqDnsdG;IACC,0BAAA;ErDqsdJ;EqDlsdG;IACC,6BAAA;ErDosdJ;EqDjsdG;IACC,2BAAA;ErDmsdJ;EqDhsdG;IACC,4BAAA;ErDksdJ;EqD/rdG;IACC,2BAAA;IACA,4BAAA;ErDisdJ;EqD9rdG;IACC,0BAAA;IACA,6BAAA;ErDgsdJ;EqD7rdG;IACC,2BAAA;ErD+rdJ;EqD5rdG;IACC,8BAAA;ErD8rdJ;EqD3rdG;IACC,4BAAA;ErD6rdJ;EqD1rdG;IACC,6BAAA;ErD4rdJ;EqDzrdG;IACC,4BAAA;IACA,6BAAA;ErD2rdJ;EqDxrdG;IACC,2BAAA;IACA,8BAAA;ErD0rdJ;EqDvrdG;IACC,mBAAA;ErDyrdJ;EqD9udG;IACC,0BAAA;ErDgvdJ;EqD7udG;IACC,6BAAA;ErD+udJ;EqD5udG;IACC,2BAAA;ErD8udJ;EqD3udG;IACC,4BAAA;ErD6udJ;EqD1udG;IACC,2BAAA;IACA,4BAAA;ErD4udJ;EqDzudG;IACC,0BAAA;IACA,6BAAA;ErD2udJ;EqDxudG;IACC,2BAAA;ErD0udJ;EqDvudG;IACC,8BAAA;ErDyudJ;EqDtudG;IACC,4BAAA;ErDwudJ;EqDrudG;IACC,6BAAA;ErDuudJ;EqDpudG;IACC,4BAAA;IACA,6BAAA;ErDsudJ;EqDnudG;IACC,2BAAA;IACA,8BAAA;ErDqudJ;EqDludG;IACC,mBAAA;ErDoudJ;EqDzxdG;IACC,2BAAA;ErD2xdJ;EqDxxdG;IACC,8BAAA;ErD0xdJ;EqDvxdG;IACC,4BAAA;ErDyxdJ;EqDtxdG;IACC,6BAAA;ErDwxdJ;EqDrxdG;IACC,4BAAA;IACA,6BAAA;ErDuxdJ;EqDpxdG;IACC,2BAAA;IACA,8BAAA;ErDsxdJ;EqDnxdG;IACC,4BAAA;ErDqxdJ;EqDlxdG;IACC,+BAAA;ErDoxdJ;EqDjxdG;IACC,6BAAA;ErDmxdJ;EqDhxdG;IACC,8BAAA;ErDkxdJ;EqD/wdG;IACC,6BAAA;IACA,8BAAA;ErDixdJ;EqD9wdG;IACC,4BAAA;IACA,+BAAA;ErDgxdJ;EqD7wdG;IACC,oBAAA;ErD+wdJ;EqDp0dG;IACC,2BAAA;ErDs0dJ;EqDn0dG;IACC,8BAAA;ErDq0dJ;EqDl0dG;IACC,4BAAA;ErDo0dJ;EqDj0dG;IACC,6BAAA;ErDm0dJ;EqDh0dG;IACC,4BAAA;IACA,6BAAA;ErDk0dJ;EqD/zdG;IACC,2BAAA;IACA,8BAAA;ErDi0dJ;EqD9zdG;IACC,4BAAA;ErDg0dJ;EqD7zdG;IACC,+BAAA;ErD+zdJ;EqD5zdG;IACC,6BAAA;ErD8zdJ;EqD3zdG;IACC,8BAAA;ErD6zdJ;EqD1zdG;IACC,6BAAA;IACA,8BAAA;ErD4zdJ;EqDzzdG;IACC,4BAAA;IACA,+BAAA;ErD2zdJ;EqDxzdG;IACC,oBAAA;ErD0zdJ;EqD/2dG;IACC,2BAAA;ErDi3dJ;EqD92dG;IACC,8BAAA;ErDg3dJ;EqD72dG;IACC,4BAAA;ErD+2dJ;EqD52dG;IACC,6BAAA;ErD82dJ;EqD32dG;IACC,4BAAA;IACA,6BAAA;ErD62dJ;EqD12dG;IACC,2BAAA;IACA,8BAAA;ErD42dJ;EqDz2dG;IACC,4BAAA;ErD22dJ;EqDx2dG;IACC,+BAAA;ErD02dJ;EqDv2dG;IACC,6BAAA;ErDy2dJ;EqDt2dG;IACC,8BAAA;ErDw2dJ;EqDr2dG;IACC,6BAAA;IACA,8BAAA;ErDu2dJ;EqDp2dG;IACC,4BAAA;IACA,+BAAA;ErDs2dJ;EqDn2dG;IACC,oBAAA;ErDq2dJ;EqD15dG;IACC,2BAAA;ErD45dJ;EqDz5dG;IACC,8BAAA;ErD25dJ;EqDx5dG;IACC,4BAAA;ErD05dJ;EqDv5dG;IACC,6BAAA;ErDy5dJ;EqDt5dG;IACC,4BAAA;IACA,6BAAA;ErDw5dJ;EqDr5dG;IACC,2BAAA;IACA,8BAAA;ErDu5dJ;EqDp5dG;IACC,4BAAA;ErDs5dJ;EqDn5dG;IACC,+BAAA;ErDq5dJ;EqDl5dG;IACC,6BAAA;ErDo5dJ;EqDj5dG;IACC,8BAAA;ErDm5dJ;EqDh5dG;IACC,6BAAA;IACA,8BAAA;ErDk5dJ;EqD/4dG;IACC,4BAAA;IACA,+BAAA;ErDi5dJ;EqD94dG;IACC,oBAAA;ErDg5dJ;EqDr8dG;IACC,2BAAA;ErDu8dJ;EqDp8dG;IACC,8BAAA;ErDs8dJ;EqDn8dG;IACC,4BAAA;ErDq8dJ;EqDl8dG;IACC,6BAAA;ErDo8dJ;EqDj8dG;IACC,4BAAA;IACA,6BAAA;ErDm8dJ;EqDh8dG;IACC,2BAAA;IACA,8BAAA;ErDk8dJ;EqD/7dG;IACC,4BAAA;ErDi8dJ;EqD97dG;IACC,+BAAA;ErDg8dJ;EqD77dG;IACC,6BAAA;ErD+7dJ;EqD57dG;IACC,8BAAA;ErD87dJ;EqD37dG;IACC,6BAAA;IACA,8BAAA;ErD67dJ;EqD17dG;IACC,4BAAA;IACA,+BAAA;ErD47dJ;EqDz7dG;IACC,oBAAA;ErD27dJ;EqDh/dG;IACC,2BAAA;ErDk/dJ;EqD/+dG;IACC,8BAAA;ErDi/dJ;EqD9+dG;IACC,4BAAA;ErDg/dJ;EqD7+dG;IACC,6BAAA;ErD++dJ;EqD5+dG;IACC,4BAAA;IACA,6BAAA;ErD8+dJ;EqD3+dG;IACC,2BAAA;IACA,8BAAA;ErD6+dJ;EqD1+dG;IACC,4BAAA;ErD4+dJ;EqDz+dG;IACC,+BAAA;ErD2+dJ;EqDx+dG;IACC,6BAAA;ErD0+dJ;EqDv+dG;IACC,8BAAA;ErDy+dJ;EqDt+dG;IACC,6BAAA;IACA,8BAAA;ErDw+dJ;EqDr+dG;IACC,4BAAA;IACA,+BAAA;ErDu+dJ;EqDp+dG;IACC,oBAAA;ErDs+dJ;EqD3heG;IACC,2BAAA;ErD6heJ;EqD1heG;IACC,8BAAA;ErD4heJ;EqDzheG;IACC,4BAAA;ErD2heJ;EqDxheG;IACC,6BAAA;ErD0heJ;EqDvheG;IACC,4BAAA;IACA,6BAAA;ErDyheJ;EqDtheG;IACC,2BAAA;IACA,8BAAA;ErDwheJ;EqDrheG;IACC,4BAAA;ErDuheJ;EqDpheG;IACC,+BAAA;ErDsheJ;EqDnheG;IACC,6BAAA;ErDqheJ;EqDlheG;IACC,8BAAA;ErDoheJ;EqDjheG;IACC,6BAAA;IACA,8BAAA;ErDmheJ;EqDhheG;IACC,4BAAA;IACA,+BAAA;ErDkheJ;EqD/geG;IACC,oBAAA;ErDiheJ;EqDtkeG;IACC,2BAAA;ErDwkeJ;EqDrkeG;IACC,8BAAA;ErDukeJ;EqDpkeG;IACC,4BAAA;ErDskeJ;EqDnkeG;IACC,6BAAA;ErDqkeJ;EqDlkeG;IACC,4BAAA;IACA,6BAAA;ErDokeJ;EqDjkeG;IACC,2BAAA;IACA,8BAAA;ErDmkeJ;EqDhkeG;IACC,4BAAA;ErDkkeJ;EqD/jeG;IACC,+BAAA;ErDikeJ;EqD9jeG;IACC,6BAAA;ErDgkeJ;EqD7jeG;IACC,8BAAA;ErD+jeJ;EqD5jeG;IACC,6BAAA;IACA,8BAAA;ErD8jeJ;EqD3jeG;IACC,4BAAA;IACA,+BAAA;ErD6jeJ;EqD1jeG;IACC,oBAAA;ErD4jeJ;EqDjneG;IACC,2BAAA;ErDmneJ;EqDhneG;IACC,8BAAA;ErDkneJ;EqD/meG;IACC,4BAAA;ErDineJ;EqD9meG;IACC,6BAAA;ErDgneJ;EqD7meG;IACC,4BAAA;IACA,6BAAA;ErD+meJ;EqD5meG;IACC,2BAAA;IACA,8BAAA;ErD8meJ;EqD3meG;IACC,4BAAA;ErD6meJ;EqD1meG;IACC,+BAAA;ErD4meJ;EqDzmeG;IACC,6BAAA;ErD2meJ;EqDxmeG;IACC,8BAAA;ErD0meJ;EqDvmeG;IACC,6BAAA;IACA,8BAAA;ErDymeJ;EqDtmeG;IACC,4BAAA;IACA,+BAAA;ErDwmeJ;EqDrmeG;IACC,oBAAA;ErDumeJ;AACF;AsDh5eA;EACE,gBAAA;AtDk5eF;AsDn5eA;EAGI,cAAA;EACA,UAAA;AtDm5eJ;AsDj5eI;EACE,kBAAA;AtDm5eN;AsD15eA;EAWM,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AtDk5eN;AsDj5eM;EACE,cAAA;AtDm5eR;AsDj5eM;EACE,gBAAA;EACA,cAAA;AtDm5eR;AsDr5eM;EAKI,yBAAA;EACA,yBAAA;EACA,yDAAA;EACA,4BAAA;EACA,kCAAA;EACA,wBAAA;AtDm5eV;AsDh5eM;EACE,gBAAA;EACA,cAAA;AtDk5eR;AsDp5eM;EAKI,yBAAA;EACA,yBAAA;EACA,yDAAA;EACA,4BAAA;EACA,kCAAA;EACA,wBAAA;AtDk5eV;AsD/4eM;EACE,gBAAA;EACA,cAAA;AtDi5eR;AsDn5eM;EAKI,yBAAA;EACA,yBAAA;EACA,yDAAA;EACA,4BAAA;EACA,kCAAA;EACA,wBAAA;AtDi5eV;AsD74eM;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;AtD+4eR;AsDh9eA;EAqEQ,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AtD84eR;AACA,0BAA0B;AuDz9e1B;EACE,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,oBAAA;EACA,eAAA;EACA,WAAA;AvD29eF;AuDz9eE;EACE,gBAAA;EACA,6BAAA;AvD29eJ;AuDz9eI;EACE,cAAA;AvD29eN;AuDx9eI;EACE,YAAA;AvD09eN;AuDv9eI;EACE,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;AvDy9eN;AuDt9eI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AvDw9eN;AuDv/eA;EAoCI,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AvDs9eJ;AuDjgfA;EA+CI,aAAA;EACA,gBAAA;EACA,wCAAA;AvDq9eJ;AuDtgfA;EAqDI,iBAAA;AvDo9eJ;AuDj9eE;EACE;IACE,uBAAA;EvDm9eJ;EuDh9eE;IACE,wBAAA;EvDk9eJ;AACF;AuDjhfA;EAmEI,qBAAA;EACA,uCAAA;AvDi9eJ;AuDrhfA;EAwEI,wBAAA;AvDg9eJ;AwDzhfE;EACE,qBAAA;AxD2hfJ;AwD7hfA;EAMI,iCAAA;AxD0hfJ;AwDhifA;EAUI,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,QAAA;EACA,sBAAA;EACA,8IAAA;AxDyhfJ;AwD5ifA;EA0BM,gBAAA;AxDqhfN;AwDhhfA;EACE,eAAA;EACA,iCAAA;AxDkhfF;AwDhhfE;EACE,oCAAA;AxDkhfJ;AACA,kCAAkC","sourcesContent":["/**\n * React Select\n * ============\n * Created by Jed Watson and Joss Mackison for KeystoneJS, http://www.keystonejs.com/\n * https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs\n * MIT License: https://github.com/keystonejs/react-select\n*/\n.Select {\n  position: relative;\n}\n.Select,\n.Select div,\n.Select input,\n.Select span {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.Select.is-disabled > .Select-control {\n  background-color: #f6f6f6;\n}\n.Select.is-disabled .Select-arrow-zone {\n  cursor: default;\n  pointer-events: none;\n}\n.Select-control {\n  background-color: #fff;\n  border-color: #d9d9d9 #ccc #b3b3b3;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n  color: #333;\n  cursor: default;\n  display: table;\n  height: 46px;\n  outline: none;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n}\n.Select-control:hover {\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n}\n.is-searchable.is-open > .Select-control {\n  cursor: text;\n}\n.is-open > .Select-control {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n  background: #fff;\n  border-color: #b3b3b3 #ccc #d9d9d9;\n}\n.is-open > .Select-control > .Select-arrow {\n  border-color: transparent transparent #999;\n  border-width: 0 5px 5px;\n}\n.is-searchable.is-focused:not(.is-open) > .Select-control {\n  cursor: text;\n}\n.is-focused:not(.is-open) > .Select-control {\n  border-color: #08c #0099e6 #0099e6;\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1), 0 0 5px -1px rgba(0, 136, 204, 0.5);\n}\n.Select-placeholder {\n  bottom: 0;\n  color: #777;\n  left: 0;\n  line-height: 44px;\n  padding-left: 15px;\n  padding-right: 15px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  font-size: 18px;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.has-value > .Select-control > .Select-placeholder {\n  color: #333;\n  font-size: 18px;\n}\n.Select-value {\n  color: #777;\n  left: 0;\n  padding: 8px 52px 8px 15px;\n  position: absolute;\n  right: -20px;\n  top: 0;\n  font-size: 18px;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.has-value > .Select-control > .Select-value {\n  color: #333;\n  font-size: 18px;\n}\n.Select-input {\n  height: 44px;\n  padding-left: 15px;\n  padding-right: 15px;\n  vertical-align: middle;\n}\n.Select-input > input {\n  background: none transparent;\n  border: 0 none;\n  box-shadow: none;\n  cursor: default;\n  display: inline-block;\n  font-family: inherit;\n  font-size: inherit;\n  height: 44px;\n  margin: 0;\n  outline: none;\n  padding: 0;\n  -webkit-appearance: none;\n}\n.is-focused .Select-input > input {\n  cursor: text;\n}\n.Select-control:not(.is-searchable) > .Select-input {\n  outline: none;\n}\n.Select-loading-zone {\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 16px;\n}\n.Select-loading {\n  -webkit-animation: Select-animation-spin 400ms infinite linear;\n  -o-animation: Select-animation-spin 400ms infinite linear;\n  animation: Select-animation-spin 400ms infinite linear;\n  width: 16px;\n  height: 16px;\n  box-sizing: border-box;\n  border-radius: 50%;\n  border: 2px solid #ccc;\n  border-right-color: #333;\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n}\n.Select-clear-zone {\n  -webkit-animation: Select-animation-fadeIn 200ms;\n  -o-animation: Select-animation-fadeIn 200ms;\n  animation: Select-animation-fadeIn 200ms;\n  color: #999;\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 22px;\n}\n.Select-clear-zone:hover {\n  color: #d0021b;\n}\n.Select-clear {\n  display: inline-block;\n  font-size: 23px;\n  line-height: 1;\n}\n.Select--multi .Select-clear-zone {\n  width: 22px;\n}\n.Select-arrow-zone {\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: 25px;\n  padding-right: 5px;\n}\n.Select-arrow {\n  border-color: #999 transparent transparent;\n  border-style: solid;\n  border-width: 5px 5px 2.5px;\n  display: inline-block;\n  height: 0;\n  width: 0;\n}\n.is-open .Select-arrow,\n.Select-arrow-zone:hover > .Select-arrow {\n  border-top-color: #666;\n}\n@-webkit-keyframes Select-animation-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes Select-animation-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.Select-menu-outer {\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-top-color: #e6e6e6;\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  box-sizing: border-box;\n  margin-top: -1px;\n  max-height: 200px;\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  z-index: 1000;\n  -webkit-overflow-scrolling: touch;\n}\n.Select-menu {\n  max-height: 198px;\n  overflow-y: auto;\n}\n.Select-option {\n  box-sizing: border-box;\n  color: #666666;\n  cursor: pointer;\n  display: block;\n  padding: 8px 15px;\n}\n.Select-option:last-child {\n  border-bottom-right-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.Select-option.is-focused {\n  background-color: #f2f2f2;\n  color: #333;\n}\n.Select-option.is-disabled {\n  color: #cccccc;\n  cursor: not-allowed;\n}\n.Select-noresults,\n.Select-search-prompt,\n.Select-searching {\n  box-sizing: border-box;\n  color: #999999;\n  cursor: default;\n  display: block;\n  padding: 8px 15px;\n}\n.Select--multi .Select-input {\n  vertical-align: middle;\n  margin-left: 15px;\n  padding: 0;\n}\n.Select--multi.has-value .Select-input {\n  margin-left: 5px;\n}\n.Select-item {\n  background-color: #f2f2f2;\n  border-radius: 2px;\n  border: 1px solid #d9d9d9;\n  color: #333333;\n  display: inline-block;\n  font-size: 1em;\n  margin-left: 5px;\n  margin-top: 5px;\n  vertical-align: top;\n}\n.Select-item-icon,\n.Select-item-label {\n  display: inline-block;\n  vertical-align: middle;\n}\n.Select-item-label {\n  border-bottom-right-radius: 2px;\n  border-top-right-radius: 2px;\n  cursor: default;\n  padding: 5px 5px;\n}\n.Select-item-label .Select-item-label__a {\n  color: #333333;\n  cursor: pointer;\n}\n.Select-item-icon {\n  cursor: pointer;\n  border-bottom-left-radius: 2px;\n  border-top-left-radius: 2px;\n  border-right: 1px solid #d9d9d9;\n  padding: 5px 5px 6px;\n}\n.Select-item-icon:hover,\n.Select-item-icon:focus {\n  background-color: #e5e5e5;\n  color: #262626;\n}\n.Select-item-icon:active {\n  background-color: #d9d9d9;\n}\n.Select--multi.is-disabled .Select-item {\n  background-color: #f2f2f2;\n  border: 1px solid #d9d9d9;\n  color: #888;\n}\n.Select--multi.is-disabled .Select-item-icon {\n  cursor: not-allowed;\n  border-right: 1px solid #d9d9d9;\n}\n.Select--multi.is-disabled .Select-item-icon:hover,\n.Select--multi.is-disabled .Select-item-icon:focus,\n.Select--multi.is-disabled .Select-item-icon:active {\n  background-color: #f2f2f2;\n}\n@keyframes Select-animation-spin {\n  to {\n    transform: rotate(1turn);\n  }\n}\n@-webkit-keyframes Select-animation-spin {\n  to {\n    -webkit-transform: rotate(1turn);\n  }\n}\n.m-signature-pad {\n  position: absolute;\n  font-size: 10px;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n  background-color: #fff;\n  border-radius: 4px;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n}\n.m-signature-pad--body {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border: 1px solid #f4f4f4;\n}\n.m-signature-pad--body canvas {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.02) inset;\n}\n.m-signature-pad--footer {\n  position: absolute;\n  left: 20px;\n  right: 20px;\n  bottom: 20px;\n  height: 40px;\n}\n.m-signature-pad--footer .description {\n  color: #c3c3c3;\n  text-align: center;\n  font-size: 1.2em;\n  margin-top: 1.8em;\n}\n.m-signature-pad--footer .button {\n  position: absolute;\n  bottom: 0;\n}\n.m-signature-pad--footer .button.clear {\n  left: 0;\n}\n.m-signature-pad--footer .button.save {\n  right: 0;\n}\n@media screen and (max-width: 1024px) {\n  .m-signature-pad {\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: auto;\n    height: auto;\n    min-width: 250px;\n    min-height: 140px;\n  }\n  #github {\n    display: none;\n  }\n}\n@media screen and (max-height: 320px) {\n  .m-signature-pad--body {\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n  }\n  .m-signature-pad--footer {\n    left: 20px;\n    right: 20px;\n    bottom: 4px;\n    height: 28px;\n  }\n  .m-signature-pad--footer .description {\n    font-size: 1em;\n    margin-top: 1em;\n  }\n}\n@media print {\n  .m-signature-pad-button {\n    height: 30px;\n    margin-bottom: 10px;\n  }\n  .m-signature-pad-button .btn,\n  .m-signature-pad-button button {\n    display: none !important;\n  }\n}\n.sample-job-watermark:after {\n  content: 'Sample';\n  position: absolute;\n  z-index: 2;\n  left: 20%;\n  top: 30%;\n  font-size: 180px;\n  text-transform: uppercase;\n  font-family: 'open sans', 'helvetica neue', helvetica, arial;\n  -webkit-transform: rotate(-25deg);\n  -moz-transform: rotate(-25deg);\n  -ms-transform: rotate(-25deg);\n  transform: rotate(-25deg);\n  font-family: 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif;\n  font-weight: 300;\n  color: rgba(0, 0, 0, 0.24);\n}\n.signed-copy-job-watermark:after {\n  content: 'Signed Copy';\n  position: absolute;\n  z-index: 2;\n  left: 0%;\n  top: 32%;\n  font-size: 154px;\n  text-transform: uppercase;\n  font-weight: 300;\n  font-family: 'open sans', 'helvetica neue', helvetica, arial;\n  -webkit-transform: rotate(-30deg);\n  -moz-transform: rotate(-30deg);\n  -ms-transform: rotate(-30deg);\n  transform: rotate(-30deg);\n  color: rgba(0, 0, 0, 0.24);\n}\n.out-of-date-job-watermark:after {\n  content: 'Out of Date';\n  position: absolute;\n  z-index: 2;\n  left: 0%;\n  top: 32%;\n  font-size: 154px;\n  text-transform: uppercase;\n  font-weight: 300;\n  font-family: 'open sans', 'helvetica neue', helvetica, arial;\n  -webkit-transform: rotate(-30deg);\n  -moz-transform: rotate(-30deg);\n  -ms-transform: rotate(-30deg);\n  transform: rotate(-30deg);\n  color: rgba(217, 45, 32, 0.24);\n}\n.desaturate-image {\n  -webkit-filter: grayscale(100%);\n  -moz-filter: grayscale(100%);\n  filter: grayscale(100%);\n}\n@-webkit-keyframes fadeOut {\n  to {\n    opacity: 0;\n  }\n}\n@keyframes fadeOut {\n  to {\n    opacity: 0;\n  }\n}\n@-webkit-keyframes shrinkHeight {\n  to {\n    max-height: 0;\n    transform: scale(0);\n  }\n}\n@keyframes shrinkHeight {\n  to {\n    max-height: 0;\n    transform: scale(0);\n  }\n}\n.uploader-container {\n  position: relative;\n  height: 115px;\n  text-align: center;\n  background-color: #f9f9f9;\n  border-radius: 6px;\n  cursor: pointer;\n}\n.uploader-container .btn.delete-photo {\n  color: red;\n  background-color: #fff;\n  border-color: #ccc;\n  border: 1px solid #ddd;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: -10px;\n  margin: auto;\n  width: 45px;\n  font-size: 18px;\n}\n.uploader-container .btn.delete-photo:hover,\n.uploader-container .btn.delete-photo:focus,\n.uploader-container .btn.delete-photo:active,\n.uploader-container .btn.delete-photo.active,\n.open > .dropdown-toggle.uploader-container .btn.delete-photo {\n  color: red;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.uploader-container .btn.delete-photo:active,\n.uploader-container .btn.delete-photo.active,\n.open > .dropdown-toggle.uploader-container .btn.delete-photo {\n  background-image: none;\n}\n.uploader-container .btn.delete-photo.disabled,\n.uploader-container .btn.delete-photo[disabled],\nfieldset[disabled] .uploader-container .btn.delete-photo,\n.uploader-container .btn.delete-photo.disabled:hover,\n.uploader-container .btn.delete-photo[disabled]:hover,\nfieldset[disabled] .uploader-container .btn.delete-photo:hover,\n.uploader-container .btn.delete-photo.disabled:focus,\n.uploader-container .btn.delete-photo[disabled]:focus,\nfieldset[disabled] .uploader-container .btn.delete-photo:focus,\n.uploader-container .btn.delete-photo.disabled:active,\n.uploader-container .btn.delete-photo[disabled]:active,\nfieldset[disabled] .uploader-container .btn.delete-photo:active,\n.uploader-container .btn.delete-photo.disabled.active,\n.uploader-container .btn.delete-photo[disabled].active,\nfieldset[disabled] .uploader-container .btn.delete-photo.active {\n  background-color: #fff;\n  border-color: #ccc;\n}\n.uploader-container .btn.delete-photo .badge {\n  color: #fff;\n  background-color: red;\n}\n.uploader-container .delete-photo {\n  display: none;\n}\n.uploader-container img {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  max-height: 100%;\n  max-width: 100%;\n  height: auto;\n  width: auto;\n  min-height: 50px;\n  min-width: 50px;\n  cursor: pointer;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n}\n.uploader-container > .uploadcare--widget__dragndrop-area {\n  margin-top: 0;\n  cursor: pointer;\n  position: relative;\n  border-radius: 5px;\n  min-width: initial;\n  background-color: #f9f9f9;\n  color: #777777;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  border: 1px dashed rgba(0, 0, 0, 0.2);\n}\n.uploader-container > .uploadcare--widget__dragndrop-area:hover {\n  background-color: #fef5e9;\n  border-color: #fbbc6d;\n}\n.uploader-container > .uploadcare--widget__dragndrop-area:active,\n.uploader-container > .uploadcare--widget__dragndrop-area:focus {\n  background-color: #ffe5c5;\n  border-color: #fbb65e;\n}\n.uploader-container > .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text {\n  line-height: 28px;\n  padding: 15px 0;\n  display: block;\n  margin: auto;\n  font-size: 10px;\n}\n.uploader-container > .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text i[class^='ico-'],\n.uploader-container > .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text i[class*=' ico-'] {\n  font-size: 36px;\n}\n.uploadcare--widget {\n  width: 100%;\n  cursor: pointer;\n}\n.uploadcare--widget .uploadcare--widget__button {\n  display: none !important;\n}\n.uploadcare--widget .uploadcare--widget__status,\n.uploadcare--widget .uploadcare--widget__circle-back {\n  display: none;\n}\n.uploadcare--widget .uploadcare--widget__status {\n  display: none;\n}\n.uploadcare--widget .uploadcare--widget__dragndrop-area {\n  margin-top: 0;\n  cursor: pointer;\n  position: relative;\n  border-radius: 5px;\n  min-width: initial;\n  background-color: #f9f9f9;\n  color: #777777;\n  left: 0;\n  display: block;\n  min-height: 115px;\n}\n.uploadcare--widget .uploadcare--widget__dragndrop-area:hover {\n  background-color: #fef5e9;\n  border-color: #fbbc6d;\n}\n.uploadcare--widget .uploadcare--widget__dragndrop-area:active,\n.uploadcare--widget .uploadcare--widget__dragndrop-area:focus {\n  background-color: #ffe5c5;\n  border-color: #fbb65e;\n}\n.uploadcare--widget .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text {\n  line-height: 28px;\n  padding: 15px 0;\n  display: block;\n  margin: auto;\n  font-size: 10px;\n}\n.uploadcare--widget .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text i[class^='ico-'],\n.uploadcare--widget .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text i[class*=' ico-'] {\n  font-size: 36px;\n}\n.uploadcare-dragging {\n  background-color: #fffcf8;\n}\n.snugg-uploader-dropzone-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 5;\n  pointer-events: none;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px;\n  border-radius: 6px;\n  border: 2px dashed #ff9003;\n  background-color: rgba(255, 144, 3, 0.1);\n  animation: snugg-uploader-dropzone-in 120ms ease-out;\n}\n.snugg-uploader-dropzone-overlay__inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  text-align: center;\n  color: #c56e00;\n}\n.snugg-uploader-dropzone-overlay__icon {\n  width: 28px;\n  height: 28px;\n  color: #ff9003;\n}\n.snugg-uploader-dropzone-overlay__text {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.2;\n}\n@keyframes snugg-uploader-dropzone-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.uploadcare--dialog__powered-by {\n  display: none;\n}\n.uploadcare-file-container .uploadcare--widget {\n  display: none !important;\n}\n.uploadcare-widget-disabled {\n  float: left;\n  margin-left: 10px;\n  min-width: initial;\n  min-height: 115px;\n  width: 200px;\n  height: 100%;\n  left: 0;\n  margin-top: 0;\n  display: block;\n  position: relative;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  text-align: center;\n  background-color: #eeeeee;\n  border: 1px dashed rgba(0, 0, 0, 0.2);\n}\n.uploadcare-widget-disabled .ico-budicon-10 {\n  position: absolute;\n  z-index: 3;\n  top: 0.8em;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  text-align: center;\n  color: #777777;\n}\n.photo-upload-refine {\n  position: relative;\n  margin-bottom: 20px;\n}\n.photo-upload-refine .snugg-upload-prompt-text {\n  line-height: 1.1 !important;\n}\n.uploaded-image-loading {\n  background: url('../img/spinner.svg') center center no-repeat;\n}\n.photo-upload-report {\n  position: relative;\n  width: 200px;\n  margin-bottom: 20px;\n}\n.photo-upload-report .snugg-upload-prompt-text {\n  line-height: 1.1 !important;\n}\n.snugg-uploader-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.45);\n  animation: snugg-uploader-fade-in 0.2s ease;\n}\n@keyframes snugg-uploader-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.snugg-uploader-dialog {\n  display: flex;\n  position: relative;\n  width: 800px;\n  max-width: calc(100% - 40px);\n  height: 660px;\n  max-height: calc(100% - 40px);\n  border-radius: 6px;\n  overflow: hidden;\n  box-shadow: -2px 1px 50px rgba(0, 0, 0, 0.4);\n  animation: snugg-uploader-slide-up 0.25s ease;\n}\n@media (max-width: 767px), (max-height: 500px) {\n  .snugg-uploader-dialog {\n    width: 100%;\n    height: 100%;\n    max-width: 100%;\n    max-height: 100%;\n    border-radius: 0;\n  }\n}\n@keyframes snugg-uploader-slide-up {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.snugg-uploader-panel {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background: #fff;\n}\n.snugg-uploader-header {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  height: 60px;\n  background: #f2f2f2;\n  border-bottom: 1px solid #eeeeee;\n}\n.snugg-uploader-header__close {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 60px;\n  height: 60px;\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  border: none;\n  color: #333333;\n  cursor: pointer;\n  transition: color 0.15s ease, background-color 0.15s ease;\n  outline: none;\n  -webkit-appearance: none;\n}\n.snugg-uploader-header__close:hover {\n  color: #333333;\n  background-color: rgba(0, 0, 0, 0.06);\n}\n.snugg-uploader-header__close:focus-visible {\n  box-shadow: inset 0 0 0 2px #fa7b00;\n}\n@media (max-width: 600px) {\n  .snugg-uploader-header__close {\n    width: 44px;\n  }\n}\n.snugg-uploader-tabs {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n@media (max-width: 600px) {\n  .snugg-uploader-tabs {\n    margin: 0;\n    flex: 1;\n    min-width: 0;\n  }\n}\n.snugg-uploader-tab {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 24px;\n  gap: 12px;\n  height: 60px;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 142%;\n  color: #777777;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n  outline: none;\n  -webkit-appearance: none;\n}\n@media (max-width: 600px) {\n  .snugg-uploader-tab {\n    padding: 0 12px;\n    gap: 6px;\n    font-size: 13px;\n  }\n}\n.snugg-uploader-tab:hover {\n  background-color: rgba(255, 255, 255, 0.5);\n}\n.snugg-uploader-tab:focus-visible {\n  box-shadow: inset 0 0 0 2px #fa7b00;\n}\n.snugg-uploader-tab.snugg-uploader-tab--active {\n  background: #fff;\n  color: #333333;\n}\n.snugg-uploader-tab__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n.snugg-uploader-tab__icon svg {\n  width: 16px;\n  height: 16px;\n}\n.snugg-uploader-tab__label {\n  white-space: nowrap;\n}\n.snugg-uploader-body {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  padding: 0;\n}\n.snugg-uploader-upload-body {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 24px;\n  gap: 16px;\n  width: 100%;\n  height: 100%;\n}\n.snugg-uploader-progress {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 32px 24px;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n}\n.snugg-uploader-progress__icon {\n  color: #777777;\n  opacity: 0.8;\n}\n.snugg-uploader-progress__icon svg {\n  width: 40px;\n  height: 40px;\n}\n.snugg-uploader-progress__name {\n  max-width: 320px;\n  color: #333333;\n  font-weight: 600;\n  word-break: break-word;\n}\n.snugg-uploader-progress__track {\n  position: relative;\n  width: 100%;\n  max-width: 320px;\n  height: 8px;\n  border-radius: 999px;\n  background: #eeeeee;\n  overflow: hidden;\n}\n.snugg-uploader-progress__bar {\n  height: 100%;\n  border-radius: 999px;\n  background: linear-gradient(180deg, #fea100 0%, #fa7b00 100%);\n  transition: width 0.2s ease;\n}\n.snugg-uploader-progress__pct {\n  color: #777777;\n  font-size: 13px;\n}\n.snugg-uploader-progress--error .snugg-uploader-progress__name {\n  color: #d92d20;\n}\n.snugg-uploader-dropzone {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  padding: 24px;\n  width: 100%;\n  flex-grow: 1;\n  background: #fff;\n  border: 1px dashed #cccccc;\n  border-radius: 12px;\n  text-align: center;\n  cursor: default;\n}\n.snugg-uploader-dropzone--dragging {\n  background-color: rgba(250, 123, 0, 0.04);\n  border-color: #fa7b00;\n  border-style: dashed;\n}\n.snugg-uploader-dropzone__heading {\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 142%;\n  color: #333333;\n}\n.snugg-uploader-dropzone__or {\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 142%;\n  color: #777777;\n}\n.snugg-uploader-dropzone__browse {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 15px 18px;\n  background: linear-gradient(180deg, #fea100 0%, #fa7b00 100%);\n  border: none;\n  border-radius: 6px;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  text-align: center;\n  color: #ffffff;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n  outline: none;\n  -webkit-appearance: none;\n}\n.snugg-uploader-dropzone__browse:hover {\n  opacity: 0.9;\n}\n.snugg-uploader-dropzone__browse:active {\n  opacity: 0.8;\n}\n.snugg-uploader-dropzone__browse:focus-visible {\n  box-shadow: 0 0 0 2px rgba(250, 123, 0, 0.5);\n}\n.snugg-uploader-dropzone__url-row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n  width: 500px;\n  max-width: 100%;\n}\n.snugg-uploader-dropzone__url-input {\n  box-sizing: border-box;\n  flex: 1;\n  height: 46px;\n  padding: 10px 12px;\n  background: #fff;\n  border: 1px solid #cccccc;\n  border-radius: 6px;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 142%;\n  color: #555555;\n  outline: none;\n}\n.snugg-uploader-dropzone__url-input::placeholder {\n  color: #555555;\n  opacity: 0.5;\n}\n.snugg-uploader-dropzone__url-input:focus {\n  border-color: #fa7b00;\n  box-shadow: 0 0 0 2px rgba(250, 123, 0, 0.2);\n}\n.snugg-uploader-dropzone__url-input:disabled {\n  opacity: 0.6;\n}\n.snugg-uploader-dropzone__url-btn {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 12px 16px;\n  width: 82px;\n  height: 46px;\n  background: linear-gradient(180deg, #505252 0%, #2f3030 100%);\n  border: none;\n  border-radius: 6px;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 19px;\n  text-align: center;\n  color: #ffffff;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n  outline: none;\n  -webkit-appearance: none;\n}\n.snugg-uploader-dropzone__url-btn:hover {\n  opacity: 0.9;\n}\n.snugg-uploader-dropzone__url-btn:active {\n  opacity: 0.8;\n}\n.snugg-uploader-dropzone__url-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.snugg-uploader-dropzone__url-btn:focus-visible {\n  box-shadow: 0 0 0 2px rgba(47, 48, 48, 0.5);\n}\n.snugg-uploader-dropzone__size-pill {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 6px 12px;\n  background: #f2f2f2;\n  border-radius: 12px;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 142%;\n  color: #777777;\n}\n.snugg-uploader-dropzone__error {\n  color: #c90606;\n  font-size: 13px;\n  margin-top: 4px;\n}\n.snugg-uploader-footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px 16px;\n  min-height: 65px;\n  border-top: 1px solid #eeeeee;\n}\n.snugg-uploader-footer:not(.snugg-uploader-footer--crop) > :first-child,\n.snugg-uploader-footer:not(.snugg-uploader-footer--crop) > :last-child {\n  flex: 0 0 160px;\n}\n.snugg-uploader-footer > :first-child {\n  text-align: left;\n}\n.snugg-uploader-footer > :last-child {\n  text-align: right;\n}\n@media (max-width: 600px) {\n  .snugg-uploader-footer {\n    padding: 10px 12px 14px;\n  }\n  .snugg-uploader-footer:not(.snugg-uploader-footer--crop) {\n    flex-wrap: wrap;\n    row-gap: 12px;\n  }\n  .snugg-uploader-footer:not(.snugg-uploader-footer--crop) .snugg-uploader-toolbar {\n    order: -1;\n    flex: 0 0 100%;\n    padding: 0;\n  }\n  .snugg-uploader-footer:not(.snugg-uploader-footer--crop) > :first-child,\n  .snugg-uploader-footer:not(.snugg-uploader-footer--crop) > :last-child {\n    flex: 0 0 auto;\n  }\n  .snugg-uploader-footer .snugg-uploader-btn {\n    padding: 0 14px;\n    font-size: 13px;\n    min-width: 0;\n  }\n}\n.snugg-uploader-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  min-width: 90px;\n  height: 40px;\n  padding: 0 20px;\n  border: 1px solid #fa7b00;\n  border-radius: 6px;\n  background: transparent;\n  color: #fa7b00;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1;\n  text-align: center;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n  outline: none;\n  -webkit-appearance: none;\n}\n.snugg-uploader-btn:hover {\n  border-color: #ff9024;\n  color: #ff9024;\n}\n.snugg-uploader-btn:active {\n  border-color: #db6c00;\n  color: #db6c00;\n}\n.snugg-uploader-btn:focus-visible {\n  box-shadow: 0 0 0 2px rgba(250, 123, 0, 0.4);\n}\n.snugg-uploader-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.snugg-uploader-btn--primary {\n  background: linear-gradient(180deg, #fea100 0%, #fa7b00 100%);\n  border-color: #fa7b00;\n  color: #fff;\n  font-weight: 700;\n}\n.snugg-uploader-btn--primary:hover {\n  opacity: 0.9;\n  border-color: #ff9024;\n  color: #fff;\n}\n.snugg-uploader-btn--primary:active {\n  opacity: 0.8;\n  border-color: #db6c00;\n  color: #fff;\n}\n.snugg-uploader-btn--primary:disabled {\n  background: #ccc;\n  border-color: #ccc;\n  color: #fff;\n  opacity: 1;\n}\n.snugg-uploader-btn--close {\n  min-width: 0;\n  border-color: transparent;\n  color: #777777;\n}\n.snugg-uploader-btn--close:hover {\n  color: #333333;\n  border-color: transparent;\n}\n.snugg-uploader-toolbar {\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  padding: 0 12px;\n}\n.snugg-uploader-toolbar__btn {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  color: #333333;\n  font-size: 18px;\n  cursor: pointer;\n  transition: color 0.15s ease, background-color 0.15s ease;\n  outline: none;\n  -webkit-appearance: none;\n}\n.snugg-uploader-toolbar__btn:hover {\n  background-color: rgba(0, 0, 0, 0.06);\n  color: #fa7b00;\n}\n.snugg-uploader-toolbar__btn:focus-visible {\n  box-shadow: 0 0 0 2px #fa7b00;\n}\n.snugg-uploader-toolbar__btn.snugg-uploader-toolbar__btn--active {\n  color: #fa7b00;\n}\n.snugg-uploader-toolbar__btn.snugg-uploader-toolbar__btn--active::after {\n  content: '';\n  position: absolute;\n  bottom: 2px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #fa7b00;\n}\n.snugg-uploader-toolbar__btn:disabled {\n  opacity: 0.35;\n  cursor: default;\n}\n.snugg-uploader-toolbar__btn:disabled:hover {\n  background-color: transparent;\n  color: #333333;\n}\n.snugg-uploader-toolbar__btn[title] {\n  position: relative;\n}\n.snugg-uploader-camera {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n}\n.snugg-uploader-camera video {\n  flex: 0 1 auto;\n  min-height: 0;\n  width: 100%;\n  max-height: 380px;\n  object-fit: contain;\n  background: #000;\n  border-radius: 4px;\n}\n.snugg-uploader-camera canvas {\n  display: none;\n}\n.snugg-uploader-camera .snugg-uploader-camera__controls {\n  flex-shrink: 0;\n  margin-top: 16px;\n}\n@media (max-height: 500px) {\n  .snugg-uploader-camera {\n    padding: 10px;\n  }\n  .snugg-uploader-camera .snugg-uploader-camera__controls {\n    margin-top: 10px;\n  }\n}\n.snugg-uploader-camera .snugg-uploader-camera__error {\n  color: #c90606;\n  text-align: center;\n  padding: 40px 20px;\n}\n.snugg-uploader-camera .snugg-uploader-camera__spinner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  color: #777777;\n}\n.snugg-uploader-camera .snugg-uploader-camera__message {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px 20px;\n  max-width: 480px;\n}\n.snugg-uploader-camera .snugg-uploader-camera__message-heading {\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 142%;\n  color: #333333;\n  margin-bottom: 8px;\n}\n.snugg-uploader-camera .snugg-uploader-camera__message-line {\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 160%;\n  color: #777777;\n}\n.snugg-uploader-camera .snugg-uploader-camera__message-line:first-of-type {\n  font-weight: 600;\n  color: #333333;\n  margin-top: 4px;\n  margin-bottom: 6px;\n}\n.snugg-uploader-camera .snugg-uploader-camera__message-action {\n  margin-top: 20px;\n  padding: 10px 20px;\n  background: transparent;\n  border: 1px solid #fa7b00;\n  border-radius: 6px;\n  color: #fa7b00;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s ease, color 0.15s ease;\n  outline: none;\n  -webkit-appearance: none;\n}\n.snugg-uploader-camera .snugg-uploader-camera__message-action:hover {\n  background-color: rgba(250, 123, 0, 0.08);\n}\n.snugg-uploader-camera .snugg-uploader-camera__message-action:focus-visible {\n  box-shadow: 0 0 0 2px rgba(250, 123, 0, 0.4);\n}\n.snugg-uploader-url {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  padding: 20px 40px;\n}\n.snugg-uploader-url__input-group {\n  display: flex;\n  width: 100%;\n  max-width: 500px;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n.snugg-uploader-url__input-group input {\n  flex: 1;\n  height: 40px;\n  padding: 0 12px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 14px;\n  font-family: inherit;\n  outline: none;\n}\n.snugg-uploader-url__input-group input:focus {\n  border-color: #fa7b00;\n  box-shadow: 0 0 0 2px rgba(250, 123, 0, 0.2);\n}\n.snugg-uploader-url__input-group input::placeholder {\n  color: #bbb;\n}\n.snugg-uploader-url__error {\n  color: #c90606;\n  font-size: 13px;\n  margin-bottom: 8px;\n  max-width: 500px;\n  width: 100%;\n}\n.snugg-uploader-url__preview {\n  text-align: center;\n  margin-top: 16px;\n}\n.snugg-uploader-url__preview img {\n  max-width: 100%;\n  max-height: 260px;\n  border-radius: 4px;\n  margin-bottom: 12px;\n}\n.snugg-uploader-editor {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 20px;\n  overflow: hidden;\n}\n.snugg-uploader-editor img {\n  max-width: 100%;\n  display: block;\n}\n.snugg-uploader-editor-canvas-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n.snugg-uploader-preview-canvas {\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  border-radius: 4px;\n}\n.snugg-uploader-editor .cropper-container {\n  max-height: 100%;\n}\n.snugg-uploader-editor .cropper-view-box {\n  outline: 1px solid rgba(255, 255, 255, 0.7);\n  outline-color: rgba(51, 153, 255, 0.5);\n}\n.snugg-uploader-editor .cropper-line {\n  background-color: #fa7b00;\n  opacity: 0.2;\n}\n.snugg-uploader-editor .cropper-point {\n  background-color: #fa7b00;\n  opacity: 0.7;\n  width: 8px;\n  height: 8px;\n}\n.snugg-uploader-editor .cropper-modal {\n  background-color: #000;\n  opacity: 0.4;\n}\n.custom-uploader-progress {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background-color: #eee;\n  border-radius: 0 0 6px 6px;\n  overflow: hidden;\n}\n.custom-uploader-progress .progress-fill {\n  height: 100%;\n  background-color: #ff9003;\n  transition: width 0.2s ease;\n}\n.snugg-uploader-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 40px;\n  color: #777777;\n  font-size: 14px;\n}\n.snugg-uploader-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px;\n  color: #777777;\n  font-size: 14px;\n}\n.snugg-uploader-mobile-home {\n  display: none;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  position: relative;\n  padding: 56px 24px 40px;\n}\n.snugg-uploader-mobile-home__close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  color: #333333;\n  cursor: pointer;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  transition: background-color 0.15s ease;\n}\n.snugg-uploader-mobile-home__close:hover {\n  background-color: rgba(0, 0, 0, 0.06);\n}\n.snugg-uploader-mobile-home__close:focus-visible {\n  box-shadow: inset 0 0 0 2px #fa7b00;\n}\n.snugg-uploader-mobile-home__back {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  color: #333333;\n  cursor: pointer;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  transition: background-color 0.15s ease;\n}\n.snugg-uploader-mobile-home__back:hover {\n  background-color: rgba(0, 0, 0, 0.06);\n}\n.snugg-uploader-mobile-home__back:focus-visible {\n  box-shadow: inset 0 0 0 2px #fa7b00;\n}\n.snugg-uploader-mobile-sources {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 14px;\n  width: 100%;\n  max-width: 300px;\n}\n.snugg-uploader-mobile-source-btn {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  padding: 18px 24px;\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 14px;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 1.3;\n  color: #333333;\n  cursor: pointer;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n  text-align: left;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  transition: background-color 0.15s ease;\n}\n.snugg-uploader-mobile-source-btn:hover {\n  background-color: #f7f7f7;\n}\n.snugg-uploader-mobile-source-btn:active {\n  background-color: #efefef;\n}\n.snugg-uploader-mobile-source-btn:focus-visible {\n  box-shadow: 0 0 0 2px #fa7b00;\n}\n.snugg-uploader-mobile-source-btn__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #777777;\n}\n.snugg-uploader-mobile-source-btn__icon svg {\n  width: 22px;\n  height: 22px;\n}\n.snugg-uploader-mobile-source-btn__label {\n  white-space: nowrap;\n}\n.snugg-uploader-mobile-home__filesize {\n  margin-top: 20px;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  color: #777777;\n}\n.snugg-uploader-url-tab {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  padding: 24px 32px;\n  gap: 8px;\n}\n.snugg-uploader-url-tab .snugg-uploader-dropzone__url-row {\n  width: 100%;\n  max-width: 480px;\n}\n.snugg-uploader-mobile-nav {\n  display: none;\n  flex-shrink: 0;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: 52px;\n  padding: 0 4px;\n  background: #f2f2f2;\n  border-bottom: 1px solid #eeeeee;\n}\n.snugg-uploader-mobile-nav__back {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 0 12px;\n  height: 44px;\n  background: transparent;\n  border: none;\n  color: #fa7b00;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 600;\n  font-size: 15px;\n  cursor: pointer;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  border-radius: 4px;\n  transition: background-color 0.15s ease;\n}\n.snugg-uploader-mobile-nav__back:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n.snugg-uploader-mobile-nav__back:focus-visible {\n  box-shadow: inset 0 0 0 2px #fa7b00;\n}\n.snugg-uploader-mobile-nav__back svg {\n  width: 18px;\n  height: 18px;\n}\n.snugg-uploader-mobile-nav__close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  background: transparent;\n  border: none;\n  color: #333333;\n  cursor: pointer;\n  border-radius: 4px;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  transition: background-color 0.15s ease;\n}\n.snugg-uploader-mobile-nav__close:hover {\n  background-color: rgba(0, 0, 0, 0.06);\n}\n.snugg-uploader-mobile-nav__close:focus-visible {\n  box-shadow: inset 0 0 0 2px #fa7b00;\n}\n.snugg-uploader-mobile-nav__menu {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  background: transparent;\n  border: none;\n  color: #333333;\n  cursor: pointer;\n  border-radius: 4px;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  transition: background-color 0.15s ease;\n}\n.snugg-uploader-mobile-nav__menu:hover {\n  background-color: rgba(0, 0, 0, 0.06);\n}\n.snugg-uploader-mobile-nav__menu:focus-visible {\n  box-shadow: inset 0 0 0 2px #fa7b00;\n}\n@media (max-width: 767px) {\n  .snugg-uploader-header {\n    display: none;\n  }\n  .snugg-uploader-panel--picker .snugg-uploader-body {\n    display: none;\n  }\n  .snugg-uploader-panel--picker .snugg-uploader-mobile-home {\n    display: flex;\n  }\n  .snugg-uploader-panel:not(.snugg-uploader-panel--picker) .snugg-uploader-mobile-nav {\n    display: flex;\n  }\n}\n.snugg-uploader-gdrive {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  color: #777777;\n  font-size: 14px;\n  overflow: hidden;\n}\n.snugg-uploader-gdrive__status {\n  color: #777777;\n  font-size: 14px;\n  padding: 40px;\n}\n.snugg-uploader-gdrive__error {\n  color: #c90606;\n  font-size: 13px;\n  padding: 40px;\n  max-width: 400px;\n}\n.content-header .dropdown-menu {\n  min-width: 280px;\n}\n.dropdown-toggle .badge {\n  background-color: #303232;\n  color: #d9d9d9;\n}\n.dropdown-toggle .badge .badge-left-tip {\n  border-right-color: #303232;\n}\n.dropdown-menu {\n  overflow: scroll;\n  max-height: 500px;\n  padding: 0;\n  border-radius: 6px;\n  padding: 8px;\n  border: none;\n  width: 100%;\n  margin-top: -1px;\n  text-align: left;\n  background-color: #fff;\n  box-shadow: 0 5px 20px 5px rgba(0, 0, 0, 0.3);\n  z-index: 1065;\n}\n.dropdown-menu .active,\n.dropdown-menu .active > a,\n.dropdown-menu .active > a:hover,\n.dropdown-menu a:active,\n.dropdown-menu a:focus {\n  border-radius: 4px;\n  background-color: #eeeeee;\n  color: #000;\n}\n.dropdown-menu .active .badge,\n.dropdown-menu .active > a .badge,\n.dropdown-menu .active > a:hover .badge,\n.dropdown-menu a:active .badge,\n.dropdown-menu a:focus .badge {\n  background-color: #303232;\n  color: #d9d9d9;\n}\n.dropdown-menu .active .badge .badge-left-tip,\n.dropdown-menu .active > a .badge .badge-left-tip,\n.dropdown-menu .active > a:hover .badge .badge-left-tip,\n.dropdown-menu a:active .badge .badge-left-tip,\n.dropdown-menu a:focus .badge .badge-left-tip {\n  border-right-color: #303232;\n}\n.dropdown-menu > li.top-divider {\n  border-top: 3px solid #cccccc;\n  position: relative;\n}\n.dropdown-menu > li > a {\n  padding: 13px 10px;\n  border-radius: 4px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-size: 13px;\n}\n.dropdown-menu > li > a:hover,\n.dropdown-menu > li > a:focus {\n  background-color: #f2f2f2;\n  outline: none;\n}\n.dropdown-menu > li > a:hover .badge,\n.dropdown-menu > li > a:focus .badge {\n  background-color: #777777;\n  color: #f2f2f2;\n}\n.dropdown-menu > li > a:hover .badge .badge-left-tip,\n.dropdown-menu > li > a:focus .badge .badge-left-tip {\n  border-right-color: #777777;\n}\n.dropdown-menu > li > a:active {\n  background-color: #cccccc;\n}\n.dropdown.btn-group {\n  width: 100%;\n  border-left: solid 0px transparent;\n}\n.dropdown.btn-group > .btn:first-child {\n  background-color: #f9f9f9;\n  border: none;\n}\n.dropdown.btn-group#btn-group-companies {\n  position: relative;\n  z-index: 4;\n}\n.dropdown.btn-group#btn-group-companies > .btn {\n  border-left: none;\n  border-radius: 0;\n}\n.dropdown.btn-group#btn-group-stages {\n  z-index: 3;\n  position: relative;\n  text-align: left;\n}\n.dropdown.btn-group#btn-group-stages > .btn {\n  border-left: none;\n  border-radius: 0;\n}\n.dropdown.btn-group#btn-group-sort {\n  border-right: 1px solid #ededed;\n  text-align: left;\n}\n.dropdown.btn-group#btn-group-sort > .btn {\n  border-left: none;\n  border-radius: 0;\n}\n.dropdown.btn-group .btn {\n  float: none;\n  text-align: left;\n  border-color: transparent;\n  border-top: none;\n  border-bottom: none;\n  border-right: none;\n  background-color: inherit;\n  margin: auto;\n  height: 100%;\n  width: 100%;\n  min-width: 60px;\n  padding: 4px 12px;\n  font-size: 12px;\n  color: #303232;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n}\n.dropdown.btn-group .btn [class*=' ico-'],\n.dropdown.btn-group .btn [class^='ico-'] {\n  font-size: 16px;\n  display: block;\n  float: none;\n  clear: both;\n}\n.dropdown.btn-group .btn:hover {\n  background-color: #ededed;\n}\n.dropdown.btn-group .btn:hover .arrow-right {\n  border-left-color: #ededed;\n}\n.dropdown.btn-group .btn:hover .arrow-right-n1,\n.dropdown.btn-group .btn:hover .arrow-right-n2 {\n  border-right-color: #ededed;\n}\n.dropdown.btn-group .btn:active,\n.dropdown.btn-group .btn.active,\n.dropdown.btn-group .btn:focus {\n  color: #303232;\n  box-shadow: none;\n  background-color: #e3e3e3;\n}\n.dropdown.btn-group .btn:active .arrow-right,\n.dropdown.btn-group .btn.active .arrow-right,\n.dropdown.btn-group .btn:focus .arrow-right {\n  border-left-color: #e3e3e3;\n}\n.dropdown.btn-group .btn .arrow-right {\n  width: 0;\n  height: 0;\n  border-top: 23px solid transparent;\n  border-bottom: 23px solid transparent;\n  border-left: 14px solid #f9f9f9;\n  float: right;\n  position: absolute;\n  right: -13px;\n  top: 0;\n  z-index: 10;\n}\n.dropdown.btn-group .btn .arrow-right.arrow-right-border {\n  right: -14px;\n  border-left-color: #d9d9d9;\n  z-index: 9;\n}\n.dropdown.btn-group .btn.btn-lg {\n  font-size: 14px;\n  padding: 7px 13px 14px 20px;\n}\n.dropdown.btn-group .btn.btn-lg .caret {\n  margin: auto 0 auto 8px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 8px;\n  font-size: 24px;\n  border-left-width: 5px;\n  border-right-width: 5px;\n  border-top-width: 5px;\n  opacity: 0.7;\n}\n.dropdown.btn-group .btn.btn-lg .badge {\n  margin: 0 10px 0 0;\n  top: 1px;\n}\n.dropdown.btn-group.open .dropdown-toggle {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  background-color: #f7f7f7;\n  color: #303232;\n}\n.dropdown.btn-group.open .dropdown-toggle .arrow-right {\n  border-left: 14px solid #f7f7f7;\n}\n.dropdown.btn-group.open .dropdown-toggle .arrow-right.arrow-right-border {\n  border-left-color: #e5e5e5;\n}\n.secondary-nav::-webkit-scrollbar {\n  width: 8px;\n  background-color: transparent;\n}\n.secondary-nav::-webkit-scrollbar-track {\n  background-color: transparent;\n  margin-bottom: 30px;\n}\n.secondary-nav::-webkit-scrollbar-thumb {\n  border-radius: 6px;\n  background-color: rgba(0, 0, 0, 0.25);\n}\n@media (min-height: 720px) {\n  .secondary-nav::-webkit-scrollbar {\n    display: none;\n  }\n}\n@media (min-height: 425px) {\n  .secondary-nav.report-secondary-nav::-webkit-scrollbar {\n    display: none;\n  }\n}\n:focus {\n  outline: transparent auto 0;\n}\nhtml {\n  height: 100%;\n}\nbody {\n  height: 100%;\n  background: #ffffff;\n  font-weight: 400;\n  color: #303232;\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: #303232;\n  line-height: 1.4em;\n}\nh1,\nh2,\nh3 {\n  text-rendering: auto;\n}\nh2 {\n  font-size: 24px;\n  margin-bottom: 15px;\n}\nh4 {\n  font-weight: 600;\n  margin-bottom: 10px;\n}\nh5 {\n  line-height: 1.1em;\n  font-weight: 600;\n  color: inherit;\n}\na {\n  color: #c84900;\n}\na:focus {\n  text-decoration: none;\n}\na:hover {\n  color: #e25200;\n  text-decoration: none;\n}\n.desaturate {\n  -webkit-filter: grayscale(100%);\n  -moz-filter: grayscale(100%);\n  filter: grayscale(100%);\n}\nhr {\n  border-top: 1px solid #ddd;\n}\ntextarea::-moz-placeholder,\nselect::-moz-placeholder,\n.form-control::-moz-placeholder,\ninput[type='text']::-moz-placeholder,\ninput[type='password']::-moz-placeholder,\ninput[type='datetime']::-moz-placeholder,\ninput[type='datetime-local']::-moz-placeholder,\ninput[type='date']::-moz-placeholder,\ninput[type='month']::-moz-placeholder,\ninput[type='time']::-moz-placeholder,\ninput[type='week']::-moz-placeholder,\ninput[type='number']::-moz-placeholder,\ninput[type='email']::-moz-placeholder,\ninput[type='url']::-moz-placeholder,\ninput[type='search']::-moz-placeholder,\ninput[type='tel']::-moz-placeholder,\ninput[type='color']::-moz-placeholder,\n.uneditable-input::-moz-placeholder {\n  color: #aaa;\n  opacity: 1;\n}\ntextarea:-ms-input-placeholder,\nselect:-ms-input-placeholder,\n.form-control:-ms-input-placeholder,\ninput[type='text']:-ms-input-placeholder,\ninput[type='password']:-ms-input-placeholder,\ninput[type='datetime']:-ms-input-placeholder,\ninput[type='datetime-local']:-ms-input-placeholder,\ninput[type='date']:-ms-input-placeholder,\ninput[type='month']:-ms-input-placeholder,\ninput[type='time']:-ms-input-placeholder,\ninput[type='week']:-ms-input-placeholder,\ninput[type='number']:-ms-input-placeholder,\ninput[type='email']:-ms-input-placeholder,\ninput[type='url']:-ms-input-placeholder,\ninput[type='search']:-ms-input-placeholder,\ninput[type='tel']:-ms-input-placeholder,\ninput[type='color']:-ms-input-placeholder,\n.uneditable-input:-ms-input-placeholder {\n  color: #aaa;\n}\ntextarea::-webkit-input-placeholder,\nselect::-webkit-input-placeholder,\n.form-control::-webkit-input-placeholder,\ninput[type='text']::-webkit-input-placeholder,\ninput[type='password']::-webkit-input-placeholder,\ninput[type='datetime']::-webkit-input-placeholder,\ninput[type='datetime-local']::-webkit-input-placeholder,\ninput[type='date']::-webkit-input-placeholder,\ninput[type='month']::-webkit-input-placeholder,\ninput[type='time']::-webkit-input-placeholder,\ninput[type='week']::-webkit-input-placeholder,\ninput[type='number']::-webkit-input-placeholder,\ninput[type='email']::-webkit-input-placeholder,\ninput[type='url']::-webkit-input-placeholder,\ninput[type='search']::-webkit-input-placeholder,\ninput[type='tel']::-webkit-input-placeholder,\ninput[type='color']::-webkit-input-placeholder,\n.uneditable-input::-webkit-input-placeholder {\n  color: #aaa;\n}\n.form-group-lg select[multiple].form-control {\n  padding: 0;\n}\n.form-group-lg select[multiple].form-control option {\n  border-bottom: 1px dashed #ddd;\n  padding: 10px 15px;\n}\n.form-group-lg select[multiple].form-control option:hover {\n  background-color: #ffd39c;\n}\n.form-group-lg select[multiple].form-control option:active,\n.form-group-lg select[multiple].form-control option:focus,\n.form-group-lg select[multiple].form-control option:checked {\n  background-color: #ff9003;\n}\ntextarea:focus,\nselect:focus,\n.form-control:focus,\n.form-control.focused,\ninput[type='text']:focus,\ninput[type='password']:focus,\ninput[type='datetime']:focus,\ninput[type='datetime-local']:focus,\ninput[type='date']:focus,\ninput[type='month']:focus,\ninput[type='time']:focus,\ninput[type='week']:focus,\ninput[type='number']:focus,\ninput[type='email']:focus,\ninput[type='url']:focus,\ninput[type='search']:focus,\ninput[type='tel']:focus,\ninput[type='color']:focus,\n.uneditable-input:focus {\n  border-color: #66afe9;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\n  outline: 0;\n  outline: thin dotted \\9;\n  /* IE6-9 */\n}\ntextarea:focus::-moz-placeholder,\nselect:focus::-moz-placeholder,\n.form-control:focus::-moz-placeholder,\n.form-control.focused::-moz-placeholder,\ninput[type='text']:focus::-moz-placeholder,\ninput[type='password']:focus::-moz-placeholder,\ninput[type='datetime']:focus::-moz-placeholder,\ninput[type='datetime-local']:focus::-moz-placeholder,\ninput[type='date']:focus::-moz-placeholder,\ninput[type='month']:focus::-moz-placeholder,\ninput[type='time']:focus::-moz-placeholder,\ninput[type='week']:focus::-moz-placeholder,\ninput[type='number']:focus::-moz-placeholder,\ninput[type='email']:focus::-moz-placeholder,\ninput[type='url']:focus::-moz-placeholder,\ninput[type='search']:focus::-moz-placeholder,\ninput[type='tel']:focus::-moz-placeholder,\ninput[type='color']:focus::-moz-placeholder,\n.uneditable-input:focus::-moz-placeholder {\n  color: #ccc;\n  opacity: 1;\n}\ntextarea:focus:-ms-input-placeholder,\nselect:focus:-ms-input-placeholder,\n.form-control:focus:-ms-input-placeholder,\n.form-control.focused:-ms-input-placeholder,\ninput[type='text']:focus:-ms-input-placeholder,\ninput[type='password']:focus:-ms-input-placeholder,\ninput[type='datetime']:focus:-ms-input-placeholder,\ninput[type='datetime-local']:focus:-ms-input-placeholder,\ninput[type='date']:focus:-ms-input-placeholder,\ninput[type='month']:focus:-ms-input-placeholder,\ninput[type='time']:focus:-ms-input-placeholder,\ninput[type='week']:focus:-ms-input-placeholder,\ninput[type='number']:focus:-ms-input-placeholder,\ninput[type='email']:focus:-ms-input-placeholder,\ninput[type='url']:focus:-ms-input-placeholder,\ninput[type='search']:focus:-ms-input-placeholder,\ninput[type='tel']:focus:-ms-input-placeholder,\ninput[type='color']:focus:-ms-input-placeholder,\n.uneditable-input:focus:-ms-input-placeholder {\n  color: #ccc;\n}\ntextarea:focus::-webkit-input-placeholder,\nselect:focus::-webkit-input-placeholder,\n.form-control:focus::-webkit-input-placeholder,\n.form-control.focused::-webkit-input-placeholder,\ninput[type='text']:focus::-webkit-input-placeholder,\ninput[type='password']:focus::-webkit-input-placeholder,\ninput[type='datetime']:focus::-webkit-input-placeholder,\ninput[type='datetime-local']:focus::-webkit-input-placeholder,\ninput[type='date']:focus::-webkit-input-placeholder,\ninput[type='month']:focus::-webkit-input-placeholder,\ninput[type='time']:focus::-webkit-input-placeholder,\ninput[type='week']:focus::-webkit-input-placeholder,\ninput[type='number']:focus::-webkit-input-placeholder,\ninput[type='email']:focus::-webkit-input-placeholder,\ninput[type='url']:focus::-webkit-input-placeholder,\ninput[type='search']:focus::-webkit-input-placeholder,\ninput[type='tel']:focus::-webkit-input-placeholder,\ninput[type='color']:focus::-webkit-input-placeholder,\n.uneditable-input:focus::-webkit-input-placeholder {\n  color: #ccc;\n}\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button,\ninput[type='datetime']::-webkit-inner-spin-button,\ninput[type='datetime']::-webkit-outer-spin-button,\ninput[type='datetime-local']::-webkit-inner-spin-button,\ninput[type='datetime-local']::-webkit-outer-spin-button,\ninput[type='date']::-webkit-inner-spin-button,\ninput[type='date']::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button,\ninput[type='date']::-webkit-inner-spin-button,\ninput[type='date']::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\nlegend {\n  margin-bottom: 15px;\n}\n.has-error {\n  position: relative;\n}\n.has-error .form-control.focused {\n  border-color: #843534;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 6px #ce8483;\n}\nbody #primary-container {\n  background-color: #f9f9f9;\n  height: auto;\n  min-height: 100vh;\n}\nbody #primary-container ::-webkit-input-placeholder {\n  color: #aaa;\n}\nbody #primary-container .inverse-placeholder ::-webkit-input-placeholder {\n  color: #fff;\n}\nbody #primary-container .inverse-placeholder:hover ::-webkit-input-placeholder {\n  color: #777777;\n}\nbody #primary-container .sidebar-placeholder::-webkit-input-placeholder {\n  color: #857e79;\n}\n.form-horizontal textarea {\n  height: 80px;\n}\n.input-xsmall {\n  width: 60px;\n}\n.search-jobs.topmost-search-job-container {\n  display: inline-block;\n  width: 210px;\n  float: left;\n}\n.form-search .form-group {\n  margin-top: 8px;\n  margin-bottom: 8px;\n  border-radius: 30px;\n  border: 1px solid #eeeeee;\n}\n.form-search .form-group:focus-within {\n  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);\n  border-color: #66afe9;\n}\n.form-search .form-group .form-control.search-query {\n  -webkit-appearance: none;\n  outline: none;\n  box-shadow: none;\n  padding-left: 0;\n  padding-right: 3px;\n  border-right-width: 0;\n  border-left-width: 0;\n  padding-top: 7px;\n  padding-bottom: 7px;\n  border: none;\n  font-size: 16px;\n}\n.form-search .form-group .input-group-addon {\n  box-shadow: none;\n  background-color: white;\n  font-size: 18px;\n  color: #777;\n  padding-top: 10px;\n  min-width: initial;\n  width: 30px;\n  border: none;\n}\n.form-search .form-group .input-group-addon.input-group-addon-clickable:hover {\n  color: #000;\n  cursor: pointer;\n}\n.form-search .form-group .input-group-addon:first-child {\n  border-radius: 30px 0 0 30px;\n  border-right: none;\n}\n.form-search .form-group .input-group-addon:last-child {\n  border-radius: 0 30px 30px 0;\n}\n.form-group {\n  height: auto !important;\n  -webkit-transition: all 0.3s;\n  -o-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.form-group.success {\n  -webkit-transition: border-color 0.4s ease-in-out;\n  -moz-transition: border-color 0.4s ease-in-out;\n  -o-transition: border-color 0.4s ease-in-out;\n  transition: border-color 0.4s ease-in-out;\n}\n.form-group-lg .form-control-static,\n.form-group-lg .form-control-static {\n  padding-top: 12px;\n  padding-bottom: 7px;\n}\n.form-group-lg .btn-group > .btn,\n.form-group-lg .btn-group > .btn {\n  padding: 12px 11px;\n  min-width: 47px;\n}\nlabel {\n  font-weight: 600;\n  padding: 0.3em 0.6em 0.3em;\n}\nlabel small {\n  color: #777777;\n}\n.label.label-danger {\n  margin-top: 2px;\n  color: #ffffff;\n}\n.label-touch {\n  cursor: pointer;\n}\n.label-touch:hover {\n  background-color: #f2f2f2;\n}\n.label {\n  color: #303232;\n  font-weight: 400;\n}\n.input-group-addon {\n  background-color: #f7f7f7;\n  min-width: 40px;\n  padding: 6px 8px;\n  color: #777777;\n  font-size: 1em !important;\n}\n::selection {\n  background-color: #f2a814;\n  color: #000;\n}\n.form-group.form-group-two-rows label.control-label {\n  padding-top: inherit;\n}\n.label-secondary {\n  font-size: 0.85em;\n  text-transform: uppercase;\n  margin-top: 10px;\n}\n.jl .snugg-select {\n  height: 74px;\n}\n.snugg-select {\n  width: 36px;\n  height: 46px;\n  position: relative;\n  float: left;\n  cursor: pointer;\n}\n.snugg-select > span {\n  border-radius: 2px;\n  width: 20px;\n  height: 20px;\n  line-height: 1.2em;\n  display: block;\n  cursor: pointer;\n  margin: auto;\n  font-size: 18px;\n  border: 1px solid rgba(0, 0, 0, 0.3);\n  background: #fff;\n  position: absolute;\n  text-align: center;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  ms-user-select: none;\n}\n.snugg-select > span:after {\n  content: '';\n  width: 20px;\n  height: 20px;\n  display: block;\n}\n.snugg-select:hover {\n  background-color: #fef4cb;\n  color: #cccccc;\n}\n.snugg-select:hover span {\n  border-color: #555555;\n}\n.snugg-select:hover span:after {\n  content: '\\2713';\n}\n.snugg-select:hover:active,\n.snugg-select:active,\n.snugg-select:focus,\n.snugg-select:focus:active {\n  background-color: #fef4cb;\n  color: black;\n}\n.snugg-select:hover:active span,\n.snugg-select:active span,\n.snugg-select:focus span,\n.snugg-select:focus:active span {\n  background: #777777;\n}\n.snugg-select:hover:active span:after,\n.snugg-select:active span:after,\n.snugg-select:focus span:after,\n.snugg-select:focus:active span:after {\n  content: '\\2713';\n}\n.snugg-selected .snugg-select span {\n  color: #333333;\n  background: #fff;\n}\n.snugg-selected .snugg-select span:after {\n  content: '';\n}\n.snugg-selected .snugg-select:hover span {\n  color: #777777;\n}\n.snugg-selected .snugg-select:hover span:after {\n  content: '';\n}\n.snugg-selected .snugg-select:focus span,\n.snugg-selected .snugg-select:focus:active span,\n.snugg-selected .snugg-select:active span {\n  background: #777777;\n  color: #555555;\n}\n.snugg-selected {\n  background-color: #fff4e6;\n}\n.snugg-selected:nth-child(even) {\n  background-color: #fff8f0;\n}\n.table-extra-condensed > tbody > tr > td,\n.table-extra-condensed > thead > tr > th {\n  padding: 5px 2px;\n  font-size: 0.8em;\n  line-height: 100%;\n}\ntable.table th {\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: rgba(0, 0, 0, 0.6);\n  font-size: 0.9em;\n}\ntable.table.table-expansive th,\ntable.table.table-expansive td {\n  padding: 15px 5px;\n  line-height: 100%;\n  vertical-align: middle;\n}\n.table-striped > tbody > tr:nth-child(odd) > td,\n.table-striped > tbody > tr:nth-child(odd) > th {\n  background-color: #f5f5f5;\n}\n.has-switch:focus {\n  outline: none;\n}\n.select-inline {\n  margin-left: 10px;\n  margin-top: 10px;\n}\n/* target job form only*/\n.form-block {\n  *zoom: 1;\n  padding-bottom: 30px;\n  margin-bottom: 10;\n}\n.form-block:before,\n.form-block:after {\n  content: \" \";\n  display: table;\n}\n.form-block:after {\n  clear: both;\n}\n.form-block:before,\n.form-block:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.form-block:after {\n  clear: both;\n}\n.headless-page {\n  margin-top: 50px;\n}\n.container-flex {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n}\n.signin-container {\n  background-color: #e8e8e8;\n  position: relative;\n  z-index: 0;\n  min-height: 100vh;\n  min-width: 320px;\n}\n.signin-container h1 {\n  font-size: 24px;\n  font-weight: 600;\n}\n.signin-container h2 {\n  font-size: 18px;\n  font-weight: 600;\n}\n.signin-container h3 {\n  font-weight: 400;\n}\n.signin-container .signin-form {\n  padding: 25px 30px 10px;\n  margin-bottom: 30px;\n  border: 1px solid #dddddd;\n  background-color: #fff;\n  border-radius: 5px;\n  position: relative;\n}\n.signin-container .signin-form:after {\n  content: '';\n  position: absolute;\n  z-index: -1;\n  -webkit-box-shadow: 0 5px 40px rgba(0, 0, 0, 0.4);\n  box-shadow: 0 5px 40px rgba(0, 0, 0, 0.4);\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: auto;\n  height: 30px;\n  width: 90%;\n  margin: auto 5%;\n}\n.signin-container .welcome-logo {\n  text-align: center;\n}\n.signin-container .welcome-logo img {\n  margin: 0 auto 10px;\n}\n.otp-form {\n  margin-top: 26px;\n}\n.opt-login-link-section {\n  margin-top: 10px;\n  margin-bottom: 23px;\n}\n.otp-title {\n  color: #333333;\n  font-size: 20px;\n  font-weight: 600;\n}\n.otp-title-bottom {\n  height: 43px;\n}\n.pointer {\n  cursor: pointer;\n}\n.form-wizard {\n  display: table;\n  margin-top: 20px;\n  width: 100%;\n}\n.form-wizard span {\n  text-align: center;\n  display: table-cell;\n  color: #ccc;\n  position: relative;\n  width: 25%;\n}\n.form-wizard span.completed {\n  color: #666;\n}\n.form-wizard i {\n  display: block;\n  font-size: 18px;\n}\n.form-wizard label {\n  display: block;\n  font-size: 12px;\n}\n.form-wizard span:before,\n.form-wizard span:after {\n  position: absolute;\n  content: '';\n  right: -10px;\n  top: 8px;\n  width: 50%;\n  height: 0;\n  border-bottom: 1px dashed #ccc;\n}\n.form-wizard span:before {\n  left: -8px;\n}\n.form-wizard span:first-child:before {\n  display: none;\n}\n.form-wizard span:last-child:after {\n  display: none;\n}\n.otp-secret-input {\n  padding-left: 25px;\n  padding-right: 25px;\n  letter-spacing: 18px;\n  font-family: 'Courier New', monospace;\n  font-weight: bold;\n  width: 100% !important;\n  box-shadow: none !important;\n  font-size: 30px;\n  height: auto;\n}\n.otp-form {\n  max-width: 490px;\n}\n@media (max-width: 767px) {\n  .otp-form {\n    max-width: 250px;\n  }\n}\n.secret-key-input {\n  height: 46px;\n  font-size: 30px;\n  letter-spacing: 30px;\n}\n.dashes-text {\n  text-align: center;\n  font-size: 30px;\n  font-weight: 600;\n  letter-spacing: 3px;\n  border-style: dashed;\n  border-radius: 11px;\n  line-height: 42px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  border: 2px dashed #bcb8b0;\n}\n.phone-format-number {\n  letter-spacing: 1px;\n}\n.alert-error-link {\n  font-weight: bold;\n  color: #6c3636 !important;\n}\n.phone-number-input {\n  height: 46px;\n  margin-top: 72px;\n  font-size: 17px;\n  letter-spacing: 7px;\n}\n.form-control.input-header .input-header,\n.form-group-lg .form-control .input-header {\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  border-bottom: #c84900 dashed 1px;\n  box-shadow: none;\n  padding: 10px 0 0;\n  line-height: inherit;\n  height: auto;\n  border-radius: 0;\n  font-size: 18px;\n  color: #000;\n}\n.form-control.input-header .input-header:hover,\n.form-group-lg .form-control .input-header:hover {\n  background-color: #fef2c1;\n}\n.form-control.input-header .input-header:focus,\n.form-group-lg .form-control .input-header:focus {\n  background-color: inherit;\n  outline: none;\n  box-shadow: none;\n}\n.form-group-lg input[type='date'].form-control {\n  line-height: 2.5em;\n}\n.back-link {\n  color: #333333;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  margin-bottom: 10px;\n  display: inline-block;\n}\n.back-link:hover {\n  color: #333333;\n}\n.back-icon {\n  font-size: 21px;\n  float: left;\n  margin-right: 11px;\n}\nbutton[disabled] {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n.btn {\n  border-radius: 4px;\n  background-image: none;\n  border: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  background-color: #e7e7e7;\n  box-sizing: border-box;\n  vertical-align: middle;\n  outline: none;\n  outline-offset: 0;\n}\n.btn:focus,\n.btn:active:focus,\n.btn:active,\n.btn.active,\n.btn.active:focus,\n.btn:hover:focus {\n  outline: none;\n  outline-offset: 0;\n}\n.btn:hover {\n  background-color: #dadada;\n}\n.btn.disabled,\n.btn[disabled] {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n.btn.active[disabled] {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n  background-color: #dadada !important;\n  color: #6f6f6f !important;\n}\n.btn-mini {\n  line-height: 1em;\n  padding: 6px;\n}\n.btn-mini [class^='icofont-'],\n.btn-mini [class*=' icofont-'] {\n  font-size: 20px;\n}\n.btn-md {\n  padding: 15px 6px;\n  font-size: 12px;\n  line-height: 1.33;\n}\n.btn-lg {\n  font-size: 16px;\n  padding: 15px;\n}\n.btn-group-lg > .btn {\n  font-size: 16px;\n}\n.btn-xlarge {\n  padding: 15px 25px;\n  font-size: 24px;\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  border-radius: 3px;\n}\n.btn-brand-1,\n.btn-primary {\n  background: #ff7f00;\n  border: none;\n  background-image: linear-gradient(10deg, #f96b00 0%, #ffb100 100% 100%);\n  color: #fff;\n  font-weight: 600;\n}\n.btn-brand-1:hover,\n.btn-primary:hover {\n  background-image: linear-gradient(10deg, #f47516 0%, #ffbc22 100% 100%);\n  color: #fff;\n}\n.btn-brand-1:active,\n.btn-primary:active,\n.btn-brand-1:focus,\n.btn-primary:focus {\n  background: #ff7f00;\n  background-image: linear-gradient(10deg, #e26202 0%, #ffb000 100% 100%);\n  color: #fff;\n}\n.btn-brand-1.disabled,\n.btn-primary.disabled,\n.btn-brand-1[disabled],\n.btn-primary[disabled] {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n.btn-brand-2 {\n  position: relative;\n  cursor: pointer;\n  color: #fff;\n  background: #303232;\n  background-image: 0;\n  text-shadow: none;\n  font-weight: normal;\n}\n.btn-brand-2:hover,\n.btn-brand-2:focus {\n  background: #414444;\n  color: #fff;\n}\n.btn-brand-2.active,\n.btn-brand-2:active,\n.open > .dropdown-toggle.btn-brand-2 {\n  background-color: #171818;\n  color: #fff;\n}\n.btn-brand-2:active,\n.btn-brand-2.active,\n.open > .dropdown-toggle.btn-brand-2 {\n  background-image: none;\n}\n.btn-brand-2:before {\n  display: block;\n  position: absolute;\n  padding-top: 10px;\n  top: 10px;\n}\n.btn-brand-2.disabled,\n.btn-brand-2[disabled],\nfieldset[disabled] .btn-brand-2,\n.btn-brand-2.disabled:hover,\n.btn-brand-2[disabled]:hover,\nfieldset[disabled] .btn-brand-2:hover,\n.btn-brand-2.disabled:focus,\n.btn-brand-2[disabled]:focus,\nfieldset[disabled] .btn-brand-2:focus,\n.btn-brand-2.disabled:active,\n.btn-brand-2[disabled]:active,\nfieldset[disabled] .btn-brand-2:active,\n.btn-brand-2.disabled.active,\n.btn-brand-2[disabled].active,\nfieldset[disabled] .btn-brand-2.active {\n  background-color: #303232;\n  border-color: transparent;\n}\n.btn-brand-2 .badge {\n  color: #303232;\n  background-color: #fff;\n}\n.btn-brand-2.disabled,\n.btn-brand-2[disabled],\n.btn-brand-2.disabled:hover,\n.btn-brand-2[disabled]:hover,\n.btn-brand-2.disabled:focus,\n.btn-brand-2[disabled]:focus,\n.btn-brand-2.disabled:active,\n.btn-brand-2[disabled]:active,\n.btn-brand-2.disabled.active,\n.btn-brand-2[disabled].active {\n  background-color: #303232;\n  border-color: transparent;\n}\n.btn-brand-3 {\n  color: #a5a5a5;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-color: #cccccc;\n}\n.btn-brand-3:hover,\n.btn-brand-3:focus,\n.btn-brand-3:active,\n.btn-brand-3.active,\n.open > .dropdown-toggle.btn-brand-3 {\n  color: #a5a5a5;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-color: #adadad;\n}\n.btn-brand-3:active,\n.btn-brand-3.active,\n.open > .dropdown-toggle.btn-brand-3 {\n  background-image: none;\n}\n.btn-brand-3.disabled,\n.btn-brand-3[disabled],\nfieldset[disabled] .btn-brand-3,\n.btn-brand-3.disabled:hover,\n.btn-brand-3[disabled]:hover,\nfieldset[disabled] .btn-brand-3:hover,\n.btn-brand-3.disabled:focus,\n.btn-brand-3[disabled]:focus,\nfieldset[disabled] .btn-brand-3:focus,\n.btn-brand-3.disabled:active,\n.btn-brand-3[disabled]:active,\nfieldset[disabled] .btn-brand-3:active,\n.btn-brand-3.disabled.active,\n.btn-brand-3[disabled].active,\nfieldset[disabled] .btn-brand-3.active {\n  background-color: rgba(0, 0, 0, 0.03);\n  border-color: #cccccc;\n}\n.btn-brand-3 .badge {\n  color: rgba(0, 0, 0, 0.03);\n  background-color: #a5a5a5;\n}\n.btn-brand-3.disabled,\n.btn-brand-3[disabled],\n.btn-brand-3.disabled:hover,\n.btn-brand-3[disabled]:hover,\n.btn-brand-3.disabled:focus,\n.btn-brand-3[disabled]:focus,\n.btn-brand-3.disabled:active,\n.btn-brand-3[disabled]:active,\n.btn-brand-3.disabled.active,\n.btn-brand-3[disabled].active {\n  background-color: rgba(0, 0, 0, 0.03);\n  border-color: #cccccc;\n}\n.btn-brand-3:active,\n.btn-brand-3 .active {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.btn-brand-4 {\n  background: #ff7f00;\n  background-image: linear-gradient(208deg, #ffba00 0%, #ff8f2a 100%);\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);\n  color: #303232;\n  border: none;\n}\n.btn-brand-4:hover {\n  background: #ff7f00;\n  background-image: linear-gradient(208deg, #f9c539 0%, #f99c47 100%);\n}\n.btn-brand-4:active,\n.btn-brand-4:focus {\n  background-image: linear-gradient(208deg, #f0b413 0%, #ee8321 100%);\n}\n.btn-brand-4.disabled,\n.btn-brand-4[disabled] {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n.btn-brand-5 {\n  color: #303232;\n  background-color: #f9f9f9;\n  border-color: #d3d3d3;\n}\n.btn-brand-5:hover,\n.btn-brand-5:focus,\n.btn-brand-5:active,\n.btn-brand-5.active,\n.open > .dropdown-toggle.btn-brand-5 {\n  color: #303232;\n  background-color: #e0e0e0;\n  border-color: #b4b4b4;\n}\n.btn-brand-5:active,\n.btn-brand-5.active,\n.open > .dropdown-toggle.btn-brand-5 {\n  background-image: none;\n}\n.btn-brand-5.disabled,\n.btn-brand-5[disabled],\nfieldset[disabled] .btn-brand-5,\n.btn-brand-5.disabled:hover,\n.btn-brand-5[disabled]:hover,\nfieldset[disabled] .btn-brand-5:hover,\n.btn-brand-5.disabled:focus,\n.btn-brand-5[disabled]:focus,\nfieldset[disabled] .btn-brand-5:focus,\n.btn-brand-5.disabled:active,\n.btn-brand-5[disabled]:active,\nfieldset[disabled] .btn-brand-5:active,\n.btn-brand-5.disabled.active,\n.btn-brand-5[disabled].active,\nfieldset[disabled] .btn-brand-5.active {\n  background-color: #f9f9f9;\n  border-color: #d3d3d3;\n}\n.btn-brand-5 .badge {\n  color: #f9f9f9;\n  background-color: #303232;\n}\n.btn-brand-5.disabled,\n.btn-brand-5[disabled],\n.btn-brand-5.disabled:hover,\n.btn-brand-5[disabled]:hover,\n.btn-brand-5.disabled:focus,\n.btn-brand-5[disabled]:focus,\n.btn-brand-5.disabled:active,\n.btn-brand-5[disabled]:active,\n.btn-brand-5.disabled.active,\n.btn-brand-5[disabled].active {\n  background-color: #f9f9f9;\n  border-color: #d3d3d3;\n}\n.btn-brand-5:active,\n.btn-brand-5 .active {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  background-color: #bfbfbf;\n}\n.btn-back {\n  padding: 9px 10px;\n  position: relative;\n  min-width: 80px;\n  width: auto;\n  margin-left: 15px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n  background-color: #373a3a;\n  border-color: #373a3a;\n}\n.btn-back:hover,\n.btn-back:active,\n.btn-back:focus {\n  background-color: #242525;\n  border-color: #242525;\n}\n.btn-back:after,\n.btn-back:before,\n.btn-back:after:active,\n.btn-back:before:active {\n  content: '';\n  position: absolute;\n  top: 50%;\n  margin-top: -19px;\n  border-top: 20px solid transparent;\n  border-bottom: 19px solid transparent;\n  border-right: 1em solid;\n  left: -0.98em;\n  padding-top: 0;\n}\n.btn-back:before {\n  z-index: 2;\n  border-right-color: inherit;\n}\n.btn-back:hover:before {\n  border-right-color: inherit;\n}\n.btn-delete {\n  background-color: inherit;\n  color: red;\n  margin-left: 30px;\n  margin-top: 3px;\n}\n.btn-delete:hover {\n  background-color: red;\n  color: white;\n}\n.btn.btn-message {\n  background-image: none;\n}\n.btn.btn-message:hover,\n.btn.btn-message:active,\n.btn.btn-message.active,\n.btn.btn-message:focus {\n  box-shadow: none;\n  background-image: none;\n  cursor: default;\n}\n.btn.btn-message.success {\n  background-color: #dff0d8;\n  color: #3c763d;\n  font-size: 1.2em;\n  border: 1px solid #d6e9c6;\n}\n.btn-group > .btn {\n  cursor: pointer;\n  background-color: white;\n  border: 1px solid #cccccc;\n  color: #555555;\n}\n.btn-group > .btn:hover {\n  background-color: #f2f2f2;\n}\n.btn-group > .btn + .btn {\n  border-left: 1px solid #cccccc;\n}\n.btn-group > .btn:first-child {\n  border-right: 1px solid #cccccc;\n}\n.btn-group > .btn.active {\n  text-shadow: none;\n  -webkit-box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.5);\n  box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.5);\n  color: black;\n  background-color: #eeeeee;\n}\n.report-toggles .btn-group > .btn {\n  background: white;\n  color: #777777;\n}\n.report-toggles .btn-group > .btn:hover {\n  background-color: #f2f2f2;\n  color: #333333;\n}\n.report-toggles .btn-group > .btn.active {\n  background-color: #555555;\n  color: #f9f9f9;\n  font-weight: 600;\n  cursor: default;\n  border-color: transparent;\n  box-shadow: inset -1px -1px 0 rgba(0, 0, 0, 0.3);\n}\n.report-toggles .btn-group.btn-group-sm {\n  padding-top: 6px;\n}\n.nav-tabs a:hover,\n.nav-tabs > .active > a:hover,\n.nav-tabs > .active > a:focus {\n  color: #303232;\n}\n.nav-tabs > li {\n  margin-bottom: -2px;\n}\n.nav-tabs > li > a:hover {\n  background-color: #e5e5e5;\n  border-bottom: white;\n}\n.nav-tabs > li > a:active {\n  background-color: #dedede;\n  border-bottom: white;\n}\n.nav-tabs > li > a:focus {\n  outline: none;\n}\n.nav.nav-tabs li > a {\n  padding: 10px;\n}\n.tab-content {\n  margin-top: 5px;\n}\n.nav-pills > li {\n  margin-bottom: -2px;\n  border-radius: 0;\n}\n.nav-pills > li.active > a {\n  border-bottom: 3px solid #ff9003;\n  background-color: transparent;\n  color: #303232;\n  text-shadow: 0px 0px 0px black,\n        0px 0px 0px black,\n        0px 0px 0px black;\n}\n.nav-pills > li.active > a:hover {\n  background-color: transparent;\n  color: #303232;\n  border-bottom: 3px solid #ff9003;\n}\n.nav-pills > li.active > a:focus {\n  background-color: transparent;\n  color: #303232;\n}\n.nav-pills > li > a {\n  cursor: pointer;\n  border-bottom: 3px solid transparent;\n  border-radius: 0;\n  background-color: transparent;\n  color: #303232;\n  font-size: 15px;\n}\n.nav-pills > li > a:hover {\n  background-color: #f7f7f7;\n  color: #303232;\n  border-bottom: 3px solid #cccccc;\n}\n.nav-pills > li > a:active {\n  background-color: #f2f2f2;\n  border-bottom: white;\n  border-bottom: 3px solid #f38800;\n}\n.nav-pills > li > a:focus {\n  outline: none;\n}\n.nav.nav-pills li > a {\n  padding: 10px 14px;\n}\n.tab-content {\n  margin-top: 5px;\n}\n.pills {\n  margin-bottom: 20px;\n  background-color: #f2f2f2;\n  border: 1px solid #e5e5e5;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.pills .btn {\n  cursor: pointer;\n  border-radius: 0;\n  background-color: #f2f2f2;\n  color: #303232;\n  border-right: 1px solid #e5e5e5;\n  padding: 5px 6px;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 1em;\n}\n.pills .btn:focus {\n  outline: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.pills .btn:hover {\n  background-color: #e9e9e9;\n}\n.pills .btn:active,\n.pills .btn.active {\n  background-color: #494c4c;\n  color: #ff9003;\n  font-weight: 400;\n}\n.pills .btn:active small,\n.pills .btn.active small {\n  color: #b5b0b0;\n}\n.pills .btn:nth-child(4),\n.pills .btn:nth-child(4).active {\n  border-right: none;\n}\n.pills .btn small {\n  color: #555555;\n  display: block;\n  font-size: 0.85em;\n}\n.pills .btn.active {\n  -webkit-box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.6);\n  box-shadow: inset 0px 1px 1px rgba(0, 0, 0, 0.6);\n  border-right-color: #b2b2b2;\n}\n.badge {\n  background-color: #e0e0e0;\n  color: #494c4c;\n  margin-left: 5px;\n  font-weight: 600;\n  -webkit-border-radius: 5px;\n  -moz-border-radius: 5px;\n  border-radius: 5px;\n}\n.badge.badge-inverse {\n  background-color: rgba(0, 0, 0, 0.8);\n  color: #fff;\n}\n.badge.badge-header {\n  background-color: rgba(217, 0, 0, 0.8);\n  color: #fff;\n  position: absolute;\n  top: 14px;\n  right: 24%;\n  padding: 1px 4px;\n  font-size: 11px;\n}\n.badge .badge-left-tip {\n  width: 0;\n  height: 0;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  border-right: 6px solid #e0e0e0;\n  position: absolute;\n  left: -5px;\n  bottom: 0;\n  top: 0;\n  margin: auto;\n}\n.label.label-title {\n  color: #303232;\n  font-weight: 700;\n  text-align: left;\n  text-shadow: none;\n  display: block;\n  margin-bottom: 5px;\n  font-size: 1em;\n  padding: 4px 10px 2px 0;\n  border-radius: 0;\n}\n.well {\n  background-color: #ffffff;\n  -webkit-box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 6px inset;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 6px inset;\n  -webkit-border-radius: 4px;\n  -moz-border-radius: 4px;\n  border-radius: 4px;\n  *zoom: 1;\n}\n.well:before,\n.well:after {\n  content: \" \";\n  display: table;\n}\n.well:after {\n  clear: both;\n}\n.well:before,\n.well:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.well:after {\n  clear: both;\n}\n.title-divider {\n  position: relative;\n  text-align: center;\n  font-weight: 600;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.title-divider span {\n  padding: 0 15px;\n  position: relative;\n  color: #333333;\n  text-transform: uppercase;\n  font-size: 11;\n  font-weight: 700;\n}\n.title-divider:before {\n  display: block;\n  content: '';\n  height: 1px;\n  background: -webkit-gradient(linear, 0 0, 100% 0, from(rgba(0, 0, 0, 0)), color-stop(0.5, #999), color-stop(0.5, #999), to(rgba(0, 0, 0, 0)));\n  background: -webkit-linear-gradient(left, rgba(0, 0, 0, 0), #999, #999, rgba(0, 0, 0, 0));\n  background: -moz-linear-gradient(left, rgba(0, 0, 0, 0), #999, #999, rgba(0, 0, 0, 0));\n  background: -o-linear-gradient(left, rgba(0, 0, 0, 0), #999, #999, rgba(0, 0, 0, 0));\n  background: linear-gradient(left, rgba(0, 0, 0, 0), #999, #999, rgba(0, 0, 0, 0));\n  position: absolute;\n  top: 50%;\n  width: 100%;\n}\n.inlay {\n  max-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  -webkit-transition: max-height 0.5s cubic-bezier(0, 1.05, 0, 1);\n  transition: max-height 0.5s cubic-bezier(0, 1.05, 0, 1);\n  width: 100%;\n}\n.inlay.inlay-open {\n  -webkit-transition: max-height 1s cubic-bezier(0.1, 1.05, 0, 1);\n  transition: max-height 1s cubic-bezier(0.1, 1.05, 0, 1);\n  max-height: 3000px;\n}\n.inlay.inlay-open-60 {\n  max-height: 60px;\n  -webkit-transition: max-height 0.2s ease-in-out;\n  transition: max-height 0.2s ease-in-out;\n}\n.popover {\n  display: block;\n  font-size: 13px;\n  z-index: 1061;\n}\n.popover ul {\n  padding-left: 15px;\n}\n.popover.popover-field {\n  z-index: 1070;\n}\n.popover.popover-field.bottom {\n  position: relative;\n  top: -3px !important;\n  left: 0 !important;\n  max-width: none;\n  width: 100%;\n}\n.popover.popover-error {\n  background-color: rgba(194, 51, 51, 0.85);\n  border-color: rgba(194, 51, 51, 0.85);\n  z-index: 19;\n  color: rgba(255, 255, 255, 0.8);\n  min-height: 46px;\n  display: flex !important;\n  align-items: center;\n}\n.popover.popover-error.popover-compact {\n  min-width: 200px;\n}\n.popover.popover-error.popover-compact .popover-content {\n  padding: 3px 6px;\n  font-size: 12px;\n}\n.popover.popover-error.right > .arrow:after,\n.popover.popover-error-and-content.right > .arrow:after {\n  border-right-color: #c95150;\n}\n.popover.popover-error.bottom > .arrow:after,\n.popover.popover-error-and-content.bottom > .arrow:after {\n  border-bottom-color: #c95150;\n}\n.popover.popover-error.right > .arrow,\n.popover.popover-error-and-content.right > .arrow {\n  top: 20px !important;\n}\n.popover-dark {\n  background: rgba(48, 50, 50, 0.97);\n  color: #eeeeee;\n}\n.popover-dark .popover-title {\n  background: rgba(48, 50, 50, 0.97);\n  border: rgba(36, 37, 37, 0.97);\n  color: #cdcdcd;\n  font-size: 18px;\n}\n.popover-dark.left .arrow {\n  border-left-color: rgba(48, 50, 50, 0.97);\n}\n.popover-dark.left .arrow:after {\n  border-left-color: transparent;\n}\n.popover-dark.right .arrow {\n  border-right-color: rgba(48, 50, 50, 0.97);\n}\n.popover-dark.right .arrow:after {\n  border-right-color: transparent;\n}\n.popover-dark .nav-pills {\n  font-size: 16px;\n}\n.nav-pills.nav-pills-popover {\n  -webkit-box-shadow: 0 4px 10px #f2f2f2;\n  box-shadow: 0 4px 10px #f2f2f2;\n  z-index: 1;\n  position: relative;\n}\n.nav-pills.nav-pills-popover li {\n  width: 50%;\n  margin: 0;\n  overflow: hidden;\n}\n.nav-pills.nav-pills-popover li:first-child > a {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n.nav-pills.nav-pills-popover li:last-child > a {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n.nav-pills.nav-pills-popover li + li {\n  margin: 0;\n}\n.nav-pills.nav-pills-popover li > a {\n  border-radius: 0;\n  text-align: center;\n  color: #303232;\n  padding: 15px 20px;\n  font-weight: 600;\n  font-size: 13px;\n  line-height: 1em;\n  background-color: #e9e9e9;\n}\n.nav-pills.nav-pills-popover li > a:focus {\n  outline: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.nav-pills.nav-pills-popover li > a:hover {\n  background-color: #e0e0e0;\n}\n.nav-pills.nav-pills-popover li > a:active,\n.nav-pills.nav-pills-popover li > a.active {\n  background-color: #494c4c;\n  color: #ff9003;\n  font-weight: 400;\n}\n.nav-pills.nav-pills-popover > .active > a,\n.nav-pills.nav-pills-popover > .active > a:hover,\n.nav-pills.nav-pills-popover > .active > a:focus {\n  background-color: #494c4c;\n  color: #ff9003;\n  font-weight: 400;\n}\n.tab-content > .tab-pane,\n.pill-content > .pill-pane {\n  overflow: hidden;\n  padding: 0 10px;\n}\n.input-lg,\n.form-group-lg textarea.form-control {\n  height: auto;\n  width: 100%;\n}\n.break-word {\n  word-wrap: break-word;\n}\n.float-right {\n  float: right;\n}\n.flex-center {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n.font-weight-700 {\n  font-weight: 700;\n}\n.container-fluid.core-container {\n  margin-left: 0;\n  margin-right: 0;\n  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n}\n.sidebar > .spacer {\n  height: 5px;\n}\n#intercom-container .intercom-launcher {\n  right: 10px !important;\n}\n#intercom-container .intercom-powered-by {\n  visibility: hidden !important;\n}\n.content {\n  margin-top: 0;\n  padding-bottom: 50px;\n  background: white;\n  border: none;\n  position: relative;\n  z-index: auto;\n  min-height: 100vh;\n}\n.settings-company-logo img {\n  max-height: 164px;\n}\n.header {\n  background-color: #303232;\n  background-image: none;\n  border-bottom: none;\n}\n.header .username {\n  color: #eeeeee;\n  line-height: 1em;\n  margin-right: 10px;\n}\n.header .top-nav-buttons {\n  position: relative;\n  margin-right: 20px;\n  float: right;\n  right: 0;\n}\n.header .btn-group {\n  margin-top: -5px;\n}\n.content-header-h1 {\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 36px;\n  padding-top: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.content-header {\n  background: #f9f9f9;\n  border-bottom: 1px solid #dddddd;\n  *zoom: 1;\n  /* Style the secondary header bar */\n  /* Style header metrics like the ones on the refine screen */\n}\n.content-header:before,\n.content-header:after {\n  content: \" \";\n  display: table;\n}\n.content-header:after {\n  clear: both;\n}\n.content-header:before,\n.content-header:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.content-header:after {\n  clear: both;\n}\n.content-header h1 {\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 400;\n  margin: 5px 0 0;\n}\n.content-header h1.vertical-center {\n  margin-top: 12px;\n  float: left;\n}\n.content-header small {\n  font-size: 13px;\n  color: #555555;\n  line-height: 18px;\n  font-weight: 400;\n  margin: 2px 0;\n}\n.content-header h4 {\n  margin-bottom: 10px;\n}\n.content-header .nav {\n  margin: 1px 0 0px;\n}\n.content-header .nav-tabs {\n  border-bottom: none;\n}\n.content-header .header-btn-right {\n  margin-top: 5px;\n}\n.content-header .header-account {\n  line-height: 1.2em;\n  margin-top: 3px;\n  margin-right: 10px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 260px;\n}\n.content-header .header-account i {\n  margin-left: 6px;\n}\n.content-header .app-logo {\n  margin: 13px 2px 0 0;\n  float: left;\n}\n.content-header .app-logo img {\n  width: 93px;\n  height: auto;\n}\n.content-header .navbar-group {\n  float: none;\n  display: block;\n}\n.content-header .navbar-group .header-navbar {\n  width: 25%;\n}\n.content-header .header-navbar {\n  height: 46px;\n  position: relative;\n  float: left;\n}\n.content-header .header-navbar .nav-tabs > li > a {\n  line-height: 44px;\n  margin: auto;\n  padding: 0 15px;\n}\n.content-header .header-navbar .badge {\n  float: right;\n}\n.content-header .header-navbar .btn-error [class*=' ico-'],\n.content-header .header-navbar .btn-error [class^='ico-'] {\n  color: #e9001d;\n}\n.content-header .header-navbar .btn-warning [class*=' ico-'],\n.content-header .header-navbar .btn-warning [class^='ico-'] {\n  color: #ff9003;\n}\n.content-header .btn.btn-header {\n  position: relative;\n  border-color: transparent;\n  border-top: none;\n  border-bottom: none;\n  border-right: none;\n  background-color: inherit;\n  margin: auto;\n  height: 100%;\n  width: auto;\n  min-width: 60px;\n  padding: 2.5px 12px;\n  font-size: 12px;\n  color: #303232;\n  -webkit-border-radius: 0;\n  -moz-border-radius: 0;\n  border-radius: 0;\n}\n.content-header .btn.btn-header [class*=' ico-'],\n.content-header .btn.btn-header [class^='ico-'] {\n  font-size: 16px;\n  display: block;\n  float: none;\n  clear: both;\n}\n.content-header .btn.btn-header:hover {\n  background-color: #e9e9e9;\n}\n.content-header .btn.btn-header:hover .arrow-right {\n  border-left-color: #e9e9e9;\n}\n.content-header .btn.btn-header:hover .arrow-right-n1,\n.content-header .btn.btn-header:hover .arrow-right-n2 {\n  border-right-color: #e9e9e9;\n}\n.content-header .btn.btn-header:active,\n.content-header .btn.btn-header.active,\n.content-header .btn.btn-header:focus {\n  color: #303232;\n  box-shadow: none;\n  background-color: #e0e0e0;\n}\n.content-header .btn.btn-header:active .arrow-right,\n.content-header .btn.btn-header.active .arrow-right,\n.content-header .btn.btn-header:focus .arrow-right {\n  border-left-color: #e0e0e0;\n}\n.content-header .btn.btn-header .arrow-right {\n  width: 0;\n  height: 0;\n  border-top: 23px solid transparent;\n  border-bottom: 23px solid transparent;\n  border-left: 14px solid #f2f2f2;\n  float: right;\n  position: absolute;\n  right: -13px;\n  top: 0;\n  z-index: 10;\n}\n.content-header .btn.btn-header .arrow-right.arrow-right-border {\n  right: -14px;\n  border-left-color: #d9d9d9;\n  z-index: 9;\n}\n.content-header .btn.btn-header.btn-lg {\n  font-size: 15px;\n  padding: 14px 13px 13px 20px;\n}\n.content-header .btn.btn-header.btn-lg .caret {\n  margin: auto 0 auto 8px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 10px;\n  font-size: 24px;\n  border-left-width: 5px;\n  border-right-width: 5px;\n  border-top-width: 5px;\n  opacity: 0.7;\n}\n.content-header .btn.btn-header.btn-lg .badge {\n  margin: 2px 15px 0 10px;\n}\n.content-header .btn.btn-header.btn-side-left-handle {\n  margin: 0 5px 0 -15px;\n  font-size: 18px;\n  color: #7b8080;\n  padding: 13px 12px 12px;\n}\n.content-header ul.content-header-action {\n  text-align: center;\n  padding: 10px 10px 0px;\n}\n.content-header ul.content-header-action li .action-text {\n  margin: 5px 0 5px 5px;\n}\n.content-header ul.content-header-action li.divider {\n  height: 33px;\n}\n.content-header.content-header-2 {\n  border-bottom: 1px solid #fff;\n  background: #f2f2f2;\n}\n.content-header.content-header-2 .header-navbar > .btn,\n.content-header.content-header-2 .header-navbar > .btn-group > .btn {\n  border-left: none;\n}\n.content-header .header-metrics {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 3px;\n  padding-bottom: 3px;\n}\n.content-header .header-metrics .header-metric {\n  text-align: right;\n  margin-right: 20px;\n}\n.content-header .header-metrics .header-metric:last-child {\n  margin-right: 0;\n}\n.content-header .header-metrics .header-metric small {\n  display: block;\n  float: none;\n  clear: both;\n  color: #777777;\n  font-size: 0.8em;\n  margin: 0;\n  line-height: 1.2;\n}\n.header-instructions {\n  *zoom: 1;\n  margin: -2px -15px 20px -15px;\n  padding: 15px 15px 10px;\n  font-size: 16px;\n  -webkit-box-shadow: inset 0 -1px 4px rgba(0, 0, 0, 0.1);\n  box-shadow: inset 0 -1px 4px rgba(0, 0, 0, 0.1);\n  background-color: #f5f5f5;\n  font-size: 14px;\n  color: #333333;\n  position: relative;\n}\n.header-instructions:before,\n.header-instructions:after {\n  content: \" \";\n  display: table;\n}\n.header-instructions:after {\n  clear: both;\n}\n.header-instructions:before,\n.header-instructions:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.header-instructions:after {\n  clear: both;\n}\n.header-instructions h1,\n.header-instructions h2,\n.header-instructions h3 {\n  text-rendering: auto;\n  margin-bottom: 0.5em;\n}\n.popover {\n  z-index: 20;\n}\n.popover.popover-support {\n  top: auto !important;\n  bottom: 15px !important;\n}\n.popover.popover-support .arrow {\n  border-right-color: rgba(41, 42, 42, 0.97);\n  bottom: 5px;\n  left: -11px;\n  top: auto;\n}\n.popover.popover-settings {\n  top: auto !important;\n  bottom: 0px !important;\n}\n.popover.popover-settings > .arrow {\n  border-right-color: rgba(41, 42, 42, 0.97);\n  bottom: 20px;\n  left: -11px;\n  top: auto;\n}\n.popover.popover-leftnav {\n  left: 100%;\n  margin-left: 11px;\n  display: block;\n  z-index: 1063;\n  width: 220px;\n  border-radius: 3px;\n}\n.popover.popover-leftnav .popover-content {\n  padding: 0;\n}\n.popover.popover-leftnav .link-icon {\n  display: block;\n  float: left;\n  margin-right: 10px;\n  background-color: rgba(43, 45, 45, 0.97);\n  padding: 10px 12px 6px 8px;\n  height: 100%;\n}\n.popover.popover-leftnav .link-label {\n  display: block;\n  padding: 10px;\n  height: 100%;\n}\n.popover.popover-leftnav a {\n  height: 45px;\n  padding: 0;\n  font-size: 1em;\n  letter-spacing: 0em;\n  font-weight: 400;\n  display: block;\n  text-align: left;\n  color: #cdcdcd;\n  -webkit-transition: all 0.1s;\n  -o-transition: all 0.1s;\n  transition: all 0.1s;\n}\n.popover.popover-leftnav a:hover {\n  color: #fff;\n  background-color: rgba(43, 45, 45, 0.97);\n}\n.popover.popover-leftnav a:hover .link-icon {\n  background-color: rgba(31, 32, 32, 0.97);\n}\n.popover.popover-leftnav a:active {\n  color: #ff9003;\n  background-color: rgba(60, 63, 63, 0.97);\n}\n.popover.popover-leftnav a:active .link-icon {\n  background-color: rgba(48, 50, 50, 0.97);\n}\n.popover.popover-leftnav .list-footer {\n  border-top: 1px solid rgba(28, 29, 29, 0.97);\n  background-color: rgba(41, 42, 42, 0.97);\n  border-bottom: none;\n  font-size: 13px;\n  color: #999;\n  line-height: 1.2em;\n  font-weight: normal;\n  padding: 8px 0 6px 5px;\n  text-align: center;\n  cursor: default;\n}\n.popover.popover-header {\n  top: 46px;\n  width: 360px;\n  max-width: 360px;\n  background-color: #f9f9f9;\n  border-radius: 2px;\n  border: 1px solid transparent;\n  box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.4);\n  border-radius: 4px;\n}\n.popover.popover-header.popover-debug {\n  max-width: none;\n}\n.popover.popover-header.bottom .arrow {\n  border-bottom-color: #c6c6c6;\n}\n.popover.popover-header.bottom .arrow:after {\n  border-bottom-color: #f9f9f9;\n}\n.popover .popover-scrollable-content {\n  overflow-y: scroll;\n  -webkit-overflow-scrolling: touch;\n}\n.side-left {\n  position: fixed;\n  z-index: 1062;\n  left: 0;\n  overflow: visible;\n  float: left;\n  width: 60px;\n  height: 100%;\n  text-align: center;\n  border: none;\n  background-color: #303232;\n  background-image: none;\n  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n}\n.side-left .btn-calculate-job {\n  cursor: pointer;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 5px 4px;\n  border-radius: 4px;\n  margin: 5px 3px;\n  width: 54px;\n}\n.side-left .btn-calculate-job:not(disabled),\n.side-left .btn-calculate-job:not([disabled]) {\n  background: #ff7f00;\n  background-image: linear-gradient(208deg, #ffba00 0%, #ff8f2a 100%);\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);\n  color: #303232;\n  border: none;\n}\n.side-left .btn-calculate-job:not(disabled):hover,\n.side-left .btn-calculate-job:not([disabled]):hover {\n  background: #ff7f00;\n  background-image: linear-gradient(208deg, #f9c539 0%, #f99c47 100%);\n}\n.side-left .btn-calculate-job:not(disabled):active,\n.side-left .btn-calculate-job:not([disabled]):active,\n.side-left .btn-calculate-job:not(disabled):focus,\n.side-left .btn-calculate-job:not([disabled]):focus {\n  background-image: linear-gradient(208deg, #f0b413 0%, #ee8321 100%);\n}\n.side-left .btn-calculate-job:not(disabled).disabled,\n.side-left .btn-calculate-job:not([disabled]).disabled,\n.side-left .btn-calculate-job:not(disabled)[disabled],\n.side-left .btn-calculate-job:not([disabled])[disabled] {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n.side-left .btn-calculate-job.disabled,\n.side-left .btn-calculate-job[disabled] {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n.side-left .btn-calculate-job .isolate-spinner {\n  height: 27px;\n  overflow: hidden;\n}\n.signup-form {\n  margin-top: 50px;\n}\n.form-paragraph {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n.utility-bills .row > select:first-child,\n.utility-bills .row > input:first-child,\n.utility-bills .row > .input-append:first-child {\n  margin-left: 20px;\n}\n.utility-bills .input-start-date {\n  width: 75px;\n}\n.utility-bills .input-date {\n  width: 102px;\n}\n.utility-bills select {\n  width: 194px;\n  margin-bottom: 10px;\n}\n#js-calculate-div {\n  height: 15px;\n  padding-top: 13px;\n}\n/* Remove / Tweak Shadow DOM elements */\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n/* Rotate icons when class is added (by javascript) */\n.rotate-clockwise {\n  transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  transition: 0.2s;\n  -webkit-transition: 0.2s;\n}\n.rotate-counterclockwise {\n  transform: rotate(0deg);\n  -webkit-transform: rotate(0deg);\n  transition: 0.2s;\n  -webkit-transition: 0.2s;\n}\n.rotate-180 {\n  transform: rotate(180deg);\n  -webkit-transform: rotate(180deg);\n  display: block;\n}\n/* Overwrite themes*/\n.solid-grey {\n  background: #ccc;\n  color: #333;\n}\n.spin-box-container {\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 9999;\n  position: fixed;\n  margin: auto;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n.circle {\n  width: 80px;\n  height: 80px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  border-radius: 40px;\n  box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  border: solid 10px rgba(48, 50, 50, 0.15);\n  border-top-color: #ff9003;\n  -webkit-animation: loader-spin 0.75s infinite linear;\n}\n@-webkit-keyframes loader-spin {\n  100% {\n    transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -webkit-transform: rotate(360deg);\n  }\n}\n.loader-wrap {\n  width: 20px;\n  height: 20px;\n  position: relative;\n  flex-shrink: 0;\n}\n.body-loader {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  border-radius: 50%;\n  border: 2px solid rgba(0, 0, 0, 0.2);\n  border-left-color: #ffffff;\n  animation: utilitySpin 1.1s linear infinite;\n  will-change: transform;\n  contain: layout paint;\n  /* hide text safely */\n  color: transparent;\n  white-space: nowrap;\n  pointer-events: none;\n}\n@keyframes utilitySpin {\n  to {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n}\n/* CARD SPINNER */\n.loader-spinner {\n  display: flex;\n  position: relative;\n  width: 42px;\n  height: 42px;\n}\n.loader-spinner div {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 42px;\n  height: 42px;\n  border: 5px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n}\n.loader-spinner div:not(:nth-child(1)) {\n  clip-path: polygon(50% 50%, 0 0, 80% 0);\n  border: 5px solid #f56600;\n  animation: loader-spinner_spin 1.4s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n}\n.loader-spinner div:nth-child(2) {\n  animation-delay: 0s;\n}\n.loader-spinner div:nth-child(3) {\n  animation-delay: -0.06s;\n}\n.loader-spinner div:nth-child(4) {\n  animation-delay: -0.11s;\n}\n.loader-spinner div:nth-child(5) {\n  animation-delay: -0.17s;\n}\n.loader-spinner div:nth-child(6) {\n  animation-delay: -0.22s;\n}\n@keyframes loader-spinner_spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.muted {\n  opacity: 0.75;\n}\n.clickable {\n  cursor: pointer;\n}\n.visibility-hidden {\n  visibility: hidden;\n}\n.link-disabled {\n  color: #777777;\n  cursor: not-allowed;\n}\n.no-float {\n  float: none !important;\n}\n.no-relative {\n  position: static;\n}\n.no-gutter-al {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.no-gutter-left-al {\n  padding-left: 0px;\n}\n.no-gutter-right-al {\n  padding-right: 0px;\n}\n.col-no-gutter {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.col-no-left-gutter {\n  padding-left: 0;\n}\n.col-no-right-gutter {\n  padding-right: 0;\n}\n.scroll-past-200 {\n  max-height: 200px;\n  overflow: scroll;\n}\n.ma-tb-5 {\n  margin-top: 5px !important;\n  margin-bottom: 5px !important;\n}\n.ma-bo-5 {\n  margin-bottom: 5px !important;\n}\n.ma-tb-10 {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n}\n.ma-tb-20 {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.ma-bo-20 {\n  margin-bottom: 20px;\n}\n.ma-to-10 {\n  margin-top: 10px;\n}\n.ma-to-20 {\n  margin-top: 20px;\n}\n.form-actions {\n  margin-top: 30px;\n}\n.error-page .box-container {\n  border-radius: 4px;\n  background-color: #f7f7f7;\n  padding: 22px 22px 40px;\n  margin: 45px 0 40px;\n}\n.error-page .box-container .error-code {\n  font-size: 1.125em;\n  line-height: 24px;\n  color: #333333;\n  float: right;\n  border-radius: 6px;\n  background-color: rgba(0, 0, 0, 0.08);\n  padding: 3px 8px;\n}\n.error-page .box-container h1 {\n  margin-top: 0;\n  font-size: 24px;\n  font-weight: 700;\n}\n.error-page .box-container p {\n  font-size: 16px;\n  line-height: 22px;\n}\n.snugg-pro-footer-icon {\n  display: inline-block;\n  width: auto;\n  border-radius: 12px;\n  padding: 12px;\n  box-shadow: inset 0 3px 4px 2px rgba(0, 0, 0, 0.06), inset 0 -3px 4px 2px rgba(255, 255, 255, 0.88);\n  margin: 50px 0 10px;\n}\n.snugg-pro-footer-icon img {\n  opacity: 0.95;\n}\n/* Extra small devices (phones, less than 768px) */\n/* No media query since this is the default in Bootstrap */\n/* ONLY extra small devices (phones less than 768px) */\n@media (max-width: 767px) {\n  .xs-ma-bo-20 {\n    margin-bottom: 20px;\n  }\n  .xs-ma-bo-40 {\n    margin-bottom: 40px;\n  }\n  .col-xs-no-gutter {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n  .col-xs-no-left-gutter {\n    padding-left: 0px;\n  }\n  .col-xs-no-right-gutter {\n    padding-right: 0px;\n  }\n  .xs-no-relative {\n    position: static !important;\n  }\n  .nav-tabs-xs-compact.nav.nav-tabs {\n    font-size: 0.8em;\n  }\n  .nav-tabs-xs-compact.nav.nav-tabs > li > a {\n    padding: 12px 5px;\n  }\n  .side-left {\n    -ms-transform: translateX(-60px);\n    transform: translateX(-60px);\n    -webkit-transform: translateX(-60px);\n    /** Chrome & Safari **/\n    -o-transform: translateX(-60px);\n    /** Opera **/\n    -moz-transform: translateX(-60px);\n    /** Firefox **/\n  }\n  .push-left .container-fluid.core-container {\n    -ms-transform: translateX(60px);\n    transform: translateX(60px);\n    -webkit-transform: translateX(60px);\n    /** Chrome & Safari **/\n    -o-transform: translateX(60px);\n    /** Opera **/\n    -moz-transform: translateX(60px);\n    /** Firefox **/\n  }\n  .push-left .side-left {\n    -ms-transform: translateX(0);\n    transform: translateX(0);\n    -webkit-transform: translateX(0);\n    /** Chrome & Safari **/\n    -o-transform: translateX(0);\n    /** Opera **/\n    -moz-transform: translateX(0);\n    /** Firefox **/\n  }\n  .push-left .push-menu-overlay {\n    position: fixed;\n    cursor: pointer;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 1060;\n    background-color: rgba(255, 255, 255, 0.5);\n  }\n  .form-control.input-header.rec-input-header {\n    font-size: 15px;\n    font-weight: 600;\n    min-width: 255px;\n  }\n}\n/* Small devices (tablets, 768px and up) */\n@media (min-width: 768px) {\n  .container-fluid.core-container {\n    margin-left: 60px;\n    margin-right: 0;\n  }\n  .push-left .container-fluid.core-container {\n    margin-left: 60px;\n    margin-right: 0;\n  }\n  .push-left .side-left {\n    left: 0;\n  }\n  .push-left .push-menu-overlay {\n    display: none;\n  }\n  .col-sm-no-gutter {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .col-sm-no-left-gutter {\n    padding-left: 0;\n  }\n  .col-sm-no-right-gutter {\n    padding-right: 0;\n  }\n  .side-left {\n    left: 0;\n    transform: translateX(0);\n  }\n  .content-header .app-logo {\n    margin: 11px 10px 0 0;\n  }\n  .content-header .btn.btn-new-job {\n    border-left: 0;\n  }\n  .content-header .navbar-group {\n    float: right;\n    display: block;\n  }\n  .content-header .navbar-group .header-navbar {\n    width: auto;\n  }\n  .content-header .header-navbar .btn-group.btn-group-sort {\n    border-right: 1px solid #d9d9d9;\n  }\n  .form-search .form-group {\n    margin-top: 4px;\n  }\n  .popover.popover-header {\n    right: 0;\n  }\n  .popover.popover-header .arrow {\n    left: auto;\n    right: 15px;\n  }\n  .form-group.form-group-two-rows label.control-label {\n    padding-top: 42px;\n  }\n  .form-control.input-header.rec-input-header {\n    min-width: 300px;\n  }\n  .modal-dialog.modal-lg {\n    min-width: 600px;\n    max-width: 90%;\n    width: auto;\n  }\n  .jl .snugg-select {\n    height: 46px;\n  }\n  .search-jobs.topmost-search-job-container {\n    width: 60px;\n  }\n}\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: 992px) {\n  .search-jobs.topmost-search-job-container {\n    width: auto;\n    max-width: 160px;\n  }\n}\n/* Large devices (desktops, 992px and up) */\n@media (min-width: 1200px) {\n  .search-jobs.topmost-search-job-container {\n    max-width: 260px;\n  }\n}\n/* ONLY extra short devices (phones less than 568px)  This is a fringe case*/\n@media (max-height: 589px) {\n  .popover.popover-support .arrow {\n    bottom: 3px;\n  }\n  .popover.popover-settings .arrow {\n    bottom: 30px;\n  }\n}\n.no-gutter-all {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n.no-gutter-left-all {\n  padding-left: 0px;\n}\n.no-gutter-right-all {\n  padding-right: 0px;\n}\n.margin-top-all-5 {\n  margin-top: 5;\n}\n.margin-bottom-all-5 {\n  margin-top: 5;\n}\n.margin-vertical-all-5 {\n  margin-top: 5;\n  margin-bottom: 5;\n}\n.margin-top-all-10 {\n  margin-top: 10;\n}\n.margin-bottom-all-10 {\n  margin-top: 10;\n}\n.margin-vertical-all-10 {\n  margin-top: 10;\n  margin-bottom: 10;\n}\n.margin-top-all-15 {\n  margin-top: 15;\n}\n.margin-bottom-all-15 {\n  margin-top: 15;\n}\n.margin-vertical-all-15 {\n  margin-top: 15;\n  margin-bottom: 15;\n}\n.margin-top-all-20 {\n  margin-top: 20;\n}\n.margin-bottom-all-20 {\n  margin-top: 20;\n}\n.margin-vertical-all-20 {\n  margin-top: 20;\n  margin-bottom: 20;\n}\n@media (max-width: 767px) {\n  .no-gutter-xs {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n  .no-gutter-left-xs {\n    padding-left: 0px;\n  }\n  .no-gutter-right-xs {\n    padding-right: 0px;\n  }\n  .margin-top-xs-5 {\n    margin-top: 5;\n  }\n  .margin-bottom-xs-5 {\n    margin-top: 5;\n  }\n  .margin-vertical-xs-5 {\n    margin-top: 5;\n    margin-bottom: 5;\n  }\n  .margin-top-xs-10 {\n    margin-top: 10;\n  }\n  .margin-bottom-xs-10 {\n    margin-top: 10;\n  }\n  .margin-vertical-xs-10 {\n    margin-top: 10;\n    margin-bottom: 10;\n  }\n  .margin-top-xs-15 {\n    margin-top: 15;\n  }\n  .margin-bottom-xs-15 {\n    margin-top: 15;\n  }\n  .margin-vertical-xs-15 {\n    margin-top: 15;\n    margin-bottom: 15;\n  }\n  .margin-top-xs-20 {\n    margin-top: 20;\n  }\n  .margin-bottom-xs-20 {\n    margin-top: 20;\n  }\n  .margin-vertical-xs-20 {\n    margin-top: 20;\n    margin-bottom: 20;\n  }\n}\n@media (min-width: 768px) {\n  .no-gutter-sm {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n  .no-gutter-left-sm {\n    padding-left: 0px;\n  }\n  .no-gutter-right-sm {\n    padding-right: 0px;\n  }\n  .margin-top-sm-5 {\n    margin-top: 5;\n  }\n  .margin-bottom-sm-5 {\n    margin-top: 5;\n  }\n  .margin-vertical-sm-5 {\n    margin-top: 5;\n    margin-bottom: 5;\n  }\n  .margin-top-sm-10 {\n    margin-top: 10;\n  }\n  .margin-bottom-sm-10 {\n    margin-top: 10;\n  }\n  .margin-vertical-sm-10 {\n    margin-top: 10;\n    margin-bottom: 10;\n  }\n  .margin-top-sm-15 {\n    margin-top: 15;\n  }\n  .margin-bottom-sm-15 {\n    margin-top: 15;\n  }\n  .margin-vertical-sm-15 {\n    margin-top: 15;\n    margin-bottom: 15;\n  }\n  .margin-top-sm-20 {\n    margin-top: 20;\n  }\n  .margin-bottom-sm-20 {\n    margin-top: 20;\n  }\n  .margin-vertical-sm-20 {\n    margin-top: 20;\n    margin-bottom: 20;\n  }\n}\n@media (min-width: 992px) {\n  .no-gutter-md {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n  .no-gutter-left-md {\n    padding-left: 0px;\n  }\n  .no-gutter-right-md {\n    padding-right: 0px;\n  }\n  .margin-top-md-5 {\n    margin-top: 5;\n  }\n  .margin-bottom-md-5 {\n    margin-top: 5;\n  }\n  .margin-vertical-md-5 {\n    margin-top: 5;\n    margin-bottom: 5;\n  }\n  .margin-top-md-10 {\n    margin-top: 10;\n  }\n  .margin-bottom-md-10 {\n    margin-top: 10;\n  }\n  .margin-vertical-md-10 {\n    margin-top: 10;\n    margin-bottom: 10;\n  }\n  .margin-top-md-15 {\n    margin-top: 15;\n  }\n  .margin-bottom-md-15 {\n    margin-top: 15;\n  }\n  .margin-vertical-md-15 {\n    margin-top: 15;\n    margin-bottom: 15;\n  }\n  .margin-top-md-20 {\n    margin-top: 20;\n  }\n  .margin-bottom-md-20 {\n    margin-top: 20;\n  }\n  .margin-vertical-md-20 {\n    margin-top: 20;\n    margin-bottom: 20;\n  }\n}\n@media (min-width: 1200px) {\n  .no-gutter-lg {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n  .no-gutter-left-lg {\n    padding-left: 0px;\n  }\n  .no-gutter-right-lg {\n    padding-right: 0px;\n  }\n  .margin-top-lg-5 {\n    margin-top: 5;\n  }\n  .margin-bottom-lg-5 {\n    margin-top: 5;\n  }\n  .margin-vertical-lg-5 {\n    margin-top: 5;\n    margin-bottom: 5;\n  }\n  .margin-top-lg-10 {\n    margin-top: 10;\n  }\n  .margin-bottom-lg-10 {\n    margin-top: 10;\n  }\n  .margin-vertical-lg-10 {\n    margin-top: 10;\n    margin-bottom: 10;\n  }\n  .margin-top-lg-15 {\n    margin-top: 15;\n  }\n  .margin-bottom-lg-15 {\n    margin-top: 15;\n  }\n  .margin-vertical-lg-15 {\n    margin-top: 15;\n    margin-bottom: 15;\n  }\n  .margin-top-lg-20 {\n    margin-top: 20;\n  }\n  .margin-bottom-lg-20 {\n    margin-top: 20;\n  }\n  .margin-vertical-lg-20 {\n    margin-top: 20;\n    margin-bottom: 20;\n  }\n}\n@media print {\n  .side-right-handle {\n    display: none;\n  }\n  .side-right.report-side-right,\n  .side-right.report-side-right.expanded {\n    right: -197px;\n    top: -10px;\n  }\n  .side-left {\n    top: -10px;\n  }\n}\n.custom-dropdown li {\n  margin-bottom: 2px;\n}\n.custom-dropdown li:last-child {\n  margin-bottom: 0;\n}\n.custom-dropdown li a {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px 12px;\n  font-size: 14px;\n  line-height: 1.42;\n  color: #111;\n  font-weight: 600;\n}\n.custom-dropdown li a span {\n  font-size: 12px;\n  color: #777;\n  display: inline-block;\n  font-weight: 500;\n}\n.custom-dropdown li.delete a {\n  color: #d92d20;\n}\n.custom-dropdown li.active {\n  background-color: #fff5e9;\n}\n.custom-dropdown li.active a {\n  background-color: #fff5e9;\n  color: #f56600;\n}\n.custom-dropdown li.active a span {\n  color: #555;\n}\n.custom-dropdown li.active a:hover {\n  color: #f56600;\n  background-color: #feecd6;\n}\n.custom-dropdown .dropdown-icon {\n  margin-left: 8px;\n  margin-top: -4px;\n  width: 16px;\n  height: 16px;\n  transition: all 200ms linear;\n}\n.custom-dropdown .dropdown-icon.rotated {\n  transform: rotate(-180deg);\n}\n.custom-dropdown button span {\n  transition: all 150ms ease;\n}\n.custom-dropdown:hover button span {\n  color: #f56600;\n}\n.settings-page-header {\n  width: 100%;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  display: flex;\n  justify-content: space-between;\n  gap: 24px;\n}\n.settings-page-title-container {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.incentive-template-empty-state {\n  background-color: #fff;\n  border: 1px dashed #ccc;\n  border-radius: 6px;\n  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  padding: 24px 16px 32px;\n  margin-bottom: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #333;\n}\n.incentives-list-empty-state {\n  background-color: #fff;\n  border: 1px dashed #ccc;\n  border-radius: 6px;\n  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n  padding: 24px 16px 32px;\n  margin-bottom: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #333;\n  border: 1px solid #eee;\n}\n.incentives-template-wrapper {\n  background-color: #f9f9f9;\n  padding-top: 20px;\n  padding-bottom: 40px;\n}\n.incentives-template-layout {\n  width: 800px;\n}\n.incentives-field-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 20px;\n}\n.incentives-field-container .form-group {\n  margin-bottom: 0;\n}\n.incentives-field-container span {\n  margin: 0 0 0 0 !important;\n  padding-left: 8px;\n  font-size: 12px;\n  line-height: 1.42;\n}\n.incentives-category-title {\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.5;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: #555;\n  background-color: #f7f7f7;\n  padding: 4px 8px;\n  border-radius: 3px;\n  margin-bottom: 4px;\n}\n.measure-checklist {\n  display: flex;\n  align-items: center;\n  padding: 0 16px 8px 28px !important;\n  margin-left: 16px;\n  margin-top: 8px;\n  border-bottom: 1px solid #eee;\n}\n.measure-checklist:last-child {\n  border-bottom: none;\n}\n.incentives-text-list {\n  text-align: 'left';\n  font-size: 12px;\n  line-height: 1.5;\n  color: #555;\n  padding-left: 24px;\n}\n.incentives-text-list li {\n  margin-bottom: 4px;\n}\n.incentives-text-list b {\n  font-weight: 600;\n}\n.incentive-template-form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 16px;\n  padding-bottom: 8px;\n}\n.seprator-style {\n  border-top: 1px solid #eee;\n}\n.seprator-style.dark {\n  border-color: #ddd;\n}\n.seprator-style.mb0 {\n  margin-bottom: 0;\n}\n.seprator-style.mt0 {\n  margin-top: 0;\n}\n.seprator-style.my0 {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.incentive-published-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n  font-size: 12px;\n  line-height: 1.42;\n  color: #555;\n  font-style: italic;\n}\n.incentives-dropdown-style {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.incentives-dropdown-style .incentive-source-and-name-container {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 14px;\n  line-height: 1.42;\n  color: #333;\n}\n.incentives-dropdown-style .incentive-source-and-name-container .source {\n  font-size: 12px;\n  line-height: 1.42;\n  color: #777;\n}\n.incentives-dropdown-style .incentive-type {\n  font-size: 12px;\n  line-height: 1.42;\n  text-align: center;\n  color: #555;\n  text-transform: uppercase;\n  padding: 1px 6px 2px;\n  background-color: #eee;\n  border-radius: 3px;\n}\n.incentives-list-container-table thead th {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #656565;\n  text-transform: none !important;\n  letter-spacing: 0;\n  border-bottom: 1px solid #eee !important;\n}\n.incentives-list-container-table thead th:first-child {\n  padding-left: 16px;\n}\n.incentives-list-container-table .incentive-source {\n  background-color: #f2f2f2;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #656565;\n}\n.incentives-list-container-table .incentive-source td {\n  padding: 4px 8px;\n}\n.incentives-list-container-table .incentive-source td:first-child {\n  padding-left: 16px;\n  border-left: 1px solid #eee;\n}\n.incentives-list-container-table .incentive-source td:last-child {\n  border-right: 1px solid #eee;\n}\n.incentives-list-container-table .incentive-list-itme {\n  cursor: pointer;\n  background-color: #fff;\n  transition: all 250ms ease;\n  position: relative;\n}\n.incentives-list-container-table .incentive-list-itme td {\n  vertical-align: middle;\n  padding: 16px 8px;\n  border-top: none;\n  border-bottom: 1px solid #eee;\n}\n.incentives-list-container-table .incentive-list-itme td:first-child {\n  padding-left: 16px;\n  border-left: 1px solid #eee;\n}\n.incentives-list-container-table .incentive-list-itme td:last-child {\n  border-right: 1px solid #eee;\n}\n.incentives-list-container-table .incentive-list-itme:hover {\n  background-color: #fff;\n  z-index: 10;\n  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.2);\n}\n.incentives-list-container-table .incentive-list-itme:hover td {\n  border-bottom: 1px solid #fff;\n}\n.incentives-list-container-table .incentive-list-itme:hover td:first-child {\n  border-left: 1px solid #fff;\n}\n.incentives-list-container-table .incentive-list-itme:hover td:last-child {\n  border-right: 1px solid #fff;\n}\n.incentives-list-container-table .incentive-list-item-title {\n  font-size: 14px;\n  line-height: 1.42;\n  font-weight: 600;\n  color: #333;\n}\n.incentives-details-title-section {\n  padding-top: 24px;\n  padding-bottom: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n.incentives-details-title-section span {\n  font-size: 12px;\n  line-height: 1.42;\n  color: #555;\n}\n.incentives-details-status-section {\n  padding-top: 24px;\n  padding-bottom: 8px;\n  display: flex;\n  justify-content: flex-end;\n}\n@media (max-width: 991px) {\n  .incentives-details-status-section {\n    justify-content: flex-start;\n    padding-top: 0;\n  }\n}\n.incentives-details-estimated-amount {\n  font-size: 12px;\n  line-height: 1.42;\n  font-weight: 600;\n  text-align: right;\n  margin-bottom: 4px;\n}\n.incentives-details-estimated-amount a {\n  text-decoration: underline;\n}\n.incentives-details-estimated-amount a:hover {\n  text-decoration: none;\n}\n.incentives-line-items-table thead tr th {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #c84900;\n  letter-spacing: 0;\n  text-transform: none;\n  border-bottom: none;\n  background-color: #f7f7f7;\n  padding: 4px 8px;\n}\n.incentives-line-items-table thead tr th.incentive-source-total {\n  color: #656565;\n  text-align: right;\n}\n.incentives-line-items-table tbody tr td {\n  font-weight: 600;\n}\n.incentives-line-items-table tbody tr:first-child td {\n  border-top: none;\n}\n@media (max-width: 991px) {\n  .incentives-list-container-table thead {\n    display: none;\n  }\n  .incentives-list-container-table .incentive-source {\n    display: flex;\n    flex-wrap: wrap;\n    background: none;\n  }\n  .incentives-list-container-table .incentive-source td {\n    display: block;\n    width: 50%;\n    box-sizing: border-box;\n    font-size: 1.5rem;\n    border: none !important;\n    padding-left: 0 !important;\n    padding-top: 4px;\n  }\n  .incentives-list-container-table .incentive-source td:last-child {\n    text-align: right;\n  }\n  .incentives-list-container-table .incentive-list-itme {\n    display: flex;\n    flex-wrap: wrap;\n    margin-bottom: 16px;\n    margin-top: 16px;\n    width: 100%;\n    padding: 8px 16px;\n    box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.06), 0 0 0 1px rgba(0, 0, 0, 0.06);\n    border-radius: 3px;\n  }\n  .incentives-list-container-table .incentive-list-itme td {\n    display: block;\n    width: 50%;\n    box-sizing: border-box;\n    text-align: left;\n    padding-top: 24px !important;\n    position: relative;\n    border: none !important;\n  }\n  .incentives-list-container-table .incentive-list-itme td:first-child {\n    padding-left: 8px;\n  }\n  .incentives-list-container-table .incentive-list-itme td:nth-child(1) {\n    width: 50%;\n    padding-top: 16px !important;\n  }\n  .incentives-list-container-table .incentive-list-itme td:nth-child(2) {\n    width: 50%;\n    padding-top: 8px !important;\n  }\n  .incentives-list-container-table .incentive-list-itme td::before {\n    content: attr(data-label);\n    position: absolute;\n    top: 4px;\n    left: 8px;\n    width: 100%;\n    font-weight: 400;\n    text-align: left;\n    font-size: 12px;\n  }\n}\n@media (max-width: 767px) {\n  .incentives-list-container-table .incentive-list-itme td:nth-child(1) {\n    width: 100%;\n    padding-top: 16px !important;\n  }\n  .incentives-list-container-table .incentive-list-itme td:nth-child(2) {\n    width: 100%;\n    padding-top: 0 !important;\n    padding-bottom: 8px !important;\n  }\n}\n.selected-incentives-table thead tr th {\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 1.42;\n  color: #333;\n  border-bottom: none;\n  background-color: #fff;\n  padding: 8px;\n}\n.selected-incentives-table thead tr th.incentive-source-total {\n  text-align: right;\n}\n.selected-incentives-table tbody tr td {\n  vertical-align: middle;\n  font-size: 14px;\n  line-height: 1.42;\n  color: #333;\n  font-weight: 600;\n}\n.selected-incentives-table tbody tr td.rebate-type-block {\n  font-size: 10px;\n  line-height: 1.42;\n  color: #656565;\n  font-weight: 600;\n  background-color: #f2f2f2;\n  border: 1px solid #eee;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n.incentives-line-items-total {\n  font-size: 18px;\n  font-weight: 700;\n  color: #333;\n  text-align: right;\n}\n.eligibility-list {\n  padding-left: 24px;\n  margin-bottom: 0;\n}\n.eligibility-list li {\n  margin-bottom: 6px;\n}\n.eligibility-list li:last-child {\n  margin-bottom: 0;\n}\n.incentives-attributes-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n  padding-right: 8px;\n}\n.incentives-key-value-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.floating-back-button {\n  display: flex;\n  justify-content: center;\n  gap: 0;\n  position: fixed;\n  bottom: 40px;\n  left: 50%;\n  transform: translate(-50%);\n  z-index: 99;\n  font-size: 14px;\n  line-height: 1.42;\n  text-align: left;\n  color: #fff;\n  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.5);\n  border-radius: 6px;\n  overflow: hidden;\n  transition: all 300ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n}\n.floating-back-button .float-button-inner {\n  background-color: rgba(0, 0, 0, 0.6);\n  border-radius: 6px 0 0 6px;\n  backdrop-filter: blur(16px);\n  transition: all 300ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  cursor: pointer;\n}\n.floating-back-button .float-button-inner:hover {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n.floating-back-button .close-float {\n  background-color: rgba(0, 0, 0, 0.6);\n  border-radius: 0 6px 6px 0;\n  padding: 0px 16px 0 14px;\n  backdrop-filter: blur(16px);\n  transition: all 300ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  border-left: 1px solid rgba(0, 0, 0, 0.35);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n}\n.floating-back-button .close-float:hover {\n  background-color: rgba(0, 0, 0, 0.8);\n}\n@media (max-width: 767px) {\n  .floating-back-button {\n    left: 4%;\n    right: 4%;\n    transform: translate(0%);\n  }\n  .floating-back-button .float-button-inner {\n    flex: 1;\n  }\n}\n.linked-measure-incentive-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px 8px 0 0;\n}\n.linked-measure-incentive-button {\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-radius: 6px;\n  border: 1px solid transparent;\n  transition: all 300ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #555;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n  padding: 8px 16px 8px 12px;\n}\n.linked-measure-incentive-button:hover {\n  background-color: #fff5e9;\n  border: 1px solid rgba(251, 207, 165, 0.5);\n  border-radius: 6px;\n  color: #f56600;\n}\n.line-items-show-more {\n  font-size: 12px;\n  line-height: 1.42;\n  text-align: center;\n  text-decoration: underline;\n  color: #c84900;\n}\n.no-selected-incentives-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 16px 8px;\n}\n.cocompliances_table {\n  width: 100%;\n  font-size: 16px;\n}\n.cocompliances_table tr {\n  display: flex;\n  gap: 8px;\n}\n.cocompliances_table td,\n.cocompliances_table th {\n  padding: 10px 12px;\n  width: 33.33%;\n  border-bottom: 1px solid #eee;\n}\n.cocompliances_table th b {\n  font-weight: 700;\n}\n.cocompliances_table td b {\n  font-weight: 600;\n}\n.cocompliances_table th.active {\n  background-color: #7cad3e;\n  color: #fff;\n  border-radius: 12px 12px 0 0;\n  text-align: center;\n}\n.cocompliances_table th.inactive {\n  background-color: #eee;\n  color: #777;\n  border-radius: 12px 12px 0 0;\n  text-align: center;\n}\n.cocompliances_table td.active {\n  background-color: #e5f0d6;\n  border-bottom: 1px solid #c4dda2;\n  text-align: center;\n}\n.cocompliances_table td.inactive {\n  background-color: #f7f7f7;\n  border-bottom: 1px solid #eee;\n  text-align: center;\n  color: #777;\n}\n.signature-box {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  width: 240px;\n  height: 164px;\n  margin-top: 8px;\n}\n.signature-box .signature-action {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 4px;\n  font-size: 12px;\n  line-height: 1.42;\n  text-transform: uppercase;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.2);\n  padding: 8px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 200ms ease-in-out;\n}\n.signature-box .signature-action svg {\n  fill: rgba(0, 0, 0, 0.2);\n  transition: all 200ms ease-in-out;\n}\n.signature-box .signature-action:hover {\n  background-color: #fff5e9;\n  color: #f56600;\n}\n.signature-box .signature-action:hover svg {\n  fill: #f56600;\n}\n.signature-box .signature-footer {\n  width: 100%;\n  font-size: 12px;\n  line-height: 1.42;\n  color: #555;\n  padding-top: 4px;\n  border-top: 1px solid #cccccc;\n  display: flex;\n}\n.signature-box .signature-footer span {\n  float: left;\n  width: 64px;\n}\n/* CUSTOM WORK ORDER COMPONENTS FOR PROGRAMS */\n.energy-savings-improvements-work-order {\n  display: flex;\n  flex-direction: column;\n  background-color: #f2f2f2;\n  border-radius: 6px;\n  padding: 2px 10px;\n  margin-bottom: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n}\n.energy-savings-improvements-work-order > div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 6px 0;\n  border-bottom: 1px solid #e6e6e6;\n}\n.energy-savings-improvements-work-order > div:last-child {\n  border-bottom: none;\n}\n.energy-savings-improvements-work-order .key {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.energy-savings-improvements-work-order .value {\n  color: #111;\n}\n.custom-di-payment-modal {\n  max-width: 1000px;\n  width: 96%;\n}\n.custom-di-payment-modal-email {\n  display: block;\n  line-break: anywhere;\n}\n@media (max-width: 991px) {\n  .custom-di-payment-modal {\n    width: 96%;\n  }\n  .custom-di-payment-modal-email {\n    display: inline;\n  }\n}\n.konva-canvas-modal {\n  width: 100vw;\n  height: 100vh;\n  margin: 0;\n}\n.konva-canvas-modal .modal-content {\n  height: 100vh;\n  border-radius: 0;\n  border: none;\n  display: flex;\n  flex-direction: column;\n  min-height: 600px;\n}\n.konva-canvas-modal .modal-header {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #f7f7f7;\n  border-bottom: 1px solid #e6e6e6;\n  padding: 8px 16px;\n  display: table;\n}\n.konva-canvas-modal .modal-header .modal-title {\n  font-size: 16px;\n  font-weight: 600;\n  color: #777777;\n}\n.konva-canvas-modal .modal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n  display: flex;\n  flex-direction: row;\n}\n.konva-canvas-modal .modal-body .left-sidebar {\n  width: 192px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 16px;\n  border-right: 1px solid #e6e6e6;\n}\n.konva-canvas-modal .modal-body .left-sidebar .top {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.konva-canvas-modal .modal-body .left-sidebar .top .draw-mode-btns-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.konva-canvas-modal .modal-body .left-sidebar .top .shape-btns-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.konva-canvas-modal .modal-body .right-sidebar {\n  border-left: 1px solid #e6e6e6;\n}\n.konva-canvas-modal .modal-body hr {\n  border-top: 1px solid #e6e6e6;\n  width: 100%;\n  margin: 0;\n}\n.konva-canvas-modal .fixed-footer {\n  position: sticky;\n  bottom: 0;\n  z-index: 2;\n  background-color: #f7f7f7;\n  box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.1);\n  padding: 16px;\n}\n.konva-canvas-modal .fixed-footer .footer-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n.konva-canvas-modal .fixed-footer .footer-container span {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 142%;\n  color: #777777;\n}\n.konva-canvas-modal .fixed-footer .footer-container span b {\n  font-weight: 700;\n  color: #333333;\n}\n.konva-canvas-modal .fixed-footer .footer-container .footer-buttons-container {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n}\n.konva-canvas-page {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1064;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  min-height: 600px;\n}\n.konva-canvas-page .konva-canvas-page-header {\n  position: sticky;\n  top: 0;\n  z-index: 2;\n  background: #f7f7f7;\n  border-bottom: 1px solid #e6e6e6;\n  padding: 8px 16px;\n  display: table;\n}\n.konva-canvas-page .konva-canvas-page-header h3 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #777777;\n  margin: 0;\n}\n.konva-canvas-page .konva-canvas-page-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 0;\n  display: flex;\n  flex-direction: row;\n}\n.konva-canvas-page .konva-canvas-page-body .left-sidebar {\n  width: 192px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 16px;\n  border-right: 1px solid #e6e6e6;\n}\n.konva-canvas-page .konva-canvas-page-body .left-sidebar .top {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n.konva-canvas-page .konva-canvas-page-body .left-sidebar .top .draw-mode-btns-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.konva-canvas-page .konva-canvas-page-body .left-sidebar .top .shape-btns-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.konva-canvas-page .konva-canvas-page-body .right-sidebar {\n  border-left: 1px solid #e6e6e6;\n}\n.konva-canvas-page .konva-canvas-page-body hr {\n  border-top: 1px solid #e6e6e6;\n  width: 100%;\n  margin: 0;\n}\n.konva-canvas-page .konva-canvas-page-footer {\n  position: sticky;\n  bottom: 0;\n  z-index: 2;\n  background-color: #f7f7f7;\n  box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.1);\n  padding: 16px;\n}\n.konva-canvas-page .konva-canvas-page-footer .footer-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n.konva-canvas-page .konva-canvas-page-footer .footer-container span {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 142%;\n  color: #777777;\n}\n.konva-canvas-page .konva-canvas-page-footer .footer-container span b {\n  font-weight: 700;\n  color: #333333;\n}\n.konva-canvas-page .konva-canvas-page-footer .footer-container .footer-buttons-container {\n  display: flex;\n  flex-direction: row;\n  gap: 4px;\n}\n.konva-edit-wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: #f7f7f7;\n  padding: 16px;\n}\n.konva-fixed-area {\n  width: 100%;\n  max-width: 100%;\n  aspect-ratio: 16 / 9;\n  height: auto;\n  max-height: 100%;\n  position: relative;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.stored-file-notify {\n  color: #777;\n  font-size: 12px;\n  line-height: 1.6;\n  font-weight: 600;\n  padding: 16px;\n  border-radius: 12px;\n  background-color: #fff;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 1px 2px -1px rgba(0, 0, 0, 0.06), 0 2px 4px 0 rgba(0, 0, 0, 0.04);\n}\n.stored-file-notify b {\n  font-weight: 700;\n  color: #111;\n}\n.no-image-selected {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 0;\n  text-align: center;\n  color: #777777;\n  gap: 16px;\n  z-index: 2;\n}\n.wwrt-image-uploader-container {\n  align-items: center;\n  background: #f9f9f9;\n  border-color: #cccccc;\n  border-radius: 12px;\n  border-style: dashed;\n  border-width: 1px;\n  display: flex;\n  gap: 16px;\n  height: 100%;\n  justify-content: center;\n  padding: 8px;\n  width: 100%;\n  cursor: pointer;\n}\n.wwrt-image-uploader-container:hover {\n  background-color: #f2f2f2;\n}\n.wwrt-image-uploader-container p {\n  margin: 0;\n}\n.wwrt-image-uploader-container input[type='file'] {\n  display: none;\n}\n.wwrt-image-uploader-container .wwrt-image-uploader {\n  align-items: center;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 16px;\n  justify-content: center;\n  min-height: 115px;\n  color: #777777;\n  font-size: 12px;\n}\n.wwr-white-btn {\n  transition: all 150ms ease-in-out;\n}\n.wwr-white-btn:hover {\n  background-color: #f7f7f7 !important;\n}\n.wwr-wall-btn {\n  transition: all 150ms ease-in-out;\n}\n.wwr-wall-btn:hover {\n  background-color: #fef0e6 !important;\n}\n.wwr-window-btn {\n  transition: all 150ms ease-in-out;\n}\n.wwr-window-btn:hover {\n  background-color: #ebf1fe !important;\n}\n.wwr-delete-btn {\n  transition: all 150ms ease-in-out;\n  background-color: #d92d20 !important;\n  color: #fff !important;\n}\n.wwr-delete-btn:hover {\n  background-color: #ae241a !important;\n}\n.shape-properties-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #777777;\n  margin: 0;\n}\n.undo-redo-btns {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n}\n.zoom-controls {\n  width: 34px;\n  position: absolute;\n  bottom: 24px;\n  right: 24px;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n.zoom-button {\n  width: 100%;\n  height: 32px;\n  background-color: rgba(255, 255, 255, 0.95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  backdrop-filter: blur(2px);\n}\n.zoom-button:hover {\n  background-color: #f2f2f2;\n}\n.zoom-button hr {\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\n}\n.start-audit-button {\n  width: auto !important;\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n}\n@media (min-width: 992px) {\n  .start-audit-button {\n    padding-top: 11px !important;\n    padding-bottom: 11px !important;\n  }\n}\n.content.jobs-view {\n  background-color: transparent;\n  padding-top: 92px;\n  min-height: 100vh;\n}\n.content.jobs-view.jobs-view-has-only-one-organization {\n  padding-top: 46px;\n}\n.content.jobs-view h1 {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 19px;\n}\n.content.jobs-view h1 .btn-group {\n  margin-left: 10px;\n}\n.content.jobs-view h1 .btn-group > .btn-large {\n  font-size: 24px;\n}\n.content.jobs-view h2 {\n  font-size: 24px;\n  font-weight: 300;\n  margin-top: 5px;\n}\n.content.jobs-view .listings {\n  min-height: 50vh;\n}\n.listings {\n  color: #303232;\n}\n.listings h3 {\n  font-weight: 600;\n  font-size: 15px;\n  text-transform: capitalize;\n  margin: 0;\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  color: #222222;\n}\n.listings h3 small {\n  color: #666;\n}\n.listings a {\n  color: #333333;\n}\n.listings .jl {\n  font-size: 13px;\n  line-height: 26px;\n  position: relative;\n  overflow: hidden;\n  min-height: 60px;\n  cursor: pointer;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n  *zoom: 1;\n}\n.listings .jl.jl-not-wholly-clickable {\n  cursor: default;\n}\n.listings .jl.jl-not-wholly-clickable a {\n  color: #c84900;\n}\n.listings .jl:before,\n.listings .jl:after {\n  content: \" \";\n  display: table;\n}\n.listings .jl:after {\n  clear: both;\n}\n.listings .jl:before,\n.listings .jl:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.listings .jl:after {\n  clear: both;\n}\n.listings .jl:nth-last-child(2) {\n  border-bottom: 0;\n}\n.listings .jl.jl-header {\n  text-transform: uppercase;\n  cursor: default;\n  border-bottom: none;\n  min-height: 46px;\n}\n.listings .jl.jl-header .jl-buttons {\n  min-height: 46px;\n}\n.listings .jl.jl-header .jl-everything-else {\n  cursor: default;\n  min-height: 46px;\n}\n.listings .jl.jl-header .jl-everything-else:hover {\n  background-color: transparent;\n}\n.listings .jl.jl-header .jl-box {\n  color: #555555;\n  letter-spacing: 0.08em;\n  font-size: 0.95em;\n  font-weight: 700;\n  text-align: left;\n}\n.listings .jl.jl-header-sortable .jl-box {\n  cursor: pointer;\n  border-radius: 5px;\n}\n.listings .jl.jl-header-sortable .jl-box:hover {\n  background-color: #f2f2f2;\n  color: #000;\n}\n.listings .jl.jl-header-sortable .jl-box:active,\n.listings .jl.jl-header-sortable .jl-box:focus {\n  background-color: #eeeeee;\n}\n.listings .jl.jl-unread {\n  background-color: #f3f3f3;\n}\n.listings .jl.jl-unread h3 {\n  padding-right: 35px;\n  font-weight: 700;\n  padding-right: 20px;\n}\n.listings .jl.jl-unread h3:after {\n  content: '\\3e';\n  font-family: 'snugg-6';\n  position: absolute;\n  display: block;\n  height: 20px;\n  right: 10px;\n  top: 8px;\n  top: 10px;\n  font-size: 17px;\n  padding-left: 5px;\n  margin: auto;\n  font-size: inherit;\n  color: rgba(0, 0, 0, 0.5);\n}\n.listings .jl.jl-single-line .jl-everything-else {\n  padding-top: 13px;\n}\n.listings .jl.jl-single-button .jl-buttons {\n  width: 36px;\n}\n.listings .jl.jl-single-button .jl-everything-else {\n  margin-left: 35px;\n  padding-left: 5px;\n}\n.listings .jl.jl-no-button .jl-everything-else {\n  margin-left: 0;\n}\n.listings .jl-buttons {\n  width: 72px;\n  min-height: 60px;\n  float: left;\n}\n.listings .jl-buttons .snugg-select {\n  min-height: 60px;\n}\n.listings .btn-map-it,\n.listings .jl-select {\n  position: relative;\n  padding: 0;\n  font-size: 18px;\n  padding: 6px;\n  border-radius: 0;\n  height: 60px;\n  width: 36px;\n  color: rgba(0, 0, 0, 0.3);\n  background-color: transparent;\n  cursor: pointer;\n}\n.listings .btn-map-it:hover,\n.listings .jl-select:hover,\n.listings .btn-map-it:focus,\n.listings .jl-select:focus,\n.listings .btn-map-it:focus-within,\n.listings .jl-select:focus-within {\n  background-color: #fff3e3;\n  color: #303232;\n}\n.listings .btn-map-it:active,\n.listings .jl-select:active {\n  background-color: #ffeacf;\n  box-show: 'none';\n}\n.listings .btn-map-it [class^='ico-'],\n.listings .jl-select [class^='ico-'],\n.listings .btn-map-it [class*=' ico-'],\n.listings .jl-select [class*=' ico-'] {\n  height: 22px;\n  position: absolute;\n  margin: auto;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.listings .jl-select.checkbox-container {\n  display: inline-block;\n  width: 36px;\n  height: 60px;\n  float: left;\n}\n.listings .jl-select.checkbox-container .checkmark {\n  top: 0;\n  bottom: 0;\n  left: 10px;\n  margin: auto;\n}\n.listings .jl-everything-else {\n  cursor: pointer;\n  min-height: 60px;\n  margin-left: 72px;\n}\n.listings .jl-everything-else:hover {\n  background-color: #fff3e3;\n}\n.listings .jl-everything-else:active {\n  background-color: #ffdfb5;\n}\n.listings .jl-everything-else .link-to-job {\n  display: block;\n}\n.listings .jl-everything-else .link-to-job:focus {\n  outline: none;\n  background-color: #fff3e3;\n}\n.listings .jl-everything-else .job-row-unread-indicator {\n  background-color: #3571f7;\n  border-radius: 2em;\n  width: 12px;\n  height: 12px;\n  position: absolute;\n  right: 16px;\n  left: auto;\n  top: 42%;\n  bottom: auto;\n}\n.listings .snugg-selected .jl-everything-else:hover {\n  background-color: #ffefdc;\n}\n.listings .jl-box {\n  padding-top: 15px;\n  padding: 15px 1.5% 3px;\n  float: left;\n  color: #222222;\n  position: relative;\n  overflow-x: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.listings .jl-job-id {\n  width: 25%;\n}\n.listings .jl-job-id-list {\n  padding: 8px 5px 0 4px;\n  line-height: 1.5;\n}\n.listings .jl-alt-job-id {\n  line-height: 1.5;\n  padding-top: 2px;\n}\n.listings .jl-account {\n  *zoom: 1;\n  padding: 6px 5px 0 4px;\n}\n.listings .jl-account:before,\n.listings .jl-account:after {\n  content: \" \";\n  display: table;\n}\n.listings .jl-account:after {\n  clear: both;\n}\n.listings .jl-account:before,\n.listings .jl-account:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.listings .jl-account:after {\n  clear: both;\n}\n.listings .jl-discreet {\n  color: #555555;\n  white-space: nowrap;\n  overflow-x: hidden;\n}\n.listings .jl-user {\n  width: 20%;\n}\n.listings .jl-program {\n  width: 30%;\n}\n.listings .jl-stage {\n  width: 20%;\n}\n.listings .jl-date-and-time {\n  float: right;\n  padding: 5px 5px 0 0;\n}\n.listings .jl-date-and-time .cal-icon {\n  text-align: center;\n  min-width: 70px;\n  min-height: 57px;\n}\n.listings .jl-date-and-time .cal-icon .cal-icon__month {\n  font-size: 11px;\n  font-weight: 400;\n}\n.listings .jl-date-and-time .cal-icon .cal-icon__month-day {\n  font-weight: 400;\n  font-size: 22px;\n  line-height: 1.2em;\n}\n.listings .jl-date-and-time .cal-icon .cal-icon__week-day-and-time {\n  font-size: 11px;\n  font-weight: 400;\n  white-space: nowrap;\n}\n.listings .jl-date {\n  float: none;\n  text-align: left;\n  padding-left: 0;\n}\n.listings .jl-job-type {\n  float: right;\n  text-align: right;\n  padding-right: 0;\n}\n/* Extra small devices (phones, less than 768px) */\n/* No media query since this is the default in Bootstrap */\n/* ONLY extra small devices (phones less than 768px) */\n@media (max-width: 767px) {\n  .listings .jl.jl-unread h3 {\n    padding-right: 35px;\n  }\n  .listings .jl.jl-unread h3:after {\n    top: 10px;\n    font-size: 17px;\n  }\n  .listings .jl-job-id-list {\n    padding: 0;\n    line-height: inherit;\n  }\n  .listings .jl-job-id-text {\n    display: inline;\n  }\n  .listings .jl-alt-job-id {\n    display: inline;\n    padding-left: 4px;\n    padding-top: 0;\n  }\n  .listings .jl-date-and-time {\n    float: right;\n    color: #555555;\n  }\n  .listings .jl-date-and-time .jl-box-left {\n    display: none;\n  }\n  .listings .jl-select,\n  .listings .btn-map-it,\n  .listings .jl-everything-else {\n    min-height: 80px;\n  }\n  .listings .jl-select .job-row-unread-indicator,\n  .listings .btn-map-it .job-row-unread-indicator,\n  .listings .jl-everything-else .job-row-unread-indicator {\n    right: 8px;\n  }\n  .listings .jl-account {\n    height: auto;\n    padding: 8px 0 0 3px;\n  }\n  .listings .jl-account h3 {\n    max-width: none;\n    margin-top: 0;\n    padding: 2px 0;\n  }\n  .listings .jl-job-id,\n  .listings .jl-program,\n  .listings .jl-user {\n    display: inline;\n    width: auto;\n  }\n  .listings .jl-job-stats {\n    color: #777777;\n    padding-top: 2px;\n  }\n  .listings .jl-job-stats .jl-box {\n    width: auto;\n    padding: 0;\n    padding-left: 3px;\n  }\n  .listings .jl-job-stats .jl-box:first-child:after {\n    content: ' \\2022  ';\n  }\n  .listings .jl-box {\n    padding: 3px;\n  }\n}\n#main-pane {\n  min-height: 70vh;\n}\n/* Small devices (tablets, 768px and up) */\n@media (min-width: 768px) {\n  .content.jobs-view {\n    background-color: transparent;\n    padding-top: 46px;\n  }\n  .content.jobs-view #main-pane {\n    padding-left: 30px;\n  }\n}\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: 992px) {\n  .content.jobs-view .jl-date {\n    padding-left: 10%;\n  }\n  .content.jobs-view #main-pane {\n    padding-left: 26px;\n  }\n}\n/* Large devices (large desktops, 1200px and up) */\n.content.activity-view {\n  background-color: transparent;\n  min-height: 500px;\n  padding-bottom: 10px;\n  background-image: url('../img/ui/tiled-background-skewed@0.82x.png');\n  background-attachment: fixed;\n  background-repeat: repeat;\n  padding-top: 92px;\n}\n.content.activity-view.activity-view-has-only-one-organization {\n  padding-top: 46px;\n}\n.content.activity-view .activity-feed-main-pane {\n  margin-bottom: 40px;\n  min-height: 700px;\n}\n.content.activity-view .activity-feed-newer-activity-detected.alert.alert-alert {\n  border-radius: 30px;\n  min-width: 370px;\n  width: 370px;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n}\n.content.activity-view .activity-feed-newer-activity-detected.alert.alert-alert h4 {\n  margin-bottom: 6px;\n  padding-top: 4px;\n}\n.content.activity-view .activity-feed-newer-activity-detected.alert.alert-alert:hover {\n  background-color: #e3f2fa;\n  color: #1a3140;\n}\n.content.activity-view .activity-feed-newer-activity-detected.alert.alert-alert .close {\n  padding: 8px 18px 0px;\n}\n.content.activity-view .activity-feed-newer-activity-detected.alert.alert-alert .close:hover {\n  color: #000;\n}\n.content.activity-view .activity-feed-cards-container {\n  position: relative;\n}\n.content.activity-view .activity-feed-cards-container .activity-feed-visual-card-link {\n  position: absolute;\n  top: 10px;\n  bottom: 0;\n  left: 9%;\n  right: auto;\n  width: 2px;\n  background-color: #bbb;\n  z-index: 0;\n}\n.content.activity-view .activity-feed-end-of-new-notifications {\n  position: relative;\n  text-align: center;\n  max-width: 750px;\n  font-weight: 600;\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n.content.activity-view .activity-feed-end-of-new-notifications span {\n  padding: 5px 15px;\n  position: relative;\n  color: #f88b00;\n  text-transform: uppercase;\n  font-size: 14px;\n  font-weight: 600;\n  background-color: #f2f2f2;\n  border: 2px solid #f88b00;\n  border-radius: 4px;\n  display: inline-block;\n}\n.content.activity-view .activity-feed-end-of-new-notifications:before {\n  display: block;\n  content: '';\n  height: 1px;\n  border-bottom: 2px dashed #f88b00;\n  position: absolute;\n  top: 50%;\n  width: 100%;\n}\n.content.activity-view .activity-feed-day-divider {\n  position: relative;\n  z-index: 1;\n  height: 30px;\n  min-width: 18%;\n  border-radius: 17px;\n  background-color: #555555;\n  color: #f9f9f9;\n  padding: 6px 16px;\n  display: inline-block;\n  margin-bottom: 30px;\n  font-size: 13px;\n  font-weight: 600;\n  text-align: center;\n}\n.content.activity-view .activity-card + .activity-feed-day-divider {\n  margin-top: 30px;\n}\n.content.activity-view .activity-card {\n  z-index: 1;\n  position: relative;\n  min-height: 130px;\n  border-radius: 5px;\n  background-color: #ffffff;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n  padding: 20px 20px 15px;\n  margin-bottom: 20px;\n  animation-duration: 1.2s;\n  max-width: 750px;\n}\n.content.activity-view .activity-card .activity-card-header {\n  font-size: 22px;\n  line-height: 1.3em;\n  font-weight: 700;\n  letter-spacing: 0;\n  margin-bottom: 10px;\n}\n.content.activity-view .activity-card .activity-card-job-id {\n  color: #777777;\n  font-weight: 600;\n  border-radius: 4px;\n  padding-left: 5px;\n  display: inline-block;\n}\n.content.activity-view .activity-card .activity-card-message {\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 19px;\n  color: #333333;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.content.activity-view .activity-card .activity-card-user-name {\n  color: #555555;\n  font-size: 12px;\n  line-height: 17px;\n  text-align: center;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  width: 80px;\n  overflow-x: hidden;\n}\n.content.activity-view .activity-card .activity-card-time {\n  font-size: 12px;\n  line-height: 1.76em;\n  color: #555;\n  font-weight: 700;\n  white-space: nowrap;\n  text-align: left;\n  padding-top: 3px;\n  padding-bottom: 5px;\n}\n.content.activity-view .activity-card .activity-card-job-info {\n  margin-bottom: 20px;\n  font-weight: 600;\n}\n@media (min-width: 768px) {\n  .content.activity-view {\n    padding-top: 46px;\n  }\n  .content.activity-view.activity-view-has-only-one-organization {\n    padding-top: 46px;\n  }\n  .content.activity-view .activity-card .activity-card-header {\n    font-size: 20px;\n  }\n  .content.activity-view .activity-card .activity-card-time {\n    text-align: center;\n  }\n  .content.activity-view .activity-card .activity-card-job-info {\n    margin-bottom: 10px;\n  }\n  .content.activity-view .activity-card .activity-card-message {\n    margin-left: 12px;\n  }\n}\n.editable-prefix {\n  float: left;\n  margin-right: 20px;\n  padding-top: 6px;\n}\ninput.editable-title,\ninput.form-control.editable-title,\n.form-horizontal .form-group-lg input.form-control.editable-title {\n  display: block;\n  background-color: inherit;\n  border: 0;\n  width: 100%;\n  height: 28px;\n  box-shadow: none;\n  padding: 2px 0 3px 1px;\n  margin-top: 9px;\n  color: #000;\n  border-radius: 0;\n  border-bottom: 1px dashed #c84900;\n}\ninput.editable-title:hover,\ninput.form-control.editable-title:hover,\n.form-horizontal .form-group-lg input.form-control.editable-title:hover {\n  background-color: #fef2c1;\n}\ninput.editable-title:focus,\ninput.form-control.editable-title:focus,\n.form-horizontal .form-group-lg input.form-control.editable-title:focus,\ninput.editable-title:active,\ninput.form-control.editable-title:active,\n.form-horizontal .form-group-lg input.form-control.editable-title:active {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: 0;\n  background-color: inherit;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\n.job-form input.editable-title,\n.job-form input.form-control.editable-title,\n.job-form .form-horizontal .form-group-lg input.form-control.editable-title {\n  font-weight: 600;\n  letter-spacing: 0.03em;\n  font-size: 15px;\n  margin-bottom: 10px;\n  text-align: left;\n  color: #666;\n}\n.editable {\n  background-color: inherit;\n  font: inherit;\n  color: inherit;\n  height: inherit;\n  text-align: inherit;\n  width: 100%;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  margin: 0;\n  line-height: inherit;\n  vertical-align: inherit;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.editable:hover {\n  background-color: rgba(249, 143, 9, 0.2);\n  color: #222222;\n  background-opacity: 1;\n  cursor: text;\n  outline: 0;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\n.editable:focus,\n.editable:active {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  color: inherit !important;\n  outline: 0;\n  background-color: inherit !important;\n  -moz-appearance: none;\n  -webkit-appearance: none;\n}\ninput[type='text'].editable {\n  border-bottom: 1px dashed #777777;\n}\ninput[type='text'].editable[disabled] {\n  border-bottom: none;\n}\ninput[type='text'].editable[disabled]:hover {\n  background-color: inherit;\n  cursor: not-allowed;\n  -webkit-user-select: none;\n  user-select: none;\n}\n.editable-container {\n  overflow: hidden;\n}\n.report-present .report-page .editable-container:hover {\n  background-color: transparent !important;\n  color: default !important;\n  cursor: default;\n}\n.report-present .report-page input[type='text'].editable {\n  border-bottom: none;\n}\n.report-present .report-page .disabled-hover {\n  pointer-events: none;\n}\n.inline-editable__target {\n  max-height: 580px;\n  overflow: hidden;\n}\n.report-sidebar .editable:hover {\n  background-color: rgba(255, 255, 255, 0.85);\n}\n.slidedown-enter {\n  min-height: 0px;\n  max-height: 0px;\n  transition: all 0.5s ease;\n  overflow: hidden;\n}\n.slidedown-enter.slidedown-enter-active {\n  max-height: 600px;\n}\n.readonly-job select,\n.readonly-job .form-control,\n.readonly-job input[type='text'],\n.readonly-job input[type='password'],\n.readonly-job input[type='datetime'],\n.readonly-job input[type='datetime-local'],\n.readonly-job input[type='date'],\n.readonly-job input[type='month'],\n.readonly-job input[type='time'],\n.readonly-job input[type='week'],\n.readonly-job input[type='number'],\n.readonly-job input[type='email'],\n.readonly-job input[type='url'],\n.readonly-job input[type='search'],\n.readonly-job input[type='tel'],\n.readonly-job input[type='color'],\n.readonly-job .uneditable-input {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n  color: #555555 !important;\n  background-color: #f2f2f2 !important;\n  opacity: 1 !important;\n  border-color: #dfdfdf !important;\n  pointer-events: none;\n}\n.readonly-job .input-group-addon {\n  background-color: #f2f2f2 !important;\n  color: #555555 !important;\n  border-color: #dfdfdf !important;\n}\n.readonly-job .btn-group {\n  pointer-events: none;\n}\n.readonly-job .btn-group > .btn {\n  color: #222;\n  background-color: #f2f2f2;\n  border-color: #dfdfdf;\n}\n.readonly-job .btn-group > .btn.active {\n  box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.5);\n  color: #222;\n  background-color: #fff;\n}\n.readonly-job .DraftEditor-root {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n  pointer-events: none;\n}\n.readonly-job .themes-list {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n  pointer-events: none;\n}\n.readonly-job .snugg-btn-collectionAdd:not(.readonly-exception) {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n  pointer-events: none;\n  background-color: #f9f9f9 !important;\n  border: 1px dashed #dfdfdf !important;\n}\n.readonly-job .snugg-btn-orange {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n  pointer-events: none;\n}\n.readonly-job .snugg-btn-delete {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n  pointer-events: none;\n}\n.readonly-job .report-photo-row {\n  pointer-events: none;\n}\n.job-container {\n  padding-top: 91px;\n  padding-bottom: 600px;\n}\n.collection-set {\n  padding-bottom: 20px;\n}\n.collection {\n  padding-bottom: 20px;\n}\n.collection + .collection {\n  border-top: 1px solid #e0e0e0;\n  padding-top: 20px;\n}\n.input-group {\n  position: relative;\n}\n.input-group.deletable {\n  display: block;\n}\n.input-group.deletable select {\n  max-width: 76%;\n  width: auto;\n}\n.input-group .popover-sibling {\n  display: inline;\n}\n.delete-job-row {\n  float: right;\n  display: inline-block;\n  color: red;\n  margin-left: 16px;\n  padding: 12px 16px;\n  font-size: 16px;\n  border-radius: 3px;\n  background: inherit;\n  border: none;\n}\n.delete-job-row:hover {\n  color: #fff;\n  background-color: red;\n}\n.delete-job-row:active {\n  color: #fff;\n  background-color: #db0000;\n}\n.table-control-group.jobform-refrigerator table td:last-child {\n  position: relative;\n  padding-right: 10px;\n}\n.table-control-group.jobform-windows .table > tbody > tr > td {\n  border-top: none;\n  padding: 8px 4px;\n}\n.table-control-group .control-label {\n  padding-top: 50px;\n}\n.table-control-group .control-label span {\n  display: block;\n  padding-top: 46px;\n}\n.table-control-group .css-delete-row {\n  position: absolute;\n}\n.table-control-group table {\n  margin-bottom: 10px;\n}\n.table-control-group .delete-job-row {\n  position: absolute;\n  display: block;\n  float: left;\n  top: 3px;\n  right: -45px;\n}\n.date-difference {\n  float: right;\n  margin-top: -95px;\n  padding: 3px;\n  border-radius: 10px;\n  width: 67px;\n  border: dotted 1px #aaa;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  display: block;\n  position: relative;\n  z-index: 2;\n}\n.date-difference:before {\n  content: '';\n  display: block;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 20px;\n  margin: auto;\n  width: 1px;\n  height: 177px;\n  border-left: 1px dotted #aaa;\n}\n.date-difference:after {\n  content: '\\25CB';\n  display: block;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 90px;\n  bottom: 0;\n  margin: auto;\n  text-align: center;\n  font-size: 18px;\n  line-height: 7px;\n  height: 10px;\n  width: 15px;\n  color: #555555;\n  background-color: white;\n}\n.date-difference.label {\n  background-color: white;\n}\n.date-difference.label-warning {\n  background-color: #f7efd3;\n  color: #554610;\n  border-color: #efdfa8;\n}\n.date-difference.label-error {\n  background-color: #f1e3e3;\n  color: #b21212;\n  border-color: #721111;\n}\n.date-difference.date-difference-start {\n  content: '';\n  border: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.date-difference.date-difference-start:before {\n  top: 30px;\n  height: 50px;\n}\n.date-difference.date-difference-start:after {\n  content: '\\29BF';\n  top: 47px;\n}\n.date-difference.date-difference-end {\n  content: '';\n}\n.date-difference.date-difference-end:before {\n  top: 17px;\n  height: 30px;\n}\n.date-difference.date-difference-end:after {\n  content: '\\29BF';\n  top: 47px;\n}\n/* Extra small devices (phones, less than 768px) */\n/* No media query since this is the default in Bootstrap */\n/* ONLY extra small devices (phones less than 768px) */\n@media (max-width: 767px) {\n  .push-left .scroll-spy-clicked,\n  .push-left.scroll-spy {\n    left: 60px;\n    right: -60px;\n    -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  }\n  .form-group-utility-date:last-child .date-difference:before {\n    height: 80px;\n  }\n}\n@media (max-width: 991px) {\n  .form-group-narrow .input-lg,\n  .form-group-narrow input.form-control {\n    padding-left: 8px;\n    padding-right: 5px;\n  }\n  .form-group-narrow .input-group-addon {\n    min-width: 20px;\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n  .form-group-narrow .btn-group > .btn {\n    padding-left: 9px;\n    padding-right: 9px;\n  }\n}\n/* Small devices (tablets, 768px and up) */\n@media (min-width: 768px) {\n  .push-left .scroll-spy-clicked,\n  .push-left .scroll-spy {\n    left: 60px;\n    right: -60px;\n    -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  }\n  .scroll-spy-clicked,\n  .scroll-spy {\n    left: 60px;\n    -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  }\n  .delete-job-row {\n    float: none;\n  }\n  .job-container {\n    padding-top: 46px;\n  }\n}\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: 992px) {\n  .date-difference {\n    margin-top: 0;\n  }\n  .date-difference:before {\n    left: 0;\n    right: 0;\n    top: 18px;\n    height: 95px;\n  }\n  .date-difference:after {\n    left: 0;\n    right: 0;\n    top: 90px;\n    bottom: 0;\n    height: 10px;\n  }\n  .date-difference.date-difference-start {\n    margin-top: 0;\n  }\n  .date-difference.date-difference-start:before {\n    top: 45px;\n    height: 50px;\n  }\n  .date-difference.date-difference-start:after {\n    content: '\\29BF';\n    top: 47px;\n  }\n  .date-difference.date-difference-end:before {\n    top: 16px;\n    height: 30px;\n  }\n}\n@media (max-height: 589px) {\n  .push-left .scroll-spy-clicked,\n  .push-left .scroll-spy {\n    left: 108px;\n    right: -108px;\n    -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  }\n}\n@media (max-height: 589px) and (min-width: 768px) {\n  .scroll-spy-clicked,\n  .scroll-spy {\n    left: 108px;\n    right: -108px;\n    -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n    transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  }\n}\n.rec-content .add-rec {\n  margin: 20px 0 25px;\n}\n.rec-content .nav-tabs > li.active > a {\n  background-color: #f4f4f4;\n}\n.rec-content .rec-row {\n  *zoom: 1;\n  box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);\n  border-radius: 0;\n  font-size: 1em;\n  margin-bottom: 10px;\n  background-color: #fff;\n  border: 1px solid #eaeaea;\n  border-bottom: none;\n  cursor: pointer;\n  position: relative;\n  user-select: none;\n}\n.rec-content .rec-row:before,\n.rec-content .rec-row:after {\n  content: \" \";\n  display: table;\n}\n.rec-content .rec-row:after {\n  clear: both;\n}\n.rec-content .rec-row:before,\n.rec-content .rec-row:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.rec-content .rec-row:after {\n  clear: both;\n}\n.rec-content .rec-row:hover,\n.rec-content .rec-row:focus {\n  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);\n  z-index: 1;\n}\n.rec-content .rec-row:active {\n  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);\n  z-index: 10;\n}\n.rec-content .rec-row.rec-header {\n  min-height: 20px;\n  height: 20px;\n  padding: 0 8px;\n  text-align: center;\n  font-size: 0.9em;\n  text-transform: uppercase;\n  border: none;\n  box-shadow: none;\n  background-color: transparent;\n}\n.rec-content .rec-row.rec-header:hover {\n  box-shadow: none;\n}\n.rec-content .rec-row.rec-header .span-rec {\n  padding-top: 0;\n  padding-bottom: 5px;\n  text-align: right;\n}\n.rec-content .rec-row.rec-header .span-rec.span-cost {\n  text-align: right;\n}\n.rec-content .rec-row.rec-header .span-accept {\n  text-align: left;\n}\n.rec-content .rec-row.new-rec-row {\n  border: 1px dashed #cdcdcd;\n}\n.rec-content .rec-row.new-rec-row .custom-rec-name {\n  color: #222;\n  font-weight: 700;\n}\n.rec-content .btn-go {\n  height: 62px;\n  border-radius: 0;\n  font-size: 18px;\n  padding-top: 23px;\n  border-top-right-radius: 4px;\n}\n.rec-content .span-rec {\n  padding-top: 4px;\n  padding-bottom: 8px;\n}\n.rec-content .span-rec .span-label {\n  padding-bottom: 4px;\n  color: #555555;\n}\n.rec-content .span-rec-name {\n  display: block;\n  font-weight: 600;\n  padding-top: 15px;\n  padding-left: 15px;\n  color: #303232;\n}\n.rec-content .span-rec-name .span-rec-title {\n  font-size: 0.9em;\n  opacity: 0.7;\n  font-weight: 400;\n}\n.rec-content .span-rec-name .notes-label {\n  font-size: 0.9em;\n}\n.rec-content .span-rec-name .general-label {\n  margin: 0;\n}\n.rec-content .span-cost {\n  width: 100%;\n  float: left;\n  text-align: right;\n  padding-right: 5px;\n}\n.rec-content .span-cost .span-label {\n  padding-right: 10px;\n  text-align: left;\n}\n.rec-content .span-cost input {\n  text-align: right;\n  padding-right: 5px;\n}\n.rec-content .span-potential {\n  width: 25%;\n  text-align: right;\n  float: left;\n  padding-right: 10px;\n}\n.rec-content .span-savings {\n  width: 25%;\n  text-align: right;\n  float: left;\n  padding-right: 10px;\n}\n.rec-content .span-sir {\n  width: 25%;\n  text-align: right;\n  float: left;\n  padding-right: 10px;\n}\n.rec-content .span-priorities {\n  width: 45px;\n  float: left;\n  margin-right: 0px;\n}\n.rec-content .span-blank-state {\n  text-align: center;\n  padding: 22px 0;\n}\n.rec-content .rec-area {\n  border-top: none;\n  border-right: 1px solid #cdcdcd;\n  border-bottom: 1px solid #cdcdcd;\n  border-left: 1px solid #cdcdcd;\n}\n.rec-content .rec-untitled {\n  color: #959999;\n}\n.incentive-badge-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: center;\n  gap: 2px;\n  padding-top: 4px;\n  padding-bottom: 8px;\n  padding-right: 0;\n  padding-left: 0;\n  height: auto;\n}\n.incentive-name-badge {\n  font-size: 10px;\n  font-weight: 600;\n  color: #fff;\n  line-height: 1.2;\n  padding: 2px 8px;\n  background-color: #555;\n  border-radius: 24px;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 200px;\n}\n@media (min-width: 1200px) {\n  .incentive-badge-container {\n    padding-top: 4px;\n    padding-bottom: 4px;\n    padding-right: 0px;\n    padding-left: 8px;\n    height: 60px;\n    justify-content: center;\n  }\n  .incentive-name-badge {\n    max-width: 120px;\n  }\n}\n.refine-table {\n  width: 100%;\n  border-collapse: collapse;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-right: 15px;\n}\n.refine-table > div {\n  box-sizing: border-box;\n  padding-right: 16px;\n}\n.refine-table .refine-name {\n  width: 100%;\n  order: 1;\n}\n.refine-table .refine-status {\n  width: 100%;\n  padding-left: 16px;\n  display: flex;\n  order: 2;\n}\n.refine-table .refine-cost {\n  width: 45%;\n  padding-left: 16px;\n  padding-right: 5%;\n  padding-bottom: 8px;\n  text-align: left;\n  order: 3;\n}\n.refine-table .refine-incentives {\n  width: 45%;\n  padding-left: 5%;\n  padding-bottom: 8px;\n  text-align: left;\n  order: 4;\n}\n.refine-table .refine-incentive-sources {\n  width: 100%;\n  padding-left: 16px;\n  padding-bottom: 8px;\n  order: 5;\n}\n.refine-table .refine-savings {\n  width: 50%;\n  padding-left: 16px;\n  padding-bottom: 16px;\n  text-align: left;\n  order: 6;\n}\n.refine-table .refine-sir {\n  width: 50%;\n  padding-bottom: 16px;\n  text-align: left;\n  order: 7;\n}\n.refine-table-head {\n  display: none;\n}\n@media (min-width: 480px) {\n  .refine-table > div {\n    padding-right: 8px;\n  }\n  .refine-table .refine-cost {\n    width: 45%;\n  }\n  .refine-table .refine-incentives {\n    width: 45%;\n  }\n  .refine-table .refine-incentive-sources {\n    width: 100%;\n  }\n  .refine-table .refine-savings {\n    width: 50%;\n  }\n  .refine-table .refine-sir {\n    width: 50%;\n  }\n}\n@media (min-width: 768px) {\n  .refine-table .refine-name {\n    width: 50%;\n    order: 1;\n  }\n  .refine-table .refine-status {\n    width: 50%;\n    justify-content: flex-end;\n    order: 2;\n  }\n  .refine-table .refine-cost {\n    width: 30%;\n    padding-right: 0;\n    padding-bottom: 8px;\n    order: 3;\n  }\n  .refine-table .refine-incentives {\n    width: 25%;\n    padding-left: 5%;\n    padding-bottom: 8px;\n    order: 4;\n  }\n  .refine-table .refine-savings {\n    width: 20%;\n    padding-left: 0;\n    padding-bottom: 8px;\n    order: 5;\n  }\n  .refine-table .refine-sir {\n    width: 20%;\n    padding-bottom: 8px;\n    order: 6;\n  }\n  .refine-table .refine-incentive-sources {\n    width: 100%;\n    order: 7;\n  }\n}\n@media (min-width: 1200px) {\n  .refine-table .refine-name {\n    width: 22%;\n    order: 1;\n  }\n  .refine-table .refine-status {\n    width: 26%;\n    justify-content: flex-start;\n    padding: 0;\n    order: 2;\n  }\n  .refine-table .refine-cost {\n    width: 14%;\n    order: 3;\n  }\n  .refine-table .refine-incentives {\n    width: 10%;\n    padding-left: 0;\n    padding-right: 14px;\n    order: 5;\n    text-align: right;\n  }\n  .refine-table .refine-incentive-sources {\n    width: 14%;\n    padding: 0;\n    order: 5;\n  }\n  .refine-table .refine-savings {\n    width: 6%;\n    text-align: right;\n    order: 6;\n  }\n  .refine-table .refine-sir {\n    width: 6%;\n    text-align: right;\n    order: 7;\n  }\n  .refine-table-head {\n    display: flex;\n    font-size: 13px;\n    text-transform: uppercase;\n    padding: 0px 5px 4px 15px;\n    align-items: flex-end;\n  }\n  .refine-table-head .refine-name {\n    width: 22%;\n    order: 1;\n  }\n  .refine-table-head .refine-status {\n    width: 26%;\n    justify-content: flex-start;\n    padding: 0;\n    order: 2;\n  }\n  .refine-table-head .refine-cost {\n    width: 14%;\n    order: 3;\n  }\n  .refine-table-head .refine-incentives {\n    width: 10%;\n    padding-left: 0;\n    padding-right: 14px;\n    order: 5;\n    text-align: right;\n  }\n  .refine-table-head .refine-incentive-sources {\n    width: 14%;\n    padding: 0;\n    order: 5;\n  }\n  .refine-table-head .refine-savings {\n    width: 6%;\n    text-align: right;\n    order: 6;\n  }\n  .refine-table-head .refine-sir {\n    width: 6%;\n    text-align: right;\n    order: 7;\n  }\n}\n/* Extra small devices (phones, less than 768px) */\n/* No media query since this is the default in Bootstrap */\n/* ONLY extra small devices (phones less than 768px) */\n/* Small devices (tablets, 768px and up) */\n@media (min-width: 768px) {\n  .rec-content .rec-row {\n    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n    border-radius: 0;\n    min-height: 62px;\n    margin-bottom: 0;\n    padding-left: 10px;\n  }\n  .rec-content .rec-row .span-cost .input-group-addon {\n    min-width: 20px;\n  }\n  .rec-content .rec-row .span-sir,\n  .rec-content .rec-row .span-savings {\n    padding-top: 21px;\n  }\n  .rec-content .rec-row .btn-go {\n    border-top-right-radius: 0;\n  }\n  .rec-content .span-accept .btn {\n    padding: 8px 4px;\n    font-size: 0.85em;\n  }\n}\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: 992px) {\n  .rec-content .span-accept .btn {\n    padding: 6px 9px;\n    font-size: 1em;\n  }\n  .rec-content .span-cost {\n    width: 100%;\n  }\n}\n/* Large devices (large desktops, 1200px and up) */\n.rec-single {\n  /* Photo row styling*/\n}\n.rec-single .span-rec-name .form-group {\n  margin-bottom: 0;\n}\n.rec-single .span-accept .btn {\n  padding-left: 8px;\n  padding-right: 8px;\n}\n.rec-single .btn-up,\n.rec-single .btn-down {\n  border-radius: 0;\n  border-right: none;\n  background-image: none;\n  border-bottom: none;\n  border-top: none;\n  border-left: none;\n  padding: 6px 9px;\n}\n.rec-single .btn-up:focus,\n.rec-single .btn-down:focus {\n  background-color: #f2f2f2;\n}\n.rec-single .btn-up:active,\n.rec-single .btn-down:active {\n  background-color: #c9c9c9;\n}\n.rec-single .btn-down {\n  border-top: 1px solid #e8e8e8;\n}\n.rec-single .rec-blank-state {\n  padding: 10px;\n  margin: 20px 0;\n  border-radius: 2px;\n}\n.rec-single .span-value {\n  padding-top: 7px;\n}\n.rec-single .photo-row-container {\n  padding-bottom: 20px;\n}\n.rec-single .photo-row {\n  padding-top: 10px;\n  padding-bottom: 5px;\n  transition: outline 0.2s ease;\n  position: relative;\n  border-bottom: 1px dashed #ccc;\n  max-height: 1000px;\n  overflow: hidden;\n  opacity: 1;\n  transform: scale(1);\n}\n.rec-single .photo-row.photo-row-deleting {\n  -webkit-animation: fadeOut 0.2s ease-in forwards, shrinkHeight 0.5s ease-in forwards;\n  animation: fadeOut 0.2s ease-in forwards, shrinkHeight 0.5s ease-in forwards;\n}\n.rec-single .photo-row:first-child .span-priorities .btn-up {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.rec-single .photo-row:first-child .span-priorities .btn-up:hover {\n  background-color: #f2f2f2;\n}\n.rec-single .photo-row:last-child .span-priorities .btn-down {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.rec-single .photo-row:last-child .span-priorities .btn-down:hover {\n  background-color: #f2f2f2;\n}\n.rec-single .photo-row h4 {\n  padding: 4px 0;\n}\n.rec-single .photo-row.highlight-delete {\n  background-color: #f1e3e3;\n}\n.rec-single .photo-row .photo-caption {\n  height: 115px;\n}\n.rec-single .photo-row .uploader-container .uploadcare-widget-circle--canvas {\n  display: none;\n}\n.rec-single textarea.form-control {\n  border: none;\n  box-shadow: none;\n  background-color: transparent;\n}\n.rec-single textarea.form-control:hover {\n  background-color: #feeeda;\n}\n.rec-single textarea.form-control:hover:active,\n.rec-single textarea.form-control:hover:focus {\n  background-color: transparent;\n}\n/* Extra small devices (phones, less than 768px) */\n/* No media query since this is the default in Bootstrap */\n/* ONLY extra small devices (phones less than 768px) */\n/* Small devices (tablets, 768px and up) */\n/* Medium devices (desktops, 992px and up) */\n/* Large devices (large desktops, 1200px and up) */\n.recommendation-content .recommendation-area {\n  border-top: none;\n  border-right: 1px solid #cdcdcd;\n  border-bottom: 1px solid #cdcdcd;\n  border-left: 1px solid #cdcdcd;\n}\n.recommendation-content .recommendation-area .section-header {\n  margin-top: 34px;\n  border-bottom: 1px solid #e2e2e2;\n}\n.recommendation-content .recommendation-area .section-header .control-label {\n  padding-top: 0;\n}\n.clearfix {\n  *zoom: 1;\n}\n.clearfix:before,\n.clearfix:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.clearfix:after {\n  clear: both;\n}\n.r-row {\n  margin-left: -18px;\n  *zoom: 1;\n}\n.r-row:before,\n.r-row:after {\n  content: \" \";\n  display: table;\n}\n.r-row:after {\n  clear: both;\n}\n.r-row:before,\n.r-row:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.r-row:after {\n  clear: both;\n}\n[class*='r-spa'] {\n  float: left;\n  min-height: 5px;\n  margin-left: 18px;\n}\n.r-container,\n.r-navbar-static-top .container,\n.r-navbar-fixed-top .container,\n.r-navbar-fixed-bottom .container {\n  width: 942px;\n}\n.r-spa12 {\n  width: 942px;\n}\n.r-spa11 {\n  width: 862px;\n}\n.r-spa10 {\n  width: 782px;\n}\n.r-spa9 {\n  width: 702px;\n}\n.r-spa8 {\n  width: 622px;\n}\n.r-spa7 {\n  width: 542px;\n}\n.r-spa6 {\n  width: 462px;\n}\n.r-spa5 {\n  width: 382px;\n}\n.r-spa4 {\n  width: 302px;\n}\n.r-spa3 {\n  width: 222px;\n}\n.r-spa2 {\n  width: 142px;\n}\n.r-spa1 {\n  width: 62px;\n}\n.r-offset12 {\n  margin-left: 978px;\n}\n.r-offset11 {\n  margin-left: 898px;\n}\n.r-offset10 {\n  margin-left: 818px;\n}\n.r-offset9 {\n  margin-left: 738px;\n}\n.r-offset8 {\n  margin-left: 658px;\n}\n.r-offset7 {\n  margin-left: 578px;\n}\n.r-offset6 {\n  margin-left: 498px;\n}\n.r-offset5 {\n  margin-left: 418px;\n}\n.r-offset4 {\n  margin-left: 338px;\n}\n.r-offset3 {\n  margin-left: 258px;\n}\n.r-offset2 {\n  margin-left: 178px;\n}\n.r-offset1 {\n  margin-left: 98px;\n}\n[class*='r-spa'].hide,\n.row-fluid [class*='r-spa'].hide {\n  display: none;\n}\n[class*='r-spa'].pull-right,\n.row-fluid [class*='r-spa'].pull-right {\n  float: right;\n}\n.repaginate-report {\n  position: fixed;\n  left: 10px;\n  bottom: 10px;\n}\n.popover.popover-report-settings .popover-title {\n  font-weight: 600;\n  font-size: 16px;\n  padding: 10px 14px;\n}\n.popover.popover-report-settings .popover-content {\n  padding: 0;\n}\n.popover.popover-report-settings-pages .arrow {\n  left: 50px;\n  right: auto;\n}\n.popover.popover-report-settings-elements .arrow {\n  left: 106px;\n  right: auto;\n}\n.popover.popover-report-themes {\n  max-width: 250px;\n}\n.popover.popover-report-themes .arrow {\n  left: 156px;\n  right: auto;\n}\n.popover.popover-report-signature-pages {\n  max-width: 250px;\n  left: 200px;\n}\n.popover.popover-report-signature-pages .arrow {\n  right: 56px;\n  left: auto;\n}\n.popover-report-link-items {\n  padding: 8px 12px;\n  border-radius: 6px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 4px;\n}\n.popover-report-link-items:last-child {\n  margin-bottom: 4px;\n}\n.popover-report-link-items:hover {\n  background-color: #e6e6e6;\n}\n.scroll-spy.report-scroll-spy {\n  position: fixed;\n  background: #e8e8e8;\n  width: 100%;\n  z-index: 12;\n  height: auto;\n  top: 25px;\n  padding: 0;\n  opacity: 1;\n  border-top: 1px solid #cccccc;\n}\n.content-header.content-header-report {\n  background-color: #f2f2f2;\n  min-height: 46px;\n  height: auto;\n}\n.content-header.content-header-report h1 {\n  width: 85%;\n  display: inline-block;\n  font-weight: 300;\n  margin: 0;\n  font-size: 18px;\n  color: #575757;\n  line-height: 46px;\n}\n.content-header.content-header-report h1 input[type='text'] {\n  width: 100%;\n}\n.content-header.content-header-report .rep-toolbar {\n  width: 100%;\n  height: 46px;\n  float: left;\n}\n.content-header.content-header-report .rep-toolbar .rep-btn {\n  position: relative;\n  text-align: center;\n  color: #303232;\n  background-color: transparent;\n  white-space: inherit;\n  font-size: 11px;\n  min-width: 46px;\n  min-height: 42px;\n  padding: 5px 4px 3px;\n  margin: 2px 4px 3px 0;\n}\n.content-header.content-header-report .rep-toolbar .rep-btn [class^='ico-'],\n.content-header.content-header-report .rep-toolbar .rep-btn [class*=' ico-'] {\n  display: block;\n  float: none;\n  font-size: 18px;\n  line-height: 18px;\n}\n.content-header.content-header-report .rep-toolbar .rep-btn:last-child {\n  margin-right: 0;\n}\n.content-header.content-header-report .rep-toolbar .rep-btn:hover {\n  -webkit-box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\n  background-color: inherit;\n}\n.content-header.content-header-report .rep-toolbar .rep-btn:active,\n.content-header.content-header-report .rep-toolbar .rep-btn:focus,\n.content-header.content-header-report .rep-toolbar .rep-btn.active {\n  -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);\n  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);\n  background-color: #e3e3e3;\n}\n.content-header.content-header-report .rep-toolbar-report {\n  text-align: center;\n}\n.content-header.content-header-report .rep-toolbar-page {\n  float: left;\n  text-align: center;\n}\n.content-header.content-header-report .rep-toolbar-page > .btn {\n  width: 20%;\n}\n.themes-list {\n  margin: 0;\n  padding: 0;\n}\n.themes-list .btn {\n  width: 100%;\n  clear: both;\n  float: none;\n  text-align: left;\n  border-radius: 3px;\n  padding: 10px;\n}\n.themes-list .btn.active {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.themes-list .report-theme {\n  width: 60px;\n  height: 40px;\n  margin: 0 10px 0 0;\n}\n.report-theme {\n  height: 17px;\n  width: 25px;\n  margin: auto;\n  border-radius: 2px;\n  margin-bottom: 3px;\n  border: 1px solid #303232;\n}\n.report-present {\n  background: #e4e4e4;\n  padding-top: 5px;\n  min-width: 982px;\n}\n.in-app-report .content {\n  background-color: #fafafa;\n  overflow-x: scroll;\n  padding-top: 50px;\n}\n.in-app-report .editable-page-header {\n  margin-right: 20px;\n  width: 676px;\n}\n.in-app-report .report-photo-row textarea {\n  opacity: 0;\n  padding: 10px 5px 5px;\n}\n.in-app-report .report-photo-row textarea:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.in-app-report .report-photo-row textarea:focus {\n  -webkit-box-shadow: 0 0 10px #a2a6a6;\n  box-shadow: 0 0 10px #a2a6a6;\n  border-color: #afb2b2;\n  opacity: 1;\n  transition: opacity 0.2s ease;\n}\n.in-app-report .report-page {\n  zoom: 70%;\n  margin: 10px 0;\n  border-radius: 4px;\n  opacity: 1;\n  padding: 10px;\n  width: 965px;\n  -webkit-box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);\n}\n.in-app-report .report-page .report-body,\n.in-app-report .report-page .report-main {\n  height: auto;\n  overflow: visible;\n  min-height: 659px;\n}\n.in-app-report .report-page .report-sidebar {\n  height: auto;\n  min-height: 659px;\n  position: absolute;\n  bottom: 10px;\n  top: 10px;\n  width: 222px;\n}\n.in-app-report .report-page .report-sidebar dl dt {\n  max-width: 145px;\n}\n.in-app-report .report-page .report-sidebar-v2 {\n  min-height: 659px;\n}\n.report-page {\n  font-family: 'Open Sans', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  background-color: #fff;\n  border: 1px solid #d9d9d9;\n  padding: 30px;\n  margin: 10px 9px 20px 20px;\n  width: 1005px;\n  position: relative;\n  border-radius: 4px;\n  /* -- warn if printing on the in-app report page -- */\n}\n.report-page h1,\n.report-page h2,\n.report-page h3,\n.report-page h4,\n.report-page h5,\n.report-page h6 {\n  margin: 0 0 10px 0;\n  text-rendering: optimizespeed;\n}\n.report-page h1 {\n  color: #182416;\n  font-size: 32px;\n  font-weight: 600;\n  margin: 10px 0 0;\n}\n.report-page h2 {\n  color: #555555;\n  font-size: 22px;\n  font-weight: 600;\n}\n.report-page h3 {\n  color: #2f2f2f;\n  font-size: 18px;\n  font-weight: 600;\n  margin-bottom: 5px;\n}\n.report-page h4 {\n  color: #262626;\n  font-size: 16px;\n  font-weight: 400;\n  margin-bottom: 5px;\n}\n.report-page h5 {\n  color: #262626;\n  font-size: 15px;\n  margin-bottom: 5px;\n}\n.report-page h6 {\n  margin: 0px;\n}\n.report-page p {\n  line-height: 18px;\n}\n.report-page a {\n  color: #4182d0;\n}\n.report-page hr.thick {\n  border-top: 4px solid #eeeeee;\n}\n.report-page .report-header {\n  *zoom: 1;\n  height: 60px;\n  overflow: hidden;\n}\n.report-page .report-header:before,\n.report-page .report-header:after {\n  content: \" \";\n  display: table;\n}\n.report-page .report-header:after {\n  clear: both;\n}\n.report-page .report-header:before,\n.report-page .report-header:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.report-page .report-header:after {\n  clear: both;\n}\n.report-page .report-header .company img {\n  height: 60px;\n  width: auto;\n}\n.report-page .report-header .program-branding {\n  height: 55px;\n  overflow: hidden;\n  text-align: right;\n  font-size: 12px;\n  *zoom: 1;\n}\n.report-page .report-header .program-branding:before,\n.report-page .report-header .program-branding:after {\n  content: \" \";\n  display: table;\n}\n.report-page .report-header .program-branding:after {\n  clear: both;\n}\n.report-page .report-header .program-branding:before,\n.report-page .report-header .program-branding:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.report-page .report-header .program-branding:after {\n  clear: both;\n}\n.report-page .report-header .program-branding span {\n  float: right;\n  text-align: right;\n  display: block;\n}\n.report-page .report-header .report-title {\n  height: 60px;\n  overflow-y: hidden;\n  position: relative;\n}\n.report-page .report-header .report-title .report-title-input {\n  color: #182416;\n  font-size: 36px;\n  margin: 0;\n  height: auto;\n  padding: 1px 0 0 0;\n  width: 99%;\n}\n.report-page .report-logo {\n  height: 60px;\n  overflow: hidden;\n  *zoom: 1;\n}\n.report-page .report-logo:before,\n.report-page .report-logo:after {\n  content: \" \";\n  display: table;\n}\n.report-page .report-logo:after {\n  clear: both;\n}\n.report-page .report-logo:before,\n.report-page .report-logo:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.report-page .report-logo:after {\n  clear: both;\n}\n.report-page .report-logo img {\n  float: left;\n  min-height: 30px;\n  display: block;\n  max-height: 55px;\n  max-width: 222px;\n  width: auto;\n  height: auto;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.report-page .report-logo h2 {\n  text-align: center;\n  padding: 8px 3px;\n  font-size: 18px;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.report-page .report-logo-area {\n  height: 60px;\n  text-align: center;\n}\n.report-page .report-logo-area span {\n  display: block;\n  padding-top: 25px;\n}\n.report-page .report-body {\n  height: 659px;\n}\n.report-page .report-sidebar-borderless {\n  position: relative;\n  height: 659px;\n}\n.report-page .report-sidebar {\n  position: relative;\n  height: 659px;\n  border-radius: 3px;\n  line-height: 1.3em;\n}\n.report-page .report-sidebar h3 {\n  margin-top: 10px;\n  font-size: 16px;\n  font-weight: 600;\n}\n.report-page .report-sidebar dl {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  line-height: 1em;\n  *zoom: 1;\n}\n.report-page .report-sidebar dl:before,\n.report-page .report-sidebar dl:after {\n  content: \" \";\n  display: table;\n}\n.report-page .report-sidebar dl:after {\n  clear: both;\n}\n.report-page .report-sidebar dl:before,\n.report-page .report-sidebar dl:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.report-page .report-sidebar dl:after {\n  clear: both;\n}\n.report-page .report-sidebar dl dt {\n  float: left;\n  font-weight: normal;\n  max-width: 125px;\n  min-width: 100px;\n  margin-bottom: 6px;\n  line-height: 18px;\n  *zoom: 1;\n}\n.report-page .report-sidebar dl dt:before,\n.report-page .report-sidebar dl dt:after {\n  content: \" \";\n  display: table;\n}\n.report-page .report-sidebar dl dt:after {\n  clear: both;\n}\n.report-page .report-sidebar dl dt:before,\n.report-page .report-sidebar dl dt:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.report-page .report-sidebar dl dt:after {\n  clear: both;\n}\n.report-page .report-sidebar dl dd {\n  float: right;\n  margin-bottom: 6px;\n  line-height: 18px;\n}\n.report-page .sidebar-header {\n  padding: 12px;\n  border-radius: 3px 3px 0 0;\n}\n.report-page .sidebar-header h3 {\n  font-size: 14px;\n  margin: 0;\n  text-transform: uppercase;\n  font-weight: 500;\n}\n.report-page .sidebar-body {\n  position: relative;\n  height: 100%;\n}\n.report-page .sidebar-body input[type='date'],\n.report-page .sidebar-body input[type='time'],\n.report-page .sidebar-body input[type='datetime-local'],\n.report-page .sidebar-body input[type='month'] {\n  line-height: 1.42;\n}\n.report-page .header-key-value {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n.report-page .header-key-value .sidebar-label {\n  font-size: 12px;\n  line-height: 1.42;\n  color: #fff;\n  font-weight: 600;\n}\n.report-page .header-key-value .sidebar-value {\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #fff;\n}\n.report-page .sidebar-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 8px 12px;\n  font-size: 12px;\n  line-height: 1.5;\n  font-weight: 500;\n  color: #333;\n}\n.report-page .sidebar-section p {\n  font-size: 12px;\n  line-height: 1.5;\n  font-weight: 500;\n  color: #333;\n}\n.report-page .sidebar-section.medium-font {\n  font-size: 14px;\n  line-height: 1.5;\n}\n.report-page .sidebar-section.medium-font p {\n  font-size: 14px;\n  line-height: 1.5;\n}\n.report-page .sidebar-section.small-font {\n  font-size: 12px;\n  line-height: 1.5;\n}\n.report-page .sidebar-section.small-font p {\n  font-size: 12px;\n  line-height: 1.5;\n}\n.report-page .sidebar-section.solid-separator {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.report-page .sidebar-section.dashed-separator {\n  border-bottom: 1px dashed rgba(0, 0, 0, 0.2);\n}\n.report-page .sidebar-section:last-child {\n  border-bottom: none;\n}\n.report-page .sidebar-section-title {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #111;\n  margin: 8px 0 0 0;\n}\n.report-page .sidebar-section-title.medium-font {\n  font-size: 14px;\n}\n.report-page .sidebar-key-value-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n.report-page .solid-separator {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.report-page .dashed-separator {\n  border-bottom: 1px dashed rgba(0, 0, 0, 0.2);\n}\n.report-page .sidebar-key-value-horizontal {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  gap: 4px;\n  padding: 6px 0;\n}\n.report-page .sidebar-key-value-horizontal .sidebar-label {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.42;\n  color: #333;\n  text-align: left;\n}\n.report-page .sidebar-key-value-horizontal .sidebar-value {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 1.42;\n  color: #111;\n  text-align: right;\n}\n.report-page .sidebar-key-value-horizontal.solid-separator {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.report-page .sidebar-key-value-horizontal.solid-separator:last-child {\n  border-bottom: none;\n}\n.report-page .sidebar-key-value-horizontal.dashed-separator {\n  border-bottom: 1px dashed rgba(0, 0, 0, 0.2);\n}\n.report-page .sidebar-key-value-horizontal.dashed-separator:last-child {\n  border-bottom: none;\n}\n.report-page .sidebar-key-value-horizontal:first-child {\n  padding-top: 0;\n}\n.report-page .sidebar-key-value-horizontal:last-child {\n  padding-bottom: 0;\n}\n.report-page .sidebar-key-value-horizontal.reverse-order {\n  flex-direction: row-reverse;\n}\n.report-page .sidebar-key-value-vertical {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 12px 0;\n}\n.report-page .sidebar-key-value-vertical .sidebar-label {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #555;\n}\n.report-page .sidebar-key-value-vertical .sidebar-value {\n  font-size: 20px;\n  line-height: 1.42;\n  color: #111;\n  font-weight: 600;\n}\n.report-page .sidebar-key-value-vertical:first-child {\n  padding-top: 0;\n}\n.report-page .sidebar-key-value-vertical:last-child {\n  padding-bottom: 0;\n}\n.report-page .sidebar-key-value-vertical.solid-separator {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n.report-page .sidebar-key-value-vertical.solid-separator:last-child {\n  border-bottom: none;\n}\n.report-page .sidebar-key-value-vertical.dashed-separator {\n  border-bottom: 1px dashed rgba(0, 0, 0, 0.2);\n}\n.report-page .sidebar-key-value-vertical.dashed-separator:last-child {\n  border-bottom: none;\n}\n.report-page .sidebar-key-value-vertical.reverse-order {\n  flex-direction: column-reverse;\n}\n.report-page .sidebar-key-value-vertical.no-bottom-spacing {\n  padding-bottom: 0;\n}\n.report-page .uppercase {\n  text-transform: uppercase;\n}\n.report-page .report-sidebar-v2 {\n  height: 659px;\n  border-radius: 3px;\n  position: relative;\n}\n.report-page .report-sidebar-v2--title {\n  font-size: 16px;\n  color: #000000;\n  line-height: 1.5;\n  font-weight: 600;\n  padding-left: 16px;\n  padding-right: 16px;\n  padding-top: 11px;\n  padding-bottom: 12px;\n  margin-bottom: 0;\n}\n.report-page .report-main {\n  height: 659px;\n  overflow: hidden;\n}\n.report-page .report-photo-row {\n  border-radius: 3px;\n}\n.report-page .report-footer {\n  *zoom: 1;\n  padding-top: 10px;\n  color: #797979;\n  height: 35px;\n  font-size: 12px;\n}\n.report-page .report-footer:before,\n.report-page .report-footer:after {\n  content: \" \";\n  display: table;\n}\n.report-page .report-footer:after {\n  clear: both;\n}\n.report-page .report-footer:before,\n.report-page .report-footer:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.report-page .report-footer:after {\n  clear: both;\n}\n.report-page .report-footer .program-logo-footer {\n  max-height: 25px;\n  width: auto;\n  margin-left: 5px;\n}\n.report-page .recommendation-category-label {\n  font-size: 15px;\n  margin-bottom: 12px;\n  color: rgba(0, 0, 0, 0.7);\n  text-transform: uppercase;\n}\n.report-page .notes-header,\n.report-page .now-and-goals-header {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #555;\n}\n.report-page .upgrade-details-section {\n  margin-top: 6px;\n  padding-top: 6px;\n}\n.report-page.report-page-cover .report-body .report-main .snugg-upload-prompt-text {\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  height: 150px;\n  width: 160px;\n  text-align: center;\n  font-size: 24px;\n  color: #777777;\n  cursor: pointer;\n}\n.report-page.report-page-cover .report-body .report-main .uploadcare--widget__button.uploadcare--widget__button_type_open {\n  display: none !important;\n}\n.report-page.report-page-cover .report-body .report-main .uploadcare-widget-disabled .ico-budicon-10 {\n  height: 150px;\n  width: 160px;\n}\n.report-page.report-page-cover .report-body .report-main .uploadcare-widget-disabled {\n  display: block !important;\n  width: 99.5%;\n  height: 347px;\n  font-size: 24px;\n}\n.report-page.report-page-cover .report-body .report-main .uploadcare--widget {\n  display: block !important;\n  width: 99.5%;\n  height: 347px;\n  font-size: 24px;\n}\n.report-page.report-page-cover .report-body .report-main .uploadcare--widget .uploadcare--widget__dragndrop-area {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  border-radius: 0;\n  padding: 0 !important;\n  left: 0 !important;\n  margin: 0;\n  line-height: normal;\n  padding: 0;\n  top: 0;\n  display: block;\n  cursor: pointer;\n}\n.report-page.report-page-cover .report-body .report-main .uploadcare--widget.uploadcare--widget .uploadcare--widget__circle {\n  display: none;\n}\n.report-page.report-page-cover .report-body .report-main .uploader-container {\n  width: 99.5%;\n  height: 347px;\n  font-size: 24px;\n}\n.report-page .intro-cover .wysiwyg {\n  height: 270px;\n  border: 1px dashed #bbb;\n}\n.report-page .intro-cover .wysiwyg:focus {\n  border: 1px solid #bbb;\n}\n.report-page.report-page-metrics h6 {\n  font-size: 1em;\n}\n.report-page.report-page-hes .report-header {\n  overflow: visible;\n}\n.report-page.report-page-hes .report-main {\n  overflow: visible;\n}\n.report-page.report-page-hes .nav.nav-tabs li > a {\n  padding: 10px 20px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #c84900;\n}\n.report-page.report-page-hes .nav.nav-tabs li.active > a {\n  color: #333;\n}\n.report-page.report-page-hes .hes-home {\n  padding-top: 30px;\n  padding-left: 20px;\n}\n.report-page.report-page-hes .hes-home dt {\n  font-size: 11px;\n  color: #196234;\n  text-transform: uppercase;\n  width: 120px;\n  padding-top: 3px;\n  padding-right: 10px;\n  font-weight: 600;\n  float: left;\n  clear: left;\n}\n.report-page.report-page-hes .hes-home dd {\n  float: left;\n  font-weight: 700;\n  font-size: 15px;\n}\n.report-page.report-page-hes .hes-container {\n  margin-top: 30px;\n  margin-left: 20px;\n  margin-right: 10px;\n  padding: 90px 0 15px 85px;\n  position: relative;\n  border-bottom: 4px solid #223f74;\n  *zoom: 1;\n}\n.report-page.report-page-hes .hes-container:before,\n.report-page.report-page-hes .hes-container:after {\n  content: \" \";\n  display: table;\n}\n.report-page.report-page-hes .hes-container:after {\n  clear: both;\n}\n.report-page.report-page-hes .hes-container:before,\n.report-page.report-page-hes .hes-container:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.report-page.report-page-hes .hes-container:after {\n  clear: both;\n}\n.report-page.report-page-hes .hes-legend {\n  float: left;\n  min-height: 60px;\n  padding: 24px 5px 0;\n  text-align: left;\n  font-weight: 600;\n  font-size: 12px;\n}\n.report-page.report-page-hes .hes-legend:last-child {\n  text-align: left;\n}\n.report-page.report-page-hes .hes-spectrum {\n  position: relative;\n  float: left;\n}\n.report-page.report-page-hes .hes-spectrum ul {\n  text-align: center;\n  background: #d9d9d9;\n  background: -moz-linear-gradient(left, #d9d9d9 0%, #cbd4bf 44%, #89c648 97%, #89c648 100%);\n  background: -webkit-gradient(left top, right top, color-stop(0%, #d9d9d9), color-stop(44%, #cbd4bf), color-stop(97%, #89c648), color-stop(100%, #89c648));\n  background: -webkit-linear-gradient(left, #d9d9d9 0%, #cbd4bf 44%, #89c648 97%, #89c648 100%);\n  background: -o-linear-gradient(left, #d9d9d9 0%, #cbd4bf 44%, #89c648 97%, #89c648 100%);\n  background: -ms-linear-gradient(left, #d9d9d9 0%, #cbd4bf 44%, #89c648 97%, #89c648 100%);\n  background: linear-gradient(to right, #d9d9d9 0%, #cbd4bf 44%, #89c648 97%, #89c648 100%);\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#d9d9d9', endColorstr='#89c648', GradientType=1);\n  display: inline-block;\n  float: left;\n  *zoom: 1;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  font-weight: 700;\n  font-size: 20px;\n}\n.report-page.report-page-hes .hes-spectrum ul:before,\n.report-page.report-page-hes .hes-spectrum ul:after {\n  content: \" \";\n  display: table;\n}\n.report-page.report-page-hes .hes-spectrum ul:after {\n  clear: both;\n}\n.report-page.report-page-hes .hes-spectrum ul:before,\n.report-page.report-page-hes .hes-spectrum ul:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.report-page.report-page-hes .hes-spectrum ul:after {\n  clear: both;\n}\n.report-page.report-page-hes .hes-spectrum ul li {\n  padding: 35px 0;\n  margin: 0;\n  float: left;\n  border-right: 3px solid white;\n  box-sizing: border-box;\n}\n.report-page.report-page-hes .hes-spectrum ul li:last-child {\n  border-right: none;\n}\n.report-page.report-page-hes .hes-definition {\n  padding-left: 20px;\n  padding-top: 15px;\n  font-size: 0.85em;\n}\n.report-page.report-page-hes .hes-stats {\n  margin-top: 15px;\n  color: #959394;\n  font-weight: 700;\n  text-align: right;\n  font-size: 10px;\n}\n.print-preview .report-page {\n  zoom: 100%;\n  margin: 8px auto 20px;\n}\n.print-preview.sample-job .report-page:after {\n  content: 'Sample';\n  position: absolute;\n  z-index: 2;\n  left: 20%;\n  top: 30%;\n  font-size: 180px;\n  text-transform: uppercase;\n  font-family: 'open sans', 'helvetica neue', helvetica, arial;\n  -webkit-transform: rotate(-25deg);\n  -moz-transform: rotate(-25deg);\n  -ms-transform: rotate(-25deg);\n  transform: rotate(-25deg);\n  font-family: 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif;\n  font-weight: 300;\n  color: rgba(0, 0, 0, 0.24);\n}\n.discrete-navigation {\n  color: #fff;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.7);\n  border-radius: 3px;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);\n  opacity: 0.65;\n  transition: all 0.2s ease;\n}\n.discrete-navigation:hover,\n.discrete-navigation:focus,\n.discrete-navigation:focus-within {\n  opacity: 1;\n}\n.discrete-navigation .btn {\n  font-size: 11px;\n  text-align: 'center';\n  line-height: 1em;\n  background-color: transparent;\n  border-radius: 0;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.35);\n  display: block;\n  width: 100%;\n  color: #fff;\n  padding: 12px 12px;\n}\n.discrete-navigation .btn:hover,\n.discrete-navigation .btn:focus {\n  background-color: rgba(0, 0, 0, 0.75);\n}\n.discrete-navigation .btn:active {\n  color: #ff9003;\n  background-color: #000000;\n}\n.discrete-navigation .btn:first-child {\n  border-radius: 3px;\n}\n.discrete-navigation .btn:last-child {\n  border-bottom: none;\n  margin-bottom: 0;\n  border-radius: 3px;\n}\n.discrete-navigation--right {\n  position: fixed;\n  right: 5px;\n  top: 5px;\n  z-index: 1000;\n}\n.discrete-navigation--left {\n  position: fixed;\n  left: 5px;\n  top: 5px;\n  z-index: 1000;\n}\nbody {\n  counter-reset: page;\n}\n.report-footer {\n  counter-increment: page;\n}\n.pageNumber {\n  float: right;\n  padding-right: 50px;\n}\n.pageNumber:before {\n  content: '– ' counter(page) ' –';\n}\n@media print {\n  * {\n    text-shadow: none !important;\n    filter: none !important;\n    -ms-filter: none !important;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n  body {\n    background: none;\n    background-image: none;\n  }\n  body .report-present {\n    background: none;\n    background-image: none;\n    padding-top: 0;\n  }\n  .hidden-print {\n    display: none !important;\n  }\n  a.print-link[href^='http'] {\n    font-weight: 700;\n    text-decoration: none;\n  }\n  a.print-link[href^='http']:after {\n    content: ' <' attr(href) '> ';\n  }\n  .content {\n    background-image: none !important;\n    background: transparent !important;\n    padding: none !important;\n    margin: none !important;\n    border: none !important;\n  }\n  .discrete-navigation {\n    display: none !important;\n  }\n  .print-preview .report-page {\n    padding: 0.3in 0.5in 0.2in;\n    margin: 0 !important;\n    border: none !important;\n    width: auto !important;\n    page-break-inside: avoid;\n    page-break-after: always;\n  }\n  .print-preview .report-page:last-child {\n    page-break-after: avoid;\n  }\n  .r-container {\n    margin: 0 !important;\n    padding: 0 !important;\n    border: none;\n    position: relative;\n    opacity: 1;\n  }\n  .r-container img {\n    max-width: 100% !important;\n  }\n  .r-container .cover-photo-replace,\n  .r-container .cover-photo-upload {\n    display: none;\n  }\n  .r-container .img-border {\n    outline: 0;\n  }\n  .r-container .editor-area {\n    border: none;\n  }\n  .r-container .editor-area:hover,\n  .r-container .editor-area:focus {\n    border: none;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    outline: none;\n  }\n  .repaginate-report {\n    display: none;\n  }\n}\n@page {\n  size: letter landscape;\n  margin: 0mm;\n}\n/* Extra small devices (phones, less than 768px) */\n/* No media query since this is the default in Bootstrap */\n/* ONLY extra small devices (phones less than 768px) */\n@media (max-width: 767px) {\n  .rep-toolbar {\n    border-bottom: 1px solid #d9d9d9;\n  }\n}\n/* Small devices (tablets, 768px and up) */\n@media (min-width: 768px) {\n  .content-header.content-header-report .rep-toolbar .rep-btn {\n    max-width: 56px;\n  }\n  .content-header.content-header-report .rep-toolbar-title {\n    width: 240px;\n  }\n  .content-header.content-header-report .rep-toolbar-page {\n    width: 242px;\n  }\n}\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: 992px) {\n  .in-app-report .report-page {\n    zoom: 85%;\n  }\n  .in-app-report .editable-page-header {\n    margin-right: 20px;\n    width: 821px;\n  }\n}\n/* Large devices (large desktops, 1200px and up) */\n@media (min-width: 1200px) {\n  .in-app-report .report-page {\n    zoom: 100%;\n  }\n  .in-app-report .editable-page-header {\n    margin-right: 20px;\n    width: 965px;\n  }\n}\n.img-polaroid {\n  padding: 4px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n.cards {\n  *zoom: 1;\n  margin-bottom: 24px;\n}\n.cards:before,\n.cards:after {\n  content: \" \";\n  display: table;\n}\n.cards:after {\n  clear: both;\n}\n.cards:before,\n.cards:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.cards:after {\n  clear: both;\n}\n.cards .cards-row {\n  *zoom: 1;\n}\n.cards .cards-row:before,\n.cards .cards-row:after {\n  content: \" \";\n  display: table;\n}\n.cards .cards-row:after {\n  clear: both;\n}\n.cards .cards-row:before,\n.cards .cards-row:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.cards .cards-row:after {\n  clear: both;\n}\n.cards .card {\n  display: inline-block;\n  vertical-align: bottom;\n  width: 250px;\n  margin-right: 20px;\n  margin-top: 20px;\n  float: left;\n  border-radius: 4px;\n  background-color: white;\n  border: solid 1px #e2e2e2;\n  color: inherit;\n  position: relative;\n}\n.cards .card:after {\n  content: '';\n  position: absolute;\n  z-index: -1;\n  -webkit-box-shadow: 0 2px 8px rgba(48, 50, 50, 0.2);\n  box-shadow: 0 2px 8px rgba(48, 50, 50, 0.2);\n  bottom: 0;\n  left: 10px;\n  right: 10px;\n  height: 50%;\n  width: auto;\n}\n.cards .card:hover,\n.cards .card:focus {\n  transition: all 0.3s ease;\n  -webkit-box-shadow: 0 2px 8px rgba(48, 50, 50, 0.2);\n  box-shadow: 0 2px 8px rgba(48, 50, 50, 0.2);\n}\n.cards .card:hover:after,\n.cards .card:focus:after {\n  transition: all 0.3s ease;\n  -webkit-box-shadow: 0 5px 12px rgba(48, 50, 50, 0.35);\n  box-shadow: 0 5px 12px rgba(48, 50, 50, 0.35);\n}\n.cards .card:active:after {\n  transition: none;\n  -webkit-box-shadow: 0 12px 22px rgba(48, 50, 50, 0.2);\n  box-shadow: 0 12px 22px rgba(48, 50, 50, 0.2);\n}\n.cards .card.card-fluid {\n  width: 100%;\n}\n.cards .card table.table {\n  margin-bottom: 3px;\n}\n.cards .card table.table tr:first-child td {\n  border-top: none;\n}\n.cards .card table.table td {\n  padding: 10px 3px;\n}\n.cards .card table.table td:nth-child(2) {\n  text-align: right;\n}\n.cards .card table.table.table-striped td {\n  border-color: #e3e3e3;\n}\n.cards .card ul {\n  margin: 0;\n  padding-left: 0;\n}\n.cards .card ul li {\n  font-size: 0.9em;\n  list-style-type: none;\n  padding: 10px 3px;\n  margin: 0 12px;\n  border-bottom: 1px solid #ddd;\n}\n.cards .card ul li:last-child {\n  border-bottom: none;\n}\n.cards .card ul li .value {\n  float: right;\n}\n.cards .card.card-readonly:hover,\n.cards .card.card-readonly:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n.cards .card.card-readonly:hover:after,\n.cards .card.card-readonly:focus:after {\n  -webkit-box-shadow: 0 4px 12px rgba(48, 50, 50, 0.2);\n  box-shadow: 0 4px 12px rgba(48, 50, 50, 0.2);\n}\n.cards .card.card-readonly:active:after {\n  -webkit-box-shadow: 0 4px 12px rgba(48, 50, 50, 0.2);\n  box-shadow: 0 4px 12px rgba(48, 50, 50, 0.2);\n}\n.cards .card.card-rec {\n  position: relative;\n  z-index: 1;\n  margin-bottom: 10px;\n  margin-top: 0;\n  cursor: pointer;\n}\n.cards .card.card-rec:first-child {\n  border-top-width: 1px;\n}\n.cards .card.card-rec:hover {\n  z-index: 2;\n  -webkit-box-shadow: 0 0 10px rgba(48, 50, 50, 0.3);\n  box-shadow: 0 0 10px rgba(48, 50, 50, 0.3);\n}\n.cards .card.card-rec:active {\n  z-index: 3;\n  transition: none;\n  -webkit-box-shadow: 0 1px 14px rgba(48, 50, 50, 0.4);\n  box-shadow: 0 1px 14px rgba(48, 50, 50, 0.4);\n}\n.cards .card.card-rec:active:after {\n  z-index: 4;\n}\n.cards .card .card-rec-header {\n  background-color: #ededed;\n  color: #595959;\n  height: 65px;\n}\n.cards .card .card-header {\n  *zoom: 1;\n  display: block;\n  position: relative;\n  border-radius: 0 !important;\n  padding: 15px 10px 15px 12px;\n  background-color: #f2f2f2;\n  text-align: left;\n  color: #555555;\n  max-width: 100%;\n  font-size: 14px;\n  letter-spacing: 0.02em;\n  line-height: 1em;\n  white-space: nowrap;\n  font-weight: 600;\n}\n.cards .card .card-header:before,\n.cards .card .card-header:after {\n  content: \" \";\n  display: table;\n}\n.cards .card .card-header:after {\n  clear: both;\n}\n.cards .card .card-header:before,\n.cards .card .card-header:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.cards .card .card-header:after {\n  clear: both;\n}\n.cards .card .card-header [class*=' ico-'],\n.cards .card .card-header [class^='ico-'] {\n  display: block;\n  background-color: inherit;\n  margin-left: 8px;\n  opacity: 0.7;\n  float: right;\n}\n.cards .card a.card-header {\n  color: inherit;\n}\n.cards .card a.card-header:hover {\n  cursor: pointer;\n  background: #e5e5e5;\n}\n.cards .card a.card-header:active {\n  background: #dedede;\n}\n.cards .card .card-body {\n  *zoom: 1;\n  padding: 10px 8px;\n}\n.cards .card .card-body:before,\n.cards .card .card-body:after {\n  content: \" \";\n  display: table;\n}\n.cards .card .card-body:after {\n  clear: both;\n}\n.cards .card .card-body:before,\n.cards .card .card-body:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.cards .card .card-body:after {\n  clear: both;\n}\n.cards .card .card-footer {\n  *zoom: 1;\n  padding: 12px 10px 0px;\n  background-color: #f2f2f2;\n  position: relative;\n}\n.cards .card .card-footer:before,\n.cards .card .card-footer:after {\n  content: \" \";\n  display: table;\n}\n.cards .card .card-footer:after {\n  clear: both;\n}\n.cards .card .card-footer:before,\n.cards .card .card-footer:after {\n  display: table;\n  content: '';\n  line-height: 0;\n}\n.cards .card .card-footer:after {\n  clear: both;\n}\n.cards .card .card-footer .card-footer-content {\n  float: left;\n  max-width: 190px;\n  max-height: 20px;\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n.cards .card .card-footer .card-delete {\n  display: inline;\n  font-size: 16px;\n  color: red;\n  margin-left: 10px;\n  margin-top: -10px;\n  margin-right: -11px;\n  border-radius: 0 0 6px 0;\n  padding: 12px 15px;\n}\n.cards .card .card-footer .card-delete:hover {\n  color: #fff;\n  background-color: red;\n}\n.cards .card .card-footer .card-delete:active {\n  color: #fff;\n  background-color: #db0000;\n}\n.cards .card.card-calculator {\n  float: none;\n}\n.cards .card.card-calculator .input-group-addon {\n  padding: 6px;\n}\n/* Small devices (tablets, 768px and up) */\n@media (min-width: 768px) {\n  .cards .card.card-rec {\n    margin-bottom: 1px;\n    border-radius: 0;\n    border: none;\n    background-color: #f2f2f2;\n  }\n  .cards .card.card-rec:nth-child(even) {\n    background-color: #f7f7f7;\n  }\n  .cards .card.card-rec:first-child {\n    border-radius: 6px 6px 0 0;\n  }\n  .cards .card.card-rec:last-child {\n    border-radius: 0 0 6px 6px;\n  }\n  .cards .card .card-rec-header {\n    background-color: inherit;\n    text-align: inherit;\n    color: inherit;\n    height: auto;\n  }\n}\n.alert {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  border-radius: 6px;\n  margin: 10px 0;\n  padding: 12px;\n}\n.alert .alert-style-container {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  width: 100%;\n}\n.alert h4 {\n  font-size: 1em;\n  color: inherit;\n  font-weight: 600;\n  margin: 0;\n}\n.alert p {\n  margin-bottom: 10px;\n}\n.alert.alert-live {\n  padding: 0;\n  border-radius: 0;\n  display: inline-block;\n  width: auto;\n  border: 0;\n  margin: 5px 0;\n}\n.alert.alert-live.character-counter {\n  display: inline;\n}\n.alert.alert-banner {\n  padding: 5px;\n  text-align: center;\n  border-top-style: solid;\n  margin: 0 -15px;\n  font-size: 12px;\n  border-radius: 0;\n  z-index: 1064;\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  width: auto;\n  left: 15px;\n  border-top: 1px solid #c9dade;\n}\n.alert.alert-banner .alert-message {\n  padding-bottom: 0;\n  text-align: center;\n  color: #333;\n}\n.alert.alert-alert {\n  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  min-width: 500px;\n  min-height: 40px;\n  margin: 4px 0 8px 0;\n  border-radius: 6px;\n  border: none;\n  padding: 16px;\n  box-shadow: 0px 9px 28px 0px rgba(0, 0, 0, 0.05), 0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08);\n  max-width: 500px;\n}\n.alert.alert-alert .close {\n  transition: all 200ms linear;\n  font-size: 24px;\n  font-weight: 300;\n  opacity: 0.3;\n  width: 24px;\n  min-width: 24px;\n  height: 24px;\n  border-radius: 100%;\n  background-color: #fff;\n}\n.alert.alert-alert .close:hover {\n  background-color: #eee;\n  opacity: 0.6;\n}\n@media (max-width: 575.98px) {\n  .alert.alert-alert {\n    min-width: auto;\n    width: 90%;\n  }\n}\n.alert.alert-alert.alert-success {\n  background-color: #ffffff;\n}\n.alert.alert-alert.alert-warning {\n  background-color: #ffffff;\n}\n.alert.alert-alert.alert-error {\n  background-color: #ffffff;\n}\n.alert.alert-alert.alert-minimized {\n  min-width: 200px;\n  max-width: fit-content;\n  position: relative;\n  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n}\n.alert.alert-inline {\n  margin: 20px 0;\n}\n.alert.alert-inline .alert-message {\n  padding-bottom: 0;\n  color: #333;\n}\n.alert.alert-field {\n  margin: 8px 0 8px 0;\n  padding: 0;\n  border: none;\n  background: none;\n  font-size: 12px;\n}\n.alert.alert-field .alert-message {\n  padding-bottom: 0;\n}\n.alert.alert-field img {\n  width: 14px;\n}\n.alert.alert-field .alert-style-container {\n  gap: 6px;\n}\n.alert-content {\n  width: 100%;\n  margin-top: 2px;\n  margin-bottom: 2px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.alert-job-id {\n  margin-left: 10px;\n  font-size: 0.8em;\n  opacity: 0.8;\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 3px;\n  padding: 0 5px;\n  color: #333333;\n}\n.alert-job-id:hover {\n  background-color: rgba(0, 0, 0, 0.2);\n  color: black;\n}\n.alert-job-id:active {\n  background-color: rgba(0, 0, 0, 0.5);\n  color: #eeeeee;\n}\n.alert-message {\n  display: block;\n  color: #333;\n  line-height: 1.5;\n  font-weight: 500;\n}\n.alert.alert-header {\n  margin: 0;\n  border-radius: 0;\n}\n.alert-warning {\n  background-color: #faf0cb;\n  color: #333;\n  border: 1px solid #e1d8b7;\n}\n.alert-warning .alert-title {\n  color: #e38016;\n}\n.alert-error {\n  background-color: #fdf5f4;\n  color: #333;\n  border-color: #f7d5d2;\n  border-style: solid;\n  border-width: 1px;\n}\n.alert-error h2,\n.alert-error h3,\n.alert-error h4,\n.alert-error h5 {\n  color: #d92d20;\n}\n.alert-error .alert-title {\n  color: #d92d20;\n}\n.alert-success {\n  background-color: #f3faf7;\n  color: #333;\n  border-color: #cdeadd;\n  border-style: solid;\n  border-width: 1px;\n}\n.alert-success .alert-title {\n  color: #039855;\n}\n.alert-info {\n  background-color: #f5f8ff;\n  color: #333;\n  border-color: #d7e3fd;\n  border-style: solid;\n  border-width: 1px;\n}\n.alert-info a {\n  color: #144761;\n  text-decoration: underline;\n}\n.alert-info .alert-title {\n  color: #3875f6;\n}\n.alert-neutral {\n  background-color: #f9f9f9;\n  border-color: #eaeaea;\n  box-shadow: inset 0 0 0 1px white;\n  border-style: solid;\n  border-width: 1px;\n}\n.alert-neutral a {\n  color: #c84900;\n}\n.alert-internal {\n  background-color: #28548a;\n  color: white;\n  padding: 20px;\n  -webkit-box-shadow: 0 2px 5px rgba(0, 0, 0, 0.6);\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.6);\n}\n.alert-primary-button {\n  width: auto;\n  display: inline-block;\n  box-shadow: none;\n  padding: 8px 16px 9px;\n  background: #2b2b2b;\n  color: #fff;\n  font-weight: 500;\n  border: none;\n  border-radius: 6px;\n}\n.alert-primary-button:hover {\n  background: #333;\n  color: white;\n}\n.alert-primary-button:active {\n  background: #111;\n}\n.alert-secondary-button {\n  width: auto;\n  display: inline-block;\n  box-shadow: none;\n  padding: 8px 16px 9px;\n  background: #2b2b2b;\n  color: #fff;\n  font-weight: 500;\n  border: none;\n  border-radius: 6px;\n  margin-left: 8px;\n  background: #fff;\n  border: 1px solid #d0d5dd;\n  color: #222;\n}\n.alert-secondary-button:hover {\n  background: #333;\n  color: white;\n}\n.alert-secondary-button:active {\n  background: #111;\n}\n.alert-secondary-button:hover {\n  background: #eee;\n  color: #222;\n}\n.alert-secondary-button:active {\n  background: #ddd;\n}\n/* Extra small devices (phones, less than 768px) */\n/* No media query since this is the default in Bootstrap */\n/* ONLY extra small devices (phones less than 768px) */\n@media (max-width: 767px) {\n  .push-left .alert.alert-alert {\n    margin-left: 5px;\n  }\n  .form-control.input-header.rec-input-header {\n    font-size: 15px;\n    font-weight: 600;\n    min-width: 255px;\n  }\n}\n/* Small devices (tablets, 768px and up) */\n@media (min-width: 768px) {\n  .alert.alert-alert {\n    width: 500px;\n  }\n  .alert.alert-banner {\n    left: 75px;\n  }\n}\n/* Medium devices (desktops, 992px and up) */\n/* ONLY extra short devices (phones less than 568px)  This is a fringe case*/\n@media (max-height: 589px) and (max-width: 767px) {\n  .push-left .side-left {\n    -ms-transform: tranformX(0);\n    transform: tranformX(0);\n    -webkit-transform: tranformX(0);\n    /** Chrome & Safari **/\n    -o-transform: tranformX(0);\n    /** Opera **/\n    -moz-transform: tranformX(0);\n    /** Firefox **/\n  }\n}\n.DraftEditor-root .public-DraftEditorPlaceholder-inner {\n  color: #888;\n  position: absolute;\n}\n.DraftEditor-root .public-DraftEditor-content {\n  min-height: 40px;\n  padding-bottom: 5px;\n}\n.DraftEditor-root .public-DraftEditor-content:hover {\n  background-color: #fdd39e;\n}\n.DraftEditor-root .public-DraftEditor-content:hover:focus {\n  background-color: inherit;\n}\n.DraftEditor-root:focus .public-DraftEditorPlaceholder-inner {\n  display: none;\n}\n.tickets-template .DraftEditor-root .public-DraftEditor-content {\n  min-height: 80px;\n}\n.report-sidebar .DraftEditor-root .public-DraftEditor-content:hover {\n  background-color: rgba(255, 255, 255, 0.85);\n}\n.draft-toolbar {\n  background-color: #000;\n  border: none;\n  border-radius: 50px;\n  font-size: 16px;\n}\n.draft-toolbar .item {\n  float: left;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background-color: #000;\n}\n.draft-toolbar .item:first-child {\n  border-bottom-left-radius: 50px;\n  border-top-left-radius: 50px;\n  padding-left: 6px;\n}\n.draft-toolbar .item:last-child {\n  border-bottom-right-radius: 50px;\n  border-top-right-radius: 50px;\n  padding-right: 6px;\n}\n.draft-toolbar .item.active {\n  background-color: #2f2f2f;\n}\n.draft-toolbar .item:hover {\n  background-color: #2f2f2f;\n}\n.draft-toolbar .item button {\n  background-color: transparent;\n  border: 0;\n  color: white;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: block;\n  font-size: 14px;\n  line-height: 1.33;\n  margin: 0;\n  padding: 15px;\n  text-decoration: none;\n}\n.TeXEditor-container {\n  width: 100%;\n  height: 100%;\n}\n.TeXEditor-root {\n  background: inherit;\n  -webkit-font-smoothing: antialiased;\n}\n.TeXEditor-editor {\n  cursor: text;\n  min-height: 40px;\n}\n.TeXEditor-button {\n  margin-top: 10px;\n  text-align: center;\n}\n.TeXEditor-handle {\n  color: #62b1fe;\n  direction: ltr;\n  unicode-bidi: bidi-override;\n}\n.TeXEditor-hashtag {\n  color: #5fb88a;\n}\n.TeXEditor-tex {\n  background-color: #fff;\n  cursor: pointer;\n  margin: 20px auto;\n  padding: 20px;\n  -webkit-transition: background-color 0.2s fade-in-out;\n  user-select: none;\n  -webkit-user-select: none;\n}\n.TeXEditor-activeTeX {\n  color: #888;\n}\n.TeXEditor-panel {\n  font-family: 'Helvetica', sans-serif;\n  font-weight: 200;\n}\n.TeXEditor-panel .TeXEditor-texValue {\n  border: 1px solid #e1e1e1;\n  display: block;\n  font-family: 'Inconsolata', 'Menlo', monospace;\n  font-size: 14px;\n  height: 110px;\n  margin: 20px auto 10px;\n  outline: none;\n  padding: 14px;\n  resize: none;\n  -webkit-box-sizing: border-box;\n  width: 500px;\n}\n.TeXEditor-buttons {\n  text-align: center;\n}\n.TeXEditor-saveButton,\n.TeXEditor-removeButton {\n  background-color: #fff;\n  border: 1px solid #0a0;\n  cursor: pointer;\n  font-family: 'Helvetica', 'Arial', sans-serif;\n  font-size: 16px;\n  font-weight: 200;\n  margin: 10px auto;\n  padding: 6px;\n  -webkit-border-radius: 3px;\n  width: 100px;\n}\n.TeXEditor-removeButton {\n  border-color: #aaa;\n  color: #999;\n  margin-left: 8px;\n}\n.TeXEditor-invalidButton {\n  background-color: #eee;\n  border-color: #a00;\n  color: #666;\n}\n.TeXEditor-insert {\n  background-color: #f1f1f1;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  bottom: 30px;\n  position: fixed;\n  right: 30px;\n}\n.TeXEditor-insert2 {\n  background-color: #f1f1f1;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  bottom: 30px;\n  position: fixed;\n  right: 160px;\n}\n.TeXEditor-insert3 {\n  background-color: #f1f1f1;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  bottom: 30px;\n  position: fixed;\n  right: 300px;\n}\n.secondary-nav .filter-item-container {\n  margin-left: 7px;\n  margin-right: 7px;\n  padding: 8px 5px 8px 10px;\n  border-radius: 4px;\n}\n.secondary-nav .filter-item-container:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n}\n.secondary-nav .filter-item-container:active,\n.secondary-nav .filter-item-container:focus {\n  background-color: rgba(0, 0, 0, 0.08);\n}\n.secondary-nav .filter-item-container.checkbox-filter.checkbox-container {\n  padding-left: 36px;\n}\n.secondary-nav .filter-item-container .checkmark {\n  top: 10px;\n  left: 10px;\n}\n.secondary-nav .radio-filter {\n  position: relative;\n}\n.secondary-nav-link {\n  color: #303232;\n  font-size: 12px;\n  padding-top: 10px;\n  padding-right: 5px;\n  padding-bottom: 10px;\n  cursor: pointer;\n  padding-left: 15px;\n  letter-spacing: 0.025em;\n  display: block;\n  user-select: none;\n  border-radius: 4px;\n  margin-left: 7px;\n  margin-right: 7px;\n}\n.secondary-nav-link:hover {\n  background-color: rgba(255, 144, 3, 0.3);\n  color: inherit;\n}\n.secondary-nav-link:hover .active-only {\n  display: inline !important;\n}\n.secondary-nav-link:focus {\n  color: #303232;\n  outline: none;\n  background-color: #e7e7e7;\n}\n.secondary-nav-link:active {\n  color: #303232;\n  outline: none;\n  background-color: rgba(255, 144, 3, 0.45);\n}\n.secondary-nav-link .active-only {\n  display: none !important;\n}\n.secondary-nav-link.active {\n  background-color: rgba(255, 144, 3, 0.35);\n  color: #000;\n  text-shadow: 0 0 0 #000;\n}\n.secondary-nav-link.active:active,\n.secondary-nav-link.active:focus {\n  background-color: rgba(255, 144, 3, 0.35);\n  color: #000;\n  text-shadow: 0 0 0 #000;\n}\n.secondary-nav-link.active .active-only {\n  display: inline !important;\n}\n.secondary-nav-scroll-link {\n  color: #303232;\n  font-size: 12px;\n  cursor: pointer;\n  letter-spacing: 0.025em;\n  display: block;\n  user-select: none;\n  position: relative;\n  min-height: 36px;\n}\n.secondary-nav-scroll-link > a {\n  margin-left: 7px;\n  margin-right: 7px;\n  border-radius: 4px;\n  color: #303232;\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding-top: 10px;\n  padding-right: 5px;\n  padding-bottom: 10px;\n  padding-left: 15px;\n  display: block;\n}\n.secondary-nav-scroll-link > a:hover {\n  background-color: rgba(255, 144, 3, 0.3);\n  color: inherit;\n}\n.secondary-nav-scroll-link > a:focus {\n  color: #303232;\n  outline: none;\n  background-color: #e7e7e7;\n}\n.secondary-nav-scroll-link > a:active {\n  color: #303232;\n  outline: none;\n  background-color: rgba(255, 144, 3, 0.45);\n}\n.secondary-nav-scroll-link > a.active {\n  background-color: rgba(255, 144, 3, 0.35);\n  color: #000;\n  text-shadow: 0 0 0 #000;\n}\n.secondary-nav-scroll-link > a.active:active,\n.secondary-nav-scroll-link > a.active:focus {\n  background-color: rgba(255, 144, 3, 0.35);\n  color: #000;\n  text-shadow: 0 0 0 #000;\n}\n.secondary-nav-scroll-link .secondary-actions {\n  position: absolute;\n  right: 7px;\n  top: 0;\n  bottom: 0;\n}\n.secondary-nav-scroll-link .secondary-actions .snugg-btn {\n  text-align: center;\n  display: inline-block;\n  width: auto;\n  opacity: 0.8;\n  padding-top: 8px;\n  padding-left: 6px;\n  padding-right: 6px;\n  padding-bottom: 0;\n  border-radius: 0;\n  height: 100%;\n  border-radius: 0 4px 4px 0;\n}\n.secondary-nav-scroll-link > .reveal-on-hover {\n  display: none;\n}\n.secondary-nav-scroll-link:hover > .reveal-on-hover {\n  display: inline;\n}\n.draggable-item {\n  transform: scale(1);\n}\n#tertiary-nav {\n  padding: 0;\n  height: 100%;\n  border-right: 1px solid #ddd;\n  width: 50%;\n  float: right;\n}\n#tertiary-nav .tertiary-list {\n  top: 46px;\n}\n#tertiary-nav .tertiary-nav-link {\n  width: 100%;\n  padding: 8px 10px 8px 10px;\n  box-shadow: inset 0 -1px 0 0 #eeeeee;\n  cursor: pointer;\n}\n#tertiary-nav .tertiary-nav-link:hover {\n  background-color: #f2f2f2;\n}\n#tertiary-nav .tertiary-nav-link:active {\n  background-color: #eeeeee;\n}\n.pane-content ul {\n  padding-left: 20px;\n  padding-top: 5px;\n}\n.pane-content ul li {\n  margin-bottom: 5px;\n}\n.snugg-btn {\n  user-select: none;\n  -webkit-user-select: none;\n  background-image: none;\n  border-top-width: 1px;\n  border-right-width: 1px;\n  border-bottom-width: 1px;\n  border-left-width: 1px;\n  border-style: solid;\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  border-left-color: transparent;\n  border-radius: 6px;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.42;\n  outline: none;\n  outline-offset: 0;\n  padding-top: 6px;\n  padding-right: 12px;\n  padding-bottom: 6px;\n  padding-left: 12px;\n  text-align: center;\n  vertical-align: middle;\n  white-space: nowrap;\n  width: 100%;\n  touch-action: manipulation;\n}\n.snugg-btn:active {\n  box-shadow: none;\n}\n.snugg-btn.snugg-btn-primaryNavigation {\n  color: #dedede;\n  background-color: #303232;\n  text-shadow: 0 2px 6px #000000;\n  border-radius: 0;\n  margin: 0;\n  padding-top: 6px;\n  padding-right: 0;\n  padding-bottom: 6px;\n  min-height: 18px;\n  padding-left: 0;\n  font-weight: 400;\n  font-size: 10px;\n  width: 100%;\n  letter-spacing: 0.05em;\n  display: block;\n  position: relative;\n}\n.snugg-btn.snugg-btn-primaryNavigation:hover {\n  color: #fff;\n  background-color: #3c3f3f;\n}\n.snugg-btn.snugg-btn-primaryNavigation:focus {\n  background-color: #1f2020;\n}\n.snugg-btn.snugg-btn-primaryNavigation > i[class^='ico-budicon'],\n.snugg-btn.snugg-btn-primaryNavigation i[class*=' ico-budicon'] {\n  height: 18px;\n  width: 24px;\n  color: #dedede;\n  font-family: snugg-6;\n  font-size: 18px;\n  letter-spacing: 0;\n  line-height: 18px;\n  text-align: center;\n  text-shadow: 0px 2px 5px #000000;\n}\n.snugg-btn.snugg-btn-primaryNavigation img {\n  filter: invert(96%) sepia(0%) saturate(1%) hue-rotate(192deg) brightness(88%) contrast(88%);\n}\n.snugg-btn.snugg-btn-primaryNavigation:active,\n.snugg-btn.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive {\n  background-color: #1f2020;\n  color: #ff9003;\n}\n.snugg-btn.snugg-btn-primaryNavigation:active > i[class^='ico-budicon'],\n.snugg-btn.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive > i[class^='ico-budicon'],\n.snugg-btn.snugg-btn-primaryNavigation:active i[class*=' ico-budicon'],\n.snugg-btn.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive i[class*=' ico-budicon'] {\n  color: #ff9003;\n}\n.snugg-btn.snugg-btn-primaryNavigation:active > img,\n.snugg-btn.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive > img {\n  filter: invert(74%) sepia(76%) saturate(3050%) hue-rotate(355deg) brightness(101%) contrast(110%);\n}\n.snugg-btn.snugg-btn-add-new-job {\n  padding-top: 8px;\n  padding-left: 20px;\n  padding-right: 20px;\n  height: 37px;\n  font-weight: 600;\n  font-size: 15px;\n  border-radius: 30px;\n  margin-top: 4px;\n  margin-left: 10px;\n  width: auto;\n  display: inline-block;\n  float: left;\n}\n@-webkit-keyframes hvr-pop {\n  50% {\n    -webkit-transform: scale(1.04);\n    transform: scale(1.04);\n  }\n}\n@keyframes hvr-pop {\n  50% {\n    -webkit-transform: scale(1.04);\n    transform: scale(1.04);\n  }\n}\n@-webkit-keyframes nrml-pop {\n  50% {\n    -webkit-transform: scale(1.025);\n    transform: scale(1.025);\n  }\n}\n@keyframes nrml-pop {\n  50% {\n    -webkit-transform: scale(1.025);\n    transform: scale(1.025);\n  }\n}\n.snugg-btn.snugg-btn-unassigned-jobs {\n  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  padding-left: 14px;\n  padding-right: 14px;\n  height: 35px;\n  font-size: 15px;\n  border-radius: 30px;\n  margin-top: 8px;\n  margin-right: 8px;\n  width: 100%;\n  float: left;\n  background: #fffaf5 !important;\n  background: linear-gradient(0deg, #fffcfa 0%, #fff0e6 51%, #fffcfa 100%) !important;\n  background-size: auto 200% !important;\n  box-shadow: inset 0px 1px 0px 0px rgba(255, 255, 255, 0.7);\n  border: 1px solid #fbcfa5;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 142%;\n  color: #f56600 !important;\n  transform: perspective(1px) translateZ(0);\n  -webkit-animation-name: nrml-pop;\n  animation-name: nrml-pop;\n  -webkit-animation-duration: 0.3s;\n  animation-duration: 0.3s;\n  -webkit-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-iteration-count: 1;\n  animation-iteration-count: 1;\n}\n.snugg-btn.snugg-btn-unassigned-jobs:hover,\n.snugg-btn.snugg-btn-unassigned-jobs:focus,\n.snugg-btn.snugg-btn-unassigned-jobs:active {\n  background-position: bottom !important;\n  -webkit-animation-name: hvr-pop;\n  animation-name: hvr-pop;\n  -webkit-animation-duration: 0.3s;\n  animation-duration: 0.3s;\n  -webkit-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-iteration-count: 1;\n  animation-iteration-count: 1;\n}\n.snugg-btn.snugg-btn-sm {\n  padding-top: 5px;\n  padding-right: 10px;\n  padding-bottom: 5px;\n  padding-left: 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 6px;\n}\n.snugg-btn.snugg-btn-md {\n  padding-top: 11px;\n  padding-right: 18px;\n  padding-bottom: 11px;\n  padding-left: 18px;\n  font-size: 14px;\n  line-height: 1.5;\n  border-radius: 6px;\n  letter-spacing: 0.02em;\n}\n.snugg-btn.snugg-btn-lg {\n  font-size: 15px;\n  padding-top: 14px;\n  padding-right: 18px;\n  padding-bottom: 14px;\n  padding-left: 18px;\n}\n.snugg-btn.snugg-btn-light {\n  background: #f9f9f9;\n  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.05) 95%);\n  color: #222;\n  border: 1px solid #ddd;\n}\n.snugg-btn.snugg-btn-light:hover {\n  color: #000;\n  background: #f9f9f9;\n  background-image: linear-gradient(202deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.07) 79%);\n}\n.snugg-btn.snugg-btn-light:active {\n  color: #000;\n  background: #f9f9f9;\n}\n.snugg-btn.snugg-btn-dark {\n  background: #303232;\n  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.05) 79%);\n  color: #f2f2f2;\n}\n.snugg-btn.snugg-btn-dark:hover {\n  color: #fff;\n  background-image: linear-gradient(202deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.07) 79%);\n}\n.snugg-btn.snugg-btn-dark:active {\n  color: #fff;\n  background: #171818;\n  background-image: linear-gradient(202deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.07) 79%);\n}\n.snugg-btn.snugg-btn-collectionAdd {\n  color: #3c2a14;\n  border-style: dashed;\n  background-color: #fef5e9;\n  border-color: #f3c78f;\n}\n.snugg-btn.snugg-btn-collectionAdd:hover {\n  background-color: #ffdfb5;\n  border-color: #edb061;\n}\n.snugg-btn.snugg-btn-collectionAdd:active {\n  background-color: #f7b767;\n  border-color: #cf7400;\n}\n.snugg-btn.snugg-btn-yellow {\n  position: relative;\n  cursor: pointer;\n  color: #303232;\n  background: #fdda52;\n  background-image: linear-gradient(202deg, #fdda52 0%, #fdde66 100% 79%);\n  -webkit-transition: 200ms;\n  /* Safari prior 6.1 */\n  transition: 200ms;\n  border: none;\n}\n.snugg-btn.snugg-btn-yellow:hover,\n.snugg-btn.snugg-btn-yellow:focus {\n  background: #fde175;\n  background-image: linear-gradient(202deg, #fddf6b 9%, #fde37f 79%);\n  color: #303232;\n}\n.snugg-btn.snugg-btn-yellow.active,\n.snugg-btn.snugg-btn-yellow:active,\n.open > .dropdown-toggle.snugg-btn.snugg-btn-yellow {\n  background-color: #fccf20;\n  background-image: linear-gradient(202deg, #fdd748 9%, #fddc5c 79%);\n  color: #303232;\n}\n.snugg-btn.snugg-btn-yellow:active,\n.snugg-btn.snugg-btn-yellow.active,\n.open > .dropdown-toggle.snugg-btn.snugg-btn-yellow {\n  background-image: none;\n}\n.snugg-btn.snugg-btn-yellow:before {\n  display: block;\n  position: absolute;\n  padding-top: 10px;\n  top: 10px;\n}\n.snugg-btn.snugg-btn-yellow.disabled,\n.snugg-btn.snugg-btn-yellow[disabled],\nfieldset[disabled] .snugg-btn.snugg-btn-yellow,\n.snugg-btn.snugg-btn-yellow.disabled:hover,\n.snugg-btn.snugg-btn-yellow[disabled]:hover,\nfieldset[disabled] .snugg-btn.snugg-btn-yellow:hover,\n.snugg-btn.snugg-btn-yellow.disabled:focus,\n.snugg-btn.snugg-btn-yellow[disabled]:focus,\nfieldset[disabled] .snugg-btn.snugg-btn-yellow:focus,\n.snugg-btn.snugg-btn-yellow.disabled:active,\n.snugg-btn.snugg-btn-yellow[disabled]:active,\nfieldset[disabled] .snugg-btn.snugg-btn-yellow:active,\n.snugg-btn.snugg-btn-yellow.disabled.active,\n.snugg-btn.snugg-btn-yellow[disabled].active,\nfieldset[disabled] .snugg-btn.snugg-btn-yellow.active {\n  background-color: #fdda52;\n  border-color: #fdde66;\n}\n.snugg-btn.snugg-btn-yellow .badge {\n  color: #fdda52;\n  background-color: #303232;\n}\n.snugg-btn.snugg-btn-orange {\n  background: #ff7f00;\n  border: none;\n  background-image: linear-gradient(10deg, #f96b00 0%, #ffb100 100% 100%);\n  color: #fff;\n  font-weight: 600;\n}\n.snugg-btn.snugg-btn-orange:hover {\n  background-image: linear-gradient(10deg, #f47516 0%, #ffbc22 100% 100%);\n  color: #fff;\n}\n.snugg-btn.snugg-btn-orange:active,\n.snugg-btn.snugg-btn-orange:focus {\n  background: #ff7f00;\n  background-image: linear-gradient(10deg, #e26202 0%, #ffb000 100% 100%);\n  color: #fff;\n}\n.snugg-btn.snugg-btn-orange.disabled,\n.snugg-btn.snugg-btn-orange[disabled] {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n.snugg-btn.snugg-btn-link {\n  background-color: inherit;\n  display: inline-block;\n  color: #c84900;\n}\n.snugg-btn.snugg-btn-link:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.snugg-btn.snugg-btn-link:focus {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.snugg-btn.snugg-btn-link:active {\n  background-color: rgba(0, 0, 0, 0.1);\n  box-shadow: none;\n}\n.snugg-btn.snugg-btn-discrete {\n  background-color: inherit;\n  display: inline-block;\n  color: inherit;\n}\n.snugg-btn.snugg-btn-discrete:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.snugg-btn.snugg-btn-discrete:focus {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n.snugg-btn.snugg-btn-discrete:active {\n  background-color: rgba(0, 0, 0, 0.1);\n  box-shadow: none;\n}\n.snugg-btn.snugg-btn-delete {\n  background-color: inherit;\n  color: #333;\n}\n.snugg-btn.snugg-btn-delete:hover {\n  background-color: #ff0000;\n  color: #ffffff;\n}\n.snugg-btn.snugg-btn-delete:active {\n  background-color: #b30000;\n  color: #ffffff;\n}\n.snugg-btn.snugg-btn-rounded {\n  background: #fff5e9;\n  color: #c84900;\n  box-shadow: 0 0 0 1px rgba(251, 207, 165, 0.5);\n  border-radius: 50px;\n  transition: all 200ms ease-in-out;\n}\n.snugg-btn.snugg-btn-rounded:hover {\n  background: #ffedd5;\n  box-shadow: 0 0 0 1px rgba(251, 207, 165, 0.7);\n}\n.snugg-btn.snugg-btn-rounded:active {\n  background: #ffedd5;\n  box-shadow: 0 0 0 1px rgba(251, 207, 165, 0.7);\n}\n.modal-footer .snugg-btn {\n  border: none;\n  font-weight: 600;\n  font-size: 15px;\n  letter-spacing: 0.02em;\n  border-radius: 0 0 4px 4px;\n}\n.modal-footer .snugg-btn.snugg-btn-yellow {\n  background-image: linear-gradient(15deg, #ff9003 50%, #fdde6645 90% 79%);\n  color: #fff;\n}\n@media (min-height: 590px) {\n  .snugg-btn.snugg-btn-primaryNavigation {\n    min-height: 55px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n  }\n}\n/* Small devices (tablets, 768px and up) */\n@media (min-width: 768px) {\n  .snugg-btn.snugg-btn-add-new-job {\n    float: right;\n  }\n  .snugg-btn.snugg-btn-unassigned-jobs {\n    width: auto;\n    margin-top: 5px;\n  }\n}\n/* Customize the label (the container) */\n.checkbox-container {\n  display: block;\n  position: relative;\n  padding-left: 28px;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-bottom: 0;\n  cursor: pointer;\n  font-weight: inherit;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  /* Hide the browser's default checkbox */\n  /* Create a custom checkbox */\n  /* On mouse-over, add a grey background color */\n  /* When the checkbox is checked, add a blue background */\n  /* Show the checkmark when checked */\n  /* Style the checkmark/indicator */\n}\n.checkbox-container.checkbox-container-no-label {\n  padding-left: 0;\n}\n.checkbox-container:hover .checkmark:after,\n.checkbox-container:focus-within .checkmark:after {\n  display: block;\n}\n.checkbox-container input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n.checkbox-container .checkmark {\n  position: absolute;\n  top: 2px;\n  left: 0;\n  height: 16px;\n  width: 16px;\n  background-color: #eee;\n  border-radius: 3px;\n  /* Create the checkmark/indicator (hidden when not checked) */\n}\n.checkbox-container .checkmark:after {\n  content: '';\n  position: absolute;\n  display: none;\n}\n.checkbox-container:hover input ~ .checkmark,\n.checkbox-container:focus-within input ~ .checkmark {\n  background-color: #ccc;\n}\n.checkbox-container input:checked ~ .checkmark {\n  background-color: #ff9003;\n}\n.checkbox-container input:disabled ~ .checkmark {\n  background-color: #777777;\n}\n.checkbox-container input:checked ~ .checkmark:after {\n  display: block;\n}\n.checkbox-container .checkmark:after {\n  left: 6px;\n  top: 3px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 3px 3px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n.checkbox-fix {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n}\n.Select .Select-menu-outer {\n  padding: 0 5px;\n  border-radius: 0 0 4px 4px;\n  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.14);\n}\n.Select .Select-menu-outer .Select-menu .Select-option {\n  border-radius: 4px;\n}\n#tickets-container {\n  font-size: 16px;\n}\n#tickets-container #main-pane {\n  padding-bottom: 180px;\n}\n#tickets-container .ticket-file-block {\n  max-width: 235px;\n  display: inline-block;\n}\n#tickets-container .ticket-file-block .no-file-cannot-modify {\n  position: relative;\n  height: 175px;\n  width: 235px;\n  background-color: #f9f9f9;\n  border-radius: 6px;\n  border: 1px solid #f9f9f9;\n  font-size: 16px;\n  color: #777777;\n}\n#tickets-container .ticket-file-block .no-file-cannot-modify .no-file-label {\n  text-align: center;\n  height: 60px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n#tickets-container .ticket-file-block .ticket-file-preview {\n  transition: all ease-in-out 0.2s;\n}\n#tickets-container .ticket-file-block .ticket-file-preview img {\n  border-radius: 6px;\n}\n#tickets-container .ticket-file-block .ticket-file-preview:hover {\n  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.15);\n}\n#tickets-container .ticket-file-block .ticket-file-preview:active,\n#tickets-container .ticket-file-block .ticket-file-preview:focus {\n  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.15);\n  transform: scale(1.05);\n}\n#tickets-container .ticket-file-block .ticket-file-is-image {\n  width: 235px;\n  height: 175px;\n  display: inline-block;\n  margin-right: 9px;\n  overflow: hidden;\n  border: 1px solid #cccccc;\n  border-radius: 6px;\n  position: relative;\n}\n#tickets-container .ticket-file-block .ticket-file-is-image img {\n  height: 175px;\n  width: 235px;\n  position: relative;\n  z-index: 2;\n}\n#tickets-container .ticket-file-block .ticket-file-is-not-image {\n  height: 175px;\n  width: 235px;\n  background-color: white;\n  position: relative;\n  border-radius: 6px;\n  border: 1px solid #cccccc;\n  font-size: 16px;\n  cursor: pointer;\n}\n#tickets-container .ticket-file-image--loader {\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  text-align: center;\n  font-size: 12px;\n  background-color: #f9f9f9;\n  border: 1px dashed #ccc;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  color: #777;\n  gap: 8px;\n}\n#tickets-container .uploader-container {\n  width: 235px;\n  height: 175px;\n  margin-bottom: 0;\n  border-radius: 6px;\n}\n#tickets-container .uploadcare--widget .uploadcare--widget__dragndrop-area {\n  height: 175px;\n  border-radius: 6px;\n  border: 1px dashed #ccc;\n}\n#tickets-container .uploadcare--widget .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: fit-content;\n  font-size: 12px;\n  line-height: 1.1;\n  color: #777;\n}\n.ticket-file-modal-nav {\n  height: 60vh !important;\n  top: 0;\n  text-shadow: 0 0 10px #000;\n  cursor: pointer;\n  width: 74px;\n  color: #fff;\n  font-size: 60px;\n  position: absolute;\n  line-height: 122px;\n  z-index: 1;\n}\n.ticket-file-modal-nav.ticket-file-modal-nav--left {\n  left: 0;\n  border-radius: 0 8px 8px 0;\n}\n.ticket-file-modal-nav.ticket-file-modal-nav--left:hover {\n  background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0));\n}\n.ticket-file-modal-nav.ticket-file-modal-nav--left:active:hover {\n  background-image: linear-gradient(90deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.1));\n}\n.ticket-file-modal-nav.ticket-file-modal-nav--right {\n  right: 0;\n  border-radius: 8px 0 0 8px;\n}\n.ticket-file-modal-nav.ticket-file-modal-nav--right:hover {\n  background-image: linear-gradient(270deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0));\n}\n.ticket-file-modal-nav.ticket-file-modal-nav--right:active:hover {\n  background-image: linear-gradient(270deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.1));\n}\n.geolocation-placeholder-wrapper {\n  height: 60vh;\n  overflow: auto;\n  text-align: center;\n}\n.geolocation-image-wrapper {\n  height: 60vh;\n  overflow: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.geolocation-image-preview {\n  max-height: 60vh;\n  max-width: 100%;\n  display: inline;\n}\n.ticket-file-modal-body .uploadcare--widget .uploadcare--widget__dragndrop-area {\n  height: 60vh;\n  display: flex;\n  max-height: 560px;\n}\n.ticket-file-modal-body .uploadcare--widget .uploadcare--widget__dragndrop-area .snugg-upload-prompt-text {\n  font-size: 26px;\n  letter-spacing: 0;\n  line-height: 48px;\n}\n.ticket-file-modal-body .no-file-cannot-modify {\n  position: relative;\n  height: 60vh;\n  overflow: auto;\n  text-align: center;\n  background-color: #f9f9f9;\n  border-radius: 6px;\n  border: 1px solid #f9f9f9;\n  font-size: 36px;\n  color: #777777;\n}\n.ticket-file-modal-body .no-file-cannot-modify .no-file-label {\n  text-align: center;\n  height: 100px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n}\n#tickets-status-mutton {\n  user-select: none;\n  -webkit-user-select: none;\n  background-image: none;\n  border-top-width: 1px;\n  border-right-width: 1px;\n  border-bottom-width: 1px;\n  border-left-width: 1px;\n  border-style: solid;\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  border-left-color: transparent;\n  border-radius: 6px;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: block;\n  font-size: 14px;\n  line-height: 1.42;\n  outline: none;\n  outline-offset: 0;\n  padding-top: 6px;\n  padding-right: 12px;\n  padding-bottom: 6px;\n  padding-left: 12px;\n  text-align: center;\n  vertical-align: middle;\n  white-space: nowrap;\n  touch-action: manipulation;\n  background: #ff7f00;\n  border: none;\n  background-image: linear-gradient(10deg, #f96b00 0%, #ffb100 100% 100%);\n  color: #fff;\n  font-weight: 600;\n  height: 40px;\n  float: right;\n  display: inline-block;\n  max-width: 260px;\n  min-width: 220px;\n  width: 100%;\n}\n#tickets-status-mutton:active {\n  box-shadow: none;\n}\n#tickets-status-mutton.snugg-btn-primaryNavigation {\n  color: #dedede;\n  background-color: #303232;\n  text-shadow: 0 2px 6px #000000;\n  border-radius: 0;\n  margin: 0;\n  padding-top: 6px;\n  padding-right: 0;\n  padding-bottom: 6px;\n  min-height: 18px;\n  padding-left: 0;\n  font-weight: 400;\n  font-size: 10px;\n  width: 100%;\n  letter-spacing: 0.05em;\n  display: block;\n  position: relative;\n}\n#tickets-status-mutton.snugg-btn-primaryNavigation:hover {\n  color: #fff;\n  background-color: #3c3f3f;\n}\n#tickets-status-mutton.snugg-btn-primaryNavigation:focus {\n  background-color: #1f2020;\n}\n#tickets-status-mutton.snugg-btn-primaryNavigation > i[class^='ico-budicon'],\n#tickets-status-mutton.snugg-btn-primaryNavigation i[class*=' ico-budicon'] {\n  height: 18px;\n  width: 24px;\n  color: #dedede;\n  font-family: snugg-6;\n  font-size: 18px;\n  letter-spacing: 0;\n  line-height: 18px;\n  text-align: center;\n  text-shadow: 0px 2px 5px #000000;\n}\n#tickets-status-mutton.snugg-btn-primaryNavigation img {\n  filter: invert(96%) sepia(0%) saturate(1%) hue-rotate(192deg) brightness(88%) contrast(88%);\n}\n#tickets-status-mutton.snugg-btn-primaryNavigation:active,\n#tickets-status-mutton.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive {\n  background-color: #1f2020;\n  color: #ff9003;\n}\n#tickets-status-mutton.snugg-btn-primaryNavigation:active > i[class^='ico-budicon'],\n#tickets-status-mutton.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive > i[class^='ico-budicon'],\n#tickets-status-mutton.snugg-btn-primaryNavigation:active i[class*=' ico-budicon'],\n#tickets-status-mutton.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive i[class*=' ico-budicon'] {\n  color: #ff9003;\n}\n#tickets-status-mutton.snugg-btn-primaryNavigation:active > img,\n#tickets-status-mutton.snugg-btn-primaryNavigation.snugg-btn-primaryNavigationActive > img {\n  filter: invert(74%) sepia(76%) saturate(3050%) hue-rotate(355deg) brightness(101%) contrast(110%);\n}\n#tickets-status-mutton.snugg-btn-add-new-job {\n  padding-top: 8px;\n  padding-left: 20px;\n  padding-right: 20px;\n  height: 37px;\n  font-weight: 600;\n  font-size: 15px;\n  border-radius: 30px;\n  margin-top: 4px;\n  margin-left: 10px;\n  width: auto;\n  display: inline-block;\n  float: left;\n}\n@-webkit-keyframes hvr-pop {\n  50% {\n    -webkit-transform: scale(1.04);\n    transform: scale(1.04);\n  }\n}\n@keyframes hvr-pop {\n  50% {\n    -webkit-transform: scale(1.04);\n    transform: scale(1.04);\n  }\n}\n@-webkit-keyframes nrml-pop {\n  50% {\n    -webkit-transform: scale(1.025);\n    transform: scale(1.025);\n  }\n}\n@keyframes nrml-pop {\n  50% {\n    -webkit-transform: scale(1.025);\n    transform: scale(1.025);\n  }\n}\n#tickets-status-mutton.snugg-btn-unassigned-jobs {\n  -webkit-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  -o-transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  transition: all 200ms cubic-bezier(0.445, 0.05, 0.55, 0.95);\n  padding-left: 14px;\n  padding-right: 14px;\n  height: 35px;\n  font-size: 15px;\n  border-radius: 30px;\n  margin-top: 8px;\n  margin-right: 8px;\n  width: 100%;\n  float: left;\n  background: #fffaf5 !important;\n  background: linear-gradient(0deg, #fffcfa 0%, #fff0e6 51%, #fffcfa 100%) !important;\n  background-size: auto 200% !important;\n  box-shadow: inset 0px 1px 0px 0px rgba(255, 255, 255, 0.7);\n  border: 1px solid #fbcfa5;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 142%;\n  color: #f56600 !important;\n  transform: perspective(1px) translateZ(0);\n  -webkit-animation-name: nrml-pop;\n  animation-name: nrml-pop;\n  -webkit-animation-duration: 0.3s;\n  animation-duration: 0.3s;\n  -webkit-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-iteration-count: 1;\n  animation-iteration-count: 1;\n}\n#tickets-status-mutton.snugg-btn-unassigned-jobs:hover,\n#tickets-status-mutton.snugg-btn-unassigned-jobs:focus,\n#tickets-status-mutton.snugg-btn-unassigned-jobs:active {\n  background-position: bottom !important;\n  -webkit-animation-name: hvr-pop;\n  animation-name: hvr-pop;\n  -webkit-animation-duration: 0.3s;\n  animation-duration: 0.3s;\n  -webkit-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-animation-iteration-count: 1;\n  animation-iteration-count: 1;\n}\n#tickets-status-mutton.snugg-btn-sm {\n  padding-top: 5px;\n  padding-right: 10px;\n  padding-bottom: 5px;\n  padding-left: 10px;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 6px;\n}\n#tickets-status-mutton.snugg-btn-md {\n  padding-top: 11px;\n  padding-right: 18px;\n  padding-bottom: 11px;\n  padding-left: 18px;\n  font-size: 14px;\n  line-height: 1.5;\n  border-radius: 6px;\n  letter-spacing: 0.02em;\n}\n#tickets-status-mutton.snugg-btn-lg {\n  font-size: 15px;\n  padding-top: 14px;\n  padding-right: 18px;\n  padding-bottom: 14px;\n  padding-left: 18px;\n}\n#tickets-status-mutton.snugg-btn-light {\n  background: #f9f9f9;\n  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.05) 95%);\n  color: #222;\n  border: 1px solid #ddd;\n}\n#tickets-status-mutton.snugg-btn-light:hover {\n  color: #000;\n  background: #f9f9f9;\n  background-image: linear-gradient(202deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.07) 79%);\n}\n#tickets-status-mutton.snugg-btn-light:active {\n  color: #000;\n  background: #f9f9f9;\n}\n#tickets-status-mutton.snugg-btn-dark {\n  background: #303232;\n  background-image: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(0, 0, 0, 0.05) 79%);\n  color: #f2f2f2;\n}\n#tickets-status-mutton.snugg-btn-dark:hover {\n  color: #fff;\n  background-image: linear-gradient(202deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.07) 79%);\n}\n#tickets-status-mutton.snugg-btn-dark:active {\n  color: #fff;\n  background: #171818;\n  background-image: linear-gradient(202deg, rgba(255, 255, 255, 0.1) 0%, rgba(0, 0, 0, 0.07) 79%);\n}\n#tickets-status-mutton.snugg-btn-collectionAdd {\n  color: #3c2a14;\n  border-style: dashed;\n  background-color: #fef5e9;\n  border-color: #f3c78f;\n}\n#tickets-status-mutton.snugg-btn-collectionAdd:hover {\n  background-color: #ffdfb5;\n  border-color: #edb061;\n}\n#tickets-status-mutton.snugg-btn-collectionAdd:active {\n  background-color: #f7b767;\n  border-color: #cf7400;\n}\n#tickets-status-mutton.snugg-btn-yellow {\n  position: relative;\n  cursor: pointer;\n  color: #303232;\n  background: #fdda52;\n  background-image: linear-gradient(202deg, #fdda52 0%, #fdde66 100% 79%);\n  -webkit-transition: 200ms;\n  /* Safari prior 6.1 */\n  transition: 200ms;\n  border: none;\n}\n#tickets-status-mutton.snugg-btn-yellow:hover,\n#tickets-status-mutton.snugg-btn-yellow:focus {\n  background: #fde175;\n  background-image: linear-gradient(202deg, #fddf6b 9%, #fde37f 79%);\n  color: #303232;\n}\n#tickets-status-mutton.snugg-btn-yellow.active,\n#tickets-status-mutton.snugg-btn-yellow:active,\n.open > .dropdown-toggle#tickets-status-mutton.snugg-btn-yellow {\n  background-color: #fccf20;\n  background-image: linear-gradient(202deg, #fdd748 9%, #fddc5c 79%);\n  color: #303232;\n}\n#tickets-status-mutton.snugg-btn-yellow:active,\n#tickets-status-mutton.snugg-btn-yellow.active,\n.open > .dropdown-toggle#tickets-status-mutton.snugg-btn-yellow {\n  background-image: none;\n}\n#tickets-status-mutton.snugg-btn-yellow:before {\n  display: block;\n  position: absolute;\n  padding-top: 10px;\n  top: 10px;\n}\n#tickets-status-mutton.snugg-btn-yellow.disabled,\n#tickets-status-mutton.snugg-btn-yellow[disabled],\nfieldset[disabled] #tickets-status-mutton.snugg-btn-yellow,\n#tickets-status-mutton.snugg-btn-yellow.disabled:hover,\n#tickets-status-mutton.snugg-btn-yellow[disabled]:hover,\nfieldset[disabled] #tickets-status-mutton.snugg-btn-yellow:hover,\n#tickets-status-mutton.snugg-btn-yellow.disabled:focus,\n#tickets-status-mutton.snugg-btn-yellow[disabled]:focus,\nfieldset[disabled] #tickets-status-mutton.snugg-btn-yellow:focus,\n#tickets-status-mutton.snugg-btn-yellow.disabled:active,\n#tickets-status-mutton.snugg-btn-yellow[disabled]:active,\nfieldset[disabled] #tickets-status-mutton.snugg-btn-yellow:active,\n#tickets-status-mutton.snugg-btn-yellow.disabled.active,\n#tickets-status-mutton.snugg-btn-yellow[disabled].active,\nfieldset[disabled] #tickets-status-mutton.snugg-btn-yellow.active {\n  background-color: #fdda52;\n  border-color: #fdde66;\n}\n#tickets-status-mutton.snugg-btn-yellow .badge {\n  color: #fdda52;\n  background-color: #303232;\n}\n#tickets-status-mutton.snugg-btn-orange {\n  background: #ff7f00;\n  border: none;\n  background-image: linear-gradient(10deg, #f96b00 0%, #ffb100 100% 100%);\n  color: #fff;\n  font-weight: 600;\n}\n#tickets-status-mutton.snugg-btn-orange:hover {\n  background-image: linear-gradient(10deg, #f47516 0%, #ffbc22 100% 100%);\n  color: #fff;\n}\n#tickets-status-mutton.snugg-btn-orange:active,\n#tickets-status-mutton.snugg-btn-orange:focus {\n  background: #ff7f00;\n  background-image: linear-gradient(10deg, #e26202 0%, #ffb000 100% 100%);\n  color: #fff;\n}\n#tickets-status-mutton.snugg-btn-orange.disabled,\n#tickets-status-mutton.snugg-btn-orange[disabled] {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n#tickets-status-mutton.snugg-btn-link {\n  background-color: inherit;\n  display: inline-block;\n  color: #c84900;\n}\n#tickets-status-mutton.snugg-btn-link:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n#tickets-status-mutton.snugg-btn-link:focus {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n#tickets-status-mutton.snugg-btn-link:active {\n  background-color: rgba(0, 0, 0, 0.1);\n  box-shadow: none;\n}\n#tickets-status-mutton.snugg-btn-discrete {\n  background-color: inherit;\n  display: inline-block;\n  color: inherit;\n}\n#tickets-status-mutton.snugg-btn-discrete:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n#tickets-status-mutton.snugg-btn-discrete:focus {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n#tickets-status-mutton.snugg-btn-discrete:active {\n  background-color: rgba(0, 0, 0, 0.1);\n  box-shadow: none;\n}\n#tickets-status-mutton.snugg-btn-delete {\n  background-color: inherit;\n  color: #333;\n}\n#tickets-status-mutton.snugg-btn-delete:hover {\n  background-color: #ff0000;\n  color: #ffffff;\n}\n#tickets-status-mutton.snugg-btn-delete:active {\n  background-color: #b30000;\n  color: #ffffff;\n}\n#tickets-status-mutton.snugg-btn-rounded {\n  background: #fff5e9;\n  color: #c84900;\n  box-shadow: 0 0 0 1px rgba(251, 207, 165, 0.5);\n  border-radius: 50px;\n  transition: all 200ms ease-in-out;\n}\n#tickets-status-mutton.snugg-btn-rounded:hover {\n  background: #ffedd5;\n  box-shadow: 0 0 0 1px rgba(251, 207, 165, 0.7);\n}\n#tickets-status-mutton.snugg-btn-rounded:active {\n  background: #ffedd5;\n  box-shadow: 0 0 0 1px rgba(251, 207, 165, 0.7);\n}\n#tickets-status-mutton:hover {\n  background-image: linear-gradient(10deg, #f47516 0%, #ffbc22 100% 100%);\n  color: #fff;\n}\n#tickets-status-mutton:active,\n#tickets-status-mutton:focus {\n  background: #ff7f00;\n  background-image: linear-gradient(10deg, #e26202 0%, #ffb000 100% 100%);\n  color: #fff;\n}\n#tickets-status-mutton.disabled,\n#tickets-status-mutton[disabled] {\n  color: #777777 !important;\n  background-color: #eeeeee !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n#tickets-status-mutton > div {\n  float: left;\n  display: inline-block;\n}\n.mutton-dropdown-menu {\n  padding: 8px;\n}\n.mutton-dropdown-menu li {\n  border-radius: 4px;\n  padding: 10px 20px;\n}\n.mutton-dropdown-menu li:hover {\n  background-color: #f2f2f2;\n}\n.mutton-dropdown-menu li:active {\n  background-color: #cccccc;\n}\n.mutton-dropdown-menu li.active {\n  background-color: #eeeeee;\n  color: #000;\n}\n.ticket-view {\n  padding-top: 20px;\n}\n.ticket-view .tab-content > .tab-pane,\n.ticket-view .pill-content > .pill-pane {\n  padding: 0 2px;\n}\n.workflow-pane {\n  padding: 0 10px;\n}\n.workflow-pane--ticket-list {\n  position: relative;\n  margin-bottom: 20px;\n}\n.workflow-pane--ticket-list .workflow-pane--continuity-line {\n  position: absolute;\n  top: 20px;\n  bottom: 20px;\n  left: 30px;\n  right: auto;\n  width: 1px;\n  border-right: dashed #777777 1px;\n  z-index: 0;\n}\n.workflow-pane--ticket-link {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-content: stretch;\n  align-items: center;\n  border-radius: 4px;\n  padding: 10px 12px 10px 12px;\n  margin-bottom: 4px;\n  cursor: pointer;\n  transition: background 0.15s ease-in-out;\n}\n.workflow-pane--ticket-link:hover,\n.workflow-pane--ticket-link:focus {\n  background-color: #f4f4f4;\n}\n.workflow-pane--ticket-link:active {\n  background-color: #eee;\n}\n.workflow-pane--ticket-link.workflow-pane--ticket-link--template {\n  border: 1px solid #f2f2f2;\n  background-color: #f9f9f9;\n}\n.workflow-pane--ticket-link.workflow-pane--ticket-link--template:hover,\n.workflow-pane--ticket-link.workflow-pane--ticket-link--template:focus {\n  background-color: #f2f2f2;\n}\n.workflow-pane--ticket-link.workflow-pane--ticket-link--template:hover .workflow-ticket-icon-container,\n.workflow-pane--ticket-link.workflow-pane--ticket-link--template:focus .workflow-ticket-icon-container {\n  background-color: #e3e3e3;\n}\n.workflow-pane--ticket-link.workflow-pane--ticket-link--template:active {\n  background-color: #eee;\n}\n.workflow-pane--ticket-details {\n  max-width: 89%;\n  flex-grow: 2;\n  padding: 0 10px;\n}\n.workflow-pane--ticket-title {\n  font-size: 1em;\n  font-weight: 600;\n  white-space: nowrap;\n  width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-bottom: 2px;\n}\n.workflow-pane--ticket-metadata,\n.workflow-pane--ticket-heading {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-content: stretch;\n  align-items: stretch;\n}\n.workflow-pane--ticket-created-by {\n  font-size: 0.9em;\n  color: #222222;\n}\n.workflow-pane--ticket-time {\n  font-size: 0.8em;\n  line-height: 16px;\n  color: #555555;\n}\n.workflow-ticket-icon-container {\n  border-radius: 20em;\n  height: 36px;\n  width: 36px;\n  flex-shrink: 0;\n  position: relative;\n}\n.workflow-pane--ticket-icon {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  left: 0;\n  right: 0;\n  width: 17px;\n  height: 17px;\n  font-size: 17px;\n  line-height: 1;\n}\n.workflow-ticket-icon-container.workflow-status-icon--workflowTemplate {\n  background-color: #eeeeee;\n  color: #555555;\n}\n.workflow-ticket-icon-container.workflow-status-icon--workflowDraft {\n  background-color: #faedb7;\n  color: #967804;\n}\n.workflow-ticket-icon-container.workflow-status-icon--workflowSubmitted,\n.workflow-ticket-icon-container.workflow-status-icon--workflowChangesRequested {\n  background-color: #daf0fd;\n  color: #196188;\n}\n.workflow-ticket-icon-container.workflow-status-icon--workflowClosedResolved {\n  background-color: #c0f5c8;\n  color: #0a6117;\n}\n.workflow-ticket-icon-container.workflow-status-icon--workflowClosedUnresolved {\n  background-color: #fddeda;\n  color: #922513;\n}\n.workflow-ticket-icon-container.workflow-status-icon--workflowClosedUnresolved .workflow-pane--ticket-icon {\n  top: 2px;\n}\n.ticket-file-display-area {\n  text-align: center;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  height: 90px;\n  width: 90px;\n  border-radius: 20em;\n  background-color: #f2f2f2;\n  color: #555555;\n}\n.ticket-file-extension {\n  border-radius: 4px;\n  font-size: 14px;\n  background: #fa611b;\n  color: white;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 20px;\n  margin: auto;\n  height: 1.4em;\n  line-height: 1.4em;\n  max-width: 46px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n@media (min-width: 768px) {\n  #tickets-container #main-pane {\n    padding-left: 30px;\n  }\n}\n@media (min-width: 992px) {\n  .geolocation-placeholder-wrapper {\n    height: 70vh;\n  }\n  .geolocation-image-wrapper {\n    height: 70vh;\n  }\n  .geolocation-image-preview {\n    max-height: 70vh;\n  }\n}\n.pane-job-snapshots * {\n  pointer-events: all;\n}\n.snapshot-footer-banner {\n  width: calc(100% - 60px) !important;\n  box-shadow: 0 -2px 32px 0 rgba(0, 0, 0, 0.24);\n}\n.snapshot-footer-banner .alert-style-container {\n  padding-left: 16px;\n  padding-right: 16px;\n}\n.snapshot-footer-banner p {\n  font-size: 13px;\n  line-height: 1.42;\n  margin-bottom: 0;\n  color: #555;\n}\n.snapshot-footer-banner p span {\n  color: #111;\n}\n@media (max-width: 768px) {\n  .snapshot-footer-banner {\n    width: auto !important;\n  }\n}\n.snapshot-footer-banner.alert .alert-style-container {\n  align-items: center;\n}\n.snapshot-footer-banner .alert-content > div {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: baseline;\n}\n.custom-dropdown li {\n  margin-bottom: 2px !important;\n}\n.custom-dropdown li:last-child {\n  margin-bottom: 0;\n}\n.custom-dropdown li a {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  padding: 8px 12px;\n  font-size: 14px;\n  line-height: 1.42;\n  color: #111;\n  font-weight: 600;\n}\n.custom-dropdown li a span {\n  font-size: 12px;\n  color: #777;\n  display: inline-block;\n  font-weight: 500;\n}\n.custom-dropdown li.active {\n  background-color: #fff5e9;\n}\n.custom-dropdown li.active a {\n  background-color: #fff5e9;\n  color: #f56600;\n}\n.custom-dropdown li.active a span {\n  color: #555;\n}\n.custom-dropdown li.active a:hover {\n  color: #f56600;\n  background-color: #feecd6;\n}\n.custom-dropdown .dropdown-icon {\n  margin-left: 8px;\n  margin-top: -4px;\n  width: 16px;\n  height: 16px;\n  transition: all 200ms linear;\n}\n.custom-dropdown .dropdown-icon.rotated {\n  transform: rotate(-180deg);\n}\n.custom-dropdown button span {\n  transition: all 150ms ease;\n}\n.custom-dropdown:hover button span {\n  color: #f56600;\n}\n.snapshot-custom-dropdown ul {\n  width: auto;\n  padding: 8px !important;\n  overflow: hidden;\n}\n.snapshot-custom-dropdown li {\n  margin: 0 !important;\n}\n.snapshot-custom-dropdown li a {\n  font-weight: normal;\n}\n.snapshot-custom-dropdown .divider {\n  margin: 2px !important;\n}\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(0.9);\n    opacity: 0.75;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n/* ===================== INCENTIVES CSS =====================*/\n.geo-photos-section {\n  position: relative;\n}\n.geo-photos-grid {\n  box-shadow: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 32px;\n}\n.geo-photo-title-container {\n  display: flex;\n  gap: 4px;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n.geo-photo-category-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 32px;\n  margin-bottom: 24px;\n}\n.geo-photo-category-container:last-of-type {\n  border-bottom: none;\n  padding-bottom: 16px;\n  margin-bottom: 0px;\n}\n.geo-photo-file-block-inner {\n  width: 235px;\n  height: 175px;\n  justify-content: center;\n  align-items: center;\n  margin-right: 8px;\n  position: relative;\n}\n.geo-photo-file-block-inner:hover .incentives-photo-delete-button {\n  bottom: 10px;\n  opacity: 1;\n}\n.incentives-photo-delete-button {\n  position: absolute;\n  bottom: 0;\n  opacity: 0;\n  z-index: 5;\n  margin-left: 50%;\n  transform: translateX(-50%);\n  transition: all 150ms ease-in-out;\n}\n.incentives-photo-delete-button button {\n  width: 44px;\n  height: 44px;\n  background-color: rgba(255, 255, 255, 0.8) !important;\n  border-radius: 6px;\n  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.04);\n  backdrop-filter: blur(4px);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transition: all 200ms ease-in-out;\n}\n.incentives-photo-delete-button button:hover {\n  background-color: #ffffff !important;\n  transform: scale(1.05);\n}\n.geotagging-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  background-color: #039855;\n  border-radius: 20px;\n  box-shadow: inset 0 1px 2px 0 rgba(255, 255, 255, 0.1);\n  border: 1px solid #039855;\n  font-size: 9px;\n  line-height: 140%;\n  text-align: center;\n  color: #fff;\n  letter-spacing: 0.5px;\n  padding: 2px 8px;\n  position: absolute;\n  z-index: 3;\n  top: 8px;\n  right: 8px;\n  pointer-events: none;\n}\n.geo-photo-category-title {\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  line-height: 1.42 !important;\n  letter-spacing: 0.3px !important;\n  text-transform: uppercase !important;\n  color: #555 !important;\n  padding: 0 !important;\n}\n.geo-photo-file-title {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #333;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.geo-photo-badge-style {\n  margin-left: 0px !important;\n  margin-top: 3px !important;\n  font-size: 9px !important;\n  padding: 2px 4px !important;\n  display: inline-table !important;\n}\n#tickets-container .geo-photo-block {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.uploadcare-icon-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n.uploadcare-icon-container .plus-text {\n  font-size: 1.6em;\n  font-weight: 700;\n  line-height: 142%;\n  text-align: center;\n  color: #777;\n  padding-left: 8px;\n}\n.geolocation-data-container {\n  width: 100%;\n}\n.geolocation-data-vertical {\n  background-color: #f9f9f9;\n  border: 1px solid #eee;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.geolocation-data-vertical .geolocation-data-set {\n  display: flex;\n  gap: 4px;\n  font-size: 12px;\n  line-height: 1.42;\n  color: #333;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-bottom: 1px solid #eee;\n}\n.geolocation-data-vertical .geolocation-data-set:last-child {\n  border-bottom: none;\n}\n.geolocation-data-vertical .geolocation-data-set span {\n  font-weight: 500;\n}\n.geolocation-data-horizontal {\n  background-color: #f9f9f9;\n  border: 1px solid #eee;\n  border-radius: 6px;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  padding: 8px 4px;\n  gap: 6px;\n}\n.geolocation-data-horizontal .geolocation-data-set {\n  display: flex;\n  gap: 4px;\n  font-size: 12px;\n  line-height: 1.42;\n  color: #333;\n  font-weight: 600;\n  padding: 4px 8px;\n  border-bottom: 1px solid #eee;\n}\n.geolocation-data-horizontal .geolocation-data-set:last-child {\n  border-bottom: none;\n}\n.geolocation-data-horizontal .geolocation-data-set span {\n  font-weight: 500;\n}\n.geolocation-data-horizontal .geolocation-data-set {\n  border-right: none;\n  border-bottom: 1px solid #eee;\n  padding: 4px 8px;\n}\n.geolocation-data-horizontal .geolocation-data-set:last-child {\n  border-right: none;\n}\n.photo-notes {\n  font-size: 14px !important;\n  padding: 12px !important;\n  resize: vertical;\n  transition: all 200ms ease-in-out;\n  min-height: 30px;\n  max-height: 80px;\n  field-sizing: content;\n  border: 1px solid #e6e6e6 !important;\n}\n.photo-notes:focus,\n.photo-notes:focus-within,\n.photo-notes:active {\n  min-height: 80px;\n  border: 1px solid #ccc !important;\n}\n.modal-footer-action-container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0;\n  flex: 1;\n}\n.undo-delete-action {\n  position: absolute;\n  bottom: 1px;\n  left: 1px;\n  right: 1px;\n  padding: 10px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #d92d20;\n  border-top: 1px solid #e6e6e6;\n  transition: all 150ms ease-in-out;\n  border-radius: 0 0 6px 6px;\n}\n.undo-delete-action span {\n  transition: all 200ms ease-in-out;\n  display: flex;\n  gap: 6px;\n  align-items: center;\n}\n.undo-delete-action:hover {\n  background-color: #f2f2f2;\n}\n.undo-delete-action:hover span {\n  transform: scale(1.1);\n}\n.undo-delete-modal {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #d92d20;\n  cursor: pointer;\n}\n.undo-delete-modal span {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  transition: all 200ms ease-in-out;\n}\n.undo-delete-modal:hover span {\n  transform: scale(1.1);\n}\n.ticket-file-modal-footer {\n  height: auto;\n  padding: 24px 25px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n/* ================================================================\n    ERROR STATES\n================================================================ */\n.no-camera-location {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.42;\n  text-align: center;\n  color: #555;\n  padding: 8px 40px 56px;\n}\n.no-camera-location h2,\n.no-camera-location p {\n  margin: 0;\n  padding: 0;\n}\n.no-camera-location h2 {\n  font-size: 22px;\n  line-height: 1.42;\n  text-align: center;\n  color: #111;\n  font-weight: 600;\n}\n.no-camera-location p {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.42;\n  text-align: center;\n  color: #555;\n}\n.no-camera-location a {\n  text-decoration: none;\n  color: #c84900;\n}\n.no-camera-location .camera-location-error-icons {\n  display: flex;\n  gap: 4px;\n  margin-bottom: 8px;\n}\n/* ================================================================\n    MEDIA QUERIES\n================================================================ */\n@media (min-width: 992px) {\n  .ticket-file-modal-footer {\n    height: 92px;\n    padding: 0 25px;\n    flex-direction: row;\n  }\n  .geolocation-data-container {\n    width: auto;\n  }\n  .geolocation-data-vertical {\n    width: auto;\n  }\n  .geolocation-data-horizontal {\n    flex-direction: row;\n    width: auto;\n  }\n  .geolocation-data-horizontal .geolocation-data-set {\n    border-bottom: none;\n    border-right: 1px solid #eee;\n  }\n}\n.incentives-edit-icon {\n  height: 32px;\n  width: 32px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 3px 3px -1.5px rgba(0, 0, 0, 0.02), 0 6px 6px -3px rgba(0, 0, 0, 0.02), 0 12px 12px -6px rgba(0, 0, 0, 0.02);\n  transition: all 200ms ease-in-out;\n  position: absolute;\n  right: 22px;\n  top: 41px;\n  z-index: 10;\n}\n.incentives-edit-icon i {\n  transition: all 200ms ease-in-out;\n}\n.incentives-edit-icon:hover {\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 3px 3px 0 rgba(0, 0, 0, 0.02), 0 6px 6px 0 rgba(0, 0, 0, 0.02), 0 12px 12px 0 rgba(0, 0, 0, 0.02);\n  transform: scale(1.05);\n}\n.incentives-edit-icon:hover i {\n  color: #c84900;\n}\n/* ==================================================================  \n    INCENTIVES REPORT CLASSES \n================================================================== */\n.work-order-incentives-total {\n  border: 1px solid #f2f2f2;\n  border-radius: 6px;\n  padding: 12px 0;\n  display: flex;\n  gap: 0;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #777;\n  text-align: left;\n}\n.work-order-incentives-total span {\n  font-size: 18px;\n  line-height: 1.42;\n  display: block;\n  color: #111;\n}\n.work-order-incentives-total > div {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0 16px;\n  border-right: 1px solid #e6e6e6;\n}\n.work-order-incentives-total > div:last-child {\n  border-right: 0;\n  padding-right: 4px;\n}\n.solutions-available-incentives {\n  border: 1px solid rgba(52, 86, 73, 0.1);\n  border-radius: 6px;\n  padding: 12px 16px;\n  margin-bottom: 12px;\n  position: relative;\n  overflow: hidden;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.42;\n  color: #222;\n}\n.solutions-available-incentives span {\n  display: block;\n  font-size: 24px;\n  line-height: 1.42;\n  font-weight: 600;\n}\n.solutions-available-incentives::before {\n  display: block;\n  content: '';\n  width: 100px;\n  height: 100px;\n  z-index: 10;\n  position: absolute;\n  right: 24px;\n  top: -22px;\n  background: url(../img/ui/savingsIcon.svg) no-repeat;\n  mix-blend-mode: luminosity;\n}\n.incentives-report-title-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.42;\n  color: #555;\n}\n.incentives-report-title-section span {\n  padding: 0 4px;\n  display: inline-block;\n}\n.incentives-report-title-section h1 {\n  margin: 0;\n  line-height: 1.2;\n  font-size: 18px;\n  padding-top: 4px;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.key-value-container {\n  background-color: #f9f9f9;\n  border: 1px solid #e6e6e6;\n  border-radius: 6px;\n  padding: 12px 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #111;\n  display: flex;\n}\n.key-value-container div {\n  padding-left: 24px;\n  padding-right: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  justify-content: center;\n  border-right: 1px solid #e6e6e6;\n}\n.key-value-container div:first-child {\n  padding-left: 16px;\n}\n.key-value-container div:last-child {\n  padding-right: 16px;\n  border-right: none;\n}\n.key-value-container span {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #777;\n}\n.key-value-container a {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #c84900;\n  display: inline;\n}\n.key-value-container a:hover {\n  text-decoration: underline;\n}\n.key-value-container p {\n  margin: 0;\n  padding: 0;\n}\n.incentives-description-section {\n  margin-top: 8px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.7;\n  color: #333;\n}\n.incentives-description-section h2 {\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #333;\n  margin-bottom: 8px;\n}\n.incentives-description-section ul {\n  padding-left: 16px;\n}\n.incentives-description-section ul,\n.incentives-description-section li {\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.7;\n  color: #333;\n}\n/* ============= POTENTIAL INCENTIVES TABLE ============= */\n.table-potential-incentives {\n  border: none;\n  font-size: 13px;\n  line-height: 1.42;\n  font-weight: 600;\n  color: #111;\n  page-break-inside: avoid;\n  margin-bottom: 0;\n}\n.table-potential-incentives tr {\n  page-break-inside: avoid;\n  break-inside: avoid;\n}\n.table-potential-incentives td {\n  border-top: 1px solid #eee !important;\n  padding: 6px 12px !important;\n  vertical-align: middle !important;\n}\n.table-potential-incentives thead th {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 142%;\n  color: #555;\n  padding: 8px 12px !important;\n  border-bottom: 2px solid #e6e6e6;\n}\n.table-potential-incentives .table-section-row {\n  background-color: #f7f7f7;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #555;\n}\n.table-potential-incentives .table-section-row td {\n  border-bottom: 1px solid #eee !important;\n  border-top: 1px solid #eee !important;\n  padding: 3px 12px !important;\n  letter-spacing: 0.2px;\n}\n.table-potential-incentives .table-incentive-name {\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: #111;\n}\n.table-potential-incentives .table-incentive-name span {\n  font-size: 11px;\n  line-height: 1.3;\n  color: #656565;\n  display: block;\n  font-weight: 500;\n}\n.table-potential-incentives .table-total-row {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.42;\n  color: #111;\n}\n.potential-incentives-wrapper {\n  page-break-inside: avoid;\n  break-inside: avoid;\n}\n.table-style-2 thead th {\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 142%;\n  color: #555;\n  padding: 8px 12px !important;\n  border-bottom: 2px solid #eee;\n}\n.table-style-2 tbody tr td {\n  border-bottom: 1px dashed #eee;\n  border-top: none !important;\n}\n.table-style-2 .table-section-category {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #656565;\n}\n.table-style-2 .table-section-category td {\n  padding: 20px 8px 4px !important;\n  border-bottom: none !important;\n  border-top: none !important;\n}\n.table-style-2 .table-incentive-name {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: #111;\n}\n.table-style-2 .table-incentive-name span {\n  font-size: 11px;\n  line-height: 1.3;\n  color: #656565;\n  display: block;\n  font-weight: 500;\n}\n.table-style-2 .table-total-row {\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.42;\n  color: #111;\n}\n.table-style-2 .table-total-row td {\n  border-bottom: none !important;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n/* INCENTIVES DETAILS TABLE ROW */\n.row-subheader {\n  background-color: #f9f9f9;\n  font-weight: bold;\n}\n/* ===================== BPI 2400 CSS =====================*/\n.bpi-2400-container {\n  border: 1px solid #e6e6e6;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n  padding: 24px 16px;\n  border-radius: 6px;\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n.bpi-2400-status-icon {\n  height: 48px;\n  width: 48px;\n}\n.bpi-2400-status.success {\n  color: #039855;\n}\n.bpi-2400-status.error {\n  color: #d92d20;\n}\n.bpi-2400-status.unavailable {\n  color: #656565;\n}\n.bpi-2400-date-time {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.42;\n  color: #656565;\n  margin-bottom: 0;\n}\n.bpi-2400-button-container {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n}\n.bpi-2400-button-container .primary-button {\n  border: none;\n  width: auto;\n  padding: 6px 10px;\n  color: #c84900;\n  transition: all 250ms ease-in-out;\n}\n.bpi-2400-button-container .secondary-button {\n  border: 1px solid rgba(200, 73, 0, 0.15);\n  width: auto;\n  padding: 6px 10px;\n  color: #c84900;\n  transition: all 250ms ease-in-out;\n  background-color: #fff;\n}\n.bpi-2400-button-container .secondary-button:hover {\n  border: 1px solid rgba(200, 73, 0, 0.15);\n}\n/* ===================== ALTERNATIVE METHOD CSS =====================*/\n.alternative-method-card-container {\n  background-color: #f2f2f2;\n  border-radius: 6px;\n}\n.alternative-method-card-container .alternative-method-card-header {\n  padding: 6px 16px 5px;\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.42;\n  letter-spacing: 0.5px;\n  text-align: left;\n  color: #777;\n}\n/* ===================== HES MODAL CSS =====================*/\n.hes-modal .hes-savings {\n  background-color: #f7f7f7;\n  border: 1px solid #eee;\n  border-radius: 6px;\n  padding: 6px 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  line-height: 1.42;\n  color: #555;\n}\n.hes-modal .hes-savings span {\n  color: #7cad3e;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.42;\n}\n.hes-modal .no-intial-score {\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  flex-direction: column;\n  padding-top: 16px;\n  padding-bottom: 40px;\n}\n.hes-modal .no-alt-final-score {\n  text-align: center;\n  position: absolute;\n  margin-left: 50%;\n  transform: translateX(-50%);\n  bottom: -90px;\n}\n.hes-modal .hes-container {\n  margin-top: 0;\n  margin-left: 0;\n  margin-right: 0;\n  padding: 120px 0;\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n.hes-modal .hes-legend {\n  min-height: 60px;\n  padding: 2px 5px 0;\n  text-align: left;\n  font-weight: 600;\n  font-size: 12px;\n}\n.hes-modal .hes-legend:last-child {\n  text-align: left;\n}\n.hes-modal .hes-spectrum {\n  position: relative;\n}\n.hes-modal .hes-spectrum ul {\n  text-align: center;\n  background: #d9d9d9;\n  background: linear-gradient(to right, #d9d9d9 0%, #cbd4bf 44%, #89c648 97%, #89c648 100%);\n  display: flex;\n  gap: 2px;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  font-weight: 700;\n  font-size: 20px;\n}\n.hes-modal .hes-spectrum ul li {\n  padding: 12px 0;\n  margin: 0;\n  border-right: 3px solid white;\n  box-sizing: border-box;\n}\n.hes-modal .hes-spectrum ul li:last-child {\n  border-right: none;\n}\n.checklist-settings-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.checklist-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.import-checklist-box {\n  padding: 64px;\n  background-color: #fff;\n  border: 1px dashed #ccc;\n  border-radius: 6px;\n  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n}\n.import-checklist-box .text-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n}\n.import-checklist-box h2 {\n  font-size: 16px;\n  font-weight: 600;\n  color: #111;\n  margin: 0;\n}\n.import-checklist-box span {\n  display: block;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.8;\n  color: #777;\n  text-align: center;\n}\n.download-sample-file {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 8px;\n}\n.compare-category .compare-question-container:last-child .compare-linestyle {\n  display: none;\n}\n.compare-category-text {\n  margin: 0 0 16px 0;\n  padding: 8px 12px;\n  font-size: 18px;\n  line-height: 1.42;\n  color: #000;\n  background-color: #f7f7f7;\n}\n.compare-question {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.42;\n  color: #111111;\n  text-align: right;\n  padding: 6px 4px;\n}\n.compare-question span {\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 1.42;\n  color: #777777;\n  display: block;\n}\n.compare-linestyle {\n  border-top: 1px solid #eee;\n  margin: 0 0 16px 0;\n}\n.checklist-questions-category {\n  font-size: 20px;\n  font-weight: 600;\n  color: #111;\n  margin-top: 32px;\n  margin-bottom: 12px;\n}\n.checklist-questions-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.checklist-questions-container .checklist-question {\n  padding: 12px;\n  background-color: #f9f9f9;\n  border-radius: 12px;\n  font-size: 14px;\n  line-height: 1.42;\n  color: #777;\n  font-weight: 600;\n  display: flex;\n  gap: 8px;\n}\n.checklist-questions-container .checklist-question .question {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n}\n.checklist-questions-container .checklist-question .question span {\n  font-size: 12px;\n  font-weight: 600;\n  color: #777;\n}\n.checklist-questions-container .checklist-question .question-number {\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n  padding-left: 12px;\n}\n.checklist-questions-container .checklist-question .question-number span {\n  font-size: 12px;\n  font-weight: 600;\n  color: #777;\n}\n.checklist-questions-container .checklist-question .checklist-question-content {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n.checklist-questions-container .checklist-question .checklist-question-content > span {\n  display: block;\n}\n.checklist-empty-state {\n  padding: 80px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n}\n.checklist-empty-state .checklist-empty-state__text {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: 8px;\n}\n.checklist-empty-state h2 {\n  font-size: 16px;\n  line-height: 1.42;\n  font-weight: 700;\n  color: #111;\n  margin: 0;\n}\n.checklist-empty-state p {\n  font-size: 14px;\n  line-height: 1.42;\n  font-weight: 500;\n  color: #777;\n  text-align: center;\n}\n.checklist-archived-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 24px;\n}\n.checklist-archived-section .checklist-archived-date {\n  padding: 4px 8px;\n  background-color: #eee;\n  font-size: 14px;\n  font-weight: 600;\n  color: #2b2b2b;\n  border-radius: 6px;\n}\n.checklist-archived-section .checklist-archived-question-container {\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  border-bottom: 1px solid #eee;\n  font-weight: 600;\n  font-size: 14px;\n  color: #2b2b2b;\n  transition: all 200ms ease-in-out;\n}\n.checklist-archived-section .checklist-archived-question-container:last-child {\n  border-bottom: none;\n}\n.checklist-archived-section .checklist-archived-question-container:hover {\n  background-color: #f2f2f2;\n}\n.checklist-archived-section .checklist-archived-question-container .checklist-archived-answer {\n  display: block;\n  font-size: 16px;\n  font-weight: 700;\n}\n.report-branding-setting .report-branding-settings-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.report-branding-setting .report-branding-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.report-branding-setting .theme-section {\n  margin-bottom: 40px;\n}\n.report-branding-setting .theme-section .section-title {\n  font-weight: 600;\n  margin-top: 0;\n  margin-bottom: 16px;\n  color: #777;\n  font-size: 14px;\n}\n.report-branding-setting .theme-list-container {\n  display: flex;\n  align-items: flex-start;\n  align-content: flex-start;\n  gap: 24px;\n  align-self: stretch;\n  flex-wrap: wrap;\n}\n.report-branding-setting .theme-card {\n  width: 160px;\n  padding: 16px 16px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 3px 3px -1.5px rgba(0, 0, 0, 0.02), 0 6px 6px -3px rgba(0, 0, 0, 0.02), 0 12px 12px -6px rgba(0, 0, 0, 0.02);\n  transition: all 200ms ease-in-out;\n  cursor: pointer;\n}\n.report-branding-setting .theme-card:hover {\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.08), 0 3px 3px -1.5px rgba(0, 0, 0, 0.04), 0 6px 6px -3px rgba(0, 0, 0, 0.04), 0 12px 12px -6px rgba(0, 0, 0, 0.04);\n}\n.report-branding-setting .theme-card:active {\n  transform: scale(0.97);\n}\n.report-branding-setting .theme-card .theme-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.42;\n  color: #2b2b2b;\n}\n.report-branding-setting .theme-card .theme-card-header .more-options {\n  min-width: 30px;\n  height: 30px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  cursor: pointer;\n  background-color: transparent;\n  transition: background 200ms ease-in-out;\n  padding: 0 1px 0 0;\n}\n.report-branding-setting .theme-card .theme-card-header .more-options:hover {\n  background: #f0f0f0;\n}\n.report-branding-setting .theme-card .theme-card-header .more-options i {\n  transform: rotate(90deg) !important;\n  line-height: 1;\n  color: #777;\n}\n.report-branding-setting .theme-card.custom-theme {\n  width: 274px;\n  gap: 32px;\n}\n.report-branding-setting .theme-card .theme-color-block {\n  width: 80px;\n  height: 48px;\n  border-radius: 6px;\n  display: flex;\n  overflow: hidden;\n  border: 1px solid #000;\n}\n.report-branding-setting .theme-card .theme-color-block div {\n  height: 100%;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 16px;\n  line-height: 1.42;\n  font-weight: 600;\n  text-align: center;\n}\n.report-branding-setting .create-theme-action {\n  width: 274px;\n  height: 150px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  gap: 12px;\n  border-radius: 12px;\n  border: 1px dashed #ccc;\n  background: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #777777;\n  cursor: pointer;\n  transition: all 150ms ease-in-out;\n}\n.report-branding-setting .create-theme-action:hover {\n  border-color: #999;\n  background: #f9f9f9;\n}\n.report-branding-setting .create-theme-action:active {\n  transform: scale(0.98);\n}\n.report-branding-setting .report-branding-custom-dropdown {\n  width: 30px;\n  height: 30px;\n}\n.report-branding-setting .report-branding-custom-dropdown ul {\n  width: auto;\n  padding: 6px !important;\n  overflow: hidden;\n}\n.report-branding-setting .report-branding-custom-dropdown li {\n  margin: 0 !important;\n}\n.report-branding-setting .report-branding-custom-dropdown li a {\n  font-weight: normal;\n}\n.report-branding-setting .report-branding-custom-dropdown .divider {\n  margin: 2px !important;\n}\n.report-branding-setting .colors-input-section {\n  margin-bottom: 12px;\n}\n.report-branding-setting .colors-input-section-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #777;\n  margin-bottom: 12px;\n  margin-top: 0;\n}\n.report-branding-setting .colors-input-container {\n  display: flex;\n  gap: 8px;\n}\n.report-branding-setting .auto-gererate-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: space-between;\n}\n.report-preview-page {\n  width: 1005px;\n  height: 816px;\n  padding: 30px;\n  background-color: #fff;\n  box-shadow: 0 0 0 0.979px rgba(0, 0, 0, 0.06), 0 3px 3px -1.5px rgba(0, 0, 0, 0.02), 0 6px 6px -3px rgba(0, 0, 0, 0.02), 0 0 12px 8px rgba(0, 0, 0, 0.02);\n  border-radius: 6px;\n  border: none;\n  transform-origin: top left;\n  transform: scale(0.7);\n  margin: 0;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .report-header {\n  background: url('../img/programs/xcel/xcel-rebate-banner.png') no-repeat no-repeat right;\n  background-size: auto 60px;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .report-body {\n  height: 550px;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-header {\n  font-size: 15px;\n  color: #81112d;\n  margin: 0;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-header.large-sub-header {\n  margin-top: 10px;\n  font-size: 2em;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .fine-print {\n  font-size: 0.7em;\n  line-height: 1.5;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .fine-print2 {\n  font-size: 0.7em;\n  line-height: 12px;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel ul > li {\n  margin: 12px 0;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .text-center {\n  text-align: center;\n  margin-top: 20px;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .text-right {\n  text-align: right;\n  margin-top: 20px;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel img.rebate-icon {\n  width: auto;\n  height: 14px;\n  margin-right: 5px;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .call-to-action {\n  margin-top: 15px;\n  height: 100px;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .call-to-action .contact {\n  margin-top: 0;\n  font-size: 1.5em;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .call-to-action .advisor-logo.img {\n  margin-left: 10px;\n  margin-top: -10px;\n  width: 110px;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel blockquote {\n  background: #f9f9f9;\n  border-left: 2px solid #eee;\n  margin: 1.1em 1em;\n  padding: 0.5em 1em;\n  quotes: '\\201C' '\\201D';\n}\n.report-page.report-page-rebates .report-page-rebates-xcel blockquote:before {\n  color: #808080;\n  content: open-quote;\n  font-size: 4em;\n  line-height: 0.1em;\n  margin-right: 0.25em;\n  vertical-align: -0.4em;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel blockquote:first-child {\n  display: inline;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table {\n  font-size: 0.7em;\n  line-height: 1.1em;\n  margin-bottom: 4px;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1 .col-power {\n  width: 6%;\n  text-align: center;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1 .col-rebate-area {\n  width: 10%;\n  font-weight: bold;\n  line-height: 1.1;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1 .col-qualifier1 {\n  width: 12%;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1 .col-qualifier2 {\n  width: 8%;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1 .col-rebate {\n  width: 0.8%;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1 .col-info {\n  width: 40%;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1-1 .col-power {\n  width: 7.4%;\n  text-align: center;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1-1 .col-rebate-area {\n  width: 36.5%;\n  background-color: #9b9da2;\n  font-weight: bold;\n  color: #ffffff;\n  line-height: 1.1;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1-1 .col-qualifier {\n  width: 15%;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1-1 .col-utility1 {\n  width: 3.7%;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1-1 .col-utility2 {\n  width: 17.7%;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-1-1 .col-utility3 {\n  width: 17.7%;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2 td {\n  line-height: 1.4;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2 .col-power {\n  width: 7%;\n  text-align: center;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2 .col-rebate-area {\n  width: 30%;\n  background-color: #9b9da2;\n  font-weight: bold;\n  color: #ffffff;\n  line-height: 1.1;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2 .col-rebate {\n  width: 20%;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2 .col-info {\n  width: 43%;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2-1 td {\n  line-height: 1.4;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2-1 .col-measures {\n  width: 50%;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2-1 .col-utility1 {\n  width: 14%;\n  text-align: right;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2-1 .col-utility1.1 {\n  width: 3%;\n  text-align: right;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2-1 .col-utility2 {\n  width: 15%;\n  text-align: right;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table.xcel-table-2-1 .col-utility3 {\n  width: 15%;\n  text-align: right;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table th {\n  border: 1px solid #c8c9cc;\n  border-bottom: 0;\n  border-top: 0;\n  line-height: 1.5;\n  padding: 2px 4px;\n  background-color: #221f20;\n  color: #ffffff;\n  text-transform: none;\n  font-size: 1em;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table td {\n  border: 1px solid #c7c9cc;\n  vertical-align: middle;\n  padding: 3px 6px;\n  line-height: 1.2;\n  color: #262626;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table [class*='header'] td {\n  padding: 3px 4px;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-cooling {\n  background-color: #e92c31;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-cooling td {\n  color: #fff;\n  border-bottom: 0;\n  border-top: 0;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-cooling-odd {\n  background-color: #ffffff;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-cooling-even {\n  background-color: #f5f5f5;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-heating {\n  background-color: #e92c31;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-heating td {\n  color: #fff;\n  border-bottom: 0;\n  border-top: 0;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-heating-odd {\n  background-color: #ffffff;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-heating-even {\n  background-color: #f5f5f5;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-dhw {\n  background-color: #e92c31;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-dhw td {\n  color: #fff;\n  border-bottom: 0;\n  border-top: 0;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-dhw-odd {\n  background-color: #ffffff;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-dhw-even {\n  background-color: #f5f5f5;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-insulation {\n  background-color: #e92c31;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-insulation td {\n  color: #fff;\n  border-bottom: 0;\n  border-top: 0;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .subheader-insulation {\n  background-color: #dddee0;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .subheader-insulation td {\n  color: #000;\n  border: 1px solid #b7b9bd;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .subheader-hpwes {\n  background-color: #9b9da2;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .subheader-hpwes td {\n  color: #fff;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-insulation-odd {\n  background-color: #ffffff;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-insulation-even {\n  background-color: #f5f5f5;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-audit {\n  background-color: #e92c31;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-audit td {\n  color: #fff;\n  border-bottom: 0;\n  border-top: 0;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-audit-odd {\n  background-color: #ffffff;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-audit-even {\n  background-color: #f5f5f5;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-hpwes {\n  background-color: #e92c31;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .header-hpwes td {\n  color: #fff;\n  border-bottom: 0;\n  border-top: 0;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-hpwes-odd {\n  background-color: #ffffff;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-hpwes-even {\n  background-color: #f5f5f5;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-right {\n  text-align: right;\n}\n.report-page.report-page-rebates .report-page-rebates-xcel .rebate-table .item-center {\n  text-align: center;\n}\n.report-page.report-page-rebates .report-page-rebates-aps {\n  font-size: 0.95em;\n  line-height: 1.4em;\n}\n.report-page.report-page-rebates .report-page-rebates-aps ul,\n.report-page.report-page-rebates .report-page-rebates-aps ol {\n  padding-left: 20px;\n}\n.report-page.report-page-rebates .report-page-rebates-aps h3 {\n  margin-top: 20px;\n}\n.report-page.report-page-rebates .report-page-rebates-aps h4 {\n  margin: 30px 0 6px;\n}\n.report-page.report-page-rebates .report-page-rebates-aps li {\n  line-height: 1.35em;\n}\n.report-page.report-page-rebates .report-page-rebates-aps p {\n  margin-bottom: 10px;\n}\n.report-page-rebates-cvetu {\n  padding-top: 10px;\n}\n.report-page-rebates-cvetu .timelineContainer img {\n  max-width: 100%;\n}\n.report-page-rebates-cvetu .breakoutStyle {\n  background-color: #f3f3f3;\n  font-size: 12px;\n  line-height: 20px;\n  font-weight: 600;\n}\n.report-page-rebates-cvetu .textAlignCenter {\n  text-align: center;\n}\n.report-page-rebates-cvetu .cvetu-body {\n  padding-top: 20px;\n}\n.report-page-rebates-cvetu .cvetu-body h2 {\n  font-size: 18px;\n  font-weight: 600;\n  color: #2f2d2b;\n}\n.report-page-rebates-cvetu .cvetu-body h3 {\n  font-size: 14px;\n  font-weight: 600;\n  color: #2f2d2b;\n}\n.report-page-rebates-cvetu .cvetu-body p,\n.report-page-rebates-cvetu .cvetu-body ul {\n  font-size: 12px;\n  line-height: 18px;\n  color: #2f2d2b;\n}\n.report-page-rebates-cvetu .cvetu-body p {\n  margin: 10px 0;\n}\n.report-page-rebates-cvetu .cvetu-body li {\n  margin: 5px 0;\n}\n.report-page-rebates-cvetu .cvetu-body ul {\n  padding-left: 15px;\n}\n.report-page-rebates-cvetu .cvetu-body h4 {\n  font-size: 13px;\n  font-weight: 700;\n  color: #2f2d2b;\n}\n.report-page-rebates-cvetu .cvetu-body a {\n  color: #0092d9;\n}\n.report-page-rebates-cvetu .cvetu-body table {\n  font-size: 10px;\n}\n.report-page-rebates-cvetu .cvetu-body table td {\n  vertical-align: middle;\n}\n.report-page-rebates-cvetu .cvetu-body table th {\n  font-size: 11px;\n  text-align: center;\n  vertical-align: middle;\n}\n.report-page-rebates-cvetu .cvetu-body table img {\n  max-width: 100%;\n  max-height: 50px;\n}\n.report-page-rebates-cvetu .loanProgramList li {\n  margin: 15px 0;\n}\n.report-page-rebates-cvetu .solarContractorList li {\n  margin: 15px 0;\n}\n.report-page-rebates-cvetu .cvetu-terms,\n.report-page-rebates-cvetu .cvetu-terms p {\n  font-size: 11px;\n  line-height: 17px;\n}\n.report-page-rebates-cvetu .cvetu-terms p,\n.report-page-rebates-cvetu .cvetu-terms p p {\n  margin-top: 0;\n}\n.report-page.report-page-tech_specs .headline-style {\n  font-size: 16px;\n  color: #000;\n  font-weight: 600;\n  padding-left: 20px;\n  margin: 0;\n}\n.report-page.report-page-tech_specs .homeIcon {\n  width: 70%;\n  margin-top: -15px;\n}\n.report-page.report-page-tech_specs .tableTypeStyle {\n  font-size: 12px;\n}\n.report-page.report-page-tech_specs .tableTypeStyle b u {\n  padding-top: 7px;\n  display: inline-block;\n}\n.report-page.report-page-tech_specs .tableTypeStyle > .r-row [class*='r-spa']:nth-child(1) {\n  text-align: right;\n  padding: 1px 0;\n}\n.report-page.report-page-tech_specs .tableTypeStyle > .r-row [class*='r-spa']:nth-child(2) {\n  text-align: left;\n  font-weight: 600;\n  padding: 1px 0;\n}\n.report-page.report-page-tech_specs .leftBorder {\n  position: relative;\n  padding-bottom: 10px;\n}\n.report-page.report-page-tech_specs .leftBorder ::before {\n  content: '';\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  bottom: 0;\n  left: 0%;\n  border-left: 2px solid #213a81;\n  transform: translate(-2px);\n}\n.report-page.report-page-tech_specs .rightBorder {\n  position: relative;\n  padding-bottom: 10px;\n}\n.report-page.report-page-tech_specs .rightBorder ::before {\n  content: '';\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  bottom: 0;\n  left: 100%;\n  border-right: 2px solid #213a81;\n  transform: translate(16px);\n}\n.report-page.report-page-tech_specs .topBorder {\n  border-top: 2px solid #213a81;\n  padding-top: 15px;\n}\n.report-page.report-page-tech_specs .fontSize12 {\n  font-size: 12px;\n}\n.report-page.report-page-tech_specs .fontSize12 [class*='r-spa'] {\n  padding: 1px 0;\n}\n.eneContentStyle.eneContentStyleXL p {\n  font-size: 11px;\n}\n.eneContentStyle table {\n  border: 1px solid #ddd;\n  border-collapse: collapse;\n  font-size: 10px;\n  line-height: 1.2;\n  margin-bottom: 10px;\n  width: 100%;\n}\n.eneContentStyle table td,\n.eneContentStyle table th {\n  border: 1px solid #ddd;\n  border-collapse: collapse;\n  padding: 2px 5px 2px 7px;\n}\n.eneContentStyle table th,\n.eneContentStyle table .headStyle td {\n  padding: 5px 5px 5px 7px;\n  background: #f0f0f0;\n}\n.eneContentStyle table td.rightAlign,\n.eneContentStyle table th.rightAlign {\n  text-align: right;\n}\n.eneContentStyle table tr:nth-child(even) {\n  background: #fafafa;\n}\n.eneContentStyle table.lessContent {\n  font-size: 12px;\n  line-height: 1.5;\n}\n.eneContentStyle table.lessContent td,\n.eneContentStyle table.lessContent th,\n.eneContentStyle table.lessContent tr.headStyle td {\n  padding: 4px 5px 4px 7px;\n}\n.eneContentStyle table.lessContent2 {\n  font-size: 11px;\n  line-height: 1.3;\n}\n.eneContentStyle table.lessContent2 td {\n  padding: 4px 5px 4px 7px;\n}\n.eneContentStyle table.lessContent2 tr.headStyle td,\n.eneContentStyle table.lessContent2 th {\n  padding: 6px 5px 6px 7px;\n}\n.eneContentStyle Table.lessContent3 {\n  font-size: 11px;\n  line-height: 1.3;\n}\n.eneContentStyle Table.lessContent3 td {\n  padding: 3px 5px 3px 7px;\n}\n.eneContentStyle Table.lessContent3 tr.headStyle td,\n.eneContentStyle Table.lessContent3 th {\n  padding: 4px 5px 4px 7px;\n}\n.eneContentStyle Table.lessContent4 {\n  font-size: 11px;\n  line-height: 1.2;\n}\n.eneContentStyle Table.lessContent4 td {\n  padding: 2px 5px 2px 5px;\n}\n.eneContentStyle Table.lessContent4 tr.headStyle td,\n.eneContentStyle Table.lessContent4 th {\n  padding: 2px 5px 2px 5px;\n}\n.eneContentStyle table.eneCompact th,\n.eneContentStyle table.eneCompact .headStyle td {\n  padding: 3px 5px 3px 5px;\n}\n.eneContentStyle ul {\n  font-size: 12px;\n  margin-bottom: 5px;\n  padding-left: 20px;\n}\n.eneContentStyle p {\n  font-size: 10px;\n  line-height: 1.5;\n  margin-bottom: 5px;\n}\n.eneContentStyle h2 {\n  font-size: 12px;\n  color: #2f2b22;\n  margin-bottom: 2px;\n  line-height: 1.2;\n}\n.eneContentStyle hr {\n  margin-top: 0px;\n  margin-bottom: 15px;\n}\n.eneContentStyle .title {\n  float: left;\n  font-size: 15px;\n  font-weight: 700;\n  text-transform: uppercase;\n  padding-top: 5px;\n}\n.eneContentStyle .logoImg {\n  max-width: 100%;\n  height: 30px;\n  width: auto;\n  margin-bottom: 4px;\n  float: right;\n}\n.eneContentStyle .headerProgramName {\n  font-size: 10;\n  display: block;\n}\n.eneContentStyle .bold {\n  font-weight: 700;\n}\n.eneContentStyle .conditions {\n  color: #ef233c;\n  line-height: 1.5;\n  font-weight: 600;\n}\n.report-page.report-page-coc .table.table-extra-condensed.new-jersey-coc-table > thead > tr > th:nth-child(1) {\n  width: 160px;\n}\n.report-page.report-page-coc .table.table-extra-condensed.new-jersey-coc-table > thead > tr > th:nth-child(2) {\n  width: 190px;\n}\n.report-page.report-page-coc .table.table-extra-condensed.new-jersey-coc-table > thead > tr > th:nth-child(3) {\n  width: 130px;\n}\n.report-page.report-page-coc .table.table-extra-condensed.new-jersey-coc-table > thead > tr > th:nth-child(4) {\n  width: 130px;\n}\n.report-page.report-page-coc .table.table-extra-condensed.new-jersey-coc-table > thead > tr > th:nth-child(3) {\n  width: 80px;\n}\n.report-page.report-page-coc .table.table-extra-condensed.new-jersey-coc-table > tbody > tr > td {\n  padding-right: 8px;\n}\n.report-page .report-page-contract-terms-berkshire-gas {\n  font-size: 11px;\n}\n.report-page .report-page-contract-terms-berkshire-gas p {\n  line-height: 1.3em;\n}\n.report-page .report-page-contract-terms-berkshire-gas h5 {\n  font-size: 1em;\n  font-style: bold;\n}\n.report-page .report-page-contract-terms-berkshire-gas ol {\n  padding-left: 20px;\n}\n.report-page .report-page-rebates-wge .fine-print {\n  font-size: 10px;\n  line-height: 1.5;\n}\n.report-page .report-page-rebates-wge .note {\n  font-size: 10px;\n  line-height: 1.5;\n  display: block;\n  padding: 5px 8px;\n  background-color: #eee;\n  border-radius: 4px;\n}\n.report-page .report-page-rebates-wge .heading-rebate-table {\n  font-size: 12px;\n  font-weight: 600;\n}\n.report-page .report-page-rebates-wge table {\n  margin-bottom: 10px;\n  width: 100%;\n  border: 1px solid #ddd;\n}\n.report-page .report-page-rebates-wge table.table-extra-condensed > tbody > tr > td,\n.report-page .report-page-rebates-wge table.table-extra-condensed > thead > tr > th {\n  border: 1px solid #ddd;\n  padding: 3px 4px;\n  line-height: 1.3;\n  font-size: 10px;\n}\n.report-page .report-page-rebates-wge table.table-extra-condensed > thead > tr > th {\n  letter-spacing: 0.03em;\n  text-transform: none;\n}\n.report-page .report-page-rebates-wge table.table-extra-condensed > thead > tr > th.darkbackground {\n  background-color: #555555;\n  color: #fff;\n}\n.wysiwyg .editor {\n  border: 1px solid transparent;\n  height: 100%;\n  overflow: hidden;\n}\n.wysiwyg .editor.blank-editor:before {\n  display: block;\n  content: 'Click to add text';\n  color: #777777;\n}\n.wysiwyg .editor:focus {\n  border: 1px solid #777777;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  outline: none;\n}\n.wysiwyg .editor:hover {\n  background-color: #feeeb2;\n}\n.wysiwyg .editor:hover:focus {\n  background-color: inherit;\n}\n.wysiwyg .toolbar {\n  width: 360px;\n}\n.wysiwyg .toolbar .btn {\n  float: left;\n  font-size: 18px;\n  width: 45px;\n  height: 45px;\n  border-radius: 0;\n  text-align: center;\n  box-shadow: 0 -1px 1px rgba(0, 0, 0, 0.5);\n}\n.wysiwyg .toolbar .btn:active:focus {\n  outline: none;\n}\n.wysiwyg .toolbar .btn:first-child {\n  border-top-left-radius: 5px;\n}\n.wysiwyg .toolbar .btn:last-child {\n  border-top-right-radius: 5px;\n}\n.wysiwyg .toolbar .btn [class*=' icon-'],\n.wysiwyg .toolbar .btn [class^='icon-'] {\n  font-size: 15px;\n}\n.wysiwyg .toolbar .btn.active {\n  background-color: #d0d0d0;\n}\n.wysiwyg .toolbar .btn-bold {\n  font-weight: 700;\n}\n.wysiwyg .toolbar .btn-italic {\n  font-style: italic;\n}\n.custom-rc-pagination .rc-pagination-item,\n.custom-rc-pagination .rc-pagination-jump-prev,\n.custom-rc-pagination .rc-pagination-jump-next,\n.custom-rc-pagination .rc-pagination-prev,\n.custom-rc-pagination .rc-pagination-next,\n.custom-rc-pagination .rc-pagination-jump-prev,\n.custom-rc-pagination .rc-pagination-jump-next {\n  border: 1px solid #eeeeee;\n  background-color: #fff;\n  min-width: 38px;\n  height: 38px;\n  line-height: 38px;\n}\n.custom-rc-pagination .rc-pagination-item a,\n.custom-rc-pagination .rc-pagination-jump-prev a,\n.custom-rc-pagination .rc-pagination-jump-next a,\n.custom-rc-pagination .rc-pagination-prev a,\n.custom-rc-pagination .rc-pagination-next a,\n.custom-rc-pagination .rc-pagination-jump-prev a,\n.custom-rc-pagination .rc-pagination-jump-next a {\n  color: #c84900;\n}\n.custom-rc-pagination .rc-pagination-item:hover,\n.custom-rc-pagination .rc-pagination-jump-prev:hover,\n.custom-rc-pagination .rc-pagination-jump-next:hover,\n.custom-rc-pagination .rc-pagination-prev:hover,\n.custom-rc-pagination .rc-pagination-next:hover,\n.custom-rc-pagination .rc-pagination-jump-prev:hover,\n.custom-rc-pagination .rc-pagination-jump-next:hover {\n  border-color: #777777;\n}\n.custom-rc-pagination .rc-pagination-item:hover a,\n.custom-rc-pagination .rc-pagination-jump-prev:hover a,\n.custom-rc-pagination .rc-pagination-jump-next:hover a,\n.custom-rc-pagination .rc-pagination-prev:hover a,\n.custom-rc-pagination .rc-pagination-next:hover a,\n.custom-rc-pagination .rc-pagination-jump-prev:hover a,\n.custom-rc-pagination .rc-pagination-jump-next:hover a {\n  color: #555555;\n}\n.custom-rc-pagination .rc-pagination-item:active,\n.custom-rc-pagination .rc-pagination-jump-prev:active,\n.custom-rc-pagination .rc-pagination-jump-next:active,\n.custom-rc-pagination .rc-pagination-prev:active,\n.custom-rc-pagination .rc-pagination-next:active,\n.custom-rc-pagination .rc-pagination-jump-prev:active,\n.custom-rc-pagination .rc-pagination-jump-next:active {\n  background-color: #eeeeee;\n}\n.custom-rc-pagination .rc-pagination-item:active a,\n.custom-rc-pagination .rc-pagination-jump-prev:active a,\n.custom-rc-pagination .rc-pagination-jump-next:active a,\n.custom-rc-pagination .rc-pagination-prev:active a,\n.custom-rc-pagination .rc-pagination-next:active a,\n.custom-rc-pagination .rc-pagination-jump-prev:active a,\n.custom-rc-pagination .rc-pagination-jump-next:active a {\n  color: #c84900;\n}\n.custom-rc-pagination .rc-pagination-item.rc-pagination-disabled,\n.custom-rc-pagination .rc-pagination-jump-prev.rc-pagination-disabled,\n.custom-rc-pagination .rc-pagination-jump-next.rc-pagination-disabled,\n.custom-rc-pagination .rc-pagination-prev.rc-pagination-disabled,\n.custom-rc-pagination .rc-pagination-next.rc-pagination-disabled,\n.custom-rc-pagination .rc-pagination-jump-prev.rc-pagination-disabled,\n.custom-rc-pagination .rc-pagination-jump-next.rc-pagination-disabled,\n.custom-rc-pagination .rc-pagination-item .rc-pagination-disabled:hover,\n.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:hover,\n.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:hover,\n.custom-rc-pagination .rc-pagination-prev .rc-pagination-disabled:hover,\n.custom-rc-pagination .rc-pagination-next .rc-pagination-disabled:hover,\n.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:hover,\n.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:hover,\n.custom-rc-pagination .rc-pagination-item .rc-pagination-disabled:active,\n.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:active,\n.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:active,\n.custom-rc-pagination .rc-pagination-prev .rc-pagination-disabled:active,\n.custom-rc-pagination .rc-pagination-next .rc-pagination-disabled:active,\n.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:active,\n.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:active {\n  border: 1px solid #eeeeee;\n  background-color: #fff;\n}\n.custom-rc-pagination .rc-pagination-item.rc-pagination-disabled a,\n.custom-rc-pagination .rc-pagination-jump-prev.rc-pagination-disabled a,\n.custom-rc-pagination .rc-pagination-jump-next.rc-pagination-disabled a,\n.custom-rc-pagination .rc-pagination-prev.rc-pagination-disabled a,\n.custom-rc-pagination .rc-pagination-next.rc-pagination-disabled a,\n.custom-rc-pagination .rc-pagination-jump-prev.rc-pagination-disabled a,\n.custom-rc-pagination .rc-pagination-jump-next.rc-pagination-disabled a,\n.custom-rc-pagination .rc-pagination-item .rc-pagination-disabled:hover a,\n.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:hover a,\n.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:hover a,\n.custom-rc-pagination .rc-pagination-prev .rc-pagination-disabled:hover a,\n.custom-rc-pagination .rc-pagination-next .rc-pagination-disabled:hover a,\n.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:hover a,\n.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:hover a,\n.custom-rc-pagination .rc-pagination-item .rc-pagination-disabled:active a,\n.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:active a,\n.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:active a,\n.custom-rc-pagination .rc-pagination-prev .rc-pagination-disabled:active a,\n.custom-rc-pagination .rc-pagination-next .rc-pagination-disabled:active a,\n.custom-rc-pagination .rc-pagination-jump-prev .rc-pagination-disabled:active a,\n.custom-rc-pagination .rc-pagination-jump-next .rc-pagination-disabled:active a {\n  color: #ccc;\n}\n.custom-rc-pagination .rc-pagination-item-active {\n  background-color: #555555;\n  border-color: #222222;\n}\n.custom-rc-pagination .rc-pagination-item-active a {\n  color: #fff;\n}\n.custom-rc-pagination .rc-pagination-item-active:hover a {\n  color: #fff;\n}\n.custom-rc-pagination .rc-pagination-jump-prev:hover:after,\n.custom-rc-pagination .rc-pagination-jump-next:hover:after {\n  color: #555555;\n}\n.custom-rc-pagination .rc-pagination-jump-prev-custom-icon:hover .custom-icon-jump-prev,\n.custom-rc-pagination .rc-pagination-jump-next-custom-icon:hover .custom-icon-jump-prev,\n.custom-rc-pagination .rc-pagination-jump-prev-custom-icon:hover .custom-icon-jump-next,\n.custom-rc-pagination .rc-pagination-jump-next-custom-icon:hover .custom-icon-jump-next {\n  opacity: 1;\n  color: #555555;\n}\n.custom-rc-pagination .rc-pagination-options-quick-jumper input:hover {\n  border-color: #555555;\n}\n.custom-rc-pagination .rc-pagination-options-quick-jumper button:hover,\n.custom-rc-pagination .rc-pagination-options-quick-jumper button:active,\n.custom-rc-pagination .rc-pagination-options-quick-jumper button:focus {\n  color: #555555;\n  background-color: #fff;\n  border-color: #555555;\n}\n.custom-rc-pagination .rc-pagination-simple .rc-pagination-simple-pager input:hover {\n  border-color: #555555;\n}\n.custom-rc-pagination .rc-pagination-simple .rc-pagination-simple-pager button:hover,\n.custom-rc-pagination .rc-pagination-simple .rc-pagination-simple-pager button:active,\n.custom-rc-pagination .rc-pagination-simple .rc-pagination-simple-pager button:focus {\n  color: #555555;\n  background-color: #fff;\n  border-color: #555555;\n}\n.horizontal-slider {\n  margin-bottom: 20px;\n}\n.horizontal-slider .handle {\n  background-color: #303232;\n  z-index: 101;\n  margin-top: 8px;\n  margin-left: -20px;\n  border-color: rgba(48, 50, 50, 0.6);\n}\n.horizontal-slider div.bar:last-of-type {\n  border-radius: 0 10px 10px 0;\n}\n.horizontal-slider .bar {\n  height: 20px;\n  text-align: center;\n  color: transparent !important;\n  -webkit-user-select: none;\n}\n.horizontal-slider .bar:first-child {\n  border-radius: 10px 0 0 10px;\n}\n.horizontal-slider .bar.bar-0 {\n  background-color: #872c4f;\n  color: #fff;\n}\n.horizontal-slider .bar.bar-1 {\n  background-color: #ef8a45;\n}\n.horizontal-slider .bar.bar-2 {\n  background-color: #f2cd50;\n}\n.horizontal-slider .bar .bar-value {\n  text-align: center;\n}\n.modal-backdrop {\n  z-index: 1069;\n}\n.modal-backdrop.in {\n  opacity: 0.7;\n}\n.modal-open .modal {\n  z-index: 1070;\n}\n.modal-header {\n  padding: 20px 20px 10px 25px;\n  border-bottom: none;\n}\n.modal-title {\n  font-weight: 600;\n  font-size: 20px;\n  color: #303232;\n  text-align: left;\n}\n.modal-content {\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.7);\n  border-radius: 5px;\n}\n.modal-content .close {\n  font-size: 36px;\n  font-weight: 400;\n  line-height: 1.72em;\n  text-shadow: 0 1px 0 #ffffff;\n  opacity: 0.3;\n  filter: alpha(opacity=30);\n  width: 44px;\n  text-align: center;\n  margin: -20px -12px 0 0;\n}\n.modal-content .close:hover {\n  opacity: 0.4;\n}\n.modal-content .close:active {\n  opacity: 0.8;\n}\n.modal-body {\n  padding: 15px 25px;\n}\n.confirmation.modal {\n  display: flex !important;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  z-index: 1090;\n}\n.confirmation.modal .modal-dialog {\n  font-size: 16px;\n  max-width: 400px;\n}\n.confirmation.modal .modal-dialog .modal-body {\n  padding: 25px;\n  background-color: #ffffff;\n}\n.confirmation.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1089;\n  background-color: #000000;\n}\n.confirmation.modal-backdrop.fade {\n  opacity: 0;\n  filter: alpha(opacity=0);\n}\n.confirmation.modal-backdrop.in {\n  opacity: 0.5;\n  filter: alpha(opacity=50);\n}\n.modal-footer {\n  padding: 0;\n  border: none;\n}\n.actived-progress-btn {\n  color: #ffa845;\n}\n.actived-progress-btn p {\n  color: #303232 !important;\n}\n.actived-progress-btn:hover {\n  cursor: pointer;\n}\n.buy-credit-modal .active {\n  color: black;\n}\n.buy-credit-modal .disable {\n  color: #f2f2f2;\n}\n.buy-credit-modal .disable p {\n  color: #adadad !important;\n}\n.buy-credit-modal p.disable {\n  color: #adadad !important;\n}\n.buy-credit-modal label {\n  cursor: pointer;\n}\n.buy-credit-modal [type='radio']:checked,\n.buy-credit-modal [type='radio']:not(:checked) {\n  position: absolute;\n  left: -99999px;\n}\n.buy-credit-modal [type='radio']:checked + span,\n.buy-credit-modal [type='radio']:not(:checked) + span {\n  position: relative;\n  padding-left: 30px;\n}\n.buy-credit-modal [type='radio']:checked + span:before,\n.buy-credit-modal [type='radio']:not(:checked) + span:before {\n  content: '';\n  position: absolute;\n  left: 0px;\n  top: 15px;\n  width: 18px;\n  height: 18px;\n  border: 1px solid #ddd;\n  border-radius: 100%;\n  background: #ffffff;\n}\n.buy-credit-modal [type='radio']:checked + span:after,\n.buy-credit-modal [type='radio']:not(:checked) + span:after {\n  content: '';\n  position: absolute;\n  left: 3px;\n  top: 18px;\n  width: 12px;\n  height: 12px;\n  border: 1px solid #ffa845;\n  border-radius: 100%;\n  background: #ffa845;\n  -webkit-transition: all 0.2s ease;\n  transition: all 0.2s ease;\n}\n.buy-credit-modal [type='radio']:not(:checked) + span:after {\n  opacity: 0;\n  transform: scale(0);\n}\n.buy-credit-modal [type='radio']:checked + span:after {\n  opacity: 1;\n  transform: scale(1);\n}\n.buy-credit-modal [type='radio']:checked + span:before {\n  border: 1px solid #ffa845;\n}\n@media (min-width: 768px) {\n  .assign-modal {\n    width: 480px;\n  }\n}\n.snapshot-compare .modal-dialog {\n  width: 95%;\n}\n.snapshot-compare .modal-header {\n  padding-bottom: 0px;\n}\n.snapshot-compare .modal-body {\n  padding-top: 0px;\n}\n@media (max-width: 768px) {\n  .snapshot-compare .snapshot-row .col-sm-4 {\n    padding: 0;\n  }\n}\n.checklist-compare .modal-dialog {\n  width: 95%;\n}\n.checklist-compare .modal-header {\n  padding-bottom: 0px;\n}\n.checklist-compare .modal-body {\n  padding-top: 0px;\n}\n@media (max-width: 768px) {\n  .checklist-compare .checklist-row .col-sm-4 {\n    padding: 0;\n  }\n}\n.block-container {\n  display: flex;\n  flex-wrap: wrap;\n  border-bottom: 1px solid #eeeeee;\n  color: #4a4a4a;\n  padding-bottom: 25px;\n}\n.block-container.without-border-bottom {\n  border-bottom: none;\n}\n.block-container button {\n  margin-top: 15px;\n  margin-bottom: 15px;\n}\n.block-container .block-content {\n  height: 128.72px;\n}\n.block-container .block-header {\n  color: #625845;\n  padding: 0;\n  margin-bottom: 10px;\n}\n.block-container .block-horizontal {\n  width: 220px;\n  margin-bottom: 15px;\n  margin-right: 60px;\n}\n.section-info-container {\n  padding: 16px;\n  border-radius: 5px;\n  cursor: pointer;\n}\n.section-info-container.disabled {\n  cursor: default;\n}\n.section-info-container:not(.disabled):hover {\n  padding: 15px;\n  border-width: 1px;\n  border-style: dashed;\n  border-color: #cccccc;\n  background-color: #f9f9f9;\n}\n.section-info-container .link {\n  color: #c84900;\n  font-size: 14px;\n  margin-top: 10px;\n  font-weight: 600;\n}\n#auto-badge-tooltip .tooltip-inner {\n  text-align: left;\n  width: 160px;\n}\n.vertical-center-icon {\n  line-height: 1;\n  margin-bottom: -2px;\n}\n.settings-companies,\n.settings-programs {\n  padding-top: 46px;\n}\n.content.settings-view {\n  padding: 48px 16px;\n}\n.mt-0 {\n  margin-top: 0px !important;\n}\n.mb-0 {\n  margin-bottom: 0px !important;\n}\n.ml-0 {\n  margin-left: 0px !important;\n}\n.mr-0 {\n  margin-right: 0px !important;\n}\n.mx-0 {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n}\n.my-0 {\n  margin-top: 0px !important;\n  margin-bottom: 0px !important;\n}\n.pt-0 {\n  padding-top: 0px !important;\n}\n.pb-0 {\n  padding-bottom: 0px !important;\n}\n.pl-0 {\n  padding-left: 0px !important;\n}\n.pr-0 {\n  padding-right: 0px !important;\n}\n.px-0 {\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n}\n.py-0 {\n  padding-top: 0px !important;\n  padding-bottom: 0px !important;\n}\n.gap-0 {\n  gap: 0px !important;\n}\n.mt-2 {\n  margin-top: 2px !important;\n}\n.mb-2 {\n  margin-bottom: 2px !important;\n}\n.ml-2 {\n  margin-left: 2px !important;\n}\n.mr-2 {\n  margin-right: 2px !important;\n}\n.mx-2 {\n  margin-left: 2px !important;\n  margin-right: 2px !important;\n}\n.my-2 {\n  margin-top: 2px !important;\n  margin-bottom: 2px !important;\n}\n.pt-2 {\n  padding-top: 2px !important;\n}\n.pb-2 {\n  padding-bottom: 2px !important;\n}\n.pl-2 {\n  padding-left: 2px !important;\n}\n.pr-2 {\n  padding-right: 2px !important;\n}\n.px-2 {\n  padding-left: 2px !important;\n  padding-right: 2px !important;\n}\n.py-2 {\n  padding-top: 2px !important;\n  padding-bottom: 2px !important;\n}\n.gap-2 {\n  gap: 2px !important;\n}\n.mt-4 {\n  margin-top: 4px !important;\n}\n.mb-4 {\n  margin-bottom: 4px !important;\n}\n.ml-4 {\n  margin-left: 4px !important;\n}\n.mr-4 {\n  margin-right: 4px !important;\n}\n.mx-4 {\n  margin-left: 4px !important;\n  margin-right: 4px !important;\n}\n.my-4 {\n  margin-top: 4px !important;\n  margin-bottom: 4px !important;\n}\n.pt-4 {\n  padding-top: 4px !important;\n}\n.pb-4 {\n  padding-bottom: 4px !important;\n}\n.pl-4 {\n  padding-left: 4px !important;\n}\n.pr-4 {\n  padding-right: 4px !important;\n}\n.px-4 {\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n}\n.py-4 {\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n.gap-4 {\n  gap: 4px !important;\n}\n.mt-6 {\n  margin-top: 6px !important;\n}\n.mb-6 {\n  margin-bottom: 6px !important;\n}\n.ml-6 {\n  margin-left: 6px !important;\n}\n.mr-6 {\n  margin-right: 6px !important;\n}\n.mx-6 {\n  margin-left: 6px !important;\n  margin-right: 6px !important;\n}\n.my-6 {\n  margin-top: 6px !important;\n  margin-bottom: 6px !important;\n}\n.pt-6 {\n  padding-top: 6px !important;\n}\n.pb-6 {\n  padding-bottom: 6px !important;\n}\n.pl-6 {\n  padding-left: 6px !important;\n}\n.pr-6 {\n  padding-right: 6px !important;\n}\n.px-6 {\n  padding-left: 6px !important;\n  padding-right: 6px !important;\n}\n.py-6 {\n  padding-top: 6px !important;\n  padding-bottom: 6px !important;\n}\n.gap-6 {\n  gap: 6px !important;\n}\n.mt-8 {\n  margin-top: 8px !important;\n}\n.mb-8 {\n  margin-bottom: 8px !important;\n}\n.ml-8 {\n  margin-left: 8px !important;\n}\n.mr-8 {\n  margin-right: 8px !important;\n}\n.mx-8 {\n  margin-left: 8px !important;\n  margin-right: 8px !important;\n}\n.my-8 {\n  margin-top: 8px !important;\n  margin-bottom: 8px !important;\n}\n.pt-8 {\n  padding-top: 8px !important;\n}\n.pb-8 {\n  padding-bottom: 8px !important;\n}\n.pl-8 {\n  padding-left: 8px !important;\n}\n.pr-8 {\n  padding-right: 8px !important;\n}\n.px-8 {\n  padding-left: 8px !important;\n  padding-right: 8px !important;\n}\n.py-8 {\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n}\n.gap-8 {\n  gap: 8px !important;\n}\n.mt-10 {\n  margin-top: 10px !important;\n}\n.mb-10 {\n  margin-bottom: 10px !important;\n}\n.ml-10 {\n  margin-left: 10px !important;\n}\n.mr-10 {\n  margin-right: 10px !important;\n}\n.mx-10 {\n  margin-left: 10px !important;\n  margin-right: 10px !important;\n}\n.my-10 {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n}\n.pt-10 {\n  padding-top: 10px !important;\n}\n.pb-10 {\n  padding-bottom: 10px !important;\n}\n.pl-10 {\n  padding-left: 10px !important;\n}\n.pr-10 {\n  padding-right: 10px !important;\n}\n.px-10 {\n  padding-left: 10px !important;\n  padding-right: 10px !important;\n}\n.py-10 {\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n}\n.gap-10 {\n  gap: 10px !important;\n}\n.mt-12 {\n  margin-top: 12px !important;\n}\n.mb-12 {\n  margin-bottom: 12px !important;\n}\n.ml-12 {\n  margin-left: 12px !important;\n}\n.mr-12 {\n  margin-right: 12px !important;\n}\n.mx-12 {\n  margin-left: 12px !important;\n  margin-right: 12px !important;\n}\n.my-12 {\n  margin-top: 12px !important;\n  margin-bottom: 12px !important;\n}\n.pt-12 {\n  padding-top: 12px !important;\n}\n.pb-12 {\n  padding-bottom: 12px !important;\n}\n.pl-12 {\n  padding-left: 12px !important;\n}\n.pr-12 {\n  padding-right: 12px !important;\n}\n.px-12 {\n  padding-left: 12px !important;\n  padding-right: 12px !important;\n}\n.py-12 {\n  padding-top: 12px !important;\n  padding-bottom: 12px !important;\n}\n.gap-12 {\n  gap: 12px !important;\n}\n.mt-16 {\n  margin-top: 16px !important;\n}\n.mb-16 {\n  margin-bottom: 16px !important;\n}\n.ml-16 {\n  margin-left: 16px !important;\n}\n.mr-16 {\n  margin-right: 16px !important;\n}\n.mx-16 {\n  margin-left: 16px !important;\n  margin-right: 16px !important;\n}\n.my-16 {\n  margin-top: 16px !important;\n  margin-bottom: 16px !important;\n}\n.pt-16 {\n  padding-top: 16px !important;\n}\n.pb-16 {\n  padding-bottom: 16px !important;\n}\n.pl-16 {\n  padding-left: 16px !important;\n}\n.pr-16 {\n  padding-right: 16px !important;\n}\n.px-16 {\n  padding-left: 16px !important;\n  padding-right: 16px !important;\n}\n.py-16 {\n  padding-top: 16px !important;\n  padding-bottom: 16px !important;\n}\n.gap-16 {\n  gap: 16px !important;\n}\n.mt-20 {\n  margin-top: 20px !important;\n}\n.mb-20 {\n  margin-bottom: 20px !important;\n}\n.ml-20 {\n  margin-left: 20px !important;\n}\n.mr-20 {\n  margin-right: 20px !important;\n}\n.mx-20 {\n  margin-left: 20px !important;\n  margin-right: 20px !important;\n}\n.my-20 {\n  margin-top: 20px !important;\n  margin-bottom: 20px !important;\n}\n.pt-20 {\n  padding-top: 20px !important;\n}\n.pb-20 {\n  padding-bottom: 20px !important;\n}\n.pl-20 {\n  padding-left: 20px !important;\n}\n.pr-20 {\n  padding-right: 20px !important;\n}\n.px-20 {\n  padding-left: 20px !important;\n  padding-right: 20px !important;\n}\n.py-20 {\n  padding-top: 20px !important;\n  padding-bottom: 20px !important;\n}\n.gap-20 {\n  gap: 20px !important;\n}\n.mt-24 {\n  margin-top: 24px !important;\n}\n.mb-24 {\n  margin-bottom: 24px !important;\n}\n.ml-24 {\n  margin-left: 24px !important;\n}\n.mr-24 {\n  margin-right: 24px !important;\n}\n.mx-24 {\n  margin-left: 24px !important;\n  margin-right: 24px !important;\n}\n.my-24 {\n  margin-top: 24px !important;\n  margin-bottom: 24px !important;\n}\n.pt-24 {\n  padding-top: 24px !important;\n}\n.pb-24 {\n  padding-bottom: 24px !important;\n}\n.pl-24 {\n  padding-left: 24px !important;\n}\n.pr-24 {\n  padding-right: 24px !important;\n}\n.px-24 {\n  padding-left: 24px !important;\n  padding-right: 24px !important;\n}\n.py-24 {\n  padding-top: 24px !important;\n  padding-bottom: 24px !important;\n}\n.gap-24 {\n  gap: 24px !important;\n}\n.mt-28 {\n  margin-top: 24px !important;\n}\n.mb-28 {\n  margin-bottom: 24px !important;\n}\n.ml-28 {\n  margin-left: 24px !important;\n}\n.mr-28 {\n  margin-right: 24px !important;\n}\n.mx-28 {\n  margin-left: 24px !important;\n  margin-right: 24px !important;\n}\n.my-28 {\n  margin-top: 24px !important;\n  margin-bottom: 24px !important;\n}\n.pt-28 {\n  padding-top: 24px !important;\n}\n.pb-28 {\n  padding-bottom: 24px !important;\n}\n.pl-28 {\n  padding-left: 24px !important;\n}\n.pr-28 {\n  padding-right: 24px !important;\n}\n.px-28 {\n  padding-left: 24px !important;\n  padding-right: 24px !important;\n}\n.py-28 {\n  padding-top: 24px !important;\n  padding-bottom: 24px !important;\n}\n.gap-28 {\n  gap: 24px !important;\n}\n.mt-32 {\n  margin-top: 32px !important;\n}\n.mb-32 {\n  margin-bottom: 32px !important;\n}\n.ml-32 {\n  margin-left: 32px !important;\n}\n.mr-32 {\n  margin-right: 32px !important;\n}\n.mx-32 {\n  margin-left: 32px !important;\n  margin-right: 32px !important;\n}\n.my-32 {\n  margin-top: 32px !important;\n  margin-bottom: 32px !important;\n}\n.pt-32 {\n  padding-top: 32px !important;\n}\n.pb-32 {\n  padding-bottom: 32px !important;\n}\n.pl-32 {\n  padding-left: 32px !important;\n}\n.pr-32 {\n  padding-right: 32px !important;\n}\n.px-32 {\n  padding-left: 32px !important;\n  padding-right: 32px !important;\n}\n.py-32 {\n  padding-top: 32px !important;\n  padding-bottom: 32px !important;\n}\n.gap-32 {\n  gap: 32px !important;\n}\n.mt-40 {\n  margin-top: 40px !important;\n}\n.mb-40 {\n  margin-bottom: 40px !important;\n}\n.ml-40 {\n  margin-left: 40px !important;\n}\n.mr-40 {\n  margin-right: 40px !important;\n}\n.mx-40 {\n  margin-left: 40px !important;\n  margin-right: 40px !important;\n}\n.my-40 {\n  margin-top: 40px !important;\n  margin-bottom: 40px !important;\n}\n.pt-40 {\n  padding-top: 40px !important;\n}\n.pb-40 {\n  padding-bottom: 40px !important;\n}\n.pl-40 {\n  padding-left: 40px !important;\n}\n.pr-40 {\n  padding-right: 40px !important;\n}\n.px-40 {\n  padding-left: 40px !important;\n  padding-right: 40px !important;\n}\n.py-40 {\n  padding-top: 40px !important;\n  padding-bottom: 40px !important;\n}\n.gap-40 {\n  gap: 40px !important;\n}\n@media (min-width: 768px) {\n  .mt-sm-0 {\n    margin-top: 0px !important;\n  }\n  .mb-sm-0 {\n    margin-bottom: 0px !important;\n  }\n  .ml-sm-0 {\n    margin-left: 0px !important;\n  }\n  .mr-sm-0 {\n    margin-right: 0px !important;\n  }\n  .mx-sm-0 {\n    margin-left: 0px !important;\n    margin-right: 0px !important;\n  }\n  .my-sm-0 {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n  }\n  .pt-sm-0 {\n    padding-top: 0px !important;\n  }\n  .pb-sm-0 {\n    padding-bottom: 0px !important;\n  }\n  .pl-sm-0 {\n    padding-left: 0px !important;\n  }\n  .pr-sm-0 {\n    padding-right: 0px !important;\n  }\n  .px-sm-0 {\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n  }\n  .py-sm-0 {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n  }\n  .gap-sm-0 {\n    gap: 0px !important;\n  }\n  .mt-sm-2 {\n    margin-top: 2px !important;\n  }\n  .mb-sm-2 {\n    margin-bottom: 2px !important;\n  }\n  .ml-sm-2 {\n    margin-left: 2px !important;\n  }\n  .mr-sm-2 {\n    margin-right: 2px !important;\n  }\n  .mx-sm-2 {\n    margin-left: 2px !important;\n    margin-right: 2px !important;\n  }\n  .my-sm-2 {\n    margin-top: 2px !important;\n    margin-bottom: 2px !important;\n  }\n  .pt-sm-2 {\n    padding-top: 2px !important;\n  }\n  .pb-sm-2 {\n    padding-bottom: 2px !important;\n  }\n  .pl-sm-2 {\n    padding-left: 2px !important;\n  }\n  .pr-sm-2 {\n    padding-right: 2px !important;\n  }\n  .px-sm-2 {\n    padding-left: 2px !important;\n    padding-right: 2px !important;\n  }\n  .py-sm-2 {\n    padding-top: 2px !important;\n    padding-bottom: 2px !important;\n  }\n  .gap-sm-2 {\n    gap: 2px !important;\n  }\n  .mt-sm-4 {\n    margin-top: 4px !important;\n  }\n  .mb-sm-4 {\n    margin-bottom: 4px !important;\n  }\n  .ml-sm-4 {\n    margin-left: 4px !important;\n  }\n  .mr-sm-4 {\n    margin-right: 4px !important;\n  }\n  .mx-sm-4 {\n    margin-left: 4px !important;\n    margin-right: 4px !important;\n  }\n  .my-sm-4 {\n    margin-top: 4px !important;\n    margin-bottom: 4px !important;\n  }\n  .pt-sm-4 {\n    padding-top: 4px !important;\n  }\n  .pb-sm-4 {\n    padding-bottom: 4px !important;\n  }\n  .pl-sm-4 {\n    padding-left: 4px !important;\n  }\n  .pr-sm-4 {\n    padding-right: 4px !important;\n  }\n  .px-sm-4 {\n    padding-left: 4px !important;\n    padding-right: 4px !important;\n  }\n  .py-sm-4 {\n    padding-top: 4px !important;\n    padding-bottom: 4px !important;\n  }\n  .gap-sm-4 {\n    gap: 4px !important;\n  }\n  .mt-sm-6 {\n    margin-top: 6px !important;\n  }\n  .mb-sm-6 {\n    margin-bottom: 6px !important;\n  }\n  .ml-sm-6 {\n    margin-left: 6px !important;\n  }\n  .mr-sm-6 {\n    margin-right: 6px !important;\n  }\n  .mx-sm-6 {\n    margin-left: 6px !important;\n    margin-right: 6px !important;\n  }\n  .my-sm-6 {\n    margin-top: 6px !important;\n    margin-bottom: 6px !important;\n  }\n  .pt-sm-6 {\n    padding-top: 6px !important;\n  }\n  .pb-sm-6 {\n    padding-bottom: 6px !important;\n  }\n  .pl-sm-6 {\n    padding-left: 6px !important;\n  }\n  .pr-sm-6 {\n    padding-right: 6px !important;\n  }\n  .px-sm-6 {\n    padding-left: 6px !important;\n    padding-right: 6px !important;\n  }\n  .py-sm-6 {\n    padding-top: 6px !important;\n    padding-bottom: 6px !important;\n  }\n  .gap-sm-6 {\n    gap: 6px !important;\n  }\n  .mt-sm-8 {\n    margin-top: 8px !important;\n  }\n  .mb-sm-8 {\n    margin-bottom: 8px !important;\n  }\n  .ml-sm-8 {\n    margin-left: 8px !important;\n  }\n  .mr-sm-8 {\n    margin-right: 8px !important;\n  }\n  .mx-sm-8 {\n    margin-left: 8px !important;\n    margin-right: 8px !important;\n  }\n  .my-sm-8 {\n    margin-top: 8px !important;\n    margin-bottom: 8px !important;\n  }\n  .pt-sm-8 {\n    padding-top: 8px !important;\n  }\n  .pb-sm-8 {\n    padding-bottom: 8px !important;\n  }\n  .pl-sm-8 {\n    padding-left: 8px !important;\n  }\n  .pr-sm-8 {\n    padding-right: 8px !important;\n  }\n  .px-sm-8 {\n    padding-left: 8px !important;\n    padding-right: 8px !important;\n  }\n  .py-sm-8 {\n    padding-top: 8px !important;\n    padding-bottom: 8px !important;\n  }\n  .gap-sm-8 {\n    gap: 8px !important;\n  }\n  .mt-sm-10 {\n    margin-top: 10px !important;\n  }\n  .mb-sm-10 {\n    margin-bottom: 10px !important;\n  }\n  .ml-sm-10 {\n    margin-left: 10px !important;\n  }\n  .mr-sm-10 {\n    margin-right: 10px !important;\n  }\n  .mx-sm-10 {\n    margin-left: 10px !important;\n    margin-right: 10px !important;\n  }\n  .my-sm-10 {\n    margin-top: 10px !important;\n    margin-bottom: 10px !important;\n  }\n  .pt-sm-10 {\n    padding-top: 10px !important;\n  }\n  .pb-sm-10 {\n    padding-bottom: 10px !important;\n  }\n  .pl-sm-10 {\n    padding-left: 10px !important;\n  }\n  .pr-sm-10 {\n    padding-right: 10px !important;\n  }\n  .px-sm-10 {\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n  }\n  .py-sm-10 {\n    padding-top: 10px !important;\n    padding-bottom: 10px !important;\n  }\n  .gap-sm-10 {\n    gap: 10px !important;\n  }\n  .mt-sm-12 {\n    margin-top: 12px !important;\n  }\n  .mb-sm-12 {\n    margin-bottom: 12px !important;\n  }\n  .ml-sm-12 {\n    margin-left: 12px !important;\n  }\n  .mr-sm-12 {\n    margin-right: 12px !important;\n  }\n  .mx-sm-12 {\n    margin-left: 12px !important;\n    margin-right: 12px !important;\n  }\n  .my-sm-12 {\n    margin-top: 12px !important;\n    margin-bottom: 12px !important;\n  }\n  .pt-sm-12 {\n    padding-top: 12px !important;\n  }\n  .pb-sm-12 {\n    padding-bottom: 12px !important;\n  }\n  .pl-sm-12 {\n    padding-left: 12px !important;\n  }\n  .pr-sm-12 {\n    padding-right: 12px !important;\n  }\n  .px-sm-12 {\n    padding-left: 12px !important;\n    padding-right: 12px !important;\n  }\n  .py-sm-12 {\n    padding-top: 12px !important;\n    padding-bottom: 12px !important;\n  }\n  .gap-sm-12 {\n    gap: 12px !important;\n  }\n  .mt-sm-16 {\n    margin-top: 16px !important;\n  }\n  .mb-sm-16 {\n    margin-bottom: 16px !important;\n  }\n  .ml-sm-16 {\n    margin-left: 16px !important;\n  }\n  .mr-sm-16 {\n    margin-right: 16px !important;\n  }\n  .mx-sm-16 {\n    margin-left: 16px !important;\n    margin-right: 16px !important;\n  }\n  .my-sm-16 {\n    margin-top: 16px !important;\n    margin-bottom: 16px !important;\n  }\n  .pt-sm-16 {\n    padding-top: 16px !important;\n  }\n  .pb-sm-16 {\n    padding-bottom: 16px !important;\n  }\n  .pl-sm-16 {\n    padding-left: 16px !important;\n  }\n  .pr-sm-16 {\n    padding-right: 16px !important;\n  }\n  .px-sm-16 {\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n  .py-sm-16 {\n    padding-top: 16px !important;\n    padding-bottom: 16px !important;\n  }\n  .gap-sm-16 {\n    gap: 16px !important;\n  }\n  .mt-sm-20 {\n    margin-top: 20px !important;\n  }\n  .mb-sm-20 {\n    margin-bottom: 20px !important;\n  }\n  .ml-sm-20 {\n    margin-left: 20px !important;\n  }\n  .mr-sm-20 {\n    margin-right: 20px !important;\n  }\n  .mx-sm-20 {\n    margin-left: 20px !important;\n    margin-right: 20px !important;\n  }\n  .my-sm-20 {\n    margin-top: 20px !important;\n    margin-bottom: 20px !important;\n  }\n  .pt-sm-20 {\n    padding-top: 20px !important;\n  }\n  .pb-sm-20 {\n    padding-bottom: 20px !important;\n  }\n  .pl-sm-20 {\n    padding-left: 20px !important;\n  }\n  .pr-sm-20 {\n    padding-right: 20px !important;\n  }\n  .px-sm-20 {\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  }\n  .py-sm-20 {\n    padding-top: 20px !important;\n    padding-bottom: 20px !important;\n  }\n  .gap-sm-20 {\n    gap: 20px !important;\n  }\n  .mt-sm-28 {\n    margin-top: 28px !important;\n  }\n  .mb-sm-28 {\n    margin-bottom: 28px !important;\n  }\n  .ml-sm-28 {\n    margin-left: 28px !important;\n  }\n  .mr-sm-28 {\n    margin-right: 28px !important;\n  }\n  .mx-sm-28 {\n    margin-left: 28px !important;\n    margin-right: 28px !important;\n  }\n  .my-sm-28 {\n    margin-top: 28px !important;\n    margin-bottom: 28px !important;\n  }\n  .pt-sm-28 {\n    padding-top: 28px !important;\n  }\n  .pb-sm-28 {\n    padding-bottom: 28px !important;\n  }\n  .pl-sm-28 {\n    padding-left: 28px !important;\n  }\n  .pr-sm-28 {\n    padding-right: 28px !important;\n  }\n  .px-sm-28 {\n    padding-left: 28px !important;\n    padding-right: 28px !important;\n  }\n  .py-sm-28 {\n    padding-top: 28px !important;\n    padding-bottom: 28px !important;\n  }\n  .gap-sm-28 {\n    gap: 28px !important;\n  }\n  .mt-sm-32 {\n    margin-top: 32px !important;\n  }\n  .mb-sm-32 {\n    margin-bottom: 32px !important;\n  }\n  .ml-sm-32 {\n    margin-left: 32px !important;\n  }\n  .mr-sm-32 {\n    margin-right: 32px !important;\n  }\n  .mx-sm-32 {\n    margin-left: 32px !important;\n    margin-right: 32px !important;\n  }\n  .my-sm-32 {\n    margin-top: 32px !important;\n    margin-bottom: 32px !important;\n  }\n  .pt-sm-32 {\n    padding-top: 32px !important;\n  }\n  .pb-sm-32 {\n    padding-bottom: 32px !important;\n  }\n  .pl-sm-32 {\n    padding-left: 32px !important;\n  }\n  .pr-sm-32 {\n    padding-right: 32px !important;\n  }\n  .px-sm-32 {\n    padding-left: 32px !important;\n    padding-right: 32px !important;\n  }\n  .py-sm-32 {\n    padding-top: 32px !important;\n    padding-bottom: 32px !important;\n  }\n  .gap-sm-32 {\n    gap: 32px !important;\n  }\n  .mt-sm-36 {\n    margin-top: 36px !important;\n  }\n  .mb-sm-36 {\n    margin-bottom: 36px !important;\n  }\n  .ml-sm-36 {\n    margin-left: 36px !important;\n  }\n  .mr-sm-36 {\n    margin-right: 36px !important;\n  }\n  .mx-sm-36 {\n    margin-left: 36px !important;\n    margin-right: 36px !important;\n  }\n  .my-sm-36 {\n    margin-top: 36px !important;\n    margin-bottom: 36px !important;\n  }\n  .pt-sm-36 {\n    padding-top: 36px !important;\n  }\n  .pb-sm-36 {\n    padding-bottom: 36px !important;\n  }\n  .pl-sm-36 {\n    padding-left: 36px !important;\n  }\n  .pr-sm-36 {\n    padding-right: 36px !important;\n  }\n  .px-sm-36 {\n    padding-left: 36px !important;\n    padding-right: 36px !important;\n  }\n  .py-sm-36 {\n    padding-top: 36px !important;\n    padding-bottom: 36px !important;\n  }\n  .gap-sm-36 {\n    gap: 36px !important;\n  }\n  .mt-sm-40 {\n    margin-top: 40px !important;\n  }\n  .mb-sm-40 {\n    margin-bottom: 40px !important;\n  }\n  .ml-sm-40 {\n    margin-left: 40px !important;\n  }\n  .mr-sm-40 {\n    margin-right: 40px !important;\n  }\n  .mx-sm-40 {\n    margin-left: 40px !important;\n    margin-right: 40px !important;\n  }\n  .my-sm-40 {\n    margin-top: 40px !important;\n    margin-bottom: 40px !important;\n  }\n  .pt-sm-40 {\n    padding-top: 40px !important;\n  }\n  .pb-sm-40 {\n    padding-bottom: 40px !important;\n  }\n  .pl-sm-40 {\n    padding-left: 40px !important;\n  }\n  .pr-sm-40 {\n    padding-right: 40px !important;\n  }\n  .px-sm-40 {\n    padding-left: 40px !important;\n    padding-right: 40px !important;\n  }\n  .py-sm-40 {\n    padding-top: 40px !important;\n    padding-bottom: 40px !important;\n  }\n  .gap-sm-40 {\n    gap: 40px !important;\n  }\n}\n@media (min-width: 992px) {\n  .mt-md-0 {\n    margin-top: 0px !important;\n  }\n  .mb-md-0 {\n    margin-bottom: 0px !important;\n  }\n  .ml-md-0 {\n    margin-left: 0px !important;\n  }\n  .mr-md-0 {\n    margin-right: 0px !important;\n  }\n  .mx-md-0 {\n    margin-left: 0px !important;\n    margin-right: 0px !important;\n  }\n  .my-md-0 {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n  }\n  .pt-md-0 {\n    padding-top: 0px !important;\n  }\n  .pb-md-0 {\n    padding-bottom: 0px !important;\n  }\n  .pl-md-0 {\n    padding-left: 0px !important;\n  }\n  .pr-md-0 {\n    padding-right: 0px !important;\n  }\n  .px-md-0 {\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n  }\n  .py-md-0 {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n  }\n  .gap-md-0 {\n    gap: 0px !important;\n  }\n  .mt-md-2 {\n    margin-top: 2px !important;\n  }\n  .mb-md-2 {\n    margin-bottom: 2px !important;\n  }\n  .ml-md-2 {\n    margin-left: 2px !important;\n  }\n  .mr-md-2 {\n    margin-right: 2px !important;\n  }\n  .mx-md-2 {\n    margin-left: 2px !important;\n    margin-right: 2px !important;\n  }\n  .my-md-2 {\n    margin-top: 2px !important;\n    margin-bottom: 2px !important;\n  }\n  .pt-md-2 {\n    padding-top: 2px !important;\n  }\n  .pb-md-2 {\n    padding-bottom: 2px !important;\n  }\n  .pl-md-2 {\n    padding-left: 2px !important;\n  }\n  .pr-md-2 {\n    padding-right: 2px !important;\n  }\n  .px-md-2 {\n    padding-left: 2px !important;\n    padding-right: 2px !important;\n  }\n  .py-md-2 {\n    padding-top: 2px !important;\n    padding-bottom: 2px !important;\n  }\n  .gap-md-2 {\n    gap: 2px !important;\n  }\n  .mt-md-4 {\n    margin-top: 4px !important;\n  }\n  .mb-md-4 {\n    margin-bottom: 4px !important;\n  }\n  .ml-md-4 {\n    margin-left: 4px !important;\n  }\n  .mr-md-4 {\n    margin-right: 4px !important;\n  }\n  .mx-md-4 {\n    margin-left: 4px !important;\n    margin-right: 4px !important;\n  }\n  .my-md-4 {\n    margin-top: 4px !important;\n    margin-bottom: 4px !important;\n  }\n  .pt-md-4 {\n    padding-top: 4px !important;\n  }\n  .pb-md-4 {\n    padding-bottom: 4px !important;\n  }\n  .pl-md-4 {\n    padding-left: 4px !important;\n  }\n  .pr-md-4 {\n    padding-right: 4px !important;\n  }\n  .px-md-4 {\n    padding-left: 4px !important;\n    padding-right: 4px !important;\n  }\n  .py-md-4 {\n    padding-top: 4px !important;\n    padding-bottom: 4px !important;\n  }\n  .gap-md-4 {\n    gap: 4px !important;\n  }\n  .mt-md-6 {\n    margin-top: 6px !important;\n  }\n  .mb-md-6 {\n    margin-bottom: 6px !important;\n  }\n  .ml-md-6 {\n    margin-left: 6px !important;\n  }\n  .mr-md-6 {\n    margin-right: 6px !important;\n  }\n  .mx-md-6 {\n    margin-left: 6px !important;\n    margin-right: 6px !important;\n  }\n  .my-md-6 {\n    margin-top: 6px !important;\n    margin-bottom: 6px !important;\n  }\n  .pt-md-6 {\n    padding-top: 6px !important;\n  }\n  .pb-md-6 {\n    padding-bottom: 6px !important;\n  }\n  .pl-md-6 {\n    padding-left: 6px !important;\n  }\n  .pr-md-6 {\n    padding-right: 6px !important;\n  }\n  .px-md-6 {\n    padding-left: 6px !important;\n    padding-right: 6px !important;\n  }\n  .py-md-6 {\n    padding-top: 6px !important;\n    padding-bottom: 6px !important;\n  }\n  .gap-md-6 {\n    gap: 6px !important;\n  }\n  .mt-md-8 {\n    margin-top: 8px !important;\n  }\n  .mb-md-8 {\n    margin-bottom: 8px !important;\n  }\n  .ml-md-8 {\n    margin-left: 8px !important;\n  }\n  .mr-md-8 {\n    margin-right: 8px !important;\n  }\n  .mx-md-8 {\n    margin-left: 8px !important;\n    margin-right: 8px !important;\n  }\n  .my-md-8 {\n    margin-top: 8px !important;\n    margin-bottom: 8px !important;\n  }\n  .pt-md-8 {\n    padding-top: 8px !important;\n  }\n  .pb-md-8 {\n    padding-bottom: 8px !important;\n  }\n  .pl-md-8 {\n    padding-left: 8px !important;\n  }\n  .pr-md-8 {\n    padding-right: 8px !important;\n  }\n  .px-md-8 {\n    padding-left: 8px !important;\n    padding-right: 8px !important;\n  }\n  .py-md-8 {\n    padding-top: 8px !important;\n    padding-bottom: 8px !important;\n  }\n  .gap-md-8 {\n    gap: 8px !important;\n  }\n  .mt-md-10 {\n    margin-top: 10px !important;\n  }\n  .mb-md-10 {\n    margin-bottom: 10px !important;\n  }\n  .ml-md-10 {\n    margin-left: 10px !important;\n  }\n  .mr-md-10 {\n    margin-right: 10px !important;\n  }\n  .mx-md-10 {\n    margin-left: 10px !important;\n    margin-right: 10px !important;\n  }\n  .my-md-10 {\n    margin-top: 10px !important;\n    margin-bottom: 10px !important;\n  }\n  .pt-md-10 {\n    padding-top: 10px !important;\n  }\n  .pb-md-10 {\n    padding-bottom: 10px !important;\n  }\n  .pl-md-10 {\n    padding-left: 10px !important;\n  }\n  .pr-md-10 {\n    padding-right: 10px !important;\n  }\n  .px-md-10 {\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n  }\n  .py-md-10 {\n    padding-top: 10px !important;\n    padding-bottom: 10px !important;\n  }\n  .gap-md-10 {\n    gap: 10px !important;\n  }\n  .mt-md-12 {\n    margin-top: 12px !important;\n  }\n  .mb-md-12 {\n    margin-bottom: 12px !important;\n  }\n  .ml-md-12 {\n    margin-left: 12px !important;\n  }\n  .mr-md-12 {\n    margin-right: 12px !important;\n  }\n  .mx-md-12 {\n    margin-left: 12px !important;\n    margin-right: 12px !important;\n  }\n  .my-md-12 {\n    margin-top: 12px !important;\n    margin-bottom: 12px !important;\n  }\n  .pt-md-12 {\n    padding-top: 12px !important;\n  }\n  .pb-md-12 {\n    padding-bottom: 12px !important;\n  }\n  .pl-md-12 {\n    padding-left: 12px !important;\n  }\n  .pr-md-12 {\n    padding-right: 12px !important;\n  }\n  .px-md-12 {\n    padding-left: 12px !important;\n    padding-right: 12px !important;\n  }\n  .py-md-12 {\n    padding-top: 12px !important;\n    padding-bottom: 12px !important;\n  }\n  .gap-md-12 {\n    gap: 12px !important;\n  }\n  .mt-md-16 {\n    margin-top: 16px !important;\n  }\n  .mb-md-16 {\n    margin-bottom: 16px !important;\n  }\n  .ml-md-16 {\n    margin-left: 16px !important;\n  }\n  .mr-md-16 {\n    margin-right: 16px !important;\n  }\n  .mx-md-16 {\n    margin-left: 16px !important;\n    margin-right: 16px !important;\n  }\n  .my-md-16 {\n    margin-top: 16px !important;\n    margin-bottom: 16px !important;\n  }\n  .pt-md-16 {\n    padding-top: 16px !important;\n  }\n  .pb-md-16 {\n    padding-bottom: 16px !important;\n  }\n  .pl-md-16 {\n    padding-left: 16px !important;\n  }\n  .pr-md-16 {\n    padding-right: 16px !important;\n  }\n  .px-md-16 {\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n  .py-md-16 {\n    padding-top: 16px !important;\n    padding-bottom: 16px !important;\n  }\n  .gap-md-16 {\n    gap: 16px !important;\n  }\n  .mt-md-20 {\n    margin-top: 20px !important;\n  }\n  .mb-md-20 {\n    margin-bottom: 20px !important;\n  }\n  .ml-md-20 {\n    margin-left: 20px !important;\n  }\n  .mr-md-20 {\n    margin-right: 20px !important;\n  }\n  .mx-md-20 {\n    margin-left: 20px !important;\n    margin-right: 20px !important;\n  }\n  .my-md-20 {\n    margin-top: 20px !important;\n    margin-bottom: 20px !important;\n  }\n  .pt-md-20 {\n    padding-top: 20px !important;\n  }\n  .pb-md-20 {\n    padding-bottom: 20px !important;\n  }\n  .pl-md-20 {\n    padding-left: 20px !important;\n  }\n  .pr-md-20 {\n    padding-right: 20px !important;\n  }\n  .px-md-20 {\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  }\n  .py-md-20 {\n    padding-top: 20px !important;\n    padding-bottom: 20px !important;\n  }\n  .gap-md-20 {\n    gap: 20px !important;\n  }\n  .mt-md-24 {\n    margin-top: 24px !important;\n  }\n  .mb-md-24 {\n    margin-bottom: 24px !important;\n  }\n  .ml-md-24 {\n    margin-left: 24px !important;\n  }\n  .mr-md-24 {\n    margin-right: 24px !important;\n  }\n  .mx-md-24 {\n    margin-left: 24px !important;\n    margin-right: 24px !important;\n  }\n  .my-md-24 {\n    margin-top: 24px !important;\n    margin-bottom: 24px !important;\n  }\n  .pt-md-24 {\n    padding-top: 24px !important;\n  }\n  .pb-md-24 {\n    padding-bottom: 24px !important;\n  }\n  .pl-md-24 {\n    padding-left: 24px !important;\n  }\n  .pr-md-24 {\n    padding-right: 24px !important;\n  }\n  .px-md-24 {\n    padding-left: 24px !important;\n    padding-right: 24px !important;\n  }\n  .py-md-24 {\n    padding-top: 24px !important;\n    padding-bottom: 24px !important;\n  }\n  .gap-md-24 {\n    gap: 24px !important;\n  }\n  .mt-md-28 {\n    margin-top: 28px !important;\n  }\n  .mb-md-28 {\n    margin-bottom: 28px !important;\n  }\n  .ml-md-28 {\n    margin-left: 28px !important;\n  }\n  .mr-md-28 {\n    margin-right: 28px !important;\n  }\n  .mx-md-28 {\n    margin-left: 28px !important;\n    margin-right: 28px !important;\n  }\n  .my-md-28 {\n    margin-top: 28px !important;\n    margin-bottom: 28px !important;\n  }\n  .pt-md-28 {\n    padding-top: 28px !important;\n  }\n  .pb-md-28 {\n    padding-bottom: 28px !important;\n  }\n  .pl-md-28 {\n    padding-left: 28px !important;\n  }\n  .pr-md-28 {\n    padding-right: 28px !important;\n  }\n  .px-md-28 {\n    padding-left: 28px !important;\n    padding-right: 28px !important;\n  }\n  .py-md-28 {\n    padding-top: 28px !important;\n    padding-bottom: 28px !important;\n  }\n  .gap-md-28 {\n    gap: 28px !important;\n  }\n  .mt-md-32 {\n    margin-top: 32px !important;\n  }\n  .mb-md-32 {\n    margin-bottom: 32px !important;\n  }\n  .ml-md-32 {\n    margin-left: 32px !important;\n  }\n  .mr-md-32 {\n    margin-right: 32px !important;\n  }\n  .mx-md-32 {\n    margin-left: 32px !important;\n    margin-right: 32px !important;\n  }\n  .my-md-32 {\n    margin-top: 32px !important;\n    margin-bottom: 32px !important;\n  }\n  .pt-md-32 {\n    padding-top: 32px !important;\n  }\n  .pb-md-32 {\n    padding-bottom: 32px !important;\n  }\n  .pl-md-32 {\n    padding-left: 32px !important;\n  }\n  .pr-md-32 {\n    padding-right: 32px !important;\n  }\n  .px-md-32 {\n    padding-left: 32px !important;\n    padding-right: 32px !important;\n  }\n  .py-md-32 {\n    padding-top: 32px !important;\n    padding-bottom: 32px !important;\n  }\n  .gap-md-32 {\n    gap: 32px !important;\n  }\n  .mt-md-36 {\n    margin-top: 36px !important;\n  }\n  .mb-md-36 {\n    margin-bottom: 36px !important;\n  }\n  .ml-md-36 {\n    margin-left: 36px !important;\n  }\n  .mr-md-36 {\n    margin-right: 36px !important;\n  }\n  .mx-md-36 {\n    margin-left: 36px !important;\n    margin-right: 36px !important;\n  }\n  .my-md-36 {\n    margin-top: 36px !important;\n    margin-bottom: 36px !important;\n  }\n  .pt-md-36 {\n    padding-top: 36px !important;\n  }\n  .pb-md-36 {\n    padding-bottom: 36px !important;\n  }\n  .pl-md-36 {\n    padding-left: 36px !important;\n  }\n  .pr-md-36 {\n    padding-right: 36px !important;\n  }\n  .px-md-36 {\n    padding-left: 36px !important;\n    padding-right: 36px !important;\n  }\n  .py-md-36 {\n    padding-top: 36px !important;\n    padding-bottom: 36px !important;\n  }\n  .gap-md-36 {\n    gap: 36px !important;\n  }\n  .mt-md-40 {\n    margin-top: 40px !important;\n  }\n  .mb-md-40 {\n    margin-bottom: 40px !important;\n  }\n  .ml-md-40 {\n    margin-left: 40px !important;\n  }\n  .mr-md-40 {\n    margin-right: 40px !important;\n  }\n  .mx-md-40 {\n    margin-left: 40px !important;\n    margin-right: 40px !important;\n  }\n  .my-md-40 {\n    margin-top: 40px !important;\n    margin-bottom: 40px !important;\n  }\n  .pt-md-40 {\n    padding-top: 40px !important;\n  }\n  .pb-md-40 {\n    padding-bottom: 40px !important;\n  }\n  .pl-md-40 {\n    padding-left: 40px !important;\n  }\n  .pr-md-40 {\n    padding-right: 40px !important;\n  }\n  .px-md-40 {\n    padding-left: 40px !important;\n    padding-right: 40px !important;\n  }\n  .py-md-40 {\n    padding-top: 40px !important;\n    padding-bottom: 40px !important;\n  }\n  .gap-md-40 {\n    gap: 40px !important;\n  }\n}\n@media (min-width: 1200px) {\n  .mt-lg-0 {\n    margin-top: 0px !important;\n  }\n  .mb-lg-0 {\n    margin-bottom: 0px !important;\n  }\n  .ml-lg-0 {\n    margin-left: 0px !important;\n  }\n  .mr-lg-0 {\n    margin-right: 0px !important;\n  }\n  .mx-lg-0 {\n    margin-left: 0px !important;\n    margin-right: 0px !important;\n  }\n  .my-lg-0 {\n    margin-top: 0px !important;\n    margin-bottom: 0px !important;\n  }\n  .pt-lg-0 {\n    padding-top: 0px !important;\n  }\n  .pb-lg-0 {\n    padding-bottom: 0px !important;\n  }\n  .pl-lg-0 {\n    padding-left: 0px !important;\n  }\n  .pr-lg-0 {\n    padding-right: 0px !important;\n  }\n  .px-lg-0 {\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n  }\n  .py-lg-0 {\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n  }\n  .gap-lg-0 {\n    gap: 0px !important;\n  }\n  .mt-lg-2 {\n    margin-top: 2px !important;\n  }\n  .mb-lg-2 {\n    margin-bottom: 2px !important;\n  }\n  .ml-lg-2 {\n    margin-left: 2px !important;\n  }\n  .mr-lg-2 {\n    margin-right: 2px !important;\n  }\n  .mx-lg-2 {\n    margin-left: 2px !important;\n    margin-right: 2px !important;\n  }\n  .my-lg-2 {\n    margin-top: 2px !important;\n    margin-bottom: 2px !important;\n  }\n  .pt-lg-2 {\n    padding-top: 2px !important;\n  }\n  .pb-lg-2 {\n    padding-bottom: 2px !important;\n  }\n  .pl-lg-2 {\n    padding-left: 2px !important;\n  }\n  .pr-lg-2 {\n    padding-right: 2px !important;\n  }\n  .px-lg-2 {\n    padding-left: 2px !important;\n    padding-right: 2px !important;\n  }\n  .py-lg-2 {\n    padding-top: 2px !important;\n    padding-bottom: 2px !important;\n  }\n  .gap-lg-2 {\n    gap: 2px !important;\n  }\n  .mt-lg-4 {\n    margin-top: 4px !important;\n  }\n  .mb-lg-4 {\n    margin-bottom: 4px !important;\n  }\n  .ml-lg-4 {\n    margin-left: 4px !important;\n  }\n  .mr-lg-4 {\n    margin-right: 4px !important;\n  }\n  .mx-lg-4 {\n    margin-left: 4px !important;\n    margin-right: 4px !important;\n  }\n  .my-lg-4 {\n    margin-top: 4px !important;\n    margin-bottom: 4px !important;\n  }\n  .pt-lg-4 {\n    padding-top: 4px !important;\n  }\n  .pb-lg-4 {\n    padding-bottom: 4px !important;\n  }\n  .pl-lg-4 {\n    padding-left: 4px !important;\n  }\n  .pr-lg-4 {\n    padding-right: 4px !important;\n  }\n  .px-lg-4 {\n    padding-left: 4px !important;\n    padding-right: 4px !important;\n  }\n  .py-lg-4 {\n    padding-top: 4px !important;\n    padding-bottom: 4px !important;\n  }\n  .gap-lg-4 {\n    gap: 4px !important;\n  }\n  .mt-lg-6 {\n    margin-top: 6px !important;\n  }\n  .mb-lg-6 {\n    margin-bottom: 6px !important;\n  }\n  .ml-lg-6 {\n    margin-left: 6px !important;\n  }\n  .mr-lg-6 {\n    margin-right: 6px !important;\n  }\n  .mx-lg-6 {\n    margin-left: 6px !important;\n    margin-right: 6px !important;\n  }\n  .my-lg-6 {\n    margin-top: 6px !important;\n    margin-bottom: 6px !important;\n  }\n  .pt-lg-6 {\n    padding-top: 6px !important;\n  }\n  .pb-lg-6 {\n    padding-bottom: 6px !important;\n  }\n  .pl-lg-6 {\n    padding-left: 6px !important;\n  }\n  .pr-lg-6 {\n    padding-right: 6px !important;\n  }\n  .px-lg-6 {\n    padding-left: 6px !important;\n    padding-right: 6px !important;\n  }\n  .py-lg-6 {\n    padding-top: 6px !important;\n    padding-bottom: 6px !important;\n  }\n  .gap-lg-6 {\n    gap: 6px !important;\n  }\n  .mt-lg-8 {\n    margin-top: 8px !important;\n  }\n  .mb-lg-8 {\n    margin-bottom: 8px !important;\n  }\n  .ml-lg-8 {\n    margin-left: 8px !important;\n  }\n  .mr-lg-8 {\n    margin-right: 8px !important;\n  }\n  .mx-lg-8 {\n    margin-left: 8px !important;\n    margin-right: 8px !important;\n  }\n  .my-lg-8 {\n    margin-top: 8px !important;\n    margin-bottom: 8px !important;\n  }\n  .pt-lg-8 {\n    padding-top: 8px !important;\n  }\n  .pb-lg-8 {\n    padding-bottom: 8px !important;\n  }\n  .pl-lg-8 {\n    padding-left: 8px !important;\n  }\n  .pr-lg-8 {\n    padding-right: 8px !important;\n  }\n  .px-lg-8 {\n    padding-left: 8px !important;\n    padding-right: 8px !important;\n  }\n  .py-lg-8 {\n    padding-top: 8px !important;\n    padding-bottom: 8px !important;\n  }\n  .gap-lg-8 {\n    gap: 8px !important;\n  }\n  .mt-lg-10 {\n    margin-top: 10px !important;\n  }\n  .mb-lg-10 {\n    margin-bottom: 10px !important;\n  }\n  .ml-lg-10 {\n    margin-left: 10px !important;\n  }\n  .mr-lg-10 {\n    margin-right: 10px !important;\n  }\n  .mx-lg-10 {\n    margin-left: 10px !important;\n    margin-right: 10px !important;\n  }\n  .my-lg-10 {\n    margin-top: 10px !important;\n    margin-bottom: 10px !important;\n  }\n  .pt-lg-10 {\n    padding-top: 10px !important;\n  }\n  .pb-lg-10 {\n    padding-bottom: 10px !important;\n  }\n  .pl-lg-10 {\n    padding-left: 10px !important;\n  }\n  .pr-lg-10 {\n    padding-right: 10px !important;\n  }\n  .px-lg-10 {\n    padding-left: 10px !important;\n    padding-right: 10px !important;\n  }\n  .py-lg-10 {\n    padding-top: 10px !important;\n    padding-bottom: 10px !important;\n  }\n  .gap-lg-10 {\n    gap: 10px !important;\n  }\n  .mt-lg-12 {\n    margin-top: 12px !important;\n  }\n  .mb-lg-12 {\n    margin-bottom: 12px !important;\n  }\n  .ml-lg-12 {\n    margin-left: 12px !important;\n  }\n  .mr-lg-12 {\n    margin-right: 12px !important;\n  }\n  .mx-lg-12 {\n    margin-left: 12px !important;\n    margin-right: 12px !important;\n  }\n  .my-lg-12 {\n    margin-top: 12px !important;\n    margin-bottom: 12px !important;\n  }\n  .pt-lg-12 {\n    padding-top: 12px !important;\n  }\n  .pb-lg-12 {\n    padding-bottom: 12px !important;\n  }\n  .pl-lg-12 {\n    padding-left: 12px !important;\n  }\n  .pr-lg-12 {\n    padding-right: 12px !important;\n  }\n  .px-lg-12 {\n    padding-left: 12px !important;\n    padding-right: 12px !important;\n  }\n  .py-lg-12 {\n    padding-top: 12px !important;\n    padding-bottom: 12px !important;\n  }\n  .gap-lg-12 {\n    gap: 12px !important;\n  }\n  .mt-lg-16 {\n    margin-top: 16px !important;\n  }\n  .mb-lg-16 {\n    margin-bottom: 16px !important;\n  }\n  .ml-lg-16 {\n    margin-left: 16px !important;\n  }\n  .mr-lg-16 {\n    margin-right: 16px !important;\n  }\n  .mx-lg-16 {\n    margin-left: 16px !important;\n    margin-right: 16px !important;\n  }\n  .my-lg-16 {\n    margin-top: 16px !important;\n    margin-bottom: 16px !important;\n  }\n  .pt-lg-16 {\n    padding-top: 16px !important;\n  }\n  .pb-lg-16 {\n    padding-bottom: 16px !important;\n  }\n  .pl-lg-16 {\n    padding-left: 16px !important;\n  }\n  .pr-lg-16 {\n    padding-right: 16px !important;\n  }\n  .px-lg-16 {\n    padding-left: 16px !important;\n    padding-right: 16px !important;\n  }\n  .py-lg-16 {\n    padding-top: 16px !important;\n    padding-bottom: 16px !important;\n  }\n  .gap-lg-16 {\n    gap: 16px !important;\n  }\n  .mt-lg-20 {\n    margin-top: 20px !important;\n  }\n  .mb-lg-20 {\n    margin-bottom: 20px !important;\n  }\n  .ml-lg-20 {\n    margin-left: 20px !important;\n  }\n  .mr-lg-20 {\n    margin-right: 20px !important;\n  }\n  .mx-lg-20 {\n    margin-left: 20px !important;\n    margin-right: 20px !important;\n  }\n  .my-lg-20 {\n    margin-top: 20px !important;\n    margin-bottom: 20px !important;\n  }\n  .pt-lg-20 {\n    padding-top: 20px !important;\n  }\n  .pb-lg-20 {\n    padding-bottom: 20px !important;\n  }\n  .pl-lg-20 {\n    padding-left: 20px !important;\n  }\n  .pr-lg-20 {\n    padding-right: 20px !important;\n  }\n  .px-lg-20 {\n    padding-left: 20px !important;\n    padding-right: 20px !important;\n  }\n  .py-lg-20 {\n    padding-top: 20px !important;\n    padding-bottom: 20px !important;\n  }\n  .gap-lg-20 {\n    gap: 20px !important;\n  }\n  .mt-lg-24 {\n    margin-top: 24px !important;\n  }\n  .mb-lg-24 {\n    margin-bottom: 24px !important;\n  }\n  .ml-lg-24 {\n    margin-left: 24px !important;\n  }\n  .mr-lg-24 {\n    margin-right: 24px !important;\n  }\n  .mx-lg-24 {\n    margin-left: 24px !important;\n    margin-right: 24px !important;\n  }\n  .my-lg-24 {\n    margin-top: 24px !important;\n    margin-bottom: 24px !important;\n  }\n  .pt-lg-24 {\n    padding-top: 24px !important;\n  }\n  .pb-lg-24 {\n    padding-bottom: 24px !important;\n  }\n  .pl-lg-24 {\n    padding-left: 24px !important;\n  }\n  .pr-lg-24 {\n    padding-right: 24px !important;\n  }\n  .px-lg-24 {\n    padding-left: 24px !important;\n    padding-right: 24px !important;\n  }\n  .py-lg-24 {\n    padding-top: 24px !important;\n    padding-bottom: 24px !important;\n  }\n  .gap-lg-24 {\n    gap: 24px !important;\n  }\n  .mt-lg-28 {\n    margin-top: 28px !important;\n  }\n  .mb-lg-28 {\n    margin-bottom: 28px !important;\n  }\n  .ml-lg-28 {\n    margin-left: 28px !important;\n  }\n  .mr-lg-28 {\n    margin-right: 28px !important;\n  }\n  .mx-lg-28 {\n    margin-left: 28px !important;\n    margin-right: 28px !important;\n  }\n  .my-lg-28 {\n    margin-top: 28px !important;\n    margin-bottom: 28px !important;\n  }\n  .pt-lg-28 {\n    padding-top: 28px !important;\n  }\n  .pb-lg-28 {\n    padding-bottom: 28px !important;\n  }\n  .pl-lg-28 {\n    padding-left: 28px !important;\n  }\n  .pr-lg-28 {\n    padding-right: 28px !important;\n  }\n  .px-lg-28 {\n    padding-left: 28px !important;\n    padding-right: 28px !important;\n  }\n  .py-lg-28 {\n    padding-top: 28px !important;\n    padding-bottom: 28px !important;\n  }\n  .gap-lg-28 {\n    gap: 28px !important;\n  }\n  .mt-lg-32 {\n    margin-top: 32px !important;\n  }\n  .mb-lg-32 {\n    margin-bottom: 32px !important;\n  }\n  .ml-lg-32 {\n    margin-left: 32px !important;\n  }\n  .mr-lg-32 {\n    margin-right: 32px !important;\n  }\n  .mx-lg-32 {\n    margin-left: 32px !important;\n    margin-right: 32px !important;\n  }\n  .my-lg-32 {\n    margin-top: 32px !important;\n    margin-bottom: 32px !important;\n  }\n  .pt-lg-32 {\n    padding-top: 32px !important;\n  }\n  .pb-lg-32 {\n    padding-bottom: 32px !important;\n  }\n  .pl-lg-32 {\n    padding-left: 32px !important;\n  }\n  .pr-lg-32 {\n    padding-right: 32px !important;\n  }\n  .px-lg-32 {\n    padding-left: 32px !important;\n    padding-right: 32px !important;\n  }\n  .py-lg-32 {\n    padding-top: 32px !important;\n    padding-bottom: 32px !important;\n  }\n  .gap-lg-32 {\n    gap: 32px !important;\n  }\n  .mt-lg-36 {\n    margin-top: 36px !important;\n  }\n  .mb-lg-36 {\n    margin-bottom: 36px !important;\n  }\n  .ml-lg-36 {\n    margin-left: 36px !important;\n  }\n  .mr-lg-36 {\n    margin-right: 36px !important;\n  }\n  .mx-lg-36 {\n    margin-left: 36px !important;\n    margin-right: 36px !important;\n  }\n  .my-lg-36 {\n    margin-top: 36px !important;\n    margin-bottom: 36px !important;\n  }\n  .pt-lg-36 {\n    padding-top: 36px !important;\n  }\n  .pb-lg-36 {\n    padding-bottom: 36px !important;\n  }\n  .pl-lg-36 {\n    padding-left: 36px !important;\n  }\n  .pr-lg-36 {\n    padding-right: 36px !important;\n  }\n  .px-lg-36 {\n    padding-left: 36px !important;\n    padding-right: 36px !important;\n  }\n  .py-lg-36 {\n    padding-top: 36px !important;\n    padding-bottom: 36px !important;\n  }\n  .gap-lg-36 {\n    gap: 36px !important;\n  }\n  .mt-lg-40 {\n    margin-top: 40px !important;\n  }\n  .mb-lg-40 {\n    margin-bottom: 40px !important;\n  }\n  .ml-lg-40 {\n    margin-left: 40px !important;\n  }\n  .mr-lg-40 {\n    margin-right: 40px !important;\n  }\n  .mx-lg-40 {\n    margin-left: 40px !important;\n    margin-right: 40px !important;\n  }\n  .my-lg-40 {\n    margin-top: 40px !important;\n    margin-bottom: 40px !important;\n  }\n  .pt-lg-40 {\n    padding-top: 40px !important;\n  }\n  .pb-lg-40 {\n    padding-bottom: 40px !important;\n  }\n  .pl-lg-40 {\n    padding-left: 40px !important;\n  }\n  .pr-lg-40 {\n    padding-right: 40px !important;\n  }\n  .px-lg-40 {\n    padding-left: 40px !important;\n    padding-right: 40px !important;\n  }\n  .py-lg-40 {\n    padding-top: 40px !important;\n    padding-bottom: 40px !important;\n  }\n  .gap-lg-40 {\n    gap: 40px !important;\n  }\n}\n.authentication-requirement {\n  margin-left: 8px;\n}\n.authentication-requirement ul {\n  margin: 12px 0;\n  padding: 0;\n}\n.authentication-requirement ul:first-child {\n  margin: 4px 0 10px;\n}\n.authentication-requirement ul li {\n  margin: 6px 0;\n  list-style: none;\n  font-size: 12px;\n  color: #777777;\n  vertical-align: middle;\n  display: flex;\n  align-items: center;\n}\n.authentication-requirement ul li.error {\n  color: #c90606;\n}\n.authentication-requirement ul li.active {\n  font-weight: 600;\n  color: #4a7222;\n}\n.authentication-requirement ul li.active span {\n  background-color: #4a7222;\n  border: 1px solid #4a7222;\n  background-image: url(../img/ui/checkIcon.svg);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 8px 7px;\n}\n.authentication-requirement ul li.error {\n  font-weight: 600;\n  color: #c10101;\n}\n.authentication-requirement ul li.error span {\n  background-color: #c10101;\n  border: 1px solid #c10101;\n  background-image: url(../img/ui/xIcon.svg);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 6px 6px;\n}\n.authentication-requirement ul li.warning {\n  font-weight: 600;\n  color: #f6bb54;\n}\n.authentication-requirement ul li.warning span {\n  background-color: #f6bb54;\n  border: 1px solid #f6bb54;\n  background-image: url(../img/ui/warningIcon.svg);\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-size: 6px ​8p;\n}\n.authentication-requirement ul li.requirement-title {\n  font-size: 13px;\n  color: #555555;\n  font-weight: 600;\n  padding-bottom: 4px;\n}\n.authentication-requirement ul li span {\n  background: #ffffff;\n  border: 1px solid #dddddd;\n  margin-left: 8px;\n  margin-right: 10px;\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border-radius: 100%;\n}\n/* TREE COMPONENT STYLES */\n.tree {\n  list-style: none;\n  margin: 0 !important;\n  padding: 0 !important;\n  padding-bottom: 16px;\n  font-size: 14px;\n  color: #333;\n}\n.tree > li {\n  padding: 8px 8px;\n  border-bottom: 1px solid #eee;\n}\n.tree > li.read-only {\n  padding: 8px 0;\n}\n.tree > li:last-child {\n  border: none;\n}\n.tree > li ul {\n  padding-bottom: 4px;\n  list-style: none;\n  margin: 0px;\n  padding: 4px 0px 0px 16px;\n}\n.tree > li li {\n  margin: 6px 16px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.tree .box {\n  cursor: pointer;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n.tree .nested {\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.15s ease-in-out;\n}\n.tree .active {\n  max-height: 500px;\n}\n@keyframes rotate {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(90deg);\n  }\n}\n.tree .icon-rotate {\n  display: inline-block;\n  transition: transform 0.15s ease-in-out;\n}\n.tree .icon-rotate.rotating {\n  transform: rotate(90deg);\n}\n.white-tooltip.in {\n  opacity: 1 !important;\n}\n.white-tooltip .tooltip-arrow {\n  border-top-color: #fff !important;\n}\n.white-tooltip .tooltip-inner {\n  max-width: 280px;\n  background-color: #fff;\n  color: #555;\n  text-align: left;\n  padding: 12px;\n  border-radius: 6px;\n  display: flex;\n  gap: 4px;\n  flex-direction: column;\n  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 4px 4px 0 rgba(0, 0, 0, 0.06), 0 8px 8px 0 rgba(0, 0, 0, 0.06), 0 16px 16px 0 rgba(0, 0, 0, 0.06);\n}\n.white-tooltip .tooltip-inner p {\n  margin-bottom: 0;\n}\n.tooltip-td-trigger {\n  cursor: pointer;\n  transition: all 200ms ease-in-out;\n}\n.tooltip-td-trigger:hover {\n  background-color: #fdf5f4 !important;\n}\n/*# sourceMappingURL=app.css.map */","//\n// Control\n// ------------------------------\n\n.Select {\n  position: relative;\n\n  // preferred box model\n  &,\n  & div,\n  & input,\n  & span {\n    .box-sizing(border-box);\n  }\n\n  // handle disabled state\n  &.is-disabled > .Select-control {\n    background-color: @select-input-bg-disabled;\n  }\n  &.is-disabled .Select-arrow-zone {\n    cursor: default;\n    pointer-events: none;\n  }\n}\n\n// base\n\n.Select-control {\n  background-color: @select-input-bg;\n  border-color: lighten(@select-input-border-color, 5%)\n    @select-input-border-color darken(@select-input-border-color, 10%);\n  border-radius: @select-input-border-radius;\n  border: @select-input-border-width solid @select-input-border-color;\n  color: @select-text-color;\n  cursor: default;\n  display: table;\n  height: @select-input-height;\n  outline: none;\n  overflow: hidden;\n  position: relative;\n  width: 100%;\n\n  &:hover {\n    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  }\n}\n\n.is-searchable {\n  &.is-open > .Select-control {\n    cursor: text;\n  }\n}\n\n.is-open > .Select-control {\n  .border-bottom-radius( 0 );\n  background: @select-input-bg;\n  border-color: darken(@select-input-border-color, 10%)\n    @select-input-border-color lighten(@select-input-border-color, 5%);\n\n  // flip the arrow so its pointing up when the menu is open\n  > .Select-arrow {\n    border-color: transparent transparent @select-arrow-color;\n    border-width: 0 @select-arrow-width @select-arrow-width;\n  }\n}\n\n.is-searchable {\n  &.is-focused:not(.is-open) > .Select-control {\n    cursor: text;\n  }\n}\n\n.is-focused:not(.is-open) > .Select-control {\n  border-color: @select-input-border-focus\n    lighten(@select-input-border-focus, 5%)\n    lighten(@select-input-border-focus, 5%);\n  box-shadow:\n    inset 0 1px 2px rgba(0, 0, 0, 0.1),\n    0 0 5px -1px fade(@select-input-border-focus, 50%);\n}\n\n// placeholder\n\n.Select-placeholder {\n  bottom: 0;\n  color: @select-input-placeholder;\n  left: 0;\n  line-height: @select-input-internal-height;\n  padding-left: @select-padding-horizontal;\n  padding-right: @select-padding-horizontal;\n  position: absolute;\n  right: 0;\n  top: 0;\n  font-size: 18px;\n  // crop text\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.has-value > .Select-control > .Select-placeholder {\n  color: @select-text-color;\n  font-size: 18px;\n}\n\n// value with custom renderer\n\n.Select-value {\n  color: @select-input-placeholder;\n  left: 0;\n  padding: @select-padding-vertical 52px @select-padding-vertical\n    @select-padding-horizontal;\n  position: absolute;\n  right: -(@select-arrow-width + @select-padding-horizontal);\n  top: 0;\n  font-size: 18px;\n  // crop text\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.has-value > .Select-control > .Select-value {\n  color: @select-text-color;\n  font-size: 18px;\n}\n\n// the <input> element users type in\n\n.Select-input {\n  // inherits `display: inline-block` from \"react-input-autosize\"\n  height: @select-input-internal-height;\n  padding-left: @select-padding-horizontal;\n  padding-right: @select-padding-horizontal;\n  vertical-align: middle;\n\n  > input {\n    background: none transparent;\n    border: 0 none;\n    box-shadow: none;\n    cursor: default;\n    display: inline-block;\n    font-family: inherit;\n    font-size: inherit;\n    height: @select-input-internal-height;\n    margin: 0;\n    outline: none;\n    padding: 0;\n    -webkit-appearance: none;\n\n    .is-focused & {\n      cursor: text;\n    }\n  }\n}\n\n// fake input\n.Select-control:not(.is-searchable) > .Select-input {\n  outline: none;\n}\n\n// loading indicator\n.Select-loading-zone {\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: @select-loading-size;\n}\n.Select-loading {\n  .Select-spinner(@select-loading-size, @select-loading-color-bg, @select-loading-color);\n  vertical-align: middle;\n}\n\n// the little cross that clears the field\n\n.Select-clear-zone {\n  .animation( Select-animation-fadeIn 200ms );\n  color: @select-clear-color;\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: @select-clear-width;\n\n  &:hover {\n    color: @select-clear-hover-color;\n  }\n}\n.Select-clear {\n  display: inline-block;\n  font-size: @select-clear-size;\n  line-height: 1;\n}\n.Select--multi .Select-clear-zone {\n  width: @select-clear-width;\n}\n\n// arrow indicator\n\n.Select-arrow-zone {\n  cursor: pointer;\n  display: table-cell;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n  width: (@select-arrow-width * 5);\n  padding-right: @select-arrow-width;\n}\n\n.Select-arrow {\n  border-color: @select-arrow-color transparent transparent;\n  border-style: solid;\n  border-width: @select-arrow-width @select-arrow-width\n    (@select-arrow-width / 2);\n  display: inline-block;\n  height: 0;\n  width: 0;\n}\n.is-open .Select-arrow,\n.Select-arrow-zone:hover > .Select-arrow {\n  border-top-color: @select-arrow-color-hover;\n}\n\n// Animation\n// ------------------------------\n\n// fade in\n\n@-webkit-keyframes Select-animation-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n@keyframes Select-animation-fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n","//\n// Mixins\n// ------------------------------\n\n// Utilities\n\n.size(@width; @height) {\n  width: @width;\n  height: @height;\n}\n.square(@size) {\n  .size(@size; @size);\n}\n.border-top-radius(@radius) {\n  border-top-right-radius: @radius;\n  border-top-left-radius: @radius;\n}\n.border-right-radius(@radius) {\n  border-bottom-right-radius: @radius;\n  border-top-right-radius: @radius;\n}\n.border-bottom-radius(@radius) {\n  border-bottom-right-radius: @radius;\n  border-bottom-left-radius: @radius;\n}\n.border-left-radius(@radius) {\n  border-bottom-left-radius: @radius;\n  border-top-left-radius: @radius;\n}\n\n// Vendor Prefixes\n\n.animation(@animation) {\n  -webkit-animation: @animation;\n  -o-animation: @animation;\n  animation: @animation;\n}\n.box-sizing(@boxmodel) {\n  -webkit-box-sizing: @boxmodel;\n  -moz-box-sizing: @boxmodel;\n  box-sizing: @boxmodel;\n}\n.rotate(@degrees) {\n  -webkit-transform: rotate(@degrees);\n  -ms-transform: rotate(@degrees); // IE9 only\n  -o-transform: rotate(@degrees);\n  transform: rotate(@degrees);\n}\n.transform(@transform) {\n  -webkit-transform: @transform;\n  -moz-transform: @transform;\n  -ms-transform: @transform;\n  transform: @transform;\n}\n","//\n// Spinner\n// ------------------------------\n\n.Select-spinner(@size, @orbit, @satellite) {\n  .animation( Select-animation-spin 400ms infinite linear );\n  .square(@size);\n  box-sizing: border-box;\n  border-radius: 50%;\n  border: floor((@size / 8)) solid @orbit;\n  border-right-color: @satellite;\n  display: inline-block;\n  position: relative;\n}\n\n@keyframes Select-animation-spin {\n  to {\n    transform: rotate(1turn);\n  }\n}\n@-webkit-keyframes Select-animation-spin {\n  to {\n    -webkit-transform: rotate(1turn);\n  }\n}\n","//\n// Select Menu\n// ------------------------------\n\n// wrapper around the menu\n\n.Select-menu-outer {\n  // Unfortunately, having both border-radius and allows scrolling using overflow defined on the same\n  // element forces the browser to repaint on scroll.  However, if these definitions are split into an\n  // outer and an inner element, the browser is able to optimize the scrolling behavior and does not\n  // have to repaint on scroll.\n  .border-bottom-radius( @select-input-border-radius );\n  background-color: @select-input-bg;\n  border: 1px solid @select-input-border-color;\n  border-top-color: mix(@select-input-bg, @select-input-border-color, 50%);\n  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);\n  box-sizing: border-box;\n  margin-top: -1px;\n  max-height: @select-menu-max-height;\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  z-index: @select-menu-zindex;\n  -webkit-overflow-scrolling: touch;\n}\n\n// wrapper\n\n.Select-menu {\n  max-height: (@select-menu-max-height - 2px);\n  overflow-y: auto;\n}\n\n// options\n\n.Select-option {\n  box-sizing: border-box;\n  color: @select-option-color;\n  cursor: pointer;\n  display: block;\n  padding: @select-padding-vertical @select-padding-horizontal;\n\n  &:last-child {\n    .border-bottom-radius( @select-input-border-radius );\n  }\n\n  &.is-focused {\n    background-color: @select-option-focused-bg;\n    color: @select-option-focused-color;\n  }\n\n  &.is-disabled {\n    color: @select-option-disabled-color;\n    cursor: not-allowed;\n  }\n}\n\n// no results\n\n.Select-noresults,\n.Select-search-prompt,\n.Select-searching {\n  box-sizing: border-box;\n  color: @select-noresults-color;\n  cursor: default;\n  display: block;\n  padding: @select-padding-vertical @select-padding-horizontal;\n}\n","//\n// Multi-Select\n// ------------------------------\n\n// Base\n\n.Select--multi {\n  // control: reduce padding to allow for items\n  .Select-control {\n  }\n\n  // add margin to the input element\n  .Select-input {\n    vertical-align: middle;\n    // border: 1px solid transparent;\n    margin-left: @select-padding-horizontal;\n    padding: 0;\n  }\n\n  // reduce margin once there is value\n  &.has-value .Select-input {\n    margin-left: @select-item-gutter;\n  }\n}\n\n// Items\n\n.Select-item {\n  background-color: @select-item-bg;\n  border-radius: @select-item-border-radius;\n  border: 1px solid @select-item-border-color;\n  color: @select-item-color;\n  display: inline-block;\n  font-size: @select-item-font-size;\n  margin-left: @select-item-gutter;\n  margin-top: @select-item-gutter;\n  vertical-align: top;\n}\n\n// common\n.Select-item-icon,\n.Select-item-label {\n  display: inline-block;\n  vertical-align: middle;\n}\n\n// label\n.Select-item-label {\n  .border-right-radius( @select-item-border-radius );\n  cursor: default;\n  padding: @select-item-padding-vertical @select-item-padding-horizontal;\n\n  .Select-item-label__a {\n    color: @select-item-color;\n    cursor: pointer;\n  }\n}\n\n// icon\n.Select-item-icon {\n  cursor: pointer;\n  .border-left-radius( @select-item-border-radius );\n  border-right: 1px solid @select-item-border-color;\n\n  // move the baseline up by 1px\n  padding: @select-item-padding-vertical @select-item-padding-horizontal\n    (@select-item-padding-vertical + 1);\n\n  &:hover,\n  &:focus {\n    background-color: @select-item-hover-bg;\n    color: @select-item-hover-color;\n  }\n  &:active {\n    background-color: @select-item-border-color;\n  }\n}\n\n.Select--multi.is-disabled {\n  .Select-item {\n    background-color: @select-item-disabled-bg;\n    border: 1px solid @select-item-disabled-border-color;\n    color: @select-item-disabled-color;\n  }\n  // icon\n  .Select-item-icon {\n    cursor: not-allowed;\n    border-right: 1px solid @select-item-disabled-border-color;\n\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: @select-item-disabled-bg;\n    }\n  }\n}\n",".m-signature-pad {\n  position: absolute;\n  font-size: 10px;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  margin: auto;\n  background-color: #fff;\n  border-radius: 4px;\n  -moz-user-select: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n}\n\n.m-signature-pad--body {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  border: 1px solid #f4f4f4;\n}\n\n.m-signature-pad--body canvas {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 4px;\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.02) inset;\n}\n\n.m-signature-pad--footer {\n  position: absolute;\n  left: 20px;\n  right: 20px;\n  bottom: 20px;\n  height: 40px;\n}\n\n.m-signature-pad--footer .description {\n  color: #c3c3c3;\n  text-align: center;\n  font-size: 1.2em;\n  margin-top: 1.8em;\n}\n\n.m-signature-pad--footer .button {\n  position: absolute;\n  bottom: 0;\n}\n\n.m-signature-pad--footer .button.clear {\n  left: 0;\n}\n\n.m-signature-pad--footer .button.save {\n  right: 0;\n}\n\n@media screen and (max-width: 1024px) {\n  .m-signature-pad {\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    width: auto;\n    height: auto;\n    min-width: 250px;\n    min-height: 140px;\n  }\n  #github {\n    display: none;\n  }\n}\n\n@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n  .m-signature-pad {\n  }\n}\n\n@media screen and (max-height: 320px) {\n  .m-signature-pad--body {\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n  }\n  .m-signature-pad--footer {\n    left: 20px;\n    right: 20px;\n    bottom: 4px;\n    height: 28px;\n  }\n  .m-signature-pad--footer .description {\n    font-size: 1em;\n    margin-top: 1em;\n  }\n}\n\n@media print {\n  // Renders an elegant signature line if there is no digital signature.\n  .m-signature-pad-button {\n    height: 30px;\n    margin-bottom: 10px;\n    .btn,\n    button {\n      display: none !important;\n    }\n  }\n}\n","// =========== Snugg Mixins =================\n\n// Border Radius\n.border-radius(@radius) {\n  -webkit-border-radius: @radius;\n  -moz-border-radius: @radius;\n  border-radius: @radius;\n}\n\n//  ========= Theme gradient ================\n.theme-colors(@color-1, @color-2) {\n  background: @color-1;\n  /* Old browsers */\n  background: -moz-linear-gradient(\n    left,\n    @color-1 0%,\n    @color-1 50%,\n    @color-2 50%,\n    @color-2 100%\n  );\n  /* FF3.6+ */\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    color-stop(0%, @color-1),\n    color-stop(50%, @color-1),\n    color-stop(50%, @color-2),\n    color-stop(100%, @color-2)\n  );\n  /* Chrome,Safari4+ */\n  background: -webkit-linear-gradient(\n    left,\n    @color-1 0%,\n    @color-1 50%,\n    @color-2 50%,\n    @color-2 100%\n  );\n  /* Chrome10+,Safari5.1+ */\n  background: -o-linear-gradient(\n    left,\n    @color-1 0%,\n    @color-1 50%,\n    @color-2 50%,\n    @color-2 100%\n  );\n  /* Opera 11.10+ */\n  background: -ms-linear-gradient(\n    left,\n    @color-1 0%,\n    @color-1 50%,\n    @color-2 50%,\n    @color-2 100%\n  );\n  /* IE10+ */\n  background: linear-gradient(\n    to right,\n    @color-1 0%,\n    @color-1 50%,\n    @color-2 50%,\n    @color-2 100%\n  );\n  /* W3C */\n}\n\n// =========  deprecated mixins in BS 3 that are useful\n\n// Border Radius\n.border-radius(@radius) {\n  -webkit-border-radius: @radius;\n  -moz-border-radius: @radius;\n  border-radius: @radius;\n}\n\n// Watermark to display on sample jobs\n.sample-job-watermark {\n  &:after {\n    content: 'Sample';\n    position: absolute;\n    z-index: 2;\n    left: 20%;\n    top: 30%;\n    font-size: 180px;\n    text-transform: uppercase;\n    font-family: 'open sans', 'helvetica neue', helvetica, arial;\n    -webkit-transform: rotate(-25deg);\n    -moz-transform: rotate(-25deg);\n    -ms-transform: rotate(-25deg);\n    transform: rotate(-25deg);\n    font-family: 'HelveticaNeue-Light', 'Helvetica Neue Light', 'Helvetica Neue',\n      Helvetica, Arial, 'Lucida Grande', sans-serif;\n    font-weight: 300;\n    color: rgba(0, 0, 0, 0.24);\n  }\n}\n\n.signed-copy-job-watermark {\n  &:after {\n    content: 'Signed Copy';\n    position: absolute;\n    z-index: 2;\n    left: 0%;\n    top: 32%;\n    font-size: 154px;\n    text-transform: uppercase;\n    font-weight: 300;\n    font-family: 'open sans', 'helvetica neue', helvetica, arial;\n    -webkit-transform: rotate(-30deg);\n    -moz-transform: rotate(-30deg);\n    -ms-transform: rotate(-30deg);\n    transform: rotate(-30deg);\n    color: rgba(0, 0, 0, 0.24);\n  }\n}\n\n.out-of-date-job-watermark {\n  &:after {\n    content: 'Out of Date';\n    position: absolute;\n    z-index: 2;\n    left: 0%;\n    top: 32%;\n    font-size: 154px;\n    text-transform: uppercase;\n    font-weight: 300;\n    font-family: 'open sans', 'helvetica neue', helvetica, arial;\n    -webkit-transform: rotate(-30deg);\n    -moz-transform: rotate(-30deg);\n    -ms-transform: rotate(-30deg);\n    transform: rotate(-30deg);\n    color: rgba(217, 45, 32, 0.24);\n  }\n}\n\n.desaturate-image {\n  filter: grayscale(100%);\n  -webkit-filter: grayscale(100%);\n  -moz-filter: grayscale(100%);\n  filter: grayscale(100%);\n}\n\n.transform(@method) {\n  transform: @method;\n  -webkit-transform: @method;\n  /** Chrome & Safari **/\n  -o-transform: @method;\n  /** Opera **/\n  -moz-transform: @method;\n  /** Firefox **/\n}\n\n.animate-hide() {\n  -webkit-animation:\n    fadeOut 0.2s ease-in forwards,\n    shrinkHeight 0.5s ease-in forwards;\n  animation:\n    fadeOut 0.2s ease-in forwards,\n    shrinkHeight 0.5s ease-in forwards;\n}\n\n@-webkit-keyframes fadeOut {\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  to {\n    opacity: 0;\n  }\n}\n\n@-webkit-keyframes shrinkHeight {\n  to {\n    max-height: 0;\n    transform: scale(0);\n  }\n}\n\n@keyframes shrinkHeight {\n  to {\n    max-height: 0;\n    transform: scale(0);\n  }\n}\n",".dragndrop-area-base() {\n  margin-top: 0;\n  cursor: pointer;\n  position: relative;\n  border-radius: 5px;\n  min-width: initial;\n  background-color: @gray-lightestest;\n  color: @gray-light;\n  left: 0;\n\n  &:hover {\n    background-color: desaturate(lighten(@custom-color-4, 45%), 8%);\n    border-color: desaturate(lighten(@custom-color-4, 20%), 5%);\n  }\n\n  &:active,\n  &:focus {\n    background-color: lighten(@custom-color-4, 38%);\n    border-color: desaturate(lighten(@custom-color-4, 17%), 5%);\n  }\n\n  .snugg-upload-prompt-text {\n    line-height: 28px;\n    padding: 15px 0;\n    display: block;\n    margin: auto;\n    font-size: 10px;\n\n    i[class^='ico-'],\n    i[class*=' ico-'] {\n      font-size: 36px;\n    }\n  }\n}\n\n.uploader-container {\n  position: relative;\n  height: 115px;\n  text-align: center;\n  background-color: #f9f9f9;\n  border-radius: 6px;\n  cursor: pointer;\n\n  // .box-shadow(inset 0px 1px 3px rgba(0,0,0,0.2));\n  .btn.delete-photo {\n    .button-variant(red, #fff, #ccc);\n    border: 1px solid #ddd;\n    position: absolute;\n    left: 0;\n    right: 0;\n    bottom: -10px;\n    margin: auto;\n    width: 45px;\n    font-size: 18px;\n  }\n\n  .delete-photo {\n    display: none;\n  }\n\n  img {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    max-height: 100%;\n    max-width: 100%;\n    height: auto;\n    width: auto;\n    min-height: 50px;\n    min-width: 50px;\n    cursor: pointer;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n  }\n\n  // Custom uploader: apply drag-and-drop area styles directly inside container\n  // (legacy Uploadcare widget had an extra .uploadcare--widget parent)\n  > .uploadcare--widget__dragndrop-area {\n    .dragndrop-area-base();\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    border: 1px dashed rgba(0, 0, 0, 0.2);\n  }\n}\n\n.uploadcare--widget {\n  width: 100%;\n  cursor: pointer;\n\n  // The buttons...\n  .uploadcare--widget__button {\n    display: none !important;\n  }\n\n  // The upload circle\n  .uploadcare--widget__status,\n  .uploadcare--widget__circle-back {\n    display: none;\n  }\n\n  // All widget messages. You can change the font, text size, or color, for example.\n  .uploadcare--widget__status {\n    display: none;\n  }\n\n  // Drag and drop area styling...\n  .uploadcare--widget__dragndrop-area {\n    .dragndrop-area-base();\n    display: block;\n    min-height: 115px;\n  }\n}\n\n.uploadcare-dragging {\n  background-color: lighten(@custom-color-4, 48%);\n}\n\n// Drag-and-drop overlay shown over the uploader while a file is dragged over it.\n// pointer-events: none so the underlying container keeps receiving drag events.\n.snugg-uploader-dropzone-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 5;\n  pointer-events: none;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px;\n  border-radius: 6px;\n  border: 2px dashed @custom-color-4;\n  background-color: fade(@custom-color-4, 10%);\n  animation: snugg-uploader-dropzone-in 120ms ease-out;\n\n  &__inner {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 6px;\n    text-align: center;\n    color: darken(@custom-color-4, 12%);\n  }\n\n  &__icon {\n    width: 28px;\n    height: 28px;\n    color: @custom-color-4;\n  }\n\n  &__text {\n    font-size: 12px;\n    font-weight: 700;\n    line-height: 1.2;\n  }\n}\n\n@keyframes snugg-uploader-dropzone-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.uploadcare--dialog__powered-by {\n  display: none;\n}\n\n.uploadcare-file-container {\n  .uploadcare--widget {\n    display: none !important;\n  }\n}\n\n.uploadcare-widget-disabled {\n  float: left;\n  margin-left: 10px;\n  min-width: initial;\n  min-height: 115px;\n  width: 200px;\n  height: 100%;\n  left: 0;\n  margin-top: 0;\n  display: block;\n  position: relative;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  text-align: center;\n  background-color: @gray-lighter;\n  border: 1px dashed rgba(0, 0, 0, 0.2);\n\n  .ico-budicon-10 {\n    position: absolute;\n    z-index: 3;\n    top: 0.8em;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    text-align: center;\n    color: @gray-light;\n  }\n}\n\n.photo-upload-refine {\n  position: relative;\n  margin-bottom: 20px;\n\n  .snugg-upload-prompt-text {\n    line-height: 1.1 !important;\n  }\n}\n\n.uploaded-image-loading {\n  background: url('../../img/spinner.svg') center center no-repeat;\n}\n\n.photo-upload-report {\n  position: relative;\n  width: 200px;\n  margin-bottom: 20px;\n\n  .snugg-upload-prompt-text {\n    line-height: 1.1 !important;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n.button-variant(@color; @background; @border) {\n  color: @color;\n  background-color: @background;\n  border-color: @border;\n\n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  .open > .dropdown-toggle& {\n    color: @color;\n    background-color: darken(@background, 10%);\n        border-color: darken(@border, 12%);\n  }\n  &:active,\n  &.active,\n  .open > .dropdown-toggle& {\n    background-image: none;\n  }\n  &.disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    &,\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      background-color: @background;\n          border-color: @border;\n    }\n  }\n\n  .badge {\n    color: @background;\n    background-color: @color;\n  }\n}\n\n// Button sizes\n.button-size(@padding-vertical; @padding-horizontal; @font-size; @line-height; @border-radius) {\n  padding: @padding-vertical @padding-horizontal;\n  font-size: @font-size;\n  line-height: @line-height;\n  border-radius: @border-radius;\n}\n","// Custom Uploader styles - v2 (horizontal tab navigation)\n\n// ---- Design tokens ----\n@snugg-up-orange: #fa7b00;\n@snugg-up-orange-gradient: linear-gradient(180deg, #fea100 0%, #fa7b00 100%);\n@snugg-up-primary: @snugg-up-orange;\n@snugg-up-primary-hover: lighten(@snugg-up-primary, 8%);\n@snugg-up-primary-active: darken(@snugg-up-primary, 6%);\n@snugg-up-dialog-bg: #fff;\n@snugg-up-header-bg: #f2f2f2;\n@snugg-up-border: #eeeeee;\n@snugg-up-text: #333333;\n@snugg-up-text-muted: #777777;\n@snugg-up-radius: 6px;\n@snugg-up-header-height: 60px;\n@snugg-up-footer-height: 65px;\n@snugg-up-tab-active-text: #333333;\n@snugg-up-tab-text: #777777;\n@snugg-up-dropzone-border: #cccccc;\n@snugg-up-preview-dot: @custom-color-4; // orange/yellow\n\n// ---- Overlay ----\n.snugg-uploader-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(0, 0, 0, 0.45);\n  animation: snugg-uploader-fade-in 0.2s ease;\n}\n\n@keyframes snugg-uploader-fade-in {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n// ---- Dialog container ----\n.snugg-uploader-dialog {\n  display: flex;\n  position: relative;\n  width: 800px;\n  max-width: calc(100% - 40px);\n  height: 660px;\n  max-height: calc(100% - 40px);\n  border-radius: @snugg-up-radius;\n  overflow: hidden;\n  box-shadow: -2px 1px 50px rgba(0, 0, 0, 0.4);\n  animation: snugg-uploader-slide-up 0.25s ease;\n\n  // Go full-screen on mobile (matches the breakpoint where the mobile\n  // nav/picker chrome takes over), so the editor uses all available space.\n  @media (max-width: 767px), (max-height: 500px) {\n    width: 100%;\n    height: 100%;\n    max-width: 100%;\n    max-height: 100%;\n    border-radius: 0;\n  }\n}\n\n@keyframes snugg-uploader-slide-up {\n  from {\n    opacity: 0;\n    transform: translateY(12px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n// ---- Panel (column: header + body + footer) ----\n.snugg-uploader-panel {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  background: @snugg-up-dialog-bg;\n}\n\n// ---- Header (tab bar + close button) ----\n.snugg-uploader-header {\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  height: @snugg-up-header-height;\n  background: @snugg-up-header-bg;\n  border-bottom: 1px solid @snugg-up-border;\n}\n\n.snugg-uploader-header__close {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: @snugg-up-header-height;\n  height: @snugg-up-header-height;\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  border: none;\n  color: @snugg-up-text;\n  cursor: pointer;\n  transition:\n    color 0.15s ease,\n    background-color 0.15s ease;\n  outline: none;\n  -webkit-appearance: none;\n\n  &:hover {\n    color: @snugg-up-text;\n    background-color: rgba(0, 0, 0, 0.06);\n  }\n\n  &:focus-visible {\n    box-shadow: inset 0 0 0 2px @snugg-up-primary;\n  }\n\n  @media (max-width: 600px) {\n    width: 44px;\n  }\n}\n\n// ---- Tabs (centered in header) ----\n.snugg-uploader-tabs {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n\n  @media (max-width: 600px) {\n    margin: 0;\n    flex: 1;\n    min-width: 0;\n  }\n}\n\n.snugg-uploader-tab {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 24px;\n  gap: 12px;\n  height: @snugg-up-header-height;\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n\n  @media (max-width: 600px) {\n    padding: 0 12px;\n    gap: 6px;\n    font-size: 13px;\n  }\n\n  line-height: 142%;\n  color: @snugg-up-tab-text;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease;\n  outline: none;\n  -webkit-appearance: none;\n\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.5);\n  }\n\n  &:focus-visible {\n    box-shadow: inset 0 0 0 2px @snugg-up-primary;\n  }\n\n  &.snugg-uploader-tab--active {\n    background: @snugg-up-dialog-bg;\n    color: @snugg-up-tab-active-text;\n  }\n}\n\n.snugg-uploader-tab__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n\n  svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.snugg-uploader-tab__label {\n  white-space: nowrap;\n}\n\n// ---- Body (scrollable content area) ----\n.snugg-uploader-body {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  padding: 0;\n}\n\n// ---- Upload Files tab body ----\n.snugg-uploader-upload-body {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 24px;\n  gap: 16px;\n  width: 100%;\n  height: 100%;\n}\n\n// ---- Upload progress / error view (shown while a selected file uploads) ----\n.snugg-uploader-progress {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 32px 24px;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n\n  &__icon {\n    color: @snugg-up-text-muted;\n    opacity: 0.8;\n\n    svg {\n      width: 40px;\n      height: 40px;\n    }\n  }\n\n  &__name {\n    max-width: 320px;\n    color: @snugg-up-text;\n    font-weight: 600;\n    word-break: break-word;\n  }\n\n  &__track {\n    position: relative;\n    width: 100%;\n    max-width: 320px;\n    height: 8px;\n    border-radius: 999px;\n    background: @snugg-up-border;\n    overflow: hidden;\n  }\n\n  &__bar {\n    height: 100%;\n    border-radius: 999px;\n    background: @snugg-up-orange-gradient;\n    transition: width 0.2s ease;\n  }\n\n  &__pct {\n    color: @snugg-up-text-muted;\n    font-size: 13px;\n  }\n\n  &--error &__name {\n    color: #d92d20;\n  }\n}\n\n// ---- Drop zone (Upload Files tab) ----\n.snugg-uploader-dropzone {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  padding: 24px;\n  width: 100%;\n  flex-grow: 1;\n  background: @snugg-up-dialog-bg;\n  border: 1px dashed @snugg-up-dropzone-border;\n  border-radius: 12px;\n  text-align: center;\n  cursor: default;\n}\n\n.snugg-uploader-dropzone--dragging {\n  background-color: fade(@snugg-up-primary, 4%);\n  border-color: @snugg-up-primary;\n  border-style: dashed;\n}\n\n.snugg-uploader-dropzone__heading {\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 142%;\n  color: @snugg-up-text;\n}\n\n.snugg-uploader-dropzone__or {\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 142%;\n  color: @snugg-up-text-muted;\n}\n\n.snugg-uploader-dropzone__browse {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 15px 18px;\n  background: linear-gradient(180deg, #fea100 0%, #fa7b00 100%);\n  border: none;\n  border-radius: @snugg-up-radius;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  line-height: 20px;\n  text-align: center;\n  color: #ffffff;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n  outline: none;\n  -webkit-appearance: none;\n\n  &:hover {\n    opacity: 0.9;\n  }\n\n  &:active {\n    opacity: 0.8;\n  }\n\n  &:focus-visible {\n    box-shadow: 0 0 0 2px fade(#fa7b00, 50%);\n  }\n}\n\n.snugg-uploader-dropzone__url-row {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n  width: 500px;\n  max-width: 100%;\n}\n\n.snugg-uploader-dropzone__url-input {\n  box-sizing: border-box;\n  flex: 1;\n  height: 46px;\n  padding: 10px 12px;\n  background: @snugg-up-dialog-bg;\n  border: 1px solid @snugg-up-dropzone-border;\n  border-radius: @snugg-up-radius;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 142%;\n  color: #555555;\n  outline: none;\n\n  &::placeholder {\n    color: #555555;\n    opacity: 0.5;\n  }\n\n  &:focus {\n    border-color: @snugg-up-primary;\n    box-shadow: 0 0 0 2px fade(@snugg-up-primary, 20%);\n  }\n\n  &:disabled {\n    opacity: 0.6;\n  }\n}\n\n.snugg-uploader-dropzone__url-btn {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 12px 16px;\n  width: 82px;\n  height: 46px;\n  background: linear-gradient(180deg, #505252 0%, #2f3030 100%);\n  border: none;\n  border-radius: @snugg-up-radius;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  line-height: 19px;\n  text-align: center;\n  color: #ffffff;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n  outline: none;\n  -webkit-appearance: none;\n\n  &:hover {\n    opacity: 0.9;\n  }\n\n  &:active {\n    opacity: 0.8;\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n\n  &:focus-visible {\n    box-shadow: 0 0 0 2px fade(#2f3030, 50%);\n  }\n}\n\n.snugg-uploader-dropzone__size-pill {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 6px 12px;\n  background: @snugg-up-header-bg;\n  border-radius: 12px;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 142%;\n  color: @snugg-up-text-muted;\n}\n\n.snugg-uploader-dropzone__error {\n  color: @color-alertred;\n  font-size: 13px;\n  margin-top: 4px;\n}\n\n// ---- Footer ----\n.snugg-uploader-footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px 16px;\n  min-height: @snugg-up-footer-height;\n  border-top: 1px solid @snugg-up-border;\n\n  // Equal-width side slots so the toolbar stays perfectly centered\n  &:not(.snugg-uploader-footer--crop) > :first-child,\n  &:not(.snugg-uploader-footer--crop) > :last-child {\n    flex: 0 0 160px;\n  }\n\n  > :first-child {\n    text-align: left;\n  }\n\n  > :last-child {\n    text-align: right;\n  }\n\n  // On phones the single row (button · toolbar · button) overflows, clipping\n  // the primary action. Stack into two rows: the edit toolbar on top, the\n  // Cancel/primary actions spread across the bottom.\n  @media (max-width: 600px) {\n    padding: 10px 12px 14px;\n\n    &:not(.snugg-uploader-footer--crop) {\n      flex-wrap: wrap;\n      row-gap: 12px;\n\n      // Toolbar takes its own full-width first row, icons centered.\n      .snugg-uploader-toolbar {\n        order: -1;\n        flex: 0 0 100%;\n        padding: 0;\n      }\n\n      // Action buttons size to content and split across the second row\n      // (justify-content: space-between applies per wrapped line).\n      > :first-child,\n      > :last-child {\n        flex: 0 0 auto;\n      }\n    }\n\n    .snugg-uploader-btn {\n      padding: 0 14px;\n      font-size: 13px;\n      min-width: 0;\n    }\n  }\n}\n\n// ---- Buttons ----\n.snugg-uploader-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  min-width: 90px;\n  height: 40px;\n  padding: 0 20px;\n  border: 1px solid @snugg-up-primary;\n  border-radius: @snugg-up-radius;\n  background: transparent;\n  color: @snugg-up-primary;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1;\n  text-align: center;\n  cursor: pointer;\n  transition:\n    background-color 0.15s ease,\n    color 0.15s ease,\n    border-color 0.15s ease;\n  outline: none;\n  -webkit-appearance: none;\n\n  &:hover {\n    border-color: @snugg-up-primary-hover;\n    color: @snugg-up-primary-hover;\n  }\n\n  &:active {\n    border-color: @snugg-up-primary-active;\n    color: @snugg-up-primary-active;\n  }\n\n  &:focus-visible {\n    box-shadow: 0 0 0 2px fade(@snugg-up-primary, 40%);\n  }\n\n  &:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.snugg-uploader-btn--primary {\n  background: @snugg-up-orange-gradient;\n  border-color: @snugg-up-orange;\n  color: #fff;\n  font-weight: 700;\n\n  &:hover {\n    opacity: 0.9;\n    border-color: @snugg-up-primary-hover;\n    color: #fff;\n  }\n\n  &:active {\n    opacity: 0.8;\n    border-color: @snugg-up-primary-active;\n    color: #fff;\n  }\n\n  &:disabled {\n    background: #ccc;\n    border-color: #ccc;\n    color: #fff;\n    opacity: 1;\n  }\n}\n\n.snugg-uploader-btn--close {\n  min-width: 0;\n  border-color: transparent;\n  color: @snugg-up-text-muted;\n\n  &:hover {\n    color: @snugg-up-text;\n    border-color: transparent;\n  }\n}\n\n// ---- Toolbar (crop/rotate/flip icons in footer) ----\n.snugg-uploader-toolbar {\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2px;\n  padding: 0 12px;\n}\n\n.snugg-uploader-toolbar__btn {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  color: @snugg-up-text;\n  font-size: 18px;\n  cursor: pointer;\n  transition:\n    color 0.15s ease,\n    background-color 0.15s ease;\n  outline: none;\n  -webkit-appearance: none;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.06);\n    color: @snugg-up-primary;\n  }\n\n  &:focus-visible {\n    box-shadow: 0 0 0 2px @snugg-up-primary;\n  }\n\n  &.snugg-uploader-toolbar__btn--active {\n    color: @snugg-up-primary;\n\n    &::after {\n      content: '';\n      position: absolute;\n      bottom: 2px;\n      left: 50%;\n      transform: translateX(-50%);\n      width: 6px;\n      height: 6px;\n      border-radius: 50%;\n      background: @snugg-up-primary;\n    }\n  }\n\n  &:disabled {\n    opacity: 0.35;\n    cursor: default;\n\n    &:hover {\n      background-color: transparent;\n      color: @snugg-up-text;\n    }\n  }\n\n  // Tooltip\n  &[title] {\n    position: relative;\n  }\n}\n\n// ---- Camera tab ----\n.snugg-uploader-camera {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  padding: 20px;\n\n  video {\n    flex: 0 1 auto;\n    min-height: 0;\n    width: 100%;\n    max-height: 380px;\n    object-fit: contain;\n    background: #000;\n    border-radius: 4px;\n  }\n\n  canvas {\n    display: none;\n  }\n\n  .snugg-uploader-camera__controls {\n    flex-shrink: 0;\n    margin-top: 16px;\n  }\n\n  @media (max-height: 500px) {\n    padding: 10px;\n\n    .snugg-uploader-camera__controls {\n      margin-top: 10px;\n    }\n  }\n\n  .snugg-uploader-camera__error {\n    color: @color-alertred;\n    text-align: center;\n    padding: 40px 20px;\n  }\n\n  .snugg-uploader-camera__spinner {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 40px 20px;\n    color: @snugg-up-text-muted;\n  }\n\n  .snugg-uploader-camera__message {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    padding: 40px 20px;\n    max-width: 480px;\n  }\n\n  .snugg-uploader-camera__message-heading {\n    font-family: 'Open Sans', sans-serif;\n    font-weight: 700;\n    font-size: 18px;\n    line-height: 142%;\n    color: @snugg-up-text;\n    margin-bottom: 8px;\n  }\n\n  .snugg-uploader-camera__message-line {\n    font-family: 'Open Sans', sans-serif;\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 160%;\n    color: @snugg-up-text-muted;\n\n    &:first-of-type {\n      font-weight: 600;\n      color: @snugg-up-text;\n      margin-top: 4px;\n      margin-bottom: 6px;\n    }\n  }\n\n  .snugg-uploader-camera__message-action {\n    margin-top: 20px;\n    padding: 10px 20px;\n    background: transparent;\n    border: 1px solid @snugg-up-primary;\n    border-radius: @snugg-up-radius;\n    color: @snugg-up-primary;\n    font-family: inherit;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition:\n      background-color 0.15s ease,\n      color 0.15s ease;\n    outline: none;\n    -webkit-appearance: none;\n\n    &:hover {\n      background-color: fade(@snugg-up-primary, 8%);\n    }\n\n    &:focus-visible {\n      box-shadow: 0 0 0 2px fade(@snugg-up-primary, 40%);\n    }\n  }\n}\n\n// ---- URL tab (standalone, kept for backward compat) ----\n.snugg-uploader-url {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  padding: 20px 40px;\n}\n\n.snugg-uploader-url__input-group {\n  display: flex;\n  width: 100%;\n  max-width: 500px;\n  gap: 8px;\n  margin-bottom: 8px;\n\n  input {\n    flex: 1;\n    height: 40px;\n    padding: 0 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 14px;\n    font-family: inherit;\n    outline: none;\n\n    &:focus {\n      border-color: @snugg-up-primary;\n      box-shadow: 0 0 0 2px fade(@snugg-up-primary, 20%);\n    }\n\n    &::placeholder {\n      color: #bbb;\n    }\n  }\n}\n\n.snugg-uploader-url__error {\n  color: @color-alertred;\n  font-size: 13px;\n  margin-bottom: 8px;\n  max-width: 500px;\n  width: 100%;\n}\n\n.snugg-uploader-url__preview {\n  text-align: center;\n  margin-top: 16px;\n\n  img {\n    max-width: 100%;\n    max-height: 260px;\n    border-radius: 4px;\n    margin-bottom: 12px;\n  }\n}\n\n// ---- Image editor (inside body) ----\n.snugg-uploader-editor {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 20px;\n  overflow: hidden;\n\n  img {\n    max-width: 100%;\n    display: block;\n  }\n}\n\n.snugg-uploader-editor-canvas-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n}\n\n.snugg-uploader-preview-canvas {\n  max-width: 100%;\n  max-height: 100%;\n  display: block;\n  border-radius: 4px;\n}\n\n// ---- Cropper.js overrides ----\n// Make cropperjs visuals subtler / match dialog aesthetics\n.snugg-uploader-editor {\n  .cropper-container {\n    max-height: 100%;\n  }\n\n  .cropper-view-box {\n    outline: 1px solid rgba(255, 255, 255, 0.7);\n    outline-color: rgba(51, 153, 255, 0.5);\n  }\n\n  .cropper-line {\n    background-color: @snugg-up-primary;\n    opacity: 0.2;\n  }\n\n  .cropper-point {\n    background-color: @snugg-up-primary;\n    opacity: 0.7;\n    width: 8px;\n    height: 8px;\n  }\n\n  .cropper-modal {\n    background-color: #000;\n    opacity: 0.4;\n  }\n}\n\n// ---- Upload progress (inline in uploader container) ----\n.custom-uploader-progress {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background-color: #eee;\n  border-radius: 0 0 6px 6px;\n  overflow: hidden;\n\n  .progress-fill {\n    height: 100%;\n    background-color: @custom-color-4;\n    transition: width 0.2s ease;\n  }\n}\n\n// ---- Loading state ----\n.snugg-uploader-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 40px;\n  color: @snugg-up-text-muted;\n  font-size: 14px;\n}\n\n.snugg-uploader-error {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  padding: 40px;\n  color: @snugg-up-text-muted;\n  font-size: 14px;\n}\n\n// ---- Mobile source picker (viewport < 768px / Bootstrap md) ----\n\n// Hidden by default on all viewports; shown on mobile via --picker modifier\n.snugg-uploader-mobile-home {\n  display: none;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  position: relative;\n  padding: 56px 24px 40px;\n}\n\n.snugg-uploader-mobile-home__close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  color: @snugg-up-text;\n  cursor: pointer;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.06);\n  }\n\n  &:focus-visible {\n    box-shadow: inset 0 0 0 2px @snugg-up-primary;\n  }\n}\n\n// Back-to-editor arrow, shown top-left when the picker was reopened over an\n// existing preview (mirrors the close button's positioning on the right).\n.snugg-uploader-mobile-home__back {\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: transparent;\n  border: none;\n  border-radius: 50%;\n  color: @snugg-up-text;\n  cursor: pointer;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.06);\n  }\n\n  &:focus-visible {\n    box-shadow: inset 0 0 0 2px @snugg-up-primary;\n  }\n}\n\n.snugg-uploader-mobile-sources {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 14px;\n  width: 100%;\n  max-width: 300px;\n}\n\n.snugg-uploader-mobile-source-btn {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  padding: 18px 24px;\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n  border-radius: 14px;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 600;\n  font-size: 17px;\n  line-height: 1.3;\n  color: @snugg-up-text;\n  cursor: pointer;\n  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);\n  text-align: left;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background-color: #f7f7f7;\n  }\n\n  &:active {\n    background-color: #efefef;\n  }\n\n  &:focus-visible {\n    box-shadow: 0 0 0 2px @snugg-up-primary;\n  }\n}\n\n.snugg-uploader-mobile-source-btn__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: @snugg-up-text-muted;\n\n  svg {\n    width: 22px;\n    height: 22px;\n  }\n}\n\n.snugg-uploader-mobile-source-btn__label {\n  white-space: nowrap;\n}\n\n.snugg-uploader-mobile-home__filesize {\n  margin-top: 20px;\n  font-family: 'Open Sans', sans-serif;\n  font-size: 14px;\n  color: @snugg-up-text-muted;\n}\n\n// ---- Direct Link tab (URL input view, used on mobile via TAB_URL) ----\n.snugg-uploader-url-tab {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  padding: 24px 32px;\n  gap: 8px;\n\n  .snugg-uploader-dropzone__url-row {\n    width: 100%;\n    max-width: 480px;\n  }\n}\n\n// ---- Mobile nav bar (back + close; shown on mobile when NOT in picker) ----\n.snugg-uploader-mobile-nav {\n  display: none;\n  flex-shrink: 0;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: 52px;\n  padding: 0 4px;\n  background: @snugg-up-header-bg;\n  border-bottom: 1px solid @snugg-up-border;\n}\n\n.snugg-uploader-mobile-nav__back {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  padding: 0 12px;\n  height: 44px;\n  background: transparent;\n  border: none;\n  color: @snugg-up-primary;\n  font-family: 'Open Sans', sans-serif;\n  font-weight: 600;\n  font-size: 15px;\n  cursor: pointer;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  border-radius: 4px;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.04);\n  }\n\n  &:focus-visible {\n    box-shadow: inset 0 0 0 2px @snugg-up-primary;\n  }\n\n  svg {\n    width: 18px;\n    height: 18px;\n  }\n}\n\n.snugg-uploader-mobile-nav__close {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  background: transparent;\n  border: none;\n  color: @snugg-up-text;\n  cursor: pointer;\n  border-radius: 4px;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.06);\n  }\n\n  &:focus-visible {\n    box-shadow: inset 0 0 0 2px @snugg-up-primary;\n  }\n}\n\n// Hamburger that reopens the source picker while editing an already-picked\n// image (top-left of the mobile nav bar).\n.snugg-uploader-mobile-nav__menu {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  background: transparent;\n  border: none;\n  color: @snugg-up-text;\n  cursor: pointer;\n  border-radius: 4px;\n  outline: none;\n  -webkit-appearance: none;\n  appearance: none;\n  transition: background-color 0.15s ease;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.06);\n  }\n\n  &:focus-visible {\n    box-shadow: inset 0 0 0 2px @snugg-up-primary;\n  }\n}\n\n// On mobile (<768px): always hide desktop header; toggle picker vs content views\n@media (max-width: 767px) {\n  // Desktop tab bar is never needed on mobile\n  .snugg-uploader-header {\n    display: none;\n  }\n\n  // Picker active: show source buttons, hide body\n  .snugg-uploader-panel--picker {\n    .snugg-uploader-body {\n      display: none;\n    }\n\n    .snugg-uploader-mobile-home {\n      display: flex;\n    }\n  }\n\n  // Content active (any source selected): show mobile nav\n  .snugg-uploader-panel:not(.snugg-uploader-panel--picker) {\n    .snugg-uploader-mobile-nav {\n      display: flex;\n    }\n  }\n}\n\n// ---- Google Drive tab (iframe-based) ----\n.snugg-uploader-gdrive {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  color: @snugg-up-text-muted;\n  font-size: 14px;\n  overflow: hidden;\n}\n\n.snugg-uploader-gdrive__status {\n  color: @snugg-up-text-muted;\n  font-size: 14px;\n  padding: 40px;\n}\n\n.snugg-uploader-gdrive__error {\n  color: @color-alertred;\n  font-size: 13px;\n  padding: 40px;\n  max-width: 400px;\n}\n",".content-header .dropdown-menu {\n  min-width: 280px;\n}\n.dropdown-toggle {\n  .badge {\n    background-color: @custom-color-1;\n    color: darken(@gray-lightest, 10%);\n    .badge-left-tip {\n      border-right-color: @custom-color-1;\n    }\n  }\n}\n.dropdown-menu {\n  overflow: scroll;\n  max-height: 500px;\n  padding: 0;\n  border-radius: 6px;\n  padding: 8px;\n  border: none;\n  width: 100%;\n  margin-top: -1px;\n  text-align: left;\n  background-color: #fff;\n  box-shadow: 0 5px 20px 5px rgba(0, 0, 0, 0.3);\n  z-index: 1065;\n  .active,\n  .active > a,\n  .active > a:hover,\n  a:active,\n  a:focus {\n    border-radius: 4px;\n    background-color: @gray-lighter;\n    color: #000;\n    .badge {\n      background-color: @custom-color-1;\n      color: darken(@gray-lightest, 10%);\n      .badge-left-tip {\n        border-right-color: @custom-color-1;\n      }\n    }\n  }\n  > li {\n    &.top-divider {\n      border-top: 3px solid darken(@gray-lightest, 15%);\n      position: relative;\n    }\n  }\n  > li > a {\n    padding: 13px 10px;\n    border-radius: 4px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    font-size: 13px;\n    &:hover,\n    &:focus {\n      background-color: @gray-lightest;\n      outline: none;\n      .badge {\n        background-color: @gray-light;\n        color: @gray-lightest;\n        .badge-left-tip {\n          border-right-color: @gray-light;\n        }\n      }\n    }\n    &:active {\n      background-color: @gray-lightish;\n    }\n  }\n}\n.dropdown.btn-group {\n  width: 100%;\n  border-left: solid 0px transparent;\n  > .btn:first-child {\n    background-color: @gray-lightestest;\n    border: none;\n  }\n  &#btn-group-companies {\n    position: relative;\n    z-index: 4;\n    > .btn {\n      border-left: none;\n      border-radius: 0;\n    }\n  }\n  &#btn-group-stages {\n    z-index: 3;\n    position: relative;\n    text-align: left;\n    > .btn {\n      border-left: none;\n      border-radius: 0;\n    }\n  }\n  &#btn-group-sort {\n    border-right: 1px solid darken(@gray-lightest, 2%);\n    text-align: left;\n    > .btn {\n      border-left: none;\n      border-radius: 0;\n    }\n  }\n  .btn {\n    width: 100%;\n    float: none;\n    text-align: left;\n    border-color: transparent;\n    border-top: none;\n    border-bottom: none;\n    border-right: none;\n    background-color: inherit;\n    border-radius: 0;\n    margin: auto;\n    height: 100%;\n    width: 100%;\n    min-width: 60px;\n    padding: 4px 12px;\n    font-size: 12px;\n    color: @custom-color-1;\n    .border-radius(0);\n    [class*=' ico-'],\n    [class^='ico-'] {\n      font-size: 16px;\n      display: block;\n      float: none;\n      clear: both;\n    }\n    &:hover {\n      background-color: darken(@gray-lightest, 2%);\n      .arrow-right {\n        border-left-color: darken(@gray-lightest, 2%);\n      }\n      .arrow-right-n1,\n      .arrow-right-n2 {\n        border-right-color: darken(@gray-lightest, 2%);\n      }\n    }\n    &:active,\n    &.active,\n    &:focus {\n      color: @custom-color-1;\n      box-shadow: none;\n      background-color: darken(@gray-lightest, 6%);\n      .arrow-right {\n        border-left-color: darken(@gray-lightest, 6%);\n      }\n    }\n    .arrow-right {\n      width: 0;\n      height: 0;\n      border-top: (@header-height / 2) solid transparent;\n      border-bottom: (@header-height / 2) solid transparent;\n      border-left: 14px solid @gray-lightestest;\n      float: right;\n      position: absolute;\n      right: -13px;\n      top: 0;\n      z-index: 10;\n      &.arrow-right-border {\n        right: -14px;\n        border-left-color: darken(@gray-lightest, 10%);\n        z-index: 9;\n      }\n    }\n    &.btn-lg {\n      font-size: 14px;\n      padding: 7px 13px 14px 20px;\n      .caret {\n        margin: auto 0 auto 8px;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        right: 8px;\n        font-size: 24px;\n        border-left-width: 5px;\n        border-right-width: 5px;\n        border-top-width: 5px;\n        opacity: 0.7;\n      }\n      .badge {\n        margin: 0 10px 0 0;\n        top: 1px;\n      }\n    }\n  }\n  &.open .dropdown-toggle {\n    .box-shadow(none);\n    background-color: lighten(@gray-lightest, 2%);\n    color: @custom-color-1;\n    .arrow-right {\n      border-left: 14px solid lighten(@gray-lightest, 2%);\n      &.arrow-right-border {\n        border-left-color: darken(@gray-lightestest, 8%);\n      }\n    }\n  }\n}\n","// Vendor Prefixes\n//\n// All vendor mixins are deprecated as of v3.2.0 due to the introduction of\n// Autoprefixer in our Gruntfile. They will be removed in v4.\n\n// - Animations\n// - Backface visibility\n// - Box shadow\n// - Box sizing\n// - Content columns\n// - Hyphens\n// - Placeholder text\n// - Transformations\n// - Transitions\n// - User Select\n\n\n// Animations\n.animation(@animation) {\n  -webkit-animation: @animation;\n       -o-animation: @animation;\n          animation: @animation;\n}\n.animation-name(@name) {\n  -webkit-animation-name: @name;\n          animation-name: @name;\n}\n.animation-duration(@duration) {\n  -webkit-animation-duration: @duration;\n          animation-duration: @duration;\n}\n.animation-timing-function(@timing-function) {\n  -webkit-animation-timing-function: @timing-function;\n          animation-timing-function: @timing-function;\n}\n.animation-delay(@delay) {\n  -webkit-animation-delay: @delay;\n          animation-delay: @delay;\n}\n.animation-iteration-count(@iteration-count) {\n  -webkit-animation-iteration-count: @iteration-count;\n          animation-iteration-count: @iteration-count;\n}\n.animation-direction(@direction) {\n  -webkit-animation-direction: @direction;\n          animation-direction: @direction;\n}\n.animation-fill-mode(@fill-mode) {\n  -webkit-animation-fill-mode: @fill-mode;\n          animation-fill-mode: @fill-mode;\n}\n\n// Backface visibility\n// Prevent browsers from flickering when using CSS 3D transforms.\n// Default value is `visible`, but can be changed to `hidden`\n\n.backface-visibility(@visibility){\n  -webkit-backface-visibility: @visibility;\n     -moz-backface-visibility: @visibility;\n          backface-visibility: @visibility;\n}\n\n// Drop shadows\n//\n// Note: Deprecated `.box-shadow()` as of v3.1.0 since all of Bootstrap's\n// supported browsers that have box shadow capabilities now support it.\n\n.box-shadow(@shadow) {\n  -webkit-box-shadow: @shadow; // iOS <4.3 & Android <4.1\n          box-shadow: @shadow;\n}\n\n// Box sizing\n.box-sizing(@boxmodel) {\n  -webkit-box-sizing: @boxmodel;\n     -moz-box-sizing: @boxmodel;\n          box-sizing: @boxmodel;\n}\n\n// CSS3 Content Columns\n.content-columns(@column-count; @column-gap: @grid-gutter-width) {\n  -webkit-column-count: @column-count;\n     -moz-column-count: @column-count;\n          column-count: @column-count;\n  -webkit-column-gap: @column-gap;\n     -moz-column-gap: @column-gap;\n          column-gap: @column-gap;\n}\n\n// Optional hyphenation\n.hyphens(@mode: auto) {\n  word-wrap: break-word;\n  -webkit-hyphens: @mode;\n     -moz-hyphens: @mode;\n      -ms-hyphens: @mode; // IE10+\n       -o-hyphens: @mode;\n          hyphens: @mode;\n}\n\n// Placeholder text\n.placeholder(@color: @input-color-placeholder) {\n  &::-moz-placeholder           { color: @color;   // Firefox\n                                  opacity: 1; } // See https://github.com/twbs/bootstrap/pull/11526\n  &:-ms-input-placeholder       { color: @color; } // Internet Explorer 10+\n  &::-webkit-input-placeholder  { color: @color; } // Safari and Chrome\n}\n\n// Transformations\n.scale(@ratio) {\n  -webkit-transform: scale(@ratio);\n      -ms-transform: scale(@ratio); // IE9 only\n       -o-transform: scale(@ratio);\n          transform: scale(@ratio);\n}\n.scale(@ratioX; @ratioY) {\n  -webkit-transform: scale(@ratioX, @ratioY);\n      -ms-transform: scale(@ratioX, @ratioY); // IE9 only\n       -o-transform: scale(@ratioX, @ratioY);\n          transform: scale(@ratioX, @ratioY);\n}\n.scaleX(@ratio) {\n  -webkit-transform: scaleX(@ratio);\n      -ms-transform: scaleX(@ratio); // IE9 only\n       -o-transform: scaleX(@ratio);\n          transform: scaleX(@ratio);\n}\n.scaleY(@ratio) {\n  -webkit-transform: scaleY(@ratio);\n      -ms-transform: scaleY(@ratio); // IE9 only\n       -o-transform: scaleY(@ratio);\n          transform: scaleY(@ratio);\n}\n.skew(@x; @y) {\n  -webkit-transform: skewX(@x) skewY(@y);\n      -ms-transform: skewX(@x) skewY(@y); // See https://github.com/twbs/bootstrap/issues/4885; IE9+\n       -o-transform: skewX(@x) skewY(@y);\n          transform: skewX(@x) skewY(@y);\n}\n.translate(@x; @y) {\n  -webkit-transform: translate(@x, @y);\n      -ms-transform: translate(@x, @y); // IE9 only\n       -o-transform: translate(@x, @y);\n          transform: translate(@x, @y);\n}\n.translate3d(@x; @y; @z) {\n  -webkit-transform: translate3d(@x, @y, @z);\n          transform: translate3d(@x, @y, @z);\n}\n.rotate(@degrees) {\n  -webkit-transform: rotate(@degrees);\n      -ms-transform: rotate(@degrees); // IE9 only\n       -o-transform: rotate(@degrees);\n          transform: rotate(@degrees);\n}\n.rotateX(@degrees) {\n  -webkit-transform: rotateX(@degrees);\n      -ms-transform: rotateX(@degrees); // IE9 only\n       -o-transform: rotateX(@degrees);\n          transform: rotateX(@degrees);\n}\n.rotateY(@degrees) {\n  -webkit-transform: rotateY(@degrees);\n      -ms-transform: rotateY(@degrees); // IE9 only\n       -o-transform: rotateY(@degrees);\n          transform: rotateY(@degrees);\n}\n.perspective(@perspective) {\n  -webkit-perspective: @perspective;\n     -moz-perspective: @perspective;\n          perspective: @perspective;\n}\n.perspective-origin(@perspective) {\n  -webkit-perspective-origin: @perspective;\n     -moz-perspective-origin: @perspective;\n          perspective-origin: @perspective;\n}\n.transform-origin(@origin) {\n  -webkit-transform-origin: @origin;\n     -moz-transform-origin: @origin;\n      -ms-transform-origin: @origin; // IE9 only\n          transform-origin: @origin;\n}\n\n\n// Transitions\n\n.transition(@transition) {\n  -webkit-transition: @transition;\n       -o-transition: @transition;\n          transition: @transition;\n}\n.transition-property(@transition-property) {\n  -webkit-transition-property: @transition-property;\n          transition-property: @transition-property;\n}\n.transition-delay(@transition-delay) {\n  -webkit-transition-delay: @transition-delay;\n          transition-delay: @transition-delay;\n}\n.transition-duration(@transition-duration) {\n  -webkit-transition-duration: @transition-duration;\n          transition-duration: @transition-duration;\n}\n.transition-timing-function(@timing-function) {\n  -webkit-transition-timing-function: @timing-function;\n          transition-timing-function: @timing-function;\n}\n.transition-transform(@transition) {\n  -webkit-transition: -webkit-transform @transition;\n     -moz-transition: -moz-transform @transition;\n       -o-transition: -o-transform @transition;\n          transition: transform @transition;\n}\n\n\n// User select\n// For selecting text on the page\n\n.user-select(@select) {\n  -webkit-user-select: @select;\n     -moz-user-select: @select;\n      -ms-user-select: @select; // IE10+\n          user-select: @select;\n}\n","@import 'custom-variables.less';\n\n// ================ Shadow dom ==============\n.secondary-nav {\n  &::-webkit-scrollbar {\n    width: 8px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n    margin-bottom: 30px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    border-radius: 6px;\n    background-color: rgba(0, 0, 0, 0.25);\n  }\n}\n\n@media (min-height: 720px) {\n  .secondary-nav {\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n}\n\n@media (min-height: 425px) {\n  .secondary-nav.report-secondary-nav {\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n}\n\n// ====================  Base Stylings ======================\n:focus {\n  outline: transparent auto 0;\n}\n\nhtml {\n  height: 100%;\n}\n\nbody {\n  height: 100%;\n  background: #ffffff;\n  font-weight: 400;\n  color: @custom-color-1;\n  font-family: @font-family-sans-serif;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: @custom-color-1;\n  line-height: 1.4em;\n}\n\nh1,\nh2,\nh3 {\n  text-rendering: auto;\n}\n\nh2 {\n  font-size: 24px;\n  margin-bottom: 15px;\n}\n\nh4 {\n  font-weight: 600;\n  margin-bottom: 10px;\n}\n\nh5 {\n  line-height: 1.1em;\n  font-weight: 600;\n  color: inherit;\n}\n\na {\n  color: @link-color;\n\n  &:focus {\n    text-decoration: none;\n  }\n\n  &:hover {\n    color: lighten(@link-color, 5%);\n    text-decoration: none;\n  }\n}\n\n.desaturate {\n  .desaturate-image();\n}\n\nhr {\n  border-top: 1px solid #ddd;\n}\n\n// ------------------- Form elements-------------------\ntextarea,\nselect,\n.form-control,\ninput[type='text'],\ninput[type='password'],\ninput[type='datetime'],\ninput[type='datetime-local'],\ninput[type='date'],\ninput[type='month'],\ninput[type='time'],\ninput[type='week'],\ninput[type='number'],\ninput[type='email'],\ninput[type='url'],\ninput[type='search'],\ninput[type='tel'],\ninput[type='color'],\n.uneditable-input {\n  .placeholder(#aaa);\n}\n\n.form-group-lg select[multiple].form-control {\n  padding: 0;\n\n  // border-radius: 0;\n  option {\n    border-bottom: 1px dashed #ddd;\n    padding: 10px 15px;\n\n    &:hover {\n      background-color: lighten(@custom-color-4, 30%);\n    }\n\n    &:active,\n    &:focus,\n    &:checked {\n      background-color: @custom-color-4;\n    }\n  }\n}\n\ntextarea:focus,\nselect:focus,\n.form-control:focus,\n.form-control.focused,\ninput[type='text']:focus,\ninput[type='password']:focus,\ninput[type='datetime']:focus,\ninput[type='datetime-local']:focus,\ninput[type='date']:focus,\ninput[type='month']:focus,\ninput[type='time']:focus,\ninput[type='week']:focus,\ninput[type='number']:focus,\ninput[type='email']:focus,\ninput[type='url']:focus,\ninput[type='search']:focus,\ninput[type='tel']:focus,\ninput[type='color']:focus,\n.uneditable-input:focus {\n  border-color: #66afe9;\n  @shadow:\n    inset 0 1px 1px rgba(0, 0, 0, 0.075),\n    0 0 8px rgba(102, 175, 233, 0.6);\n  .box-shadow(@shadow);\n  outline: 0;\n  outline: thin dotted \\9;\n  /* IE6-9 */\n  .placeholder(#ccc);\n}\n\n// remove micro-spinner from type=date and type=number\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button,\ninput[type='datetime']::-webkit-inner-spin-button,\ninput[type='datetime']::-webkit-outer-spin-button,\ninput[type='datetime-local']::-webkit-inner-spin-button,\ninput[type='datetime-local']::-webkit-outer-spin-button,\ninput[type='date']::-webkit-inner-spin-button,\ninput[type='date']::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n// remove micro-spinner from type=date and type=number\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button,\ninput[type='date']::-webkit-inner-spin-button,\ninput[type='date']::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\nlegend {\n  margin-bottom: 15px;\n}\n\n.has-error {\n  position: relative;\n}\n\n.has-error .form-control.focused {\n  border-color: #843534;\n  -webkit-box-shadow:\n    inset 0 1px 1px rgba(0, 0, 0, 0.075),\n    0 0 6px #ce8483;\n  box-shadow:\n    inset 0 1px 1px rgba(0, 0, 0, 0.075),\n    0 0 6px #ce8483;\n}\n\nbody #primary-container {\n  background-color: @gray-lightestest;\n  height: auto;\n  min-height: 100vh;\n\n  ::-webkit-input-placeholder {\n    color: #aaa;\n  }\n\n  .inverse-placeholder {\n    ::-webkit-input-placeholder {\n      color: #fff;\n    }\n\n    &:hover {\n      ::-webkit-input-placeholder {\n        color: @gray-light;\n      }\n    }\n  }\n\n  .sidebar-placeholder {\n    &::-webkit-input-placeholder {\n      color: #857e79;\n    }\n  }\n}\n\n.form-horizontal {\n  textarea {\n    height: 80px;\n  }\n}\n\n.input-xsmall {\n  width: 60px;\n}\n\n// ===== Search box styling ====\n.search-jobs.topmost-search-job-container {\n  display: inline-block;\n  width: 210px;\n  float: left;\n}\n\n.form-search .form-group {\n  margin-top: 8px;\n  margin-bottom: 8px;\n  border-radius: 30px;\n  border: 1px solid @gray-lighter;\n\n  &:focus-within {\n    box-shadow:\n      inset 0 1px 1px rgba(0, 0, 0, 0.075),\n      0 0 8px rgba(102, 175, 233, 0.6);\n    border-color: #66afe9;\n  }\n\n  .form-control.search-query {\n    -webkit-appearance: none;\n    outline: none;\n    box-shadow: none;\n    padding-left: 0;\n    padding-right: 3px;\n    border-right-width: 0;\n    border-left-width: 0;\n    padding-top: 7px;\n    padding-bottom: 7px;\n    border: none;\n    font-size: 16px;\n  }\n\n  .input-group-addon {\n    box-shadow: none;\n    background-color: white;\n    font-size: 18px;\n    color: #777;\n    padding-top: 10px;\n    min-width: initial;\n    width: 30px;\n    border: none;\n\n    &.input-group-addon-clickable {\n      &:hover {\n        color: #000;\n        // background-color: @gray-lightestest;\n        cursor: pointer;\n      }\n    }\n\n    &:first-child {\n      border-radius: 30px 0 0 30px;\n      border-right: none;\n    }\n\n    &:last-child {\n      border-radius: 0 30px 30px 0;\n    }\n  }\n}\n\n.form-group {\n  height: auto !important;\n  .transition(all 0.3s);\n\n  &.success {\n    -webkit-transition: border-color 0.4s ease-in-out;\n    -moz-transition: border-color 0.4s ease-in-out;\n    -o-transition: border-color 0.4s ease-in-out;\n    transition: border-color 0.4s ease-in-out;\n  }\n}\n\n.form-group-lg,\n.form-group-lg {\n  .form-control-static {\n    padding-top: 12px;\n    padding-bottom: 7px;\n  }\n\n  .btn-group > .btn {\n    padding: 12px 11px;\n    min-width: 47px;\n  }\n}\n\nlabel {\n  font-weight: 600;\n  padding: 0.3em 0.6em 0.3em;\n\n  small {\n    color: @gray-light;\n  }\n}\n\n.label.label-danger {\n  margin-top: 2px;\n  color: #ffffff;\n}\n\n.label-touch {\n  cursor: pointer;\n\n  &:hover {\n    background-color: @custom-color-3;\n  }\n}\n\n.label {\n  color: @custom-color-1;\n  font-weight: 400;\n}\n\n.input-group-addon {\n  background-color: lighten(desaturate(@custom-color-3, 5%), 2%);\n  min-width: 40px;\n  padding: 6px 8px;\n  color: @gray-light;\n  font-size: 1em !important;\n}\n\n::selection {\n  background-color: #f2a814;\n  color: #000;\n}\n\n// Used to style complex field sets with two rows like in HVAC Dual system\n.form-group.form-group-two-rows {\n  label.control-label {\n    padding-top: inherit;\n  }\n}\n\n// Labels that accompany collapsable two rows field set\n.label-secondary {\n  font-size: 0.85em;\n  text-transform: uppercase;\n  margin-top: 10px;\n}\n\n// Checkbox custom:\n// checkbox for selected jobs\n.jl .snugg-select {\n  height: 74px;\n}\n\n.snugg-select {\n  width: 36px;\n  height: 46px;\n  position: relative;\n  float: left;\n  cursor: pointer;\n\n  > span {\n    border-radius: 2px;\n    width: 20px;\n    height: 20px;\n    line-height: 1.2em;\n    display: block;\n    cursor: pointer;\n    margin: auto;\n    font-size: 18px;\n    border: 1px solid rgba(0, 0, 0, 0.3);\n    background: #fff;\n    position: absolute;\n    text-align: center;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    user-select: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    ms-user-select: none;\n\n    &:after {\n      content: '';\n      width: 20px;\n      height: 20px;\n      display: block;\n    }\n  }\n\n  &:hover {\n    background-color: lighten(@custom-color-2, 20%);\n    color: darken(@custom-color-3, 15%);\n\n    span {\n      border-color: @gray;\n\n      &:after {\n        content: '\\2713';\n      }\n    }\n  }\n\n  &:hover:active,\n  &:active,\n  &:focus,\n  &:focus:active {\n    background-color: lighten(@custom-color-2, 20%);\n    color: black;\n\n    span {\n      background: @gray-light;\n\n      &:after {\n        content: '\\2713';\n      }\n    }\n  }\n}\n\n// Select check box\n.snugg-selected .snugg-select {\n  span {\n    color: @gray-dark;\n    background: #fff;\n\n    &:after {\n      content: '';\n    }\n  }\n\n  &:hover {\n    span {\n      color: @gray-light;\n\n      &:after {\n        content: '';\n      }\n    }\n  }\n\n  &:focus,\n  &:focus:active,\n  &:active {\n    span {\n      background: @gray-light;\n      color: @gray;\n    }\n  }\n}\n\n// Selected row\n.snugg-selected {\n  background-color: lighten(@custom-color-4, 44.5%);\n\n  &:nth-child(even) {\n    background-color: lighten(@custom-color-4, 46.5%);\n  }\n}\n\n.table-extra-condensed > tbody > tr > td,\n.table-extra-condensed > thead > tr > th {\n  padding: 5px 2px;\n  font-size: 0.8em;\n  line-height: 100%;\n}\n\ntable.table {\n  th {\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: rgba(0, 0, 0, 0.6);\n    font-size: 0.9em;\n  }\n}\n\ntable.table.table-expansive {\n  th,\n  td {\n    padding: 15px 5px;\n    line-height: 100%;\n    vertical-align: middle;\n  }\n}\n\n.table-striped {\n  > tbody > tr:nth-child(odd) {\n    > td,\n    > th {\n      background-color: lighten(@custom-color-3, 1%);\n    }\n  }\n}\n\n.has-switch:focus {\n  outline: none;\n}\n\n.select-inline {\n  margin-left: 10px;\n  margin-top: 10px;\n}\n\n/* target job form only*/\n\n.form-block {\n  .clearfix();\n  padding-bottom: 30px;\n  margin-bottom: 10;\n}\n\n// ========== Signin form  ==========\n\n.headless-page {\n  margin-top: 50px;\n}\n\n.container-flex {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n}\n\n.signin-container {\n  background-color: darken(@custom-color-3, 4%);\n  position: relative;\n  z-index: 0;\n  min-height: 100vh;\n  min-width: 320px;\n\n  h1 {\n    font-size: 24px;\n    font-weight: 600;\n  }\n\n  h2 {\n    font-size: 18px;\n    font-weight: 600;\n  }\n\n  h3 {\n    font-weight: 400;\n  }\n\n  .signin-form {\n    padding: 25px 30px 10px;\n    margin-bottom: 30px;\n    border: 1px solid #dddddd;\n    background-color: #fff;\n    border-radius: 5px;\n    position: relative;\n\n    &:after {\n      content: '';\n      position: absolute;\n      z-index: -1;\n      .box-shadow(0 5px 40px rgba(0, 0, 0, 0.4));\n      bottom: 0;\n      left: 0;\n      right: 0;\n      top: auto;\n      height: 30px;\n      width: 90%;\n      margin: auto 5%;\n    }\n  }\n\n  .welcome-logo {\n    text-align: center;\n\n    img {\n      margin: 0 auto 10px;\n    }\n  }\n}\n\n// ========== End signin form  ==========\n\n// ========== OTP screen  ==========\n.otp-form {\n  margin-top: 26px;\n}\n\n.opt-login-link-section {\n  margin-top: 10px;\n  margin-bottom: 23px;\n}\n\n.otp-title {\n  color: #333333;\n  font-size: 20px;\n  font-weight: 600;\n}\n\n.otp-title-bottom {\n  height: 43px;\n}\n\n// ========== End OTP screen  ==========\n\n.pointer {\n  cursor: pointer;\n}\n\n.form-wizard {\n  display: table;\n  margin-top: 20px;\n  width: 100%;\n}\n\n.form-wizard span {\n  text-align: center;\n  display: table-cell;\n  color: #ccc;\n  position: relative;\n  width: 25%;\n}\n\n.form-wizard span.completed {\n  color: #666;\n}\n\n.form-wizard i {\n  display: block;\n  font-size: 18px;\n}\n\n.form-wizard label {\n  display: block;\n  font-size: 12px;\n}\n\n.form-wizard span:before,\n.form-wizard span:after {\n  position: absolute;\n  content: '';\n  right: -10px;\n  top: 8px;\n  width: 50%;\n  height: 0;\n  border-bottom: 1px dashed #ccc;\n}\n\n.form-wizard span:before {\n  left: -8px;\n}\n\n.form-wizard span:first-child:before {\n  display: none;\n}\n\n.form-wizard span:last-child:after {\n  display: none;\n}\n\n.otp-secret-input {\n  padding-left: 25px;\n  padding-right: 25px;\n  letter-spacing: 18px;\n  font-family: 'Courier New', monospace;\n  font-weight: bold;\n  width: 100% !important;\n  box-shadow: none !important;\n  font-size: 30px;\n  height: auto;\n}\n\n.otp-form {\n  max-width: 490px;\n}\n\n@media (max-width: 767px) {\n  .otp-form {\n    // padding: 15px;\n    max-width: 250px;\n  }\n}\n\n.secret-key-input {\n  height: 46px;\n  font-size: 30px;\n  letter-spacing: 30px;\n}\n\n.dashes-text {\n  text-align: center;\n  font-size: 30px;\n  font-weight: 600;\n  letter-spacing: 3px;\n  border-style: dashed;\n  border-radius: 11px;\n  line-height: 42px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  border: 2px dashed #bcb8b0;\n}\n\n.phone-format-number {\n  letter-spacing: 1px;\n}\n\n.alert-error-link {\n  font-weight: bold;\n  color: #6c3636 !important;\n}\n\n.phone-number-input {\n  height: 46px;\n  margin-top: 72px;\n  font-size: 17px;\n  letter-spacing: 7px;\n}\n\n.form-control.input-header,\n.form-group-lg .form-control {\n  .input-header {\n    border-top: none;\n    border-left: none;\n    border-right: none;\n    border-bottom: @link-color dashed 1px;\n    box-shadow: none;\n    padding: 10px 0 0;\n    line-height: inherit;\n    height: auto;\n    border-radius: 0;\n    font-size: 18px;\n    color: #000;\n\n    &:hover {\n      background-color: lighten(@custom-color-2, 18%);\n    }\n\n    &:focus {\n      background-color: inherit;\n      outline: none;\n      box-shadow: none;\n    }\n  }\n}\n\n.form-group-lg input[type='date'].form-control {\n  line-height: 2.5em;\n}\n\n.back-link {\n  color: #333333;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 22px;\n  margin-bottom: 10px;\n  display: inline-block;\n\n  &:hover {\n    color: #333333;\n  }\n}\n\n.back-icon {\n  font-size: 21px;\n  float: left;\n  margin-right: 11px;\n}\n\n// ====================  Custom Bootstrap Elements ====================\n\n// Buttons\n\n// the disabled mixin overrides bootstrap defaults\n.disabled() {\n  color: @gray-light !important;\n  background-color: @gray-lighter !important;\n  background-image: none !important;\n  opacity: 0.8 !important;\n  cursor: not-allowed;\n  border-color: transparent !important;\n  box-shadow: none !important;\n}\n\nbutton[disabled] {\n  .disabled();\n}\n\n.btn {\n  border-radius: 4px;\n  // Remove next three lines to cancel flat effect\n  background-image: none;\n  border: none;\n  .box-shadow(none);\n  background-color: darken(@gray-lighter, 3%);\n  box-sizing: border-box;\n  vertical-align: middle;\n  outline: none;\n  outline-offset: 0;\n\n  &:focus,\n  &:active:focus,\n  &:active,\n  &.active,\n  &.active:focus,\n  &:hover:focus {\n    outline: none;\n    outline-offset: 0;\n  }\n\n  &:hover {\n    background-color: darken(@gray-lighter, 8%);\n  }\n\n  &.disabled,\n  &[disabled] {\n    .disabled();\n  }\n\n  &.active[disabled] {\n    .disabled();\n    background-color: darken(@gray-lighter, 8%) !important;\n    color: darken(@gray-light, 3%) !important;\n  }\n}\n\n// Button sizes\n.btn-mini {\n  line-height: 1em;\n  padding: 6px;\n\n  [class^='icofont-'],\n  [class*=' icofont-'] {\n    font-size: 20px;\n  }\n}\n\n.btn-md {\n  padding: 15px 6px;\n  font-size: 12px;\n  line-height: 1.33;\n}\n\n.btn-lg {\n  font-size: 16px;\n  padding: 15px;\n}\n\n.btn-group-lg > .btn {\n  font-size: 16px;\n}\n\n.btn-xlarge {\n  padding: 15px 25px;\n  font-size: 24px;\n  .border-radius(3px);\n}\n\n// Button themes\n.btn-brand-1,\n.btn-primary {\n  background: #ff7f00; //#ff9c00; //\n  border: none;\n  background-image: linear-gradient(10deg, #f96b00 0%, #ffb100 100% 100%);\n  // background-image: linear-gradient(200deg, rgba(255, 187, 62, 0.71) 0%, rgba(212, 0, 0, 0.15) 79%);\n  color: #fff;\n  font-weight: 600;\n\n  &:hover {\n    background-image: linear-gradient(10deg, #f47516 0%, #ffbc22 100% 100%);\n    // background-image: linear-gradient(202deg, rgba(255,255,255,0.17) 0%, rgba(212,0,0,0.25) 79%);\n    color: #fff;\n  }\n\n  &:active,\n  &:focus {\n    background: #ff7f00;\n    background-image: linear-gradient(10deg, #e26202 0%, #ffb000 100% 100%);\n    color: #fff;\n  }\n\n  &.disabled,\n  &[disabled] {\n    .disabled();\n  }\n}\n\n.btn-brand-2 {\n  .button-3d(#fff; @custom-color-1; transparent);\n  text-shadow: none; //0 -1px 0 rgba(255,255,255, 0.6);\n  font-weight: normal;\n\n  &.disabled,\n  &[disabled] {\n    .disabled();\n  }\n}\n\n.btn-brand-3 {\n  .button-variant(desaturate(darken(@custom-color-3, 30%), 10%); rgba(0, 0, 0, 0.03); desaturate(darken(@custom-color-3, 15%), 10%));\n\n  &.disabled,\n  &[disabled] {\n    .disabled();\n  }\n\n  &:active,\n  .active {\n    .box-shadow(none);\n  }\n}\n\n.btn-brand-4 {\n  background: #ff7f00;\n  background-image: linear-gradient(208deg, #ffba00 0%, #ff8f2a 100%);\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.5);\n  color: @custom-color-1;\n  border: none;\n\n  &:hover {\n    background: #ff7f00;\n    background-image: linear-gradient(208deg, #f9c539 0%, #f99c47 100%);\n  }\n\n  &:active,\n  &:focus {\n    background-image: linear-gradient(208deg, #f0b413 0%, #ee8321 100%);\n  }\n\n  &.disabled,\n  &[disabled] {\n    .disabled();\n  }\n}\n\n.btn-brand-5 {\n  // light light gray\n  .button-variant(@custom-color-1; @gray-lightestest; desaturate(darken(@gray-lightestest, 15%), 10%));\n\n  &.disabled,\n  &[disabled] {\n    .disabled();\n  }\n\n  &:active,\n  .active {\n    .box-shadow(none);\n    background-color: darken(@custom-color-3, 20%);\n  }\n}\n\n// Specialty Buttons\n.btn-back {\n  padding: 9px 10px;\n  position: relative;\n  min-width: 80px;\n  width: auto;\n  margin-left: 15px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-top-right-radius: 6px;\n  border-bottom-right-radius: 6px;\n  background-color: lighten(@custom-color-1, 3%);\n  border-color: lighten(@custom-color-1, 3%);\n\n  &:hover,\n  &:active,\n  &:focus {\n    background-color: darken(@custom-color-1, 5%);\n    border-color: darken(@custom-color-1, 5%);\n  }\n\n  &:after,\n  &:before,\n  &:after:active,\n  &:before:active {\n    content: '';\n    position: absolute;\n    top: 50%;\n    margin-top: -19px;\n    border-top: 20px solid transparent;\n    border-bottom: 19px solid transparent;\n    border-right: 1em solid;\n    left: -0.98em;\n    padding-top: 0;\n  }\n\n  &:before {\n    z-index: 2;\n    border-right-color: inherit;\n  }\n\n  &:hover:before {\n    border-right-color: inherit;\n  }\n}\n\n.btn-delete {\n  background-color: inherit;\n  color: red;\n  margin-left: 30px;\n  margin-top: 3px;\n\n  &:hover {\n    background-color: red;\n    color: white;\n  }\n}\n\n.btn.btn-message {\n  background-image: none;\n\n  &:hover,\n  &:active,\n  &.active,\n  &:focus {\n    box-shadow: none;\n    background-image: none;\n    cursor: default;\n  }\n\n  &.success {\n    background-color: @state-success-bg;\n    color: @state-success-text;\n    font-size: 1.2em;\n    border: 1px solid @state-success-border;\n  }\n}\n\n// ------------ radio btn-groups\n.btn-group {\n  > .btn {\n    cursor: pointer;\n    background-color: white;\n    border: 1px solid @gray-lightish;\n    color: @gray;\n\n    &:hover {\n      background-color: @gray-lightest;\n    }\n  }\n\n  > .btn + .btn {\n    border-left: 1px solid @gray-lightish;\n  }\n\n  > .btn:first-child {\n    border-right: 1px solid @gray-lightish;\n  }\n\n  > .btn.active {\n    text-shadow: none;\n    .box-shadow(inset 0 2px 0 rgba(0, 0, 0, 0.5));\n    color: black;\n    // border-top-color: @gray;\n    background-color: @gray-lighter;\n  }\n}\n\n.report-toggles .btn-group {\n  > .btn {\n    background: white;\n    color: @gray-light;\n\n    &:hover {\n      background-color: @gray-lightest;\n      color: @gray-dark;\n    }\n  }\n\n  > .btn.active {\n    background-color: @gray;\n    color: @gray-lightestest;\n    font-weight: 600;\n    cursor: default;\n    border-color: transparent;\n    box-shadow: inset -1px -1px 0 rgba(0, 0, 0, 0.3);\n  }\n\n  &.btn-group-sm {\n    padding-top: 6px;\n  }\n}\n\n// -----------  Tabs ------------\n.nav-tabs a:hover,\n.nav-tabs > .active > a:hover,\n.nav-tabs > .active > a:focus {\n  color: @custom-color-1;\n}\n\n.nav-tabs > li {\n  margin-bottom: -2px;\n\n  > a {\n    &:hover {\n      background-color: darken(@custom-color-3, 5%);\n      border-bottom: white;\n    }\n\n    &:active {\n      background-color: darken(@custom-color-3, 8%);\n      border-bottom: white;\n    }\n\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\n.nav.nav-tabs {\n  li > a {\n    padding: 10px;\n  }\n}\n\n.tab-content {\n  margin-top: 5px;\n}\n\n// -----------  Pills for Bootstrap ------------\n.nav-pills > li {\n  margin-bottom: -2px;\n  border-radius: 0;\n\n  &.active {\n    > a {\n      border-bottom: 3px solid @custom-color-4;\n      background-color: transparent;\n      color: @custom-color-1;\n      text-shadow:\n        0px 0px 0px black,\n        0px 0px 0px black,\n        0px 0px 0px black;\n\n      &:hover {\n        background-color: transparent;\n        color: @custom-color-1;\n        border-bottom: 3px solid @custom-color-4;\n      }\n\n      &:focus {\n        background-color: transparent;\n        color: @custom-color-1;\n      }\n    }\n  }\n\n  > a {\n    cursor: pointer;\n    border-bottom: 3px solid transparent;\n    border-radius: 0;\n    background-color: transparent;\n    color: @custom-color-1;\n    font-size: 15px;\n\n    &:hover {\n      background-color: lighten(@custom-color-3, 2%);\n      color: @custom-color-1;\n      border-bottom: 3px solid @gray-lightish;\n    }\n\n    &:active {\n      background-color: @custom-color-3;\n      border-bottom: white;\n      border-bottom: 3px solid darken(@custom-color-4, 3%);\n    }\n\n    &:focus {\n      outline: none;\n    }\n  }\n}\n\n.nav.nav-pills {\n  li > a {\n    padding: 10px 14px;\n  }\n}\n\n.tab-content {\n  margin-top: 5px;\n}\n\n// ----------------- Pills like on the job form ----------------\n.pills {\n  margin-bottom: 20px;\n  background-color: @custom-color-3;\n  border: 1px solid desaturate(darken(@custom-color-3, 5%), 10%);\n  border-radius: 4px;\n  overflow: hidden;\n\n  .btn {\n    cursor: pointer;\n    border-radius: 0;\n    background-color: @custom-color-3;\n    color: @custom-color-1;\n    border-right: 1px solid desaturate(darken(@custom-color-3, 5%), 10%);\n    padding: 5px 6px;\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 1em;\n\n    &:focus {\n      outline: none;\n      .box-shadow(none);\n    }\n\n    &:hover {\n      background-color: darken(@gray-lighter, 2%);\n    }\n\n    &:active,\n    &.active {\n      background-color: lighten(@custom-color-1, 10%);\n      // color: saturate(darken(@custom-color-3, 10%), 3%);\n      color: @custom-color-4;\n      font-weight: 400;\n\n      small {\n        color: saturate(darken(@custom-color-3, 25%), 3%);\n      }\n    }\n\n    &:nth-child(4),\n    &:nth-child(4).active {\n      border-right: none;\n    }\n\n    small {\n      color: @gray;\n      display: block;\n      font-size: 0.85em;\n    }\n\n    &.active {\n      .box-shadow(inset 0px 1px 1px rgba(0, 0, 0, 0.6));\n      border-right-color: desaturate(darken(@custom-color-3, 25%), 10%);\n    }\n  }\n}\n\n// -----------------  Badges -------------------\n.badge {\n  background-color: darken(@gray-lightest, 7%);\n  color: lighten(@custom-color-1, 10%);\n  margin-left: 5px;\n  font-weight: 600;\n  .border-radius(5px);\n\n  &.badge-inverse {\n    background-color: rgba(0, 0, 0, 0.8);\n    color: #fff;\n  }\n\n  &.badge-header {\n    background-color: rgba(217, 0, 0, 0.8);\n    color: #fff;\n    position: absolute;\n    top: 14px;\n    right: 24%;\n    padding: 1px 4px;\n    font-size: 11px;\n  }\n\n  .badge-left-tip {\n    width: 0;\n    height: 0;\n    border-top: 4px solid transparent;\n    border-bottom: 4px solid transparent;\n    border-right: 6px solid darken(@gray-lightest, 7%);\n    position: absolute;\n    left: -5px;\n    bottom: 0;\n    top: 0;\n    margin: auto;\n  }\n}\n\n.label.label-title {\n  color: @custom-color-1;\n  font-weight: 700;\n  text-align: left;\n  text-shadow: none;\n  display: block;\n  margin-bottom: 5px;\n  font-size: 1em;\n  padding: 4px 10px 2px 0;\n  border-radius: 0;\n}\n\n// ----------- Well and dividers--------\n.well {\n  background-color: lighten(@custom-color-3, 5%);\n  // padding: 20px 20px 40px;\n  .box-shadow(rgba(0, 0, 0, 0.1) 0px 0px 6px inset);\n  .border-radius(4px);\n  .clearfix();\n}\n\n.title-divider {\n  position: relative;\n  text-align: center;\n  font-weight: 600;\n  margin-top: 10px;\n  margin-bottom: 10px;\n\n  span {\n    padding: 0 15px;\n    position: relative;\n    color: @gray-dark;\n    text-transform: uppercase;\n    font-size: 11;\n    font-weight: 700;\n  }\n\n  &:before {\n    display: block;\n    content: '';\n    height: 1px;\n    background: -webkit-gradient(\n      linear,\n      0 0,\n      100% 0,\n      from(rgba(0, 0, 0, 0)),\n      color-stop(0.5, #999),\n      color-stop(0.5, #999),\n      to(rgba(0, 0, 0, 0))\n    );\n    background: -webkit-linear-gradient(\n      left,\n      rgba(0, 0, 0, 0),\n      #999,\n      #999,\n      rgba(0, 0, 0, 0)\n    );\n    background: -moz-linear-gradient(\n      left,\n      rgba(0, 0, 0, 0),\n      #999,\n      #999,\n      rgba(0, 0, 0, 0)\n    );\n    background: -o-linear-gradient(\n      left,\n      rgba(0, 0, 0, 0),\n      #999,\n      #999,\n      rgba(0, 0, 0, 0)\n    );\n    background: linear-gradient(\n      left,\n      rgba(0, 0, 0, 0),\n      #999,\n      #999,\n      rgba(0, 0, 0, 0)\n    );\n    position: absolute;\n    top: 50%;\n    width: 100%;\n  }\n}\n\n// --------------- Style the inlays ------------------\n.inlay {\n  max-height: 0;\n  min-height: 0;\n  overflow: hidden;\n  -webkit-transition: max-height 0.5s cubic-bezier(0, 1.05, 0, 1);\n  transition: max-height 0.5s cubic-bezier(0, 1.05, 0, 1);\n  width: 100%;\n\n  &.inlay-open {\n    -webkit-transition: max-height 1s cubic-bezier(0.1, 1.05, 0, 1);\n    transition: max-height 1s cubic-bezier(0.1, 1.05, 0, 1);\n    max-height: 3000px;\n  }\n\n  &.inlay-open-60 {\n    max-height: 60px;\n    -webkit-transition: max-height 0.2s ease-in-out;\n    transition: max-height 0.2s ease-in-out;\n  }\n}\n\n// ----------------  Style dark version of bootstrap popover ------------------\n.popover {\n  // displaying as block because React deals with this differently.\n  display: block;\n  font-size: 13px;\n  z-index: 1061;\n\n  ul {\n    padding-left: 15px;\n  }\n\n  &.popover-field {\n    z-index: 1070;\n\n    &.bottom {\n      position: relative;\n      top: -3px !important;\n      left: 0 !important;\n      max-width: none;\n      width: 100%;\n    }\n  }\n\n  &.popover-error {\n    background-color: rgba(194, 51, 51, 0.85); //#C95150\n    border-color: rgba(194, 51, 51, 0.85);\n    // background-color: rgba(227, 49, 43, 0.85);\n    // border-color: rgba(227, 49, 43, 0.85);\n    z-index: 19;\n    color: rgba(255, 255, 255, 0.8);\n    min-height: 46px;\n    // min-width: 220px;\n    display: flex !important;\n    align-items: center;\n\n    &.popover-compact {\n      min-width: 200px;\n\n      .popover-content {\n        padding: 3px 6px;\n        font-size: 12px;\n      }\n    }\n  }\n\n  &.popover-error,\n  &.popover-error-and-content {\n    &.right > .arrow:after {\n      border-right-color: #c95150;\n    }\n\n    &.bottom {\n      > .arrow:after {\n        border-bottom-color: #c95150;\n      }\n    }\n\n    &.right > .arrow {\n      top: 20px !important;\n    }\n  }\n}\n\n.popover-dark {\n  background: @arrow-box-color;\n  color: @gray-lighter;\n\n  .popover-title {\n    background: @arrow-box-color;\n    border: darken(@arrow-box-color, 5%);\n    color: #cdcdcd;\n    font-size: 18px;\n  }\n\n  &.left {\n    .arrow {\n      border-left-color: @arrow-box-color;\n\n      &:after {\n        border-left-color: transparent;\n      }\n    }\n  }\n\n  &.right {\n    .arrow {\n      border-right-color: @arrow-box-color;\n\n      &:after {\n        border-right-color: transparent;\n      }\n    }\n  }\n\n  .nav-pills {\n    font-size: 16px;\n  }\n}\n\n// ------------------- Bootstrap components overrides -----------------\n\n.nav-pills.nav-pills-popover {\n  .box-shadow(0 4px 10px @custom-color-3);\n  z-index: 1;\n  position: relative;\n\n  li {\n    width: 50%;\n    margin: 0;\n\n    &:first-child {\n      > a {\n        border-top-left-radius: 4px;\n        border-bottom-left-radius: 4px;\n      }\n    }\n\n    &:last-child {\n      > a {\n        border-top-right-radius: 4px;\n        border-bottom-right-radius: 4px;\n      }\n    }\n\n    overflow: hidden;\n\n    & + li {\n      margin: 0;\n    }\n\n    > a {\n      border-radius: 0;\n      text-align: center;\n      color: @custom-color-1;\n      padding: 15px 20px;\n      font-weight: 600;\n      font-size: 13px;\n      line-height: 1em;\n      background-color: darken(@gray-lighter, 2%);\n\n      &:focus {\n        outline: none;\n        .box-shadow(none);\n      }\n\n      &:hover {\n        background-color: darken(@gray-lightest, 7%);\n      }\n\n      &:active,\n      &.active {\n        background-color: lighten(@custom-color-1, 10%);\n        color: @custom-color-4;\n        font-weight: 400;\n      }\n    }\n  }\n\n  > .active {\n    > a,\n    > a:hover,\n    > a:focus {\n      background-color: lighten(@custom-color-1, 10%);\n      color: @custom-color-4;\n      font-weight: 400;\n    }\n  }\n}\n\n.tab-content > .tab-pane,\n.pill-content > .pill-pane {\n  overflow: hidden;\n  padding: 0 10px;\n}\n\n// ====================  BOOTSTRAP 3 AND DEFAULT COMPONENT STYLING OVERRIDES ======================\n.input-lg,\n.form-group-lg textarea.form-control {\n  height: auto;\n  width: 100%;\n}\n\n// ====================  GENERIC UTILITY CLASSES ======================\n\n.break-word {\n  word-wrap: break-word;\n}\n\n.float-right {\n  float: right;\n}\n\n.flex-center {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n\n.font-weight-700 {\n  font-weight: 700;\n}\n\n// ====================  SCAFFOLDING & LAYOUT ======================\n.container-fluid.core-container {\n  margin-left: 0;\n  margin-right: 0;\n  // transform: translateX(@side-left-width);\n  .transition(@push-menu-transition);\n}\n\n.sidebar > .spacer {\n  height: 5px;\n}\n\n#intercom-container .intercom-launcher {\n  right: 10px !important;\n}\n\n#intercom-container .intercom-powered-by {\n  visibility: hidden !important;\n}\n\n.content {\n  margin-top: 0;\n  padding-bottom: 50px;\n  background: white;\n  border: none;\n  position: relative;\n  z-index: auto;\n  min-height: 100vh;\n}\n\n// ====================  Components and Modules ======================\n\n// ----------  Messenger notification styling\n\n.settings-company-logo img {\n  max-height: 164px;\n}\n\n// ------- Header-------\n.header {\n  background-color: @custom-color-1;\n  background-image: none;\n  border-bottom: none;\n\n  .username {\n    color: @gray-lighter;\n    line-height: 1em;\n    margin-right: 10px;\n  }\n\n  .top-nav-buttons {\n    position: relative;\n    margin-right: 20px;\n    float: right;\n    right: 0;\n  }\n\n  .btn-group {\n    margin-top: -5px;\n  }\n}\n\n.content-header-h1 {\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 36px;\n  padding-top: 4px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.content-header {\n  background: @gray-lightestest;\n  border-bottom: 1px solid darken(@gray-lighter, 7%);\n  .clearfix();\n\n  h1 {\n    font-size: 16px;\n    line-height: 24px;\n    font-weight: 400;\n    margin: 5px 0 0;\n\n    &.vertical-center {\n      margin-top: 12px;\n      float: left;\n    }\n  }\n\n  small {\n    font-size: 13px;\n    color: @gray;\n    line-height: 18px;\n    font-weight: 400;\n    margin: 2px 0;\n  }\n\n  h4 {\n    margin-bottom: 10px;\n  }\n\n  .nav {\n    margin: 1px 0 0px;\n  }\n\n  .nav-tabs {\n    border-bottom: none;\n  }\n\n  .header-btn-right {\n    margin-top: 5px;\n  }\n\n  .header-account {\n    line-height: 1.2em;\n    margin-top: 3px;\n    margin-right: 10px;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    width: 260px;\n\n    i {\n      margin-left: 6px;\n    }\n  }\n\n  .app-logo {\n    margin: 13px 2px 0 0;\n    float: left;\n\n    img {\n      width: 93px;\n      height: auto;\n    }\n  }\n\n  .navbar-group {\n    float: none;\n    display: block;\n\n    .header-navbar {\n      width: 25%;\n    }\n  }\n\n  .header-navbar {\n    height: @header-height;\n    position: relative;\n    float: left;\n\n    .nav-tabs > li > a {\n      line-height: (@header-height - 2);\n      margin: auto;\n      padding: 0 15px;\n    }\n\n    .badge {\n      float: right;\n    }\n\n    .btn-error {\n      [class*=' ico-'],\n      [class^='ico-'] {\n        color: #e9001d;\n      }\n    }\n\n    .btn-warning {\n      [class*=' ico-'],\n      [class^='ico-'] {\n        color: @custom-color-4;\n      }\n    }\n  }\n\n  .btn.btn-header {\n    position: relative;\n    border-color: transparent;\n    border-top: none;\n    border-bottom: none;\n    border-right: none;\n    background-color: inherit;\n    border-radius: 0;\n    margin: auto;\n    height: 100%;\n    width: auto;\n    min-width: 60px;\n    padding: 2.5px 12px;\n    font-size: 12px;\n    color: @custom-color-1;\n    .border-radius(0);\n\n    [class*=' ico-'],\n    [class^='ico-'] {\n      font-size: 16px;\n      display: block;\n      float: none;\n      clear: both;\n    }\n\n    &:hover {\n      background-color: darken(@gray-lighter, 2%);\n\n      .arrow-right {\n        border-left-color: darken(@gray-lighter, 2%);\n      }\n\n      .arrow-right-n1,\n      .arrow-right-n2 {\n        border-right-color: darken(@gray-lighter, 2%);\n      }\n    }\n\n    &:active,\n    &.active,\n    &:focus {\n      color: @custom-color-1;\n      box-shadow: none;\n      background-color: darken(@gray-lightest, 7%);\n\n      .arrow-right {\n        border-left-color: darken(@gray-lightest, 7%);\n      }\n    }\n\n    .arrow-right {\n      width: 0;\n      height: 0;\n      border-top: (@header-height / 2) solid transparent;\n      border-bottom: (@header-height / 2) solid transparent;\n      border-left: 14px solid @custom-color-3;\n      float: right;\n      position: absolute;\n      right: -13px;\n      top: 0;\n      z-index: 10;\n\n      &.arrow-right-border {\n        right: -14px;\n        border-left-color: darken(@custom-color-3, 10%);\n        z-index: 9;\n      }\n    }\n\n    &.btn-lg {\n      font-size: 15px;\n      padding: 14px 13px 13px 20px;\n\n      .caret {\n        margin: auto 0 auto 8px;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        right: 10px;\n        font-size: 24px;\n        border-left-width: 5px;\n        border-right-width: 5px;\n        border-top-width: 5px;\n        opacity: 0.7;\n      }\n\n      .badge {\n        margin: 2px 15px 0 10px;\n      }\n    }\n\n    &.btn-side-left-handle {\n      margin: 0 5px 0 -15px;\n      font-size: 18px;\n      color: lighten(@custom-color-1, 30%);\n      padding: 13px 12px 12px;\n    }\n  }\n\n  // ======  END header-navbar styling ===========\n\n  ul.content-header-action {\n    text-align: center;\n    padding: 10px 10px 0px;\n\n    li {\n      .action-text {\n        margin: 5px 0 5px 5px;\n      }\n\n      &.divider {\n        height: 33px;\n      }\n    }\n  }\n\n  /* Style the secondary header bar */\n  &.content-header-2 {\n    border-bottom: 1px solid #fff;\n    background: @gray-lightest;\n\n    .header-navbar {\n      > .btn,\n      > .btn-group > .btn {\n        border-left: none;\n      }\n    }\n  }\n\n  /* Style header metrics like the ones on the refine screen */\n  .header-metrics {\n    display: flex;\n    justify-content: flex-end;\n    padding-top: 3px;\n    padding-bottom: 3px;\n\n    .header-metric {\n      text-align: right;\n      margin-right: 20px;\n\n      &:last-child {\n        margin-right: 0;\n      }\n\n      small {\n        display: block;\n        float: none;\n        clear: both;\n        color: @gray-light;\n        font-size: 0.8em;\n        margin: 0;\n        line-height: 1.2;\n      }\n    }\n  }\n}\n\n// End header\n\n/// ----------------  SCREEN HEADER Instructions ---------------  ////\n\n.header-instructions {\n  .clearfix();\n  margin: -2px -15px 20px -15px;\n  padding: 15px 15px 10px;\n  // border-bottom: 1px solid #ddd;\n  font-size: 16px;\n  color: #333333;\n  .box-shadow(inset 0 -1px 4px rgba(0, 0, 0, 0.1));\n  background-color: #f5f5f5;\n  font-size: 14px;\n  color: @gray-dark;\n  position: relative;\n\n  h1,\n  h2,\n  h3 {\n    text-rendering: auto;\n    margin-bottom: 0.5em;\n  }\n}\n\n// ------------------  Popover styling\n.popover {\n  z-index: 20;\n\n  &.popover-support {\n    top: auto !important;\n    bottom: 15px !important;\n\n    .arrow {\n      border-right-color: darken(@arrow-box-color, 3%);\n      bottom: 5px;\n      left: -11px;\n      top: auto;\n    }\n  }\n\n  &.popover-settings {\n    top: auto !important;\n    bottom: 0px !important;\n\n    > .arrow {\n      border-right-color: darken(@arrow-box-color, 3%);\n      bottom: 20px;\n      left: -11px;\n      top: auto;\n    }\n  }\n\n  &.popover-leftnav {\n    left: 100%;\n    margin-left: 11px;\n    display: block;\n    z-index: 1063;\n    width: 220px;\n    border-radius: 3px;\n\n    .popover-content {\n      padding: 0;\n    }\n\n    .link-icon {\n      display: block;\n      float: left;\n      margin-right: 10px;\n      background-color: darken(@arrow-box-color, 2%);\n      padding: 10px 12px 6px 8px;\n      height: 100%;\n    }\n\n    .link-label {\n      display: block;\n      padding: 10px;\n      height: 100%;\n    }\n\n    a {\n      height: 45px;\n      padding: 0;\n      font-size: 1em;\n      letter-spacing: 0em;\n      font-weight: 400;\n      display: block;\n      text-align: left;\n      color: #cdcdcd;\n      .transition(all 0.1s);\n\n      &:hover {\n        color: #fff;\n        background-color: darken(@arrow-box-color, 2%);\n\n        .link-icon {\n          background-color: darken(@arrow-box-color, 7%);\n        }\n      }\n\n      &:active {\n        color: @custom-color-4;\n        background-color: lighten(@arrow-box-color, 5%);\n\n        .link-icon {\n          background-color: @arrow-box-color;\n        }\n      }\n    }\n\n    .list-footer {\n      border-top: 1px solid darken(@arrow-box-color, 8%);\n      background-color: darken(@arrow-box-color, 3%);\n      border-bottom: none;\n      font-size: 13px;\n      color: #999;\n      line-height: 1.2em;\n      font-weight: normal;\n      padding: 8px 0 6px 5px;\n      text-align: center;\n      cursor: default;\n    }\n  }\n\n  &.popover-header {\n    // left: auto;\n    top: @header-height;\n    width: 360px;\n    max-width: 360px;\n    // z-index: 1061;\n    // right: 0;\n    background-color: @gray-lightestest;\n    border-radius: 2px;\n    border: 1px solid transparent;\n    box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.4);\n    border-radius: 4px;\n\n    &.popover-debug {\n      max-width: none;\n    }\n\n    &.bottom .arrow {\n      border-bottom-color: darken(@gray-lightestest, 20%);\n\n      &:after {\n        border-bottom-color: @gray-lightestest;\n      }\n    }\n  }\n\n  .popover-scrollable-content {\n    overflow-y: scroll;\n    -webkit-overflow-scrolling: touch;\n  }\n}\n\n// ------------------  Left sidebar\n\n.side-left {\n  position: fixed;\n  z-index: 1062;\n  left: 0;\n  // .transform(translateX(-@side-left-width));\n  overflow: visible;\n  float: left;\n  width: @side-left-width;\n  height: 100%;\n  text-align: center;\n  border: none;\n  background-color: @custom-color-1;\n  background-image: none;\n  .transition(@push-menu-transition);\n\n  .btn-calculate-job {\n    border-radius: 4px;\n\n    &:not(disabled),\n    &:not([disabled]) {\n      .btn-brand-4();\n    }\n\n    &.disabled,\n    &[disabled] {\n      .disabled();\n    }\n\n    cursor: pointer;\n    font-size: 10px;\n    font-weight: 700;\n    padding: 5px 4px;\n    border-radius: 4px;\n    margin: 5px 3px;\n    width: 54px;\n\n    .isolate-spinner {\n      height: 27px;\n      overflow: hidden;\n    }\n  }\n}\n\n.signup-form {\n  margin-top: 50px;\n}\n\n.form-paragraph {\n  margin-top: 5px;\n  margin-bottom: 5px;\n}\n\n.utility-bills .row > select:first-child,\n.utility-bills .row > input:first-child,\n.utility-bills .row > .input-append:first-child {\n  margin-left: 20px;\n}\n\n.utility-bills .input-start-date {\n  width: 75px;\n}\n\n.utility-bills .input-date {\n  width: 102px;\n}\n\n.utility-bills select {\n  width: 194px;\n  margin-bottom: 10px;\n}\n\n#js-calculate-div {\n  height: 15px;\n  padding-top: 13px;\n}\n\n/* Remove / Tweak Shadow DOM elements */\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Rotate icons when class is added (by javascript) */\n.rotate-clockwise {\n  transform: rotate(90deg);\n  -webkit-transform: rotate(90deg);\n  transition: 0.2s;\n  -webkit-transition: 0.2s;\n}\n\n.rotate-counterclockwise {\n  transform: rotate(0deg);\n  -webkit-transform: rotate(0deg);\n  transition: 0.2s;\n  -webkit-transition: 0.2s;\n}\n\n// No animation on the rotate\n.rotate-180 {\n  transform: rotate(180deg);\n  -webkit-transform: rotate(180deg);\n  display: block;\n}\n\n/* Overwrite themes*/\n.solid-grey {\n  background: #ccc;\n  color: #333;\n}\n\n// ====================  SPINNER / LOADER ======================\n\n.spin-box-container {\n  background-color: rgba(0, 0, 0, 0.6);\n  z-index: 9999;\n  position: fixed;\n  margin: auto;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n}\n\n// === circle loader\n\n.circle {\n  width: 80px;\n  height: 80px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  border-radius: 40px;\n  box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  border: solid 10px fade(@custom-color-1, 15%);\n  border-top-color: @custom-color-4;\n  -webkit-animation: loader-spin 0.75s infinite linear;\n}\n\n@-webkit-keyframes loader-spin {\n  100% {\n    transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n// === Body Inline Loader\n.loader-wrap {\n  width: 20px;\n  height: 20px;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.body-loader {\n  width: 20px;\n  height: 20px;\n\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n\n  border-radius: 50%;\n  border: 2px solid rgba(0, 0, 0, 0.2);\n  border-left-color: #ffffff;\n\n  animation: utilitySpin 1.1s linear infinite;\n  will-change: transform;\n  contain: layout paint;\n\n  /* hide text safely */\n  color: transparent;\n  white-space: nowrap;\n\n  pointer-events: none;\n}\n\n@keyframes utilitySpin {\n  to {\n    transform: translate(-50%, -50%) rotate(360deg);\n  }\n}\n\n/* CARD SPINNER */\n\n.loader-spinner {\n  display: flex;\n  position: relative;\n  width: 42px;\n  height: 42px;\n}\n\n.loader-spinner div {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 42px;\n  height: 42px;\n  border: 5px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n}\n\n.loader-spinner div:not(:nth-child(1)) {\n  clip-path: polygon(50% 50%, 0 0, 80% 0);\n  border: 5px solid #f56600;\n  animation: loader-spinner_spin 1.4s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n}\n\n.loader-spinner div:nth-child(2) {\n  animation-delay: 0s;\n}\n\n.loader-spinner div:nth-child(3) {\n  animation-delay: -0.06s;\n}\n\n.loader-spinner div:nth-child(4) {\n  animation-delay: -0.11s;\n}\n\n.loader-spinner div:nth-child(5) {\n  animation-delay: -0.17s;\n}\n\n.loader-spinner div:nth-child(6) {\n  animation-delay: -0.22s;\n}\n\n@keyframes loader-spinner_spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n// ====================  UTILITY CLASSES ======================\n\n.muted {\n  opacity: 0.75;\n}\n\n.clickable {\n  // for iOS clickability on elements that are not a or submit\n  cursor: pointer;\n}\n\n.visibility-hidden {\n  visibility: hidden;\n}\n\n.link-disabled {\n  color: @gray-light;\n  cursor: not-allowed;\n}\n\n.no-float {\n  float: none !important;\n}\n\n.no-relative {\n  position: static;\n}\n\n// no gutter for all screens\n.no-gutter-al {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.no-gutter-left-al {\n  padding-left: 0px;\n}\n\n.no-gutter-right-al {\n  padding-right: 0px;\n}\n\n// This no-gutter code will be replaced gradually:\n.col-no-gutter {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.col-no-left-gutter {\n  padding-left: 0;\n}\n\n.col-no-right-gutter {\n  padding-right: 0;\n}\n\n//  end replacement\n\n.scroll-past-200 {\n  max-height: 200px;\n  overflow: scroll;\n}\n\n.ma-tb-5 {\n  margin-top: 5px !important;\n  margin-bottom: 5px !important;\n}\n\n.ma-bo-5 {\n  margin-bottom: 5px !important;\n}\n\n.ma-tb-10 {\n  margin-top: 10px !important;\n  margin-bottom: 10px !important;\n}\n\n.ma-tb-20 {\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n\n.ma-bo-20 {\n  margin-bottom: 20px;\n}\n\n.ma-to-10 {\n  margin-top: 10px;\n}\n\n.ma-to-20 {\n  margin-top: 20px;\n}\n\n// ===================  Non-React pages ========================\n\n.form-actions {\n  margin-top: 30px;\n}\n\n// ====================  ERROR PAGES  ======================\n\n.error-page {\n  .box-container {\n    border-radius: 4px;\n    background-color: #f7f7f7;\n    padding: 22px 22px 40px;\n    margin: 45px 0 40px;\n\n    .error-code {\n      font-size: 1.125em;\n      line-height: 24px;\n      color: #333333;\n      float: right;\n      border-radius: 6px;\n      background-color: rgba(0, 0, 0, 0.08);\n      padding: 3px 8px;\n    }\n\n    h1 {\n      margin-top: 0;\n      font-size: 24px;\n      font-weight: 700;\n    }\n\n    p {\n      font-size: 16px;\n      line-height: 22px;\n    }\n  }\n}\n\n// ====================  BRANDING  =====================\n\n.snugg-pro-footer-icon {\n  display: inline-block;\n  width: auto;\n  border-radius: 12px;\n  padding: 12px;\n  box-shadow:\n    inset 0 3px 4px 2px rgba(0, 0, 0, 0.06),\n    inset 0 -3px 4px 2px rgba(255, 255, 255, 0.88);\n  margin: 50px 0 10px;\n\n  img {\n    opacity: 0.95;\n  }\n}\n\n// ====================  RESPONSIVE TWEAKS ======================\n/* Extra small devices (phones, less than 768px) */\n/* No media query since this is the default in Bootstrap */\n\n/* ONLY extra small devices (phones less than 768px) */\n@media (max-width: @screen-xs-max) {\n  .xs-ma-bo-20 {\n    margin-bottom: 20px;\n  }\n\n  .xs-ma-bo-40 {\n    margin-bottom: 40px;\n  }\n\n  .col-xs-no-gutter {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n\n  .col-xs-no-left-gutter {\n    padding-left: 0px;\n  }\n\n  .col-xs-no-right-gutter {\n    padding-right: 0px;\n  }\n\n  .xs-no-relative {\n    position: static !important;\n  }\n\n  .nav-tabs-xs-compact {\n    &.nav.nav-tabs {\n      font-size: 0.8em;\n\n      > li > a {\n        padding: 12px 5px;\n      }\n    }\n  }\n\n  .side-left {\n    .transform(translateX(-@side-left-width));\n  }\n\n  // Push menu button:\n\n  .push-left {\n    .container-fluid.core-container {\n      .transform(translateX(@side-left-width));\n    }\n\n    .side-left {\n      .transform(translateX(0));\n    }\n\n    .push-menu-overlay {\n      position: fixed;\n      cursor: pointer;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      height: 100%;\n      width: 100%;\n      z-index: 1060;\n      background-color: rgba(255, 255, 255, 0.5);\n    }\n  }\n\n  .form-control.input-header.rec-input-header {\n    font-size: 15px;\n    font-weight: 600;\n    min-width: 255px;\n  }\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (min-width: @screen-sm-min) {\n  // Style push menu\n  .container-fluid.core-container {\n    // .transform(translateX(@side-left-width));\n    margin-left: @side-left-width;\n    margin-right: 0;\n  }\n\n  .push-left {\n    .container-fluid.core-container {\n      // .transform(translateX(@side-left-width));\n      margin-left: @side-left-width;\n      margin-right: 0;\n    }\n\n    .side-left {\n      left: 0;\n    }\n\n    .push-menu-overlay {\n      display: none;\n    }\n  }\n\n  // Grid responsive utilities\n  .col-sm-no-gutter {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .col-sm-no-left-gutter {\n    padding-left: 0;\n  }\n\n  .col-sm-no-right-gutter {\n    padding-right: 0;\n  }\n\n  // left sidebar\n  .side-left {\n    left: 0;\n    transform: translateX(0);\n  }\n\n  .content-header {\n    .app-logo {\n      margin: 11px 10px 0 0;\n\n      img {\n      }\n    }\n\n    .btn.btn-new-job {\n      border-left: 0;\n    }\n\n    .navbar-group {\n      float: right;\n      display: block;\n\n      .header-navbar {\n        width: auto;\n      }\n    }\n\n    .header-navbar .btn-group.btn-group-sort {\n      border-right: 1px solid darken(@custom-color-3, 10%);\n    }\n  }\n\n  .form-search .form-group {\n    margin-top: 4px;\n  }\n\n  // popovers\n  .popover {\n    &.popover-header {\n      right: 0;\n\n      .arrow {\n        left: auto;\n        right: 15px;\n      }\n    }\n  }\n\n  .form-group.form-group-two-rows {\n    label.control-label {\n      padding-top: 42px;\n    }\n  }\n\n  .form-control.input-header.rec-input-header {\n    min-width: 300px;\n  }\n\n  .modal-dialog.modal-lg {\n    min-width: 600px;\n    max-width: 90%;\n    width: auto;\n  }\n\n  .jl .snugg-select {\n    height: 46px;\n  }\n\n  .search-jobs.topmost-search-job-container {\n    width: 60px;\n  }\n}\n\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: @screen-md-min) {\n  .search-jobs.topmost-search-job-container {\n    width: auto;\n    max-width: 160px;\n  }\n}\n\n/* Large devices (desktops, 992px and up) */\n@media (min-width: @screen-lg) {\n  .search-jobs.topmost-search-job-container {\n    max-width: 260px;\n  }\n}\n\n/* ONLY extra short devices (phones less than 568px)  This is a fringe case*/\n@side-left-width-short: 108px;\n\n@media (max-height: @short-screen-max) {\n  .popover {\n    &.popover-support {\n      .arrow {\n        bottom: 3px;\n      }\n    }\n\n    &.popover-settings {\n      .arrow {\n        bottom: 30px;\n      }\n    }\n  }\n}\n\n.make-margin(@class, @size) {\n  .margin-top-@{class}-@{size} {\n    margin-top: @size;\n  }\n\n  .margin-bottom-@{class}-@{size} {\n    margin-top: @size;\n  }\n\n  .margin-vertical-@{class}-@{size} {\n    margin-top: @size;\n    margin-bottom: @size;\n  }\n}\n\n.make-gutter(@class) {\n  .no-gutter-@{class} {\n    padding-left: 0px;\n    padding-right: 0px;\n  }\n\n  .no-gutter-left-@{class} {\n    padding-left: 0px;\n  }\n\n  .no-gutter-right-@{class} {\n    padding-right: 0px;\n  }\n}\n\n.make-margins(@class) {\n  .make-margin(@class, 5);\n  .make-margin(@class, 10);\n  .make-margin(@class, 15);\n  .make-margin(@class, 20);\n}\n\n// Extra small grid\n.make-gutter(all);\n.make-margins(all);\n\n@media (max-width: @screen-xs-max) {\n  .make-gutter(xs);\n  .make-margins(xs);\n}\n\n@media (min-width: @screen-sm-min) {\n  .make-gutter(sm);\n  .make-margins(sm);\n}\n\n@media (min-width: @screen-md-min) {\n  .make-gutter(md);\n  .make-margins(md);\n}\n\n@media (min-width: @screen-lg-min) {\n  .make-gutter(lg);\n  .make-margins(lg);\n}\n\n// ====================  PRINTING TWEAKS ======================\n@media print {\n  .side-right-handle {\n    display: none;\n  }\n\n  .side-right.report-side-right,\n  .side-right.report-side-right.expanded {\n    right: -197px;\n    top: -10px;\n  }\n\n  .side-left {\n    top: -10px;\n  }\n}\n\n// ================== SHARED JOB DROPDOWN =====================\n\n.custom-dropdown {\n  li {\n    margin-bottom: 2px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    a {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n      padding: 8px 12px;\n      font-size: 14px;\n      line-height: 1.42;\n      color: #111;\n      font-weight: 600;\n\n      span {\n        font-size: 12px;\n        color: #777;\n        display: inline-block;\n        font-weight: 500;\n      }\n    }\n  }\n\n  li.delete {\n    a {\n      color: #d92d20;\n    }\n  }\n\n  li.active {\n    background-color: #fff5e9;\n\n    a {\n      background-color: #fff5e9;\n      color: #f56600;\n\n      span {\n        color: #555;\n      }\n\n      &:hover {\n        color: #f56600;\n        background-color: #feecd6;\n      }\n    }\n  }\n\n  .dropdown-icon {\n    margin-left: 8px;\n    margin-top: -4px;\n    width: 16px;\n    height: 16px;\n    transition: all 200ms linear;\n\n    &.rotated {\n      transform: rotate(-180deg);\n    }\n  }\n\n  & {\n    button {\n      span {\n        transition: all 150ms ease;\n      }\n    }\n  }\n\n  &:hover {\n    button {\n      span {\n        color: #f56600;\n      }\n    }\n  }\n}\n\n// ====================  INCENTIVES TEMPLATES ======================\n\n.settings-page-header {\n  width: 100%;\n  padding-top: 20px;\n  padding-bottom: 20px;\n\n  display: flex;\n  justify-content: space-between;\n  gap: 24px;\n}\n\n.settings-page-title-container {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.incentive-template-empty-state {\n  background-color: #fff;\n  border: 1px dashed #ccc;\n  border-radius: 6px;\n  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.04);\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 16px;\n\n  padding: 24px 16px 32px;\n  margin-bottom: 8px;\n\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #333;\n}\n\n.incentives-list-empty-state {\n  .incentive-template-empty-state();\n  border: 1px solid #eee;\n}\n\n.incentives-template-wrapper {\n  background-color: #f9f9f9;\n  padding-top: 20px;\n  padding-bottom: 40px;\n}\n\n.incentives-template-layout {\n  width: 800px;\n}\n\n.incentives-field-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 20px;\n\n  .form-group {\n    margin-bottom: 0;\n  }\n\n  span {\n    margin: 0 0 0 0 !important;\n    padding-left: 8px;\n    font-size: 12px;\n    line-height: 1.42;\n  }\n}\n\n.incentives-category-title {\n  font-size: 10px;\n  font-weight: 700;\n  line-height: 1.5;\n  letter-spacing: 0.5px;\n  text-transform: uppercase;\n  color: #555;\n\n  background-color: #f7f7f7;\n  padding: 4px 8px;\n  border-radius: 3px;\n  margin-bottom: 4px;\n}\n\n.measure-checklist {\n  display: flex;\n  align-items: center;\n  padding: 0 16px 8px 28px !important;\n  margin-left: 16px;\n  margin-top: 8px;\n\n  border-bottom: 1px solid #eee;\n\n  &:last-child {\n    border-bottom: none;\n  }\n}\n\n.incentives-text-list {\n  text-align: 'left';\n  font-size: 12px;\n  line-height: 1.5;\n  color: #555;\n  padding-left: 24px;\n\n  li {\n    margin-bottom: 4px;\n  }\n\n  b {\n    font-weight: 600;\n  }\n}\n\n.incentive-template-form-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 16px;\n  padding-bottom: 8px;\n}\n\n.seprator-style {\n  border-top: 1px solid #eee;\n\n  &.dark {\n    border-color: #ddd;\n  }\n\n  &.mb0 {\n    margin-bottom: 0;\n  }\n\n  &.mt0 {\n    margin-top: 0;\n  }\n\n  &.my0 {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n}\n\n.incentive-published-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n  gap: 4px;\n\n  font-size: 12px;\n  line-height: 1.42;\n  color: #555;\n  font-style: italic;\n}\n\n.incentives-dropdown-style {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  .incentive-source-and-name-container {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n\n    font-size: 14px;\n    line-height: 1.42;\n    color: #333;\n\n    .source {\n      font-size: 12px;\n      line-height: 1.42;\n      color: #777;\n    }\n  }\n\n  .incentive-type {\n    font-size: 12px;\n    line-height: 1.42;\n    text-align: center;\n    color: #555;\n    text-transform: uppercase;\n\n    padding: 1px 6px 2px;\n    background-color: #eee;\n    border-radius: 3px;\n  }\n}\n\n.incentives-list-container-table {\n  thead {\n    th {\n      font-size: 12px;\n      font-weight: 600;\n      line-height: 1.42;\n      color: #656565;\n      text-transform: none !important;\n      letter-spacing: 0;\n\n      border-bottom: 1px solid #eee !important;\n\n      &:first-child {\n        padding-left: 16px;\n      }\n    }\n  }\n\n  .incentive-source {\n    background-color: #f2f2f2;\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.42;\n    color: #656565;\n\n    td {\n      padding: 4px 8px;\n\n      &:first-child {\n        padding-left: 16px;\n        border-left: 1px solid #eee;\n      }\n\n      &:last-child {\n        border-right: 1px solid #eee;\n      }\n    }\n  }\n\n  .incentive-list-itme {\n    cursor: pointer;\n    background-color: #fff;\n    transition: all 250ms ease;\n    position: relative;\n\n    td {\n      vertical-align: middle;\n      padding: 16px 8px;\n      border-top: none;\n      border-bottom: 1px solid #eee;\n\n      &:first-child {\n        padding-left: 16px;\n        border-left: 1px solid #eee;\n      }\n\n      &:last-child {\n        border-right: 1px solid #eee;\n      }\n    }\n\n    &:hover {\n      background-color: #fff;\n      z-index: 10;\n      box-shadow: 0 1px 12px rgba(0, 0, 0, 0.2);\n\n      td {\n        border-bottom: 1px solid #fff;\n\n        &:first-child {\n          border-left: 1px solid #fff;\n        }\n\n        &:last-child {\n          border-right: 1px solid #fff;\n        }\n      }\n    }\n  }\n\n  .incentive-list-item-title {\n    font-size: 14px;\n    line-height: 1.42;\n    font-weight: 600;\n    color: #333;\n  }\n}\n\n.incentives-details-title-section {\n  padding-top: 24px;\n  padding-bottom: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n\n  span {\n    font-size: 12px;\n    line-height: 1.42;\n    color: #555;\n  }\n}\n\n.incentives-details-status-section {\n  padding-top: 24px;\n  padding-bottom: 8px;\n\n  display: flex;\n  justify-content: flex-end;\n}\n\n@media (max-width: @screen-sm-max) {\n  .incentives-details-status-section {\n    justify-content: flex-start;\n    padding-top: 0;\n  }\n}\n\n.incentives-details-estimated-amount {\n  font-size: 12px;\n  line-height: 1.42;\n  font-weight: 600;\n  text-align: right;\n  margin-bottom: 4px;\n\n  a {\n    text-decoration: underline;\n\n    &:hover {\n      text-decoration: none;\n    }\n  }\n}\n\n.incentives-line-items-table {\n  thead {\n    tr {\n      th {\n        font-size: 13px;\n        font-weight: 600;\n        line-height: 1.42;\n        color: #c84900;\n        letter-spacing: 0;\n        text-transform: none;\n        border-bottom: none;\n\n        background-color: #f7f7f7;\n        padding: 4px 8px;\n\n        &.incentive-source-total {\n          color: #656565;\n          text-align: right;\n        }\n      }\n    }\n  }\n\n  tbody {\n    tr {\n      td {\n        font-weight: 600;\n      }\n\n      &:first-child {\n        td {\n          border-top: none;\n        }\n      }\n    }\n  }\n}\n\n@media (max-width: @screen-sm-max) {\n  .incentives-list-container-table {\n    thead {\n      display: none;\n    }\n\n    .incentive-source {\n      display: flex;\n      flex-wrap: wrap;\n      background: none;\n\n      td {\n        display: block;\n        width: 50%;\n        box-sizing: border-box;\n        font-size: 1.5rem;\n        border: none !important;\n        padding-left: 0 !important;\n        padding-top: 4px;\n\n        &:last-child {\n          text-align: right;\n        }\n      }\n    }\n\n    .incentive-list-itme {\n      display: flex;\n      flex-wrap: wrap;\n      margin-bottom: 16px;\n      margin-top: 16px;\n      width: 100%;\n      padding: 8px 16px;\n      box-shadow:\n        0 4px 4px -2px rgba(0, 0, 0, 0.06),\n        0 0 0 1px rgba(0, 0, 0, 0.06);\n      border-radius: 3px;\n\n      td {\n        display: block;\n        width: 50%;\n        box-sizing: border-box;\n        text-align: left;\n        padding-top: 24px !important;\n        position: relative;\n        border: none !important;\n\n        &:first-child {\n          padding-left: 8px;\n        }\n\n        &:nth-child(1) {\n          width: 50%;\n          padding-top: 16px !important;\n        }\n\n        &:nth-child(2) {\n          width: 50%;\n          padding-top: 8px !important;\n        }\n      }\n\n      td::before {\n        content: attr(data-label);\n        position: absolute;\n        top: 4px;\n        left: 8px;\n        width: 100%;\n        font-weight: 400;\n        text-align: left;\n        font-size: 12px;\n      }\n    }\n  }\n}\n\n@media (max-width: @screen-xs-max) {\n  .incentives-list-container-table {\n    .incentive-list-itme {\n      td {\n        &:nth-child(1) {\n          width: 100%;\n          padding-top: 16px !important;\n        }\n\n        &:nth-child(2) {\n          width: 100%;\n          padding-top: 0 !important;\n          padding-bottom: 8px !important;\n        }\n      }\n    }\n  }\n}\n\n.selected-incentives-table {\n  thead {\n    tr {\n      th {\n        font-size: 14px;\n        font-weight: 700;\n        line-height: 1.42;\n        color: #333;\n\n        border-bottom: none;\n        background-color: #fff;\n        padding: 8px;\n\n        &.incentive-source-total {\n          text-align: right;\n        }\n      }\n    }\n  }\n\n  tbody {\n    tr {\n      td {\n        vertical-align: middle;\n        font-size: 14px;\n        line-height: 1.42;\n        color: #333;\n        font-weight: 600;\n\n        &.rebate-type-block {\n          font-size: 10px;\n          line-height: 1.42;\n          color: #656565;\n          font-weight: 600;\n\n          background-color: #f2f2f2;\n          border: 1px solid #eee;\n\n          padding-top: 2px;\n          padding-bottom: 2px;\n        }\n      }\n    }\n  }\n}\n\n.incentives-line-items-total {\n  font-size: 18px;\n  font-weight: 700;\n  color: #333;\n  text-align: right;\n}\n\n.eligibility-list {\n  padding-left: 24px;\n  margin-bottom: 0;\n\n  li {\n    margin-bottom: 6px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.incentives-attributes-container {\n  display: flex;\n  flex-direction: column;\n  gap: 0px;\n  padding-right: 8px;\n}\n\n.incentives-key-value-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.floating-back-button {\n  display: flex;\n  justify-content: center;\n  gap: 0;\n  position: fixed;\n  bottom: 40px;\n  left: 50%;\n  transform: translate(-50%);\n  z-index: 99;\n\n  font-size: 14px;\n  line-height: 1.42;\n  text-align: left;\n  color: #fff;\n\n  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.5);\n  border-radius: 6px;\n  overflow: hidden;\n\n  transition: @animation;\n\n  .float-button-inner {\n    background-color: rgba(0, 0, 0, 0.6);\n    border-radius: 6px 0 0 6px;\n    backdrop-filter: blur(16px);\n    transition: @animation;\n\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 16px;\n    cursor: pointer;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.8);\n    }\n  }\n\n  .close-float {\n    background-color: rgba(0, 0, 0, 0.6);\n    border-radius: 0 6px 6px 0;\n    padding: 0px 16px 0 14px;\n    backdrop-filter: blur(16px);\n    transition: @animation;\n    border-left: 1px solid rgba(0, 0, 0, 0.35);\n\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    cursor: pointer;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.8);\n    }\n  }\n}\n\n@media (max-width: @screen-xs-max) {\n  .floating-back-button {\n    left: 4%;\n    right: 4%;\n    transform: translate(0%);\n\n    .float-button-inner {\n      flex: 1;\n    }\n  }\n}\n\n.linked-measure-incentive-list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 8px 8px 0 0;\n}\n\n.linked-measure-incentive-button {\n  width: 100%;\n  background-color: rgba(0, 0, 0, 0.03);\n  border-radius: 6px;\n  border: 1px solid transparent;\n  transition: @animation;\n  cursor: pointer;\n\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #555;\n\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n  padding: 8px 16px 8px 12px;\n\n  &:hover {\n    background-color: #fff5e9;\n    border: 1px solid rgba(251, 207, 165, 0.5);\n    border-radius: 6px;\n    color: #f56600;\n  }\n}\n\n.line-items-show-more {\n  font-size: 12px;\n  line-height: 1.42;\n  text-align: center;\n  text-decoration: underline;\n  color: #c84900;\n}\n\n.no-selected-incentives-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 16px 8px;\n}\n\n// ====================  HES Certificate of Compliances ======================\n\n.cocompliances_table {\n  width: 100%;\n  font-size: 16px;\n\n  tr {\n    display: flex;\n    gap: 8px;\n  }\n\n  td,\n  th {\n    padding: 10px 12px;\n    width: 33.33%;\n    border-bottom: 1px solid #eee;\n  }\n\n  th {\n    b {\n      font-weight: 700;\n    }\n  }\n\n  td {\n    b {\n      font-weight: 600;\n    }\n  }\n\n  th.active {\n    background-color: #7cad3e;\n    color: #fff;\n    border-radius: 12px 12px 0 0;\n    text-align: center;\n  }\n\n  th.inactive {\n    background-color: #eee;\n    color: #777;\n    border-radius: 12px 12px 0 0;\n    text-align: center;\n  }\n\n  td.active {\n    background-color: #e5f0d6;\n    border-bottom: 1px solid #c4dda2;\n    text-align: center;\n  }\n\n  td.inactive {\n    background-color: #f7f7f7;\n    border-bottom: 1px solid #eee;\n    text-align: center;\n    color: #777;\n  }\n}\n\n// ==================== SIGNATURE BOX STYLE ======================\n\n.signature-box {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  width: 240px;\n  height: 164px;\n  margin-top: 8px;\n\n  .signature-action {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 4px;\n\n    font-size: 12px;\n    line-height: 1.42;\n    text-transform: uppercase;\n    font-weight: bold;\n    color: rgba(0, 0, 0, 0.2);\n\n    padding: 8px;\n    border-radius: 6px;\n    cursor: pointer;\n\n    transition: all 200ms ease-in-out;\n\n    svg {\n      fill: rgba(0, 0, 0, 0.2);\n      transition: all 200ms ease-in-out;\n    }\n\n    &:hover {\n      background-color: #fff5e9;\n      color: #f56600;\n\n      svg {\n        fill: #f56600;\n      }\n    }\n  }\n\n  .signature-footer {\n    width: 100%;\n    font-size: 12px;\n    line-height: 1.42;\n    color: #555;\n    padding-top: 4px;\n    border-top: 1px solid #cccccc;\n    display: flex;\n\n    span {\n      float: left;\n      width: 64px;\n    }\n  }\n}\n\n/* CUSTOM WORK ORDER COMPONENTS FOR PROGRAMS */\n\n.energy-savings-improvements-work-order {\n  display: flex;\n  flex-direction: column;\n  background-color: #f2f2f2;\n  border-radius: 6px;\n  padding: 2px 10px;\n  margin-bottom: 8px;\n\n  font-size: 12px;\n  font-weight: 600;\n  color: #555;\n\n  & > div {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 6px 0;\n    border-bottom: 1px solid #e6e6e6;\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  .key {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n  }\n\n  .value {\n    color: #111;\n  }\n}\n\n// CUSTOM DI PAYMENT MODAL\n\n.custom-di-payment-modal {\n  max-width: 1000px;\n  width: 96%;\n}\n\n.custom-di-payment-modal-email {\n  display: block;\n  line-break: anywhere;\n}\n\n@media (max-width: @screen-sm-max) {\n  .custom-di-payment-modal {\n    width: 96%;\n  }\n\n  .custom-di-payment-modal-email {\n    display: inline;\n  }\n}\n\n// CUSTOM KONVA CANVAS MODAL\n.konva-canvas-modal {\n  width: 100vw;\n  height: 100vh;\n  margin: 0;\n\n  .modal-content {\n    height: 100vh;\n    border-radius: 0;\n    border: none;\n    display: flex;\n    flex-direction: column;\n    min-height: 600px;\n  }\n\n  .modal-header {\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    background: #f7f7f7;\n    border-bottom: 1px solid #e6e6e6;\n    padding: 8px 16px;\n    display: table;\n\n    .modal-title {\n      font-size: 16px;\n      font-weight: 600;\n      color: #777777;\n    }\n  }\n\n  .modal-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0;\n    display: flex;\n    flex-direction: row;\n\n    .left-sidebar {\n      width: 192px;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      padding: 16px;\n      border-right: 1px solid #e6e6e6;\n\n      .top {\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n\n        .draw-mode-btns-container {\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n        }\n\n        .shape-btns-container {\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n        }\n      }\n    }\n\n    .right-sidebar {\n      border-left: 1px solid #e6e6e6;\n    }\n\n    hr {\n      border-top: 1px solid #e6e6e6;\n      width: 100%;\n      margin: 0;\n    }\n  }\n\n  .fixed-footer {\n    position: sticky;\n    bottom: 0;\n    z-index: 2;\n    background-color: #f7f7f7;\n    box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.1);\n    padding: 16px;\n\n    .footer-container {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n\n      span {\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 142%;\n        color: #777777;\n\n        b {\n          font-weight: 700;\n          color: #333333;\n        }\n      }\n\n      .footer-buttons-container {\n        display: flex;\n        flex-direction: row;\n        gap: 4px;\n      }\n    }\n  }\n}\n\n// KONVA CANVAS PAGE\n.konva-canvas-page {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1064;\n  background: #fff;\n  display: flex;\n  flex-direction: column;\n  min-height: 600px;\n\n  .konva-canvas-page-header {\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    background: #f7f7f7;\n    border-bottom: 1px solid #e6e6e6;\n    padding: 8px 16px;\n    display: table;\n\n    h3 {\n      font-size: 16px;\n      font-weight: 600;\n      color: #777777;\n      margin: 0;\n    }\n  }\n\n  .konva-canvas-page-body {\n    flex: 1;\n    overflow-y: auto;\n    padding: 0;\n    display: flex;\n    flex-direction: row;\n\n    .left-sidebar {\n      width: 192px;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n      padding: 16px;\n      border-right: 1px solid #e6e6e6;\n\n      .top {\n        display: flex;\n        flex-direction: column;\n        gap: 16px;\n\n        .draw-mode-btns-container {\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n        }\n\n        .shape-btns-container {\n          display: flex;\n          flex-direction: column;\n          gap: 8px;\n        }\n      }\n    }\n\n    .right-sidebar {\n      border-left: 1px solid #e6e6e6;\n    }\n\n    hr {\n      border-top: 1px solid #e6e6e6;\n      width: 100%;\n      margin: 0;\n    }\n  }\n\n  .konva-canvas-page-footer {\n    position: sticky;\n    bottom: 0;\n    z-index: 2;\n    background-color: #f7f7f7;\n    box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.1);\n    padding: 16px;\n\n    .footer-container {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n\n      span {\n        font-size: 16px;\n        font-weight: 600;\n        line-height: 142%;\n        color: #777777;\n\n        b {\n          font-weight: 700;\n          color: #333333;\n        }\n      }\n\n      .footer-buttons-container {\n        display: flex;\n        flex-direction: row;\n        gap: 4px;\n      }\n    }\n  }\n}\n\n.konva-edit-wrapper {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: #f7f7f7;\n  padding: 16px;\n}\n\n.konva-fixed-area {\n  width: 100%;\n  max-width: 100%;\n  aspect-ratio: 16 / 9;\n  height: auto;\n  max-height: 100%;\n  position: relative;\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.stored-file-notify {\n  color: #777;\n  font-size: 12px;\n  line-height: 1.6;\n  font-weight: 600;\n\n  padding: 16px;\n  border-radius: 12px;\n  background-color: #fff;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.06),\n    0 1px 2px -1px rgba(0, 0, 0, 0.06),\n    0 2px 4px 0 rgba(0, 0, 0, 0.04);\n\n  b {\n    font-weight: 700;\n    color: #111;\n  }\n}\n\n.no-image-selected {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: center;\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 0;\n  text-align: center;\n  color: rgba(119, 119, 119, 1);\n  gap: 16px;\n  z-index: 2;\n}\n\n.wwrt-image-uploader-container {\n  align-items: center;\n  background: rgba(249, 249, 249, 1);\n  border-color: rgba(204, 204, 204, 1);\n  border-radius: 12px;\n  border-style: dashed;\n  border-width: 1px;\n  display: flex;\n  gap: 16px;\n  height: 100%;\n  justify-content: center;\n  padding: 8px;\n  width: 100%;\n  cursor: pointer;\n\n  &:hover {\n    background-color: #f2f2f2;\n  }\n\n  p {\n    margin: 0;\n  }\n\n  & input[type='file'] {\n    display: none;\n  }\n\n  .wwrt-image-uploader {\n    align-items: center;\n    display: inline-flex;\n    flex-direction: column;\n    gap: 16px;\n    justify-content: center;\n    min-height: 115px;\n    color: #777777;\n    font-size: 12px;\n  }\n}\n\n.wwr-white-btn {\n  transition: all 150ms ease-in-out;\n\n  &:hover {\n    background-color: #f7f7f7 !important;\n  }\n}\n\n.wwr-wall-btn {\n  transition: all 150ms ease-in-out;\n\n  &:hover {\n    background-color: #fef0e6 !important;\n  }\n}\n\n.wwr-window-btn {\n  transition: all 150ms ease-in-out;\n\n  &:hover {\n    background-color: #ebf1fe !important;\n  }\n}\n\n.wwr-delete-btn {\n  transition: all 150ms ease-in-out;\n  background-color: #d92d20 !important;\n  color: #fff !important;\n\n  &:hover {\n    background-color: #ae241a !important;\n  }\n}\n\n.shape-properties-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: #777777;\n  margin: 0;\n}\n\n.undo-redo-btns {\n  display: flex;\n  flex-direction: row;\n  gap: 8px;\n}\n\n.zoom-controls {\n  width: 34px;\n  position: absolute;\n  bottom: 24px;\n  right: 24px;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.zoom-button {\n  width: 100%;\n  height: 32px;\n  background-color: rgba(255, 255, 255, 0.95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  backdrop-filter: blur(2px);\n\n  &:hover {\n    background-color: #f2f2f2;\n  }\n\n  hr {\n    border-top: 1px solid rgba(0, 0, 0, 0.1);\n  }\n}\n\n// START AUDIT BUTTON STYLE\n\n.start-audit-button {\n  width: auto !important;\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n\n  @media (min-width: 992px) {\n    padding-top: 11px !important;\n    padding-bottom: 11px !important;\n  }\n}\n","@reportGridColumns: 12;\n@reportGridColumnWidth: 62px;\n@reportGridGutterWidth: 18px;\n@reportGridRowWidth: (@reportGridColumns * @reportGridColumnWidth) +\n  (@reportGridGutterWidth * (@reportGridColumns - 1));\n\n.clearfix {\n  *zoom: 1;\n  &:before,\n  &:after {\n    display: table;\n    content: '';\n    // Fixes Opera/contenteditable bug:\n    // http://nicolasgallagher.com/micro-clearfix-hack/#comment-36952\n    line-height: 0;\n  }\n  &:after {\n    clear: both;\n  }\n}\n\n.report-grid (@gridColumnWidth, @gridGutterWidth) {\n  .r-spaX (@index) when (@index > 0) {\n    .r-spa@{index} {\n      .r-spa(@index);\n    }\n    .r-spaX(@index - 1);\n  }\n  .r-spaX (0) {\n  }\n\n  .r-offsetX (@index) when (@index > 0) {\n    .r-offset@{index} {\n      .r-offset(@index);\n    }\n    .r-offsetX(@index - 1);\n  }\n  .r-offsetX (0) {\n  }\n\n  .r-offset (@columns) {\n    margin-left: (@gridColumnWidth * @columns) +\n      (@gridGutterWidth * (@columns + 1));\n  }\n\n  .r-spa (@columns) {\n    width: (@gridColumnWidth * @columns) + (@gridGutterWidth * (@columns - 1));\n  }\n\n  .r-row {\n    margin-left: @gridGutterWidth * -1;\n    .clearfix();\n  }\n\n  [class*='r-spa'] {\n    float: left;\n    min-height: 5px; // prevent collapsing columns\n    margin-left: @gridGutterWidth;\n  }\n\n  // Set the container width, and override it for fixed navbars in media queries\n  .r-container,\n  .r-navbar-static-top .container,\n  .r-navbar-fixed-top .container,\n  .r-navbar-fixed-bottom .container {\n    .r-spa(@reportGridColumns);\n  }\n\n  // generate .r-spaX and .r-offsetX\n  .r-spaX(@reportGridColumns);\n  .r-offsetX(@reportGridColumns);\n}\n\n.report-grid(@reportGridColumnWidth, @reportGridGutterWidth);\n\n// Reset utility classes due to specificity\n[class*='r-spa'].hide,\n.row-fluid [class*='r-spa'].hide {\n  display: none;\n}\n\n[class*='r-spa'].pull-right,\n.row-fluid [class*='r-spa'].pull-right {\n  float: right;\n}\n","// Clearfix\n//\n// For modern browsers\n// 1. The space content is one way to avoid an Opera bug when the\n//    contenteditable attribute is included anywhere else in the document.\n//    Otherwise it causes space to appear at the top and bottom of elements\n//    that are clearfixed.\n// 2. The use of `table` rather than `block` is only necessary if using\n//    `:before` to contain the top-margins of child elements.\n//\n// Source: http://nicolasgallagher.com/micro-clearfix-hack/\n\n.clearfix() {\n  &:before,\n  &:after {\n    content: \" \"; // 1\n    display: table; // 2\n  }\n  &:after {\n    clear: both;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// http://codepen.io/mediaashley/pen/kLbGf\n\n.button-3d(@color; @background; @border) {\n  position: relative;\n  cursor: pointer;\n  color: @color;\n  background: @background;\n  background-image: 0;\n  // border: 1px solid @border;\n\n  &:hover,\n  &:focus {\n    background: lighten(@background, 7%);\n    color: @color;\n    // border: 1px solid lighten(@border, 5%);\n  }\n  &.active,\n  &:active,\n  .open > .dropdown-toggle& {\n    background-color: darken(@background, 10%);\n    color: @color;\n  }\n  &:active,\n  &.active,\n  .open > .dropdown-toggle& {\n    background-image: none;\n  }\n\n  &:before {\n    display: block;\n    position: absolute;\n    padding-top: 10px;\n    top: 10px;\n  }\n\n  &:active:before {\n    // top: 7px;\n  }\n\n  &.disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    &,\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      background-color: @background;\n      border-color: @border;\n    }\n  }\n  .badge {\n    color: @background;\n    background-color: @color;\n  }\n}\n\n.button-gradient(@color; @background; @accent) {\n  position: relative;\n  cursor: pointer;\n  color: @color;\n  background: @background;\n  background-image: linear-gradient(202deg, @background 0%, @accent 100% 79%);\n  -webkit-transition: 200ms; /* Safari prior 6.1 */\n  transition: 200ms;\n  border: none;\n\n  &:hover,\n  &:focus {\n    background: lighten(@background, 7%);\n    background-image: linear-gradient(\n      202deg,\n      lighten(@background, 5%) 9%,\n      lighten(@accent, 5%) 79%\n    );\n    color: @color;\n  }\n  &.active,\n  &:active,\n  .open > .dropdown-toggle& {\n    background-color: darken(@background, 10%);\n    background-image: linear-gradient(\n      202deg,\n      darken(@background, 2%) 9%,\n      darken(@accent, 2%) 79%\n    );\n    color: @color;\n  }\n  &:active,\n  &.active,\n  .open > .dropdown-toggle& {\n    background-image: none;\n  }\n\n  &:before {\n    display: block;\n    position: absolute;\n    padding-top: 10px;\n    top: 10px;\n  }\n\n  &:active:before {\n    // top: 7px;\n  }\n\n  &.disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    &,\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      background-color: @background;\n      border-color: @accent;\n    }\n  }\n  .badge {\n    color: @background;\n    background-color: @color;\n  }\n}\n// ====== For light shades that need to darken on hover ======\n.button-3d-light-shade(@color; @background; @border) {\n  position: relative;\n  cursor: pointer;\n  color: @color;\n  background: @background;\n  background-image: 0;\n  // border: 1px solid @border;\n\n  &:hover,\n  &:focus {\n    background: darken(@background, 3%);\n    color: @color;\n    // border: 1px solid lighten(@border, 5%);\n  }\n  &.active,\n  &:active,\n  .open > .dropdown-toggle& {\n    background-color: darken(@background, 10%);\n    color: @color;\n  }\n  &:active,\n  &.active,\n  .open > .dropdown-toggle& {\n    background-image: none;\n  }\n\n  &:before {\n    display: block;\n    position: absolute;\n    padding-top: 10px;\n    top: 10px;\n  }\n\n  &:active:before {\n    // top: 7px;\n  }\n\n  &.disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    &,\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      background-color: @background;\n      border-color: @border;\n    }\n  }\n  .badge {\n    color: @background;\n    background-color: @color;\n  }\n}\n\n.button-gradient-light-shade(@color; @background; @accent) {\n  position: relative;\n  cursor: pointer;\n  color: @color;\n  background: @background;\n  background-image: linear-gradient(0deg, @background 0%, @accent 100%);\n  -webkit-transition: 200ms; /* Safari prior 6.1 */\n  transition: 200ms;\n  border: none;\n\n  &:hover,\n  &:focus {\n    background: darken(@background, 3%);\n    background-image: linear-gradient(\n      0deg,\n      darken(@background, 4%) 9%,\n      darken(@accent, 2%) 100%\n    );\n    color: @color;\n  }\n  &.active,\n  &:active,\n  .open > .dropdown-toggle& {\n    background-color: darken(@background, 10%);\n    background-image: linear-gradient(\n      0deg,\n      darken(@background, 2%) 9%,\n      darken(@accent, 2%) 100%\n    );\n    color: @color;\n  }\n  &:active,\n  &.active,\n  .open > .dropdown-toggle& {\n    background-image: none;\n  }\n\n  &:before {\n    display: block;\n    position: absolute;\n    padding-top: 10px;\n    top: 10px;\n  }\n\n  &:active:before {\n    // top: 7px;\n  }\n\n  &.disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    &,\n    &:hover,\n    &:focus,\n    &:active,\n    &.active {\n      background-color: @background;\n      border-color: @accent;\n    }\n  }\n  .badge {\n    color: @background;\n    background-color: @color;\n  }\n}\n","// --------------------------  Jobs and templates Modules --------------------\n\n@job-row-min-height: 60px;\n\n.content.jobs-view {\n  background-color: transparent;\n  padding-top: @double-header-height;\n  min-height: 100vh;\n\n  &.jobs-view-has-only-one-organization {\n    padding-top: @header-height;\n  }\n\n  h1 {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 19px;\n\n    .btn-group {\n      margin-left: 10px;\n\n      > .btn-large {\n        font-size: 24px;\n      }\n    }\n  }\n\n  h2 {\n    font-size: 24px;\n    font-weight: 300;\n    margin-top: 5px;\n  }\n\n  .listings {\n    min-height: 50vh;\n  }\n}\n\n.listings {\n  color: @custom-color-1;\n\n  h3 {\n    font-weight: 600;\n    font-size: 15px;\n    text-transform: capitalize;\n    margin: 0;\n    max-width: 100%; // 248px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    color: @gray-darker;\n\n    small {\n      color: #666;\n    }\n  }\n\n  a {\n    color: @gray-dark;\n  }\n\n  .jl {\n    font-size: 13px;\n    line-height: 26px;\n    position: relative;\n    overflow: hidden;\n    min-height: @job-row-min-height;\n    cursor: pointer;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n\n    &.jl-not-wholly-clickable {\n      cursor: default;\n\n      a {\n        color: @link-color;\n      }\n    }\n\n    .clearfix();\n\n    &:nth-last-child(2) {\n      border-bottom: 0;\n    }\n\n    &.jl-header {\n      text-transform: uppercase;\n      cursor: default;\n      border-bottom: none;\n      min-height: @header-height;\n\n      .jl-buttons {\n        min-height: @header-height;\n      }\n\n      .jl-everything-else {\n        cursor: default;\n        min-height: @header-height;\n\n        &:hover {\n          background-color: transparent;\n        }\n      }\n\n      .jl-box {\n        color: @gray;\n        letter-spacing: 0.08em;\n        font-size: 0.95em;\n        font-weight: 700;\n        text-align: left;\n      }\n    }\n\n    &.jl-header-sortable .jl-box {\n      cursor: pointer;\n      border-radius: 5px;\n\n      &:hover {\n        background-color: @gray-lightest;\n        color: #000;\n      }\n\n      &:active,\n      &:focus {\n        background-color: @gray-lighter;\n      }\n    }\n\n    &.jl-unread {\n      background-color: lighten(@custom-color-3, 0.2);\n\n      h3 {\n        padding-right: 35px;\n\n        font-weight: 700;\n        padding-right: 20px;\n\n        &:after {\n          content: '\\3e';\n          font-family: 'snugg-6';\n          position: absolute;\n          display: block;\n          height: 20px;\n          right: 10px;\n          top: 8px;\n          top: 10px;\n          font-size: 17px;\n          padding-left: 5px;\n          margin: auto;\n          font-size: inherit;\n          color: rgba(0, 0, 0, 0.5);\n        }\n      }\n    }\n\n    &.jl-single-line {\n      .jl-everything-else {\n        padding-top: 13px;\n      }\n    }\n\n    &.jl-single-button {\n      .jl-buttons {\n        width: 36px;\n      }\n\n      .jl-everything-else {\n        margin-left: 35px;\n        padding-left: 5px;\n      }\n    }\n\n    &.jl-no-button {\n      .jl-everything-else {\n        margin-left: 0;\n      }\n    }\n  }\n\n  .jl-buttons {\n    width: 72px;\n    min-height: @job-row-min-height;\n    float: left;\n\n    .snugg-select {\n      min-height: @job-row-min-height;\n    }\n  }\n\n  .btn-map-it,\n  .jl-select {\n    position: relative;\n    padding: 0;\n    font-size: 18px;\n    padding: 6px;\n    border-radius: 0;\n    height: @job-row-min-height;\n    width: 36px;\n    color: rgba(0, 0, 0, 0.3);\n    background-color: transparent;\n    cursor: pointer;\n\n    &:hover,\n    &:focus,\n    &:focus-within {\n      background-color: lighten(@custom-color-4, 44%);\n      color: @custom-color-1;\n    }\n\n    &:active {\n      background-color: lighten(@custom-color-4, 40%);\n      box-show: 'none';\n    }\n\n    [class^='ico-'],\n    [class*=' ico-'] {\n      height: 22px;\n      position: absolute;\n      margin: auto;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n    }\n  }\n\n  .jl-select.checkbox-container {\n    display: inline-block;\n    width: 36px;\n    height: 60px;\n    float: left;\n\n    .checkmark {\n      top: 0;\n      bottom: 0;\n      left: 10px;\n      margin: auto;\n    }\n  }\n\n  .jl-everything-else {\n    cursor: pointer;\n    min-height: @job-row-min-height;\n    margin-left: 72px;\n\n    &:hover {\n      background-color: lighten(@custom-color-4, 44%);\n    }\n\n    &:active {\n      background-color: lighten(@custom-color-4, 35%);\n    }\n\n    .link-to-job {\n      display: block;\n\n      &:focus {\n        outline: none;\n        background-color: lighten(@custom-color-4, 44%);\n      }\n    }\n\n    .job-row-unread-indicator {\n      background-color: @color-blue;\n      border-radius: 2em;\n      width: 12px;\n      height: 12px;\n      position: absolute;\n      right: 16px;\n      left: auto;\n      top: 42%;\n      bottom: auto;\n    }\n  }\n\n  .snugg-selected .jl-everything-else:hover {\n    background-color: lighten(@custom-color-4, 42.5%);\n  }\n\n  // Standard box within a job listing.\n\n  .jl-box {\n    padding-top: 15px;\n    padding: 15px 1.5% 3px;\n    float: left;\n    color: @gray-darker;\n    position: relative;\n    overflow-x: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n\n  .jl-job-id {\n    width: 25%;\n  }\n\n  .jl-job-id-list {\n    padding: 8px 5px 0 4px;\n    line-height: 1.5;\n  }\n\n  .jl-alt-job-id {\n    line-height: 1.5;\n    padding-top: 2px;\n  }\n\n  .jl-account {\n    .clearfix();\n    padding: 6px 5px 0 4px;\n  }\n\n  .jl-discreet {\n    color: @gray;\n    white-space: nowrap;\n    overflow-x: hidden;\n  }\n\n  .jl-user {\n    width: 20%;\n  }\n\n  .jl-program {\n    width: 30%;\n  }\n\n  .jl-stage {\n    width: 20%;\n  }\n\n  .jl-date-and-time {\n    float: right;\n    padding: 5px 5px 0 0;\n\n    .cal-icon {\n      text-align: center;\n      min-width: 70px;\n      min-height: 57px;\n\n      .cal-icon__month {\n        font-size: 11px;\n        font-weight: 400;\n      }\n\n      .cal-icon__month-day {\n        font-weight: 400;\n        font-size: 22px;\n        line-height: 1.2em;\n      }\n\n      .cal-icon__week-day-and-time {\n        font-size: 11px;\n        font-weight: 400;\n        white-space: nowrap;\n      }\n    }\n  }\n\n  .jl-date {\n    float: none;\n    text-align: left;\n    padding-left: 0;\n  }\n\n  .jl-job-type {\n    float: right;\n    text-align: right;\n    padding-right: 0;\n  }\n}\n\n// ====================  RESPONSIVE TWEAKS ======================\n/* Extra small devices (phones, less than 768px) */\n/* No media query since this is the default in Bootstrap */\n\n/* ONLY extra small devices (phones less than 768px) */\n@media (max-width: @screen-xs-max) {\n  .listings {\n    .jl {\n      &.jl-unread {\n        h3 {\n          padding-right: 35px;\n\n          &:after {\n            top: 10px;\n            font-size: 17px;\n          }\n        }\n      }\n    }\n\n    .jl-job-id-list {\n      padding: 0;\n      line-height: inherit;\n    }\n\n    .jl-job-id-text {\n      display: inline;\n    }\n\n    .jl-alt-job-id {\n      display: inline;\n      padding-left: 4px;\n      padding-top: 0;\n    }\n\n    .jl-date-and-time {\n      float: right;\n      color: @gray;\n\n      .jl-box-left {\n        display: none;\n      }\n    }\n\n    .jl-select,\n    .btn-map-it,\n    .jl-everything-else {\n      min-height: 80px;\n\n      .job-row-unread-indicator {\n        right: 8px;\n      }\n    }\n\n    .jl-account {\n      height: auto;\n      padding: 8px 0 0 3px;\n\n      h3 {\n        max-width: none;\n        margin-top: 0;\n        padding: 2px 0;\n      }\n    }\n\n    .jl-address {\n    }\n\n    .jl-job-id,\n    .jl-program,\n    .jl-user {\n      display: inline;\n      width: auto;\n    }\n\n    .jl-job-stats {\n      color: @gray-light;\n      padding-top: 2px;\n\n      .jl-box {\n        width: auto;\n        padding: 0;\n        padding-left: 3px;\n\n        &:first-child {\n          &:after {\n            content: ' \\2022  ';\n          }\n        }\n      }\n    }\n\n    .jl-box {\n      padding: 3px;\n    }\n  }\n}\n\n#main-pane {\n  min-height: 70vh;\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (min-width: @screen-sm-min) {\n  .content.jobs-view {\n    background-color: transparent;\n    padding-top: @header-height;\n\n    #main-pane {\n      padding-left: 30px;\n    }\n  }\n}\n\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: @screen-md-min) {\n  .content.jobs-view {\n    .jl-date {\n      padding-left: 10%;\n    }\n\n    #main-pane {\n      padding-left: 26px;\n    }\n  }\n}\n\n/* Large devices (large desktops, 1200px and up) */\n@media (min-width: @screen-lg-min) {\n}\n",".content.activity-view {\n  background-color: transparent;\n  min-height: 500px;\n  padding-bottom: 10px;\n  background-image: url('../../img/ui/tiled-background-skewed@0.82x.png');\n  background-attachment: fixed;\n  background-repeat: repeat;\n  padding-top: @double-header-height;\n  &.activity-view-has-only-one-organization {\n    padding-top: @header-height;\n  }\n  .activity-feed-main-pane {\n    margin-bottom: 40px;\n    min-height: 700px;\n  }\n  .activity-feed-newer-activity-detected.alert.alert-alert {\n    border-radius: 30px;\n    min-width: 370px;\n    width: 370px;\n    left: 0;\n    right: 0;\n    margin-left: auto;\n    margin-right: auto;\n\n    h4 {\n      margin-bottom: 6px;\n      padding-top: 4px;\n    }\n    &:hover {\n      background-color: #e3f2fa;\n      color: darken(#e4eef4, 75%);\n    }\n    .close {\n      padding: 8px 18px 0px;\n      &:hover {\n        color: #000;\n      }\n    }\n  }\n  .activity-feed-cards-container {\n    position: relative;\n    .activity-feed-visual-card-link {\n      position: absolute;\n      top: 10px;\n      bottom: 0;\n      left: 9%;\n      right: auto;\n      width: 2px;\n      background-color: #bbb;\n      z-index: 0;\n    }\n  }\n  .activity-feed-end-of-new-notifications {\n    position: relative;\n    text-align: center;\n    max-width: 750px;\n    font-weight: 600;\n    margin-top: 30px;\n    margin-bottom: 30px;\n    span {\n      padding: 5px 15px;\n      position: relative;\n      color: darken(@custom-color-4, 2%);\n      text-transform: uppercase;\n      font-size: 14px;\n      font-weight: 600;\n      background-color: @gray-lightest;\n      border: 2px solid darken(@custom-color-4, 2%);\n      border-radius: 4px;\n      display: inline-block;\n    }\n    &:before {\n      display: block;\n      content: '';\n      height: 1px;\n      border-bottom: 2px dashed darken(@custom-color-4, 2%);\n      position: absolute;\n      top: 50%;\n      width: 100%;\n    }\n  }\n  .activity-feed-day-divider {\n    position: relative;\n    z-index: 1;\n    height: 30px;\n    min-width: 18%;\n    border-radius: 17px;\n    background-color: @gray;\n    color: @gray-lightestest;\n    padding: 6px 16px;\n    display: inline-block;\n    margin-bottom: 30px;\n    font-size: 13px;\n    font-weight: 600;\n    text-align: center;\n  }\n  .activity-card + .activity-feed-day-divider {\n    margin-top: 30px;\n  }\n  // Start styling the activity feed items\n  .activity-card {\n    z-index: 1;\n    position: relative;\n    min-height: 130px;\n    border-radius: 5px;\n    background-color: #ffffff;\n    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);\n    padding: 20px 20px 15px;\n    margin-bottom: 20px;\n    animation-duration: 1.2s;\n    max-width: 750px;\n    .activity-card-header {\n      font-size: 22px;\n      line-height: 1.3em;\n      font-weight: 700;\n      letter-spacing: 0;\n      margin-bottom: 10px;\n    }\n    .activity-card-title {\n    }\n    .activity-card-job-id {\n      color: @gray-light;\n      font-weight: 600;\n      border-radius: 4px;\n      padding-left: 5px;\n      display: inline-block;\n    }\n    .activity-card-message {\n      font-size: 14px;\n      letter-spacing: 0;\n      line-height: 19px;\n      color: @gray-dark;\n      margin-top: 10px;\n      margin-bottom: 10px;\n    }\n    .activity-card-user-name {\n      color: #555555;\n      font-size: 12px;\n      line-height: 17px;\n      text-align: center;\n      white-space: nowrap;\n      text-overflow: ellipsis;\n      width: 80px;\n      overflow-x: hidden;\n    }\n    .activity-card-time {\n      font-size: 12px;\n      line-height: 1.76em;\n      color: #555;\n      font-weight: 700;\n      white-space: nowrap;\n      text-align: left;\n      padding-top: 3px;\n      padding-bottom: 5px;\n    }\n    .activity-card-job-info {\n      margin-bottom: 20px;\n      font-weight: 600;\n    }\n  }\n}\n\n@media (min-width: @screen-sm-min) {\n  .content.activity-view {\n    padding-top: @header-height;\n    &.activity-view-has-only-one-organization {\n      padding-top: @header-height;\n    }\n    .activity-card {\n      .activity-card-header {\n        font-size: 20px;\n      }\n      .activity-card-job-id {\n      }\n      .activity-card-time {\n        text-align: center;\n      }\n      .activity-card-job-info {\n        margin-bottom: 10px;\n      }\n      .activity-card-message {\n        margin-left: 12px;\n      }\n    }\n  }\n}\n",".editable-prefix {\n  float: left;\n  margin-right: 20px;\n  padding-top: 6px;\n}\n\ninput.editable-title,\ninput.form-control.editable-title,\n.form-horizontal .form-group-lg input.form-control.editable-title {\n  display: block;\n  background-color: inherit;\n  border: 0;\n  width: 100%;\n  height: 28px;\n  box-shadow: none;\n  padding: 2px 0 3px 1px;\n  margin-top: 9px;\n  color: #000;\n  border-radius: 0;\n  border-bottom: 1px dashed @link-color;\n\n  &:hover {\n    background-color: lighten(@custom-color-2, 18%);\n  }\n\n  &:focus,\n  &:active {\n    .box-shadow(none);\n    outline: 0;\n    background-color: inherit;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n}\n\n.job-form {\n  input.editable-title,\n  input.form-control.editable-title,\n  .form-horizontal .form-group-lg input.form-control.editable-title {\n    // text-transform: uppercase;\n    font-weight: 600;\n    letter-spacing: 0.03em;\n    font-size: 15px;\n    margin-bottom: 10px;\n    text-align: left;\n    color: #666;\n  }\n}\n\n// All editable related classes\n\n.editable {\n  background-color: inherit;\n  font: inherit;\n  color: inherit;\n  height: inherit;\n  text-align: inherit;\n  width: 100%;\n  padding: 0;\n  border: 0;\n  border-radius: 0;\n  margin: 0;\n  line-height: inherit;\n  vertical-align: inherit;\n  .box-shadow(none);\n\n  &:hover {\n    background-color: desaturate(fade(@custom-color-4, 20%), 5%);\n    color: @gray-darker;\n    background-opacity: 1;\n    cursor: text;\n    outline: 0;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n\n  &:focus,\n  &:active {\n    .box-shadow(none) !important;\n    color: inherit !important;\n    outline: 0;\n    background-color: inherit !important;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n  }\n}\n\ninput[type='text'].editable {\n  border-bottom: 1px dashed @gray-light;\n\n  &[disabled] {\n    border-bottom: none;\n\n    &:hover {\n      background-color: inherit;\n      cursor: not-allowed;\n      -webkit-user-select: none;\n      user-select: none;\n    }\n  }\n}\n\n.editable-container {\n  overflow: hidden;\n}\n\n.report-present {\n  .report-page {\n    .editable-container {\n      &:hover {\n        background-color: transparent !important;\n        color: default !important;\n        cursor: default;\n      }\n    }\n\n    input[type='text'].editable {\n      border-bottom: none;\n    }\n\n    .disabled-hover {\n      pointer-events: none;\n    }\n  }\n}\n\n.inline-editable__target {\n  max-height: 580px;\n  overflow: hidden;\n}\n\n.report-sidebar {\n  .editable:hover {\n    background-color: @sidebar-inline-editable-hover-color; // lighten(@brand-info, 32%);\n  }\n}\n\n@media (min-width: @screen-sm-min) {\n}\n",".slidedown-enter {\n  min-height: 0px;\n  max-height: 0px;\n  transition: all 0.5s ease;\n  overflow: hidden;\n}\n.slidedown-enter.slidedown-enter-active {\n  max-height: 600px;\n}\n",".readonly-job {\n  & select,\n  & .form-control,\n  & input[type='text'],\n  & input[type='password'],\n  & input[type='datetime'],\n  & input[type='datetime-local'],\n  & input[type='date'],\n  & input[type='month'],\n  & input[type='time'],\n  & input[type='week'],\n  & input[type='number'],\n  & input[type='email'],\n  & input[type='url'],\n  & input[type='search'],\n  & input[type='tel'],\n  & input[type='color'],\n  & .uneditable-input {\n    .disabled();\n    pointer-events: none;\n    color: #555555 !important;\n    background-color: #f2f2f2 !important;\n    opacity: 1 !important;\n    border-color: #dfdfdf !important;\n    pointer-events: none;\n  }\n\n  .input-group-addon {\n    background-color: #f2f2f2 !important;\n    color: #555555 !important;\n    border-color: #dfdfdf !important;\n  }\n\n  .btn-group {\n    pointer-events: none;\n\n    & > .btn {\n      color: #222;\n      background-color: #f2f2f2;\n      border-color: #dfdfdf;\n\n      &.active {\n        box-shadow: inset 0 2px 0 rgba(0, 0, 0, 0.5);\n        color: #222;\n        background-color: #fff;\n      }\n    }\n  }\n\n  .DraftEditor-root {\n    .disabled();\n    pointer-events: none;\n  }\n\n  .themes-list {\n    .disabled();\n    pointer-events: none;\n  }\n\n  .snugg-btn-collectionAdd {\n    &:not(.readonly-exception) {\n      .disabled();\n      pointer-events: none;\n      background-color: #f9f9f9 !important;\n      border: 1px dashed #dfdfdf !important;\n    }\n  }\n\n  .snugg-btn-orange {\n    .disabled();\n    pointer-events: none;\n  }\n\n  .snugg-btn-delete {\n    .disabled();\n    pointer-events: none;\n  }\n\n  .report-photo-row {\n    pointer-events: none;\n  }\n}\n\n// Pad screens for fixed header in the job section\n.job-container {\n  padding-top: 91px;\n  padding-bottom: 600px;\n}\n\n// For collection sets like Attics and Vaults one below the other\n.collection-set {\n  padding-bottom: 20px;\n}\n\n// For collections like window systems\n.collection {\n  padding-bottom: 20px;\n\n  + .collection {\n    border-top: 1px solid darken(@custom-color-3, 7%);\n    padding-top: 20px;\n  }\n}\n\n// This is needed b/c we are absolutely positioning our tooltips as a child of this el\n.input-group {\n  position: relative;\n\n  &.deletable {\n    display: block;\n\n    select {\n      max-width: 76%;\n      // min-width: 70%;\n      width: auto;\n    }\n  }\n\n  // This needs to be inline for popover positioning. When measuring the\n  // popover's sibling's width it will be full-page width unless it's display:inline\n  .popover-sibling {\n    display: inline;\n  }\n}\n\n.delete-job-row {\n  float: right;\n  display: inline-block;\n  color: red;\n  margin-left: 16px;\n  padding: 12px 16px;\n  font-size: 16px;\n  border-radius: 3px;\n  background: inherit;\n  border: none;\n\n  &:hover {\n    color: #fff;\n    background-color: red;\n  }\n\n  &:active {\n    color: #fff;\n    background-color: darken(red, 7%);\n  }\n}\n\n// Used for the refrigerator and similar tables\n// where items are added/removed.\n.table-control-group {\n  &.jobform-refrigerator table {\n    // width: 470px;\n    td:last-child {\n      position: relative;\n      padding-right: 10px;\n    }\n  }\n\n  &.jobform-windows {\n    .table > tbody > tr > td {\n      border-top: none;\n      padding: 8px 4px;\n    }\n  }\n\n  .control-label {\n    padding-top: 50px;\n\n    span {\n      display: block;\n      padding-top: 46px;\n    }\n  }\n\n  .css-delete-row {\n    position: absolute;\n  }\n\n  table {\n    // width: 260px;\n    margin-bottom: 10px;\n  }\n\n  .delete-job-row {\n    position: absolute;\n    display: block;\n    float: left;\n    top: 3px;\n    right: -45px;\n  }\n}\n\n// ================== Utility timeline =============\n.date-difference {\n  float: right;\n  margin-top: -95px;\n  padding: 3px;\n  border-radius: 10px;\n  width: 67px;\n  border: dotted 1px #aaa;\n  .box-shadow(none);\n  display: block;\n  position: relative;\n  z-index: 2;\n\n  &:before {\n    content: '';\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 20px;\n    margin: auto;\n    width: 1px;\n    height: 177px;\n    border-left: 1px dotted #aaa;\n  }\n\n  &:after {\n    content: '\\25CB'; //\"\\25CB\"; //\"\\25C2\"; // \"\\29BF\";\n    display: block;\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 90px;\n    bottom: 0;\n    margin: auto;\n    text-align: center;\n    font-size: 18px;\n    line-height: 7px;\n    height: 10px;\n    width: 15px;\n    color: @gray;\n    background-color: white;\n  }\n\n  &.label {\n    background-color: white;\n  }\n\n  &.label-warning {\n    background-color: #f7efd3;\n    color: darken(#f7efd3, 70%);\n    border-color: darken(#f7efd3, 10%);\n  }\n\n  &.label-error {\n    background-color: #f1e3e3;\n    color: #b21212;\n    border-color: darken(#9f1717, 10%);\n  }\n\n  &.date-difference-start {\n    content: '';\n    border: none;\n    .box-shadow(none);\n\n    &:before {\n      top: 30px;\n      height: 50px;\n    }\n\n    &:after {\n      content: '\\29BF'; //\"\\25CB\"; //\"\\25C2\"; // \"\\29BF\";\n      top: 47px;\n    }\n  }\n\n  &.date-difference-end {\n    content: '';\n\n    &:before {\n      top: 17px;\n      height: 30px;\n    }\n\n    &:after {\n      content: '\\29BF'; //\"\\25CB\"; //\"\\25C2\"; // \"\\29BF\";\n      top: 47px;\n    }\n  }\n}\n\n// ====================  RESPONSIVE TWEAKS ======================\n/* Extra small devices (phones, less than 768px) */\n/* No media query since this is the default in Bootstrap */\n\n/* ONLY extra small devices (phones less than 768px) */\n\n@media (max-width: @screen-xs-max) {\n  .push-left {\n    .scroll-spy-clicked,\n    &.scroll-spy {\n      left: @side-left-width;\n      right: -@side-left-width;\n      .transition(@push-menu-transition);\n    }\n  }\n\n  .form-group-utility-date:last-child {\n    .date-difference {\n      &:before {\n        height: 80px;\n      }\n    }\n  }\n}\n\n// Up to small devices\n@media (max-width: @screen-sm-max) {\n  // Make multiple columns of fields more compact to render better on narrow displays\n  .form-group-narrow {\n    .input-lg,\n    input.form-control {\n      padding-left: 8px;\n      padding-right: 5px;\n    }\n\n    .input-group-addon {\n      min-width: 20px;\n      padding-left: 5px;\n      padding-right: 5px;\n    }\n\n    .btn-group > .btn {\n      padding-left: 9px;\n      padding-right: 9px;\n    }\n  }\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (min-width: @screen-sm-min) {\n  .push-left {\n    .scroll-spy-clicked,\n    .scroll-spy {\n      left: @side-left-width;\n      right: -@side-left-width;\n      .transition(@push-menu-transition);\n    }\n  }\n\n  .scroll-spy-clicked,\n  .scroll-spy {\n    left: @side-left-width;\n    .transition(@push-menu-transition);\n  }\n\n  .delete-job-row {\n    float: none;\n  }\n\n  .job-container {\n    padding-top: 46px;\n  }\n}\n\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: @screen-md-min) {\n  .date-difference {\n    margin-top: 0;\n\n    &:before {\n      left: 0;\n      right: 0;\n      top: 18px;\n      height: 95px;\n    }\n\n    &:after {\n      left: 0;\n      right: 0;\n      top: 90px;\n      bottom: 0;\n      height: 10px;\n    }\n\n    &.date-difference-start {\n      margin-top: 0;\n\n      &:before {\n        top: 45px;\n        height: 50px;\n      }\n\n      &:after {\n        content: '\\29BF'; //\"\\25CB\"; //\"\\25C2\"; // \"\\29BF\";\n        top: 47px;\n      }\n    }\n\n    &.date-difference-end {\n      &:before {\n        top: 16px;\n        height: 30px;\n      }\n    }\n  }\n}\n\n@media (max-height: @short-screen-max) {\n  .push-left {\n    .scroll-spy-clicked,\n    .scroll-spy {\n      left: @side-left-width-short;\n      right: -@side-left-width-short;\n      .transition(@push-menu-transition);\n    }\n  }\n}\n\n@media (max-height: @short-screen-max) and (min-width: @screen-sm-min) {\n  .scroll-spy-clicked,\n  .scroll-spy {\n    left: @side-left-width-short;\n    right: -@side-left-width-short;\n    .transition(@push-menu-transition);\n  }\n}\n","@border-color: #cdcdcd;\n@rec-row-height: 62px;\n\n.rec-content {\n  .add-rec {\n    margin: 20px 0 25px;\n  }\n\n  .nav-tabs > li.active > a {\n    background-color: #f4f4f4;\n  }\n\n  .rec-row {\n    .clearfix();\n    box-shadow: 0 3px 3px rgba(0, 0, 0, 0.1);\n    border-radius: 0;\n    font-size: 1em;\n    margin-bottom: 10px;\n    background-color: #fff;\n    border: 1px solid #eaeaea;\n    border-bottom: none;\n    cursor: pointer;\n    position: relative;\n    user-select: none;\n\n    &:hover,\n    &:focus {\n      box-shadow: 0 1px 8px rgba(0, 0, 0, 0.2);\n      z-index: 1;\n    }\n\n    &:active {\n      box-shadow: 0 2px 20px rgba(0, 0, 0, 0.05);\n      z-index: 10;\n    }\n\n    &.rec-header {\n      min-height: 20px;\n      height: 20px;\n      padding: 0 8px;\n      text-align: center;\n      font-size: 0.9em;\n      text-transform: uppercase;\n      border: none;\n      box-shadow: none;\n      background-color: transparent;\n\n      &:hover {\n        box-shadow: none;\n      }\n\n      .span-rec {\n        padding-top: 0;\n        padding-bottom: 5px;\n        text-align: right;\n\n        &.span-cost {\n          text-align: right;\n        }\n      }\n\n      .span-accept {\n        text-align: left;\n      }\n    }\n\n    &.new-rec-row {\n      border: 1px dashed @border-color;\n\n      .custom-rec-name {\n        color: #222;\n        font-weight: 700;\n      }\n    }\n  }\n\n  .btn-go {\n    height: @rec-row-height;\n    border-radius: 0;\n    font-size: 18px;\n    padding-top: 23px;\n    border-top-right-radius: 4px;\n  }\n\n  .span-rec {\n    padding-top: 4px;\n    padding-bottom: 8px;\n\n    .span-label {\n      padding-bottom: 4px;\n      color: @gray;\n    }\n  }\n\n  .span-rec-name {\n    display: block;\n    font-weight: 600;\n    padding-top: 15px;\n    padding-left: 15px;\n    color: @custom-color-1;\n\n    .span-rec-title {\n      font-size: 0.9em;\n      opacity: 0.7;\n      font-weight: 400;\n    }\n\n    .notes-label {\n      font-size: 0.9em;\n    }\n\n    .general-label {\n      margin: 0;\n    }\n  }\n\n  .span-cost {\n    .span-label {\n      padding-right: 10px;\n      text-align: left;\n    }\n\n    width: 100%;\n    float: left;\n    text-align: right;\n    padding-right: 5px;\n\n    input {\n      text-align: right;\n      padding-right: 5px;\n    }\n  }\n\n  .span-potential {\n    width: 25%;\n    text-align: right;\n    float: left;\n    padding-right: 10px;\n  }\n\n  .span-savings {\n    width: 25%;\n    text-align: right;\n    float: left;\n    padding-right: 10px;\n  }\n\n  .span-sir {\n    width: 25%;\n    text-align: right;\n    float: left;\n    padding-right: 10px;\n  }\n\n  .span-priorities {\n    width: 45px;\n    float: left;\n    margin-right: 0px;\n  }\n\n  .span-blank-state {\n    text-align: center;\n    padding: 22px 0;\n  }\n\n  .rec-area {\n    border-top: none;\n    border-right: 1px solid @border-color;\n    border-bottom: 1px solid @border-color;\n    border-left: 1px solid @border-color;\n  }\n\n  .rec-untitled {\n    color: lighten(@custom-color-1, 40%);\n  }\n}\n\n// INCENTIVE BADGE FOR REFINE TABLE\n.incentive-badge-container {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: center;\n  gap: 2px;\n  padding-top: 4px;\n  padding-bottom: 8px;\n  padding-right: 0;\n  padding-left: 0;\n  height: auto;\n}\n\n.incentive-name-badge {\n  font-size: 10px;\n  font-weight: 600;\n  color: #fff;\n  line-height: 1.2;\n  padding: 2px 8px;\n  background-color: #555;\n  border-radius: 24px;\n  text-align: center;\n\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 200px;\n}\n\n@media (min-width: @screen-lg-min) {\n  .incentive-badge-container {\n    padding-top: 4px;\n    padding-bottom: 4px;\n    padding-right: 0px;\n    padding-left: 8px;\n    height: 60px;\n    justify-content: center;\n  }\n\n  .incentive-name-badge {\n    max-width: 120px;\n  }\n}\n\n// NEW REFINE TABLE\n.refine-table {\n  width: 100%;\n  border-collapse: collapse;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-right: 15px;\n\n  & > div {\n    box-sizing: border-box;\n    padding-right: 16px;\n  }\n\n  .refine-name {\n    width: 100%;\n    order: 1;\n  }\n\n  .refine-status {\n    width: 100%;\n    padding-left: 16px;\n    display: flex;\n    order: 2;\n  }\n\n  .refine-cost {\n    width: 45%;\n    padding-left: 16px;\n    padding-right: 5%;\n    padding-bottom: 8px;\n    text-align: left;\n    order: 3;\n  }\n\n  .refine-incentives {\n    width: 45%;\n    padding-left: 5%;\n    padding-bottom: 8px;\n    text-align: left;\n    order: 4;\n  }\n\n  .refine-incentive-sources {\n    width: 100%;\n    padding-left: 16px;\n    padding-bottom: 8px;\n    order: 5;\n  }\n\n  .refine-savings {\n    width: 50%;\n    padding-left: 16px;\n    padding-bottom: 16px;\n    text-align: left;\n    order: 6;\n  }\n\n  .refine-sir {\n    width: 50%;\n    padding-bottom: 16px;\n    text-align: left;\n    order: 7;\n  }\n}\n\n.refine-table-head {\n  display: none;\n}\n\n@media (min-width: @screen-xs-min) {\n  .refine-table {\n    & > div {\n      padding-right: 8px;\n    }\n\n    .refine-cost {\n      width: 45%;\n    }\n\n    .refine-incentives {\n      width: 45%;\n    }\n\n    .refine-incentive-sources {\n      width: 100%;\n    }\n\n    .refine-savings {\n      width: 50%;\n    }\n\n    .refine-sir {\n      width: 50%;\n    }\n  }\n}\n\n@media (min-width: @screen-sm-min) {\n  .refine-table {\n    .refine-name {\n      width: 50%;\n      order: 1;\n    }\n\n    .refine-status {\n      width: 50%;\n      justify-content: flex-end;\n      order: 2;\n    }\n\n    .refine-cost {\n      width: 30%;\n      padding-right: 0;\n      padding-bottom: 8px;\n      order: 3;\n    }\n\n    .refine-incentives {\n      width: 25%;\n      padding-left: 5%;\n      padding-bottom: 8px;\n      order: 4;\n    }\n\n    .refine-savings {\n      width: 20%;\n      padding-left: 0;\n      padding-bottom: 8px;\n      order: 5;\n    }\n\n    .refine-sir {\n      width: 20%;\n      padding-bottom: 8px;\n      order: 6;\n    }\n\n    .refine-incentive-sources {\n      width: 100%;\n      order: 7;\n    }\n  }\n}\n\n@media (min-width: @screen-lg-min) {\n  .refine-table {\n    .refine-name {\n      width: 22%;\n      order: 1;\n    }\n\n    .refine-status {\n      width: 26%;\n      justify-content: flex-start;\n      padding: 0;\n      order: 2;\n    }\n\n    .refine-cost {\n      width: 14%;\n      order: 3;\n    }\n\n    .refine-incentives {\n      width: 10%;\n      padding-left: 0;\n      padding-right: 14px;\n      order: 5;\n      text-align: right;\n    }\n\n    .refine-incentive-sources {\n      width: 14%;\n      padding: 0;\n      order: 5;\n    }\n\n    .refine-savings {\n      width: 6%;\n      text-align: right;\n      order: 6;\n    }\n\n    .refine-sir {\n      width: 6%;\n      text-align: right;\n      order: 7;\n    }\n  }\n\n  .refine-table-head {\n    .refine-table();\n    display: flex;\n    font-size: 13px;\n    text-transform: uppercase;\n    padding: 0px 5px 4px 15px;\n    align-items: flex-end;\n  }\n}\n\n// ====================  RESPONSIVE TWEAKS ======================\n/* Extra small devices (phones, less than 768px) */\n/* No media query since this is the default in Bootstrap */\n\n/* ONLY extra small devices (phones less than 768px) */\n@media (max-width: @screen-xs-max) {\n  .rec-content {\n    .rec-row {\n    }\n  }\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (min-width: @screen-sm-min) {\n  .rec-content {\n    .rec-row {\n      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n      // border: 1px solid rgba(0,0,0,0.08);\n      border-radius: 0;\n      min-height: @rec-row-height;\n      margin-bottom: 0;\n      padding-left: 10px;\n\n      .span-cost {\n        .input-group-addon {\n          min-width: 20px;\n        }\n      }\n\n      .span-sir,\n      .span-savings {\n        padding-top: 21px;\n      }\n\n      .btn-go {\n        border-top-right-radius: 0;\n      }\n    }\n\n    .span-accept {\n      .btn {\n        padding: 8px 4px;\n        font-size: 0.85em;\n      }\n    }\n  }\n}\n\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: @screen-md-min) {\n  .rec-content {\n    .span-accept {\n      .btn {\n        padding: 6px 9px;\n        font-size: 1em;\n      }\n    }\n\n    .span-cost {\n      width: 100%;\n    }\n  }\n}\n\n/* Large devices (large desktops, 1200px and up) */\n@media (min-width: @screen-lg-min) {\n}\n",".rec-single {\n  .span-rec-name {\n    .form-group {\n      margin-bottom: 0;\n    }\n  }\n  .span-accept {\n    .btn {\n      padding-left: 8px;\n      padding-right: 8px;\n    }\n  }\n  .btn-up,\n  .btn-down {\n    border-radius: 0;\n    border-right: none;\n    background-image: none;\n    border-bottom: none;\n    border-top: none;\n    border-left: none;\n    padding: 6px 9px;\n    &:focus {\n      background-color: @custom-color-3;\n    }\n    &:active {\n      background-color: darken(@custom-color-3, 16%);\n    }\n  }\n  .btn-down {\n    border-top: 1px solid darken(@custom-color-3, 4%);\n  }\n  .rec-blank-state {\n    padding: 10px;\n    margin: 20px 0;\n    border-radius: 2px;\n  }\n  .span-value {\n    padding-top: 7px;\n  }\n\n  /* Photo row styling*/\n  .photo-row-container {\n    padding-bottom: 20px;\n  }\n  .photo-row {\n    padding-top: 10px;\n    padding-bottom: 5px;\n    transition: outline 0.2s ease;\n    position: relative;\n    border-bottom: 1px dashed #ccc;\n    // Animation\n    max-height: 1000px;\n    overflow: hidden;\n    opacity: 1;\n    transform: scale(1);\n    &.photo-row-deleting {\n      .animate-hide();\n    }\n    &:first-child {\n      .span-priorities {\n        .btn-up {\n          opacity: 0.5;\n          cursor: not-allowed;\n          &:hover {\n            background-color: @custom-color-3;\n          }\n        }\n      }\n    }\n    &:last-child {\n      .span-priorities {\n        .btn-down {\n          opacity: 0.5;\n          cursor: not-allowed;\n          &:hover {\n            background-color: @custom-color-3;\n          }\n        }\n      }\n    }\n\n    h4 {\n      padding: 4px 0;\n    }\n    &.highlight-delete {\n      // border: 1px dashed red;\n      background-color: #f1e3e3;\n\n      // background-color: red;\n    }\n    .photo-caption {\n      height: 115px;\n    }\n    .uploader-container {\n      .uploadcare-widget-circle--canvas {\n        display: none;\n      }\n    }\n  }\n  textarea.form-control {\n    border: none;\n    box-shadow: none;\n    background-color: transparent;\n    &:hover {\n      background-color: desaturate(lighten(@custom-color-4, 42%), 5%);\n      &:active,\n      &:focus {\n        background-color: transparent;\n      }\n    }\n  }\n}\n\n// ====================  RESPONSIVE TWEAKS ======================\n/* Extra small devices (phones, less than 768px) */\n/* No media query since this is the default in Bootstrap */\n\n/* ONLY extra small devices (phones less than 768px) */\n@media (max-width: @screen-xs-max) {\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (min-width: @screen-sm-min) {\n}\n\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: @screen-md-min) {\n}\n\n/* Large devices (large desktops, 1200px and up) */\n@media (min-width: @screen-lg-min) {\n}\n","@border-color: #cdcdcd;\n\n.recommendation-content {\n  .recommendation-area {\n    border-top: none;\n    border-right: 1px solid @border-color;\n    border-bottom: 1px solid @border-color;\n    border-left: 1px solid @border-color;\n\n    .section-header {\n      margin-top: 34px;\n      border-bottom: 1px solid #e2e2e2;\n      .control-label {\n        padding-top: 0;\n      }\n    }\n  }\n}\n","//- ================ REPORT VARIABLES =================\n\n// Color palette\n@report-color-1: #182416; //very dark green\n@report-color-2: @gray; //dark gray\n@report-color-3: #dae8cc;\n@report-color-4: #e4e4e4; // light gray\n@report-color-5: #262626; // dark gray (body)\n@report-color-6: 'Unused';\n@report-color-7: #fff; // plain old white\n@report-color-8: #797979; // gray\n@report-color-9: darken(\n  @report-color-3,\n  62%\n); //#648B57; // dark green - background for callout\n@report-color-10: 'Unused';\n@report-border-radius: 3px;\n\n@report-font-family: @font-family-sans-serif;\n\n//-----------------  Calculating for pagination -----------------\n\n@report-page-width: @reportGridRowWidth; //942, 953, 964\n\n// IMPORTANT: @report-page variables are actualy used on .r-container\n// LETTER PAPER ASPECT RATIO: On an 8.5 x 11 page, the aspect ratio is 1 : 1.294\n// DEPRECATED ASPECT RATIO: Assuming a .5\" margin on all sides, the printable page size becomes 7.5 x 10.  The aspect ratio thus becomes 1 :1.333;\n\n// CURRENT ASPECT RATIO: (16/08/2016) - We must factor the margin (technically padding)\n// which is 0.3in 0.5in 0.2in. Printable papersize becomes 8 x 10. Ratio is thus 1:1.25\n\n@report-page-height: round((@report-page-width / 1.25)); // 763 but was 719\n\n// Use this to set header and footer height\n@report-header-height: 60px; // previously 12%\n@report-footer-height: 35px; // 50px total when accounting for top margin of 15px\n\n// Use this to calculate .report-main and .report-sidebar\n@report-main-height: @report-page-height - @report-header-height -\n  @report-footer-height;\n// @report-main-height: 598px;  // 598, 622, 629 < v3 uses this line and comments the one above\n\n// Use this to pad the sidebar and calculate sidebar height\n@report-sidebar-padding: 8px 12px;\n\n// Set the height of the report sidebar accounting for padding and potential border around sidebar area\n@report-sidebar-height: @report-main-height;\n// Min height on textareas until we find a better fix for blank states\n@textarea-min-height: 79px;\n\n.repaginate-report {\n  position: fixed;\n  left: 10px;\n  bottom: 10px;\n}\n\n.popover {\n  &.popover-report-settings {\n    .popover-title {\n      font-weight: 600;\n      font-size: 16px;\n      padding: 10px 14px;\n    }\n\n    .popover-content {\n      padding: 0;\n    }\n  }\n\n  &.popover-report-settings-pages {\n    // left: 7px;\n    .arrow {\n      left: 50px;\n      right: auto;\n    }\n  }\n\n  &.popover-report-settings-elements {\n    .arrow {\n      left: 106px;\n      right: auto;\n    }\n  }\n\n  &.popover-report-themes {\n    max-width: 250px;\n\n    .arrow {\n      left: 156px;\n      right: auto;\n    }\n  }\n\n  &.popover-report-signature-pages {\n    max-width: 250px;\n    left: 200px;\n\n    .arrow {\n      right: 56px;\n      left: auto;\n    }\n  }\n}\n\n.popover-report-link-items {\n  padding: 8px 12px;\n  border-radius: 6px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 4px;\n\n  &:last-child {\n    margin-bottom: 4px;\n  }\n\n  &:hover {\n    background-color: #e6e6e6;\n  }\n}\n\n// Report Scroll Sply\n.scroll-spy.report-scroll-spy {\n  position: fixed;\n  background: darken(@custom-color-3, 4%);\n  width: 100%;\n  z-index: 12;\n  height: auto;\n  top: 25px;\n  padding: 0;\n  opacity: 1;\n  border-top: 1px solid darken(@custom-color-3, 15%);\n}\n\n// Editing Toolbars in header\n@rep-toolbar-height: @header-height;\n\n.content-header.content-header-report {\n  background-color: @gray-lightest;\n  min-height: @rep-toolbar-height;\n  height: auto;\n\n  h1 {\n    width: 85%;\n    display: inline-block;\n    font-weight: 300;\n    margin: 0;\n    font-size: 18px;\n    color: #575757;\n    line-height: @rep-toolbar-height;\n\n    input[type='text'] {\n      width: 100%;\n    }\n  }\n\n  .rep-toolbar {\n    width: 100%;\n    height: @rep-toolbar-height;\n    float: left;\n\n    .rep-btn {\n      position: relative;\n      text-align: center;\n      color: @custom-color-1;\n      background-color: transparent;\n      white-space: inherit;\n      font-size: 11px;\n      min-width: @rep-toolbar-height;\n      min-height: 42px;\n      padding: 5px 4px 3px;\n      margin: 2px 4px 3px 0;\n\n      [class^='ico-'],\n      [class*=' ico-'] {\n        display: block;\n        float: none;\n        font-size: 18px;\n        line-height: 18px;\n      }\n\n      &:last-child {\n        margin-right: 0;\n      }\n\n      &:hover {\n        .box-shadow(0 0 5px rgba(0, 0, 0, 0.5));\n        background-color: inherit;\n      }\n\n      &:active,\n      &:focus,\n      &.active {\n        .box-shadow(inset 0 0 3px rgba(0, 0, 0, 0.3));\n        background-color: darken(@custom-color-3, 6%);\n      }\n    }\n  }\n\n  .rep-toolbar-report {\n    text-align: center;\n  }\n\n  .rep-toolbar-page {\n    float: left;\n    text-align: center;\n\n    > .btn {\n      width: 20%;\n    }\n  }\n}\n\n.themes-list {\n  margin: 0;\n  padding: 0;\n\n  .btn {\n    width: 100%;\n    clear: both;\n    float: none;\n    text-align: left;\n    border-radius: 3px;\n    padding: 10px;\n\n    &.active {\n      .box-shadow(none);\n    }\n  }\n\n  .report-theme {\n    width: 60px;\n    height: 40px;\n    margin: 0 10px 0 0;\n  }\n}\n\n.report-theme {\n  height: 17px;\n  width: 25px;\n  margin: auto;\n  border-radius: 2px;\n  margin-bottom: 3px;\n  border: 1px solid @custom-color-1;\n}\n\n.report-present {\n  // styles body of present page\n  background: #e4e4e4;\n  padding-top: 5px;\n  min-width: @report-page-width + 40;\n}\n\n// Encapsulates all report pages\n.in-app-report {\n  .content {\n    background-color: lighten(desaturate(@custom-color-3, 5%), 3%);\n    overflow-x: scroll;\n    padding-top: 50px;\n  }\n\n  .editable-page-header {\n    margin-right: 20px;\n    width: unit(ceil(965 * 0.7), px);\n  }\n\n  .report-photo-row {\n    textarea {\n      opacity: 0;\n      padding: 10px 5px 5px;\n\n      &:hover {\n        background-color: rgba(0, 0, 0, 0.1);\n      }\n\n      &:focus {\n        .box-shadow(0 0 10px lighten(@custom-color-1, 45%));\n        border-color: lighten(@custom-color-1, 50%);\n        opacity: 1;\n        transition: opacity 0.2s ease;\n      }\n    }\n  }\n\n  .report-page {\n    zoom: 70%;\n    margin: 10px 0;\n    border-radius: 4px;\n    opacity: 1;\n    padding: 10px;\n    width: 965px;\n    .box-shadow(0 0 10px rgba(0, 0, 0, 0.4));\n\n    .report-body,\n    .report-main {\n      height: auto;\n      overflow: visible;\n      min-height: @report-main-height;\n    }\n\n    .report-sidebar {\n      height: auto;\n      min-height: @report-main-height;\n      position: absolute;\n      bottom: 10px;\n      top: 10px;\n      width: 222px;\n\n      dl dt {\n        max-width: 145px;\n      }\n    }\n\n    .report-sidebar-v2 {\n      min-height: @report-main-height;\n    }\n  }\n}\n\n.report-page {\n  font-family: @report-font-family;\n  background-color: #fff;\n  border: 1px solid desaturate(darken(@custom-color-3, 10%), 10%);\n  padding: 30px;\n  margin: 10px 9px 20px 20px;\n  width: 1005px;\n  position: relative;\n  border-radius: 4px;\n  /* -- warn if printing on the in-app report page -- */\n\n  // =================== BASE STYLING =======================\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    margin: 0 0 10px 0;\n    text-rendering: optimizespeed;\n  }\n\n  h1 {\n    color: @report-color-1;\n    font-size: 32px;\n    font-weight: 600;\n    margin: 10px 0 0;\n  }\n\n  h2 {\n    color: @report-color-2;\n    font-size: 22px;\n    font-weight: 600;\n  }\n\n  h3 {\n    color: darken(@report-color-2, 15%);\n    font-size: 18px;\n    font-weight: 600;\n    margin-bottom: 5px;\n  }\n\n  h4 {\n    color: @report-color-5;\n    font-size: 16px;\n    font-weight: 400;\n    margin-bottom: 5px;\n  }\n\n  h5 {\n    color: @report-color-5;\n    font-size: 15px;\n    margin-bottom: 5px;\n  }\n\n  h6 {\n    margin: 0px;\n  }\n\n  p {\n    line-height: 18px;\n  }\n\n  a {\n    color: #4182d0;\n  }\n\n  // =================== MODULES/COMPONENTS =======================\n  hr.thick {\n    border-top: 4px solid @gray-lighter;\n  }\n\n  .report-header {\n    .clearfix();\n    height: @report-header-height;\n    overflow: hidden;\n\n    .company {\n      img {\n        height: 60px;\n        width: auto;\n      }\n    }\n\n    .program-branding {\n      height: @report-header-height - 5;\n      overflow: hidden;\n      text-align: right;\n      font-size: 12px;\n      .clearfix();\n\n      span {\n        float: right;\n        text-align: right;\n        display: block;\n      }\n    }\n\n    .report-title {\n      height: 60px;\n      overflow-y: hidden;\n      position: relative;\n\n      .report-title-input {\n        color: @report-color-1;\n        font-size: 36px;\n        margin: 0;\n        height: auto;\n        padding: 1px 0 0 0;\n        width: 99%;\n      }\n    }\n  }\n\n  .report-logo {\n    height: @report-header-height;\n    overflow: hidden;\n    .clearfix();\n\n    img {\n      float: left;\n      min-height: 30px;\n      display: block;\n      max-height: 55px;\n      max-width: 222px;\n      width: auto;\n      height: auto;\n      .box-sizing(border-box);\n    }\n\n    h2 {\n      text-align: center;\n      padding: 8px 3px;\n      font-size: 18px;\n      white-space: nowrap;\n      overflow: hidden;\n    }\n  }\n\n  .report-logo-area {\n    // width: 220px;\n    height: 60px;\n    text-align: center;\n  }\n\n  .report-logo-area span {\n    display: block;\n    padding-top: 25px;\n  }\n\n  .report-body {\n    height: @report-main-height;\n  }\n\n  .report-sidebar-borderless {\n    position: relative;\n    height: @report-sidebar-height;\n  }\n\n  .report-sidebar {\n    position: relative;\n    height: @report-sidebar-height;\n    border-radius: @report-border-radius;\n    line-height: 1.3em;\n    // padding: @report-sidebar-padding;\n\n    h3 {\n      margin-top: 10px;\n      font-size: 16px;\n      font-weight: 600;\n    }\n\n    dl {\n      margin-top: 10px;\n      margin-bottom: 10px;\n      line-height: 1em;\n      .clearfix();\n\n      dt {\n        float: left;\n        font-weight: normal;\n        max-width: 125px;\n        min-width: 100px;\n        margin-bottom: 6px;\n        line-height: 18px;\n        .clearfix();\n      }\n\n      dd {\n        float: right;\n        margin-bottom: 6px;\n        line-height: 18px;\n      }\n    }\n  }\n\n  .sidebar-header {\n    padding: 12px;\n    border-radius: 3px 3px 0 0;\n\n    h3 {\n      font-size: 14px;\n      margin: 0;\n      text-transform: uppercase;\n      font-weight: 500;\n    }\n  }\n\n  .sidebar-body {\n    position: relative;\n    height: 100%;\n\n    input[type='date'],\n    input[type='time'],\n    input[type='datetime-local'],\n    input[type='month'] {\n      line-height: 1.42;\n    }\n  }\n\n  .header-key-value {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n\n    .sidebar-label {\n      font-size: 12px;\n      line-height: 1.42;\n      color: #fff;\n      font-weight: 600;\n    }\n\n    .sidebar-value {\n      font-size: 24px;\n      font-weight: 600;\n      line-height: 1.42;\n      color: #fff;\n    }\n  }\n\n  .sidebar-section {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: @report-sidebar-padding;\n\n    font-size: 12px;\n    line-height: 1.5;\n    font-weight: 500;\n    color: #333;\n\n    p {\n      font-size: 12px;\n      line-height: 1.5;\n      font-weight: 500;\n      color: #333;\n    }\n\n    &.medium-font {\n      font-size: 14px;\n      line-height: 1.5;\n\n      p {\n        font-size: 14px;\n        line-height: 1.5;\n      }\n    }\n\n    &.small-font {\n      font-size: 12px;\n      line-height: 1.5;\n\n      p {\n        font-size: 12px;\n        line-height: 1.5;\n      }\n    }\n\n    &.solid-separator {\n      border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n    }\n\n    &.dashed-separator {\n      border-bottom: 1px dashed rgba(0, 0, 0, 0.2);\n    }\n\n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  .sidebar-section-title {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.42;\n    color: #111;\n    margin: 8px 0 0 0;\n\n    &.medium-font {\n      font-size: 14px;\n    }\n  }\n\n  .sidebar-key-value-container {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n  }\n\n  .solid-separator {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  }\n\n  .dashed-separator {\n    border-bottom: 1px dashed rgba(0, 0, 0, 0.2);\n  }\n\n  .sidebar-key-value-horizontal {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    gap: 4px;\n    padding: 6px 0;\n\n    .sidebar-label {\n      font-size: 12px;\n      font-weight: 500;\n      line-height: 1.42;\n      color: #333;\n      text-align: left;\n    }\n\n    .sidebar-value {\n      font-size: 12px;\n      font-weight: 700;\n      line-height: 1.42;\n      color: #111;\n      text-align: right;\n    }\n\n    &.solid-separator {\n      border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n\n    &.dashed-separator {\n      border-bottom: 1px dashed rgba(0, 0, 0, 0.2);\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n\n    &:first-child {\n      padding-top: 0;\n    }\n\n    &:last-child {\n      padding-bottom: 0;\n    }\n\n    &.reverse-order {\n      flex-direction: row-reverse;\n    }\n  }\n\n  .sidebar-key-value-vertical {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    padding: 12px 0;\n\n    .sidebar-label {\n      font-size: 12px;\n      font-weight: 600;\n      line-height: 1.42;\n      color: #555;\n    }\n\n    .sidebar-value {\n      font-size: 20px;\n      line-height: 1.42;\n      color: #111;\n      font-weight: 600;\n    }\n\n    &:first-child {\n      padding-top: 0;\n    }\n\n    &:last-child {\n      padding-bottom: 0;\n    }\n\n    &.solid-separator {\n      border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n\n    &.dashed-separator {\n      border-bottom: 1px dashed rgba(0, 0, 0, 0.2);\n\n      &:last-child {\n        border-bottom: none;\n      }\n    }\n\n    &.reverse-order {\n      flex-direction: column-reverse;\n    }\n\n    &.no-bottom-spacing {\n      padding-bottom: 0;\n    }\n  }\n\n  .uppercase {\n    text-transform: uppercase;\n  }\n\n  // report-sidebar\n  .report-sidebar-v2 {\n    height: @report-sidebar-height;\n    border-radius: @report-border-radius;\n    position: relative;\n  }\n\n  .report-sidebar-v2--title {\n    font-size: 16px;\n    color: #000000;\n    line-height: 1.5;\n    font-weight: 600;\n    padding-left: 16px;\n    padding-right: 16px;\n    padding-top: 11px;\n    padding-bottom: 12px;\n    margin-bottom: 0;\n  }\n\n  .report-main {\n    height: @report-main-height;\n    overflow: hidden;\n  }\n\n  .report-photo-row {\n    border-radius: @report-border-radius;\n  }\n\n  .report-footer {\n    .clearfix();\n    padding-top: 10px;\n    color: @report-color-8;\n    height: @report-footer-height;\n    font-size: 12px;\n\n    .program-logo-footer {\n      max-height: @report-footer-height - 10;\n      width: auto;\n      margin-left: 5px;\n    }\n  }\n\n  // report-footer\n\n  .recommendation-category-label {\n    font-size: 15px;\n    margin-bottom: 12px;\n    color: rgba(0, 0, 0, 0.7);\n    text-transform: uppercase;\n  }\n\n  .notes-header,\n  .now-and-goals-header {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1.42;\n    color: #555;\n  }\n\n  .upgrade-details-section {\n    margin-top: 6px;\n    padding-top: 6px;\n  }\n\n  //- ================ Cover page styling =================\n  &.report-page-cover {\n    .report-body {\n      .report-main {\n        .snugg-upload-prompt-text {\n          position: absolute;\n          z-index: 3;\n          top: 0;\n          bottom: 0;\n          left: 0;\n          right: 0;\n          margin: auto;\n          height: 150px;\n          width: 160px;\n          text-align: center;\n          font-size: 24px;\n          color: @gray-light;\n          cursor: pointer;\n        }\n\n        .uploadcare--widget__button.uploadcare--widget__button_type_open {\n          display: none !important;\n        }\n\n        .uploadcare-widget-disabled {\n          .ico-budicon-10 {\n            height: 150px;\n            width: 160px;\n          }\n        }\n\n        .uploadcare-widget-disabled {\n          display: block !important;\n          width: 99.5%;\n          height: 347px;\n          font-size: 24px;\n        }\n\n        .uploadcare--widget {\n          display: block !important;\n          width: 99.5%;\n          height: 347px;\n          font-size: 24px;\n\n          .uploadcare--widget__dragndrop-area {\n            width: 100%;\n            height: 100%;\n            position: relative;\n            border-radius: 0;\n            padding: 0 !important;\n            left: 0 !important;\n            margin: 0;\n            line-height: normal;\n            padding: 0;\n            top: 0;\n            display: block;\n            cursor: pointer;\n          }\n\n          &.uploadcare--widget .uploadcare--widget__circle {\n            display: none;\n          }\n        }\n\n        // Custom uploader cover page sizing\n        .uploader-container {\n          width: 99.5%;\n          height: 347px;\n          font-size: 24px;\n        }\n      }\n    }\n  }\n\n  .intro-cover {\n    .wysiwyg {\n      height: 270px;\n      border: 1px dashed #bbb;\n\n      &:focus {\n        border: 1px solid #bbb;\n      }\n    }\n  }\n\n  // report-page-cover\n  // --------------------------------  Inline editing patterns ----------------------------\n\n  // ======================= Concerns page styling =====================\n  &.report-page-concerns {\n  }\n\n  //- =================== Recommendations (solutions) list page styling =======================\n  &.report-page-solutions {\n  }\n\n  // report-page-solutions\n\n  //- =================== Financing page  =======================\n\n  &.report-page-financing {\n  }\n\n  //- =================== Recommendation detail page  =======================\n  &.report-page-upgrade_details {\n  }\n\n  // report-page-upgrade-details\n\n  //- =================== Health and safety tests page  =======================\n  &.report-page-health {\n  }\n\n  // report-page-safety\n\n  //- =================== Additional notes page =======================\n  &.report-page-additional_notes {\n  }\n\n  // report-page-additional_notes\n\n  //- =================== Technical specifications page =======================\n  &.report-page-metrics {\n    h6 {\n      font-size: 1em;\n    }\n  }\n\n  //- =================== Home Energy Score page =======================\n  @hesGreen: #196234;\n  @hesBlue: #223f74;\n\n  &.report-page-hes {\n    .report-header {\n      overflow: visible;\n    }\n\n    .report-main {\n      overflow: visible;\n    }\n\n    .report-footer {\n    }\n\n    .nav.nav-tabs li {\n      > a {\n        padding: 10px 20px;\n        font-size: 18px;\n        font-weight: 600;\n        color: @link-color;\n      }\n\n      &.active > a {\n        color: #333;\n      }\n    }\n\n    // font-size: .85em;\n    // text-align: center;\n    .hes-home {\n      padding-top: 30px;\n      padding-left: 20px;\n\n      dt {\n        font-size: 11px;\n        color: @hesGreen;\n        text-transform: uppercase;\n        float: left;\n        width: 120px;\n        padding-top: 3px;\n        padding-right: 10px;\n        font-weight: 600;\n        float: left;\n        clear: left;\n      }\n\n      dd {\n        float: left;\n        font-weight: 700;\n        font-size: 15px;\n      }\n    }\n\n    .hes-container {\n      margin-top: 30px;\n      margin-left: 20px;\n      margin-right: 10px;\n      padding: 90px 0 15px 85px;\n      position: relative;\n      border-bottom: 4px solid @hesBlue;\n\n      .clearfix();\n    }\n\n    .hes-legend {\n      float: left;\n      min-height: 60px;\n      padding: 24px 5px 0;\n      text-align: left;\n      font-weight: 600;\n      font-size: 12px;\n\n      &:last-child {\n        text-align: left;\n      }\n    }\n\n    .hes-spectrum {\n      position: relative;\n      float: left;\n\n      ul {\n        text-align: center;\n        background: rgba(217, 217, 217, 1);\n        background: -moz-linear-gradient(\n          left,\n          rgba(217, 217, 217, 1) 0%,\n          rgba(203, 212, 191, 1) 44%,\n          rgba(137, 198, 72, 1) 97%,\n          rgba(137, 198, 72, 1) 100%\n        );\n        background: -webkit-gradient(\n          left top,\n          right top,\n          color-stop(0%, rgba(217, 217, 217, 1)),\n          color-stop(44%, rgba(203, 212, 191, 1)),\n          color-stop(97%, rgba(137, 198, 72, 1)),\n          color-stop(100%, rgba(137, 198, 72, 1))\n        );\n        background: -webkit-linear-gradient(\n          left,\n          rgba(217, 217, 217, 1) 0%,\n          rgba(203, 212, 191, 1) 44%,\n          rgba(137, 198, 72, 1) 97%,\n          rgba(137, 198, 72, 1) 100%\n        );\n        background: -o-linear-gradient(\n          left,\n          rgba(217, 217, 217, 1) 0%,\n          rgba(203, 212, 191, 1) 44%,\n          rgba(137, 198, 72, 1) 97%,\n          rgba(137, 198, 72, 1) 100%\n        );\n        background: -ms-linear-gradient(\n          left,\n          rgba(217, 217, 217, 1) 0%,\n          rgba(203, 212, 191, 1) 44%,\n          rgba(137, 198, 72, 1) 97%,\n          rgba(137, 198, 72, 1) 100%\n        );\n        background: linear-gradient(\n          to right,\n          rgba(217, 217, 217, 1) 0%,\n          rgba(203, 212, 191, 1) 44%,\n          rgba(137, 198, 72, 1) 97%,\n          rgba(137, 198, 72, 1) 100%\n        );\n        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#d9d9d9', endColorstr='#89c648', GradientType=1);\n        display: inline-block;\n        float: left;\n        .clearfix();\n        list-style-type: none;\n        padding: 0;\n        margin: 0;\n        font-weight: 700;\n        font-size: 20px;\n\n        li {\n          padding: 35px 0;\n          margin: 0;\n          float: left;\n          border-right: 3px solid white;\n          box-sizing: border-box;\n\n          &:last-child {\n            border-right: none;\n          }\n        }\n      }\n    }\n\n    .hes-definition {\n      padding-left: 20px;\n      padding-top: 15px;\n      font-size: 0.85em;\n      // margin-top: 15px;\n    }\n\n    .hes-stats {\n      margin-top: 15px;\n      color: #959394;\n      font-weight: 700;\n      text-align: right;\n      font-size: 10px;\n    }\n  }\n}\n\n// report-page\n\n// -- =================== Print preview page ======================\n.print-preview {\n  .report-page {\n    // height: 710px;\n    zoom: 100%;\n    margin: 8px auto 20px;\n  }\n\n  &.sample-job {\n    .report-page {\n      .sample-job-watermark();\n    }\n  }\n}\n\n// ----------- fixed nav intended to be discreet\n.discrete-navigation {\n  color: #fff;\n  text-align: center;\n  background-color: rgba(0, 0, 0, 0.7);\n  border-radius: 3px;\n  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.5);\n  opacity: 0.65;\n  transition: all 0.2s ease;\n\n  &:hover,\n  &:focus,\n  &:focus-within {\n    opacity: 1;\n  }\n\n  .btn {\n    font-size: 11px;\n    text-align: 'center';\n    line-height: 1em;\n    background-color: transparent;\n    border-radius: 0;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.35);\n    display: block;\n    width: 100%;\n    color: #fff;\n    padding: 12px 12px;\n\n    &:hover,\n    &:focus {\n      background-color: rgba(0, 0, 0, 0.75);\n    }\n\n    &:active {\n      color: @custom-color-4;\n      background-color: rgba(0, 0, 0, 1);\n    }\n\n    &:first-child {\n      border-radius: 3px;\n    }\n\n    &:last-child {\n      border-bottom: none;\n      margin-bottom: 0;\n      border-radius: 3px;\n    }\n  }\n}\n\n.discrete-navigation--right {\n  position: fixed;\n  right: 5px;\n  top: 5px;\n  z-index: 1000;\n}\n\n.discrete-navigation--left {\n  position: fixed;\n  left: 5px;\n  top: 5px;\n  z-index: 1000;\n}\n\nbody {\n  counter-reset: page;\n}\n\n.report-footer {\n  counter-increment: page;\n}\n\n.pageNumber {\n  float: right;\n  padding-right: 50px;\n\n  &:before {\n    content: '– ' counter(page) ' –';\n  }\n}\n\n//- =================== Report Print Styles =======================\n@media print {\n  * {\n    text-shadow: none !important;\n    filter: none !important;\n    -ms-filter: none !important;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n    .box-sizing(border-box);\n  }\n\n  body {\n    background: none;\n    background-image: none;\n\n    .report-present {\n      background: none;\n      background-image: none;\n      padding-top: 0;\n    }\n  }\n\n  .hidden-print {\n    display: none !important;\n  }\n\n  a.print-link[href^='http'] {\n    font-weight: 700;\n    text-decoration: none;\n\n    &:after {\n      content: ' <' attr(href) '> ';\n    }\n  }\n\n  .header,\n  .side-left,\n  .side-right {\n    // display: none;\n  }\n\n  .content {\n    background-image: none !important;\n    background: transparent !important;\n    padding: none !important;\n    margin: none !important;\n    border: none !important;\n  }\n\n  .discrete-navigation {\n    display: none !important;\n  }\n\n  .print-preview .report-page {\n    padding: 0.3in 0.5in 0.2in;\n    margin: 0 !important;\n    border: none !important;\n    width: auto !important;\n    // height: @report-page-height;\n    // overflow:hidden;\n    // Attempt to force page breaks. May need to use widows and orphans as well.\n    page-break-inside: avoid;\n    page-break-after: always;\n\n    &:last-child {\n      page-break-after: avoid;\n    }\n  }\n\n  .r-container {\n    img {\n      max-width: 100% !important;\n    }\n\n    margin: 0 !important;\n    padding: 0 !important;\n    border: none;\n    position: relative;\n    opacity: 1;\n\n    .cover-photo-replace,\n    .cover-photo-upload {\n      display: none;\n    }\n\n    .img-border {\n      outline: 0;\n    }\n\n    .editor-area {\n      border: none;\n\n      &:hover,\n      &:focus {\n        border: none;\n        -webkit-box-shadow: none;\n        box-shadow: none;\n        outline: none;\n      }\n    }\n  }\n\n  .repaginate-report {\n    display: none;\n  }\n}\n\n@page {\n  size: letter landscape;\n  margin: 0mm;\n}\n\n// ====================  RESPONSIVE TWEAKS ======================\n/* Extra small devices (phones, less than 768px) */\n/* No media query since this is the default in Bootstrap */\n\n/* ONLY extra small devices (phones less than 768px) */\n@media (max-width: @screen-xs-max) {\n  .rep-toolbar {\n    border-bottom: 1px solid darken(@custom-color-3, 10%);\n  }\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (min-width: @screen-sm-min) {\n  .content-header.content-header-report {\n    .rep-toolbar {\n      .rep-btn {\n        max-width: 56px;\n      }\n    }\n\n    .rep-toolbar-title {\n      width: 240px;\n    }\n\n    .rep-toolbar-page {\n      width: 242px;\n    }\n  }\n\n  .in-app-report {\n  }\n}\n\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: @screen-md-min) {\n  .in-app-report {\n    .report-page {\n      zoom: 85%;\n    }\n\n    .editable-page-header {\n      margin-right: 20px;\n      width: unit(ceil(965 * 0.85), px);\n    }\n  }\n}\n\n/* Large devices (large desktops, 1200px and up) */\n@media (min-width: @screen-lg-min) {\n  .in-app-report {\n    .report-page {\n      zoom: 100%;\n    }\n\n    .editable-page-header {\n      margin-right: 20px;\n      width: 965px;\n    }\n  }\n}\n\n.img-polaroid {\n  padding: 4px;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n","/// -----------------  Financing settings ----------- ///\n@cardBorderRadius: 4px;\n@cardBoxShadow: 0 2px 8px fade(@custom-color-1, 20%);\n\n.cards {\n  .clearfix();\n  margin-bottom: 24px;\n\n  .cards-row {\n    .clearfix();\n  }\n\n  .card {\n    display: inline-block;\n    vertical-align: bottom;\n    width: 250px;\n    margin-right: 20px;\n    margin-top: 20px;\n    float: left;\n    border-radius: @cardBorderRadius;\n    background-color: white;\n    border: solid 1px darken(@gray-lighter, 5%);\n    color: inherit;\n    position: relative;\n\n    &:after {\n      content: '';\n      position: absolute;\n      z-index: -1;\n      .box-shadow(@cardBoxShadow);\n      bottom: 0;\n      left: 10px;\n      right: 10px;\n      height: 50%;\n      width: auto;\n    }\n\n    &:hover,\n    &:focus {\n      transition: all 0.3s ease;\n      .box-shadow(@cardBoxShadow);\n\n      &:after {\n        transition: all 0.3s ease;\n        .box-shadow(0 5px 12px fade(@custom-color-1, 35%));\n      }\n    }\n\n    &:active {\n      &:after {\n        transition: none;\n        .box-shadow(0 12px 22px fade(@custom-color-1, 20%));\n      }\n    }\n\n    &.card-fluid {\n      width: 100%;\n    }\n\n    table.table {\n      margin-bottom: 3px;\n\n      tr:first-child td {\n        border-top: none;\n      }\n\n      td {\n        padding: 10px 3px;\n\n        &:nth-child(2) {\n          text-align: right;\n        }\n      }\n\n      &.table-striped td {\n        border-color: #e3e3e3;\n      }\n    }\n\n    ul {\n      margin: 0;\n      padding-left: 0;\n\n      li {\n        font-size: 0.9em;\n        list-style-type: none;\n        padding: 10px 3px;\n        margin: 0 12px;\n        border-bottom: 1px solid #ddd;\n\n        &:last-child {\n          border-bottom: none;\n        }\n\n        .value {\n          float: right;\n        }\n      }\n    }\n\n    &.card-readonly {\n      &:hover,\n      &:focus {\n        .box-shadow(none);\n\n        &:after {\n          .box-shadow(0 4px 12px fade(@custom-color-1, 20%));\n        }\n      }\n\n      &:active {\n        &:after {\n          .box-shadow(0 4px 12px fade(@custom-color-1, 20%));\n        }\n      }\n    }\n\n    &.card-rec {\n      position: relative;\n      z-index: 1;\n      margin-bottom: 10px;\n      margin-top: 0;\n      cursor: pointer;\n\n      &:first-child {\n        border-top-width: 1px;\n      }\n\n      &:hover {\n        z-index: 2;\n        .box-shadow(0 0 10px fade(@custom-color-1, 30%));\n      }\n\n      &:active {\n        z-index: 3;\n        transition: none;\n        .box-shadow(0 1px 14px fade(@custom-color-1, 40%));\n\n        &:after {\n          z-index: 4;\n        }\n      }\n    }\n\n    .card-rec-header {\n      background-color: darken(@gray-lightest, 2%);\n      color: darken(@gray-lightest, 60%);\n      height: 65px;\n    }\n\n    .card-header {\n      .clearfix();\n      display: block;\n      position: relative;\n      border-radius: 0 !important;\n      padding: 15px 10px 15px 12px;\n      background-color: @gray-lightest;\n      text-align: left;\n      color: @gray;\n      max-width: 100%;\n      font-size: 14px;\n      letter-spacing: 0.02em;\n      line-height: 1em;\n      white-space: nowrap;\n      font-weight: 600;\n\n      [class*=' ico-'],\n      [class^='ico-'] {\n        display: block;\n        background-color: inherit;\n        margin-left: 8px;\n        opacity: 0.7;\n        float: right;\n      }\n    }\n\n    a.card-header {\n      color: inherit;\n\n      &:hover {\n        cursor: pointer;\n        background: darken(@custom-color-3, 5%);\n      }\n\n      &:active {\n        background: darken(@custom-color-3, 8%);\n      }\n    }\n\n    .card-body {\n      // Only use this if you have content that needs padding and c.  ULs and tables are already padded.\n      .clearfix();\n      padding: 10px 8px;\n    }\n\n    .card-footer {\n      .clearfix();\n      padding: 12px 10px 0px;\n      background-color: @custom-color-3;\n      position: relative;\n\n      .card-footer-content {\n        float: left;\n        max-width: 190px;\n        max-height: 20px;\n        margin-bottom: 10px;\n        overflow: hidden;\n      }\n\n      // trash button\n      .card-delete {\n        display: inline;\n        font-size: 16px;\n        color: red;\n        margin-left: 10px;\n        margin-top: -10px;\n        margin-right: -11px;\n        border-radius: 0 0 6px 0;\n        padding: 12px 15px;\n\n        &:hover {\n          color: #fff;\n          background-color: red;\n        }\n\n        &:active {\n          color: #fff;\n          background-color: darken(red, 7%);\n        }\n      }\n    }\n\n    // Style calculator on financing selection screen\n    &.card-calculator {\n      float: none;\n\n      .input-group-addon {\n        padding: 6px;\n      }\n    }\n  }\n}\n\n// ====================  RESPONSIVE TWEAKS ======================\n// Mobile first!\n\n/* Small devices (tablets, 768px and up) */\n@media (min-width: @screen-sm-min) {\n  .cards {\n    .card {\n      &.card-rec {\n        margin-bottom: 1px;\n        // border-top: solid 1px darken(@custom-color-3, 5%);\n        border-radius: 0;\n        border: none;\n        background-color: @custom-color-3;\n\n        &:nth-child(even) {\n          background-color: lighten(@custom-color-3, 2%);\n        }\n\n        &:first-child {\n          border-radius: 6px 6px 0 0;\n        }\n\n        &:last-child {\n          border-radius: 0 0 6px 6px;\n        }\n      }\n\n      .card-rec-header {\n        background-color: inherit;\n        text-align: inherit;\n        color: inherit;\n        height: auto;\n      }\n    }\n  }\n}\n\n@media (min-width: @screen-md-min) {\n}\n","// // ==============  Dynamic Alerts Container\n\n// ==============  Basic Alert Styling\n.alert {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n  // overflow: hidden;\n  border-radius: 6px;\n  margin: 10px 0;\n  padding: 12px;\n\n  .alert-style-container {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    width: 100%;\n  }\n\n  h4 {\n    font-size: 1em;\n    color: inherit;\n    font-weight: 600;\n    margin: 0;\n  }\n\n  p {\n    // font-size: .9em;\n    margin-bottom: 10px;\n  }\n\n  &.alert-live {\n    padding: 0;\n    border-radius: 0;\n    display: inline-block;\n    width: auto;\n    border: 0;\n    margin: 5px 0;\n\n    &.character-counter {\n      display: inline;\n    }\n  }\n\n  &.alert-banner {\n    padding: 5px;\n    text-align: center;\n    border-top-style: solid;\n    margin: 0 -15px;\n    width: auto;\n    font-size: 12px;\n    border-radius: 0;\n    z-index: 1064;\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    width: auto;\n    left: 15px;\n    border-top: 1px solid #c9dade;\n\n    .alert-message {\n      padding-bottom: 0;\n      text-align: center;\n      color: #333;\n    }\n  }\n\n  &.alert-alert {\n    .transition(@push-menu-transition);\n    min-width: 500px;\n    min-height: 40px;\n    margin: 4px 0 8px 0;\n    border-radius: 6px;\n    border: none;\n    padding: 16px;\n    box-shadow:\n      0px 9px 28px 0px rgba(0, 0, 0, 0.05),\n      0px 3px 6px -4px rgba(0, 0, 0, 0.12),\n      0px 6px 16px 0px rgba(0, 0, 0, 0.08);\n    max-width: 500px;\n\n    .close {\n      transition: all 200ms linear;\n      font-size: 24px;\n      font-weight: 300;\n      opacity: 0.3;\n      width: 24px;\n      min-width: 24px;\n      height: 24px;\n      border-radius: 100%;\n      background-color: #fff;\n\n      &:hover {\n        background-color: #eee;\n        opacity: 0.6;\n      }\n    }\n\n    @media (max-width: 575.98px) {\n      min-width: auto;\n      width: 90%;\n    }\n\n    // Override alert-alert bg to desaturate them...\n    &.alert-success {\n      background-color: #ffffff;\n    }\n\n    &.alert-warning {\n      background-color: #ffffff;\n    }\n\n    &.alert-error {\n      background-color: #ffffff;\n    }\n\n    &.alert-minimized {\n      min-width: 200px;\n      max-width: fit-content;\n      position: relative;\n      .transition(@push-menu-transition);\n    }\n  }\n\n  &.alert-inline {\n    margin: 20px 0;\n\n    .alert-message {\n      padding-bottom: 0;\n      color: #333;\n    }\n  }\n\n  &.alert-field {\n    margin: 8px 0 8px 0;\n    padding: 0;\n    border: none;\n    background: none;\n    font-size: 12px;\n\n    .alert-message {\n      padding-bottom: 0;\n    }\n\n    img {\n      width: 14px;\n    }\n\n    .alert-style-container {\n      gap: 6px;\n    }\n  }\n}\n\n.alert-content {\n  width: 100%;\n  margin-top: 2px;\n  margin-bottom: 2px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.alert-job-id {\n  margin-left: 10px;\n  font-size: 0.8em;\n  opacity: 0.8;\n  background-color: rgba(0, 0, 0, 0.1);\n  border-radius: 3px;\n  padding: 0 5px;\n  color: @gray-dark;\n\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.2);\n    color: black;\n  }\n\n  &:active {\n    background-color: rgba(0, 0, 0, 0.5);\n    color: @gray-lighter;\n  }\n}\n\n.alert-message {\n  display: block;\n  color: #333;\n  line-height: 1.5;\n  font-weight: 500;\n}\n\n.alert.alert-header {\n  margin: 0;\n  border-radius: 0;\n}\n\n.alert-warning {\n  background-color: #faf0cb;\n  color: #333;\n  border: 1px solid #e1d8b7;\n\n  .alert-title {\n    color: #e38016;\n  }\n}\n\n.alert-error {\n  background-color: #fdf5f4;\n  color: #333;\n  border-color: #f7d5d2;\n  border-style: solid;\n  border-width: 1px;\n\n  h2,\n  h3,\n  h4,\n  h5 {\n    color: #d92d20;\n  }\n\n  .alert-title {\n    color: #d92d20;\n  }\n}\n\n.alert-success {\n  background-color: #f3faf7;\n  color: #333;\n  border-color: #cdeadd;\n  border-style: solid;\n  border-width: 1px;\n\n  .alert-title {\n    color: #039855;\n  }\n}\n\n.alert-info {\n  background-color: #f5f8ff;\n  color: #333;\n  border-color: #d7e3fd; //darken(#E3F2D4, 10%);\n  border-style: solid;\n  border-width: 1px;\n\n  a {\n    color: darken(#d9edf7, 68%);\n    text-decoration: underline;\n  }\n\n  .alert-title {\n    color: #3875f6;\n  }\n}\n\n.alert-neutral {\n  background-color: @gray-lightestest;\n  border-color: darken(#f4f4f4, 4%);\n  box-shadow: inset 0 0 0 1px white;\n  border-style: solid;\n  border-width: 1px;\n\n  a {\n    color: @link-color;\n  }\n}\n\n.alert-internal {\n  background-color: #28548a;\n  color: white;\n  padding: 20px;\n  .box-shadow(0 2px 5px rgba(0, 0, 0, 0.6));\n}\n\n.alertButtonMixin() {\n  width: auto;\n  display: inline-block;\n  box-shadow: none;\n  padding: 8px 16px 9px;\n  background: #2b2b2b;\n  color: #fff;\n  font-weight: 500;\n  border: none;\n  border-radius: 6px;\n\n  &:hover {\n    background: #333;\n    color: white;\n  }\n\n  &:active {\n    background: #111;\n  }\n}\n\n.alert-primary-button {\n  .alertButtonMixin();\n}\n\n.alert-secondary-button {\n  .alertButtonMixin();\n  margin-left: 8px;\n  background: #fff;\n  border: 1px solid #d0d5dd;\n  color: #222;\n\n  &:hover {\n    background: #eee;\n    color: #222;\n  }\n\n  &:active {\n    background: #ddd;\n  }\n}\n\n// ====================  RESPONSIVE TWEAKS ======================\n/* Extra small devices (phones, less than 768px) */\n/* No media query since this is the default in Bootstrap */\n\n/* ONLY extra small devices (phones less than 768px) */\n@media (max-width: @screen-xs-max) {\n  .push-left {\n    .alert.alert-alert {\n      margin-left: 5px;\n    }\n  }\n\n  .form-control.input-header.rec-input-header {\n    font-size: 15px;\n    font-weight: 600;\n    min-width: 255px;\n  }\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (min-width: @screen-sm-min) {\n  .push-left {\n    .alert.alert-alert {\n      // left: @side-left-width + 10;\n    }\n  }\n\n  .alert.alert-alert {\n    width: 500px;\n  }\n\n  .alert.alert-banner {\n    left: 75px;\n  }\n}\n\n/* Medium devices (desktops, 992px and up) */\n@media (min-width: @screen-md-min) {\n}\n\n/* ONLY extra short devices (phones less than 568px)  This is a fringe case*/\n@side-left-width-short: 108px;\n\n@media (max-height: @short-screen-max) {\n}\n\n@media (max-height: @short-screen-max) and (max-width: @screen-xs-max) {\n  // NEXT LINES ACTUALLY MAKE THE LEFT SIDENAV USABLE FOR LANDSCAPE IPHONE\n  .push-left {\n    .container-fluid.container-core {\n    }\n\n    .side-left {\n      .transform(tranformX(0));\n    }\n  }\n}\n\n@media (max-height: @short-screen-max) and (min-width: @screen-sm-min) {\n  // Style push menu\n}\n\n// ====================  PRINTING TWEAKS ======================\n@media print {\n}\n",".DraftEditor-root {\n  .public-DraftEditorPlaceholder-inner {\n    color: #888;\n    position: absolute;\n  }\n  .public-DraftEditor-content {\n    min-height: 40px;\n    padding-bottom: 5px;\n    &:hover {\n      background-color: desaturate(lighten(@custom-color-4, 30%), 5%);\n    }\n    &:hover:focus {\n      background-color: inherit;\n    }\n  }\n  &:focus {\n    .public-DraftEditorPlaceholder-inner {\n      display: none;\n    }\n  }\n}\n\n.tickets-template {\n  .DraftEditor-root .public-DraftEditor-content {\n    min-height: 80px;\n  }\n}\n\n.report-sidebar .DraftEditor-root .public-DraftEditor-content:hover {\n  background-color: @sidebar-inline-editable-hover-color;\n}\n\n.draft-toolbar {\n  background-color: #000;\n  border: none;\n  border-radius: 50px;\n  font-size: 16px;\n}\n\n.draft-toolbar .item {\n  float: left;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background-color: #000;\n}\n\n.draft-toolbar .item:first-child {\n  border-bottom-left-radius: 50px;\n  border-top-left-radius: 50px;\n  padding-left: 6px;\n}\n\n.draft-toolbar .item:last-child {\n  border-bottom-right-radius: 50px;\n  border-top-right-radius: 50px;\n  padding-right: 6px;\n}\n\n.draft-toolbar .item.active {\n  background-color: #2f2f2f;\n}\n\n.draft-toolbar .item:hover {\n  background-color: #2f2f2f;\n}\n\n.draft-toolbar .item button {\n  background-color: transparent;\n  border: 0;\n  color: white;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: block;\n  font-size: 14px;\n  line-height: 1.33;\n  margin: 0;\n  padding: 15px;\n  text-decoration: none;\n}\n\n.TeXEditor-container {\n  width: 100%;\n  height: 100%;\n}\n\n.TeXEditor-root {\n  background: inherit;\n  -webkit-font-smoothing: antialiased;\n}\n\n.TeXEditor-editor {\n  cursor: text;\n  min-height: 40px;\n}\n\n.TeXEditor-button {\n  margin-top: 10px;\n  text-align: center;\n}\n\n.TeXEditor-handle {\n  color: rgba(98, 177, 254, 1);\n  direction: ltr;\n  unicode-bidi: bidi-override;\n}\n\n.TeXEditor-hashtag {\n  color: rgba(95, 184, 138, 1);\n}\n\n.TeXEditor-tex {\n  background-color: #fff;\n  cursor: pointer;\n  margin: 20px auto;\n  padding: 20px;\n  -webkit-transition: background-color 0.2s fade-in-out;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.TeXEditor-activeTeX {\n  color: #888;\n}\n\n.TeXEditor-panel {\n  font-family: 'Helvetica', sans-serif;\n  font-weight: 200;\n}\n\n.TeXEditor-panel .TeXEditor-texValue {\n  border: 1px solid #e1e1e1;\n  display: block;\n  font-family: 'Inconsolata', 'Menlo', monospace;\n  font-size: 14px;\n  height: 110px;\n  margin: 20px auto 10px;\n  outline: none;\n  padding: 14px;\n  resize: none;\n  -webkit-box-sizing: border-box;\n  width: 500px;\n}\n\n.TeXEditor-buttons {\n  text-align: center;\n}\n\n.TeXEditor-saveButton,\n.TeXEditor-removeButton {\n  background-color: #fff;\n  border: 1px solid #0a0;\n  cursor: pointer;\n  font-family: 'Helvetica', 'Arial', sans-serif;\n  font-size: 16px;\n  font-weight: 200;\n  margin: 10px auto;\n  padding: 6px;\n  -webkit-border-radius: 3px;\n  width: 100px;\n}\n\n.TeXEditor-removeButton {\n  border-color: #aaa;\n  color: #999;\n  margin-left: 8px;\n}\n\n.TeXEditor-invalidButton {\n  background-color: #eee;\n  border-color: #a00;\n  color: #666;\n}\n\n.TeXEditor-insert {\n  background-color: #f1f1f1;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  bottom: 30px;\n  position: fixed;\n  right: 30px;\n}\n.TeXEditor-insert2 {\n  background-color: #f1f1f1;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  bottom: 30px;\n  position: fixed;\n  right: 160px;\n}\n\n.TeXEditor-insert3 {\n  background-color: #f1f1f1;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n  bottom: 30px;\n  position: fixed;\n  right: 300px;\n}\n","@import 'custom-variables.less';\n\n@left-right-margin-inside-secondary-nav: 7px;\n\n.secondary-nav {\n  .filter-item-container {\n    margin-left: @left-right-margin-inside-secondary-nav;\n    margin-right: @left-right-margin-inside-secondary-nav;\n    padding: 8px 5px 8px 10px;\n    border-radius: 4px;\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n      cursor: pointer;\n    }\n    &:active,\n    &:focus {\n      background-color: rgba(0, 0, 0, 0.08);\n    }\n\n    // Style the checkboxes in the filter container\n    &.checkbox-filter.checkbox-container {\n      padding-left: 36px;\n    }\n    .checkmark {\n      top: 10px;\n      left: 10px;\n    }\n  }\n\n  .radio-filter {\n    position: relative;\n  }\n}\n\n.secondary-nav-link {\n  color: @custom-color-1;\n  font-size: 12px;\n  padding-top: 10px;\n  padding-right: 5px;\n  padding-bottom: 10px;\n  cursor: pointer;\n  padding-left: 15px;\n  letter-spacing: 0.025em;\n  display: block;\n  user-select: none;\n  border-radius: 4px;\n  margin-left: @left-right-margin-inside-secondary-nav;\n  margin-right: @left-right-margin-inside-secondary-nav;\n  &:hover {\n    background-color: fade(@custom-color-4, 30%);\n    color: inherit;\n    .active-only {\n      display: inline !important;\n    }\n  }\n  &:focus {\n    color: @custom-color-1;\n    outline: none;\n    background-color: darken(@gray-lighter, 3%);\n  }\n  &:active {\n    color: @custom-color-1;\n    outline: none;\n    background-color: fade(@custom-color-4, 45%);\n  }\n  .active-only {\n    display: none !important;\n  }\n  &.active {\n    background-color: fade(@custom-color-4, 35%);\n    color: #000;\n    text-shadow: 0 0 0 #000;\n    &:active,\n    &:focus {\n      background-color: fade(@custom-color-4, 35%);\n      color: #000;\n      text-shadow: 0 0 0 #000;\n    }\n    .active-only {\n      display: inline !important;\n    }\n  }\n}\n\n.secondary-nav-scroll-link {\n  color: @custom-color-1;\n  font-size: 12px;\n  cursor: pointer;\n  letter-spacing: 0.025em;\n  display: block;\n  user-select: none;\n  position: relative;\n  min-height: 36px;\n  > a {\n    margin-left: @left-right-margin-inside-secondary-nav;\n    margin-right: @left-right-margin-inside-secondary-nav;\n    border-radius: 4px;\n    color: @custom-color-1;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    padding-top: 10px;\n    padding-right: 5px;\n    padding-bottom: 10px;\n    padding-left: 15px;\n    display: block;\n    &:hover {\n      background-color: fade(@custom-color-4, 30%);\n      color: inherit;\n    }\n    &:focus {\n      color: @custom-color-1;\n      outline: none;\n      background-color: darken(@gray-lighter, 3%);\n    }\n    &:active {\n      color: @custom-color-1;\n      outline: none;\n      background-color: fade(@custom-color-4, 45%);\n    }\n    &.active {\n      background-color: fade(@custom-color-4, 35%);\n      color: #000;\n      text-shadow: 0 0 0 #000;\n\n      &:active,\n      &:focus {\n        background-color: fade(@custom-color-4, 35%);\n        color: #000;\n        text-shadow: 0 0 0 #000;\n      }\n    }\n  }\n  .secondary-actions {\n    position: absolute;\n    right: 7px;\n    top: 0;\n    bottom: 0;\n    .snugg-btn {\n      text-align: center;\n      display: inline-block;\n      width: auto;\n      opacity: 0.8;\n      padding-top: 8px;\n      padding-left: 6px;\n      padding-right: 6px;\n      padding-bottom: 0;\n      border-radius: 0;\n      height: 100%;\n      border-radius: 0 4px 4px 0;\n    }\n  }\n  > .reveal-on-hover {\n    display: none;\n  }\n  &:hover {\n    > .reveal-on-hover {\n      display: inline;\n    }\n  }\n}\n\n.draggable-item {\n  transform: scale(1);\n}\n\n#tertiary-nav {\n  padding: 0;\n  height: 100%;\n  border-right: 1px solid #ddd;\n  width: 50%;\n  float: right;\n  .tertiary-list {\n    top: @header-height;\n  }\n  .tertiary-nav-link {\n    width: 100%;\n    padding: 8px 10px 8px 10px;\n    box-shadow: inset 0 -1px 0 0 #eeeeee;\n    cursor: pointer;\n    &:hover {\n      background-color: @gray-lightest;\n    }\n    &:active {\n      background-color: @gray-lighter;\n    }\n  }\n}\n\n// TODO: MEDIA QUERY @double-header-height;\n",".pane-content {\n  ul {\n    padding-left: 20px;\n    padding-top: 5px;\n    li {\n      margin-bottom: 5px;\n    }\n  }\n}\n",".snugg-btn {\n  user-select: none;\n  -webkit-user-select: none;\n  background-image: none;\n  border-top-width: 1px;\n  border-right-width: 1px;\n  border-bottom-width: 1px;\n  border-left-width: 1px;\n  border-style: solid;\n  border-top-color: transparent;\n  border-right-color: transparent;\n  border-bottom-color: transparent;\n  border-left-color: transparent;\n  border-radius: 6px;\n  box-sizing: border-box;\n  cursor: pointer;\n  display: block;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.42;\n  outline: none;\n  outline-offset: 0;\n  padding-top: 6px;\n  padding-right: 12px;\n  padding-bottom: 6px;\n  padding-left: 12px;\n  text-align: center;\n  vertical-align: middle;\n  white-space: nowrap;\n  width: 100%;\n  touch-action: manipulation;\n\n  &:active {\n    box-shadow: none;\n  }\n\n  // ======== SPECIAL BUTTONS ========\n  &.snugg-btn-primaryNavigation {\n    color: #dedede;\n    background-color: @custom-color-1;\n    text-shadow: 0 2px 6px rgba(0, 0, 0, 1);\n    border-radius: 0;\n    margin: 0;\n    padding-top: 6px;\n    padding-right: 0;\n    padding-bottom: 6px;\n    min-height: 18px;\n    padding-left: 0;\n    font-weight: 400;\n    font-size: 10px;\n    width: 100%;\n    letter-spacing: 0.05em;\n    display: block;\n    position: relative;\n\n    &:hover {\n      color: #fff;\n      background-color: lighten(@custom-color-1, 5%);\n    }\n\n    &:focus {\n      background-color: darken(@custom-color-1, 7%);\n\n      > i[class^='ico-budicon'],\n      i[class*=' ico-budicon'] {\n      }\n    }\n\n    > i[class^='ico-budicon'],\n    i[class*=' ico-budicon'] {\n      height: 18px;\n      width: 24px;\n      color: #dedede;\n      font-family: snugg-6;\n      font-size: 18px;\n      letter-spacing: 0;\n      line-height: 18px;\n      text-align: center;\n      text-shadow: 0px 2px 5px #000000;\n    }\n\n    img {\n      filter: invert(96%) sepia(0%) saturate(1%) hue-rotate(192deg)\n        brightness(88%) contrast(88%);\n    }\n\n    &:active,\n    &.snugg-btn-primaryNavigationActive {\n      background-color: darken(@custom-color-1, 7%);\n      color: @custom-color-4;\n\n      > i[class^='ico-budicon'],\n      i[class*=' ico-budicon'] {\n        color: @custom-color-4;\n      }\n\n      > img {\n        filter: invert(74%) sepia(76%) saturate(3050%) hue-rotate(355deg)\n          brightness(101%) contrast(110%);\n      }\n    }\n  }\n\n  &.snugg-btn-add-new-job {\n    padding-top: 8px;\n    padding-left: 20px;\n    padding-right: 20px;\n    height: 37px;\n    font-weight: 600;\n    font-size: 15px;\n    border-radius: 30px;\n    margin-top: 4px;\n    margin-left: 10px;\n    width: auto;\n    display: inline-block;\n    float: left;\n  }\n\n  @-webkit-keyframes hvr-pop {\n    50% {\n      -webkit-transform: scale(1.04);\n      transform: scale(1.04);\n    }\n  }\n\n  @keyframes hvr-pop {\n    50% {\n      -webkit-transform: scale(1.04);\n      transform: scale(1.04);\n    }\n  }\n\n  @-webkit-keyframes nrml-pop {\n    50% {\n      -webkit-transform: scale(1.025);\n      transform: scale(1.025);\n    }\n  }\n\n  @keyframes nrml-pop {\n    50% {\n      -webkit-transform: scale(1.025);\n      transform: scale(1.025);\n    }\n  }\n\n  &.snugg-btn-unassigned-jobs {\n    .transition(@push-menu-transition);\n    padding-left: 14px;\n    padding-right: 14px;\n    height: 35px;\n    font-weight: 600;\n    font-size: 15px;\n    border-radius: 30px;\n    margin-top: 8px;\n    margin-right: 8px;\n    width: 100%;\n    float: left;\n    background: #fffaf5 !important;\n    background: linear-gradient(\n      0deg,\n      rgba(255, 252, 250, 1) 0%,\n      rgba(255, 240, 230, 1) 51%,\n      rgba(255, 252, 250, 1) 100%\n    ) !important;\n    // background: linear-gradient(0deg, rgba(100, 100, 100, 1) 0%, rgba(0, 0, 0, 1) 51%, rgba(255, 252, 250, 1) 100%) !important;\n\n    background-size: auto 200% !important;\n    box-shadow: inset 0px 1px 0px 0px rgba(255, 255, 255, 0.7);\n    border: 1px solid #fbcfa5;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 142%;\n    color: #f56600 !important;\n    transform: perspective(1px) translateZ(0);\n\n    -webkit-animation-name: nrml-pop;\n    animation-name: nrml-pop;\n    -webkit-animation-duration: 0.3s;\n    animation-duration: 0.3s;\n    -webkit-animation-timing-function: linear;\n    animation-timing-function: linear;\n    -webkit-animation-iteration-count: 1;\n    animation-iteration-count: 1;\n\n    &:hover,\n    &:focus,\n    &:active {\n      // background: linear-gradient(0deg, rgba(255, 252, 250, 1) 0%, rgba(255, 235, 215, 1) 100%) !important;\n      background-position: bottom !important;\n      -webkit-animation-name: hvr-pop;\n      animation-name: hvr-pop;\n      -webkit-animation-duration: 0.3s;\n      animation-duration: 0.3s;\n      -webkit-animation-timing-function: linear;\n      animation-timing-function: linear;\n      -webkit-animation-iteration-count: 1;\n      animation-iteration-count: 1;\n    }\n  }\n\n  // ======== START SIZES ========\n\n  &.snugg-btn-sm {\n    padding-top: 5px;\n    padding-right: 10px;\n    padding-bottom: 5px;\n    padding-left: 10px;\n    font-size: 12px;\n    line-height: 1.5;\n    border-radius: 6px;\n  }\n\n  &.snugg-btn-md {\n    padding-top: 11px;\n    padding-right: 18px;\n    padding-bottom: 11px;\n    padding-left: 18px;\n    font-size: 14px;\n    line-height: 1.5;\n    border-radius: 6px;\n    letter-spacing: 0.02em;\n  }\n\n  &.snugg-btn-lg {\n    font-size: 15px;\n    padding-top: 14px;\n    padding-right: 18px;\n    padding-bottom: 14px;\n    padding-left: 18px;\n  }\n\n  // ========   END SIZING   ========\n\n  // ======== START VARIANTS ========\n\n  &.snugg-btn-light {\n    background: @gray-lightestest;\n    background-image: linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.15) 0%,\n      rgba(0, 0, 0, 0.05) 95%\n    );\n    color: #222;\n    border: 1px solid #ddd;\n\n    &:hover {\n      color: #000;\n      background: @gray-lightestest;\n      background-image: linear-gradient(\n        202deg,\n        rgba(255, 255, 255, 0.1) 0%,\n        rgba(0, 0, 0, 0.07) 79%\n      );\n    }\n\n    &:active {\n      color: #000;\n      background: @gray-lightestest;\n    }\n  }\n\n  &.snugg-btn-dark {\n    background: @custom-color-1;\n    background-image: linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.15) 0%,\n      rgba(0, 0, 0, 0.05) 79%\n    );\n    color: @custom-color-3;\n\n    &:hover {\n      color: #fff;\n      background-image: linear-gradient(\n        202deg,\n        rgba(255, 255, 255, 0.1) 0%,\n        rgba(0, 0, 0, 0.07) 79%\n      );\n    }\n\n    &:active {\n      color: #fff;\n      background: darken(@custom-color-1, 10%);\n      background-image: linear-gradient(\n        202deg,\n        rgba(255, 255, 255, 0.1) 0%,\n        rgba(0, 0, 0, 0.07) 79%\n      );\n    }\n  }\n\n  &.snugg-btn-collectionAdd {\n    color: desaturate(darken(@custom-color-4, 35%), 50%);\n    border-style: dashed;\n    background-color: desaturate(lighten(@custom-color-4, 45%), 8%);\n    border-color: desaturate(lighten(@custom-color-4, 25%), 20%);\n\n    &:hover {\n      background-color: lighten(@custom-color-4, 35%);\n      border-color: desaturate(lighten(@custom-color-4, 15%), 20%);\n    }\n\n    &:active {\n      background-color: desaturate(lighten(@custom-color-4, 18%), 10%);\n      border-color: darken(@custom-color-4, 10%);\n    }\n  }\n\n  &.snugg-btn-yellow {\n    .button-gradient(@custom-color-1; darken(@custom-color-2, 4%); @custom-color-2);\n  }\n\n  &.snugg-btn-orange {\n    .btn-brand-1();\n  }\n\n  &.snugg-btn-link {\n    background-color: inherit;\n    display: inline-block;\n    color: @link-color;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n\n    &:focus {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n\n    &:active {\n      background-color: rgba(0, 0, 0, 0.1);\n      box-shadow: none;\n    }\n  }\n\n  &.snugg-btn-discrete {\n    background-color: inherit;\n    display: inline-block;\n    color: inherit;\n\n    &:hover {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n\n    &:focus {\n      background-color: rgba(0, 0, 0, 0.05);\n    }\n\n    &:active {\n      background-color: rgba(0, 0, 0, 0.1);\n      box-shadow: none;\n    }\n  }\n\n  &.snugg-btn-delete {\n    background-color: inherit;\n    color: #333;\n\n    &:hover {\n      background-color: #ff0000;\n      color: #ffffff;\n    }\n\n    &:active {\n      background-color: darken(#ff0000, 15%);\n      color: #ffffff;\n    }\n  }\n\n  &.snugg-btn-rounded {\n    background: #fff5e9;\n    color: @link-color;\n    box-shadow: 0 0 0 1px rgba(#fbcfa5, 0.5);\n    border-radius: 50px;\n    transition: all 200ms ease-in-out;\n\n    &:hover {\n      background: #ffedd5;\n      box-shadow: 0 0 0 1px rgba(#fbcfa5, 0.7);\n    }\n\n    &:active {\n      background: #ffedd5;\n      box-shadow: 0 0 0 1px rgba(#fbcfa5, 0.7);\n    }\n  }\n\n  // ======== END VARIANTS ========\n}\n\n// ========= START SPECIAL CONTEXTS =======\n\n.modal-footer {\n  .snugg-btn {\n    border: none;\n    // text-transform: uppercase;\n    font-weight: 600;\n    font-size: 15px;\n    letter-spacing: 0.02em;\n    border-radius: 0 0 4px 4px;\n\n    &.snugg-btn-yellow {\n      background-image: linear-gradient(\n        15deg,\n        @custom-color-4 50%,\n        #fdde6645 90% 79%\n      );\n      color: #fff;\n    }\n  }\n}\n\n// ========= END SPECIAL CONTEXTS =======\n\n@media (min-height: 590px) {\n  .snugg-btn {\n    &.snugg-btn-primaryNavigation {\n      min-height: 55px;\n      padding-top: 8px;\n      padding-bottom: 8px;\n    }\n\n    &.snugg-btn-add-new-job {\n    }\n  }\n}\n\n/* Small devices (tablets, 768px and up) */\n@media (min-width: @screen-sm-min) {\n  .snugg-btn {\n    &.snugg-btn-add-new-job {\n      float: right;\n    }\n\n    &.snugg-btn-unassigned-jobs {\n      width: auto;\n      margin-top: 5px;\n    }\n  }\n}\n","/* Customize the label (the container) */\n.checkbox-container {\n  display: block;\n  position: relative;\n  padding-left: 28px;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-bottom: 0;\n  cursor: pointer;\n  font-weight: inherit;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n\n  /* Hide the browser's default checkbox */\n  &.checkbox-container-no-label {\n    padding-left: 0;\n  }\n\n  &:hover .checkmark:after,\n  &:focus-within .checkmark:after {\n    display: block;\n  }\n\n  input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n  }\n\n  /* Create a custom checkbox */\n  .checkmark {\n    position: absolute;\n    top: 2px;\n    left: 0;\n    height: 16px;\n    width: 16px;\n    background-color: #eee;\n    border-radius: 3px;\n\n    /* Create the checkmark/indicator (hidden when not checked) */\n    &:after {\n      content: '';\n      position: absolute;\n      display: none;\n    }\n  }\n\n  /* On mouse-over, add a grey background color */\n  &:hover input ~ .checkmark,\n  &:focus-within input ~ .checkmark {\n    background-color: #ccc;\n  }\n\n  /* When the checkbox is checked, add a blue background */\n  input:checked ~ .checkmark {\n    background-color: @custom-color-4;\n  }\n\n  input:disabled ~ .checkmark {\n    background-color: #777777;\n  }\n\n  /* Show the checkmark when checked */\n  input:checked ~ .checkmark:after {\n    display: block;\n  }\n\n  /* Style the checkmark/indicator */\n  .checkmark:after {\n    left: 6px;\n    top: 3px;\n    width: 5px;\n    height: 10px;\n    border: solid white;\n    border-width: 0 3px 3px 0;\n    -webkit-transform: rotate(45deg);\n    -ms-transform: rotate(45deg);\n    transform: rotate(45deg);\n  }\n}\n\n.checkbox-fix {\n  width: 16px;\n  height: 16px;\n  display: inline-block;\n}\n\n// Styling react-select overrides\n.Select {\n  .Select-menu-outer {\n    padding: 0 5px;\n    border-radius: 0 0 4px 4px;\n    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.14);\n\n    .Select-menu {\n      .Select-option {\n        border-radius: 4px;\n      }\n    }\n  }\n}\n","@file-block-width: 235px;\n@file-block-height: 175px;\n@file-block-border-radius: 6px;\n\n#tickets-container {\n  font-size: 16px;\n\n  #main-pane {\n    padding-bottom: 180px;\n  }\n\n  .ticket-file-block {\n    max-width: @file-block-width;\n    display: inline-block;\n\n    .no-file-cannot-modify {\n      position: relative;\n      height: @file-block-height;\n      width: @file-block-width;\n      background-color: @gray-lightestest;\n      border-radius: @file-block-border-radius;\n      border: 1px solid @gray-lightestest;\n      font-size: 16px;\n      color: @gray-light;\n\n      .no-file-label {\n        text-align: center;\n        height: 60px;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        margin: auto;\n      }\n    }\n\n    .ticket-file-preview {\n      transition: all ease-in-out 0.2s;\n\n      img {\n        border-radius: 6px;\n      }\n\n      &:hover {\n        box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.15);\n      }\n\n      &:active,\n      &:focus {\n        box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.15);\n        transform: scale(1.05);\n      }\n    }\n\n    .ticket-file-is-image {\n      width: @file-block-width;\n      height: @file-block-height;\n      display: inline-block;\n      margin-right: 9px;\n      overflow: hidden;\n      border: 1px solid #cccccc;\n      border-radius: @file-block-border-radius;\n      position: relative;\n\n      img {\n        height: @file-block-height;\n        width: @file-block-width;\n        position: relative;\n        z-index: 2;\n      }\n    }\n\n    .ticket-file-is-not-image {\n      height: @file-block-height;\n      width: @file-block-width;\n      background-color: white;\n      position: relative;\n      border-radius: @file-block-border-radius;\n      border: 1px solid @gray-lightish;\n      font-size: 16px;\n      cursor: pointer;\n    }\n  }\n\n  .ticket-file-image--loader {\n    position: absolute;\n    z-index: 1;\n    margin: auto;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    margin: auto;\n    text-align: center;\n    font-size: 12px;\n    background-color: #f9f9f9;\n    border: 1px dashed #ccc;\n    border-radius: @file-block-border-radius;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    color: #777;\n    gap: 8px;\n  }\n\n  .uploader-container {\n    width: @file-block-width;\n    height: @file-block-height;\n    margin-bottom: 0;\n    border-radius: @file-block-border-radius;\n  }\n\n  .uploadcare--widget .uploadcare--widget__dragndrop-area {\n    height: @file-block-height;\n    border-radius: @file-block-border-radius;\n    border: 1px dashed #ccc;\n\n    .snugg-upload-prompt-text {\n      position: absolute;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      height: fit-content;\n      font-size: 12px;\n      line-height: 1.1;\n      color: #777;\n    }\n  }\n}\n\n// TODO: Responsive padding for xs screen\n@sliderHeight: 60vh;\n\n.ticket-file-modal-nav {\n  height: @sliderHeight !important;\n  top: 0;\n  text-shadow: 0 0 10px #000;\n  cursor: pointer;\n  width: 74px;\n  color: #fff;\n  font-size: 60px;\n  position: absolute;\n  line-height: 122px;\n  z-index: 1;\n\n  &.ticket-file-modal-nav--left {\n    left: 0;\n    border-radius: 0 8px 8px 0;\n\n    &:hover {\n      background-image: linear-gradient(\n        90deg,\n        rgba(0, 0, 0, 0.3),\n        rgba(0, 0, 0, 0)\n      );\n    }\n\n    &:active:hover {\n      background-image: linear-gradient(\n        90deg,\n        rgba(0, 0, 0, 0.4),\n        rgba(0, 0, 0, 0.1)\n      );\n    }\n  }\n\n  &.ticket-file-modal-nav--right {\n    right: 0;\n    border-radius: 8px 0 0 8px;\n\n    &:hover {\n      background-image: linear-gradient(\n        270deg,\n        rgba(0, 0, 0, 0.3),\n        rgba(0, 0, 0, 0)\n      );\n    }\n\n    &:active:hover {\n      background-image: linear-gradient(\n        270deg,\n        rgba(0, 0, 0, 0.4),\n        rgba(0, 0, 0, 0.1)\n      );\n    }\n  }\n}\n\n.geolocation-placeholder-wrapper {\n  height: @sliderHeight;\n  overflow: auto;\n  text-align: center;\n}\n\n.geolocation-image-wrapper {\n  height: @sliderHeight;\n  overflow: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.geolocation-image-preview {\n  max-height: @sliderHeight;\n  max-width: 100%;\n  display: inline;\n}\n\n.ticket-file-modal-body {\n  .uploadcare--widget .uploadcare--widget__dragndrop-area {\n    height: @sliderHeight;\n    display: flex;\n    max-height: 560px;\n\n    .snugg-upload-prompt-text {\n      font-size: 26px;\n      letter-spacing: 0;\n      line-height: 48px;\n    }\n  }\n\n  .no-file-cannot-modify {\n    position: relative;\n    height: @sliderHeight;\n    overflow: auto;\n    text-align: center;\n    background-color: @gray-lightestest;\n    border-radius: @file-block-border-radius;\n    border: 1px solid @gray-lightestest;\n    font-size: 36px;\n    color: @gray-light;\n\n    .no-file-label {\n      text-align: center;\n      height: 100px;\n      position: absolute;\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      margin: auto;\n    }\n  }\n}\n\n#tickets-status-mutton {\n  .snugg-btn();\n  .snugg-btn-orange();\n  height: 40px;\n  float: right;\n  display: inline-block;\n  max-width: 260px;\n  min-width: 220px;\n  width: 100%;\n\n  > div {\n    float: left;\n    display: inline-block;\n  }\n}\n\n.mutton-dropdown-menu {\n  padding: 8px;\n\n  li {\n    border-radius: 4px;\n    padding: 10px 20px;\n\n    &:hover {\n      background-color: @gray-lightest;\n    }\n\n    &:active {\n      background-color: @gray-lightish;\n    }\n\n    &.active {\n      background-color: @gray-lighter;\n      color: #000;\n    }\n  }\n}\n\n.ticket-view {\n  padding-top: 20px;\n\n  .tab-content > .tab-pane,\n  .pill-content > .pill-pane {\n    padding: 0 2px;\n  }\n}\n\n.workflow-pane {\n  padding: 0 10px;\n}\n\n.workflow-pane--ticket-list {\n  position: relative;\n  margin-bottom: 20px;\n\n  .workflow-pane--continuity-line {\n    position: absolute;\n    top: 20px;\n    bottom: 20px;\n    left: 30px;\n    right: auto;\n    width: 1px;\n    border-right: dashed @gray-light 1px;\n    z-index: 0;\n  }\n}\n\n.workflow-pane--ticket-link {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-content: stretch;\n  align-items: center;\n  border-radius: 4px;\n  padding: 10px 12px 10px 12px;\n  margin-bottom: 4px;\n  cursor: pointer;\n  transition: background 0.15s ease-in-out;\n\n  &:hover,\n  &:focus {\n    background-color: #f4f4f4;\n  }\n\n  &:active {\n    background-color: #eee;\n  }\n\n  &.workflow-pane--ticket-link--template {\n    border: 1px solid @gray-lightest;\n    background-color: @gray-lightestest;\n\n    &:hover,\n    &:focus {\n      background-color: #f2f2f2;\n\n      .workflow-ticket-icon-container {\n        background-color: #e3e3e3;\n      }\n    }\n\n    &:active {\n      background-color: #eee;\n    }\n  }\n}\n\n.workflow-pane--ticket-details {\n  max-width: 89%;\n  flex-grow: 2;\n  padding: 0 10px;\n}\n\n.workflow-pane--ticket-title {\n  font-size: 1em;\n  font-weight: 600;\n  white-space: nowrap;\n  width: 100%;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-bottom: 2px;\n}\n\n.workflow-pane--ticket-badge {\n}\n\n.workflow-pane--ticket-metadata,\n.workflow-pane--ticket-heading {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-content: stretch;\n  align-items: stretch;\n}\n\n.workflow-pane--ticket-created-by {\n  font-size: 0.9em;\n  color: @gray-darker;\n}\n\n.workflow-pane--ticket-time {\n  font-size: 0.8em;\n  line-height: 16px;\n  color: @gray;\n}\n\n.workflow-ticket-icon-container {\n  border-radius: 20em;\n  height: 36px;\n  width: 36px;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.workflow-pane--ticket-icon {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  left: 0;\n  right: 0;\n  width: 17px;\n  height: 17px;\n  font-size: 17px;\n  line-height: 1;\n}\n\n.workflow-ticket-icon-container.workflow-status-icon--workflowTemplate {\n  background-color: @gray-lighter;\n  color: @gray;\n}\n\n.workflow-ticket-icon-container {\n  &.workflow-status-icon--workflowDraft {\n    background-color: #faedb7;\n    color: #967804;\n  }\n\n  &.workflow-status-icon--workflowSubmitted,\n  &.workflow-status-icon--workflowChangesRequested {\n    background-color: #daf0fd;\n    color: #196188;\n  }\n\n  &.workflow-status-icon--workflowClosedResolved {\n    background-color: #c0f5c8;\n    color: #0a6117;\n  }\n\n  &.workflow-status-icon--workflowClosedUnresolved {\n    background-color: #fddeda;\n    color: #922513;\n\n    .workflow-pane--ticket-icon {\n      top: 2px;\n    }\n  }\n}\n\n.ticket-file-display-area {\n  text-align: center;\n  height: 90px;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  height: 90px;\n  width: 90px;\n  border-radius: 20em;\n  background-color: @gray-lightest;\n  color: @gray;\n}\n\n.ticket-file-extension {\n  border-radius: 4px;\n  font-size: 14px;\n  background: #fa611b;\n  color: white;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 20px;\n  margin: auto;\n  height: 1.4em;\n  line-height: 1.4em;\n  max-width: 46px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n@media (min-width: @screen-sm-min) {\n  #tickets-container {\n    #main-pane {\n      padding-left: 30px;\n    }\n  }\n}\n\n@media (min-width: @screen-md-min) {\n  @sliderHeight: 70vh;\n\n  .geolocation-placeholder-wrapper {\n    height: @sliderHeight;\n  }\n\n  .geolocation-image-wrapper {\n    height: @sliderHeight;\n  }\n\n  .geolocation-image-preview {\n    max-height: @sliderHeight;\n  }\n}\n",".pane-job-snapshots {\n  * {\n    pointer-events: all;\n  }\n}\n\n.snapshot-footer-banner {\n  width: calc(100% - 60px) !important;\n  // background-color: #FFFFFF;\n  box-shadow: 0 -2px 32px 0 rgba(0, 0, 0, 0.24);\n  // border: none !important;\n\n  .alert-style-container {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  p {\n    font-size: 13px;\n    line-height: 1.42;\n    margin-bottom: 0;\n    color: #555;\n\n    span {\n      color: #111;\n    }\n  }\n\n  @media (max-width: 768px) {\n    width: auto !important;\n  }\n\n  &.alert {\n    .alert-style-container {\n      align-items: center;\n    }\n  }\n\n  .alert-content {\n    > div {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: baseline;\n    }\n  }\n}\n\n// ================== CUSTOM DROPDOWN =====================\n\n.custom-dropdown {\n  li {\n    margin-bottom: 2px !important;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    a {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n      padding: 8px 12px;\n      font-size: 14px;\n      line-height: 1.42;\n      color: #111;\n      font-weight: 600;\n\n      span {\n        font-size: 12px;\n        color: #777;\n        display: inline-block;\n        font-weight: 500;\n      }\n    }\n  }\n\n  li.active {\n    background-color: #fff5e9;\n\n    a {\n      background-color: #fff5e9;\n      color: #f56600;\n\n      span {\n        color: #555;\n      }\n\n      &:hover {\n        color: #f56600;\n        background-color: #feecd6;\n      }\n    }\n  }\n\n  .dropdown-icon {\n    margin-left: 8px;\n    margin-top: -4px;\n    width: 16px;\n    height: 16px;\n    transition: all 200ms linear;\n\n    &.rotated {\n      transform: rotate(-180deg);\n    }\n  }\n\n  & {\n    button {\n      span {\n        transition: all 150ms ease;\n      }\n    }\n  }\n\n  &:hover {\n    button {\n      span {\n        color: #f56600;\n      }\n    }\n  }\n}\n\n.snapshot-custom-dropdown {\n  ul {\n    width: auto;\n    padding: 8px !important;\n    overflow: hidden;\n  }\n\n  li {\n    margin: 0 !important;\n\n    a {\n      font-weight: normal;\n    }\n  }\n\n  .divider {\n    margin: 2px !important;\n  }\n}\n\n// ================== PULSE ANIMATION =====================\n\n@keyframes pulse {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n  }\n\n  50% {\n    transform: scale(0.9);\n    opacity: 0.75;\n  }\n\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n","/* ===================== INCENTIVES CSS =====================*/\n\n.geo-photos-section {\n  position: relative;\n}\n\n.geo-photos-grid {\n  box-shadow: none;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 32px;\n}\n\n.geo-photo-title-container {\n  display: flex;\n  gap: 4px;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.geo-photo-category-container {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 32px;\n  margin-bottom: 24px;\n\n  &:last-of-type {\n    border-bottom: none;\n    padding-bottom: 16px;\n    margin-bottom: 0px;\n  }\n}\n\n.geo-photo-file-block-inner {\n  width: 235px;\n  height: 175px;\n  justify-content: center;\n  align-items: center;\n  margin-right: 8px;\n  position: relative;\n\n  &:hover {\n    .incentives-photo-delete-button {\n      bottom: 10px;\n      opacity: 1;\n    }\n  }\n}\n\n.incentives-photo-delete-button {\n  position: absolute;\n  bottom: 0;\n  opacity: 0;\n  z-index: 5;\n  margin-left: 50%;\n  transform: translateX(-50%);\n  transition: all 150ms ease-in-out;\n\n  button {\n    width: 44px;\n    height: 44px;\n    background-color: rgba(255, 255, 255, 0.8) !important;\n    border-radius: 6px;\n    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.04);\n    backdrop-filter: blur(4px);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    transition: all 200ms ease-in-out;\n\n    &:hover {\n      background-color: rgba(255, 255, 255, 1) !important;\n      transform: scale(1.05);\n    }\n  }\n}\n\n.geotagging-badge {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n\n  background-color: #039855;\n  border-radius: 20px;\n  box-shadow: inset 0 1px 2px 0 rgba(255, 255, 255, 0.1);\n  border: 1px solid #039855;\n\n  font-size: 9px;\n  line-height: 140%;\n  text-align: center;\n  color: #fff;\n  letter-spacing: 0.5px;\n\n  padding: 2px 8px;\n  position: absolute;\n  z-index: 3;\n  top: 8px;\n  right: 8px;\n\n  pointer-events: none;\n}\n\n.geo-photo-category-title {\n  font-size: 16px !important;\n  font-weight: 600 !important;\n  line-height: 1.42 !important;\n  letter-spacing: 0.3px !important;\n  text-transform: uppercase !important;\n  color: #555 !important;\n  padding: 0 !important;\n}\n\n.geo-photo-file-title {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #333;\n\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.geo-photo-badge-style {\n  margin-left: 0px !important;\n  margin-top: 3px !important;\n  font-size: 9px !important;\n  padding: 2px 4px !important;\n  display: inline-table !important;\n}\n\n#tickets-container {\n  .geo-photo-block {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n\n.uploadcare-icon-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n\n  .plus-text {\n    font-size: 1.6em;\n    font-weight: 700;\n    line-height: 142%;\n    text-align: center;\n    color: #777;\n    padding-left: 8px;\n  }\n}\n\n.geolocation-data-container {\n  width: 100%;\n}\n\n.geolocation-data-vertical {\n  background-color: #f9f9f9;\n  border: 1px solid #eee;\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n\n  .geolocation-data-set {\n    display: flex;\n    gap: 4px;\n    font-size: 12px;\n    line-height: 1.42;\n    color: #333;\n    font-weight: 600;\n    padding: 4px 8px;\n    border-bottom: 1px solid #eee;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    span {\n      font-weight: 500;\n    }\n  }\n}\n\n.geolocation-data-horizontal {\n  .geolocation-data-vertical();\n  flex-direction: column;\n  padding: 8px 4px;\n  gap: 6px;\n\n  .geolocation-data-set {\n    border-right: none;\n    border-bottom: 1px solid #eee;\n    padding: 4px 8px;\n\n    &:last-child {\n      border-right: none;\n    }\n  }\n}\n\n.photo-notes {\n  font-size: 14px !important;\n  padding: 12px !important;\n  resize: vertical;\n  transition: all 200ms ease-in-out;\n  min-height: 30px;\n  max-height: 80px;\n  field-sizing: content;\n\n  border: 1px solid #e6e6e6 !important;\n\n  &:focus,\n  &:focus-within,\n  &:active {\n    min-height: 80px;\n    border: 1px solid #ccc !important;\n  }\n}\n\n.modal-footer-action-container {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 0;\n  flex: 1;\n}\n\n.undo-delete-action {\n  position: absolute;\n  bottom: 1px;\n  left: 1px;\n  right: 1px;\n  padding: 10px 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  font-size: 10px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #d92d20;\n  border-top: 1px solid #e6e6e6;\n  transition: all 150ms ease-in-out;\n  border-radius: 0 0 6px 6px;\n\n  span {\n    transition: all 200ms ease-in-out;\n    display: flex;\n    gap: 6px;\n    align-items: center;\n  }\n\n  &:hover {\n    background-color: #f2f2f2;\n\n    span {\n      transform: scale(1.1);\n    }\n  }\n}\n\n.undo-delete-modal {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #d92d20;\n\n  cursor: pointer;\n\n  span {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    transition: all 200ms ease-in-out;\n  }\n\n  &:hover {\n    span {\n      transform: scale(1.1);\n    }\n  }\n}\n\n.ticket-file-modal-footer {\n  height: auto;\n  padding: 24px 25px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n/* ================================================================\n    ERROR STATES\n================================================================ */\n\n.no-camera-location {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: center;\n\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.42;\n  text-align: center;\n  color: #555;\n\n  padding: 8px 40px 56px;\n\n  h2,\n  p {\n    margin: 0;\n    padding: 0;\n  }\n\n  h2 {\n    font-size: 22px;\n    line-height: 1.42;\n    text-align: center;\n    color: #111;\n    font-weight: 600;\n  }\n\n  p {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 1.42;\n    text-align: center;\n    color: #555;\n  }\n\n  a {\n    text-decoration: none;\n    color: @link-color;\n  }\n\n  .camera-location-error-icons {\n    display: flex;\n    gap: 4px;\n    margin-bottom: 8px;\n  }\n}\n\n/* ================================================================\n    MEDIA QUERIES\n================================================================ */\n\n@media (min-width: @screen-md-min) {\n  .ticket-file-modal-footer {\n    height: 92px;\n    padding: 0 25px;\n    flex-direction: row;\n  }\n\n  .geolocation-data-container {\n    width: auto;\n  }\n\n  .geolocation-data-vertical {\n    width: auto;\n  }\n\n  .geolocation-data-horizontal {\n    flex-direction: row;\n    width: auto;\n\n    .geolocation-data-set {\n      border-bottom: none;\n      border-right: 1px solid #eee;\n    }\n  }\n}\n\n.incentives-edit-icon {\n  height: 32px;\n  width: 32px;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  background-color: #fff;\n  border-radius: 6px;\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.06),\n    0 3px 3px -1.5px rgba(0, 0, 0, 0.02),\n    0 6px 6px -3px rgba(0, 0, 0, 0.02),\n    0 12px 12px -6px rgba(0, 0, 0, 0.02);\n\n  transition: all 200ms ease-in-out;\n  position: absolute;\n  right: 22px;\n  top: 41px;\n  z-index: 10;\n\n  i {\n    transition: all 200ms ease-in-out;\n  }\n\n  &:hover {\n    box-shadow:\n      0 0 0 1px rgba(0, 0, 0, 0.06),\n      0 3px 3px 0 rgba(0, 0, 0, 0.02),\n      0 6px 6px 0 rgba(0, 0, 0, 0.02),\n      0 12px 12px 0 rgba(0, 0, 0, 0.02);\n    transform: scale(1.05);\n\n    i {\n      color: #c84900;\n    }\n  }\n}\n","/* ==================================================================  \n    INCENTIVES REPORT CLASSES \n================================================================== */\n\n.work-order-incentives-total {\n  border: 1px solid #f2f2f2;\n  border-radius: 6px;\n  padding: 12px 0;\n  display: flex;\n  gap: 0;\n\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #777;\n  text-align: left;\n\n  span {\n    font-size: 18px;\n    line-height: 1.42;\n    display: block;\n    color: #111;\n  }\n\n  & > div {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 0 16px;\n    border-right: 1px solid #e6e6e6;\n\n    &:last-child {\n      border-right: 0;\n      padding-right: 4px;\n    }\n  }\n}\n\n.solutions-available-incentives {\n  border: 1px solid rgba(52, 86, 73, 0.1);\n  border-radius: 6px;\n  padding: 12px 16px;\n  margin-bottom: 12px;\n  position: relative;\n  overflow: hidden;\n\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.42;\n  color: #222;\n\n  span {\n    display: block;\n\n    font-size: 24px;\n    line-height: 1.42;\n    font-weight: 600;\n  }\n\n  &::before {\n    display: block;\n    content: '';\n\n    width: 100px;\n    height: 100px;\n    z-index: 10;\n\n    position: absolute;\n    right: 24px;\n    top: -22px;\n    background: url(../../img/ui/savingsIcon.svg) no-repeat;\n    mix-blend-mode: luminosity;\n  }\n}\n\n.incentives-report-title-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.42;\n  color: #555;\n\n  span {\n    padding: 0 4px;\n    display: inline-block;\n  }\n\n  h1 {\n    margin: 0;\n    line-height: 1.2;\n    font-size: 18px;\n    padding-top: 4px;\n\n    width: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n}\n\n.key-value-container {\n  background-color: #f9f9f9;\n  border: 1px solid #e6e6e6;\n  border-radius: 6px;\n  padding: 12px 0;\n\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.42;\n  color: #111;\n  display: flex;\n\n  div {\n    padding-left: 24px;\n    padding-right: 24px;\n\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    justify-content: center;\n\n    border-right: 1px solid #e6e6e6;\n\n    &:first-child {\n      padding-left: 16px;\n    }\n\n    &:last-child {\n      padding-right: 16px;\n      border-right: none;\n    }\n  }\n\n  span {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.42;\n    color: #777;\n  }\n\n  a {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.42;\n    color: @link-color;\n    display: inline;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n\n  p {\n    margin: 0;\n    padding: 0;\n  }\n}\n\n.incentives-description-section {\n  margin-top: 8px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.7;\n  color: #333;\n\n  h2 {\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1.42;\n    color: #333;\n    margin-bottom: 8px;\n  }\n\n  ul {\n    padding-left: 16px;\n  }\n\n  ul,\n  li {\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.7;\n    color: #333;\n  }\n}\n\n/* ============= POTENTIAL INCENTIVES TABLE ============= */\n\n.table-potential-incentives {\n  border: none;\n  font-size: 13px;\n  line-height: 1.42;\n  font-weight: 600;\n  color: #111;\n  page-break-inside: avoid;\n  margin-bottom: 0;\n  tr {\n    page-break-inside: avoid;\n    break-inside: avoid;\n  }\n  td {\n    border-top: 1px solid #eee !important;\n    padding: 6px 12px !important;\n    vertical-align: middle !important;\n  }\n\n  thead {\n    th {\n      font-size: 12px;\n      font-weight: 700;\n      line-height: 142%;\n      color: #555;\n\n      padding: 8px 12px !important;\n      border-bottom: 2px solid #e6e6e6;\n    }\n  }\n\n  .table-section-row {\n    background-color: #f7f7f7;\n    font-size: 11px;\n    font-weight: 600;\n    line-height: 1.42;\n    color: #555;\n\n    td {\n      border-bottom: 1px solid #eee !important;\n      border-top: 1px solid #eee !important;\n      padding: 3px 12px !important;\n      letter-spacing: 0.2px;\n    }\n  }\n\n  .table-incentive-name {\n    font-size: 13px;\n    font-weight: 600;\n    line-height: 1.3;\n    color: #111;\n\n    span {\n      font-size: 11px;\n      line-height: 1.3;\n      color: #656565;\n      display: block;\n      font-weight: 500;\n    }\n  }\n\n  .table-total-row {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 1.42;\n    color: #111;\n  }\n}\n.potential-incentives-wrapper {\n  page-break-inside: avoid;\n  break-inside: avoid;\n}\n.table-style-2 {\n  thead {\n    th {\n      font-size: 12px;\n      font-weight: 700;\n      line-height: 142%;\n      color: #555;\n\n      padding: 8px 12px !important;\n      border-bottom: 2px solid #eee;\n    }\n  }\n\n  tbody {\n    tr {\n      td {\n        border-bottom: 1px dashed #eee;\n        border-top: none !important;\n      }\n    }\n  }\n\n  .table-section-category {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 1.42;\n    color: #656565;\n\n    td {\n      padding: 20px 8px 4px !important;\n      border-bottom: none !important;\n      border-top: none !important;\n    }\n  }\n\n  .table-incentive-name {\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.3;\n    color: #111;\n\n    span {\n      font-size: 11px;\n      line-height: 1.3;\n      color: #656565;\n      display: block;\n      font-weight: 500;\n    }\n  }\n\n  .table-total-row {\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 1.42;\n    color: #111;\n\n    td {\n      border-bottom: none !important;\n      padding-top: 12px;\n      padding-bottom: 12px;\n    }\n  }\n}\n\n/* INCENTIVES DETAILS TABLE ROW */\n.row-subheader {\n  background-color: #f9f9f9;\n  font-weight: bold;\n}\n","/* ===================== BPI 2400 CSS =====================*/\n\n.bpi-2400-container {\n  border: 1px solid #e6e6e6;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);\n  background-color: #fff;\n  padding: 24px 16px;\n  border-radius: 6px;\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.bpi-2400-status-icon {\n  height: 48px;\n  width: 48px;\n}\n\n.bpi-2400-status {\n  &.success {\n    color: #039855;\n  }\n\n  &.error {\n    color: #d92d20;\n  }\n\n  &.unavailable {\n    color: #656565;\n  }\n}\n\n.bpi-2400-date-time {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.42;\n  color: #656565;\n  margin-bottom: 0;\n}\n\n.bpi-2400-button-container {\n  display: flex;\n  gap: 8px;\n  margin-top: 12px;\n\n  .primary-button {\n    border: none;\n    width: auto;\n    padding: 6px 10px;\n    color: @link-color;\n    transition: all 250ms ease-in-out;\n  }\n\n  .secondary-button {\n    border: 1px solid rgba(200, 73, 0, 0.15);\n    width: auto;\n    padding: 6px 10px;\n    color: @link-color;\n    transition: all 250ms ease-in-out;\n    background-color: #fff;\n\n    &:hover {\n      border: 1px solid rgba(200, 73, 0, 0.15);\n    }\n  }\n}\n\n/* ===================== ALTERNATIVE METHOD CSS =====================*/\n\n.alternative-method-card-container {\n  background-color: #f2f2f2;\n  border-radius: 6px;\n\n  .alternative-method-card-header {\n    padding: 6px 16px 5px;\n    font-size: 10px;\n    font-weight: 700;\n    line-height: 1.42;\n    letter-spacing: 0.5px;\n    text-align: left;\n    color: #777;\n  }\n}\n\n/* ===================== HES MODAL CSS =====================*/\n@hesGreen: #196234;\n@hesBlue: #223f74;\n\n.hes-modal {\n  .hes-savings {\n    background-color: #f7f7f7;\n    border: 1px solid #eee;\n    border-radius: 6px;\n    padding: 6px 12px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n\n    font-size: 14px;\n    line-height: 1.42;\n    color: #555;\n\n    span {\n      color: #7cad3e;\n      font-size: 24px;\n      font-weight: 700;\n      line-height: 1.42;\n    }\n  }\n\n  .no-intial-score {\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    flex-direction: column;\n    padding-top: 16px;\n    padding-bottom: 40px;\n  }\n\n  .no-alt-final-score {\n    text-align: center;\n    position: absolute;\n    margin-left: 50%;\n    transform: translateX(-50%);\n    bottom: -90px;\n  }\n\n  .hes-container {\n    margin-top: 0;\n    margin-left: 0;\n    margin-right: 0;\n    padding: 120px 0;\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 2px;\n  }\n\n  .hes-legend {\n    min-height: 60px;\n    padding: 2px 5px 0;\n    text-align: left;\n    font-weight: 600;\n    font-size: 12px;\n\n    &:last-child {\n      text-align: left;\n    }\n  }\n\n  .hes-spectrum {\n    position: relative;\n\n    ul {\n      text-align: center;\n      background: rgba(217, 217, 217, 1);\n      background: linear-gradient(\n        to right,\n        rgba(217, 217, 217, 1) 0%,\n        rgba(203, 212, 191, 1) 44%,\n        rgba(137, 198, 72, 1) 97%,\n        rgba(137, 198, 72, 1) 100%\n      );\n      display: flex;\n      gap: 2px;\n      list-style-type: none;\n      padding: 0;\n      margin: 0;\n      font-weight: 700;\n      font-size: 20px;\n\n      li {\n        padding: 12px 0;\n        margin: 0;\n        border-right: 3px solid white;\n        box-sizing: border-box;\n\n        &:last-child {\n          border-right: none;\n        }\n      }\n    }\n  }\n}\n",".checklist-settings-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.checklist-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.import-checklist-box {\n  padding: 64px;\n  background-color: #fff;\n  border: 1px dashed #ccc;\n  border-radius: 6px;\n  box-shadow: 0 4px 4px -2px rgba(0, 0, 0, 0.04);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 24px;\n\n  .text-container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 12px;\n  }\n\n  h2 {\n    font-size: 16px;\n    font-weight: 600;\n    color: #111;\n    margin: 0;\n  }\n\n  span {\n    display: block;\n    font-size: 12px;\n    font-weight: 500;\n    line-height: 1.8;\n    color: #777;\n    text-align: center;\n  }\n}\n\n.download-sample-file {\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 8px;\n}\n\n.compare-category {\n  .compare-question-container {\n    &:last-child {\n      .compare-linestyle {\n        display: none;\n      }\n    }\n  }\n}\n\n.compare-category-text {\n  margin: 0 0 16px 0;\n  padding: 8px 12px;\n  font-size: 18px;\n  line-height: 1.42;\n  color: #000;\n  background-color: #f7f7f7;\n}\n\n.compare-question {\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.42;\n  color: #111111;\n  text-align: right;\n  padding: 6px 4px;\n\n  span {\n    font-weight: 600;\n    font-size: 12px;\n    line-height: 1.42;\n    color: #777777;\n    display: block;\n  }\n}\n\n.compare-linestyle {\n  border-top: 1px solid #eee;\n  margin: 0 0 16px 0;\n}\n\n.checklist-questions-category {\n  font-size: 20px;\n  font-weight: 600;\n  color: #111;\n  margin-top: 32px;\n  margin-bottom: 12px;\n}\n\n.checklist-questions-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  .checklist-question {\n    padding: 12px;\n    background-color: #f9f9f9;\n    border-radius: 12px;\n    font-size: 14px;\n    line-height: 1.42;\n    color: #777;\n    font-weight: 600;\n    display: flex;\n    gap: 8px;\n\n    .question {\n      font-size: 16px;\n      font-weight: 600;\n      margin: 0;\n\n      span {\n        font-size: 12px;\n        font-weight: 600;\n        color: #777;\n      }\n    }\n\n    .question-number {\n      .question;\n      padding-left: 12px;\n    }\n\n    .checklist-question-content {\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      & > span {\n        display: block;\n      }\n    }\n  }\n}\n\n.checklist-empty-state {\n  padding: 80px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  align-items: center;\n\n  .checklist-empty-state__text {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  h2 {\n    font-size: 16px;\n    line-height: 1.42;\n    font-weight: 700;\n    color: #111;\n    margin: 0;\n  }\n\n  p {\n    font-size: 14px;\n    line-height: 1.42;\n    font-weight: 500;\n    color: #777;\n    text-align: center;\n  }\n}\n\n.checklist-archived-section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 24px;\n\n  .checklist-archived-date {\n    padding: 4px 8px;\n    background-color: #eee;\n    font-size: 14px;\n    font-weight: 600;\n    color: #2b2b2b;\n    border-radius: 6px;\n  }\n\n  .checklist-archived-question-container {\n    padding: 8px;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    border-bottom: 1px solid #eee;\n    font-weight: 600;\n    font-size: 14px;\n    color: #2b2b2b;\n    transition: all 200ms ease-in-out;\n\n    &:last-child {\n      border-bottom: none;\n    }\n\n    &:hover {\n      background-color: #f2f2f2;\n    }\n\n    .checklist-archived-answer {\n      display: block;\n      font-size: 16px;\n      font-weight: 700;\n    }\n  }\n}\n",".report-branding-setting {\n  .report-branding-settings-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .report-branding-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .theme-section {\n    margin-bottom: 40px;\n\n    .section-title {\n      font-weight: 600;\n      margin-top: 0;\n      margin-bottom: 16px;\n      color: #777;\n      font-size: 14px;\n    }\n  }\n\n  .theme-list-container {\n    display: flex;\n    align-items: flex-start;\n    align-content: flex-start;\n    gap: 24px;\n    align-self: stretch;\n    flex-wrap: wrap;\n  }\n\n  .theme-card {\n    width: 160px;\n    padding: 16px 16px 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    border-radius: 12px;\n    background: #fff;\n    box-shadow:\n      0 0 0 1px rgba(0, 0, 0, 0.06),\n      0 3px 3px -1.5px rgba(0, 0, 0, 0.02),\n      0 6px 6px -3px rgba(0, 0, 0, 0.02),\n      0 12px 12px -6px rgba(0, 0, 0, 0.02);\n    transition: all 200ms ease-in-out;\n    cursor: pointer;\n\n    &:hover {\n      box-shadow:\n        0 0 0 1px rgba(0, 0, 0, 0.08),\n        0 3px 3px -1.5px rgba(0, 0, 0, 0.04),\n        0 6px 6px -3px rgba(0, 0, 0, 0.04),\n        0 12px 12px -6px rgba(0, 0, 0, 0.04);\n    }\n\n    &:active {\n      transform: scale(0.97);\n    }\n\n    .theme-card-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      font-weight: 600;\n      font-size: 14px;\n      line-height: 1.42;\n      color: #2b2b2b;\n\n      .more-options {\n        min-width: 30px;\n        height: 30px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        border-radius: 50%;\n        cursor: pointer;\n        background-color: transparent;\n        transition: background 200ms ease-in-out;\n        padding: 0 1px 0 0;\n\n        &:hover {\n          background: #f0f0f0;\n        }\n\n        i {\n          transform: rotate(90deg) !important;\n          line-height: 1;\n          color: #777;\n        }\n      }\n    }\n\n    &.custom-theme {\n      width: 274px;\n      gap: 32px;\n    }\n\n    .theme-color-block {\n      width: 80px;\n      height: 48px;\n      border-radius: 6px;\n      display: flex;\n      overflow: hidden;\n      border: 1px solid #000;\n\n      div {\n        height: 100%;\n        flex: 1;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        font-size: 16px;\n        line-height: 1.42;\n        font-weight: 600;\n        text-align: center;\n      }\n    }\n  }\n\n  .create-theme-action {\n    width: 274px;\n    height: 150px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 12px;\n    border-radius: 12px;\n    border: 1px dashed #ccc;\n    background: #fff;\n\n    font-size: 14px;\n    font-weight: 600;\n    line-height: 1.42;\n    color: #777777;\n    cursor: pointer;\n    transition: all 150ms ease-in-out;\n\n    &:hover {\n      border-color: #999;\n      background: #f9f9f9;\n    }\n\n    &:active {\n      transform: scale(0.98);\n    }\n  }\n\n  .report-branding-custom-dropdown {\n    width: 30px;\n    height: 30px;\n\n    ul {\n      width: auto;\n      padding: 6px !important;\n      overflow: hidden;\n    }\n\n    li {\n      margin: 0 !important;\n\n      a {\n        font-weight: normal;\n      }\n    }\n\n    .divider {\n      margin: 2px !important;\n    }\n  }\n\n  .colors-input-section {\n    margin-bottom: 12px;\n  }\n\n  .colors-input-section-title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #777;\n    margin-bottom: 12px;\n    margin-top: 0;\n  }\n\n  .colors-input-container {\n    display: flex;\n    gap: 8px;\n  }\n\n  .auto-gererate-container {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    justify-content: space-between;\n  }\n}\n\n.report-preview-page {\n  width: 1005px;\n  height: 816px;\n  padding: 30px;\n  background-color: #fff;\n  box-shadow:\n    0 0 0 0.979px rgba(0, 0, 0, 0.06),\n    0 3px 3px -1.5px rgba(0, 0, 0, 0.02),\n    0 6px 6px -3px rgba(0, 0, 0, 0.02),\n    0 0 12px 8px rgba(0, 0, 0, 0.02);\n  border-radius: 6px;\n  border: none;\n  transform-origin: top left;\n  transform: scale(0.7);\n  margin: 0;\n}\n","// ---- Xcel Energy Colorado Rebates ----\n.report-page.report-page-rebates {\n  .report-page-rebates-xcel {\n    .report-header {\n      background: url('../../../img/programs/xcel/xcel-rebate-banner.png')\n        no-repeat no-repeat right;\n      background-size: auto 60px;\n    }\n\n    .report-body {\n      height: 550px;\n    }\n\n    .rebate-header {\n      font-size: 15px;\n      color: #81112d;\n      margin: 0;\n\n      &.large-sub-header {\n        margin-top: 10px;\n        font-size: 2em;\n      }\n    }\n\n    .fine-print {\n      font-size: 0.7em;\n      line-height: 1.5;\n    }\n\n    .fine-print2 {\n      font-size: 0.7em;\n      line-height: 12px;\n    }\n\n    ul > li {\n      margin: 12px 0;\n    }\n\n    .text-center {\n      text-align: center;\n      margin-top: 20px;\n    }\n\n    .text-right {\n      text-align: right;\n      margin-top: 20px;\n    }\n\n    img.rebate-icon {\n      width: auto;\n      height: 14px;\n      margin-right: 5px;\n    }\n\n    .call-to-action {\n      margin-top: 15px;\n      height: 100px;\n\n      .contact {\n        margin-top: 0;\n        font-size: 1.5em;\n      }\n\n      .advisor-logo.img {\n        margin-left: 10px;\n        margin-top: -10px;\n        width: 110px;\n      }\n    }\n\n    blockquote {\n      background: #f9f9f9;\n      border-left: 2px solid #eee;\n      margin: 1.1em 1em;\n      padding: 0.5em 1em;\n      quotes: '\\201C' '\\201D';\n\n      &:before {\n        color: #808080;\n        content: open-quote;\n        font-size: 4em;\n        line-height: 0.1em;\n        margin-right: 0.25em;\n        vertical-align: -0.4em;\n      }\n\n      &:first-child {\n        display: inline;\n      }\n\n      &:last-child {\n        // margin-bottom:0;\n      }\n    }\n\n    .rebate-table {\n      font-size: 0.7em;\n      line-height: 1.1em;\n      margin-bottom: 4px;\n\n      &.xcel-table-1 {\n        .col-power {\n          width: 6%;\n          text-align: center;\n        }\n\n        .col-rebate-area {\n          width: 10%;\n          font-weight: bold;\n          line-height: 1.1;\n        }\n\n        .col-qualifier1 {\n          width: 12%;\n        }\n\n        .col-qualifier2 {\n          width: 8%;\n        }\n\n        .col-rebate {\n          width: 0.8%;\n        }\n\n        .col-info {\n          width: 40%;\n        }\n      }\n\n      &.xcel-table-1-1 {\n        .col-power {\n          width: 7.4%;\n          text-align: center;\n        }\n\n        .col-rebate-area {\n          width: 36.5%;\n          background-color: #9b9da2;\n          font-weight: bold;\n          color: #ffffff;\n          line-height: 1.1;\n        }\n\n        .col-qualifier {\n          width: 15%;\n        }\n\n        .col-utility1 {\n          width: 3.7%;\n        }\n\n        .col-utility2 {\n          width: 17.7%;\n        }\n\n        .col-utility3 {\n          width: 17.7%;\n        }\n      }\n\n      &.xcel-table-2 {\n        td {\n          line-height: 1.4;\n        }\n\n        .col-power {\n          width: 7%;\n          text-align: center;\n        }\n\n        .col-rebate-area {\n          width: 30%;\n          background-color: #9b9da2;\n          font-weight: bold;\n          color: #ffffff;\n          line-height: 1.1;\n        }\n\n        .col-rebate {\n          width: 20%;\n        }\n\n        .col-info {\n          width: 43%;\n        }\n      }\n\n      &.xcel-table-2-1 {\n        td {\n          line-height: 1.4;\n        }\n\n        .col-measures {\n          width: 50%;\n        }\n\n        .col-utility1 {\n          width: 14%;\n          text-align: right;\n        }\n\n        .col-utility1.1 {\n          width: 3%;\n          text-align: right;\n        }\n\n        .col-utility2 {\n          width: 15%;\n          text-align: right;\n        }\n\n        .col-utility3 {\n          width: 15%;\n          text-align: right;\n        }\n      }\n\n      th {\n        border: 1px solid #c8c9cc;\n        border-bottom: 0;\n        border-top: 0;\n        line-height: 1.5;\n        padding: 2px 4px;\n        background-color: #221f20;\n        color: #ffffff;\n        text-transform: none;\n        font-size: 1em;\n      }\n\n      td {\n        border: 1px solid #c7c9cc;\n        vertical-align: middle;\n        padding: 3px 6px;\n        line-height: 1.2;\n        color: #262626;\n      }\n\n      [class*='header'] td {\n        padding: 3px 4px;\n      }\n\n      .header-cooling {\n        background-color: #e92c31;\n      }\n\n      .header-cooling td {\n        color: #fff;\n        border-bottom: 0;\n        border-top: 0;\n      }\n\n      .item-cooling-odd {\n        background-color: #ffffff;\n      }\n\n      .item-cooling-even {\n        background-color: #f5f5f5;\n      }\n\n      .header-heating {\n        background-color: #e92c31;\n      }\n\n      .header-heating td {\n        color: #fff;\n        border-bottom: 0;\n        border-top: 0;\n      }\n\n      .item-heating-odd {\n        background-color: #ffffff;\n      }\n\n      .item-heating-even {\n        background-color: #f5f5f5;\n      }\n\n      .header-dhw {\n        background-color: #e92c31;\n      }\n\n      .header-dhw td {\n        color: #fff;\n        border-bottom: 0;\n        border-top: 0;\n      }\n\n      .item-dhw-odd {\n        background-color: #ffffff;\n      }\n\n      .item-dhw-even {\n        background-color: #f5f5f5;\n      }\n\n      .header-insulation {\n        background-color: #e92c31;\n      }\n\n      .header-insulation td {\n        color: #fff;\n        border-bottom: 0;\n        border-top: 0;\n      }\n\n      .subheader-insulation {\n        background-color: #dddee0;\n      }\n\n      .subheader-insulation td {\n        color: #000;\n        border: 1px solid #b7b9bd;\n      }\n\n      .subheader-hpwes {\n        background-color: #9b9da2;\n      }\n\n      .subheader-hpwes td {\n        color: #fff;\n      }\n\n      .item-insulation-odd {\n        background-color: #ffffff;\n      }\n\n      .item-insulation-even {\n        background-color: #f5f5f5;\n      }\n\n      .header-audit {\n        background-color: #e92c31;\n      }\n\n      .header-audit td {\n        color: #fff;\n        border-bottom: 0;\n        border-top: 0;\n      }\n\n      .item-audit-odd {\n        background-color: #ffffff;\n      }\n\n      .item-audit-even {\n        background-color: #f5f5f5;\n      }\n\n      .header-hpwes {\n        background-color: #e92c31;\n      }\n\n      .header-hpwes td {\n        color: #fff;\n        border-bottom: 0;\n        border-top: 0;\n      }\n\n      .item-hpwes-odd {\n        background-color: #ffffff;\n      }\n\n      .item-hpwes-even {\n        background-color: #f5f5f5;\n      }\n\n      .item-right {\n        text-align: right;\n      }\n\n      .item-center {\n        text-align: center;\n      }\n    }\n  }\n}\n","// ---- APS Rebates ----\n.report-page.report-page-rebates {\n  .report-page-rebates-aps {\n    font-size: 0.95em;\n    line-height: 1.4em;\n    ul,\n    ol {\n      padding-left: 20px;\n    }\n    h3 {\n      margin-top: 20px;\n    }\n    h4 {\n      margin: 30px 0 6px;\n    }\n    li {\n      line-height: 1.35em;\n    }\n    p {\n      margin-bottom: 10px;\n    }\n  }\n}\n","@cvetuTextColor: #2f2d2b;\n@cvetuLinkColor: #0092d9;\n\n.report-page-rebates-cvetu {\n  padding-top: 10px;\n  .timelineContainer img {\n    max-width: 100%;\n  }\n  .breakoutStyle {\n    background-color: #f3f3f3;\n    font-size: 12px;\n    line-height: 20px;\n    font-weight: 600;\n  }\n  .textAlignCenter {\n    text-align: center;\n  }\n  .cvetu-body {\n    padding-top: 20px;\n    h2 {\n      font-size: 18px;\n      font-weight: 600;\n      color: @cvetuTextColor;\n    }\n    h3 {\n      font-size: 14px;\n      font-weight: 600;\n      color: @cvetuTextColor;\n    }\n    p,\n    ul {\n      font-size: 12px;\n      line-height: 18px;\n      color: @cvetuTextColor;\n    }\n    p {\n      margin: 10px 0;\n    }\n    li {\n      margin: 5px 0;\n    }\n    ul {\n      padding-left: 15px;\n    }\n    h4 {\n      font-size: 13px;\n      font-weight: 700;\n      color: @cvetuTextColor;\n    }\n    a {\n      color: @cvetuLinkColor;\n    }\n    table {\n      font-size: 10px;\n      td {\n        vertical-align: middle;\n      }\n      th {\n        font-size: 11px;\n        text-align: center;\n        vertical-align: middle;\n      }\n      img {\n        max-width: 100%;\n        max-height: 50px;\n      }\n    }\n  }\n  .loanProgramList {\n    li {\n      margin: 15px 0;\n    }\n  }\n  .solarContractorList {\n    li {\n      margin: 15px 0;\n    }\n  }\n\n  .cvetu-terms,\n  .cvetu-terms p {\n    font-size: 11px;\n    line-height: 17px;\n    p {\n      margin-top: 0;\n    }\n  }\n}\n",".report-page {\n  &.report-page-tech_specs {\n    .headline-style {\n      font-size: 16px;\n      color: #000;\n      font-weight: 600;\n      padding-left: 20px;\n      margin: 0;\n    }\n    .homeIcon {\n      width: 70%;\n      margin-top: -15px;\n    }\n    .tableTypeStyle {\n      font-size: 12px;\n      b {\n        u {\n          padding-top: 7px;\n          display: inline-block;\n        }\n      }\n      & > .r-row [class*='r-spa']:nth-child(1) {\n        text-align: right;\n        padding: 1px 0;\n      }\n    }\n    .tableTypeStyle > .r-row [class*='r-spa']:nth-child(2) {\n      text-align: left;\n      font-weight: 600;\n      padding: 1px 0;\n    }\n\n    .leftBorder {\n      position: relative;\n      padding-bottom: 10px;\n      ::before {\n        content: '';\n        position: absolute;\n        z-index: 1;\n        top: 0;\n        bottom: 0;\n        left: 0%;\n        border-left: 2px solid #213a81;\n        transform: translate(-2px);\n      }\n    }\n    .rightBorder {\n      position: relative;\n      padding-bottom: 10px;\n      ::before {\n        content: '';\n        position: absolute;\n        z-index: 1;\n        top: 0;\n        bottom: 0;\n        left: 100%;\n        border-right: 2px solid #213a81;\n        transform: translate(16px);\n      }\n    }\n\n    .topBorder {\n      border-top: 2px solid #213a81;\n      padding-top: 15px;\n    }\n\n    .fontSize12 {\n      font-size: 12px;\n      [class*='r-spa'] {\n        padding: 1px 0;\n      }\n    }\n  }\n}\n","// Energy New England Style\n\n.eneContentStyle {\n  &.eneContentStyleXL {\n    p {\n      font-size: 11px;\n    }\n  }\n\n  table {\n    border: 1px solid #ddd;\n    border-collapse: collapse;\n    font-size: 10px;\n    line-height: 1.2;\n    margin-bottom: 10px;\n    width: 100%;\n\n    td,\n    th {\n      border: 1px solid #ddd;\n      border-collapse: collapse;\n      padding: 2px 5px 2px 7px;\n    }\n\n    th,\n    .headStyle td {\n      padding: 5px 5px 5px 7px;\n      background: #f0f0f0;\n    }\n\n    td.rightAlign,\n    th.rightAlign {\n      text-align: right;\n    }\n\n    tr:nth-child(even) {\n      background: #fafafa;\n    }\n  }\n\n  table.lessContent {\n    font-size: 12px;\n    line-height: 1.5;\n\n    td,\n    th,\n    tr.headStyle td {\n      padding: 4px 5px 4px 7px;\n    }\n  }\n\n  table.lessContent2 {\n    font-size: 11px;\n    line-height: 1.3;\n\n    td {\n      padding: 4px 5px 4px 7px;\n    }\n\n    tr.headStyle td,\n    th {\n      padding: 6px 5px 6px 7px;\n    }\n  }\n\n  Table.lessContent3 {\n    font-size: 11px;\n    line-height: 1.3;\n\n    td {\n      padding: 3px 5px 3px 7px;\n    }\n\n    tr.headStyle td,\n    th {\n      padding: 4px 5px 4px 7px;\n    }\n  }\n\n  Table.lessContent4 {\n    font-size: 11px;\n    line-height: 1.2;\n\n    td {\n      padding: 2px 5px 2px 5px;\n    }\n\n    tr.headStyle td,\n    th {\n      padding: 2px 5px 2px 5px;\n    }\n  }\n\n  table.eneCompact {\n    th,\n    .headStyle td {\n      padding: 3px 5px 3px 5px;\n    }\n  }\n\n  ul {\n    font-size: 12px;\n    margin-bottom: 5px;\n    padding-left: 20px;\n  }\n\n  p {\n    font-size: 10px;\n    line-height: 1.5;\n    margin-bottom: 5px;\n  }\n\n  h2 {\n    font-size: 12px;\n    color: #2f2b22;\n    margin-bottom: 2px;\n    line-height: 1.2;\n  }\n\n  hr {\n    margin-top: 0px;\n    margin-bottom: 15px;\n  }\n\n  .title {\n    float: left;\n    font-size: 15px;\n    font-weight: 700;\n    text-transform: uppercase;\n    padding-top: 5px;\n  }\n\n  .logoImg {\n    max-width: 100%;\n    height: 30px;\n    width: auto;\n    margin-bottom: 4px;\n    float: right;\n  }\n\n  .headerProgramName {\n    font-size: 10;\n    display: block;\n  }\n\n  .bold {\n    font-weight: 700;\n  }\n\n  .conditions {\n    color: #ef233c;\n    line-height: 1.5;\n    font-weight: 600;\n  }\n}\n",".report-page {\n  &.report-page-coc {\n    .table.table-extra-condensed.new-jersey-coc-table {\n      > thead > tr > th {\n        &:nth-child(1) {\n          width: 160px;\n        }\n        &:nth-child(2) {\n          width: 190px;\n        }\n        &:nth-child(3) {\n          width: 130px;\n        }\n        &:nth-child(4) {\n          width: 130px;\n        }\n        &:nth-child(3) {\n          width: 80px;\n        }\n      }\n      > tbody > tr > td {\n        padding-right: 8px;\n      }\n    }\n  }\n}\n",".report-page {\n  .report-page-contract-terms-berkshire-gas {\n    font-size: 11px;\n    p {\n      line-height: 1.3em;\n    }\n    h5 {\n      font-size: 1em;\n      font-style: bold;\n    }\n    ol {\n      padding-left: 20px;\n    }\n  }\n}\n",".report-page {\n  .report-page-rebates-wge {\n    .fine-print {\n      font-size: 10px;\n      line-height: 1.5;\n    }\n    .note {\n      font-size: 10px;\n      line-height: 1.5;\n      display: block;\n      padding: 5px 8px;\n      background-color: #eee;\n      border-radius: 4px;\n    }\n    .heading-rebate-table {\n      font-size: 12px;\n      font-weight: 600;\n    }\n    table {\n      margin-bottom: 10px;\n      width: 100%;\n      border: 1px solid #ddd;\n      &.table-extra-condensed > tbody > tr > td,\n      &.table-extra-condensed > thead > tr > th {\n        border: 1px solid #ddd;\n        padding: 3px 4px;\n        line-height: 1.3;\n        font-size: 10px;\n      }\n      &.table-extra-condensed > thead > tr > th {\n        letter-spacing: 0.03em;\n        text-transform: none;\n      }\n      &.table-extra-condensed > thead > tr > th.darkbackground {\n        background-color: #555555;\n        color: #fff;\n      }\n    }\n  }\n}\n","// ====================  Style WYSIWYG ======================\n.wysiwyg {\n  .editor {\n    &.blank-editor:before {\n      display: block;\n      content: 'Click to add text';\n      color: @gray-light;\n    }\n    border: 1px solid transparent;\n    height: 100%;\n    overflow: hidden;\n    &:focus {\n      border: 1px solid @gray-light;\n      -webkit-box-shadow: none;\n      box-shadow: none;\n      outline: none;\n    }\n    &:hover {\n      background-color: lighten(@custom-color-2, 15%);\n    }\n    &:hover:focus {\n      background-color: inherit;\n    }\n  }\n  .toolbar {\n    width: 360px;\n    .btn {\n      float: left;\n      font-size: 18px;\n      width: 45px;\n      height: 45px;\n      border-radius: 0;\n      text-align: center;\n      box-shadow: 0 -1px 1px rgba(0, 0, 0, 0.5);\n      &:active:focus {\n        outline: none;\n      }\n      &:first-child {\n        border-top-left-radius: 5px;\n      }\n      &:last-child {\n        border-top-right-radius: 5px;\n      }\n      [class*=' icon-'],\n      [class^='icon-'] {\n        font-size: 15px;\n      }\n      &.active {\n        background-color: darken(@gray-lighter, 12%);\n      }\n    }\n    .btn-bold {\n      font-weight: 700;\n    }\n    .btn-italic {\n      font-style: italic;\n    }\n  }\n}\n","@import '../app/custom-variables.less';\n\n@accent-color: @gray;\n\n.custom-rc-pagination {\n  .rc-pagination-item,\n  .rc-pagination-jump-prev,\n  .rc-pagination-jump-next,\n  .rc-pagination-prev,\n  .rc-pagination-next,\n  .rc-pagination-jump-prev,\n  .rc-pagination-jump-next {\n    border: 1px solid @gray-lighter;\n    background-color: #fff;\n    min-width: 38px;\n    height: 38px;\n    line-height: 38px;\n    a {\n      color: @link-color;\n    }\n    &:hover {\n      border-color: @gray-light;\n      a {\n        color: @accent-color;\n      }\n    }\n    &:active {\n      background-color: @gray-lighter;\n      a {\n        color: @link-color;\n      }\n    }\n    &.rc-pagination-disabled,\n    .rc-pagination-disabled:hover,\n    .rc-pagination-disabled:active {\n      border: 1px solid @gray-lighter;\n      background-color: #fff;\n      a {\n        color: #ccc;\n      }\n    }\n  }\n  .rc-pagination-item-active {\n    background-color: @gray;\n    border-color: @gray-darker;\n    a {\n      color: #fff;\n    }\n    &:hover a {\n      color: #fff;\n    }\n  }\n\n  .rc-pagination-jump-prev:hover:after,\n  .rc-pagination-jump-next:hover:after {\n    color: @accent-color;\n  }\n  .rc-pagination-jump-prev-custom-icon:hover .custom-icon-jump-prev,\n  .rc-pagination-jump-next-custom-icon:hover .custom-icon-jump-prev,\n  .rc-pagination-jump-prev-custom-icon:hover .custom-icon-jump-next,\n  .rc-pagination-jump-next-custom-icon:hover .custom-icon-jump-next {\n    opacity: 1;\n    color: @accent-color;\n  }\n  .rc-pagination-options-quick-jumper input:hover {\n    border-color: @accent-color;\n  }\n\n  .rc-pagination-options-quick-jumper button:hover,\n  .rc-pagination-options-quick-jumper button:active,\n  .rc-pagination-options-quick-jumper button:focus {\n    color: @accent-color;\n    background-color: #fff;\n    border-color: @accent-color;\n  }\n  .rc-pagination-simple .rc-pagination-simple-pager input:hover {\n    border-color: @accent-color;\n  }\n\n  .rc-pagination-simple .rc-pagination-simple-pager button:hover,\n  .rc-pagination-simple .rc-pagination-simple-pager button:active,\n  .rc-pagination-simple .rc-pagination-simple-pager button:focus {\n    color: @accent-color;\n    background-color: #fff;\n    border-color: @accent-color;\n  }\n}\n","@slider-border-radius: 10px;\n@chart-color-1: #872c4f;\n@chart-color-2: #ef8a45;\n@chart-color-3: #f2cd50;\n.horizontal-slider {\n  margin-bottom: 20px;\n  .handle {\n    background-color: @custom-color-1;\n    z-index: 101;\n    margin-top: 8px;\n    margin-left: -20px;\n    border-color: fade(@custom-color-1, 60%);\n  }\n  div.bar:last-of-type {\n    border-radius: 0 @slider-border-radius @slider-border-radius 0;\n  }\n  .bar {\n    height: 20px;\n    text-align: center;\n    color: transparent !important;\n    -webkit-user-select: none;\n    &:first-child {\n      border-radius: @slider-border-radius 0 0 @slider-border-radius;\n    }\n    &.bar-0 {\n      background-color: @chart-color-1;\n      color: #fff;\n    }\n    &.bar-1 {\n      background-color: @chart-color-2;\n      // color: #000;\n    }\n    &.bar-2 {\n      background-color: @chart-color-3;\n      // color: #000;\n    }\n    .bar-value {\n      text-align: center;\n    }\n  }\n}\n","// ==============  React Bootstrap Modal ===================\n.modal-backdrop {\n  z-index: 1069;\n\n  &.in {\n    opacity: 0.7;\n  }\n}\n\n.modal-open .modal {\n  z-index: 1070;\n}\n\n.modal-header {\n  padding: 20px 20px 10px 25px;\n  border-bottom: none;\n}\n\n.modal-title {\n  font-weight: 600;\n  font-size: 20px;\n  color: @custom-color-1;\n  text-align: left;\n}\n\n.modal-content {\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.7);\n  border-radius: 5px;\n}\n\n.modal-content .close {\n  font-size: 36px;\n  font-weight: 400;\n  line-height: 1.72em;\n  text-shadow: 0 1px 0 #ffffff;\n  opacity: 0.3;\n  filter: alpha(opacity=30);\n  width: 44px;\n  text-align: center;\n  margin: -20px -12px 0 0;\n\n  &:hover {\n    opacity: 0.4;\n  }\n\n  &:active {\n    opacity: 0.8;\n  }\n}\n\n.modal-body {\n  padding: 15px 25px;\n}\n\n// React bootstrap styling for the z-index of confirmation modals\n.confirmation.modal {\n  display: flex !important;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  z-index: 1090;\n\n  .modal-dialog {\n    font-size: 16px;\n    max-width: 400px;\n\n    .modal-body {\n      padding: 25px;\n      background-color: #ffffff;\n    }\n  }\n}\n\n.confirmation.modal-backdrop {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1089;\n  background-color: #000000;\n\n  &.fade {\n    opacity: 0;\n    filter: alpha(opacity=0);\n  }\n\n  &.in {\n    opacity: 0.5;\n    filter: alpha(opacity=50);\n  }\n}\n\n.modal-footer {\n  padding: 0;\n  border: none;\n}\n\n// // Payment UI\n// .show-credit-card:hover {\n//   cursor: pointer\n// }\n.actived-progress-btn {\n  color: #ffa845;\n\n  p {\n    color: @custom-color-1 !important;\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n.buy-credit-modal {\n  .active {\n    color: black;\n  }\n\n  .disable {\n    color: @custom-color-3;\n\n    p {\n      color: #adadad !important;\n    }\n  }\n\n  p.disable {\n    color: #adadad !important;\n  }\n\n  label {\n    cursor: pointer;\n  }\n\n  [type='radio']:checked,\n  [type='radio']:not(:checked) {\n    position: absolute;\n    left: -99999px;\n  }\n\n  [type='radio']:checked + span,\n  [type='radio']:not(:checked) + span {\n    position: relative;\n    padding-left: 30px;\n  }\n\n  [type='radio']:checked + span:before,\n  [type='radio']:not(:checked) + span:before {\n    content: '';\n    position: absolute;\n    left: 0px;\n    top: 15px;\n    width: 18px;\n    height: 18px;\n    border: 1px solid #ddd;\n    border-radius: 100%;\n    background: #ffffff;\n  }\n\n  [type='radio']:checked + span:after,\n  [type='radio']:not(:checked) + span:after {\n    content: '';\n    position: absolute;\n    left: 3px;\n    top: 18px;\n    width: 12px;\n    height: 12px;\n    border: 1px solid #ffa845;\n    border-radius: 100%;\n    background: #ffa845;\n    -webkit-transition: all 0.2s ease;\n    transition: all 0.2s ease;\n  }\n\n  [type='radio']:not(:checked) + span:after {\n    opacity: 0;\n    transform: scale(0);\n  }\n\n  [type='radio']:checked + span:after {\n    opacity: 1;\n    transform: scale(1);\n  }\n\n  [type='radio']:checked + span:before {\n    border: 1px solid #ffa845;\n  }\n}\n\n@media (min-width: 768px) {\n  .assign-modal {\n    width: 480px;\n  }\n}\n\n.snapshot-compare {\n  .modal-dialog {\n    width: 95%;\n  }\n  .modal-header {\n    padding-bottom: 0px;\n  }\n  .modal-body {\n    padding-top: 0px;\n  }\n\n  .snapshot-row {\n    .col-sm-4 {\n      @media (max-width: 768px) {\n        padding: 0;\n      }\n    }\n  }\n}\n\n.checklist-compare {\n  .modal-dialog {\n    width: 95%;\n  }\n  .modal-header {\n    padding-bottom: 0px;\n  }\n  .modal-body {\n    padding-top: 0px;\n  }\n\n  .checklist-row {\n    .col-sm-4 {\n      @media (max-width: 768px) {\n        padding: 0;\n      }\n    }\n  }\n}\n",".block-container {\n  display: flex;\n  flex-wrap: wrap;\n  border-bottom: 1px solid #eeeeee;\n  color: #4a4a4a;\n  padding-bottom: 25px;\n\n  &.without-border-bottom {\n    border-bottom: none;\n  }\n\n  button {\n    margin-top: 15px;\n    margin-bottom: 15px;\n  }\n\n  .block-content {\n    height: 128.72px;\n  }\n\n  .block-header {\n    color: #625845;\n    padding: 0;\n    margin-bottom: 10px;\n  }\n\n  .block-horizontal {\n    width: 220px;\n    margin-bottom: 15px;\n    margin-right: 60px;\n  }\n}\n\n.section-info-container {\n  padding: 16px;\n  border-radius: 5px;\n  cursor: pointer;\n\n  &.disabled {\n    cursor: default;\n  }\n\n  &:not(.disabled):hover {\n    padding: 15px;\n    border-width: 1px;\n    border-style: dashed;\n    border-color: #cccccc;\n    background-color: @gray-lightestest;\n  }\n\n  .link {\n    color: @link-color;\n    font-size: 14px;\n    margin-top: 10px;\n    font-weight: 600;\n  }\n}\n\n#auto-badge-tooltip {\n  .tooltip-inner {\n    text-align: left;\n    width: 160px;\n  }\n}\n\n.vertical-center-icon {\n  line-height: 1;\n  margin-bottom: -2px;\n}\n\n.settings-companies,\n.settings-programs {\n  padding-top: 46px;\n}\n\n.content.settings-view {\n  padding: 48px 16px;\n}\n","// --- spacing variables (px) ---\n@s-0: 0px;\n@s-2: 2px;\n@s-4: 4px;\n@s-6: 6px;\n@s-8: 8px;\n@s-10: 10px;\n@s-12: 12px;\n@s-16: 16px;\n@s-20: 20px;\n@s-24: 24px;\n@s-28: 28px;\n@s-32: 32px;\n@s-36: 36px;\n@s-40: 40px;\n\n// --- generator mixin (keeps classes consistent) ---\n.gen(@n, @val) {\n  .mt-@{n} {\n    margin-top: @val !important;\n  }\n\n  .mb-@{n} {\n    margin-bottom: @val !important;\n  }\n\n  .ml-@{n} {\n    margin-left: @val !important;\n  }\n\n  .mr-@{n} {\n    margin-right: @val !important;\n  }\n\n  .mx-@{n} {\n    margin-left: @val !important;\n    margin-right: @val !important;\n  }\n\n  .my-@{n} {\n    margin-top: @val !important;\n    margin-bottom: @val !important;\n  }\n\n  .pt-@{n} {\n    padding-top: @val !important;\n  }\n\n  .pb-@{n} {\n    padding-bottom: @val !important;\n  }\n\n  .pl-@{n} {\n    padding-left: @val !important;\n  }\n\n  .pr-@{n} {\n    padding-right: @val !important;\n  }\n\n  .px-@{n} {\n    padding-left: @val !important;\n    padding-right: @val !important;\n  }\n\n  .py-@{n} {\n    padding-top: @val !important;\n    padding-bottom: @val !important;\n  }\n\n  .gap-@{n} {\n    gap: @val !important;\n  }\n}\n\n// --- produce base (non-responsive) classes ---\n.gen(0, @s-0);\n.gen(2, @s-2);\n.gen(4, @s-4);\n.gen(6, @s-6);\n.gen(8, @s-8);\n.gen(10, @s-10);\n.gen(12, @s-12);\n.gen(16, @s-16);\n.gen(20, @s-20);\n.gen(24, @s-24);\n.gen(28, @s-24);\n.gen(32, @s-32);\n.gen(40, @s-40);\n\n// --- responsive: small (>=768px), medium (>=992px), large (>=1200px) ---\n// Each responsive block reuses the same mixin but prefixes the class with sm/md/lg.\n@media (min-width: 768px) {\n  .gen-sm(@n, @val) {\n    .mt-sm-@{n} {\n      margin-top: @val !important;\n    }\n\n    .mb-sm-@{n} {\n      margin-bottom: @val !important;\n    }\n\n    .ml-sm-@{n} {\n      margin-left: @val !important;\n    }\n\n    .mr-sm-@{n} {\n      margin-right: @val !important;\n    }\n\n    .mx-sm-@{n} {\n      margin-left: @val !important;\n      margin-right: @val !important;\n    }\n\n    .my-sm-@{n} {\n      margin-top: @val !important;\n      margin-bottom: @val !important;\n    }\n\n    .pt-sm-@{n} {\n      padding-top: @val !important;\n    }\n\n    .pb-sm-@{n} {\n      padding-bottom: @val !important;\n    }\n\n    .pl-sm-@{n} {\n      padding-left: @val !important;\n    }\n\n    .pr-sm-@{n} {\n      padding-right: @val !important;\n    }\n\n    .px-sm-@{n} {\n      padding-left: @val !important;\n      padding-right: @val !important;\n    }\n\n    .py-sm-@{n} {\n      padding-top: @val !important;\n      padding-bottom: @val !important;\n    }\n\n    .gap-sm-@{n} {\n      gap: @val !important;\n    }\n  }\n\n  .gen-sm(0, @s-0);\n  .gen-sm(2, @s-2);\n  .gen-sm(4, @s-4);\n  .gen-sm(6, @s-6);\n  .gen-sm(8, @s-8);\n  .gen-sm(10, @s-10);\n  .gen-sm(12, @s-12);\n  .gen-sm(16, @s-16);\n  .gen-sm(20, @s-20);\n  .gen-sm(28, @s-28);\n  .gen-sm(32, @s-32);\n  .gen-sm(36, @s-36);\n  .gen-sm(40, @s-40);\n}\n\n@media (min-width: 992px) {\n  .gen-md(@n, @val) {\n    .mt-md-@{n} {\n      margin-top: @val !important;\n    }\n\n    .mb-md-@{n} {\n      margin-bottom: @val !important;\n    }\n\n    .ml-md-@{n} {\n      margin-left: @val !important;\n    }\n\n    .mr-md-@{n} {\n      margin-right: @val !important;\n    }\n\n    .mx-md-@{n} {\n      margin-left: @val !important;\n      margin-right: @val !important;\n    }\n\n    .my-md-@{n} {\n      margin-top: @val !important;\n      margin-bottom: @val !important;\n    }\n\n    .pt-md-@{n} {\n      padding-top: @val !important;\n    }\n\n    .pb-md-@{n} {\n      padding-bottom: @val !important;\n    }\n\n    .pl-md-@{n} {\n      padding-left: @val !important;\n    }\n\n    .pr-md-@{n} {\n      padding-right: @val !important;\n    }\n\n    .px-md-@{n} {\n      padding-left: @val !important;\n      padding-right: @val !important;\n    }\n\n    .py-md-@{n} {\n      padding-top: @val !important;\n      padding-bottom: @val !important;\n    }\n\n    .gap-md-@{n} {\n      gap: @val !important;\n    }\n  }\n\n  .gen-md(0, @s-0);\n  .gen-md(2, @s-2);\n  .gen-md(4, @s-4);\n  .gen-md(6, @s-6);\n  .gen-md(8, @s-8);\n  .gen-md(10, @s-10);\n  .gen-md(12, @s-12);\n  .gen-md(16, @s-16);\n  .gen-md(20, @s-20);\n  .gen-md(24, @s-24);\n  .gen-md(28, @s-28);\n  .gen-md(32, @s-32);\n  .gen-md(36, @s-36);\n  .gen-md(40, @s-40);\n}\n\n@media (min-width: 1200px) {\n  .gen-lg(@n, @val) {\n    .mt-lg-@{n} {\n      margin-top: @val !important;\n    }\n\n    .mb-lg-@{n} {\n      margin-bottom: @val !important;\n    }\n\n    .ml-lg-@{n} {\n      margin-left: @val !important;\n    }\n\n    .mr-lg-@{n} {\n      margin-right: @val !important;\n    }\n\n    .mx-lg-@{n} {\n      margin-left: @val !important;\n      margin-right: @val !important;\n    }\n\n    .my-lg-@{n} {\n      margin-top: @val !important;\n      margin-bottom: @val !important;\n    }\n\n    .pt-lg-@{n} {\n      padding-top: @val !important;\n    }\n\n    .pb-lg-@{n} {\n      padding-bottom: @val !important;\n    }\n\n    .pl-lg-@{n} {\n      padding-left: @val !important;\n    }\n\n    .pr-lg-@{n} {\n      padding-right: @val !important;\n    }\n\n    .px-lg-@{n} {\n      padding-left: @val !important;\n      padding-right: @val !important;\n    }\n\n    .py-lg-@{n} {\n      padding-top: @val !important;\n      padding-bottom: @val !important;\n    }\n\n    .gap-lg-@{n} {\n      gap: @val !important;\n    }\n  }\n\n  .gen-lg(0, @s-0);\n  .gen-lg(2, @s-2);\n  .gen-lg(4, @s-4);\n  .gen-lg(6, @s-6);\n  .gen-lg(8, @s-8);\n  .gen-lg(10, @s-10);\n  .gen-lg(12, @s-12);\n  .gen-lg(16, @s-16);\n  .gen-lg(20, @s-20);\n  .gen-lg(24, @s-24);\n  .gen-lg(28, @s-28);\n  .gen-lg(32, @s-32);\n  .gen-lg(36, @s-36);\n  .gen-lg(40, @s-40);\n}\n",".authentication-requirement {\n  margin-left: 8px;\n  ul {\n    margin: 12px 0;\n    padding: 0;\n\n    &:first-child {\n      margin: 4px 0 10px;\n    }\n\n    li {\n      margin: 6px 0;\n      list-style: none;\n      font-size: 12px;\n      color: @gray-light;\n      vertical-align: middle;\n      display: flex;\n      align-items: center;\n      &.error {\n        color: @color-alertred;\n      }\n      &.active {\n        font-weight: 600;\n        color: #4a7222;\n\n        span {\n          background-color: #4a7222;\n          border: 1px solid #4a7222;\n          background-image: url(../../img/ui/checkIcon.svg);\n          background-repeat: no-repeat;\n          background-position: center center;\n          background-size: 8px 7px;\n        }\n      }\n      &.error {\n        font-weight: 600;\n        color: #c10101;\n\n        span {\n          background-color: #c10101;\n          border: 1px solid #c10101;\n          background-image: url(../../img/ui/xIcon.svg);\n          background-repeat: no-repeat;\n          background-position: center center;\n          background-size: 6px 6px;\n        }\n      }\n      &.warning {\n        font-weight: 600;\n        color: #f6bb54;\n\n        span {\n          background-color: #f6bb54;\n          border: 1px solid #f6bb54;\n          background-image: url(../../img/ui/warningIcon.svg);\n          background-repeat: no-repeat;\n          background-position: center center;\n          background-size: 6px ​8p;\n        }\n      }\n\n      &.requirement-title {\n        font-size: 13px;\n        color: #555555;\n        font-weight: 600;\n        padding-bottom: 4px;\n      }\n\n      span {\n        background: #ffffff;\n        border: 1px solid #dddddd;\n        margin-left: 8px;\n        margin-right: 10px;\n        display: inline-block;\n        width: 12px;\n        height: 12px;\n        border-radius: 100%;\n      }\n    }\n  }\n}\n","/* TREE COMPONENT STYLES */\n\n.tree {\n  list-style: none;\n  margin: 0 !important;\n  padding: 0 !important;\n  padding-bottom: 16px;\n  font-size: 14px;\n  color: #333;\n\n  & > li {\n    padding: 8px 8px;\n    border-bottom: 1px solid #eee;\n\n    &.read-only {\n      padding: 8px 0;\n    }\n\n    &:last-child {\n      border: none;\n    }\n\n    & ul {\n      padding-bottom: 4px;\n      list-style: none;\n      margin: 0px;\n      padding: 4px 0px 0px 16px;\n    }\n\n    & li {\n      margin: 6px 16px;\n      display: flex;\n      align-items: center;\n      gap: 6px;\n    }\n  }\n\n  .box {\n    cursor: pointer;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n  }\n\n  .nested {\n    max-height: 0;\n    overflow: hidden;\n    transition: max-height 0.15s ease-in-out;\n  }\n\n  .active {\n    max-height: 500px;\n  }\n\n  @keyframes rotate {\n    from {\n      transform: rotate(0deg);\n    }\n\n    to {\n      transform: rotate(90deg);\n    }\n  }\n\n  .icon-rotate {\n    display: inline-block;\n    transition: transform 0.15s ease-in-out;\n  }\n\n  .icon-rotate.rotating {\n    transform: rotate(90deg);\n  }\n}\n",".white-tooltip {\n  &.in {\n    opacity: 1 !important;\n  }\n\n  .tooltip-arrow {\n    border-top-color: #fff !important;\n  }\n\n  .tooltip-inner {\n    max-width: 280px;\n    background-color: #fff;\n    color: #555;\n    text-align: left;\n    padding: 12px;\n    border-radius: 6px;\n    display: flex;\n    gap: 4px;\n    flex-direction: column;\n    box-shadow:\n      0 0 0 1px rgba(0, 0, 0, 0.06),\n      0 4px 4px 0 rgba(0, 0, 0, 0.06),\n      0 8px 8px 0 rgba(0, 0, 0, 0.06),\n      0 16px 16px 0 rgba(0, 0, 0, 0.06);\n\n    p {\n      margin-bottom: 0;\n    }\n  }\n}\n\n.tooltip-td-trigger {\n  cursor: pointer;\n  transition: all 200ms ease-in-out;\n\n  &:hover {\n    background-color: #fdf5f4 !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
